//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AboutSeecServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrUpdateAboutSeecDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AboutSeec/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param isPublished (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, isPublished: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAboutSeecForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AboutSeec/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isPublished === null)
            throw new Error("The parameter 'isPublished' cannot be null.");
        else if (isPublished !== undefined)
            url_ += "IsPublished=" + encodeURIComponent("" + isPublished) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAboutSeecForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAboutSeecForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAboutSeecForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAboutSeecForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetAboutSeecForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AboutSeec/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAboutSeecForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAboutSeecForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAboutSeecForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAboutSeecForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPublished(): Observable<HomeAboutDto> {
        let url_ = this.baseUrl + "/api/services/app/AboutSeec/GetPublished";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeAboutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeAboutDto>;
        }));
    }

    protected processGetPublished(response: HttpResponseBase): Observable<HomeAboutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HomeAboutDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    publish(id: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AboutSeec/Publish?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AboutSeec/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonateUser(body: ImpersonateUserInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ImpersonateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonateUser(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonateTenant(body: ImpersonateTenantInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ImpersonateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonateTenant(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delegatedImpersonate(body: DelegatedImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/DelegatedImpersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processDelegatedImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchToLinkedAccountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchToLinkedAccountOutput>;
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssetImportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAssetImportTemplate(): Observable<AssetImportTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetImport/GetAssetImportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetImportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetImportTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetImportTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetImportTemplateDto>;
        }));
    }

    protected processGetAssetImportTemplate(response: HttpResponseBase): Observable<AssetImportTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetImportTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateAssetImportStructure(body: AssetImportInputDto | undefined): Observable<AssetImportStructureValidationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetImport/ValidateAssetImportStructure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAssetImportStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAssetImportStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetImportStructureValidationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetImportStructureValidationResultDto>;
        }));
    }

    protected processValidateAssetImportStructure(response: HttpResponseBase): Observable<AssetImportStructureValidationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetImportStructureValidationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateAssetImport(body: AssetImportInputDto | undefined): Observable<AssetImportValidationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetImport/ValidateAssetImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAssetImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAssetImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetImportValidationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetImportValidationResultDto>;
        }));
    }

    protected processValidateAssetImport(response: HttpResponseBase): Observable<AssetImportValidationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetImportValidationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveAssetImport(body: AssetImportInputDto | undefined): Observable<AssetImportValidationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetImport/SaveAssetImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAssetImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAssetImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetImportValidationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetImportValidationResultDto>;
        }));
    }

    protected processSaveAssetImport(response: HttpResponseBase): Observable<AssetImportValidationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetImportValidationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AttendeeInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param attendeeFullNameFilter (optional) 
     * @param mobileNumberFilter (optional) 
     * @param emailFilter (optional) 
     * @param maxDateOfBirthFilter (optional) 
     * @param minDateOfBirthFilter (optional) 
     * @param iDNumberFilter (optional) 
     * @param maxCreationTimeFilter (optional) 
     * @param minCreationTimeFilter (optional) 
     * @param maxLastModificationTimeFilter (optional) 
     * @param minLastModificationTimeFilter (optional) 
     * @param isDeletedFilter (optional) 
     * @param maxDeletionTimeFilter (optional) 
     * @param minDeletionTimeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, attendeeFullNameFilter: string | undefined, mobileNumberFilter: string | undefined, emailFilter: string | undefined, maxDateOfBirthFilter: DateTime | undefined, minDateOfBirthFilter: DateTime | undefined, iDNumberFilter: string | undefined, maxCreationTimeFilter: DateTime | undefined, minCreationTimeFilter: DateTime | undefined, maxLastModificationTimeFilter: DateTime | undefined, minLastModificationTimeFilter: DateTime | undefined, isDeletedFilter: number | undefined, maxDeletionTimeFilter: DateTime | undefined, minDeletionTimeFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttendeeInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendeeInfos/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (attendeeFullNameFilter === null)
            throw new Error("The parameter 'attendeeFullNameFilter' cannot be null.");
        else if (attendeeFullNameFilter !== undefined)
            url_ += "AttendeeFullNameFilter=" + encodeURIComponent("" + attendeeFullNameFilter) + "&";
        if (mobileNumberFilter === null)
            throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
        else if (mobileNumberFilter !== undefined)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&";
        if (emailFilter === null)
            throw new Error("The parameter 'emailFilter' cannot be null.");
        else if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (maxDateOfBirthFilter === null)
            throw new Error("The parameter 'maxDateOfBirthFilter' cannot be null.");
        else if (maxDateOfBirthFilter !== undefined)
            url_ += "MaxDateOfBirthFilter=" + encodeURIComponent(maxDateOfBirthFilter ? "" + maxDateOfBirthFilter.toString() : "") + "&";
        if (minDateOfBirthFilter === null)
            throw new Error("The parameter 'minDateOfBirthFilter' cannot be null.");
        else if (minDateOfBirthFilter !== undefined)
            url_ += "MinDateOfBirthFilter=" + encodeURIComponent(minDateOfBirthFilter ? "" + minDateOfBirthFilter.toString() : "") + "&";
        if (iDNumberFilter === null)
            throw new Error("The parameter 'iDNumberFilter' cannot be null.");
        else if (iDNumberFilter !== undefined)
            url_ += "IDNumberFilter=" + encodeURIComponent("" + iDNumberFilter) + "&";
        if (maxCreationTimeFilter === null)
            throw new Error("The parameter 'maxCreationTimeFilter' cannot be null.");
        else if (maxCreationTimeFilter !== undefined)
            url_ += "MaxCreationTimeFilter=" + encodeURIComponent(maxCreationTimeFilter ? "" + maxCreationTimeFilter.toString() : "") + "&";
        if (minCreationTimeFilter === null)
            throw new Error("The parameter 'minCreationTimeFilter' cannot be null.");
        else if (minCreationTimeFilter !== undefined)
            url_ += "MinCreationTimeFilter=" + encodeURIComponent(minCreationTimeFilter ? "" + minCreationTimeFilter.toString() : "") + "&";
        if (maxLastModificationTimeFilter === null)
            throw new Error("The parameter 'maxLastModificationTimeFilter' cannot be null.");
        else if (maxLastModificationTimeFilter !== undefined)
            url_ += "MaxLastModificationTimeFilter=" + encodeURIComponent(maxLastModificationTimeFilter ? "" + maxLastModificationTimeFilter.toString() : "") + "&";
        if (minLastModificationTimeFilter === null)
            throw new Error("The parameter 'minLastModificationTimeFilter' cannot be null.");
        else if (minLastModificationTimeFilter !== undefined)
            url_ += "MinLastModificationTimeFilter=" + encodeURIComponent(minLastModificationTimeFilter ? "" + minLastModificationTimeFilter.toString() : "") + "&";
        if (isDeletedFilter === null)
            throw new Error("The parameter 'isDeletedFilter' cannot be null.");
        else if (isDeletedFilter !== undefined)
            url_ += "IsDeletedFilter=" + encodeURIComponent("" + isDeletedFilter) + "&";
        if (maxDeletionTimeFilter === null)
            throw new Error("The parameter 'maxDeletionTimeFilter' cannot be null.");
        else if (maxDeletionTimeFilter !== undefined)
            url_ += "MaxDeletionTimeFilter=" + encodeURIComponent(maxDeletionTimeFilter ? "" + maxDeletionTimeFilter.toString() : "") + "&";
        if (minDeletionTimeFilter === null)
            throw new Error("The parameter 'minDeletionTimeFilter' cannot be null.");
        else if (minDeletionTimeFilter !== undefined)
            url_ += "MinDeletionTimeFilter=" + encodeURIComponent(minDeletionTimeFilter ? "" + minDeletionTimeFilter.toString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAttendeeInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAttendeeInfoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttendeeInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttendeeInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendeeInfoForView(id: number | undefined): Observable<GetAttendeeInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AttendeeInfos/GetAttendeeInfoForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendeeInfoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendeeInfoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendeeInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendeeInfoForViewDto>;
        }));
    }

    protected processGetAttendeeInfoForView(response: HttpResponseBase): Observable<GetAttendeeInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendeeInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttendeeInfoForEdit(id: number | undefined): Observable<GetAttendeeInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttendeeInfos/GetAttendeeInfoForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendeeInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendeeInfoForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendeeInfoForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendeeInfoForEditOutput>;
        }));
    }

    protected processGetAttendeeInfoForEdit(response: HttpResponseBase): Observable<GetAttendeeInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttendeeInfoForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAttendeeInfoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendeeInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttendeeInfos/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogs(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDto[]>;
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChanges(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityTypeChanges(entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChangesToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityChangeId (optional) 
     * @return Success
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getRequestEntityPropertyChanges(requestId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetRequestEntityPropertyChanges?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetRequestEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param affectedUser (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getLogInbox(actionType: ActionType, roleId: number | undefined, affectedUser: string | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfGetLogInboxOutput> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetLogInbox?";
        if (actionType === undefined || actionType === null)
            throw new Error("The parameter 'actionType' must be defined and cannot be null.");
        else
            url_ += "ActionType=" + encodeURIComponent("" + actionType) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (affectedUser === null)
            throw new Error("The parameter 'affectedUser' cannot be null.");
        else if (affectedUser !== undefined)
            url_ += "AffectedUser=" + encodeURIComponent("" + affectedUser) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogInbox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogInbox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetLogInboxOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetLogInboxOutput>;
        }));
    }

    protected processGetLogInbox(response: HttpResponseBase): Observable<PagedResultDtoOfGetLogInboxOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLogInboxOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AwarnessContentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param awarnessContentCreatorFilter (optional) 
     * @param awarnessContentCreationDateFromFilter (optional) 
     * @param awarnessContentCreationDateToFilter (optional) 
     * @param awarnessContentNameFilter (optional) 
     * @param awarnessContentClassificationIdFilter (optional) 
     * @param awarnessContentTypeIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, awarnessContentCreatorFilter: string | undefined, awarnessContentCreationDateFromFilter: DateTime | undefined, awarnessContentCreationDateToFilter: DateTime | undefined, awarnessContentNameFilter: string | undefined, awarnessContentClassificationIdFilter: number | undefined, awarnessContentTypeIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAwarnessContentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (awarnessContentCreatorFilter === null)
            throw new Error("The parameter 'awarnessContentCreatorFilter' cannot be null.");
        else if (awarnessContentCreatorFilter !== undefined)
            url_ += "AwarnessContentCreatorFilter=" + encodeURIComponent("" + awarnessContentCreatorFilter) + "&";
        if (awarnessContentCreationDateFromFilter === null)
            throw new Error("The parameter 'awarnessContentCreationDateFromFilter' cannot be null.");
        else if (awarnessContentCreationDateFromFilter !== undefined)
            url_ += "AwarnessContentCreationDateFromFilter=" + encodeURIComponent(awarnessContentCreationDateFromFilter ? "" + awarnessContentCreationDateFromFilter.toString() : "") + "&";
        if (awarnessContentCreationDateToFilter === null)
            throw new Error("The parameter 'awarnessContentCreationDateToFilter' cannot be null.");
        else if (awarnessContentCreationDateToFilter !== undefined)
            url_ += "AwarnessContentCreationDateToFilter=" + encodeURIComponent(awarnessContentCreationDateToFilter ? "" + awarnessContentCreationDateToFilter.toString() : "") + "&";
        if (awarnessContentNameFilter === null)
            throw new Error("The parameter 'awarnessContentNameFilter' cannot be null.");
        else if (awarnessContentNameFilter !== undefined)
            url_ += "AwarnessContentNameFilter=" + encodeURIComponent("" + awarnessContentNameFilter) + "&";
        if (awarnessContentClassificationIdFilter === null)
            throw new Error("The parameter 'awarnessContentClassificationIdFilter' cannot be null.");
        else if (awarnessContentClassificationIdFilter !== undefined)
            url_ += "AwarnessContentClassificationIdFilter=" + encodeURIComponent("" + awarnessContentClassificationIdFilter) + "&";
        if (awarnessContentTypeIdFilter === null)
            throw new Error("The parameter 'awarnessContentTypeIdFilter' cannot be null.");
        else if (awarnessContentTypeIdFilter !== undefined)
            url_ += "AwarnessContentTypeIdFilter=" + encodeURIComponent("" + awarnessContentTypeIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAwarnessContentForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAwarnessContentForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAwarnessContentForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAwarnessContentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seecContentId (optional) 
     * @param publicationDate (optional) 
     * @param publicationTypeId (optional) 
     * @param requestNumber (optional) 
     * @param publicationDurationInDays (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAwarnessContentUsers(seecContentId: number | undefined, publicationDate: DateTime | undefined, publicationTypeId: number | undefined, requestNumber: string | undefined, publicationDurationInDays: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGovAwarnessContentPublicationDto> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/GetAwarnessContentUsers?";
        if (seecContentId === null)
            throw new Error("The parameter 'seecContentId' cannot be null.");
        else if (seecContentId !== undefined)
            url_ += "SeecContentId=" + encodeURIComponent("" + seecContentId) + "&";
        if (publicationDate === null)
            throw new Error("The parameter 'publicationDate' cannot be null.");
        else if (publicationDate !== undefined)
            url_ += "PublicationDate=" + encodeURIComponent(publicationDate ? "" + publicationDate.toString() : "") + "&";
        if (publicationTypeId === null)
            throw new Error("The parameter 'publicationTypeId' cannot be null.");
        else if (publicationTypeId !== undefined)
            url_ += "PublicationTypeId=" + encodeURIComponent("" + publicationTypeId) + "&";
        if (requestNumber === null)
            throw new Error("The parameter 'requestNumber' cannot be null.");
        else if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&";
        if (publicationDurationInDays === null)
            throw new Error("The parameter 'publicationDurationInDays' cannot be null.");
        else if (publicationDurationInDays !== undefined)
            url_ += "PublicationDurationInDays=" + encodeURIComponent("" + publicationDurationInDays) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAwarnessContentUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAwarnessContentUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGovAwarnessContentPublicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGovAwarnessContentPublicationDto>;
        }));
    }

    protected processGetAwarnessContentUsers(response: HttpResponseBase): Observable<PagedResultDtoOfGovAwarnessContentPublicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGovAwarnessContentPublicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAwarnessContentNumber(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/GetAwarnessContentNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAwarnessContentNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAwarnessContentNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAwarnessContentNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAwarnessContentForView(id: number | undefined): Observable<GetAwarnessContentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/GetAwarnessContentForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAwarnessContentForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAwarnessContentForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAwarnessContentForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAwarnessContentForViewDto>;
        }));
    }

    protected processGetAwarnessContentForView(response: HttpResponseBase): Observable<GetAwarnessContentForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAwarnessContentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAwarnessContentForEdit(id: number | undefined): Observable<GetAwarnessContentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/GetAwarnessContentForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAwarnessContentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAwarnessContentForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAwarnessContentForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAwarnessContentForEditOutput>;
        }));
    }

    protected processGetAwarnessContentForEdit(response: HttpResponseBase): Observable<GetAwarnessContentForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAwarnessContentForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAwarnessContentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadNewAttachment(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/UploadNewAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadNewAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadNewAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadNewAttachment(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAwarenessContentClassificationForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/GetAllAwarenessContentClassificationForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAwarenessContentClassificationForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAwarenessContentClassificationForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto>;
        }));
    }

    protected processGetAllAwarenessContentClassificationForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContentTypeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfAwarnessContentContentTypeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/GetAllContentTypeForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContentTypeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContentTypeForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAwarnessContentContentTypeLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAwarnessContentContentTypeLookupTableDto>;
        }));
    }

    protected processGetAllContentTypeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfAwarnessContentContentTypeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAwarnessContentContentTypeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param contentName (optional) 
     * @return Success
     */
    getAwarnesContentForGovPublication(contentName: string | undefined): Observable<GetAwarnessContentForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AwarnessContents/GetAwarnesContentForGovPublication?";
        if (contentName === null)
            throw new Error("The parameter 'contentName' cannot be null.");
        else if (contentName !== undefined)
            url_ += "contentName=" + encodeURIComponent("" + contentName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAwarnesContentForGovPublication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAwarnesContentForGovPublication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAwarnessContentForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAwarnessContentForViewDto[]>;
        }));
    }

    protected processGetAwarnesContentForGovPublication(response: HttpResponseBase): Observable<GetAwarnessContentForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAwarnessContentForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BuildingAssetInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param regionIdFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param electricityServiceProviderIdFilter (optional) 
     * @param voltageGroupIdFilter (optional) 
     * @param tarshidRetrofitFilter (optional) 
     * @param constructionDateFromFilter (optional) 
     * @param constructionDateToFilter (optional) 
     * @param buildingAreaFromFilter (optional) 
     * @param buildingAreaToFilter (optional) 
     * @param buildingStatusIdFilter (optional) 
     * @param ownershipFilter (optional) 
     * @param assetTypeIdFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(regionIdFilter: number | undefined, organizationUnitIdFilter: number | undefined, electricityServiceProviderIdFilter: number | undefined, voltageGroupIdFilter: number | undefined, tarshidRetrofitFilter: boolean | undefined, constructionDateFromFilter: string | undefined, constructionDateToFilter: string | undefined, buildingAreaFromFilter: number | undefined, buildingAreaToFilter: number | undefined, buildingStatusIdFilter: number | undefined, ownershipFilter: number | undefined, assetTypeIdFilter: number | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBuildingAssetInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingAssetInfos/GetAll?";
        if (regionIdFilter === null)
            throw new Error("The parameter 'regionIdFilter' cannot be null.");
        else if (regionIdFilter !== undefined)
            url_ += "RegionIdFilter=" + encodeURIComponent("" + regionIdFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (electricityServiceProviderIdFilter === null)
            throw new Error("The parameter 'electricityServiceProviderIdFilter' cannot be null.");
        else if (electricityServiceProviderIdFilter !== undefined)
            url_ += "ElectricityServiceProviderIdFilter=" + encodeURIComponent("" + electricityServiceProviderIdFilter) + "&";
        if (voltageGroupIdFilter === null)
            throw new Error("The parameter 'voltageGroupIdFilter' cannot be null.");
        else if (voltageGroupIdFilter !== undefined)
            url_ += "VoltageGroupIdFilter=" + encodeURIComponent("" + voltageGroupIdFilter) + "&";
        if (tarshidRetrofitFilter === null)
            throw new Error("The parameter 'tarshidRetrofitFilter' cannot be null.");
        else if (tarshidRetrofitFilter !== undefined)
            url_ += "TarshidRetrofitFilter=" + encodeURIComponent("" + tarshidRetrofitFilter) + "&";
        if (constructionDateFromFilter === null)
            throw new Error("The parameter 'constructionDateFromFilter' cannot be null.");
        else if (constructionDateFromFilter !== undefined)
            url_ += "ConstructionDateFromFilter=" + encodeURIComponent("" + constructionDateFromFilter) + "&";
        if (constructionDateToFilter === null)
            throw new Error("The parameter 'constructionDateToFilter' cannot be null.");
        else if (constructionDateToFilter !== undefined)
            url_ += "ConstructionDateToFilter=" + encodeURIComponent("" + constructionDateToFilter) + "&";
        if (buildingAreaFromFilter === null)
            throw new Error("The parameter 'buildingAreaFromFilter' cannot be null.");
        else if (buildingAreaFromFilter !== undefined)
            url_ += "BuildingAreaFromFilter=" + encodeURIComponent("" + buildingAreaFromFilter) + "&";
        if (buildingAreaToFilter === null)
            throw new Error("The parameter 'buildingAreaToFilter' cannot be null.");
        else if (buildingAreaToFilter !== undefined)
            url_ += "BuildingAreaToFilter=" + encodeURIComponent("" + buildingAreaToFilter) + "&";
        if (buildingStatusIdFilter === null)
            throw new Error("The parameter 'buildingStatusIdFilter' cannot be null.");
        else if (buildingStatusIdFilter !== undefined)
            url_ += "BuildingStatusIdFilter=" + encodeURIComponent("" + buildingStatusIdFilter) + "&";
        if (ownershipFilter === null)
            throw new Error("The parameter 'ownershipFilter' cannot be null.");
        else if (ownershipFilter !== undefined)
            url_ += "OwnershipFilter=" + encodeURIComponent("" + ownershipFilter) + "&";
        if (assetTypeIdFilter === null)
            throw new Error("The parameter 'assetTypeIdFilter' cannot be null.");
        else if (assetTypeIdFilter !== undefined)
            url_ += "AssetTypeIdFilter=" + encodeURIComponent("" + assetTypeIdFilter) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBuildingAssetInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBuildingAssetInfoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBuildingAssetInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBuildingAssetInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBuildingAssetInfoForView(id: number | undefined): Observable<GetBuildingAssetInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingAssetInfos/GetBuildingAssetInfoForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingAssetInfoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingAssetInfoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBuildingAssetInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBuildingAssetInfoForViewDto>;
        }));
    }

    protected processGetBuildingAssetInfoForView(response: HttpResponseBase): Observable<GetBuildingAssetInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBuildingAssetInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBuildingAssetInfoDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuildingAssetInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuildingAssetInfos/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedia(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingAssetInfos/UploadMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadMedia(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param regionIdFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param electricityServiceProviderIdFilter (optional) 
     * @param voltageGroupIdFilter (optional) 
     * @param tarshidRetrofitFilter (optional) 
     * @param constructionDateFromFilter (optional) 
     * @param constructionDateToFilter (optional) 
     * @param buildingAreaFromFilter (optional) 
     * @param buildingAreaToFilter (optional) 
     * @param buildingStatusIdFilter (optional) 
     * @param ownershipFilter (optional) 
     * @param assetTypeIdFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getBuildingAssetsToExcel(regionIdFilter: number | undefined, organizationUnitIdFilter: number | undefined, electricityServiceProviderIdFilter: number | undefined, voltageGroupIdFilter: number | undefined, tarshidRetrofitFilter: boolean | undefined, constructionDateFromFilter: string | undefined, constructionDateToFilter: string | undefined, buildingAreaFromFilter: number | undefined, buildingAreaToFilter: number | undefined, buildingStatusIdFilter: number | undefined, ownershipFilter: number | undefined, assetTypeIdFilter: number | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingAssetInfos/GetBuildingAssetsToExcel?";
        if (regionIdFilter === null)
            throw new Error("The parameter 'regionIdFilter' cannot be null.");
        else if (regionIdFilter !== undefined)
            url_ += "RegionIdFilter=" + encodeURIComponent("" + regionIdFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (electricityServiceProviderIdFilter === null)
            throw new Error("The parameter 'electricityServiceProviderIdFilter' cannot be null.");
        else if (electricityServiceProviderIdFilter !== undefined)
            url_ += "ElectricityServiceProviderIdFilter=" + encodeURIComponent("" + electricityServiceProviderIdFilter) + "&";
        if (voltageGroupIdFilter === null)
            throw new Error("The parameter 'voltageGroupIdFilter' cannot be null.");
        else if (voltageGroupIdFilter !== undefined)
            url_ += "VoltageGroupIdFilter=" + encodeURIComponent("" + voltageGroupIdFilter) + "&";
        if (tarshidRetrofitFilter === null)
            throw new Error("The parameter 'tarshidRetrofitFilter' cannot be null.");
        else if (tarshidRetrofitFilter !== undefined)
            url_ += "TarshidRetrofitFilter=" + encodeURIComponent("" + tarshidRetrofitFilter) + "&";
        if (constructionDateFromFilter === null)
            throw new Error("The parameter 'constructionDateFromFilter' cannot be null.");
        else if (constructionDateFromFilter !== undefined)
            url_ += "ConstructionDateFromFilter=" + encodeURIComponent("" + constructionDateFromFilter) + "&";
        if (constructionDateToFilter === null)
            throw new Error("The parameter 'constructionDateToFilter' cannot be null.");
        else if (constructionDateToFilter !== undefined)
            url_ += "ConstructionDateToFilter=" + encodeURIComponent("" + constructionDateToFilter) + "&";
        if (buildingAreaFromFilter === null)
            throw new Error("The parameter 'buildingAreaFromFilter' cannot be null.");
        else if (buildingAreaFromFilter !== undefined)
            url_ += "BuildingAreaFromFilter=" + encodeURIComponent("" + buildingAreaFromFilter) + "&";
        if (buildingAreaToFilter === null)
            throw new Error("The parameter 'buildingAreaToFilter' cannot be null.");
        else if (buildingAreaToFilter !== undefined)
            url_ += "BuildingAreaToFilter=" + encodeURIComponent("" + buildingAreaToFilter) + "&";
        if (buildingStatusIdFilter === null)
            throw new Error("The parameter 'buildingStatusIdFilter' cannot be null.");
        else if (buildingStatusIdFilter !== undefined)
            url_ += "BuildingStatusIdFilter=" + encodeURIComponent("" + buildingStatusIdFilter) + "&";
        if (ownershipFilter === null)
            throw new Error("The parameter 'ownershipFilter' cannot be null.");
        else if (ownershipFilter !== undefined)
            url_ += "OwnershipFilter=" + encodeURIComponent("" + ownershipFilter) + "&";
        if (assetTypeIdFilter === null)
            throw new Error("The parameter 'assetTypeIdFilter' cannot be null.");
        else if (assetTypeIdFilter !== undefined)
            url_ += "AssetTypeIdFilter=" + encodeURIComponent("" + assetTypeIdFilter) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingAssetsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingAssetsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetBuildingAssetsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BuildingEnergyEfficiencySubmissionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param orgId (optional) 
     * @return Success
     */
    getBuildingsDataByOrgId(orgId: number | undefined): Observable<BuildingAssetViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/GetBuildingsDataByOrgId?";
        if (orgId === null)
            throw new Error("The parameter 'orgId' cannot be null.");
        else if (orgId !== undefined)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingsDataByOrgId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingsDataByOrgId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingAssetViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingAssetViewDto[]>;
        }));
    }

    protected processGetBuildingsDataByOrgId(response: HttpResponseBase): Observable<BuildingAssetViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BuildingAssetViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateBuildingEnergyEfficiencySubmissionDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: CreateBuildingEnergyEfficiencySubmissionDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitForTierA(body: CreateBuildingEnergyEfficiencySubmissionDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/SubmitForTierA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitForTierA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitForTierA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmitForTierA(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getForEdit(requestId: number | undefined): Observable<GetBuildingEnergyEfficiencySubmissionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/GetForEdit?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBuildingEnergyEfficiencySubmissionForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBuildingEnergyEfficiencySubmissionForEditOutput>;
        }));
    }

    protected processGetForEdit(response: HttpResponseBase): Observable<GetBuildingEnergyEfficiencySubmissionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBuildingEnergyEfficiencySubmissionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getByRequestId(requestId: number | undefined): Observable<GetBuildingEnergyEfficiencySubmissionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/GetByRequestId?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByRequestId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByRequestId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBuildingEnergyEfficiencySubmissionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBuildingEnergyEfficiencySubmissionForViewDto>;
        }));
    }

    protected processGetByRequestId(response: HttpResponseBase): Observable<GetBuildingEnergyEfficiencySubmissionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBuildingEnergyEfficiencySubmissionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param buildingAssetId (optional) 
     * @param submissionCycle (optional) 
     * @return Success
     */
    isSubmissionCycleExist(buildingAssetId: number | undefined, submissionCycle: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/IsSubmissionCycleExist?";
        if (buildingAssetId === null)
            throw new Error("The parameter 'buildingAssetId' cannot be null.");
        else if (buildingAssetId !== undefined)
            url_ += "buildingAssetId=" + encodeURIComponent("" + buildingAssetId) + "&";
        if (submissionCycle === null)
            throw new Error("The parameter 'submissionCycle' cannot be null.");
        else if (submissionCycle !== undefined)
            url_ += "submissionCycle=" + encodeURIComponent("" + submissionCycle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSubmissionCycleExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSubmissionCycleExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSubmissionCycleExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/GetMyTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMyTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetBuildingEnergyEfficiencySubmissionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBuildingEnergyEfficiencySubmissionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBuildingEnergyEfficiencySubmissionForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetBuildingEnergyEfficiencySubmissionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBuildingEnergyEfficiencySubmissionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param creationTime (optional) 
     * @param id (optional) 
     * @param organizationId (optional) 
     * @param sectorId (optional) 
     * @param submissionCycleFilter (optional) 
     * @param buildingAssetIdFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param onlyAssignedToMeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, creationTime: DateTime | undefined, id: number | undefined, organizationId: number | undefined, sectorId: number | undefined, submissionCycleFilter: string | undefined, buildingAssetIdFilter: number | undefined, requestStatusIdFilter: RequestStatusEnum | undefined, onlyAssignedToMeFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (creationTime === null)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toString() : "") + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "SectorId=" + encodeURIComponent("" + sectorId) + "&";
        if (submissionCycleFilter === null)
            throw new Error("The parameter 'submissionCycleFilter' cannot be null.");
        else if (submissionCycleFilter !== undefined)
            url_ += "SubmissionCycleFilter=" + encodeURIComponent("" + submissionCycleFilter) + "&";
        if (buildingAssetIdFilter === null)
            throw new Error("The parameter 'buildingAssetIdFilter' cannot be null.");
        else if (buildingAssetIdFilter !== undefined)
            url_ += "BuildingAssetIdFilter=" + encodeURIComponent("" + buildingAssetIdFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (onlyAssignedToMeFilter === null)
            throw new Error("The parameter 'onlyAssignedToMeFilter' cannot be null.");
        else if (onlyAssignedToMeFilter !== undefined)
            url_ += "OnlyAssignedToMeFilter=" + encodeURIComponent("" + onlyAssignedToMeFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param creationTime (optional) 
     * @param id (optional) 
     * @param organizationId (optional) 
     * @param sectorId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSubmissionsToExcel(filter: string | undefined, creationTime: DateTime | undefined, id: number | undefined, organizationId: number | undefined, sectorId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/GetSubmissionsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (creationTime === null)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toString() : "") + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "SectorId=" + encodeURIComponent("" + sectorId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubmissionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmissionsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSubmissionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadDocument(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingEnergyEfficiencySubmissions/UploadDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BuildingInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param regionName_ArFilter (optional) 
     * @param cityName_ArFilter (optional) 
     * @param buildingStatusFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param buildingNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(regionName_ArFilter: string | undefined, cityName_ArFilter: string | undefined, buildingStatusFilter: number | undefined, organizationUnitIdFilter: number | undefined, buildingNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBuildingInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingInfos/GetAll?";
        if (regionName_ArFilter === null)
            throw new Error("The parameter 'regionName_ArFilter' cannot be null.");
        else if (regionName_ArFilter !== undefined)
            url_ += "RegionName_ArFilter=" + encodeURIComponent("" + regionName_ArFilter) + "&";
        if (cityName_ArFilter === null)
            throw new Error("The parameter 'cityName_ArFilter' cannot be null.");
        else if (cityName_ArFilter !== undefined)
            url_ += "CityName_ArFilter=" + encodeURIComponent("" + cityName_ArFilter) + "&";
        if (buildingStatusFilter === null)
            throw new Error("The parameter 'buildingStatusFilter' cannot be null.");
        else if (buildingStatusFilter !== undefined)
            url_ += "BuildingStatusFilter=" + encodeURIComponent("" + buildingStatusFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (buildingNameFilter === null)
            throw new Error("The parameter 'buildingNameFilter' cannot be null.");
        else if (buildingNameFilter !== undefined)
            url_ += "BuildingNameFilter=" + encodeURIComponent("" + buildingNameFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetBuildingInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetBuildingInfoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBuildingInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBuildingInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBuildingInfoForView(id: number | undefined): Observable<GetBuildingInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BuildingInfos/GetBuildingInfoForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingInfoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingInfoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBuildingInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBuildingInfoForViewDto>;
        }));
    }

    protected processGetBuildingInfoForView(response: HttpResponseBase): Observable<GetBuildingInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBuildingInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBuildingInfoForEdit(id: number | undefined): Observable<GetBuildingInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BuildingInfos/GetBuildingInfoForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingInfoForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBuildingInfoForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBuildingInfoForEditOutput>;
        }));
    }

    protected processGetBuildingInfoForEdit(response: HttpResponseBase): Observable<GetBuildingInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBuildingInfoForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBuildingInfoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuildingInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BuildingInfos/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllRegionForTableDropdown(): Observable<BuildingInfoRegionLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BuildingInfos/GetAllRegionForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegionForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegionForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingInfoRegionLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingInfoRegionLookupTableDto[]>;
        }));
    }

    protected processGetAllRegionForTableDropdown(response: HttpResponseBase): Observable<BuildingInfoRegionLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BuildingInfoRegionLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCityForTableDropdown(): Observable<BuildingInfoCityLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BuildingInfos/GetAllCityForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCityForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCityForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingInfoCityLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingInfoCityLookupTableDto[]>;
        }));
    }

    protected processGetAllCityForTableDropdown(response: HttpResponseBase): Observable<BuildingInfoCityLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BuildingInfoCityLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDefaultEditionNameOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDefaultEditionNameOutput>;
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommonMethodsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationByUserId(): Observable<GetOrganizationUserDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/GetOrganizationByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationUserDto>;
        }));
    }

    protected processGetOrganizationByUserId(response: HttpResponseBase): Observable<GetOrganizationUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationUnitId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getOrganizationUnitHeaderInfo(organizationUnitId: number | undefined, userId: number | undefined): Observable<GetOrganizationUserDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/GetOrganizationUnitHeaderInfo?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitHeaderInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitHeaderInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationUserDto>;
        }));
    }

    protected processGetOrganizationUnitHeaderInfo(response: HttpResponseBase): Observable<GetOrganizationUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sectorId (optional) 
     * @return Success
     */
    isUserOnSector(userId: number | undefined, sectorId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/IsUserOnSector?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "sectorId=" + encodeURIComponent("" + sectorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUserOnSector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUserOnSector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsUserOnSector(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationTypeId (optional) 
     * @param sectorId (optional) 
     * @param loadByCurrentUserSectors (optional) 
     * @param includeEmptyOption (optional) 
     * @return Success
     */
    getOrganizaitonUnitTreeNodes(organizationTypeId: number | undefined, sectorId: number | undefined, loadByCurrentUserSectors: boolean | undefined, includeEmptyOption: boolean | undefined): Observable<OrganizationUnitTreeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/GetOrganizaitonUnitTreeNodes?";
        if (organizationTypeId === null)
            throw new Error("The parameter 'organizationTypeId' cannot be null.");
        else if (organizationTypeId !== undefined)
            url_ += "OrganizationTypeId=" + encodeURIComponent("" + organizationTypeId) + "&";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "sectorId=" + encodeURIComponent("" + sectorId) + "&";
        if (loadByCurrentUserSectors === null)
            throw new Error("The parameter 'loadByCurrentUserSectors' cannot be null.");
        else if (loadByCurrentUserSectors !== undefined)
            url_ += "LoadByCurrentUserSectors=" + encodeURIComponent("" + loadByCurrentUserSectors) + "&";
        if (includeEmptyOption === null)
            throw new Error("The parameter 'includeEmptyOption' cannot be null.");
        else if (includeEmptyOption !== undefined)
            url_ += "includeEmptyOption=" + encodeURIComponent("" + includeEmptyOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizaitonUnitTreeNodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizaitonUnitTreeNodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitTreeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitTreeModelDto>;
        }));
    }

    protected processGetOrganizaitonUnitTreeNodes(response: HttpResponseBase): Observable<OrganizationUnitTreeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitTreeModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    validateInActiveOrganizationOrUserForCurrentUser(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/ValidateInActiveOrganizationOrUserForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateInActiveOrganizationOrUserForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateInActiveOrganizationOrUserForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateInActiveOrganizationOrUserForCurrentUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isCurrentUserOrganizationActive(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/IsCurrentUserOrganizationActive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCurrentUserOrganizationActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCurrentUserOrganizationActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCurrentUserOrganizationActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orgId (optional) 
     * @return Success
     */
    getOrganizationCliamAccountById(orgId: number | undefined): Observable<LookupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/getOrganizationCliamAccountById?";
        if (orgId === null)
            throw new Error("The parameter 'orgId' cannot be null.");
        else if (orgId !== undefined)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationCliamAccountById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationCliamAccountById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupDto[]>;
        }));
    }

    protected processGetOrganizationCliamAccountById(response: HttpResponseBase): Observable<LookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orgId (optional) 
     * @return Success
     */
    businessValidationsForLoggedInUser(orgId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/BusinessValidationsForLoggedInUser?";
        if (orgId === null)
            throw new Error("The parameter 'orgId' cannot be null.");
        else if (orgId !== undefined)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBusinessValidationsForLoggedInUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBusinessValidationsForLoggedInUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processBusinessValidationsForLoggedInUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isGovernmentUser(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/IsGovernmentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsGovernmentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsGovernmentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsGovernmentUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isSeedUser(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/IsSeedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSeedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSeedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSeedUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPortfolioCount(id: number | undefined): Observable<PortfolioTotalCountDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/GetPortfolioCount?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPortfolioCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPortfolioCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PortfolioTotalCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PortfolioTotalCountDto>;
        }));
    }

    protected processGetPortfolioCount(response: HttpResponseBase): Observable<PortfolioTotalCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PortfolioTotalCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleName (optional) 
     * @param sectorId (optional) 
     * @param fromUserId (optional) 
     * @return Success
     */
    getAllUserByRole(roleName: string | undefined, sectorId: number | undefined, fromUserId: number | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/GetAllUserByRole?";
        if (roleName === null)
            throw new Error("The parameter 'roleName' cannot be null.");
        else if (roleName !== undefined)
            url_ += "RoleName=" + encodeURIComponent("" + roleName) + "&";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "SectorId=" + encodeURIComponent("" + sectorId) + "&";
        if (fromUserId === null)
            throw new Error("The parameter 'fromUserId' cannot be null.");
        else if (fromUserId !== undefined)
            url_ += "FromUserId=" + encodeURIComponent("" + fromUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserByRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserByRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetAllUserByRole(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCurrentUserSectors(): Observable<UserSectorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/GetCurrentUserSectors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserSectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserSectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSectorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSectorDto[]>;
        }));
    }

    protected processGetCurrentUserSectors(response: HttpResponseBase): Observable<UserSectorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSectorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCurrentUserOrganization(): Observable<OrganizationUnitForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/GetCurrentUserOrganization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitForViewDto>;
        }));
    }

    protected processGetCurrentUserOrganization(response: HttpResponseBase): Observable<OrganizationUnitForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrganizationForHeader(id: number | undefined): Observable<OrganizationUnitForHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/GetOrganizationForHeader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationForHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationForHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitForHeaderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitForHeaderDto>;
        }));
    }

    protected processGetOrganizationForHeader(response: HttpResponseBase): Observable<OrganizationUnitForHeaderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitForHeaderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @param submitDate (optional) 
     * @return Success
     */
    checkFuelLateSubmittion(year: number | undefined, submitDate: DateTime | undefined): Observable<ValidSubmitDateOuput> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/CheckFuelLateSubmittion?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (submitDate === null)
            throw new Error("The parameter 'submitDate' cannot be null.");
        else if (submitDate !== undefined)
            url_ += "SubmitDate=" + encodeURIComponent(submitDate ? "" + submitDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckFuelLateSubmittion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckFuelLateSubmittion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidSubmitDateOuput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidSubmitDateOuput>;
        }));
    }

    protected processCheckFuelLateSubmittion(response: HttpResponseBase): Observable<ValidSubmitDateOuput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidSubmitDateOuput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submissionCycle (optional) 
     * @param submitDate (optional) 
     * @return Success
     */
    checkElectricityLateSubmittion(submissionCycle: string | undefined, submitDate: DateTime | undefined): Observable<ValidSubmitDateOuput> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/CheckElectricityLateSubmittion?";
        if (submissionCycle === null)
            throw new Error("The parameter 'submissionCycle' cannot be null.");
        else if (submissionCycle !== undefined)
            url_ += "SubmissionCycle=" + encodeURIComponent("" + submissionCycle) + "&";
        if (submitDate === null)
            throw new Error("The parameter 'submitDate' cannot be null.");
        else if (submitDate !== undefined)
            url_ += "SubmitDate=" + encodeURIComponent(submitDate ? "" + submitDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckElectricityLateSubmittion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckElectricityLateSubmittion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidSubmitDateOuput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidSubmitDateOuput>;
        }));
    }

    protected processCheckElectricityLateSubmittion(response: HttpResponseBase): Observable<ValidSubmitDateOuput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidSubmitDateOuput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submissionCycle (optional) 
     * @param submitDate (optional) 
     * @return Success
     */
    checkBuildingSubmissionLateSubmittion(submissionCycle: string | undefined, submitDate: DateTime | undefined): Observable<ValidSubmitDateOuput> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/CheckBuildingSubmissionLateSubmittion?";
        if (submissionCycle === null)
            throw new Error("The parameter 'submissionCycle' cannot be null.");
        else if (submissionCycle !== undefined)
            url_ += "SubmissionCycle=" + encodeURIComponent("" + submissionCycle) + "&";
        if (submitDate === null)
            throw new Error("The parameter 'submitDate' cannot be null.");
        else if (submitDate !== undefined)
            url_ += "SubmitDate=" + encodeURIComponent(submitDate ? "" + submitDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckBuildingSubmissionLateSubmittion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckBuildingSubmissionLateSubmittion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidSubmitDateOuput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidSubmitDateOuput>;
        }));
    }

    protected processCheckBuildingSubmissionLateSubmittion(response: HttpResponseBase): Observable<ValidSubmitDateOuput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidSubmitDateOuput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAutoApprovalNoOfDays(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/GetAutoApprovalNoOfDays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoApprovalNoOfDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoApprovalNoOfDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAutoApprovalNoOfDays(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationId (optional) 
     * @return Success
     */
    validatePermisison(organizationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/ValidatePermisison?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePermisison(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePermisison(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatePermisison(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    doesCurrentGovOrganizationHaveAssets(body: RequestTypesEnum | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CommonMethods/DoesCurrentGovOrganizationHaveAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoesCurrentGovOrganizationHaveAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoesCurrentGovOrganizationHaveAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDoesCurrentGovOrganizationHaveAssets(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConsumptionComparisonReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getElectricityComparisonReportToExcel(year: number, half: ReportHalf): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumptionComparisonReport/GetElectricityComparisonReportToExcel?";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (half === undefined || half === null)
            throw new Error("The parameter 'half' must be defined and cannot be null.");
        else
            url_ += "Half=" + encodeURIComponent("" + half) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElectricityComparisonReportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElectricityComparisonReportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetElectricityComparisonReportToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getElectricityComparisonReportFilters(): Observable<ElectricityComparisonReportFiltersDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumptionComparisonReport/GetElectricityComparisonReportFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElectricityComparisonReportFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElectricityComparisonReportFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectricityComparisonReportFiltersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectricityComparisonReportFiltersDto>;
        }));
    }

    protected processGetElectricityComparisonReportFilters(response: HttpResponseBase): Observable<ElectricityComparisonReportFiltersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectricityComparisonReportFiltersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFuelConsumptionReportToExcel(year: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumptionComparisonReport/GetFuelConsumptionReportToExcel?";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelConsumptionReportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelConsumptionReportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetFuelConsumptionReportToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFuelConsumptionReportYears(): Observable<FuelConsumptionReportYearsDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumptionComparisonReport/GetFuelConsumptionReportYears";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelConsumptionReportYears(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelConsumptionReportYears(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuelConsumptionReportYearsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuelConsumptionReportYearsDto>;
        }));
    }

    protected processGetFuelConsumptionReportYears(response: HttpResponseBase): Observable<FuelConsumptionReportYearsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuelConsumptionReportYearsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContactUsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrUpdateContactUsDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ContactUs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param isPublished (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, isPublished: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetContactUsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactUs/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isPublished === null)
            throw new Error("The parameter 'isPublished' cannot be null.");
        else if (isPublished !== undefined)
            url_ += "IsPublished=" + encodeURIComponent("" + isPublished) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetContactUsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetContactUsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetContactUsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetContactUsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetContactUsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactUs/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContactUsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContactUsForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetContactUsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContactUsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPublished(): Observable<GetContactUsForHomeViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactUs/GetPublished";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContactUsForHomeViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContactUsForHomeViewDto>;
        }));
    }

    protected processGetPublished(response: HttpResponseBase): Observable<GetContactUsForHomeViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContactUsForHomeViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    publish(id: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ContactUs/Publish?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ContactUs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CoolingStationAssetInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param organizationUnitIdFilter (optional) 
     * @param regionIdFilter (optional) 
     * @param technologyTypeFilter (optional) 
     * @param usageTypeFilter (optional) 
     * @param hasThermalStorageTankFilter (optional) 
     * @param waterTypeFilter (optional) 
     * @param controlSystemTypeIdFilter (optional) 
     * @param hasNearbyUnconnectedBuildingsFilter (optional) 
     * @param cityFilter (optional) 
     * @param plantCapacityFromFilter (optional) 
     * @param plantCapacityToFilter (optional) 
     * @param plantOperationDateFromFilter (optional) 
     * @param plantOperationDateToFilter (optional) 
     * @param lastRetrofitDateFromFilter (optional) 
     * @param lastRetrofitDateToFilter (optional) 
     * @param annualEnergyConsumptionFromFilter (optional) 
     * @param annualEnergyConsumptionToFilter (optional) 
     * @param annualCoolingProductionFromFilter (optional) 
     * @param annualCoolingProductionToFilter (optional) 
     * @param numberOfConnectedBuildingsFromFilter (optional) 
     * @param numberOfConnectedBuildingsToFilter (optional) 
     * @param createdDateFromFilter (optional) 
     * @param createdDateToFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(organizationUnitIdFilter: number | undefined, regionIdFilter: number | undefined, technologyTypeFilter: number | undefined, usageTypeFilter: number | undefined, hasThermalStorageTankFilter: boolean | undefined, waterTypeFilter: number | undefined, controlSystemTypeIdFilter: number | undefined, hasNearbyUnconnectedBuildingsFilter: boolean | undefined, cityFilter: string | undefined, plantCapacityFromFilter: number | undefined, plantCapacityToFilter: number | undefined, plantOperationDateFromFilter: string | undefined, plantOperationDateToFilter: string | undefined, lastRetrofitDateFromFilter: string | undefined, lastRetrofitDateToFilter: string | undefined, annualEnergyConsumptionFromFilter: number | undefined, annualEnergyConsumptionToFilter: number | undefined, annualCoolingProductionFromFilter: number | undefined, annualCoolingProductionToFilter: number | undefined, numberOfConnectedBuildingsFromFilter: number | undefined, numberOfConnectedBuildingsToFilter: number | undefined, createdDateFromFilter: DateTime | undefined, createdDateToFilter: DateTime | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCoolingStationAssetInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CoolingStationAssetInfos/GetAll?";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (regionIdFilter === null)
            throw new Error("The parameter 'regionIdFilter' cannot be null.");
        else if (regionIdFilter !== undefined)
            url_ += "RegionIdFilter=" + encodeURIComponent("" + regionIdFilter) + "&";
        if (technologyTypeFilter === null)
            throw new Error("The parameter 'technologyTypeFilter' cannot be null.");
        else if (technologyTypeFilter !== undefined)
            url_ += "TechnologyTypeFilter=" + encodeURIComponent("" + technologyTypeFilter) + "&";
        if (usageTypeFilter === null)
            throw new Error("The parameter 'usageTypeFilter' cannot be null.");
        else if (usageTypeFilter !== undefined)
            url_ += "UsageTypeFilter=" + encodeURIComponent("" + usageTypeFilter) + "&";
        if (hasThermalStorageTankFilter === null)
            throw new Error("The parameter 'hasThermalStorageTankFilter' cannot be null.");
        else if (hasThermalStorageTankFilter !== undefined)
            url_ += "HasThermalStorageTankFilter=" + encodeURIComponent("" + hasThermalStorageTankFilter) + "&";
        if (waterTypeFilter === null)
            throw new Error("The parameter 'waterTypeFilter' cannot be null.");
        else if (waterTypeFilter !== undefined)
            url_ += "WaterTypeFilter=" + encodeURIComponent("" + waterTypeFilter) + "&";
        if (controlSystemTypeIdFilter === null)
            throw new Error("The parameter 'controlSystemTypeIdFilter' cannot be null.");
        else if (controlSystemTypeIdFilter !== undefined)
            url_ += "ControlSystemTypeIdFilter=" + encodeURIComponent("" + controlSystemTypeIdFilter) + "&";
        if (hasNearbyUnconnectedBuildingsFilter === null)
            throw new Error("The parameter 'hasNearbyUnconnectedBuildingsFilter' cannot be null.");
        else if (hasNearbyUnconnectedBuildingsFilter !== undefined)
            url_ += "HasNearbyUnconnectedBuildingsFilter=" + encodeURIComponent("" + hasNearbyUnconnectedBuildingsFilter) + "&";
        if (cityFilter === null)
            throw new Error("The parameter 'cityFilter' cannot be null.");
        else if (cityFilter !== undefined)
            url_ += "CityFilter=" + encodeURIComponent("" + cityFilter) + "&";
        if (plantCapacityFromFilter === null)
            throw new Error("The parameter 'plantCapacityFromFilter' cannot be null.");
        else if (plantCapacityFromFilter !== undefined)
            url_ += "PlantCapacityFromFilter=" + encodeURIComponent("" + plantCapacityFromFilter) + "&";
        if (plantCapacityToFilter === null)
            throw new Error("The parameter 'plantCapacityToFilter' cannot be null.");
        else if (plantCapacityToFilter !== undefined)
            url_ += "PlantCapacityToFilter=" + encodeURIComponent("" + plantCapacityToFilter) + "&";
        if (plantOperationDateFromFilter === null)
            throw new Error("The parameter 'plantOperationDateFromFilter' cannot be null.");
        else if (plantOperationDateFromFilter !== undefined)
            url_ += "PlantOperationDateFromFilter=" + encodeURIComponent("" + plantOperationDateFromFilter) + "&";
        if (plantOperationDateToFilter === null)
            throw new Error("The parameter 'plantOperationDateToFilter' cannot be null.");
        else if (plantOperationDateToFilter !== undefined)
            url_ += "PlantOperationDateToFilter=" + encodeURIComponent("" + plantOperationDateToFilter) + "&";
        if (lastRetrofitDateFromFilter === null)
            throw new Error("The parameter 'lastRetrofitDateFromFilter' cannot be null.");
        else if (lastRetrofitDateFromFilter !== undefined)
            url_ += "LastRetrofitDateFromFilter=" + encodeURIComponent("" + lastRetrofitDateFromFilter) + "&";
        if (lastRetrofitDateToFilter === null)
            throw new Error("The parameter 'lastRetrofitDateToFilter' cannot be null.");
        else if (lastRetrofitDateToFilter !== undefined)
            url_ += "LastRetrofitDateToFilter=" + encodeURIComponent("" + lastRetrofitDateToFilter) + "&";
        if (annualEnergyConsumptionFromFilter === null)
            throw new Error("The parameter 'annualEnergyConsumptionFromFilter' cannot be null.");
        else if (annualEnergyConsumptionFromFilter !== undefined)
            url_ += "AnnualEnergyConsumptionFromFilter=" + encodeURIComponent("" + annualEnergyConsumptionFromFilter) + "&";
        if (annualEnergyConsumptionToFilter === null)
            throw new Error("The parameter 'annualEnergyConsumptionToFilter' cannot be null.");
        else if (annualEnergyConsumptionToFilter !== undefined)
            url_ += "AnnualEnergyConsumptionToFilter=" + encodeURIComponent("" + annualEnergyConsumptionToFilter) + "&";
        if (annualCoolingProductionFromFilter === null)
            throw new Error("The parameter 'annualCoolingProductionFromFilter' cannot be null.");
        else if (annualCoolingProductionFromFilter !== undefined)
            url_ += "AnnualCoolingProductionFromFilter=" + encodeURIComponent("" + annualCoolingProductionFromFilter) + "&";
        if (annualCoolingProductionToFilter === null)
            throw new Error("The parameter 'annualCoolingProductionToFilter' cannot be null.");
        else if (annualCoolingProductionToFilter !== undefined)
            url_ += "AnnualCoolingProductionToFilter=" + encodeURIComponent("" + annualCoolingProductionToFilter) + "&";
        if (numberOfConnectedBuildingsFromFilter === null)
            throw new Error("The parameter 'numberOfConnectedBuildingsFromFilter' cannot be null.");
        else if (numberOfConnectedBuildingsFromFilter !== undefined)
            url_ += "NumberOfConnectedBuildingsFromFilter=" + encodeURIComponent("" + numberOfConnectedBuildingsFromFilter) + "&";
        if (numberOfConnectedBuildingsToFilter === null)
            throw new Error("The parameter 'numberOfConnectedBuildingsToFilter' cannot be null.");
        else if (numberOfConnectedBuildingsToFilter !== undefined)
            url_ += "NumberOfConnectedBuildingsToFilter=" + encodeURIComponent("" + numberOfConnectedBuildingsToFilter) + "&";
        if (createdDateFromFilter === null)
            throw new Error("The parameter 'createdDateFromFilter' cannot be null.");
        else if (createdDateFromFilter !== undefined)
            url_ += "CreatedDateFromFilter=" + encodeURIComponent(createdDateFromFilter ? "" + createdDateFromFilter.toString() : "") + "&";
        if (createdDateToFilter === null)
            throw new Error("The parameter 'createdDateToFilter' cannot be null.");
        else if (createdDateToFilter !== undefined)
            url_ += "CreatedDateToFilter=" + encodeURIComponent(createdDateToFilter ? "" + createdDateToFilter.toString() : "") + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCoolingStationAssetInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCoolingStationAssetInfoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCoolingStationAssetInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCoolingStationAssetInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCoolingStationAssetInfoForView(id: number | undefined): Observable<GetCoolingStationAssetInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CoolingStationAssetInfos/GetCoolingStationAssetInfoForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoolingStationAssetInfoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoolingStationAssetInfoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCoolingStationAssetInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCoolingStationAssetInfoForViewDto>;
        }));
    }

    protected processGetCoolingStationAssetInfoForView(response: HttpResponseBase): Observable<GetCoolingStationAssetInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCoolingStationAssetInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCoolingStationAssetInfoDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CoolingStationAssetInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CoolingStationAssetInfos/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationUnitIdFilter (optional) 
     * @param regionIdFilter (optional) 
     * @param technologyTypeFilter (optional) 
     * @param usageTypeFilter (optional) 
     * @param hasThermalStorageTankFilter (optional) 
     * @param waterTypeFilter (optional) 
     * @param controlSystemTypeIdFilter (optional) 
     * @param hasNearbyUnconnectedBuildingsFilter (optional) 
     * @param cityFilter (optional) 
     * @param plantCapacityFromFilter (optional) 
     * @param plantCapacityToFilter (optional) 
     * @param plantOperationDateFromFilter (optional) 
     * @param plantOperationDateToFilter (optional) 
     * @param lastRetrofitDateFromFilter (optional) 
     * @param lastRetrofitDateToFilter (optional) 
     * @param annualEnergyConsumptionFromFilter (optional) 
     * @param annualEnergyConsumptionToFilter (optional) 
     * @param annualCoolingProductionFromFilter (optional) 
     * @param annualCoolingProductionToFilter (optional) 
     * @param numberOfConnectedBuildingsFromFilter (optional) 
     * @param numberOfConnectedBuildingsToFilter (optional) 
     * @param createdDateFromFilter (optional) 
     * @param createdDateToFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCoolingStationAssetsToExcel(organizationUnitIdFilter: number | undefined, regionIdFilter: number | undefined, technologyTypeFilter: number | undefined, usageTypeFilter: number | undefined, hasThermalStorageTankFilter: boolean | undefined, waterTypeFilter: number | undefined, controlSystemTypeIdFilter: number | undefined, hasNearbyUnconnectedBuildingsFilter: boolean | undefined, cityFilter: string | undefined, plantCapacityFromFilter: number | undefined, plantCapacityToFilter: number | undefined, plantOperationDateFromFilter: string | undefined, plantOperationDateToFilter: string | undefined, lastRetrofitDateFromFilter: string | undefined, lastRetrofitDateToFilter: string | undefined, annualEnergyConsumptionFromFilter: number | undefined, annualEnergyConsumptionToFilter: number | undefined, annualCoolingProductionFromFilter: number | undefined, annualCoolingProductionToFilter: number | undefined, numberOfConnectedBuildingsFromFilter: number | undefined, numberOfConnectedBuildingsToFilter: number | undefined, createdDateFromFilter: DateTime | undefined, createdDateToFilter: DateTime | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CoolingStationAssetInfos/GetCoolingStationAssetsToExcel?";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (regionIdFilter === null)
            throw new Error("The parameter 'regionIdFilter' cannot be null.");
        else if (regionIdFilter !== undefined)
            url_ += "RegionIdFilter=" + encodeURIComponent("" + regionIdFilter) + "&";
        if (technologyTypeFilter === null)
            throw new Error("The parameter 'technologyTypeFilter' cannot be null.");
        else if (technologyTypeFilter !== undefined)
            url_ += "TechnologyTypeFilter=" + encodeURIComponent("" + technologyTypeFilter) + "&";
        if (usageTypeFilter === null)
            throw new Error("The parameter 'usageTypeFilter' cannot be null.");
        else if (usageTypeFilter !== undefined)
            url_ += "UsageTypeFilter=" + encodeURIComponent("" + usageTypeFilter) + "&";
        if (hasThermalStorageTankFilter === null)
            throw new Error("The parameter 'hasThermalStorageTankFilter' cannot be null.");
        else if (hasThermalStorageTankFilter !== undefined)
            url_ += "HasThermalStorageTankFilter=" + encodeURIComponent("" + hasThermalStorageTankFilter) + "&";
        if (waterTypeFilter === null)
            throw new Error("The parameter 'waterTypeFilter' cannot be null.");
        else if (waterTypeFilter !== undefined)
            url_ += "WaterTypeFilter=" + encodeURIComponent("" + waterTypeFilter) + "&";
        if (controlSystemTypeIdFilter === null)
            throw new Error("The parameter 'controlSystemTypeIdFilter' cannot be null.");
        else if (controlSystemTypeIdFilter !== undefined)
            url_ += "ControlSystemTypeIdFilter=" + encodeURIComponent("" + controlSystemTypeIdFilter) + "&";
        if (hasNearbyUnconnectedBuildingsFilter === null)
            throw new Error("The parameter 'hasNearbyUnconnectedBuildingsFilter' cannot be null.");
        else if (hasNearbyUnconnectedBuildingsFilter !== undefined)
            url_ += "HasNearbyUnconnectedBuildingsFilter=" + encodeURIComponent("" + hasNearbyUnconnectedBuildingsFilter) + "&";
        if (cityFilter === null)
            throw new Error("The parameter 'cityFilter' cannot be null.");
        else if (cityFilter !== undefined)
            url_ += "CityFilter=" + encodeURIComponent("" + cityFilter) + "&";
        if (plantCapacityFromFilter === null)
            throw new Error("The parameter 'plantCapacityFromFilter' cannot be null.");
        else if (plantCapacityFromFilter !== undefined)
            url_ += "PlantCapacityFromFilter=" + encodeURIComponent("" + plantCapacityFromFilter) + "&";
        if (plantCapacityToFilter === null)
            throw new Error("The parameter 'plantCapacityToFilter' cannot be null.");
        else if (plantCapacityToFilter !== undefined)
            url_ += "PlantCapacityToFilter=" + encodeURIComponent("" + plantCapacityToFilter) + "&";
        if (plantOperationDateFromFilter === null)
            throw new Error("The parameter 'plantOperationDateFromFilter' cannot be null.");
        else if (plantOperationDateFromFilter !== undefined)
            url_ += "PlantOperationDateFromFilter=" + encodeURIComponent("" + plantOperationDateFromFilter) + "&";
        if (plantOperationDateToFilter === null)
            throw new Error("The parameter 'plantOperationDateToFilter' cannot be null.");
        else if (plantOperationDateToFilter !== undefined)
            url_ += "PlantOperationDateToFilter=" + encodeURIComponent("" + plantOperationDateToFilter) + "&";
        if (lastRetrofitDateFromFilter === null)
            throw new Error("The parameter 'lastRetrofitDateFromFilter' cannot be null.");
        else if (lastRetrofitDateFromFilter !== undefined)
            url_ += "LastRetrofitDateFromFilter=" + encodeURIComponent("" + lastRetrofitDateFromFilter) + "&";
        if (lastRetrofitDateToFilter === null)
            throw new Error("The parameter 'lastRetrofitDateToFilter' cannot be null.");
        else if (lastRetrofitDateToFilter !== undefined)
            url_ += "LastRetrofitDateToFilter=" + encodeURIComponent("" + lastRetrofitDateToFilter) + "&";
        if (annualEnergyConsumptionFromFilter === null)
            throw new Error("The parameter 'annualEnergyConsumptionFromFilter' cannot be null.");
        else if (annualEnergyConsumptionFromFilter !== undefined)
            url_ += "AnnualEnergyConsumptionFromFilter=" + encodeURIComponent("" + annualEnergyConsumptionFromFilter) + "&";
        if (annualEnergyConsumptionToFilter === null)
            throw new Error("The parameter 'annualEnergyConsumptionToFilter' cannot be null.");
        else if (annualEnergyConsumptionToFilter !== undefined)
            url_ += "AnnualEnergyConsumptionToFilter=" + encodeURIComponent("" + annualEnergyConsumptionToFilter) + "&";
        if (annualCoolingProductionFromFilter === null)
            throw new Error("The parameter 'annualCoolingProductionFromFilter' cannot be null.");
        else if (annualCoolingProductionFromFilter !== undefined)
            url_ += "AnnualCoolingProductionFromFilter=" + encodeURIComponent("" + annualCoolingProductionFromFilter) + "&";
        if (annualCoolingProductionToFilter === null)
            throw new Error("The parameter 'annualCoolingProductionToFilter' cannot be null.");
        else if (annualCoolingProductionToFilter !== undefined)
            url_ += "AnnualCoolingProductionToFilter=" + encodeURIComponent("" + annualCoolingProductionToFilter) + "&";
        if (numberOfConnectedBuildingsFromFilter === null)
            throw new Error("The parameter 'numberOfConnectedBuildingsFromFilter' cannot be null.");
        else if (numberOfConnectedBuildingsFromFilter !== undefined)
            url_ += "NumberOfConnectedBuildingsFromFilter=" + encodeURIComponent("" + numberOfConnectedBuildingsFromFilter) + "&";
        if (numberOfConnectedBuildingsToFilter === null)
            throw new Error("The parameter 'numberOfConnectedBuildingsToFilter' cannot be null.");
        else if (numberOfConnectedBuildingsToFilter !== undefined)
            url_ += "NumberOfConnectedBuildingsToFilter=" + encodeURIComponent("" + numberOfConnectedBuildingsToFilter) + "&";
        if (createdDateFromFilter === null)
            throw new Error("The parameter 'createdDateFromFilter' cannot be null.");
        else if (createdDateFromFilter !== undefined)
            url_ += "CreatedDateFromFilter=" + encodeURIComponent(createdDateFromFilter ? "" + createdDateFromFilter.toString() : "") + "&";
        if (createdDateToFilter === null)
            throw new Error("The parameter 'createdDateToFilter' cannot be null.");
        else if (createdDateToFilter !== undefined)
            url_ += "CreatedDateToFilter=" + encodeURIComponent(createdDateToFilter ? "" + createdDateToFilter.toString() : "") + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoolingStationAssetsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoolingStationAssetsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCoolingStationAssetsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedia(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/CoolingStationAssetInfos/UploadMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadMedia(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CoursesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param startDateFilter (optional) 
     * @param startTimeFilter (optional) 
     * @param endDateFilter (optional) 
     * @param endTimeFilter (optional) 
     * @param registrationStartDateFilter (optional) 
     * @param registrationStartTimeFilter (optional) 
     * @param registrationEndDateFilter (optional) 
     * @param registrationEndTimeFilter (optional) 
     * @param cancellationDeadlineFilter (optional) 
     * @param availableSeatsFilter (optional) 
     * @param topicIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(startDateFilter: DateTime | undefined, startTimeFilter: string | undefined, endDateFilter: DateTime | undefined, endTimeFilter: string | undefined, registrationStartDateFilter: DateTime | undefined, registrationStartTimeFilter: string | undefined, registrationEndDateFilter: DateTime | undefined, registrationEndTimeFilter: string | undefined, cancellationDeadlineFilter: number | undefined, availableSeatsFilter: number | undefined, topicIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCourseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Courses/GetAll?";
        if (startDateFilter === null)
            throw new Error("The parameter 'startDateFilter' cannot be null.");
        else if (startDateFilter !== undefined)
            url_ += "StartDateFilter=" + encodeURIComponent(startDateFilter ? "" + startDateFilter.toString() : "") + "&";
        if (startTimeFilter === null)
            throw new Error("The parameter 'startTimeFilter' cannot be null.");
        else if (startTimeFilter !== undefined)
            url_ += "StartTimeFilter=" + encodeURIComponent("" + startTimeFilter) + "&";
        if (endDateFilter === null)
            throw new Error("The parameter 'endDateFilter' cannot be null.");
        else if (endDateFilter !== undefined)
            url_ += "EndDateFilter=" + encodeURIComponent(endDateFilter ? "" + endDateFilter.toString() : "") + "&";
        if (endTimeFilter === null)
            throw new Error("The parameter 'endTimeFilter' cannot be null.");
        else if (endTimeFilter !== undefined)
            url_ += "EndTimeFilter=" + encodeURIComponent("" + endTimeFilter) + "&";
        if (registrationStartDateFilter === null)
            throw new Error("The parameter 'registrationStartDateFilter' cannot be null.");
        else if (registrationStartDateFilter !== undefined)
            url_ += "RegistrationStartDateFilter=" + encodeURIComponent(registrationStartDateFilter ? "" + registrationStartDateFilter.toString() : "") + "&";
        if (registrationStartTimeFilter === null)
            throw new Error("The parameter 'registrationStartTimeFilter' cannot be null.");
        else if (registrationStartTimeFilter !== undefined)
            url_ += "RegistrationStartTimeFilter=" + encodeURIComponent("" + registrationStartTimeFilter) + "&";
        if (registrationEndDateFilter === null)
            throw new Error("The parameter 'registrationEndDateFilter' cannot be null.");
        else if (registrationEndDateFilter !== undefined)
            url_ += "RegistrationEndDateFilter=" + encodeURIComponent(registrationEndDateFilter ? "" + registrationEndDateFilter.toString() : "") + "&";
        if (registrationEndTimeFilter === null)
            throw new Error("The parameter 'registrationEndTimeFilter' cannot be null.");
        else if (registrationEndTimeFilter !== undefined)
            url_ += "RegistrationEndTimeFilter=" + encodeURIComponent("" + registrationEndTimeFilter) + "&";
        if (cancellationDeadlineFilter === null)
            throw new Error("The parameter 'cancellationDeadlineFilter' cannot be null.");
        else if (cancellationDeadlineFilter !== undefined)
            url_ += "CancellationDeadlineFilter=" + encodeURIComponent("" + cancellationDeadlineFilter) + "&";
        if (availableSeatsFilter === null)
            throw new Error("The parameter 'availableSeatsFilter' cannot be null.");
        else if (availableSeatsFilter !== undefined)
            url_ += "AvailableSeatsFilter=" + encodeURIComponent("" + availableSeatsFilter) + "&";
        if (topicIdFilter === null)
            throw new Error("The parameter 'topicIdFilter' cannot be null.");
        else if (topicIdFilter !== undefined)
            url_ += "TopicIdFilter=" + encodeURIComponent("" + topicIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCourseForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCourseForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCourseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCourseForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCourseForView(id: number | undefined): Observable<GetCourseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Courses/GetCourseForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCourseForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCourseForViewDto>;
        }));
    }

    protected processGetCourseForView(response: HttpResponseBase): Observable<GetCourseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCourseForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCourseForEdit(id: number | undefined): Observable<GetCourseForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Courses/GetCourseForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCourseForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCourseForEditOutput>;
        }));
    }

    protected processGetCourseForEdit(response: HttpResponseBase): Observable<GetCourseForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCourseForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCourseDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Courses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Courses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllTopicForTableDropdown(): Observable<CourseTopicLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Courses/GetAllTopicForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTopicForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTopicForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CourseTopicLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CourseTopicLookupTableDto[]>;
        }));
    }

    protected processGetAllTopicForTableDropdown(response: HttpResponseBase): Observable<CourseTopicLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseTopicLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllTopicTypeForTableDropdown(): Observable<CourseTopicTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Courses/GetAllTopicTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTopicTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTopicTypeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CourseTopicTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CourseTopicTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllTopicTypeForTableDropdown(response: HttpResponseBase): Observable<CourseTopicTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CourseTopicTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomAreaOfImprovementsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param organizationEEPPlanYearFilter (optional) 
     * @param eEPAreaOfImprovementName_ArFilter (optional) 
     * @param eEPAreaOfImprovementNatureName_ArFilter (optional) 
     * @param organizationUnitDisplayNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, organizationEEPPlanYearFilter: string | undefined, eEPAreaOfImprovementName_ArFilter: string | undefined, eEPAreaOfImprovementNatureName_ArFilter: string | undefined, organizationUnitDisplayNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCustomAreaOfImprovementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomAreaOfImprovements/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationEEPPlanYearFilter === null)
            throw new Error("The parameter 'organizationEEPPlanYearFilter' cannot be null.");
        else if (organizationEEPPlanYearFilter !== undefined)
            url_ += "OrganizationEEPPlanYearFilter=" + encodeURIComponent("" + organizationEEPPlanYearFilter) + "&";
        if (eEPAreaOfImprovementName_ArFilter === null)
            throw new Error("The parameter 'eEPAreaOfImprovementName_ArFilter' cannot be null.");
        else if (eEPAreaOfImprovementName_ArFilter !== undefined)
            url_ += "EEPAreaOfImprovementName_ArFilter=" + encodeURIComponent("" + eEPAreaOfImprovementName_ArFilter) + "&";
        if (eEPAreaOfImprovementNatureName_ArFilter === null)
            throw new Error("The parameter 'eEPAreaOfImprovementNatureName_ArFilter' cannot be null.");
        else if (eEPAreaOfImprovementNatureName_ArFilter !== undefined)
            url_ += "EEPAreaOfImprovementNatureName_ArFilter=" + encodeURIComponent("" + eEPAreaOfImprovementNatureName_ArFilter) + "&";
        if (organizationUnitDisplayNameFilter === null)
            throw new Error("The parameter 'organizationUnitDisplayNameFilter' cannot be null.");
        else if (organizationUnitDisplayNameFilter !== undefined)
            url_ += "OrganizationUnitDisplayNameFilter=" + encodeURIComponent("" + organizationUnitDisplayNameFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCustomAreaOfImprovementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCustomAreaOfImprovementForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCustomAreaOfImprovementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCustomAreaOfImprovementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCustomAreaOfImprovementForView(id: number | undefined): Observable<GetCustomAreaOfImprovementForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomAreaOfImprovements/GetCustomAreaOfImprovementForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomAreaOfImprovementForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomAreaOfImprovementForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomAreaOfImprovementForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomAreaOfImprovementForViewDto>;
        }));
    }

    protected processGetCustomAreaOfImprovementForView(response: HttpResponseBase): Observable<GetCustomAreaOfImprovementForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomAreaOfImprovementForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCustomAreaOfImprovementForEdit(id: number | undefined): Observable<GetCustomAreaOfImprovementForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CustomAreaOfImprovements/GetCustomAreaOfImprovementForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomAreaOfImprovementForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomAreaOfImprovementForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomAreaOfImprovementForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomAreaOfImprovementForEditOutput>;
        }));
    }

    protected processGetCustomAreaOfImprovementForEdit(response: HttpResponseBase): Observable<GetCustomAreaOfImprovementForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomAreaOfImprovementForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCustomAreaOfImprovementDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CustomAreaOfImprovements/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomAreaOfImprovements/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationEEPForTableDropdown(): Observable<CustomAreaOfImprovementOrganizationEEPLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomAreaOfImprovements/GetAllOrganizationEEPForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationEEPForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationEEPForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomAreaOfImprovementOrganizationEEPLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomAreaOfImprovementOrganizationEEPLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationEEPForTableDropdown(response: HttpResponseBase): Observable<CustomAreaOfImprovementOrganizationEEPLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomAreaOfImprovementOrganizationEEPLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllEEPAreaOfImprovementForTableDropdown(): Observable<CustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomAreaOfImprovements/GetAllEEPAreaOfImprovementForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEEPAreaOfImprovementForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEEPAreaOfImprovementForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto[]>;
        }));
    }

    protected processGetAllEEPAreaOfImprovementForTableDropdown(response: HttpResponseBase): Observable<CustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllEEPAreaOfImprovementNatureForTableDropdown(): Observable<CustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomAreaOfImprovements/GetAllEEPAreaOfImprovementNatureForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEEPAreaOfImprovementNatureForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEEPAreaOfImprovementNatureForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto[]>;
        }));
    }

    protected processGetAllEEPAreaOfImprovementNatureForTableDropdown(response: HttpResponseBase): Observable<CustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationUnitForTableDropdown(): Observable<CustomAreaOfImprovementOrganizationUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomAreaOfImprovements/GetAllOrganizationUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomAreaOfImprovementOrganizationUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomAreaOfImprovementOrganizationUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationUnitForTableDropdown(response: HttpResponseBase): Observable<CustomAreaOfImprovementOrganizationUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomAreaOfImprovementOrganizationUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getUserDashboard(dashboardName: string | undefined, application: string | undefined): Observable<Dashboard> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetUserDashboard?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Dashboard>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Dashboard>;
        }));
    }

    protected processGetUserDashboard(response: HttpResponseBase): Observable<Dashboard> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dashboard.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePage(body: SavePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/SavePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSavePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renamePage(body: RenamePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/RenamePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenamePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenamePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenamePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewPage(body: AddNewPageInput | undefined): Observable<AddNewPageOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddNewPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddNewPageOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddNewPageOutput>;
        }));
    }

    protected processAddNewPage(response: HttpResponseBase): Observable<AddNewPageOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddNewPageOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    deletePage(id: string | undefined, dashboardName: string | undefined, application: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/DeletePage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addWidget(body: AddWidgetInput | undefined): Observable<Widget> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddWidget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Widget>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Widget>;
        }));
    }

    protected processAddWidget(response: HttpResponseBase): Observable<Widget> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Widget.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getDashboardDefinition(dashboardName: string | undefined, application: string | undefined): Observable<DashboardOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetDashboardDefinition?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardDefinition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardOutput>;
        }));
    }

    protected processGetDashboardDefinition(response: HttpResponseBase): Observable<DashboardOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getAllWidgetDefinitions(dashboardName: string | undefined, application: string | undefined): Observable<WidgetOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllWidgetDefinitions?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWidgetDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWidgetDefinitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WidgetOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WidgetOutput[]>;
        }));
    }

    protected processGetAllWidgetDefinitions(response: HttpResponseBase): Observable<WidgetOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param application (optional) 
     * @return Success
     */
    getSettingName(application: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetSettingName?";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSettingName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDate(date: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDateTime(date: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    sendAndGetDateRange(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    getCountries(searchTerm: string | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendAndGetSelectedCountries(body: NameValueOfString[] | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetSelectedCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendAndGetValue(input: string | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringOutput>;
        }));
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfEditionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfEditionListDto>;
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionEditOutput>;
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEdition(body: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId === null)
            throw new Error("The parameter 'selectedEditionId' cannot be null.");
        else if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getTenantCount(editionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EEPRequestDeadlineSettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param yearFilter (optional) 
     * @param isDefault (optional) 
     * @param lastDueDateSubmissionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(yearFilter: string | undefined, isDefault: boolean | undefined, lastDueDateSubmissionFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EEPRequestDeadlineSetting/GetAll?";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (isDefault === null)
            throw new Error("The parameter 'isDefault' cannot be null.");
        else if (isDefault !== undefined)
            url_ += "IsDefault=" + encodeURIComponent("" + isDefault) + "&";
        if (lastDueDateSubmissionFilter === null)
            throw new Error("The parameter 'lastDueDateSubmissionFilter' cannot be null.");
        else if (lastDueDateSubmissionFilter !== undefined)
            url_ += "LastDueDateSubmissionFilter=" + encodeURIComponent(lastDueDateSubmissionFilter ? "" + lastDueDateSubmissionFilter.toString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEEPRequestDeadlineSettingForView(id: number | undefined): Observable<GetEEPRequestDeadlineSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EEPRequestDeadlineSetting/GetEEPRequestDeadlineSettingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEEPRequestDeadlineSettingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEEPRequestDeadlineSettingForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEEPRequestDeadlineSettingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEEPRequestDeadlineSettingForViewDto>;
        }));
    }

    protected processGetEEPRequestDeadlineSettingForView(response: HttpResponseBase): Observable<GetEEPRequestDeadlineSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEEPRequestDeadlineSettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEEPRequestDeadlineSettingForEdit(id: number | undefined): Observable<GetEEPRequestDeadlineSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EEPRequestDeadlineSetting/GetEEPRequestDeadlineSettingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEEPRequestDeadlineSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEEPRequestDeadlineSettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEEPRequestDeadlineSettingForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEEPRequestDeadlineSettingForEditOutput>;
        }));
    }

    protected processGetEEPRequestDeadlineSettingForEdit(response: HttpResponseBase): Observable<GetEEPRequestDeadlineSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEEPRequestDeadlineSettingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEEPRequestDeadlineSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EEPRequestDeadlineSetting/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EEPRequestDeadlineSetting/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EfficiencyPlansServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param year (optional) 
     * @param submitDate (optional) 
     * @return Success
     */
    checkEepLateSubmittion(year: number | undefined, submitDate: DateTime | undefined): Observable<ValidSubmitDateOuput> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/CheckEepLateSubmittion?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (submitDate === null)
            throw new Error("The parameter 'submitDate' cannot be null.");
        else if (submitDate !== undefined)
            url_ += "SubmitDate=" + encodeURIComponent(submitDate ? "" + submitDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEepLateSubmittion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEepLateSubmittion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidSubmitDateOuput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidSubmitDateOuput>;
        }));
    }

    protected processCheckEepLateSubmittion(response: HttpResponseBase): Observable<ValidSubmitDateOuput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidSubmitDateOuput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getEfficiencyPlanForViewByRequestId(requestId: number | undefined): Observable<GetEfficiencyPlanForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetEfficiencyPlanForViewByRequestId?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfficiencyPlanForViewByRequestId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfficiencyPlanForViewByRequestId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEfficiencyPlanForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEfficiencyPlanForViewDto>;
        }));
    }

    protected processGetEfficiencyPlanForViewByRequestId(response: HttpResponseBase): Observable<GetEfficiencyPlanForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEfficiencyPlanForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param yearFilter (optional) 
     * @param organizationIdFilter (optional) 
     * @param requestNumberFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param onlyAssignedToMeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, yearFilter: string | undefined, organizationIdFilter: number | undefined, requestNumberFilter: string | undefined, requestStatusIdFilter: RequestStatusEnum | undefined, onlyAssignedToMeFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEfficiencyPlanForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (onlyAssignedToMeFilter === null)
            throw new Error("The parameter 'onlyAssignedToMeFilter' cannot be null.");
        else if (onlyAssignedToMeFilter !== undefined)
            url_ += "OnlyAssignedToMeFilter=" + encodeURIComponent("" + onlyAssignedToMeFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEfficiencyPlanForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEfficiencyPlanForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEfficiencyPlanForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEfficiencyPlanForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEfficiencyPlanForView(id: number | undefined): Observable<GetEfficiencyPlanForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetEfficiencyPlanForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfficiencyPlanForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfficiencyPlanForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEfficiencyPlanForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEfficiencyPlanForViewDto>;
        }));
    }

    protected processGetEfficiencyPlanForView(response: HttpResponseBase): Observable<GetEfficiencyPlanForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEfficiencyPlanForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetMyTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMyTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEfficiencyPlanDefaultDataForCreate(): Observable<GetEfficiencyPlanForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetEfficiencyPlanDefaultDataForCreate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfficiencyPlanDefaultDataForCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfficiencyPlanDefaultDataForCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEfficiencyPlanForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEfficiencyPlanForEditOutput>;
        }));
    }

    protected processGetEfficiencyPlanDefaultDataForCreate(response: HttpResponseBase): Observable<GetEfficiencyPlanForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEfficiencyPlanForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEfficiencyPlanForEdit(id: number | undefined): Observable<GetEfficiencyPlanForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetEfficiencyPlanForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEfficiencyPlanForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEfficiencyPlanForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEfficiencyPlanForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEfficiencyPlanForEditOutput>;
        }));
    }

    protected processGetEfficiencyPlanForEdit(response: HttpResponseBase): Observable<GetEfficiencyPlanForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEfficiencyPlanForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param isFuel (optional) 
     * @return Success
     */
    getOrganizationEEPForEdit(id: number | undefined, isFuel: boolean | undefined): Observable<GetOrganizationEEPForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetOrganizationEEPForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (isFuel === null)
            throw new Error("The parameter 'isFuel' cannot be null.");
        else if (isFuel !== undefined)
            url_ += "isFuel=" + encodeURIComponent("" + isFuel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationEEPForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationEEPForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationEEPForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationEEPForEditOutput>;
        }));
    }

    protected processGetOrganizationEEPForEdit(response: HttpResponseBase): Observable<GetOrganizationEEPForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationEEPForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEfficiencyPlanDto | undefined): Observable<EfficiencyPlanDto> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfficiencyPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfficiencyPlanDto>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<EfficiencyPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EfficiencyPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isAutoApprove (optional) 
     * @param submitDate (optional) 
     * @param body (optional) 
     * @return Success
     */
    submitRequest(isAutoApprove: boolean | undefined, submitDate: DateTime | undefined, body: CreateOrEditEfficiencyPlanDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/SubmitRequest?";
        if (isAutoApprove === null)
            throw new Error("The parameter 'isAutoApprove' cannot be null.");
        else if (isAutoApprove !== undefined)
            url_ += "isAutoApprove=" + encodeURIComponent("" + isAutoApprove) + "&";
        if (submitDate === null)
            throw new Error("The parameter 'submitDate' cannot be null.");
        else if (submitDate !== undefined)
            url_ += "SubmitDate=" + encodeURIComponent(submitDate ? "" + submitDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmitRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkAddedOrSubmittedPlanExists(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/CheckAddedOrSubmittedPlanExists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAddedOrSubmittedPlanExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAddedOrSubmittedPlanExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckAddedOrSubmittedPlanExists(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkPlanExists(): Observable<EfficiencyPlanDuplicateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/CheckPlanExists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPlanExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPlanExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfficiencyPlanDuplicateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfficiencyPlanDuplicateResultDto>;
        }));
    }

    protected processCheckPlanExists(response: HttpResponseBase): Observable<EfficiencyPlanDuplicateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EfficiencyPlanDuplicateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param efficiencyPlanId (optional) 
     * @return Success
     */
    deleteEfficiencyPlan(efficiencyPlanId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/DeleteEfficiencyPlan?";
        if (efficiencyPlanId === null)
            throw new Error("The parameter 'efficiencyPlanId' cannot be null.");
        else if (efficiencyPlanId !== undefined)
            url_ += "EfficiencyPlanId=" + encodeURIComponent("" + efficiencyPlanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEfficiencyPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEfficiencyPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEfficiencyPlan(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param updatedId (optional) 
     * @param organizationId (optional) 
     * @param year (optional) 
     * @return Success
     */
    chekDuplicateData(updatedId: number | undefined, organizationId: number | undefined, year: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/ChekDuplicateData?";
        if (updatedId === null)
            throw new Error("The parameter 'updatedId' cannot be null.");
        else if (updatedId !== undefined)
            url_ += "UpdatedId=" + encodeURIComponent("" + updatedId) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChekDuplicateData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChekDuplicateData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChekDuplicateData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationUnitForTableDropdown(): Observable<EfficiencyPlanOrganizationUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetAllOrganizationUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfficiencyPlanOrganizationUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfficiencyPlanOrganizationUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationUnitForTableDropdown(response: HttpResponseBase): Observable<EfficiencyPlanOrganizationUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EfficiencyPlanOrganizationUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllRequestForTableDropdown(): Observable<EfficiencyPlanRequestLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetAllRequestForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRequestForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRequestForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfficiencyPlanRequestLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfficiencyPlanRequestLookupTableDto[]>;
        }));
    }

    protected processGetAllRequestForTableDropdown(response: HttpResponseBase): Observable<EfficiencyPlanRequestLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EfficiencyPlanRequestLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationActivityForTableDropdown(): Observable<EfficiencyPlanOrganizationActivityLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetAllOrganizationActivityForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationActivityForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationActivityForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfficiencyPlanOrganizationActivityLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfficiencyPlanOrganizationActivityLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationActivityForTableDropdown(response: HttpResponseBase): Observable<EfficiencyPlanOrganizationActivityLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EfficiencyPlanOrganizationActivityLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationEEPForTableDropdown(): Observable<EfficiencyPlanOrganizationEEPLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetAllOrganizationEEPForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationEEPForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationEEPForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EfficiencyPlanOrganizationEEPLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EfficiencyPlanOrganizationEEPLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationEEPForTableDropdown(response: HttpResponseBase): Observable<EfficiencyPlanOrganizationEEPLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EfficiencyPlanOrganizationEEPLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIdFilter (optional) 
     * @param submissionCycleFilter (optional) 
     * @return Success
     */
    getData(organizationIdFilter: number | undefined, submissionCycleFilter: string | undefined): Observable<ComparisonDataDto> {
        let url_ = this.baseUrl + "/api/services/app/EfficiencyPlans/GetData?";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (submissionCycleFilter === null)
            throw new Error("The parameter 'submissionCycleFilter' cannot be null.");
        else if (submissionCycleFilter !== undefined)
            url_ += "SubmissionCycleFilter=" + encodeURIComponent("" + submissionCycleFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComparisonDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComparisonDataDto>;
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<ComparisonDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComparisonDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ElectricityComparisonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param organizationId (optional) 
     * @return Success
     */
    getAllSubmissionCycle(organizationId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/ElectricityComparison/GetAllSubmissionCycle?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubmissionCycle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubmissionCycle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllSubmissionCycle(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIdFilter (optional) 
     * @param submissionCycleFilter (optional) 
     * @return Success
     */
    getData(organizationIdFilter: number | undefined, submissionCycleFilter: string | undefined): Observable<ComparisonDataDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectricityComparison/GetData?";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (submissionCycleFilter === null)
            throw new Error("The parameter 'submissionCycleFilter' cannot be null.");
        else if (submissionCycleFilter !== undefined)
            url_ += "SubmissionCycleFilter=" + encodeURIComponent("" + submissionCycleFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComparisonDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComparisonDataDto>;
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<ComparisonDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComparisonDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ElectricityConsumptionReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param years (optional) 
     * @param reportingPeriods (optional) 
     * @param sectorIds (optional) 
     * @param entityIds (optional) 
     * @param entityClassificationIds (optional) 
     * @param electricityProviderIds (optional) 
     * @param meterTypeIds (optional) 
     * @param requestStatuses (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(years: number[] | undefined, reportingPeriods: string[] | undefined, sectorIds: number[] | undefined, entityIds: number[] | undefined, entityClassificationIds: number[] | undefined, electricityProviderIds: number[] | undefined, meterTypeIds: number[] | undefined, requestStatuses: RequestStatusEnum[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetElectricityConsumptionReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ElectricityConsumptionReport/GetAll?";
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        if (reportingPeriods === null)
            throw new Error("The parameter 'reportingPeriods' cannot be null.");
        else if (reportingPeriods !== undefined)
            reportingPeriods && reportingPeriods.forEach(item => { url_ += "ReportingPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (sectorIds === null)
            throw new Error("The parameter 'sectorIds' cannot be null.");
        else if (sectorIds !== undefined)
            sectorIds && sectorIds.forEach(item => { url_ += "SectorIds=" + encodeURIComponent("" + item) + "&"; });
        if (entityIds === null)
            throw new Error("The parameter 'entityIds' cannot be null.");
        else if (entityIds !== undefined)
            entityIds && entityIds.forEach(item => { url_ += "EntityIds=" + encodeURIComponent("" + item) + "&"; });
        if (entityClassificationIds === null)
            throw new Error("The parameter 'entityClassificationIds' cannot be null.");
        else if (entityClassificationIds !== undefined)
            entityClassificationIds && entityClassificationIds.forEach(item => { url_ += "EntityClassificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (electricityProviderIds === null)
            throw new Error("The parameter 'electricityProviderIds' cannot be null.");
        else if (electricityProviderIds !== undefined)
            electricityProviderIds && electricityProviderIds.forEach(item => { url_ += "ElectricityProviderIds=" + encodeURIComponent("" + item) + "&"; });
        if (meterTypeIds === null)
            throw new Error("The parameter 'meterTypeIds' cannot be null.");
        else if (meterTypeIds !== undefined)
            meterTypeIds && meterTypeIds.forEach(item => { url_ += "MeterTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (requestStatuses === null)
            throw new Error("The parameter 'requestStatuses' cannot be null.");
        else if (requestStatuses !== undefined)
            requestStatuses && requestStatuses.forEach(item => { url_ += "RequestStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetElectricityConsumptionReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetElectricityConsumptionReportOutput>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetElectricityConsumptionReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetElectricityConsumptionReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param years (optional) 
     * @param reportingPeriods (optional) 
     * @param sectorIds (optional) 
     * @param entityIds (optional) 
     * @param entityClassificationIds (optional) 
     * @param electricityProviderIds (optional) 
     * @param meterTypeIds (optional) 
     * @param requestStatuses (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllToExcel(years: number[] | undefined, reportingPeriods: string[] | undefined, sectorIds: number[] | undefined, entityIds: number[] | undefined, entityClassificationIds: number[] | undefined, electricityProviderIds: number[] | undefined, meterTypeIds: number[] | undefined, requestStatuses: RequestStatusEnum[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectricityConsumptionReport/GetAllToExcel?";
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        if (reportingPeriods === null)
            throw new Error("The parameter 'reportingPeriods' cannot be null.");
        else if (reportingPeriods !== undefined)
            reportingPeriods && reportingPeriods.forEach(item => { url_ += "ReportingPeriods=" + encodeURIComponent("" + item) + "&"; });
        if (sectorIds === null)
            throw new Error("The parameter 'sectorIds' cannot be null.");
        else if (sectorIds !== undefined)
            sectorIds && sectorIds.forEach(item => { url_ += "SectorIds=" + encodeURIComponent("" + item) + "&"; });
        if (entityIds === null)
            throw new Error("The parameter 'entityIds' cannot be null.");
        else if (entityIds !== undefined)
            entityIds && entityIds.forEach(item => { url_ += "EntityIds=" + encodeURIComponent("" + item) + "&"; });
        if (entityClassificationIds === null)
            throw new Error("The parameter 'entityClassificationIds' cannot be null.");
        else if (entityClassificationIds !== undefined)
            entityClassificationIds && entityClassificationIds.forEach(item => { url_ += "EntityClassificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (electricityProviderIds === null)
            throw new Error("The parameter 'electricityProviderIds' cannot be null.");
        else if (electricityProviderIds !== undefined)
            electricityProviderIds && electricityProviderIds.forEach(item => { url_ += "ElectricityProviderIds=" + encodeURIComponent("" + item) + "&"; });
        if (meterTypeIds === null)
            throw new Error("The parameter 'meterTypeIds' cannot be null.");
        else if (meterTypeIds !== undefined)
            meterTypeIds && meterTypeIds.forEach(item => { url_ += "MeterTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (requestStatuses === null)
            throw new Error("The parameter 'requestStatuses' cannot be null.");
        else if (requestStatuses !== undefined)
            requestStatuses && requestStatuses.forEach(item => { url_ += "RequestStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAllToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFilters(): Observable<ElectricityConsumptionReportFiltersDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectricityConsumptionReport/GetFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectricityConsumptionReportFiltersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectricityConsumptionReportFiltersDto>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<ElectricityConsumptionReportFiltersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectricityConsumptionReportFiltersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ElectricityHistoricalConsumptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param newOrgCode (optional) 
     * @param newOrgId (optional) 
     * @param year (optional) 
     * @param submissionCycle (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, newOrgCode: string | undefined, newOrgId: number | undefined, year: number | undefined, submissionCycle: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfElectricityHistoricalConsumptionRowDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectricityHistoricalConsumption/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (newOrgCode === null)
            throw new Error("The parameter 'newOrgCode' cannot be null.");
        else if (newOrgCode !== undefined)
            url_ += "NewOrgCode=" + encodeURIComponent("" + newOrgCode) + "&";
        if (newOrgId === null)
            throw new Error("The parameter 'newOrgId' cannot be null.");
        else if (newOrgId !== undefined)
            url_ += "NewOrgId=" + encodeURIComponent("" + newOrgId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (submissionCycle === null)
            throw new Error("The parameter 'submissionCycle' cannot be null.");
        else if (submissionCycle !== undefined)
            url_ += "SubmissionCycle=" + encodeURIComponent("" + submissionCycle) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfElectricityHistoricalConsumptionRowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfElectricityHistoricalConsumptionRowDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfElectricityHistoricalConsumptionRowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfElectricityHistoricalConsumptionRowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDropdowns(): Observable<ElectricityHistoricalDropdownsDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectricityHistoricalConsumption/GetDropdowns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDropdowns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDropdowns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectricityHistoricalDropdownsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectricityHistoricalDropdownsDto>;
        }));
    }

    protected processGetDropdowns(response: HttpResponseBase): Observable<ElectricityHistoricalDropdownsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectricityHistoricalDropdownsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param newOrgCode (optional) 
     * @param newOrgId (optional) 
     * @param year (optional) 
     * @param submissionCycle (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getElectricityHistoricalConsumptionToExcel(filter: string | undefined, newOrgCode: string | undefined, newOrgId: number | undefined, year: number | undefined, submissionCycle: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectricityHistoricalConsumption/GetElectricityHistoricalConsumptionToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (newOrgCode === null)
            throw new Error("The parameter 'newOrgCode' cannot be null.");
        else if (newOrgCode !== undefined)
            url_ += "NewOrgCode=" + encodeURIComponent("" + newOrgCode) + "&";
        if (newOrgId === null)
            throw new Error("The parameter 'newOrgId' cannot be null.");
        else if (newOrgId !== undefined)
            url_ += "NewOrgId=" + encodeURIComponent("" + newOrgId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (submissionCycle === null)
            throw new Error("The parameter 'submissionCycle' cannot be null.");
        else if (submissionCycle !== undefined)
            url_ += "SubmissionCycle=" + encodeURIComponent("" + submissionCycle) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElectricityHistoricalConsumptionToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElectricityHistoricalConsumptionToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetElectricityHistoricalConsumptionToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Emails/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmailForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmailForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmailForView(id: number | undefined): Observable<GetEmailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Emails/GetEmailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmailForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmailForViewDto>;
        }));
    }

    protected processGetEmailForView(response: HttpResponseBase): Observable<GetEmailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmailForEdit(id: number | undefined): Observable<GetEmailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Emails/GetEmailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmailForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmailForEditOutput>;
        }));
    }

    protected processGetEmailForEdit(response: HttpResponseBase): Observable<GetEmailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmailForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEmailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Emails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Emails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getEmailsToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Emails/GetEmailsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEmailsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmailTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmailTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetEmailTemplateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetEmailTemplateForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmailTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmailTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmailTemplateForView(id: number | undefined): Observable<GetEmailTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/GetEmailTemplateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplateForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmailTemplateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmailTemplateForViewDto>;
        }));
    }

    protected processGetEmailTemplateForView(response: HttpResponseBase): Observable<GetEmailTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmailTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmailTemplateForEdit(id: number | undefined): Observable<GetEmailTemplateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/GetEmailTemplateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmailTemplateForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmailTemplateForEditOutput>;
        }));
    }

    protected processGetEmailTemplateForEdit(response: HttpResponseBase): Observable<GetEmailTemplateForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmailTemplateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEmailTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FAQServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrUpdateFAQDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FAQ/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param fAQCategoryId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, fAQCategoryId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFAQForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FAQ/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (fAQCategoryId === null)
            throw new Error("The parameter 'fAQCategoryId' cannot be null.");
        else if (fAQCategoryId !== undefined)
            url_ += "FAQCategoryId=" + encodeURIComponent("" + fAQCategoryId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetFAQForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetFAQForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFAQForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFAQForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetFAQForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FAQ/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFAQForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFAQForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetFAQForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFAQForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FAQ/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return Success
     */
    getAllFAQByCategoryId(categoryId: number | undefined): Observable<GetFAQForHomeViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FAQ/GetAllFAQByCategoryId?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFAQByCategoryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFAQByCategoryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFAQForHomeViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFAQForHomeViewDto[]>;
        }));
    }

    protected processGetAllFAQByCategoryId(response: HttpResponseBase): Observable<GetFAQForHomeViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetFAQForHomeViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FAQCategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrUpdateFAQCategoryDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FAQCategory/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFAQCategoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FAQCategory/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetFAQCategoryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetFAQCategoryForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFAQCategoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFAQCategoryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetFAQCategoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FAQCategory/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFAQCategoryForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFAQCategoryForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetFAQCategoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFAQCategoryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FAQCategory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getAllLookUp(filter: string | undefined): Observable<GetFAQCategoryForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FAQCategory/GetAllLookUp?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLookUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLookUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFAQCategoryForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFAQCategoryForViewDto[]>;
        }));
    }

    protected processGetAllLookUp(response: HttpResponseBase): Observable<GetFAQCategoryForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetFAQCategoryForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    receiveFormSubmission(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Form/ReceiveFormSubmission";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReceiveFormSubmission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReceiveFormSubmission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReceiveFormSubmission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationId (optional) 
     * @return Success
     */
    canSumbmitFormNow(organizationId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Form/CanSumbmitFormNow?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanSumbmitFormNow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanSumbmitFormNow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanSumbmitFormNow(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FuelAssetInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param organizationUnitIdFilter (optional) 
     * @param assetTypeIdFilter (optional) 
     * @param assetSubTypeIdFilter (optional) 
     * @param fuelTypeIdFilter (optional) 
     * @param fuelUnitIdFilter (optional) 
     * @param manufacturerYearFromFilter (optional) 
     * @param manufacturerYearToFilter (optional) 
     * @param totalFuelConsumptionFromFilter (optional) 
     * @param totalFuelConsumptionToFilter (optional) 
     * @param createdDateFromFilter (optional) 
     * @param createdDateToFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(organizationUnitIdFilter: number | undefined, assetTypeIdFilter: number | undefined, assetSubTypeIdFilter: number | undefined, fuelTypeIdFilter: number | undefined, fuelUnitIdFilter: number | undefined, manufacturerYearFromFilter: string | undefined, manufacturerYearToFilter: string | undefined, totalFuelConsumptionFromFilter: number | undefined, totalFuelConsumptionToFilter: number | undefined, createdDateFromFilter: DateTime | undefined, createdDateToFilter: DateTime | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFuelAssetInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelAssetInfos/GetAll?";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (assetTypeIdFilter === null)
            throw new Error("The parameter 'assetTypeIdFilter' cannot be null.");
        else if (assetTypeIdFilter !== undefined)
            url_ += "AssetTypeIdFilter=" + encodeURIComponent("" + assetTypeIdFilter) + "&";
        if (assetSubTypeIdFilter === null)
            throw new Error("The parameter 'assetSubTypeIdFilter' cannot be null.");
        else if (assetSubTypeIdFilter !== undefined)
            url_ += "AssetSubTypeIdFilter=" + encodeURIComponent("" + assetSubTypeIdFilter) + "&";
        if (fuelTypeIdFilter === null)
            throw new Error("The parameter 'fuelTypeIdFilter' cannot be null.");
        else if (fuelTypeIdFilter !== undefined)
            url_ += "FuelTypeIdFilter=" + encodeURIComponent("" + fuelTypeIdFilter) + "&";
        if (fuelUnitIdFilter === null)
            throw new Error("The parameter 'fuelUnitIdFilter' cannot be null.");
        else if (fuelUnitIdFilter !== undefined)
            url_ += "FuelUnitIdFilter=" + encodeURIComponent("" + fuelUnitIdFilter) + "&";
        if (manufacturerYearFromFilter === null)
            throw new Error("The parameter 'manufacturerYearFromFilter' cannot be null.");
        else if (manufacturerYearFromFilter !== undefined)
            url_ += "ManufacturerYearFromFilter=" + encodeURIComponent("" + manufacturerYearFromFilter) + "&";
        if (manufacturerYearToFilter === null)
            throw new Error("The parameter 'manufacturerYearToFilter' cannot be null.");
        else if (manufacturerYearToFilter !== undefined)
            url_ += "ManufacturerYearToFilter=" + encodeURIComponent("" + manufacturerYearToFilter) + "&";
        if (totalFuelConsumptionFromFilter === null)
            throw new Error("The parameter 'totalFuelConsumptionFromFilter' cannot be null.");
        else if (totalFuelConsumptionFromFilter !== undefined)
            url_ += "TotalFuelConsumptionFromFilter=" + encodeURIComponent("" + totalFuelConsumptionFromFilter) + "&";
        if (totalFuelConsumptionToFilter === null)
            throw new Error("The parameter 'totalFuelConsumptionToFilter' cannot be null.");
        else if (totalFuelConsumptionToFilter !== undefined)
            url_ += "TotalFuelConsumptionToFilter=" + encodeURIComponent("" + totalFuelConsumptionToFilter) + "&";
        if (createdDateFromFilter === null)
            throw new Error("The parameter 'createdDateFromFilter' cannot be null.");
        else if (createdDateFromFilter !== undefined)
            url_ += "CreatedDateFromFilter=" + encodeURIComponent(createdDateFromFilter ? "" + createdDateFromFilter.toString() : "") + "&";
        if (createdDateToFilter === null)
            throw new Error("The parameter 'createdDateToFilter' cannot be null.");
        else if (createdDateToFilter !== undefined)
            url_ += "CreatedDateToFilter=" + encodeURIComponent(createdDateToFilter ? "" + createdDateToFilter.toString() : "") + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetFuelAssetInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetFuelAssetInfoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFuelAssetInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFuelAssetInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFuelAssetInfoForView(id: number | undefined): Observable<GetFuelAssetInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelAssetInfos/GetFuelAssetInfoForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelAssetInfoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelAssetInfoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFuelAssetInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFuelAssetInfoForViewDto>;
        }));
    }

    protected processGetFuelAssetInfoForView(response: HttpResponseBase): Observable<GetFuelAssetInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFuelAssetInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFuelAssetInfoDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FuelAssetInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FuelAssetInfos/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationUnitIdFilter (optional) 
     * @param assetTypeIdFilter (optional) 
     * @param assetSubTypeIdFilter (optional) 
     * @param fuelTypeIdFilter (optional) 
     * @param fuelUnitIdFilter (optional) 
     * @param manufacturerYearFromFilter (optional) 
     * @param manufacturerYearToFilter (optional) 
     * @param totalFuelConsumptionFromFilter (optional) 
     * @param totalFuelConsumptionToFilter (optional) 
     * @param createdDateFromFilter (optional) 
     * @param createdDateToFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFuelAssetsToExcel(organizationUnitIdFilter: number | undefined, assetTypeIdFilter: number | undefined, assetSubTypeIdFilter: number | undefined, fuelTypeIdFilter: number | undefined, fuelUnitIdFilter: number | undefined, manufacturerYearFromFilter: string | undefined, manufacturerYearToFilter: string | undefined, totalFuelConsumptionFromFilter: number | undefined, totalFuelConsumptionToFilter: number | undefined, createdDateFromFilter: DateTime | undefined, createdDateToFilter: DateTime | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelAssetInfos/GetFuelAssetsToExcel?";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (assetTypeIdFilter === null)
            throw new Error("The parameter 'assetTypeIdFilter' cannot be null.");
        else if (assetTypeIdFilter !== undefined)
            url_ += "AssetTypeIdFilter=" + encodeURIComponent("" + assetTypeIdFilter) + "&";
        if (assetSubTypeIdFilter === null)
            throw new Error("The parameter 'assetSubTypeIdFilter' cannot be null.");
        else if (assetSubTypeIdFilter !== undefined)
            url_ += "AssetSubTypeIdFilter=" + encodeURIComponent("" + assetSubTypeIdFilter) + "&";
        if (fuelTypeIdFilter === null)
            throw new Error("The parameter 'fuelTypeIdFilter' cannot be null.");
        else if (fuelTypeIdFilter !== undefined)
            url_ += "FuelTypeIdFilter=" + encodeURIComponent("" + fuelTypeIdFilter) + "&";
        if (fuelUnitIdFilter === null)
            throw new Error("The parameter 'fuelUnitIdFilter' cannot be null.");
        else if (fuelUnitIdFilter !== undefined)
            url_ += "FuelUnitIdFilter=" + encodeURIComponent("" + fuelUnitIdFilter) + "&";
        if (manufacturerYearFromFilter === null)
            throw new Error("The parameter 'manufacturerYearFromFilter' cannot be null.");
        else if (manufacturerYearFromFilter !== undefined)
            url_ += "ManufacturerYearFromFilter=" + encodeURIComponent("" + manufacturerYearFromFilter) + "&";
        if (manufacturerYearToFilter === null)
            throw new Error("The parameter 'manufacturerYearToFilter' cannot be null.");
        else if (manufacturerYearToFilter !== undefined)
            url_ += "ManufacturerYearToFilter=" + encodeURIComponent("" + manufacturerYearToFilter) + "&";
        if (totalFuelConsumptionFromFilter === null)
            throw new Error("The parameter 'totalFuelConsumptionFromFilter' cannot be null.");
        else if (totalFuelConsumptionFromFilter !== undefined)
            url_ += "TotalFuelConsumptionFromFilter=" + encodeURIComponent("" + totalFuelConsumptionFromFilter) + "&";
        if (totalFuelConsumptionToFilter === null)
            throw new Error("The parameter 'totalFuelConsumptionToFilter' cannot be null.");
        else if (totalFuelConsumptionToFilter !== undefined)
            url_ += "TotalFuelConsumptionToFilter=" + encodeURIComponent("" + totalFuelConsumptionToFilter) + "&";
        if (createdDateFromFilter === null)
            throw new Error("The parameter 'createdDateFromFilter' cannot be null.");
        else if (createdDateFromFilter !== undefined)
            url_ += "CreatedDateFromFilter=" + encodeURIComponent(createdDateFromFilter ? "" + createdDateFromFilter.toString() : "") + "&";
        if (createdDateToFilter === null)
            throw new Error("The parameter 'createdDateToFilter' cannot be null.");
        else if (createdDateToFilter !== undefined)
            url_ += "CreatedDateToFilter=" + encodeURIComponent(createdDateToFilter ? "" + createdDateToFilter.toString() : "") + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelAssetsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelAssetsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetFuelAssetsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedia(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelAssetInfos/UploadMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadMedia(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FuelComparisonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param organizationId (optional) 
     * @return Success
     */
    getAllSubmissionCycle(organizationId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/FuelComparison/GetAllSubmissionCycle?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubmissionCycle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubmissionCycle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllSubmissionCycle(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationIdFilter (optional) 
     * @param submissionCycleFilter (optional) 
     * @return Success
     */
    getData(organizationIdFilter: number | undefined, submissionCycleFilter: string | undefined): Observable<FuelComparisonData> {
        let url_ = this.baseUrl + "/api/services/app/FuelComparison/GetData?";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (submissionCycleFilter === null)
            throw new Error("The parameter 'submissionCycleFilter' cannot be null.");
        else if (submissionCycleFilter !== undefined)
            url_ += "SubmissionCycleFilter=" + encodeURIComponent("" + submissionCycleFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuelComparisonData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuelComparisonData>;
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<FuelComparisonData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuelComparisonData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FuelConsumptionReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param years (optional) 
     * @param entityIds (optional) 
     * @param govTierIds (optional) 
     * @param fuelTypeIds (optional) 
     * @param vehicleTypeIds (optional) 
     * @param requestStatuses (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(years: number[] | undefined, entityIds: number[] | undefined, govTierIds: number[] | undefined, fuelTypeIds: number[] | undefined, vehicleTypeIds: number[] | undefined, requestStatuses: RequestStatusEnum[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetFuelConsumptionReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/FuelConsumptionReport/GetAll?";
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        if (entityIds === null)
            throw new Error("The parameter 'entityIds' cannot be null.");
        else if (entityIds !== undefined)
            entityIds && entityIds.forEach(item => { url_ += "EntityIds=" + encodeURIComponent("" + item) + "&"; });
        if (govTierIds === null)
            throw new Error("The parameter 'govTierIds' cannot be null.");
        else if (govTierIds !== undefined)
            govTierIds && govTierIds.forEach(item => { url_ += "GovTierIds=" + encodeURIComponent("" + item) + "&"; });
        if (fuelTypeIds === null)
            throw new Error("The parameter 'fuelTypeIds' cannot be null.");
        else if (fuelTypeIds !== undefined)
            fuelTypeIds && fuelTypeIds.forEach(item => { url_ += "FuelTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (vehicleTypeIds === null)
            throw new Error("The parameter 'vehicleTypeIds' cannot be null.");
        else if (vehicleTypeIds !== undefined)
            vehicleTypeIds && vehicleTypeIds.forEach(item => { url_ += "VehicleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (requestStatuses === null)
            throw new Error("The parameter 'requestStatuses' cannot be null.");
        else if (requestStatuses !== undefined)
            requestStatuses && requestStatuses.forEach(item => { url_ += "RequestStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFuelConsumptionReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFuelConsumptionReportOutput>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetFuelConsumptionReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFuelConsumptionReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param years (optional) 
     * @param entityIds (optional) 
     * @param govTierIds (optional) 
     * @param fuelTypeIds (optional) 
     * @param vehicleTypeIds (optional) 
     * @param requestStatuses (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllToExcel(years: number[] | undefined, entityIds: number[] | undefined, govTierIds: number[] | undefined, fuelTypeIds: number[] | undefined, vehicleTypeIds: number[] | undefined, requestStatuses: RequestStatusEnum[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelConsumptionReport/GetAllToExcel?";
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        if (entityIds === null)
            throw new Error("The parameter 'entityIds' cannot be null.");
        else if (entityIds !== undefined)
            entityIds && entityIds.forEach(item => { url_ += "EntityIds=" + encodeURIComponent("" + item) + "&"; });
        if (govTierIds === null)
            throw new Error("The parameter 'govTierIds' cannot be null.");
        else if (govTierIds !== undefined)
            govTierIds && govTierIds.forEach(item => { url_ += "GovTierIds=" + encodeURIComponent("" + item) + "&"; });
        if (fuelTypeIds === null)
            throw new Error("The parameter 'fuelTypeIds' cannot be null.");
        else if (fuelTypeIds !== undefined)
            fuelTypeIds && fuelTypeIds.forEach(item => { url_ += "FuelTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (vehicleTypeIds === null)
            throw new Error("The parameter 'vehicleTypeIds' cannot be null.");
        else if (vehicleTypeIds !== undefined)
            vehicleTypeIds && vehicleTypeIds.forEach(item => { url_ += "VehicleTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (requestStatuses === null)
            throw new Error("The parameter 'requestStatuses' cannot be null.");
        else if (requestStatuses !== undefined)
            requestStatuses && requestStatuses.forEach(item => { url_ += "RequestStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAllToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFilters(): Observable<FuelConsumptionReportFiltersDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelConsumptionReport/GetFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuelConsumptionReportFiltersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuelConsumptionReportFiltersDto>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<FuelConsumptionReportFiltersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuelConsumptionReportFiltersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FuelHistoricalConsumptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param newOrgCode (optional) 
     * @param newOrgId (optional) 
     * @param year (optional) 
     * @param fuelType (optional) 
     * @param unit (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, newOrgCode: string | undefined, newOrgId: number | undefined, year: number | undefined, fuelType: string | undefined, unit: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFuelHistoricalConsumptionRowDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelHistoricalConsumption/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (newOrgCode === null)
            throw new Error("The parameter 'newOrgCode' cannot be null.");
        else if (newOrgCode !== undefined)
            url_ += "NewOrgCode=" + encodeURIComponent("" + newOrgCode) + "&";
        if (newOrgId === null)
            throw new Error("The parameter 'newOrgId' cannot be null.");
        else if (newOrgId !== undefined)
            url_ += "NewOrgId=" + encodeURIComponent("" + newOrgId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (fuelType === null)
            throw new Error("The parameter 'fuelType' cannot be null.");
        else if (fuelType !== undefined)
            url_ += "FuelType=" + encodeURIComponent("" + fuelType) + "&";
        if (unit === null)
            throw new Error("The parameter 'unit' cannot be null.");
        else if (unit !== undefined)
            url_ += "Unit=" + encodeURIComponent("" + unit) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFuelHistoricalConsumptionRowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFuelHistoricalConsumptionRowDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfFuelHistoricalConsumptionRowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFuelHistoricalConsumptionRowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDropdowns(): Observable<FuelHistoricalDropdownsDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelHistoricalConsumption/GetDropdowns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDropdowns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDropdowns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuelHistoricalDropdownsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuelHistoricalDropdownsDto>;
        }));
    }

    protected processGetDropdowns(response: HttpResponseBase): Observable<FuelHistoricalDropdownsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuelHistoricalDropdownsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param newOrgCode (optional) 
     * @param newOrgId (optional) 
     * @param year (optional) 
     * @param fuelType (optional) 
     * @param unit (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFuelHistoricalConsumptionToExcel(filter: string | undefined, newOrgCode: string | undefined, newOrgId: number | undefined, year: number | undefined, fuelType: string | undefined, unit: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelHistoricalConsumption/GetFuelHistoricalConsumptionToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (newOrgCode === null)
            throw new Error("The parameter 'newOrgCode' cannot be null.");
        else if (newOrgCode !== undefined)
            url_ += "NewOrgCode=" + encodeURIComponent("" + newOrgCode) + "&";
        if (newOrgId === null)
            throw new Error("The parameter 'newOrgId' cannot be null.");
        else if (newOrgId !== undefined)
            url_ += "NewOrgId=" + encodeURIComponent("" + newOrgId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (fuelType === null)
            throw new Error("The parameter 'fuelType' cannot be null.");
        else if (fuelType !== undefined)
            url_ += "FuelType=" + encodeURIComponent("" + fuelType) + "&";
        if (unit === null)
            throw new Error("The parameter 'unit' cannot be null.");
        else if (unit !== undefined)
            url_ += "Unit=" + encodeURIComponent("" + unit) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelHistoricalConsumptionToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelHistoricalConsumptionToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetFuelHistoricalConsumptionToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FuelProviderDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fuelProviderId (optional) 
     * @return Success
     */
    getPickedByEntities(fuelProviderId: number | undefined): Observable<PickedByEntitiesViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/GetPickedByEntities?";
        if (fuelProviderId === null)
            throw new Error("The parameter 'fuelProviderId' cannot be null.");
        else if (fuelProviderId !== undefined)
            url_ += "fuelProviderId=" + encodeURIComponent("" + fuelProviderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPickedByEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPickedByEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PickedByEntitiesViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PickedByEntitiesViewDto[]>;
        }));
    }

    protected processGetPickedByEntities(response: HttpResponseBase): Observable<PickedByEntitiesViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PickedByEntitiesViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCurrentUnitName(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/GetCurrentUnitName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUnitName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUnitName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCurrentUnitName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param yearFilter (optional) 
     * @param organizationIdFilter (optional) 
     * @param requestNumberFilter (optional) 
     * @param sectorFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param onlyAssignedToMeFilter (optional) 
     * @param currentFuelProviderUnitIdFilter (optional) 
     * @param fuelProviderUnitIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(yearFilter: string | undefined, organizationIdFilter: number | undefined, requestNumberFilter: string | undefined, sectorFilter: number | undefined, requestStatusIdFilter: number | undefined, onlyAssignedToMeFilter: boolean | undefined, currentFuelProviderUnitIdFilter: boolean | undefined, fuelProviderUnitIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFuelProviderDataForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/GetAll?";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (sectorFilter === null)
            throw new Error("The parameter 'sectorFilter' cannot be null.");
        else if (sectorFilter !== undefined)
            url_ += "SectorFilter=" + encodeURIComponent("" + sectorFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (onlyAssignedToMeFilter === null)
            throw new Error("The parameter 'onlyAssignedToMeFilter' cannot be null.");
        else if (onlyAssignedToMeFilter !== undefined)
            url_ += "OnlyAssignedToMeFilter=" + encodeURIComponent("" + onlyAssignedToMeFilter) + "&";
        if (currentFuelProviderUnitIdFilter === null)
            throw new Error("The parameter 'currentFuelProviderUnitIdFilter' cannot be null.");
        else if (currentFuelProviderUnitIdFilter !== undefined)
            url_ += "CurrentFuelProviderUnitIdFilter=" + encodeURIComponent("" + currentFuelProviderUnitIdFilter) + "&";
        if (fuelProviderUnitIdFilter === null)
            throw new Error("The parameter 'fuelProviderUnitIdFilter' cannot be null.");
        else if (fuelProviderUnitIdFilter !== undefined)
            url_ += "FuelProviderUnitIdFilter=" + encodeURIComponent("" + fuelProviderUnitIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetFuelProviderDataForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetFuelProviderDataForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFuelProviderDataForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFuelProviderDataForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFuelProviderDataForView(id: number | undefined): Observable<GetFuelProviderDataForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/GetFuelProviderDataForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelProviderDataForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelProviderDataForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFuelProviderDataForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFuelProviderDataForViewDto>;
        }));
    }

    protected processGetFuelProviderDataForView(response: HttpResponseBase): Observable<GetFuelProviderDataForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFuelProviderDataForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFuelProviderDataForEdit(id: number | undefined): Observable<GetFuelProviderDataForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/GetFuelProviderDataForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelProviderDataForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelProviderDataForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFuelProviderDataForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFuelProviderDataForEditOutput>;
        }));
    }

    protected processGetFuelProviderDataForEdit(response: HttpResponseBase): Observable<GetFuelProviderDataForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFuelProviderDataForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFuelProviderDataDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: CreateOrEditFuelProviderDataDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fuelProviderDataId (optional) 
     * @return Success
     */
    getProviderDetailsDataByMasterId(fuelProviderDataId: number | undefined): Observable<GetFuelProviderDetailForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/GetProviderDetailsDataByMasterId?";
        if (fuelProviderDataId === null)
            throw new Error("The parameter 'fuelProviderDataId' cannot be null.");
        else if (fuelProviderDataId !== undefined)
            url_ += "FuelProviderDataId=" + encodeURIComponent("" + fuelProviderDataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderDetailsDataByMasterId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderDetailsDataByMasterId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFuelProviderDetailForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFuelProviderDetailForViewDto[]>;
        }));
    }

    protected processGetProviderDetailsDataByMasterId(response: HttpResponseBase): Observable<GetFuelProviderDetailForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetFuelProviderDetailForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param yearFilter (optional) 
     * @param organizationUnitDisplayNameFilter (optional) 
     * @param requestRejectionReasonFilter (optional) 
     * @return Success
     */
    getFuelProviderDatasToExcel(filter: string | undefined, yearFilter: string | undefined, organizationUnitDisplayNameFilter: string | undefined, requestRejectionReasonFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/GetFuelProviderDatasToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (organizationUnitDisplayNameFilter === null)
            throw new Error("The parameter 'organizationUnitDisplayNameFilter' cannot be null.");
        else if (organizationUnitDisplayNameFilter !== undefined)
            url_ += "OrganizationUnitDisplayNameFilter=" + encodeURIComponent("" + organizationUnitDisplayNameFilter) + "&";
        if (requestRejectionReasonFilter === null)
            throw new Error("The parameter 'requestRejectionReasonFilter' cannot be null.");
        else if (requestRejectionReasonFilter !== undefined)
            url_ += "RequestRejectionReasonFilter=" + encodeURIComponent("" + requestRejectionReasonFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelProviderDatasToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelProviderDatasToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetFuelProviderDatasToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationUnitForTableDropdown(): Observable<FuelProviderDataOrganizationUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/GetAllOrganizationUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuelProviderDataOrganizationUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuelProviderDataOrganizationUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationUnitForTableDropdown(response: HttpResponseBase): Observable<FuelProviderDataOrganizationUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FuelProviderDataOrganizationUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllRequestForTableDropdown(): Observable<FuelProviderDataRequestLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/GetAllRequestForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRequestForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRequestForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuelProviderDataRequestLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuelProviderDataRequestLookupTableDto[]>;
        }));
    }

    protected processGetAllRequestForTableDropdown(response: HttpResponseBase): Observable<FuelProviderDataRequestLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FuelProviderDataRequestLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProviderDetailData(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/DeleteProviderDetailData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProviderDetailData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProviderDetailData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProviderDetailData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param updatedFuelProviderId (optional) 
     * @param organizationId (optional) 
     * @param year (optional) 
     * @param fuelProviderUnitId (optional) 
     * @return Success
     */
    checkIfFuelProviderDataFound(updatedFuelProviderId: number | undefined, organizationId: number | undefined, year: string | undefined, fuelProviderUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/CheckIfFuelProviderDataFound?";
        if (updatedFuelProviderId === null)
            throw new Error("The parameter 'updatedFuelProviderId' cannot be null.");
        else if (updatedFuelProviderId !== undefined)
            url_ += "UpdatedFuelProviderId=" + encodeURIComponent("" + updatedFuelProviderId) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (fuelProviderUnitId === null)
            throw new Error("The parameter 'fuelProviderUnitId' cannot be null.");
        else if (fuelProviderUnitId !== undefined)
            url_ += "FuelProviderUnitId=" + encodeURIComponent("" + fuelProviderUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfFuelProviderDataFound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfFuelProviderDataFound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckIfFuelProviderDataFound(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderData/GetMyTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMyTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FuelProviderDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param fuelProviderDataYearFilter (optional) 
     * @param fuelTypeName_ArFilter (optional) 
     * @param fuelUnitName_ArFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, maxQuantityFilter: number | undefined, minQuantityFilter: number | undefined, fuelProviderDataYearFilter: string | undefined, fuelTypeName_ArFilter: string | undefined, fuelUnitName_ArFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFuelProviderDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderDetails/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (maxQuantityFilter === null)
            throw new Error("The parameter 'maxQuantityFilter' cannot be null.");
        else if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter === null)
            throw new Error("The parameter 'minQuantityFilter' cannot be null.");
        else if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (fuelProviderDataYearFilter === null)
            throw new Error("The parameter 'fuelProviderDataYearFilter' cannot be null.");
        else if (fuelProviderDataYearFilter !== undefined)
            url_ += "FuelProviderDataYearFilter=" + encodeURIComponent("" + fuelProviderDataYearFilter) + "&";
        if (fuelTypeName_ArFilter === null)
            throw new Error("The parameter 'fuelTypeName_ArFilter' cannot be null.");
        else if (fuelTypeName_ArFilter !== undefined)
            url_ += "FuelTypeName_ArFilter=" + encodeURIComponent("" + fuelTypeName_ArFilter) + "&";
        if (fuelUnitName_ArFilter === null)
            throw new Error("The parameter 'fuelUnitName_ArFilter' cannot be null.");
        else if (fuelUnitName_ArFilter !== undefined)
            url_ += "FuelUnitName_ArFilter=" + encodeURIComponent("" + fuelUnitName_ArFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetFuelProviderDetailForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetFuelProviderDetailForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFuelProviderDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFuelProviderDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFuelProviderDetailForView(id: number | undefined): Observable<GetFuelProviderDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderDetails/GetFuelProviderDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelProviderDetailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelProviderDetailForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFuelProviderDetailForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFuelProviderDetailForViewDto>;
        }));
    }

    protected processGetFuelProviderDetailForView(response: HttpResponseBase): Observable<GetFuelProviderDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFuelProviderDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFuelProviderDetailForEdit(id: number | undefined): Observable<GetFuelProviderDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderDetails/GetFuelProviderDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelProviderDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelProviderDetailForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFuelProviderDetailForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFuelProviderDetailForEditOutput>;
        }));
    }

    protected processGetFuelProviderDetailForEdit(response: HttpResponseBase): Observable<GetFuelProviderDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFuelProviderDetailForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFuelProviderDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderDetails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllFuelProviderDataForTableDropdown(): Observable<FuelProviderDetailFuelProviderDataLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderDetails/GetAllFuelProviderDataForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFuelProviderDataForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFuelProviderDataForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuelProviderDetailFuelProviderDataLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuelProviderDetailFuelProviderDataLookupTableDto[]>;
        }));
    }

    protected processGetAllFuelProviderDataForTableDropdown(response: HttpResponseBase): Observable<FuelProviderDetailFuelProviderDataLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FuelProviderDetailFuelProviderDataLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllFuelTypeForTableDropdown(): Observable<FuelProviderDetailFuelTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderDetails/GetAllFuelTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFuelTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFuelTypeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuelProviderDetailFuelTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuelProviderDetailFuelTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllFuelTypeForTableDropdown(response: HttpResponseBase): Observable<FuelProviderDetailFuelTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FuelProviderDetailFuelTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllFuelUnitForTableDropdown(): Observable<FuelProviderDetailFuelUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FuelProviderDetails/GetAllFuelUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFuelUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFuelUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuelProviderDetailFuelUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuelProviderDetailFuelUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllFuelUnitForTableDropdown(response: HttpResponseBase): Observable<FuelProviderDetailFuelUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FuelProviderDetailFuelUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GeneratorInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param generatorNameFilter (optional) 
     * @param manufacturerNameFilter (optional) 
     * @param typeAndModelFilter (optional) 
     * @param fuelTypeName_ArFilter (optional) 
     * @param powerFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(generatorNameFilter: string | undefined, manufacturerNameFilter: string | undefined, typeAndModelFilter: string | undefined, fuelTypeName_ArFilter: string | undefined, powerFilter: number | undefined, organizationUnitIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetGeneratorInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorInfos/GetAll?";
        if (generatorNameFilter === null)
            throw new Error("The parameter 'generatorNameFilter' cannot be null.");
        else if (generatorNameFilter !== undefined)
            url_ += "GeneratorNameFilter=" + encodeURIComponent("" + generatorNameFilter) + "&";
        if (manufacturerNameFilter === null)
            throw new Error("The parameter 'manufacturerNameFilter' cannot be null.");
        else if (manufacturerNameFilter !== undefined)
            url_ += "ManufacturerNameFilter=" + encodeURIComponent("" + manufacturerNameFilter) + "&";
        if (typeAndModelFilter === null)
            throw new Error("The parameter 'typeAndModelFilter' cannot be null.");
        else if (typeAndModelFilter !== undefined)
            url_ += "TypeAndModelFilter=" + encodeURIComponent("" + typeAndModelFilter) + "&";
        if (fuelTypeName_ArFilter === null)
            throw new Error("The parameter 'fuelTypeName_ArFilter' cannot be null.");
        else if (fuelTypeName_ArFilter !== undefined)
            url_ += "FuelTypeName_ArFilter=" + encodeURIComponent("" + fuelTypeName_ArFilter) + "&";
        if (powerFilter === null)
            throw new Error("The parameter 'powerFilter' cannot be null.");
        else if (powerFilter !== undefined)
            url_ += "PowerFilter=" + encodeURIComponent("" + powerFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetGeneratorInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetGeneratorInfoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGeneratorInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetGeneratorInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGeneratorInfoForView(id: number | undefined): Observable<GetGeneratorInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorInfos/GetGeneratorInfoForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneratorInfoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratorInfoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneratorInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneratorInfoForViewDto>;
        }));
    }

    protected processGetGeneratorInfoForView(response: HttpResponseBase): Observable<GetGeneratorInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneratorInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGeneratorInfoForEdit(id: number | undefined): Observable<GetGeneratorInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorInfos/GetGeneratorInfoForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneratorInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratorInfoForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneratorInfoForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneratorInfoForEditOutput>;
        }));
    }

    protected processGetGeneratorInfoForEdit(response: HttpResponseBase): Observable<GetGeneratorInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneratorInfoForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditGeneratorInfoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorInfos/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllFuelTypeForTableDropdown(): Observable<GeneratorInfoFuelTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorInfos/GetAllFuelTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFuelTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFuelTypeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneratorInfoFuelTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneratorInfoFuelTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllFuelTypeForTableDropdown(response: HttpResponseBase): Observable<GeneratorInfoFuelTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneratorInfoFuelTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationUnitForTableDropdown(): Observable<GeneratorInfoOrganizationUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorInfos/GetAllOrganizationUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneratorInfoOrganizationUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneratorInfoOrganizationUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationUnitForTableDropdown(response: HttpResponseBase): Observable<GeneratorInfoOrganizationUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneratorInfoOrganizationUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GovAwarnessContentPublicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditGovAwarnessContentPublicationDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GovAwarnessContentPublication/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seecContentId (optional) 
     * @param publicationDate (optional) 
     * @param publicationTypeId (optional) 
     * @param requestNumber (optional) 
     * @param publicationDurationInDays (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(seecContentId: number | undefined, publicationDate: DateTime | undefined, publicationTypeId: number | undefined, requestNumber: string | undefined, publicationDurationInDays: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGovAwarnessContentPublicationDto> {
        let url_ = this.baseUrl + "/api/services/app/GovAwarnessContentPublication/GetAll?";
        if (seecContentId === null)
            throw new Error("The parameter 'seecContentId' cannot be null.");
        else if (seecContentId !== undefined)
            url_ += "SeecContentId=" + encodeURIComponent("" + seecContentId) + "&";
        if (publicationDate === null)
            throw new Error("The parameter 'publicationDate' cannot be null.");
        else if (publicationDate !== undefined)
            url_ += "PublicationDate=" + encodeURIComponent(publicationDate ? "" + publicationDate.toString() : "") + "&";
        if (publicationTypeId === null)
            throw new Error("The parameter 'publicationTypeId' cannot be null.");
        else if (publicationTypeId !== undefined)
            url_ += "PublicationTypeId=" + encodeURIComponent("" + publicationTypeId) + "&";
        if (requestNumber === null)
            throw new Error("The parameter 'requestNumber' cannot be null.");
        else if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&";
        if (publicationDurationInDays === null)
            throw new Error("The parameter 'publicationDurationInDays' cannot be null.");
        else if (publicationDurationInDays !== undefined)
            url_ += "PublicationDurationInDays=" + encodeURIComponent("" + publicationDurationInDays) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGovAwarnessContentPublicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGovAwarnessContentPublicationDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGovAwarnessContentPublicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGovAwarnessContentPublicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGovAwarnessContentPublicationForEdit(id: number | undefined): Observable<CreateOrEditGovAwarnessContentPublicationDto> {
        let url_ = this.baseUrl + "/api/services/app/GovAwarnessContentPublication/GetGovAwarnessContentPublicationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGovAwarnessContentPublicationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGovAwarnessContentPublicationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrEditGovAwarnessContentPublicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrEditGovAwarnessContentPublicationDto>;
        }));
    }

    protected processGetGovAwarnessContentPublicationForEdit(response: HttpResponseBase): Observable<CreateOrEditGovAwarnessContentPublicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditGovAwarnessContentPublicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGovAwarnessContentPublicationForView(id: number | undefined): Observable<GovAwarnessContentPublicationDto> {
        let url_ = this.baseUrl + "/api/services/app/GovAwarnessContentPublication/GetGovAwarnessContentPublicationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGovAwarnessContentPublicationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGovAwarnessContentPublicationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GovAwarnessContentPublicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GovAwarnessContentPublicationDto>;
        }));
    }

    protected processGetGovAwarnessContentPublicationForView(response: HttpResponseBase): Observable<GovAwarnessContentPublicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GovAwarnessContentPublicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GovElectricitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param submissionCycleFilter (optional) 
     * @param yearFilter (optional) 
     * @param organizationIdFilter (optional) 
     * @param requestNumberFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param onlyAssignedToMeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, submissionCycleFilter: string | undefined, yearFilter: string | undefined, organizationIdFilter: number | undefined, requestNumberFilter: string | undefined, requestStatusIdFilter: RequestStatusEnum | undefined, onlyAssignedToMeFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetGovElectricityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (submissionCycleFilter === null)
            throw new Error("The parameter 'submissionCycleFilter' cannot be null.");
        else if (submissionCycleFilter !== undefined)
            url_ += "SubmissionCycleFilter=" + encodeURIComponent("" + submissionCycleFilter) + "&";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (onlyAssignedToMeFilter === null)
            throw new Error("The parameter 'onlyAssignedToMeFilter' cannot be null.");
        else if (onlyAssignedToMeFilter !== undefined)
            url_ += "OnlyAssignedToMeFilter=" + encodeURIComponent("" + onlyAssignedToMeFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetGovElectricityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetGovElectricityForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGovElectricityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetGovElectricityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getGovElectricityForView(requestId: number | undefined): Observable<GetGovElectricityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/GetGovElectricityForView?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGovElectricityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGovElectricityForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGovElectricityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGovElectricityForViewDto>;
        }));
    }

    protected processGetGovElectricityForView(response: HttpResponseBase): Observable<GetGovElectricityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGovElectricityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getGovElectricityForEdit(requestId: number | undefined): Observable<GetGovElectricityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/GetGovElectricityForEdit?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGovElectricityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGovElectricityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGovElectricityForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGovElectricityForEditOutput>;
        }));
    }

    protected processGetGovElectricityForEdit(response: HttpResponseBase): Observable<GetGovElectricityForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGovElectricityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditGovElectricityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submissionCycleFilter (optional) 
     * @param yearFilter (optional) 
     * @param organizationIdFilter (optional) 
     * @param requestNumberFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param filter (optional) 
     * @return Success
     */
    getGovElectricitiesToExcel(submissionCycleFilter: string | undefined, yearFilter: string | undefined, organizationIdFilter: number | undefined, requestNumberFilter: string | undefined, requestStatusIdFilter: RequestStatusEnum | undefined, filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/GetGovElectricitiesToExcel?";
        if (submissionCycleFilter === null)
            throw new Error("The parameter 'submissionCycleFilter' cannot be null.");
        else if (submissionCycleFilter !== undefined)
            url_ += "SubmissionCycleFilter=" + encodeURIComponent("" + submissionCycleFilter) + "&";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGovElectricitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGovElectricitiesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetGovElectricitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: CreateOrEditGovElectricityDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitForTierA(body: CreateOrEditGovElectricityDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/SubmitForTierA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitForTierA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitForTierA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmitForTierA(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    approveGovElectricities(requestId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/ApproveGovElectricities?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveGovElectricities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveGovElectricities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveGovElectricities(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param comment (optional) 
     * @return Success
     */
    rejectGovElectricities(requestId: number | undefined, comment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/RejectGovElectricities?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (comment === null)
            throw new Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectGovElectricities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectGovElectricities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectGovElectricities(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/GetMyTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMyTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOldRequestsWithPage(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetGovElectricityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/GetOldRequestsWithPage?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOldRequestsWithPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOldRequestsWithPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetGovElectricityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetGovElectricityForViewDto>;
        }));
    }

    protected processGetOldRequestsWithPage(response: HttpResponseBase): Observable<PagedResultDtoOfGetGovElectricityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetGovElectricityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLastYearVariance(body: CreateOrEditGovElectricityDto | undefined): Observable<GovElectricityLastYearVarianceDto> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/GetLastYearVariance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastYearVariance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastYearVariance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GovElectricityLastYearVarianceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GovElectricityLastYearVarianceDto>;
        }));
    }

    protected processGetLastYearVariance(response: HttpResponseBase): Observable<GovElectricityLastYearVarianceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GovElectricityLastYearVarianceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submissionCycle (optional) 
     * @return Success
     */
    isGovElectricitySubmissionCycleExist(submissionCycle: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GovElectricities/IsGovElectricitySubmissionCycleExist?";
        if (submissionCycle === null)
            throw new Error("The parameter 'submissionCycle' cannot be null.");
        else if (submissionCycle !== undefined)
            url_ += "submissionCycle=" + encodeURIComponent("" + submissionCycle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsGovElectricitySubmissionCycleExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsGovElectricitySubmissionCycleExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsGovElectricitySubmissionCycleExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GovFuelConsumptionDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovFuelConsumptionData/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GovFuelsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param submissionCycleFilter (optional) 
     * @param yearFilter (optional) 
     * @param organizationIdFilter (optional) 
     * @param requestNumberFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param onlyAssignedToMeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, submissionCycleFilter: string | undefined, yearFilter: string | undefined, organizationIdFilter: number | undefined, requestNumberFilter: string | undefined, requestStatusIdFilter: RequestStatusEnum | undefined, onlyAssignedToMeFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetGovFuelForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (submissionCycleFilter === null)
            throw new Error("The parameter 'submissionCycleFilter' cannot be null.");
        else if (submissionCycleFilter !== undefined)
            url_ += "SubmissionCycleFilter=" + encodeURIComponent("" + submissionCycleFilter) + "&";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (onlyAssignedToMeFilter === null)
            throw new Error("The parameter 'onlyAssignedToMeFilter' cannot be null.");
        else if (onlyAssignedToMeFilter !== undefined)
            url_ += "OnlyAssignedToMeFilter=" + encodeURIComponent("" + onlyAssignedToMeFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetGovFuelForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetGovFuelForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGovFuelForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetGovFuelForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/GetMyTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMyTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    approveGovFuels(requestId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/ApproveGovFuels?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveGovFuels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveGovFuels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveGovFuels(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param comment (optional) 
     * @return Success
     */
    rejectGovFuels(requestId: number | undefined, comment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/RejectGovFuels?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (comment === null)
            throw new Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectGovFuels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectGovFuels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectGovFuels(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param govFuelId (optional) 
     * @return Success
     */
    getFuelConsumptionRecord(govFuelId: number | undefined): Observable<FuelConsumptionRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/GetFuelConsumptionRecord?";
        if (govFuelId === null)
            throw new Error("The parameter 'govFuelId' cannot be null.");
        else if (govFuelId !== undefined)
            url_ += "govFuelId=" + encodeURIComponent("" + govFuelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelConsumptionRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelConsumptionRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FuelConsumptionRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FuelConsumptionRecordDto>;
        }));
    }

    protected processGetFuelConsumptionRecord(response: HttpResponseBase): Observable<FuelConsumptionRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FuelConsumptionRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getGovFuelForView(requestId: number | undefined): Observable<GetGovFuelForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/GetGovFuelForView?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGovFuelForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGovFuelForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGovFuelForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGovFuelForViewDto>;
        }));
    }

    protected processGetGovFuelForView(response: HttpResponseBase): Observable<GetGovFuelForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGovFuelForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getGovFuelForEdit(requestId: number | undefined): Observable<GetGovFuelForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/GetGovFuelForEdit?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGovFuelForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGovFuelForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGovFuelForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGovFuelForEditOutput>;
        }));
    }

    protected processGetGovFuelForEdit(response: HttpResponseBase): Observable<GetGovFuelForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGovFuelForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditGovFuelDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @return Success
     */
    isGovFuelRequestYearExist(year: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/IsGovFuelRequestYearExist?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsGovFuelRequestYearExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsGovFuelRequestYearExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsGovFuelRequestYearExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: CreateOrEditGovFuelDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitForTierA(body: CreateOrEditGovFuelDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/SubmitForTierA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitForTierA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitForTierA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmitForTierA(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    cancelNotApplicable(requestId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/CancelNotApplicable?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelNotApplicable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelNotApplicable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelNotApplicable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRequestForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGovFuelRequestLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/GetAllRequestForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRequestForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRequestForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGovFuelRequestLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGovFuelRequestLookupTableDto>;
        }));
    }

    protected processGetAllRequestForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGovFuelRequestLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGovFuelRequestLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOldRequests(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOldRequestsResponseDTO> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/GetOldRequests?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOldRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOldRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOldRequestsResponseDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOldRequestsResponseDTO>;
        }));
    }

    protected processGetOldRequests(response: HttpResponseBase): Observable<PagedResultDtoOfGetOldRequestsResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOldRequestsResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mapConsumptionRecord(body: FuelConsumptionRecordDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/mapConsumptionRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMapConsumptionRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMapConsumptionRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMapConsumptionRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadNewAttachment(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/UploadNewAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadNewAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadNewAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadNewAttachment(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLastYearVariance(body: CreateOrEditGovFuelDto | undefined): Observable<GovFuelLastYearVarianceDto> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/GetLastYearVariance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastYearVariance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastYearVariance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GovFuelLastYearVarianceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GovFuelLastYearVarianceDto>;
        }));
    }

    protected processGetLastYearVariance(response: HttpResponseBase): Observable<GovFuelLastYearVarianceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GovFuelLastYearVarianceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    compareFuelConsumptionDataLists(body: FuelConsumptionRecordDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GovFuels/CompareFuelConsumptionDataLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompareFuelConsumptionDataLists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompareFuelConsumptionDataLists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompareFuelConsumptionDataLists(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getTopStatsData(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<TopStatsData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStatsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStatsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopStatsData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopStatsData>;
        }));
    }

    protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopStatsData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentTenantsOutput>;
        }));
    }

    protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionExpiringTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpiringTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpiringTenantsOutput>;
        }));
    }

    protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpiringTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncomeStatisticsDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncomeStatisticsDataOutput>;
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionTenantStatisticsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionTenantStatisticsOutput>;
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isEnabled (optional) 
     * @return Success
     */
    setNafathLoginEnabled(isEnabled: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SetNafathLoginEnabled?";
        if (isEnabled === null)
            throw new Error("The parameter 'isEnabled' cannot be null.");
        else if (isEnabled !== undefined)
            url_ += "isEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNafathLoginEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNafathLoginEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNafathLoginEnabled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingsJsonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingsJsonDto>;
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDatabaseOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDatabaseOutput>;
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class KnowledgeBankServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePublishState(body: ChangeKnowledgeBankPublishStateDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/KnowledgeBank/ChangePublishState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePublishState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePublishState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangePublishState(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrUpdateKnowledgeBankDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/KnowledgeBank/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/KnowledgeBank/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetKnowledgeBankForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/KnowledgeBank/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetKnowledgeBankForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetKnowledgeBankForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetKnowledgeBankForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetKnowledgeBankForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param category (optional) 
     * @param publishState (optional) 
     * @param creationTime (optional) 
     * @param publishStateDate (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isFeatured (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, category: number | undefined, publishState: number | undefined, creationTime: DateTime | undefined, publishStateDate: DateTime | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, isFeatured: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetKnowledgeBankForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/KnowledgeBank/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (publishState === null)
            throw new Error("The parameter 'publishState' cannot be null.");
        else if (publishState !== undefined)
            url_ += "PublishState=" + encodeURIComponent("" + publishState) + "&";
        if (creationTime === null)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toString() : "") + "&";
        if (publishStateDate === null)
            throw new Error("The parameter 'publishStateDate' cannot be null.");
        else if (publishStateDate !== undefined)
            url_ += "PublishStateDate=" + encodeURIComponent(publishStateDate ? "" + publishStateDate.toString() : "") + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (isFeatured === null)
            throw new Error("The parameter 'isFeatured' cannot be null.");
        else if (isFeatured !== undefined)
            url_ += "IsFeatured=" + encodeURIComponent("" + isFeatured) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetKnowledgeBankForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetKnowledgeBankForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetKnowledgeBankForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetKnowledgeBankForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedia(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/KnowledgeBank/UploadMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadMedia(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param category (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPublished(filter: string | undefined, category: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetKnowledgeBankForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/KnowledgeBank/GetAllPublished?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPublished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPublished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetKnowledgeBankForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetKnowledgeBankForViewDto>;
        }));
    }

    protected processGetAllPublished(response: HttpResponseBase): Observable<PagedResultDtoOfGetKnowledgeBankForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetKnowledgeBankForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPublished(id: number | undefined): Observable<GetKnowledgeBankForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/KnowledgeBank/GetPublished?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetKnowledgeBankForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetKnowledgeBankForViewDto>;
        }));
    }

    protected processGetPublished(response: HttpResponseBase): Observable<GetKnowledgeBankForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetKnowledgeBankForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeIsFeatured(body: ChangeKnowledgeBankFeaturedState | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/KnowledgeBank/ChangeIsFeatured";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeIsFeatured(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeIsFeatured(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangeIsFeatured(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined, sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, targetValueFilter: string | undefined, filterText: string | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName === null)
            throw new Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter === null)
            throw new Error("The parameter 'targetValueFilter' cannot be null.");
        else if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText === null)
            throw new Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param objType (optional) 
     * @param filterId (optional) 
     * @return Success
     */
    getListWithFilter(objType: string | undefined, filterId: string | undefined): Observable<LookupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetListWithFilter?";
        if (objType === null)
            throw new Error("The parameter 'objType' cannot be null.");
        else if (objType !== undefined)
            url_ += "objType=" + encodeURIComponent("" + objType) + "&";
        if (filterId === null)
            throw new Error("The parameter 'filterId' cannot be null.");
        else if (filterId !== undefined)
            url_ += "filterId=" + encodeURIComponent("" + filterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListWithFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListWithFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupDto[]>;
        }));
    }

    protected processGetListWithFilter(response: HttpResponseBase): Observable<LookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param objType (optional) 
     * @return Success
     */
    getList(objType: string | undefined): Observable<LookupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetList?";
        if (objType === null)
            throw new Error("The parameter 'objType' cannot be null.");
        else if (objType !== undefined)
            url_ += "objType=" + encodeURIComponent("" + objType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<LookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    populateFuelTypesByConsumerSourceId(id: string | undefined): Observable<LookupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/PopulateFuelTypesByConsumerSourceId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPopulateFuelTypesByConsumerSourceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPopulateFuelTypesByConsumerSourceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupDto[]>;
        }));
    }

    protected processPopulateFuelTypesByConsumerSourceId(response: HttpResponseBase): Observable<LookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProvidersComboBox(): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetProvidersComboBox";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProvidersComboBox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProvidersComboBox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetProvidersComboBox(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeEmptyOption (optional) 
     * @return Success
     */
    getConsTypesTreeNodes2(includeEmptyOption: boolean | undefined): Observable<ConsumerTypesTreeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetConsTypesTreeNodes2?";
        if (includeEmptyOption === null)
            throw new Error("The parameter 'includeEmptyOption' cannot be null.");
        else if (includeEmptyOption !== undefined)
            url_ += "includeEmptyOption=" + encodeURIComponent("" + includeEmptyOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsTypesTreeNodes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsTypesTreeNodes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsumerTypesTreeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsumerTypesTreeModelDto>;
        }));
    }

    protected processGetConsTypesTreeNodes2(response: HttpResponseBase): Observable<ConsumerTypesTreeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsumerTypesTreeModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fuelProviderId (optional) 
     * @param recordIndex (optional) 
     * @param includeEmptyOption (optional) 
     * @param body (optional) 
     * @return Success
     */
    filterConsTypesTreeNodes(fuelProviderId: number | undefined, recordIndex: number | undefined, includeEmptyOption: boolean | undefined, body: FuelConsumptionRecordDto[] | undefined): Observable<ConsumerTypesTreeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/FilterConsTypesTreeNodes?";
        if (fuelProviderId === null)
            throw new Error("The parameter 'fuelProviderId' cannot be null.");
        else if (fuelProviderId !== undefined)
            url_ += "fuelProviderId=" + encodeURIComponent("" + fuelProviderId) + "&";
        if (recordIndex === null)
            throw new Error("The parameter 'recordIndex' cannot be null.");
        else if (recordIndex !== undefined)
            url_ += "recordIndex=" + encodeURIComponent("" + recordIndex) + "&";
        if (includeEmptyOption === null)
            throw new Error("The parameter 'includeEmptyOption' cannot be null.");
        else if (includeEmptyOption !== undefined)
            url_ += "includeEmptyOption=" + encodeURIComponent("" + includeEmptyOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterConsTypesTreeNodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterConsTypesTreeNodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsumerTypesTreeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsumerTypesTreeModelDto>;
        }));
    }

    protected processFilterConsTypesTreeNodes(response: HttpResponseBase): Observable<ConsumerTypesTreeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsumerTypesTreeModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param consumerSourceTypeIds (optional) 
     * @param includeEmptyOption (optional) 
     * @return Success
     */
    getConsTypesTreeNodesByConsumerSourceTypeIds(consumerSourceTypeIds: number[] | undefined, includeEmptyOption: boolean | undefined): Observable<ConsumerTypesTreeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetConsTypesTreeNodesByConsumerSourceTypeIds?";
        if (consumerSourceTypeIds === null)
            throw new Error("The parameter 'consumerSourceTypeIds' cannot be null.");
        else if (consumerSourceTypeIds !== undefined)
            consumerSourceTypeIds && consumerSourceTypeIds.forEach(item => { url_ += "consumerSourceTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeEmptyOption === null)
            throw new Error("The parameter 'includeEmptyOption' cannot be null.");
        else if (includeEmptyOption !== undefined)
            url_ += "includeEmptyOption=" + encodeURIComponent("" + includeEmptyOption) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsTypesTreeNodesByConsumerSourceTypeIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsTypesTreeNodesByConsumerSourceTypeIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsumerTypesTreeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsumerTypesTreeModelDto>;
        }));
    }

    protected processGetConsTypesTreeNodesByConsumerSourceTypeIds(response: HttpResponseBase): Observable<ConsumerTypesTreeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsumerTypesTreeModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param assetCategory (optional) 
     * @return Success
     */
    getAssetTypesByCategory(assetCategory: number | undefined): Observable<AssetTypeWithMeasurementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Lookup/GetAssetTypesByCategory?";
        if (assetCategory === null)
            throw new Error("The parameter 'assetCategory' cannot be null.");
        else if (assetCategory !== undefined)
            url_ += "assetCategory=" + encodeURIComponent("" + assetCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetTypesByCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetTypesByCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetTypeWithMeasurementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetTypeWithMeasurementDto[]>;
        }));
    }

    protected processGetAssetTypesByCategory(response: HttpResponseBase): Observable<AssetTypeWithMeasurementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetTypeWithMeasurementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MainActivitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMainActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MainActivities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMainActivityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMainActivityForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMainActivityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMainActivityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMainActivityForView(id: number | undefined): Observable<GetMainActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MainActivities/GetMainActivityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainActivityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainActivityForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMainActivityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMainActivityForViewDto>;
        }));
    }

    protected processGetMainActivityForView(response: HttpResponseBase): Observable<GetMainActivityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMainActivityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMainActivityForEdit(id: number | undefined): Observable<GetMainActivityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MainActivities/GetMainActivityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainActivityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainActivityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMainActivityForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMainActivityForEditOutput>;
        }));
    }

    protected processGetMainActivityForEdit(response: HttpResponseBase): Observable<GetMainActivityForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMainActivityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditMainActivityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainActivities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MainActivities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MediaCenterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePublishState(body: ChangeMediaCenterPublishStateDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MediaCenter/ChangePublishState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePublishState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePublishState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangePublishState(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrUpdateMediaCenterDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MediaCenter/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MediaCenter/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetMediaCenterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaCenter/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMediaCenterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMediaCenterForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetMediaCenterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMediaCenterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param category (optional) 
     * @param publishState (optional) 
     * @param creationTime (optional) 
     * @param publishStateDate (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isFeatured (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, category: number | undefined, publishState: number | undefined, creationTime: DateTime | undefined, publishStateDate: DateTime | undefined, fromDate: DateTime | undefined, toDate: DateTime | undefined, isFeatured: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMediaCenterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaCenter/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (publishState === null)
            throw new Error("The parameter 'publishState' cannot be null.");
        else if (publishState !== undefined)
            url_ += "PublishState=" + encodeURIComponent("" + publishState) + "&";
        if (creationTime === null)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toString() : "") + "&";
        if (publishStateDate === null)
            throw new Error("The parameter 'publishStateDate' cannot be null.");
        else if (publishStateDate !== undefined)
            url_ += "PublishStateDate=" + encodeURIComponent(publishStateDate ? "" + publishStateDate.toString() : "") + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (isFeatured === null)
            throw new Error("The parameter 'isFeatured' cannot be null.");
        else if (isFeatured !== undefined)
            url_ += "IsFeatured=" + encodeURIComponent("" + isFeatured) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMediaCenterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMediaCenterForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMediaCenterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMediaCenterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedia(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaCenter/UploadMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadMedia(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param category (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPublished(filter: string | undefined, category: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMediaCenterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaCenter/GetAllPublished?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPublished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPublished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetMediaCenterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetMediaCenterForViewDto>;
        }));
    }

    protected processGetAllPublished(response: HttpResponseBase): Observable<PagedResultDtoOfGetMediaCenterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMediaCenterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPublished(id: number | undefined): Observable<GetMediaCenterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaCenter/GetPublished?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMediaCenterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMediaCenterForViewDto>;
        }));
    }

    protected processGetPublished(response: HttpResponseBase): Observable<GetMediaCenterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMediaCenterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeIsFeatured(body: ChangeMediaCenterFeatureState | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MediaCenter/ChangeIsFeatured";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeIsFeatured(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeIsFeatured(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangeIsFeatured(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MediaLibraryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fileToken (optional) 
     * @return Success
     */
    getMedia(fileToken: string | undefined): Observable<MediaLibraryModel> {
        let url_ = this.baseUrl + "/api/MediaLibrary/GetMedia?";
        if (fileToken === null)
            throw new Error("The parameter 'fileToken' cannot be null.");
        else if (fileToken !== undefined)
            url_ += "fileToken=" + encodeURIComponent("" + fileToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryModel>;
        }));
    }

    protected processGetMedia(response: HttpResponseBase): Observable<MediaLibraryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileToken (optional) 
     * @return Success
     */
    getMediaForAnonymous(fileToken: string | undefined): Observable<MediaLibraryModel> {
        let url_ = this.baseUrl + "/api/MediaLibrary/GetMediaForAnonymous?";
        if (fileToken === null)
            throw new Error("The parameter 'fileToken' cannot be null.");
        else if (fileToken !== undefined)
            url_ += "fileToken=" + encodeURIComponent("" + fileToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMediaForAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMediaForAnonymous(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryModel>;
        }));
    }

    protected processGetMediaForAnonymous(response: HttpResponseBase): Observable<MediaLibraryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileToken (optional) 
     * @return Success
     */
    getMediaFile(fileToken: string | undefined): Observable<HttpResponseMessage> {
        let url_ = this.baseUrl + "/api/MediaLibrary/GetMediaFile?";
        if (fileToken === null)
            throw new Error("The parameter 'fileToken' cannot be null.");
        else if (fileToken !== undefined)
            url_ += "fileToken=" + encodeURIComponent("" + fileToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMediaFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMediaFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HttpResponseMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HttpResponseMessage>;
        }));
    }

    protected processGetMediaFile(response: HttpResponseBase): Observable<HttpResponseMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HttpResponseMessage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileToken (optional) 
     * @return Success
     */
    getMediaBase64(fileToken: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/MediaLibrary/GetMediaBase64?";
        if (fileToken === null)
            throw new Error("The parameter 'fileToken' cannot be null.");
        else if (fileToken !== undefined)
            url_ += "fileToken=" + encodeURIComponent("" + fileToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMediaBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMediaBase64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetMediaBase64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MeterInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param meterNumberFilter (optional) 
     * @param premiseIdFilter (optional) 
     * @param contractAccountFilter (optional) 
     * @param subscriptionNumberFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(meterNumberFilter: string | undefined, premiseIdFilter: number | undefined, contractAccountFilter: number | undefined, subscriptionNumberFilter: string | undefined, organizationUnitIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultExtendedDtoOfGetMeterInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeterInfos/GetAll?";
        if (meterNumberFilter === null)
            throw new Error("The parameter 'meterNumberFilter' cannot be null.");
        else if (meterNumberFilter !== undefined)
            url_ += "MeterNumberFilter=" + encodeURIComponent("" + meterNumberFilter) + "&";
        if (premiseIdFilter === null)
            throw new Error("The parameter 'premiseIdFilter' cannot be null.");
        else if (premiseIdFilter !== undefined)
            url_ += "PremiseIdFilter=" + encodeURIComponent("" + premiseIdFilter) + "&";
        if (contractAccountFilter === null)
            throw new Error("The parameter 'contractAccountFilter' cannot be null.");
        else if (contractAccountFilter !== undefined)
            url_ += "ContractAccountFilter=" + encodeURIComponent("" + contractAccountFilter) + "&";
        if (subscriptionNumberFilter === null)
            throw new Error("The parameter 'subscriptionNumberFilter' cannot be null.");
        else if (subscriptionNumberFilter !== undefined)
            url_ += "SubscriptionNumberFilter=" + encodeURIComponent("" + subscriptionNumberFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultExtendedDtoOfGetMeterInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultExtendedDtoOfGetMeterInfoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultExtendedDtoOfGetMeterInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultExtendedDtoOfGetMeterInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMeterInfoForView(id: number | undefined): Observable<GetMeterInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MeterInfos/GetMeterInfoForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterInfoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterInfoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeterInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeterInfoForViewDto>;
        }));
    }

    protected processGetMeterInfoForView(response: HttpResponseBase): Observable<GetMeterInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeterInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMeterInfoForEdit(id: number | undefined): Observable<GetMeterInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MeterInfos/GetMeterInfoForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterInfoForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMeterInfoForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMeterInfoForEditOutput>;
        }));
    }

    protected processGetMeterInfoForEdit(response: HttpResponseBase): Observable<GetMeterInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeterInfoForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditMeterInfoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeterInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeterInfos/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationUnitForTableDropdown(): Observable<MeterInfoOrganizationUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeterInfos/GetAllOrganizationUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterInfoOrganizationUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterInfoOrganizationUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationUnitForTableDropdown(response: HttpResponseBase): Observable<MeterInfoOrganizationUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeterInfoOrganizationUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMeterInfoByOrganizationId(id: number | undefined): Observable<MeterInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeterInfos/GetMeterInfoByOrganizationId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeterInfoByOrganizationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeterInfoByOrganizationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeterInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeterInfoDto[]>;
        }));
    }

    protected processGetMeterInfoByOrganizationId(response: HttpResponseBase): Observable<MeterInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeterInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param numberOfMeters (optional) 
     * @return Success
     */
    updateNumberOfMeters(id: number | undefined, numberOfMeters: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeterInfos/UpdateNumberOfMeters?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (numberOfMeters === null)
            throw new Error("The parameter 'numberOfMeters' cannot be null.");
        else if (numberOfMeters !== undefined)
            url_ += "numberOfMeters=" + encodeURIComponent("" + numberOfMeters) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNumberOfMeters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNumberOfMeters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNumberOfMeters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUpdateBussinessRule(body: CreateOrEditMeterInfoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeterInfos/AddUpdateBussinessRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUpdateBussinessRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUpdateBussinessRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUpdateBussinessRule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifiyMeters(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MeterInfos/VerifiyMeters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifiyMeters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifiyMeters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifiyMeters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NewsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePublishState(body: ChangePublishStateDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/News/ChangePublishState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePublishState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePublishState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processChangePublishState(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrUpdateNewsDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/News/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/News/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<GetNewsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/News/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNewsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNewsForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetNewsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param importanceType (optional) 
     * @param publishState (optional) 
     * @param creationTime (optional) 
     * @param publishStateDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, importanceType: number | undefined, publishState: number | undefined, creationTime: DateTime | undefined, publishStateDate: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetNewsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (importanceType === null)
            throw new Error("The parameter 'importanceType' cannot be null.");
        else if (importanceType !== undefined)
            url_ += "ImportanceType=" + encodeURIComponent("" + importanceType) + "&";
        if (publishState === null)
            throw new Error("The parameter 'publishState' cannot be null.");
        else if (publishState !== undefined)
            url_ += "PublishState=" + encodeURIComponent("" + publishState) + "&";
        if (creationTime === null)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toString() : "") + "&";
        if (publishStateDate === null)
            throw new Error("The parameter 'publishStateDate' cannot be null.");
        else if (publishStateDate !== undefined)
            url_ += "PublishStateDate=" + encodeURIComponent(publishStateDate ? "" + publishStateDate.toString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetNewsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetNewsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetNewsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetNewsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNewsVersion(id: string | undefined): Observable<GetNewsVersionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetNewsVersion?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewsVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNewsVersionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNewsVersionForViewDto>;
        }));
    }

    protected processGetNewsVersion(response: HttpResponseBase): Observable<GetNewsVersionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsVersionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param newsId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getNewsVersionsByNewsId(newsId: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetNewsVersionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetNewsVersionsByNewsId?";
        if (newsId === null)
            throw new Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "NewsId=" + encodeURIComponent("" + newsId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewsVersionsByNewsId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsVersionsByNewsId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetNewsVersionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetNewsVersionForViewDto>;
        }));
    }

    protected processGetNewsVersionsByNewsId(response: HttpResponseBase): Observable<PagedResultDtoOfGetNewsVersionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetNewsVersionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedia(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/News/UploadMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadMedia(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param importanceType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPublishedNews(filter: string | undefined, importanceType: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetNewsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetAllPublishedNews?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (importanceType === null)
            throw new Error("The parameter 'importanceType' cannot be null.");
        else if (importanceType !== undefined)
            url_ += "ImportanceType=" + encodeURIComponent("" + importanceType) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPublishedNews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPublishedNews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetNewsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetNewsForViewDto>;
        }));
    }

    protected processGetAllPublishedNews(response: HttpResponseBase): Observable<PagedResultDtoOfGetNewsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetNewsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPublishedNews(id: string | undefined): Observable<GetNewsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetPublishedNews?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublishedNews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublishedNews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNewsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNewsForViewDto>;
        }));
    }

    protected processGetPublishedNews(response: HttpResponseBase): Observable<GetNewsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNewsForEdit(id: string | undefined): Observable<GetNewsForEditDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetNewsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNewsForEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNewsForEditDto>;
        }));
    }

    protected processGetNewsForEdit(response: HttpResponseBase): Observable<GetNewsForEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsForEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteNotification(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    deleteAllUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationLogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetNotificationLogForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/NotificationLogs/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetNotificationLogForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetNotificationLogForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetNotificationLogForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetNotificationLogForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotificationLogForView(id: number | undefined): Observable<GetNotificationLogForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/NotificationLogs/GetNotificationLogForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationLogForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationLogForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationLogForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationLogForViewDto>;
        }));
    }

    protected processGetNotificationLogForView(response: HttpResponseBase): Observable<GetNotificationLogForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationLogForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotificationLogForEdit(id: number | undefined): Observable<GetNotificationLogForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/NotificationLogs/GetNotificationLogForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationLogForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationLogForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationLogForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationLogForEditOutput>;
        }));
    }

    protected processGetNotificationLogForEdit(response: HttpResponseBase): Observable<GetNotificationLogForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationLogForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditNotificationLogDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationLogs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationLogs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationActivitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param organizationUnitDisplayNameFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param sectorIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllByCurrentUser(filter: string | undefined, organizationUnitDisplayNameFilter: string | undefined, organizationUnitIdFilter: number | undefined, sectorIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrganizationActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivities/GetAllByCurrentUser?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationUnitDisplayNameFilter === null)
            throw new Error("The parameter 'organizationUnitDisplayNameFilter' cannot be null.");
        else if (organizationUnitDisplayNameFilter !== undefined)
            url_ += "OrganizationUnitDisplayNameFilter=" + encodeURIComponent("" + organizationUnitDisplayNameFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (sectorIdFilter === null)
            throw new Error("The parameter 'sectorIdFilter' cannot be null.");
        else if (sectorIdFilter !== undefined)
            url_ += "SectorIdFilter=" + encodeURIComponent("" + sectorIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrganizationActivityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrganizationActivityForViewDto>;
        }));
    }

    protected processGetAllByCurrentUser(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrganizationActivityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOrganizationActivityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param planYear (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    checkIfYearAlredyExist(planYear: string | undefined, organizationUnitId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivities/CheckIfYearAlredyExist?";
        if (planYear === null)
            throw new Error("The parameter 'planYear' cannot be null.");
        else if (planYear !== undefined)
            url_ += "planYear=" + encodeURIComponent("" + planYear) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfYearAlredyExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfYearAlredyExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfYearAlredyExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationUnitDisplayNameFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param sectorIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, organizationUnitDisplayNameFilter: string | undefined, organizationUnitIdFilter: number | undefined, sectorIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrganizationActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationUnitDisplayNameFilter === null)
            throw new Error("The parameter 'organizationUnitDisplayNameFilter' cannot be null.");
        else if (organizationUnitDisplayNameFilter !== undefined)
            url_ += "OrganizationUnitDisplayNameFilter=" + encodeURIComponent("" + organizationUnitDisplayNameFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (sectorIdFilter === null)
            throw new Error("The parameter 'sectorIdFilter' cannot be null.");
        else if (sectorIdFilter !== undefined)
            url_ += "SectorIdFilter=" + encodeURIComponent("" + sectorIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrganizationActivityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrganizationActivityForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrganizationActivityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOrganizationActivityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrganizationActivityForView(id: number | undefined): Observable<GetOrganizationActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivities/GetOrganizationActivityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationActivityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationActivityForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationActivityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationActivityForViewDto>;
        }));
    }

    protected processGetOrganizationActivityForView(response: HttpResponseBase): Observable<GetOrganizationActivityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationActivityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrganizationActivityForEdit(id: number | undefined): Observable<GetOrganizationActivityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivities/GetOrganizationActivityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationActivityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationActivityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationActivityForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationActivityForEditOutput>;
        }));
    }

    protected processGetOrganizationActivityForEdit(response: HttpResponseBase): Observable<GetOrganizationActivityForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationActivityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditOrganizationActivityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationUnitForTableDropdown(): Observable<OrganizationActivityOrganizationUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivities/GetAllOrganizationUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationActivityOrganizationUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationActivityOrganizationUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationUnitForTableDropdown(response: HttpResponseBase): Observable<OrganizationActivityOrganizationUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationActivityOrganizationUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationActivityDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param subActivityName_ArFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, subActivityName_ArFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrganizationActivityDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subActivityName_ArFilter === null)
            throw new Error("The parameter 'subActivityName_ArFilter' cannot be null.");
        else if (subActivityName_ArFilter !== undefined)
            url_ += "SubActivityName_ArFilter=" + encodeURIComponent("" + subActivityName_ArFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrganizationActivityDetailForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrganizationActivityDetailForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrganizationActivityDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOrganizationActivityDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrganizationActivityDetailForView(id: number | undefined): Observable<MainActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/GetOrganizationActivityDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationActivityDetailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationActivityDetailForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MainActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MainActivityDto[]>;
        }));
    }

    protected processGetOrganizationActivityDetailForView(response: HttpResponseBase): Observable<MainActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MainActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAllOrganizationActivityDetailForView(id: number | undefined): Observable<MainActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/GetAllOrganizationActivityDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationActivityDetailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationActivityDetailForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MainActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MainActivityDto[]>;
        }));
    }

    protected processGetAllOrganizationActivityDetailForView(response: HttpResponseBase): Observable<MainActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MainActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param isSaved (optional) 
     * @return Success
     */
    getOrganizationActivityDetailForEdit(id: number | undefined, isSaved: boolean | undefined): Observable<MainActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/GetOrganizationActivityDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (isSaved === null)
            throw new Error("The parameter 'isSaved' cannot be null.");
        else if (isSaved !== undefined)
            url_ += "isSaved=" + encodeURIComponent("" + isSaved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationActivityDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationActivityDetailForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MainActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MainActivityDto[]>;
        }));
    }

    protected processGetOrganizationActivityDetailForEdit(response: HttpResponseBase): Observable<MainActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MainActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditOrganizationActivityDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationUnitId (optional) 
     * @param planYear (optional) 
     * @return Success
     */
    businessRules(organizationUnitId: number | undefined, planYear: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/BusinessRules?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (planYear === null)
            throw new Error("The parameter 'planYear' cannot be null.");
        else if (planYear !== undefined)
            url_ += "planYear=" + encodeURIComponent("" + planYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBusinessRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBusinessRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBusinessRules(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrganizationActivityDetails(body: CreateOrEditChecklistDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/CreateOrganizationActivityDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationActivityDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationActivityDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrganizationActivityDetails(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param subActivityName_ArFilter (optional) 
     * @return Success
     */
    getOrganizationActivityDetailsToExcel(filter: string | undefined, subActivityName_ArFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/GetOrganizationActivityDetailsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subActivityName_ArFilter === null)
            throw new Error("The parameter 'subActivityName_ArFilter' cannot be null.");
        else if (subActivityName_ArFilter !== undefined)
            url_ += "SubActivityName_ArFilter=" + encodeURIComponent("" + subActivityName_ArFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationActivityDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationActivityDetailsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetOrganizationActivityDetailsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCurrentUserDetails(): Observable<GetUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/GetCurrentUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForViewDto>;
        }));
    }

    protected processGetCurrentUserDetails(response: HttpResponseBase): Observable<GetUserForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserSectors(userId: number | undefined): Observable<UserSectorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/GetUserSectors?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSectorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSectorDto[]>;
        }));
    }

    protected processGetUserSectors(response: HttpResponseBase): Observable<UserSectorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSectorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isSaved (optional) 
     * @return Success
     */
    getAllSubActivities(isSaved: boolean | undefined): Observable<MainActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/GetAllSubActivities?";
        if (isSaved === null)
            throw new Error("The parameter 'isSaved' cannot be null.");
        else if (isSaved !== undefined)
            url_ += "isSaved=" + encodeURIComponent("" + isSaved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MainActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MainActivityDto[]>;
        }));
    }

    protected processGetAllSubActivities(response: HttpResponseBase): Observable<MainActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MainActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllSubActivityForTableDropdown(): Observable<OrganizationActivityDetailSubActivityLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationActivityDetails/GetAllSubActivityForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubActivityForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubActivityForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationActivityDetailSubActivityLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationActivityDetailSubActivityLookupTableDto[]>;
        }));
    }

    protected processGetAllSubActivityForTableDropdown(response: HttpResponseBase): Observable<OrganizationActivityDetailSubActivityLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationActivityDetailSubActivityLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationEEPDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param departmentNameFilter (optional) 
     * @param maxActivityStartDateFilter (optional) 
     * @param minActivityStartDateFilter (optional) 
     * @param maxActivityEndDateFilter (optional) 
     * @param minActivityEndDateFilter (optional) 
     * @param organizationEEPSubjectFilter (optional) 
     * @param unitName_ArFilter (optional) 
     * @param eEPStatusName_ArFilter (optional) 
     * @param areaOfImprovementName_ArFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, departmentNameFilter: string | undefined, maxActivityStartDateFilter: DateTime | undefined, minActivityStartDateFilter: DateTime | undefined, maxActivityEndDateFilter: DateTime | undefined, minActivityEndDateFilter: DateTime | undefined, organizationEEPSubjectFilter: string | undefined, unitName_ArFilter: string | undefined, eEPStatusName_ArFilter: string | undefined, areaOfImprovementName_ArFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrganizationEEPDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (departmentNameFilter === null)
            throw new Error("The parameter 'departmentNameFilter' cannot be null.");
        else if (departmentNameFilter !== undefined)
            url_ += "DepartmentNameFilter=" + encodeURIComponent("" + departmentNameFilter) + "&";
        if (maxActivityStartDateFilter === null)
            throw new Error("The parameter 'maxActivityStartDateFilter' cannot be null.");
        else if (maxActivityStartDateFilter !== undefined)
            url_ += "MaxActivityStartDateFilter=" + encodeURIComponent(maxActivityStartDateFilter ? "" + maxActivityStartDateFilter.toString() : "") + "&";
        if (minActivityStartDateFilter === null)
            throw new Error("The parameter 'minActivityStartDateFilter' cannot be null.");
        else if (minActivityStartDateFilter !== undefined)
            url_ += "MinActivityStartDateFilter=" + encodeURIComponent(minActivityStartDateFilter ? "" + minActivityStartDateFilter.toString() : "") + "&";
        if (maxActivityEndDateFilter === null)
            throw new Error("The parameter 'maxActivityEndDateFilter' cannot be null.");
        else if (maxActivityEndDateFilter !== undefined)
            url_ += "MaxActivityEndDateFilter=" + encodeURIComponent(maxActivityEndDateFilter ? "" + maxActivityEndDateFilter.toString() : "") + "&";
        if (minActivityEndDateFilter === null)
            throw new Error("The parameter 'minActivityEndDateFilter' cannot be null.");
        else if (minActivityEndDateFilter !== undefined)
            url_ += "MinActivityEndDateFilter=" + encodeURIComponent(minActivityEndDateFilter ? "" + minActivityEndDateFilter.toString() : "") + "&";
        if (organizationEEPSubjectFilter === null)
            throw new Error("The parameter 'organizationEEPSubjectFilter' cannot be null.");
        else if (organizationEEPSubjectFilter !== undefined)
            url_ += "OrganizationEEPSubjectFilter=" + encodeURIComponent("" + organizationEEPSubjectFilter) + "&";
        if (unitName_ArFilter === null)
            throw new Error("The parameter 'unitName_ArFilter' cannot be null.");
        else if (unitName_ArFilter !== undefined)
            url_ += "UnitName_ArFilter=" + encodeURIComponent("" + unitName_ArFilter) + "&";
        if (eEPStatusName_ArFilter === null)
            throw new Error("The parameter 'eEPStatusName_ArFilter' cannot be null.");
        else if (eEPStatusName_ArFilter !== undefined)
            url_ += "EEPStatusName_ArFilter=" + encodeURIComponent("" + eEPStatusName_ArFilter) + "&";
        if (areaOfImprovementName_ArFilter === null)
            throw new Error("The parameter 'areaOfImprovementName_ArFilter' cannot be null.");
        else if (areaOfImprovementName_ArFilter !== undefined)
            url_ += "AreaOfImprovementName_ArFilter=" + encodeURIComponent("" + areaOfImprovementName_ArFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrganizationEEPDetailForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrganizationEEPDetailForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrganizationEEPDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOrganizationEEPDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFuelUnits(): Observable<OrganizationEEPDetailUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetFuelUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationEEPDetailUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationEEPDetailUnitLookupTableDto[]>;
        }));
    }

    protected processGetFuelUnits(response: HttpResponseBase): Observable<OrganizationEEPDetailUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationEEPDetailUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrganizationEEPDetailForView(id: number | undefined): Observable<GetOrganizationEEPDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetOrganizationEEPDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationEEPDetailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationEEPDetailForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationEEPDetailForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationEEPDetailForViewDto>;
        }));
    }

    protected processGetOrganizationEEPDetailForView(response: HttpResponseBase): Observable<GetOrganizationEEPDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationEEPDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationEEPId (optional) 
     * @return Success
     */
    getByOrgEppId(organizationEEPId: number | undefined): Observable<GetOrganizationEEPDetailByOrgEppIdDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetByOrgEppId?";
        if (organizationEEPId === null)
            throw new Error("The parameter 'organizationEEPId' cannot be null.");
        else if (organizationEEPId !== undefined)
            url_ += "organizationEEPId=" + encodeURIComponent("" + organizationEEPId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByOrgEppId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrgEppId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationEEPDetailByOrgEppIdDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationEEPDetailByOrgEppIdDto[]>;
        }));
    }

    protected processGetByOrgEppId(response: HttpResponseBase): Observable<GetOrganizationEEPDetailByOrgEppIdDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetOrganizationEEPDetailByOrgEppIdDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationEEPId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrganizationEEPDetailByOrgEppId(organizationEEPId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetOrganizationEEPDetailByOrgEppId?";
        if (organizationEEPId === null)
            throw new Error("The parameter 'organizationEEPId' cannot be null.");
        else if (organizationEEPId !== undefined)
            url_ += "OrganizationEEPId=" + encodeURIComponent("" + organizationEEPId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationEEPDetailByOrgEppId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationEEPDetailByOrgEppId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto>;
        }));
    }

    protected processGetOrganizationEEPDetailByOrgEppId(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrganizationEEPDetailForEdit(id: number | undefined): Observable<GetOrganizationEEPDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetOrganizationEEPDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationEEPDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationEEPDetailForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationEEPDetailForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationEEPDetailForEditOutput>;
        }));
    }

    protected processGetOrganizationEEPDetailForEdit(response: HttpResponseBase): Observable<GetOrganizationEEPDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationEEPDetailForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditOrganizationEEPDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param departmentNameFilter (optional) 
     * @param maxActivityStartDateFilter (optional) 
     * @param minActivityStartDateFilter (optional) 
     * @param maxActivityEndDateFilter (optional) 
     * @param minActivityEndDateFilter (optional) 
     * @param organizationEEPSubjectFilter (optional) 
     * @param unitName_ArFilter (optional) 
     * @param eEPStatusName_ArFilter (optional) 
     * @param areaOfImprovementName_ArFilter (optional) 
     * @return Success
     */
    getOrganizationEEPDetailsToExcel(filter: string | undefined, departmentNameFilter: string | undefined, maxActivityStartDateFilter: DateTime | undefined, minActivityStartDateFilter: DateTime | undefined, maxActivityEndDateFilter: DateTime | undefined, minActivityEndDateFilter: DateTime | undefined, organizationEEPSubjectFilter: string | undefined, unitName_ArFilter: string | undefined, eEPStatusName_ArFilter: string | undefined, areaOfImprovementName_ArFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetOrganizationEEPDetailsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (departmentNameFilter === null)
            throw new Error("The parameter 'departmentNameFilter' cannot be null.");
        else if (departmentNameFilter !== undefined)
            url_ += "DepartmentNameFilter=" + encodeURIComponent("" + departmentNameFilter) + "&";
        if (maxActivityStartDateFilter === null)
            throw new Error("The parameter 'maxActivityStartDateFilter' cannot be null.");
        else if (maxActivityStartDateFilter !== undefined)
            url_ += "MaxActivityStartDateFilter=" + encodeURIComponent(maxActivityStartDateFilter ? "" + maxActivityStartDateFilter.toString() : "") + "&";
        if (minActivityStartDateFilter === null)
            throw new Error("The parameter 'minActivityStartDateFilter' cannot be null.");
        else if (minActivityStartDateFilter !== undefined)
            url_ += "MinActivityStartDateFilter=" + encodeURIComponent(minActivityStartDateFilter ? "" + minActivityStartDateFilter.toString() : "") + "&";
        if (maxActivityEndDateFilter === null)
            throw new Error("The parameter 'maxActivityEndDateFilter' cannot be null.");
        else if (maxActivityEndDateFilter !== undefined)
            url_ += "MaxActivityEndDateFilter=" + encodeURIComponent(maxActivityEndDateFilter ? "" + maxActivityEndDateFilter.toString() : "") + "&";
        if (minActivityEndDateFilter === null)
            throw new Error("The parameter 'minActivityEndDateFilter' cannot be null.");
        else if (minActivityEndDateFilter !== undefined)
            url_ += "MinActivityEndDateFilter=" + encodeURIComponent(minActivityEndDateFilter ? "" + minActivityEndDateFilter.toString() : "") + "&";
        if (organizationEEPSubjectFilter === null)
            throw new Error("The parameter 'organizationEEPSubjectFilter' cannot be null.");
        else if (organizationEEPSubjectFilter !== undefined)
            url_ += "OrganizationEEPSubjectFilter=" + encodeURIComponent("" + organizationEEPSubjectFilter) + "&";
        if (unitName_ArFilter === null)
            throw new Error("The parameter 'unitName_ArFilter' cannot be null.");
        else if (unitName_ArFilter !== undefined)
            url_ += "UnitName_ArFilter=" + encodeURIComponent("" + unitName_ArFilter) + "&";
        if (eEPStatusName_ArFilter === null)
            throw new Error("The parameter 'eEPStatusName_ArFilter' cannot be null.");
        else if (eEPStatusName_ArFilter !== undefined)
            url_ += "EEPStatusName_ArFilter=" + encodeURIComponent("" + eEPStatusName_ArFilter) + "&";
        if (areaOfImprovementName_ArFilter === null)
            throw new Error("The parameter 'areaOfImprovementName_ArFilter' cannot be null.");
        else if (areaOfImprovementName_ArFilter !== undefined)
            url_ += "AreaOfImprovementName_ArFilter=" + encodeURIComponent("" + areaOfImprovementName_ArFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationEEPDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationEEPDetailsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetOrganizationEEPDetailsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationEEPForTableDropdown(): Observable<OrganizationEEPDetailOrganizationEEPLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetAllOrganizationEEPForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationEEPForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationEEPForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationEEPDetailOrganizationEEPLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationEEPDetailOrganizationEEPLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationEEPForTableDropdown(response: HttpResponseBase): Observable<OrganizationEEPDetailOrganizationEEPLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationEEPDetailOrganizationEEPLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllUnitForTableDropdown(): Observable<OrganizationEEPDetailUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetAllUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationEEPDetailUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationEEPDetailUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllUnitForTableDropdown(response: HttpResponseBase): Observable<OrganizationEEPDetailUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationEEPDetailUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllEEPStatusForTableDropdown(): Observable<OrganizationEEPDetailEEPStatusLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetAllEEPStatusForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEEPStatusForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEEPStatusForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationEEPDetailEEPStatusLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationEEPDetailEEPStatusLookupTableDto[]>;
        }));
    }

    protected processGetAllEEPStatusForTableDropdown(response: HttpResponseBase): Observable<OrganizationEEPDetailEEPStatusLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationEEPDetailEEPStatusLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAreaOfImprovementForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPDetails/GetAllAreaOfImprovementForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAreaOfImprovementForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAreaOfImprovementForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto>;
        }));
    }

    protected processGetAllAreaOfImprovementForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationEEPsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param year (optional) 
     * @param organizationId (optional) 
     * @return Success
     */
    checkBaselineExists(year: string | undefined, organizationId: number | undefined): Observable<GeBaselineOutputForEep> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/CheckBaselineExists?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckBaselineExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckBaselineExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeBaselineOutputForEep>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeBaselineOutputForEep>;
        }));
    }

    protected processCheckBaselineExists(response: HttpResponseBase): Observable<GeBaselineOutputForEep> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeBaselineOutputForEep.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @param organizationId (optional) 
     * @return Success
     */
    getElectricityBaseline(year: string | undefined, organizationId: number | undefined): Observable<BaselineResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetElectricityBaseline?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElectricityBaseline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElectricityBaseline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaselineResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaselineResultDto>;
        }));
    }

    protected processGetElectricityBaseline(response: HttpResponseBase): Observable<BaselineResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaselineResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @param organizationId (optional) 
     * @return Success
     */
    getFuelBaseline(year: string | undefined, organizationId: number | undefined): Observable<BaselineResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetFuelBaseline?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelBaseline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelBaseline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaselineResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaselineResultDto>;
        }));
    }

    protected processGetFuelBaseline(response: HttpResponseBase): Observable<BaselineResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaselineResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAreaOfImprovement(id: number | undefined): Observable<AreaOfImprovementDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetAreaOfImprovement?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaOfImprovement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaOfImprovement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaOfImprovementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaOfImprovementDto>;
        }));
    }

    protected processGetAreaOfImprovement(response: HttpResponseBase): Observable<AreaOfImprovementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaOfImprovementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkCurrentUserIsSecUser(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/CheckCurrentUserIsSecUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentUserIsSecUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserIsSecUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCurrentUserIsSecUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param planYearFilter (optional) 
     * @param baselineFilter (optional) 
     * @param organizationUnitDisplayNameFilter (optional) 
     * @param userNameFilter (optional) 
     * @param unitName_ArFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param sectorIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllOrganizationElectricityEEPs(filter: string | undefined, planYearFilter: string | undefined, baselineFilter: string | undefined, organizationUnitDisplayNameFilter: string | undefined, userNameFilter: string | undefined, unitName_ArFilter: string | undefined, organizationUnitIdFilter: number | undefined, sectorIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrganizationEEPForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetAllOrganizationElectricityEEPs?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (planYearFilter === null)
            throw new Error("The parameter 'planYearFilter' cannot be null.");
        else if (planYearFilter !== undefined)
            url_ += "PlanYearFilter=" + encodeURIComponent("" + planYearFilter) + "&";
        if (baselineFilter === null)
            throw new Error("The parameter 'baselineFilter' cannot be null.");
        else if (baselineFilter !== undefined)
            url_ += "BaselineFilter=" + encodeURIComponent("" + baselineFilter) + "&";
        if (organizationUnitDisplayNameFilter === null)
            throw new Error("The parameter 'organizationUnitDisplayNameFilter' cannot be null.");
        else if (organizationUnitDisplayNameFilter !== undefined)
            url_ += "OrganizationUnitDisplayNameFilter=" + encodeURIComponent("" + organizationUnitDisplayNameFilter) + "&";
        if (userNameFilter === null)
            throw new Error("The parameter 'userNameFilter' cannot be null.");
        else if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&";
        if (unitName_ArFilter === null)
            throw new Error("The parameter 'unitName_ArFilter' cannot be null.");
        else if (unitName_ArFilter !== undefined)
            url_ += "UnitName_ArFilter=" + encodeURIComponent("" + unitName_ArFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (sectorIdFilter === null)
            throw new Error("The parameter 'sectorIdFilter' cannot be null.");
        else if (sectorIdFilter !== undefined)
            url_ += "SectorIdFilter=" + encodeURIComponent("" + sectorIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationElectricityEEPs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationElectricityEEPs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrganizationEEPForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrganizationEEPForViewDto>;
        }));
    }

    protected processGetAllOrganizationElectricityEEPs(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrganizationEEPForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOrganizationEEPForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param planYearFilter (optional) 
     * @param baselineFilter (optional) 
     * @param organizationUnitDisplayNameFilter (optional) 
     * @param userNameFilter (optional) 
     * @param unitName_ArFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param sectorIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param isSECUser (optional) 
     * @param currentUserId (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, planYearFilter: string | undefined, baselineFilter: string | undefined, organizationUnitDisplayNameFilter: string | undefined, userNameFilter: string | undefined, unitName_ArFilter: string | undefined, organizationUnitIdFilter: number | undefined, sectorIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined, isSECUser: boolean | undefined, currentUserId: number | undefined): Observable<PagedResultDtoOfGetOrganizationEEPForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (planYearFilter === null)
            throw new Error("The parameter 'planYearFilter' cannot be null.");
        else if (planYearFilter !== undefined)
            url_ += "PlanYearFilter=" + encodeURIComponent("" + planYearFilter) + "&";
        if (baselineFilter === null)
            throw new Error("The parameter 'baselineFilter' cannot be null.");
        else if (baselineFilter !== undefined)
            url_ += "BaselineFilter=" + encodeURIComponent("" + baselineFilter) + "&";
        if (organizationUnitDisplayNameFilter === null)
            throw new Error("The parameter 'organizationUnitDisplayNameFilter' cannot be null.");
        else if (organizationUnitDisplayNameFilter !== undefined)
            url_ += "OrganizationUnitDisplayNameFilter=" + encodeURIComponent("" + organizationUnitDisplayNameFilter) + "&";
        if (userNameFilter === null)
            throw new Error("The parameter 'userNameFilter' cannot be null.");
        else if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&";
        if (unitName_ArFilter === null)
            throw new Error("The parameter 'unitName_ArFilter' cannot be null.");
        else if (unitName_ArFilter !== undefined)
            url_ += "UnitName_ArFilter=" + encodeURIComponent("" + unitName_ArFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (sectorIdFilter === null)
            throw new Error("The parameter 'sectorIdFilter' cannot be null.");
        else if (sectorIdFilter !== undefined)
            url_ += "SectorIdFilter=" + encodeURIComponent("" + sectorIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (isSECUser === null)
            throw new Error("The parameter 'isSECUser' cannot be null.");
        else if (isSECUser !== undefined)
            url_ += "IsSECUser=" + encodeURIComponent("" + isSECUser) + "&";
        if (currentUserId === null)
            throw new Error("The parameter 'currentUserId' cannot be null.");
        else if (currentUserId !== undefined)
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrganizationEEPForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrganizationEEPForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrganizationEEPForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOrganizationEEPForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param departmentNameFilter (optional) 
     * @param maxActivityStartDateFilter (optional) 
     * @param minActivityStartDateFilter (optional) 
     * @param maxActivityEndDateFilter (optional) 
     * @param minActivityEndDateFilter (optional) 
     * @param organizationEEPSubjectFilter (optional) 
     * @param unitName_ArFilter (optional) 
     * @param eEPStatusName_ArFilter (optional) 
     * @param areaOfImprovementName_ArFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param lstToFilter (optional) 
     * @return Success
     */
    getAllDetails(filter: string | undefined, departmentNameFilter: string | undefined, maxActivityStartDateFilter: DateTime | undefined, minActivityStartDateFilter: DateTime | undefined, maxActivityEndDateFilter: DateTime | undefined, minActivityEndDateFilter: DateTime | undefined, organizationEEPSubjectFilter: string | undefined, unitName_ArFilter: string | undefined, eEPStatusName_ArFilter: string | undefined, areaOfImprovementName_ArFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined, lstToFilter: OrganizationEEPDetailDto[] | undefined): Observable<PagedResultDtoOfGetOrganizationEEPDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetAllDetails?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (departmentNameFilter === null)
            throw new Error("The parameter 'departmentNameFilter' cannot be null.");
        else if (departmentNameFilter !== undefined)
            url_ += "DepartmentNameFilter=" + encodeURIComponent("" + departmentNameFilter) + "&";
        if (maxActivityStartDateFilter === null)
            throw new Error("The parameter 'maxActivityStartDateFilter' cannot be null.");
        else if (maxActivityStartDateFilter !== undefined)
            url_ += "MaxActivityStartDateFilter=" + encodeURIComponent(maxActivityStartDateFilter ? "" + maxActivityStartDateFilter.toString() : "") + "&";
        if (minActivityStartDateFilter === null)
            throw new Error("The parameter 'minActivityStartDateFilter' cannot be null.");
        else if (minActivityStartDateFilter !== undefined)
            url_ += "MinActivityStartDateFilter=" + encodeURIComponent(minActivityStartDateFilter ? "" + minActivityStartDateFilter.toString() : "") + "&";
        if (maxActivityEndDateFilter === null)
            throw new Error("The parameter 'maxActivityEndDateFilter' cannot be null.");
        else if (maxActivityEndDateFilter !== undefined)
            url_ += "MaxActivityEndDateFilter=" + encodeURIComponent(maxActivityEndDateFilter ? "" + maxActivityEndDateFilter.toString() : "") + "&";
        if (minActivityEndDateFilter === null)
            throw new Error("The parameter 'minActivityEndDateFilter' cannot be null.");
        else if (minActivityEndDateFilter !== undefined)
            url_ += "MinActivityEndDateFilter=" + encodeURIComponent(minActivityEndDateFilter ? "" + minActivityEndDateFilter.toString() : "") + "&";
        if (organizationEEPSubjectFilter === null)
            throw new Error("The parameter 'organizationEEPSubjectFilter' cannot be null.");
        else if (organizationEEPSubjectFilter !== undefined)
            url_ += "OrganizationEEPSubjectFilter=" + encodeURIComponent("" + organizationEEPSubjectFilter) + "&";
        if (unitName_ArFilter === null)
            throw new Error("The parameter 'unitName_ArFilter' cannot be null.");
        else if (unitName_ArFilter !== undefined)
            url_ += "UnitName_ArFilter=" + encodeURIComponent("" + unitName_ArFilter) + "&";
        if (eEPStatusName_ArFilter === null)
            throw new Error("The parameter 'eEPStatusName_ArFilter' cannot be null.");
        else if (eEPStatusName_ArFilter !== undefined)
            url_ += "EEPStatusName_ArFilter=" + encodeURIComponent("" + eEPStatusName_ArFilter) + "&";
        if (areaOfImprovementName_ArFilter === null)
            throw new Error("The parameter 'areaOfImprovementName_ArFilter' cannot be null.");
        else if (areaOfImprovementName_ArFilter !== undefined)
            url_ += "AreaOfImprovementName_ArFilter=" + encodeURIComponent("" + areaOfImprovementName_ArFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (lstToFilter === null)
            throw new Error("The parameter 'lstToFilter' cannot be null.");
        else if (lstToFilter !== undefined)
            lstToFilter && lstToFilter.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "lstToFilter[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetOrganizationEEPDetailForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetOrganizationEEPDetailForViewDto>;
        }));
    }

    protected processGetAllDetails(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrganizationEEPDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOrganizationEEPDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationEEPId (optional) 
     * @return Success
     */
    getEEPDetailsByEEPId(organizationEEPId: number | undefined): Observable<GetOrganizationEEPDetailForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetEEPDetailsByEEPId?";
        if (organizationEEPId === null)
            throw new Error("The parameter 'organizationEEPId' cannot be null.");
        else if (organizationEEPId !== undefined)
            url_ += "OrganizationEEPId=" + encodeURIComponent("" + organizationEEPId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEEPDetailsByEEPId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEEPDetailsByEEPId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationEEPDetailForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationEEPDetailForViewDto[]>;
        }));
    }

    protected processGetEEPDetailsByEEPId(response: HttpResponseBase): Observable<GetOrganizationEEPDetailForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetOrganizationEEPDetailForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrganizationEEPForView(id: number | undefined): Observable<GetOrganizationEEPForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetOrganizationEEPForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationEEPForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationEEPForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationEEPForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationEEPForViewDto>;
        }));
    }

    protected processGetOrganizationEEPForView(response: HttpResponseBase): Observable<GetOrganizationEEPForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationEEPForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrganizationEEPForEdit(id: number | undefined): Observable<GetOrganizationEEPForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetOrganizationEEPForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationEEPForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationEEPForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationEEPForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationEEPForEditOutput>;
        }));
    }

    protected processGetOrganizationEEPForEdit(response: HttpResponseBase): Observable<GetOrganizationEEPForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationEEPForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getOrganizationEEPDefaultData(): Observable<GetOrganizationEEPForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetOrganizationEEPDefaultData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationEEPDefaultData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationEEPDefaultData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationEEPForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationEEPForEditOutput>;
        }));
    }

    protected processGetOrganizationEEPDefaultData(response: HttpResponseBase): Observable<GetOrganizationEEPForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationEEPForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditOrganizationEEPDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param baselineYearFilter (optional) 
     * @param organizationUnitDisplayNameFilter (optional) 
     * @param userNameFilter (optional) 
     * @param unitName_ArFilter (optional) 
     * @return Success
     */
    getOrganizationEEPsToExcel(filter: string | undefined, baselineYearFilter: string | undefined, organizationUnitDisplayNameFilter: string | undefined, userNameFilter: string | undefined, unitName_ArFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetOrganizationEEPsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (baselineYearFilter === null)
            throw new Error("The parameter 'baselineYearFilter' cannot be null.");
        else if (baselineYearFilter !== undefined)
            url_ += "BaselineYearFilter=" + encodeURIComponent("" + baselineYearFilter) + "&";
        if (organizationUnitDisplayNameFilter === null)
            throw new Error("The parameter 'organizationUnitDisplayNameFilter' cannot be null.");
        else if (organizationUnitDisplayNameFilter !== undefined)
            url_ += "OrganizationUnitDisplayNameFilter=" + encodeURIComponent("" + organizationUnitDisplayNameFilter) + "&";
        if (userNameFilter === null)
            throw new Error("The parameter 'userNameFilter' cannot be null.");
        else if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&";
        if (unitName_ArFilter === null)
            throw new Error("The parameter 'unitName_ArFilter' cannot be null.");
        else if (unitName_ArFilter !== undefined)
            url_ += "UnitName_ArFilter=" + encodeURIComponent("" + unitName_ArFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationEEPsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationEEPsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetOrganizationEEPsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationUnitForTableDropdown(): Observable<OrganizationEEPOrganizationUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetAllOrganizationUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationEEPOrganizationUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationEEPOrganizationUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationUnitForTableDropdown(response: HttpResponseBase): Observable<OrganizationEEPOrganizationUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationEEPOrganizationUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllUserForTableDropdown(): Observable<OrganizationEEPUserLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetAllUserForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationEEPUserLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationEEPUserLookupTableDto[]>;
        }));
    }

    protected processGetAllUserForTableDropdown(response: HttpResponseBase): Observable<OrganizationEEPUserLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationEEPUserLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllUnitForTableDropdown(): Observable<OrganizationEEPUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetAllUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationEEPUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationEEPUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllUnitForTableDropdown(response: HttpResponseBase): Observable<OrganizationEEPUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationEEPUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllBaselinePeriodForTableDropdown(): Observable<OrganizationEEPBaselinePeriodLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/GetAllBaselinePeriodForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBaselinePeriodForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBaselinePeriodForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationEEPBaselinePeriodLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationEEPBaselinePeriodLookupTableDto[]>;
        }));
    }

    protected processGetAllBaselinePeriodForTableDropdown(response: HttpResponseBase): Observable<OrganizationEEPBaselinePeriodLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationEEPBaselinePeriodLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkElectricityPlanExistsForCurrentYear(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/CheckElectricityPlanExistsForCurrentYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckElectricityPlanExistsForCurrentYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckElectricityPlanExistsForCurrentYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckElectricityPlanExistsForCurrentYear(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    businessRules(body: CreateOrEditOrganizationEEPDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationEEPs/BusinessRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBusinessRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBusinessRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBusinessRules(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param sectorId (optional) 
     * @param body (optional) 
     * @return Success
     */
    transfertoAnotherSector(sectorId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/TransfertoAnotherSector?";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "sectorId=" + encodeURIComponent("" + sectorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransfertoAnotherSector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransfertoAnotherSector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransfertoAnotherSector(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param govCodeFilter (optional) 
     * @param govCliamAccountNumerFilter (optional) 
     * @param orgnanizationTypeId (optional) 
     * @param name_ArFilter (optional) 
     * @param name_EnFilter (optional) 
     * @param sectorName_EnFilter (optional) 
     * @param parentEntity_Filter (optional) 
     * @param sectorId (optional) 
     * @param isActive (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param organizationTierId (optional) 
     * @param mustPassTierA (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrganizationUnits(filter: string | undefined, govCodeFilter: string | undefined, govCliamAccountNumerFilter: number | undefined, orgnanizationTypeId: number | undefined, name_ArFilter: string | undefined, name_EnFilter: string | undefined, sectorName_EnFilter: string | undefined, parentEntity_Filter: string | undefined, sectorId: number | undefined, isActive: boolean | undefined, organizationUnitIdFilter: number | undefined, organizationTierId: number | undefined, mustPassTierA: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (govCodeFilter === null)
            throw new Error("The parameter 'govCodeFilter' cannot be null.");
        else if (govCodeFilter !== undefined)
            url_ += "GovCodeFilter=" + encodeURIComponent("" + govCodeFilter) + "&";
        if (govCliamAccountNumerFilter === null)
            throw new Error("The parameter 'govCliamAccountNumerFilter' cannot be null.");
        else if (govCliamAccountNumerFilter !== undefined)
            url_ += "GovCliamAccountNumerFilter=" + encodeURIComponent("" + govCliamAccountNumerFilter) + "&";
        if (orgnanizationTypeId === null)
            throw new Error("The parameter 'orgnanizationTypeId' cannot be null.");
        else if (orgnanizationTypeId !== undefined)
            url_ += "OrgnanizationTypeId=" + encodeURIComponent("" + orgnanizationTypeId) + "&";
        if (name_ArFilter === null)
            throw new Error("The parameter 'name_ArFilter' cannot be null.");
        else if (name_ArFilter !== undefined)
            url_ += "Name_ArFilter=" + encodeURIComponent("" + name_ArFilter) + "&";
        if (name_EnFilter === null)
            throw new Error("The parameter 'name_EnFilter' cannot be null.");
        else if (name_EnFilter !== undefined)
            url_ += "Name_EnFilter=" + encodeURIComponent("" + name_EnFilter) + "&";
        if (sectorName_EnFilter === null)
            throw new Error("The parameter 'sectorName_EnFilter' cannot be null.");
        else if (sectorName_EnFilter !== undefined)
            url_ += "SectorName_EnFilter=" + encodeURIComponent("" + sectorName_EnFilter) + "&";
        if (parentEntity_Filter === null)
            throw new Error("The parameter 'parentEntity_Filter' cannot be null.");
        else if (parentEntity_Filter !== undefined)
            url_ += "parentEntity_Filter=" + encodeURIComponent("" + parentEntity_Filter) + "&";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "sectorId=" + encodeURIComponent("" + sectorId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (organizationTierId === null)
            throw new Error("The parameter 'organizationTierId' cannot be null.");
        else if (organizationTierId !== undefined)
            url_ += "OrganizationTierId=" + encodeURIComponent("" + organizationTierId) + "&";
        if (mustPassTierA === null)
            throw new Error("The parameter 'mustPassTierA' cannot be null.");
        else if (mustPassTierA !== undefined)
            url_ += "MustPassTierA=" + encodeURIComponent("" + mustPassTierA) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitDto>;
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param parentEntityId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrganizationSubs(filter: string | undefined, parentEntityId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationSubs?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (parentEntityId === null)
            throw new Error("The parameter 'parentEntityId' cannot be null.");
        else if (parentEntityId !== undefined)
            url_ += "ParentEntityId=" + encodeURIComponent("" + parentEntityId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationSubs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationSubs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitDto>;
        }));
    }

    protected processGetOrganizationSubs(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param govCodeFilter (optional) 
     * @param name_ArFilter (optional) 
     * @param sectorName_EnFilter (optional) 
     * @param sectorId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getInactiveOrganizationUnits(filter: string | undefined, govCodeFilter: string | undefined, name_ArFilter: string | undefined, sectorName_EnFilter: string | undefined, sectorId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetInactiveOrganizationUnits?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (govCodeFilter === null)
            throw new Error("The parameter 'govCodeFilter' cannot be null.");
        else if (govCodeFilter !== undefined)
            url_ += "GovCodeFilter=" + encodeURIComponent("" + govCodeFilter) + "&";
        if (name_ArFilter === null)
            throw new Error("The parameter 'name_ArFilter' cannot be null.");
        else if (name_ArFilter !== undefined)
            url_ += "Name_ArFilter=" + encodeURIComponent("" + name_ArFilter) + "&";
        if (sectorName_EnFilter === null)
            throw new Error("The parameter 'sectorName_EnFilter' cannot be null.");
        else if (sectorName_EnFilter !== undefined)
            url_ += "SectorName_EnFilter=" + encodeURIComponent("" + sectorName_EnFilter) + "&";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "sectorId=" + encodeURIComponent("" + sectorId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInactiveOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInactiveOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitDto>;
        }));
    }

    protected processGetInactiveOrganizationUnits(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param _organizationId (optional) 
     * @return Success
     */
    getOrganizationUnitClaimAccounts(_organizationId: number | undefined): Observable<ClaimAccountListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitClaimAccounts?";
        if (_organizationId === null)
            throw new Error("The parameter '_organizationId' cannot be null.");
        else if (_organizationId !== undefined)
            url_ += "_organizationId=" + encodeURIComponent("" + _organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitClaimAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitClaimAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimAccountListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimAccountListDto[]>;
        }));
    }

    protected processGetOrganizationUnitClaimAccounts(response: HttpResponseBase): Observable<ClaimAccountListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimAccountListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationUnitId (optional) 
     * @param serializedModifiedClaimsAccount (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllOrganizationPaging(filter: string | undefined, organizationUnitId: number | undefined, serializedModifiedClaimsAccount: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfClaimAccountListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAllOrganizationPaging?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (serializedModifiedClaimsAccount === null)
            throw new Error("The parameter 'serializedModifiedClaimsAccount' cannot be null.");
        else if (serializedModifiedClaimsAccount !== undefined)
            url_ += "SerializedModifiedClaimsAccount=" + encodeURIComponent("" + serializedModifiedClaimsAccount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfClaimAccountListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfClaimAccountListDto>;
        }));
    }

    protected processGetAllOrganizationPaging(response: HttpResponseBase): Observable<PagedResultDtoOfClaimAccountListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfClaimAccountListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationUnitId (optional) 
     * @param serializedModifiedClaimsAccount (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllOrganizationClaimAccounts(filter: string | undefined, organizationUnitId: number | undefined, serializedModifiedClaimsAccount: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfClaimAccountListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAllOrganizationClaimAccounts?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (serializedModifiedClaimsAccount === null)
            throw new Error("The parameter 'serializedModifiedClaimsAccount' cannot be null.");
        else if (serializedModifiedClaimsAccount !== undefined)
            url_ += "SerializedModifiedClaimsAccount=" + encodeURIComponent("" + serializedModifiedClaimsAccount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationClaimAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationClaimAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfClaimAccountListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfClaimAccountListDto>;
        }));
    }

    protected processGetAllOrganizationClaimAccounts(response: HttpResponseBase): Observable<PagedResultDtoOfClaimAccountListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfClaimAccountListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitRoles(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrganizationForEdit(id: number | undefined): Observable<CreateOrganizationUnitInput> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrganizationUnitInput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrganizationUnitInput>;
        }));
    }

    protected processGetOrganizationForEdit(response: HttpResponseBase): Observable<CreateOrganizationUnitInput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrganizationUnitInput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrganizationForView(id: number | undefined): Observable<GetOrganizationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationForViewDto>;
        }));
    }

    protected processGetOrganizationForView(response: HttpResponseBase): Observable<GetOrganizationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationId (optional) 
     * @return Success
     */
    validateOrganizationForSuspend(organizationId: number | undefined): Observable<{ [key: string]: string; }[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/ValidateOrganizationForSuspend?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateOrganizationForSuspend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateOrganizationForSuspend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }[]>;
        }));
    }

    protected processValidateOrganizationForSuspend(response: HttpResponseBase): Observable<{ [key: string]: string; }[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationId (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    activateDeActivate(organizationId: number | undefined, isActive: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/ActivateDeActivate?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationId (optional) 
     * @return Success
     */
    suspend(organizationId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Suspend?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuspend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuspend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSuspend(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param govCodeFilter (optional) 
     * @param govCliamAccountNumerFilter (optional) 
     * @param orgnanizationTypeId (optional) 
     * @param name_ArFilter (optional) 
     * @param name_EnFilter (optional) 
     * @param sectorName_EnFilter (optional) 
     * @param parentEntity_Filter (optional) 
     * @param sectorId (optional) 
     * @param isActive (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getOrganizationsToExcel(filter: string | undefined, govCodeFilter: string | undefined, govCliamAccountNumerFilter: number | undefined, orgnanizationTypeId: number | undefined, name_ArFilter: string | undefined, name_EnFilter: string | undefined, sectorName_EnFilter: string | undefined, parentEntity_Filter: string | undefined, sectorId: number | undefined, isActive: boolean | undefined, organizationUnitIdFilter: number | undefined, sorting: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (govCodeFilter === null)
            throw new Error("The parameter 'govCodeFilter' cannot be null.");
        else if (govCodeFilter !== undefined)
            url_ += "GovCodeFilter=" + encodeURIComponent("" + govCodeFilter) + "&";
        if (govCliamAccountNumerFilter === null)
            throw new Error("The parameter 'govCliamAccountNumerFilter' cannot be null.");
        else if (govCliamAccountNumerFilter !== undefined)
            url_ += "GovCliamAccountNumerFilter=" + encodeURIComponent("" + govCliamAccountNumerFilter) + "&";
        if (orgnanizationTypeId === null)
            throw new Error("The parameter 'orgnanizationTypeId' cannot be null.");
        else if (orgnanizationTypeId !== undefined)
            url_ += "OrgnanizationTypeId=" + encodeURIComponent("" + orgnanizationTypeId) + "&";
        if (name_ArFilter === null)
            throw new Error("The parameter 'name_ArFilter' cannot be null.");
        else if (name_ArFilter !== undefined)
            url_ += "Name_ArFilter=" + encodeURIComponent("" + name_ArFilter) + "&";
        if (name_EnFilter === null)
            throw new Error("The parameter 'name_EnFilter' cannot be null.");
        else if (name_EnFilter !== undefined)
            url_ += "Name_EnFilter=" + encodeURIComponent("" + name_EnFilter) + "&";
        if (sectorName_EnFilter === null)
            throw new Error("The parameter 'sectorName_EnFilter' cannot be null.");
        else if (sectorName_EnFilter !== undefined)
            url_ += "SectorName_EnFilter=" + encodeURIComponent("" + sectorName_EnFilter) + "&";
        if (parentEntity_Filter === null)
            throw new Error("The parameter 'parentEntity_Filter' cannot be null.");
        else if (parentEntity_Filter !== undefined)
            url_ += "parentEntity_Filter=" + encodeURIComponent("" + parentEntity_Filter) + "&";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "sectorId=" + encodeURIComponent("" + sectorId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetOrganizationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sectorId (optional) 
     * @param tierId (optional) 
     * @return Success
     */
    getNextCodeNumber(sectorId: number | undefined, tierId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetNextCodeNumber?";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "SectorId=" + encodeURIComponent("" + sectorId) + "&";
        if (tierId === null)
            throw new Error("The parameter 'tierId' cannot be null.");
        else if (tierId !== undefined)
            url_ += "TierId=" + encodeURIComponent("" + tierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextCodeNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextCodeNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetNextCodeNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isMetersVerified(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/IsMetersVerified";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsMetersVerified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsMetersVerified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsMetersVerified(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    mustPassTierAFirst(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MustPassTierAFirst";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMustPassTierAFirst(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMustPassTierAFirst(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMustPassTierAFirst(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationId (optional) 
     * @return Success
     */
    archivingRelatedRequests(organizationId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/archivingRelatedRequests?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchivingRelatedRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchivingRelatedRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processArchivingRelatedRequests(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrgHistoricalConsumptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param orgId (optional) 
     * @param currentYear (optional) 
     * @return Success
     */
    getPrevPeriodOrgHistoricalConsumptionByOrgId(orgId: number | undefined, currentYear: number | undefined): Observable<HistoricalConsumptionInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/OrgHistoricalConsumption/GetPrevPeriodOrgHistoricalConsumptionByOrgId?";
        if (orgId === null)
            throw new Error("The parameter 'orgId' cannot be null.");
        else if (orgId !== undefined)
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        if (currentYear === null)
            throw new Error("The parameter 'currentYear' cannot be null.");
        else if (currentYear !== undefined)
            url_ += "currentYear=" + encodeURIComponent("" + currentYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrevPeriodOrgHistoricalConsumptionByOrgId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrevPeriodOrgHistoricalConsumptionByOrgId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricalConsumptionInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricalConsumptionInfoDto>;
        }));
    }

    protected processGetPrevPeriodOrgHistoricalConsumptionByOrgId(response: HttpResponseBase): Observable<HistoricalConsumptionInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalConsumptionInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    disableGoogleAuthenticator(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param username (optional) 
     * @return Success
     */
    getProfilePictureByUserName(username: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUserName?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUserName(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getProfilePictureByUser(userId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUser(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProviderElectricitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param yearFilter (optional) 
     * @param monthFilter (optional) 
     * @param organizationIdFilter (optional) 
     * @param requestNumberFilter (optional) 
     * @param sectorFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param onlyAssignedToMeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(yearFilter: string | undefined, monthFilter: number | undefined, organizationIdFilter: number | undefined, requestNumberFilter: string | undefined, sectorFilter: number | undefined, requestStatusIdFilter: RequestStatusEnum | undefined, onlyAssignedToMeFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetProviderElectricityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProviderElectricities/GetAll?";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (monthFilter === null)
            throw new Error("The parameter 'monthFilter' cannot be null.");
        else if (monthFilter !== undefined)
            url_ += "MonthFilter=" + encodeURIComponent("" + monthFilter) + "&";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (sectorFilter === null)
            throw new Error("The parameter 'sectorFilter' cannot be null.");
        else if (sectorFilter !== undefined)
            url_ += "SectorFilter=" + encodeURIComponent("" + sectorFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (onlyAssignedToMeFilter === null)
            throw new Error("The parameter 'onlyAssignedToMeFilter' cannot be null.");
        else if (onlyAssignedToMeFilter !== undefined)
            url_ += "OnlyAssignedToMeFilter=" + encodeURIComponent("" + onlyAssignedToMeFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetProviderElectricityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetProviderElectricityForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProviderElectricityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetProviderElectricityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProviderElectricityForView(id: number | undefined): Observable<GetProviderElectricityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProviderElectricities/GetProviderElectricityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderElectricityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderElectricityForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProviderElectricityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProviderElectricityForViewDto>;
        }));
    }

    protected processGetProviderElectricityForView(response: HttpResponseBase): Observable<GetProviderElectricityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProviderElectricityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProviderElectricityForEdit(id: number | undefined): Observable<GetProviderElectricityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProviderElectricities/GetProviderElectricityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderElectricityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderElectricityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProviderElectricityForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProviderElectricityForEditOutput>;
        }));
    }

    protected processGetProviderElectricityForEdit(response: HttpResponseBase): Observable<GetProviderElectricityForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProviderElectricityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditProviderElectricityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProviderElectricities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: CreateOrEditProviderElectricityDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ProviderElectricities/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProviderElectricities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param yearFilter (optional) 
     * @param organizationIdFilter (optional) 
     * @param requestNumberFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @return Success
     */
    getProviderElectricitiesToExcel(yearFilter: string | undefined, organizationIdFilter: number | undefined, requestNumberFilter: string | undefined, requestStatusIdFilter: RequestStatusEnum | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ProviderElectricities/GetProviderElectricitiesToExcel?";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderElectricitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderElectricitiesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetProviderElectricitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ProviderElectricities/GetMyTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMyTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<void> {
        let url_ = this.baseUrl + "/api/public/auth-settings/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocalizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<void> {
        let url_ = this.baseUrl + "/api/public/localization/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReferenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrUpdateReferenceDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Reference/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param targetUsers (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, targetUsers: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetReferenceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Reference/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetUsers === null)
            throw new Error("The parameter 'targetUsers' cannot be null.");
        else if (targetUsers !== undefined)
            url_ += "TargetUsers=" + encodeURIComponent("" + targetUsers) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetReferenceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetReferenceForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetReferenceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetReferenceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<GetReferenceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Reference/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReferenceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReferenceForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetReferenceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReferenceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reference/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadAttachment(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Reference/UploadAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadAttachment(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param targetUsers (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForPublic(filter: string | undefined, targetUsers: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetReferenceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Reference/GetAllForPublic?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetUsers === null)
            throw new Error("The parameter 'targetUsers' cannot be null.");
        else if (targetUsers !== undefined)
            url_ += "TargetUsers=" + encodeURIComponent("" + targetUsers) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForPublic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForPublic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetReferenceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetReferenceForViewDto>;
        }));
    }

    protected processGetAllForPublic(response: HttpResponseBase): Observable<PagedResultDtoOfGetReferenceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetReferenceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForPublic(id: string | undefined): Observable<GetReferenceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Reference/GetForPublic?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForPublic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForPublic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReferenceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReferenceForViewDto>;
        }));
    }

    protected processGetForPublic(response: HttpResponseBase): Observable<GetReferenceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReferenceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReopenRequestsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: CreateReopenRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ReopenRequests/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: RequestInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReopenRequests/Approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reject(body: RequestInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReopenRequests/Reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRequest(body: CreateRequestInput | undefined): Observable<RequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/CreateRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestDto>;
        }));
    }

    protected processCreateRequest(response: HttpResponseBase): Observable<RequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitRequest(body: SumbitRequestInput | undefined): Observable<RequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/SubmitRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestDto>;
        }));
    }

    protected processSubmitRequest(response: HttpResponseBase): Observable<RequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveRequest(body: RequestInputDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Request/ApproveRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processApproveRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param d1 (optional) 
     * @param d2 (optional) 
     * @return Success
     */
    areDatesEqual(d1: DateTime | undefined, d2: DateTime | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Request/AreDatesEqual?";
        if (d1 === null)
            throw new Error("The parameter 'd1' cannot be null.");
        else if (d1 !== undefined)
            url_ += "d1=" + encodeURIComponent(d1 ? "" + d1.toString() : "") + "&";
        if (d2 === null)
            throw new Error("The parameter 'd2' cannot be null.");
        else if (d2 !== undefined)
            url_ += "d2=" + encodeURIComponent(d2 ? "" + d2.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAreDatesEqual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAreDatesEqual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAreDatesEqual(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectRequest(body: RequestInputDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Request/RejectRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRejectRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reqid (optional) 
     * @return Success
     */
    getRequestByID(reqid: number | undefined): Observable<RequestDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetRequestByID?";
        if (reqid === null)
            throw new Error("The parameter 'reqid' cannot be null.");
        else if (reqid !== undefined)
            url_ += "reqid=" + encodeURIComponent("" + reqid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestDto>;
        }));
    }

    protected processGetRequestByID(response: HttpResponseBase): Observable<RequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getRequestEntityPropertyChanges(requestId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetRequestEntityPropertyChanges?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetRequestEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param requestNumberFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param requestTypeIdFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param sectorIdFilter (optional) 
     * @param submitedByFilter (optional) 
     * @param isOnTimeSubmitedFilter (optional) 
     * @param submissionCycle (optional) 
     * @param yearlySubmissionCycleFilter (optional) 
     * @param monthlySubmissionCycleFilter (optional) 
     * @param requesTypesList (optional) 
     * @param courseTitleFilterId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, requestNumberFilter: string | undefined, requestStatusIdFilter: number | undefined, requestTypeIdFilter: number | undefined, organizationUnitIdFilter: number | undefined, sectorIdFilter: number | undefined, submitedByFilter: string | undefined, isOnTimeSubmitedFilter: boolean | undefined, submissionCycle: string | undefined, yearlySubmissionCycleFilter: string | undefined, monthlySubmissionCycleFilter: string | undefined, requestListViewFilter: RequestListViewFilterEnum, requesTypesList: number[] | undefined, courseTitleFilterId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultForTabsDtoOfGetRequestsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (requestTypeIdFilter === null)
            throw new Error("The parameter 'requestTypeIdFilter' cannot be null.");
        else if (requestTypeIdFilter !== undefined)
            url_ += "RequestTypeIdFilter=" + encodeURIComponent("" + requestTypeIdFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (sectorIdFilter === null)
            throw new Error("The parameter 'sectorIdFilter' cannot be null.");
        else if (sectorIdFilter !== undefined)
            url_ += "SectorIdFilter=" + encodeURIComponent("" + sectorIdFilter) + "&";
        if (submitedByFilter === null)
            throw new Error("The parameter 'submitedByFilter' cannot be null.");
        else if (submitedByFilter !== undefined)
            url_ += "SubmitedByFilter=" + encodeURIComponent("" + submitedByFilter) + "&";
        if (isOnTimeSubmitedFilter === null)
            throw new Error("The parameter 'isOnTimeSubmitedFilter' cannot be null.");
        else if (isOnTimeSubmitedFilter !== undefined)
            url_ += "IsOnTimeSubmitedFilter=" + encodeURIComponent("" + isOnTimeSubmitedFilter) + "&";
        if (submissionCycle === null)
            throw new Error("The parameter 'submissionCycle' cannot be null.");
        else if (submissionCycle !== undefined)
            url_ += "SubmissionCycle=" + encodeURIComponent("" + submissionCycle) + "&";
        if (yearlySubmissionCycleFilter === null)
            throw new Error("The parameter 'yearlySubmissionCycleFilter' cannot be null.");
        else if (yearlySubmissionCycleFilter !== undefined)
            url_ += "YearlySubmissionCycleFilter=" + encodeURIComponent("" + yearlySubmissionCycleFilter) + "&";
        if (monthlySubmissionCycleFilter === null)
            throw new Error("The parameter 'monthlySubmissionCycleFilter' cannot be null.");
        else if (monthlySubmissionCycleFilter !== undefined)
            url_ += "MonthlySubmissionCycleFilter=" + encodeURIComponent("" + monthlySubmissionCycleFilter) + "&";
        if (requestListViewFilter === undefined || requestListViewFilter === null)
            throw new Error("The parameter 'requestListViewFilter' must be defined and cannot be null.");
        else
            url_ += "RequestListViewFilter=" + encodeURIComponent("" + requestListViewFilter) + "&";
        if (requesTypesList === null)
            throw new Error("The parameter 'requesTypesList' cannot be null.");
        else if (requesTypesList !== undefined)
            requesTypesList && requesTypesList.forEach(item => { url_ += "RequesTypesList=" + encodeURIComponent("" + item) + "&"; });
        if (courseTitleFilterId === null)
            throw new Error("The parameter 'courseTitleFilterId' cannot be null.");
        else if (courseTitleFilterId !== undefined)
            url_ += "courseTitleFilterId=" + encodeURIComponent("" + courseTitleFilterId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultForTabsDtoOfGetRequestsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultForTabsDtoOfGetRequestsForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultForTabsDtoOfGetRequestsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultForTabsDtoOfGetRequestsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTrainingAttendanceRequestsTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetTrainingAttendanceRequestsTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingAttendanceRequestsTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingAttendanceRequestsTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTrainingAttendanceRequestsTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyMemberRequestsTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetMyMemberRequestsTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyMemberRequestsTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyMemberRequestsTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMyMemberRequestsTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFuelsRequestsTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetFuelsRequestsTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFuelsRequestsTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFuelsRequestsTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetFuelsRequestsTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTrainingPackageRequestsTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetTrainingPackageRequestsTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingPackageRequestsTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingPackageRequestsTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTrainingPackageRequestsTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBuildingSubmissionRequestsTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetBuildingSubmissionRequestsTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingSubmissionRequestsTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingSubmissionRequestsTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetBuildingSubmissionRequestsTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyEEPRequestsTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetMyEEPRequestsTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyEEPRequestsTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyEEPRequestsTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMyEEPRequestsTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param requestNumberFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param requestTypeIdFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param sectorIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllMembersRequests(filter: string | undefined, requestNumberFilter: string | undefined, requestStatusIdFilter: number | undefined, requestTypeIdFilter: number | undefined, organizationUnitIdFilter: number | undefined, sectorIdFilter: number | undefined, requestListViewFilter: RequestListViewFilterEnum, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultForTabsDtoOfGetRequestsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetAllMembersRequests?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (requestTypeIdFilter === null)
            throw new Error("The parameter 'requestTypeIdFilter' cannot be null.");
        else if (requestTypeIdFilter !== undefined)
            url_ += "RequestTypeIdFilter=" + encodeURIComponent("" + requestTypeIdFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (sectorIdFilter === null)
            throw new Error("The parameter 'sectorIdFilter' cannot be null.");
        else if (sectorIdFilter !== undefined)
            url_ += "SectorIdFilter=" + encodeURIComponent("" + sectorIdFilter) + "&";
        if (requestListViewFilter === undefined || requestListViewFilter === null)
            throw new Error("The parameter 'requestListViewFilter' must be defined and cannot be null.");
        else
            url_ += "RequestListViewFilter=" + encodeURIComponent("" + requestListViewFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMembersRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMembersRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultForTabsDtoOfGetRequestsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultForTabsDtoOfGetRequestsForViewDto>;
        }));
    }

    protected processGetAllMembersRequests(response: HttpResponseBase): Observable<PagedResultForTabsDtoOfGetRequestsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultForTabsDtoOfGetRequestsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getRequestJson(requestId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetRequestJson?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "RequestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRequestJson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getMemberRequestJson(requestId: number | undefined): Observable<MemberDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetMemberRequestJson?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "RequestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberRequestJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberRequestJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberDto>;
        }));
    }

    protected processGetMemberRequestJson(response: HttpResponseBase): Observable<MemberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRequestsForView(id: number | undefined): Observable<GetRequestsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetRequestsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequestsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequestsForViewDto>;
        }));
    }

    protected processGetRequestsForView(response: HttpResponseBase): Observable<GetRequestsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRequestsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEEPRequestsForView(id: number | undefined): Observable<GetRequestsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetEEPRequestsForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEEPRequestsForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEEPRequestsForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequestsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequestsForViewDto>;
        }));
    }

    protected processGetEEPRequestsForView(response: HttpResponseBase): Observable<GetRequestsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRequestsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param requestNumberFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param requestTypeIdFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param sectorIdFilter (optional) 
     * @param submissionCycle (optional) 
     * @return Success
     */
    getRequestsToExcel(filter: string | undefined, requestNumberFilter: string | undefined, requestStatusIdFilter: number | undefined, requestTypeIdFilter: number | undefined, organizationUnitIdFilter: number | undefined, sectorIdFilter: number | undefined, submissionCycle: string | undefined, requestListViewFilter: RequestListViewFilterEnum): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetRequestsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (requestTypeIdFilter === null)
            throw new Error("The parameter 'requestTypeIdFilter' cannot be null.");
        else if (requestTypeIdFilter !== undefined)
            url_ += "RequestTypeIdFilter=" + encodeURIComponent("" + requestTypeIdFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (sectorIdFilter === null)
            throw new Error("The parameter 'sectorIdFilter' cannot be null.");
        else if (sectorIdFilter !== undefined)
            url_ += "SectorIdFilter=" + encodeURIComponent("" + sectorIdFilter) + "&";
        if (submissionCycle === null)
            throw new Error("The parameter 'submissionCycle' cannot be null.");
        else if (submissionCycle !== undefined)
            url_ += "SubmissionCycle=" + encodeURIComponent("" + submissionCycle) + "&";
        if (requestListViewFilter === undefined || requestListViewFilter === null)
            throw new Error("The parameter 'requestListViewFilter' must be defined and cannot be null.");
        else
            url_ += "RequestListViewFilter=" + encodeURIComponent("" + requestListViewFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetRequestsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getRequestHistoryList(requestId: number | undefined): Observable<RequestHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetRequestHistoryList?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestHistoryList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestHistoryList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestHistoryDto[]>;
        }));
    }

    protected processGetRequestHistoryList(response: HttpResponseBase): Observable<RequestHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequestHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reassignTechAdmin(body: ReassignTechAdminDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Request/ReassignTechAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReassignTechAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReassignTechAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processReassignTechAdmin(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fuelProviderDataId (optional) 
     * @return Success
     */
    getProviderDetailsDataByMasterId(fuelProviderDataId: number | undefined): Observable<GetFuelProviderDetailForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Request/getProviderDetailsDataByMasterId?";
        if (fuelProviderDataId === null)
            throw new Error("The parameter 'fuelProviderDataId' cannot be null.");
        else if (fuelProviderDataId !== undefined)
            url_ += "FuelProviderDataId=" + encodeURIComponent("" + fuelProviderDataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderDetailsDataByMasterId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderDetailsDataByMasterId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFuelProviderDetailForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFuelProviderDetailForViewDto[]>;
        }));
    }

    protected processGetProviderDetailsDataByMasterId(response: HttpResponseBase): Observable<GetFuelProviderDetailForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetFuelProviderDetailForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestNumberFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllReopenRequests(requestNumberFilter: string | undefined, requestStatusIdFilter: number | undefined, requestListViewFilter: RequestListViewFilterEnum, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultForTabsDtoOfGetRequestsForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetAllReopenRequests?";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (requestListViewFilter === undefined || requestListViewFilter === null)
            throw new Error("The parameter 'requestListViewFilter' must be defined and cannot be null.");
        else
            url_ += "RequestListViewFilter=" + encodeURIComponent("" + requestListViewFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReopenRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReopenRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultForTabsDtoOfGetRequestsForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultForTabsDtoOfGetRequestsForViewDto>;
        }));
    }

    protected processGetAllReopenRequests(response: HttpResponseBase): Observable<PagedResultForTabsDtoOfGetRequestsForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultForTabsDtoOfGetRequestsForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadNewAttachment(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/UploadNewAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadNewAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadNewAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadNewAttachment(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileToken (optional) 
     * @return Success
     */
    deleteAttachment(fileToken: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Request/DeleteAttachment?";
        if (fileToken === null)
            throw new Error("The parameter 'fileToken' cannot be null.");
        else if (fileToken !== undefined)
            url_ += "fileToken=" + encodeURIComponent("" + fileToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectRequestBySeecAdmin(body: RequestInputDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Request/RejectRequestBySeecAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectRequestBySeecAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectRequestBySeecAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRejectRequestBySeecAdmin(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectRequestByTierA(body: RequestInputDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Request/RejectRequestByTierA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectRequestByTierA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectRequestByTierA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRejectRequestByTierA(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RequestPeriodSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param yearFilter (optional) 
     * @param requestTypeIdFilter (optional) 
     * @param isDefault (optional) 
     * @param settingPeriodTypeName_ArFilter (optional) 
     * @param settingPeriodsRequestTypeName_ArFilter (optional) 
     * @param submissionCycleName_ArFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(yearFilter: string | undefined, requestTypeIdFilter: number | undefined, isDefault: boolean | undefined, settingPeriodTypeName_ArFilter: string | undefined, settingPeriodsRequestTypeName_ArFilter: string | undefined, submissionCycleName_ArFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRequestPeriodSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/GetAll?";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (requestTypeIdFilter === null)
            throw new Error("The parameter 'requestTypeIdFilter' cannot be null.");
        else if (requestTypeIdFilter !== undefined)
            url_ += "requestTypeIdFilter=" + encodeURIComponent("" + requestTypeIdFilter) + "&";
        if (isDefault === null)
            throw new Error("The parameter 'isDefault' cannot be null.");
        else if (isDefault !== undefined)
            url_ += "IsDefault=" + encodeURIComponent("" + isDefault) + "&";
        if (settingPeriodTypeName_ArFilter === null)
            throw new Error("The parameter 'settingPeriodTypeName_ArFilter' cannot be null.");
        else if (settingPeriodTypeName_ArFilter !== undefined)
            url_ += "SettingPeriodTypeName_ArFilter=" + encodeURIComponent("" + settingPeriodTypeName_ArFilter) + "&";
        if (settingPeriodsRequestTypeName_ArFilter === null)
            throw new Error("The parameter 'settingPeriodsRequestTypeName_ArFilter' cannot be null.");
        else if (settingPeriodsRequestTypeName_ArFilter !== undefined)
            url_ += "SettingPeriodsRequestTypeName_ArFilter=" + encodeURIComponent("" + settingPeriodsRequestTypeName_ArFilter) + "&";
        if (submissionCycleName_ArFilter === null)
            throw new Error("The parameter 'submissionCycleName_ArFilter' cannot be null.");
        else if (submissionCycleName_ArFilter !== undefined)
            url_ += "SubmissionCycleName_ArFilter=" + encodeURIComponent("" + submissionCycleName_ArFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetRequestPeriodSettingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetRequestPeriodSettingForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRequestPeriodSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRequestPeriodSettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRequestPeriodSettingForView(id: number | undefined): Observable<GetRequestPeriodSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/GetRequestPeriodSettingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestPeriodSettingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestPeriodSettingForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequestPeriodSettingForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequestPeriodSettingForViewDto>;
        }));
    }

    protected processGetRequestPeriodSettingForView(response: HttpResponseBase): Observable<GetRequestPeriodSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRequestPeriodSettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRequestPeriodSettingForEdit(id: number | undefined): Observable<GetRequestPeriodSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/GetRequestPeriodSettingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestPeriodSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestPeriodSettingForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequestPeriodSettingForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequestPeriodSettingForEditOutput>;
        }));
    }

    protected processGetRequestPeriodSettingForEdit(response: HttpResponseBase): Observable<GetRequestPeriodSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRequestPeriodSettingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditRequestPeriodSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param yearFilter (optional) 
     * @param settingPeriodTypeName_ArFilter (optional) 
     * @param settingPeriodsRequestTypeName_ArFilter (optional) 
     * @param submissionCycleName_ArFilter (optional) 
     * @return Success
     */
    getRequestPeriodSettingsToExcel(filter: string | undefined, yearFilter: string | undefined, settingPeriodTypeName_ArFilter: string | undefined, settingPeriodsRequestTypeName_ArFilter: string | undefined, submissionCycleName_ArFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/GetRequestPeriodSettingsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (settingPeriodTypeName_ArFilter === null)
            throw new Error("The parameter 'settingPeriodTypeName_ArFilter' cannot be null.");
        else if (settingPeriodTypeName_ArFilter !== undefined)
            url_ += "SettingPeriodTypeName_ArFilter=" + encodeURIComponent("" + settingPeriodTypeName_ArFilter) + "&";
        if (settingPeriodsRequestTypeName_ArFilter === null)
            throw new Error("The parameter 'settingPeriodsRequestTypeName_ArFilter' cannot be null.");
        else if (settingPeriodsRequestTypeName_ArFilter !== undefined)
            url_ += "SettingPeriodsRequestTypeName_ArFilter=" + encodeURIComponent("" + settingPeriodsRequestTypeName_ArFilter) + "&";
        if (submissionCycleName_ArFilter === null)
            throw new Error("The parameter 'submissionCycleName_ArFilter' cannot be null.");
        else if (submissionCycleName_ArFilter !== undefined)
            url_ += "SubmissionCycleName_ArFilter=" + encodeURIComponent("" + submissionCycleName_ArFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestPeriodSettingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestPeriodSettingsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetRequestPeriodSettingsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllSettingPeriodTypeForTableDropdown(): Observable<RequestPeriodSettingSettingPeriodTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/GetAllSettingPeriodTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettingPeriodTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettingPeriodTypeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestPeriodSettingSettingPeriodTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestPeriodSettingSettingPeriodTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllSettingPeriodTypeForTableDropdown(response: HttpResponseBase): Observable<RequestPeriodSettingSettingPeriodTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequestPeriodSettingSettingPeriodTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllSettingPeriodsRequestTypeForTableDropdown(): Observable<RequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/GetAllSettingPeriodsRequestTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettingPeriodsRequestTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettingPeriodsRequestTypeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllSettingPeriodsRequestTypeForTableDropdown(response: HttpResponseBase): Observable<RequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllSubmissionCycleForTableDropdown(): Observable<RequestPeriodSettingSubmissionCycleLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/GetAllSubmissionCycleForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubmissionCycleForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubmissionCycleForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestPeriodSettingSubmissionCycleLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestPeriodSettingSubmissionCycleLookupTableDto[]>;
        }));
    }

    protected processGetAllSubmissionCycleForTableDropdown(response: HttpResponseBase): Observable<RequestPeriodSettingSubmissionCycleLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequestPeriodSettingSubmissionCycleLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSettingsChangeNotificationEmail(body: CreateOrEditRequestPeriodSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/SendSettingsChangeNotificationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSettingsChangeNotificationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSettingsChangeNotificationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendSettingsChangeNotificationEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestType (optional) 
     * @return Success
     */
    getAllSubmissionCycleForCurrentDate(requestType: number | undefined): Observable<GetRequestPeriodSettingForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/GetAllSubmissionCycleForCurrentDate?";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "requestType=" + encodeURIComponent("" + requestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubmissionCycleForCurrentDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubmissionCycleForCurrentDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRequestPeriodSettingForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRequestPeriodSettingForViewDto[]>;
        }));
    }

    protected processGetAllSubmissionCycleForCurrentDate(response: HttpResponseBase): Observable<GetRequestPeriodSettingForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRequestPeriodSettingForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    changeStatus(id: number | undefined, isActive: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestPeriodSettings/ChangeStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRoles(body: GetRolesInput | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SecMetersReviewServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param organizationUnitIdFilter (optional) 
     * @param reviewStatusFilter (optional) 
     * @param seecCodeFilter (optional) 
     * @param installationNumberFilter (optional) 
     * @param createdDateFromFilter (optional) 
     * @param createdDateToFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(organizationUnitIdFilter: number | undefined, reviewStatusFilter: SecMeterReviewStatusFilter | undefined, seecCodeFilter: string | undefined, installationNumberFilter: string | undefined, createdDateFromFilter: DateTime | undefined, createdDateToFilter: DateTime | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSecMeterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SecMetersReview/GetAll?";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (reviewStatusFilter === null)
            throw new Error("The parameter 'reviewStatusFilter' cannot be null.");
        else if (reviewStatusFilter !== undefined)
            url_ += "ReviewStatusFilter=" + encodeURIComponent("" + reviewStatusFilter) + "&";
        if (seecCodeFilter === null)
            throw new Error("The parameter 'seecCodeFilter' cannot be null.");
        else if (seecCodeFilter !== undefined)
            url_ += "SeecCodeFilter=" + encodeURIComponent("" + seecCodeFilter) + "&";
        if (installationNumberFilter === null)
            throw new Error("The parameter 'installationNumberFilter' cannot be null.");
        else if (installationNumberFilter !== undefined)
            url_ += "InstallationNumberFilter=" + encodeURIComponent("" + installationNumberFilter) + "&";
        if (createdDateFromFilter === null)
            throw new Error("The parameter 'createdDateFromFilter' cannot be null.");
        else if (createdDateFromFilter !== undefined)
            url_ += "CreatedDateFromFilter=" + encodeURIComponent(createdDateFromFilter ? "" + createdDateFromFilter.toString() : "") + "&";
        if (createdDateToFilter === null)
            throw new Error("The parameter 'createdDateToFilter' cannot be null.");
        else if (createdDateToFilter !== undefined)
            url_ += "CreatedDateToFilter=" + encodeURIComponent(createdDateToFilter ? "" + createdDateToFilter.toString() : "") + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSecMeterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSecMeterForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSecMeterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSecMeterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSecMeterForDetails(id: number | undefined): Observable<GetSecMeterForDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/SecMetersReview/GetSecMeterForDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecMeterForDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecMeterForDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecMeterForDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecMeterForDetailsDto>;
        }));
    }

    protected processGetSecMeterForDetails(response: HttpResponseBase): Observable<GetSecMeterForDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSecMeterForDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeReviewStatus(body: ChangeSecMeterReviewStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecMetersReview/ChangeReviewStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeReviewStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeReviewStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeReviewStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationUnitIdFilter (optional) 
     * @param reviewStatusFilter (optional) 
     * @param seecCodeFilter (optional) 
     * @param installationNumberFilter (optional) 
     * @param createdDateFromFilter (optional) 
     * @param createdDateToFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSecMetersToExcel(organizationUnitIdFilter: number | undefined, reviewStatusFilter: SecMeterReviewStatusFilter | undefined, seecCodeFilter: string | undefined, installationNumberFilter: string | undefined, createdDateFromFilter: DateTime | undefined, createdDateToFilter: DateTime | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SecMetersReview/GetSecMetersToExcel?";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (reviewStatusFilter === null)
            throw new Error("The parameter 'reviewStatusFilter' cannot be null.");
        else if (reviewStatusFilter !== undefined)
            url_ += "ReviewStatusFilter=" + encodeURIComponent("" + reviewStatusFilter) + "&";
        if (seecCodeFilter === null)
            throw new Error("The parameter 'seecCodeFilter' cannot be null.");
        else if (seecCodeFilter !== undefined)
            url_ += "SeecCodeFilter=" + encodeURIComponent("" + seecCodeFilter) + "&";
        if (installationNumberFilter === null)
            throw new Error("The parameter 'installationNumberFilter' cannot be null.");
        else if (installationNumberFilter !== undefined)
            url_ += "InstallationNumberFilter=" + encodeURIComponent("" + installationNumberFilter) + "&";
        if (createdDateFromFilter === null)
            throw new Error("The parameter 'createdDateFromFilter' cannot be null.");
        else if (createdDateFromFilter !== undefined)
            url_ += "CreatedDateFromFilter=" + encodeURIComponent(createdDateFromFilter ? "" + createdDateFromFilter.toString() : "") + "&";
        if (createdDateToFilter === null)
            throw new Error("The parameter 'createdDateToFilter' cannot be null.");
        else if (createdDateToFilter !== undefined)
            url_ += "CreatedDateToFilter=" + encodeURIComponent(createdDateToFilter ? "" + createdDateToFilter.toString() : "") + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecMetersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecMetersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSecMetersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SectorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param name_EnFilter (optional) 
     * @param name_ArFilter (optional) 
     * @param code_Filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, name_EnFilter: string | undefined, name_ArFilter: string | undefined, code_Filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSectorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Sectors/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (name_EnFilter === null)
            throw new Error("The parameter 'name_EnFilter' cannot be null.");
        else if (name_EnFilter !== undefined)
            url_ += "Name_EnFilter=" + encodeURIComponent("" + name_EnFilter) + "&";
        if (name_ArFilter === null)
            throw new Error("The parameter 'name_ArFilter' cannot be null.");
        else if (name_ArFilter !== undefined)
            url_ += "Name_ArFilter=" + encodeURIComponent("" + name_ArFilter) + "&";
        if (code_Filter === null)
            throw new Error("The parameter 'code_Filter' cannot be null.");
        else if (code_Filter !== undefined)
            url_ += "Code_Filter=" + encodeURIComponent("" + code_Filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSectorForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSectorForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSectorForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSectorForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSectorForView(id: number | undefined): Observable<GetSectorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Sectors/GetSectorForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSectorForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSectorForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSectorForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSectorForViewDto>;
        }));
    }

    protected processGetSectorForView(response: HttpResponseBase): Observable<GetSectorForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSectorForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSectorForEdit(id: number | undefined): Observable<GetSectorForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sectors/GetSectorForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSectorForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSectorForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSectorForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSectorForEditOutput>;
        }));
    }

    protected processGetSectorForEdit(response: HttpResponseBase): Observable<GetSectorForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSectorForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSectorDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sectors/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param secName (optional) 
     * @return Success
     */
    checkifSectorNameExist(secName: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Sectors/CheckifSectorNameExist?";
        if (secName === null)
            throw new Error("The parameter 'secName' cannot be null.");
        else if (secName !== undefined)
            url_ += "secName=" + encodeURIComponent("" + secName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckifSectorNameExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckifSectorNameExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckifSectorNameExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param secCode (optional) 
     * @return Success
     */
    checkifSectorCodeExist(secCode: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Sectors/CheckifSectorCodeExist?";
        if (secCode === null)
            throw new Error("The parameter 'secCode' cannot be null.");
        else if (secCode !== undefined)
            url_ += "secCode=" + encodeURIComponent("" + secCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckifSectorCodeExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckifSectorCodeExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckifSectorCodeExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sectors/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param name_EnFilter (optional) 
     * @param name_ArFilter (optional) 
     * @return Success
     */
    getSectorsToExcel(filter: string | undefined, name_EnFilter: string | undefined, name_ArFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sectors/GetSectorsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (name_EnFilter === null)
            throw new Error("The parameter 'name_EnFilter' cannot be null.");
        else if (name_EnFilter !== undefined)
            url_ += "Name_EnFilter=" + encodeURIComponent("" + name_EnFilter) + "&";
        if (name_ArFilter === null)
            throw new Error("The parameter 'name_ArFilter' cannot be null.");
        else if (name_ArFilter !== undefined)
            url_ += "Name_ArFilter=" + encodeURIComponent("" + name_ArFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSectorsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSectorsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSectorsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SeecEmailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param receiverEmailAddressFilter (optional) 
     * @param emailSubjectFilter (optional) 
     * @param emailBodyFilter (optional) 
     * @param isSentFilter (optional) 
     * @param errorTypeFilter (optional) 
     * @param errorCodeFilter (optional) 
     * @param errorMessageFilter (optional) 
     * @param maxReTryCounterFilter (optional) 
     * @param minReTryCounterFilter (optional) 
     * @param machineNameFilter (optional) 
     * @param maxDateCreatedFilter (optional) 
     * @param minDateCreatedFilter (optional) 
     * @param maxDateUpdatedFilter (optional) 
     * @param minDateUpdatedFilter (optional) 
     * @param emailTemplateNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, receiverEmailAddressFilter: string | undefined, emailSubjectFilter: string | undefined, emailBodyFilter: string | undefined, isSentFilter: number | undefined, errorTypeFilter: string | undefined, errorCodeFilter: string | undefined, errorMessageFilter: string | undefined, maxReTryCounterFilter: number | undefined, minReTryCounterFilter: number | undefined, machineNameFilter: string | undefined, maxDateCreatedFilter: DateTime | undefined, minDateCreatedFilter: DateTime | undefined, maxDateUpdatedFilter: DateTime | undefined, minDateUpdatedFilter: DateTime | undefined, emailTemplateNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSeecEmailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmails/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (receiverEmailAddressFilter === null)
            throw new Error("The parameter 'receiverEmailAddressFilter' cannot be null.");
        else if (receiverEmailAddressFilter !== undefined)
            url_ += "ReceiverEmailAddressFilter=" + encodeURIComponent("" + receiverEmailAddressFilter) + "&";
        if (emailSubjectFilter === null)
            throw new Error("The parameter 'emailSubjectFilter' cannot be null.");
        else if (emailSubjectFilter !== undefined)
            url_ += "EmailSubjectFilter=" + encodeURIComponent("" + emailSubjectFilter) + "&";
        if (emailBodyFilter === null)
            throw new Error("The parameter 'emailBodyFilter' cannot be null.");
        else if (emailBodyFilter !== undefined)
            url_ += "EmailBodyFilter=" + encodeURIComponent("" + emailBodyFilter) + "&";
        if (isSentFilter === null)
            throw new Error("The parameter 'isSentFilter' cannot be null.");
        else if (isSentFilter !== undefined)
            url_ += "IsSentFilter=" + encodeURIComponent("" + isSentFilter) + "&";
        if (errorTypeFilter === null)
            throw new Error("The parameter 'errorTypeFilter' cannot be null.");
        else if (errorTypeFilter !== undefined)
            url_ += "ErrorTypeFilter=" + encodeURIComponent("" + errorTypeFilter) + "&";
        if (errorCodeFilter === null)
            throw new Error("The parameter 'errorCodeFilter' cannot be null.");
        else if (errorCodeFilter !== undefined)
            url_ += "ErrorCodeFilter=" + encodeURIComponent("" + errorCodeFilter) + "&";
        if (errorMessageFilter === null)
            throw new Error("The parameter 'errorMessageFilter' cannot be null.");
        else if (errorMessageFilter !== undefined)
            url_ += "ErrorMessageFilter=" + encodeURIComponent("" + errorMessageFilter) + "&";
        if (maxReTryCounterFilter === null)
            throw new Error("The parameter 'maxReTryCounterFilter' cannot be null.");
        else if (maxReTryCounterFilter !== undefined)
            url_ += "MaxReTryCounterFilter=" + encodeURIComponent("" + maxReTryCounterFilter) + "&";
        if (minReTryCounterFilter === null)
            throw new Error("The parameter 'minReTryCounterFilter' cannot be null.");
        else if (minReTryCounterFilter !== undefined)
            url_ += "MinReTryCounterFilter=" + encodeURIComponent("" + minReTryCounterFilter) + "&";
        if (machineNameFilter === null)
            throw new Error("The parameter 'machineNameFilter' cannot be null.");
        else if (machineNameFilter !== undefined)
            url_ += "MachineNameFilter=" + encodeURIComponent("" + machineNameFilter) + "&";
        if (maxDateCreatedFilter === null)
            throw new Error("The parameter 'maxDateCreatedFilter' cannot be null.");
        else if (maxDateCreatedFilter !== undefined)
            url_ += "MaxDateCreatedFilter=" + encodeURIComponent(maxDateCreatedFilter ? "" + maxDateCreatedFilter.toString() : "") + "&";
        if (minDateCreatedFilter === null)
            throw new Error("The parameter 'minDateCreatedFilter' cannot be null.");
        else if (minDateCreatedFilter !== undefined)
            url_ += "MinDateCreatedFilter=" + encodeURIComponent(minDateCreatedFilter ? "" + minDateCreatedFilter.toString() : "") + "&";
        if (maxDateUpdatedFilter === null)
            throw new Error("The parameter 'maxDateUpdatedFilter' cannot be null.");
        else if (maxDateUpdatedFilter !== undefined)
            url_ += "MaxDateUpdatedFilter=" + encodeURIComponent(maxDateUpdatedFilter ? "" + maxDateUpdatedFilter.toString() : "") + "&";
        if (minDateUpdatedFilter === null)
            throw new Error("The parameter 'minDateUpdatedFilter' cannot be null.");
        else if (minDateUpdatedFilter !== undefined)
            url_ += "MinDateUpdatedFilter=" + encodeURIComponent(minDateUpdatedFilter ? "" + minDateUpdatedFilter.toString() : "") + "&";
        if (emailTemplateNameFilter === null)
            throw new Error("The parameter 'emailTemplateNameFilter' cannot be null.");
        else if (emailTemplateNameFilter !== undefined)
            url_ += "EmailTemplateNameFilter=" + encodeURIComponent("" + emailTemplateNameFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeecEmailForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeecEmailForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeecEmailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeecEmailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSeecEmailForView(id: number | undefined): Observable<GetSeecEmailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmails/GetSeecEmailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecEmailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecEmailForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeecEmailForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeecEmailForViewDto>;
        }));
    }

    protected processGetSeecEmailForView(response: HttpResponseBase): Observable<GetSeecEmailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeecEmailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSeecEmailForEdit(id: number | undefined): Observable<GetSeecEmailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmails/GetSeecEmailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecEmailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecEmailForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeecEmailForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeecEmailForEditOutput>;
        }));
    }

    protected processGetSeecEmailForEdit(response: HttpResponseBase): Observable<GetSeecEmailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeecEmailForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSeecEmailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param receiverEmailAddressFilter (optional) 
     * @param emailSubjectFilter (optional) 
     * @param emailBodyFilter (optional) 
     * @param isSentFilter (optional) 
     * @param errorTypeFilter (optional) 
     * @param errorCodeFilter (optional) 
     * @param errorMessageFilter (optional) 
     * @param maxReTryCounterFilter (optional) 
     * @param minReTryCounterFilter (optional) 
     * @param machineNameFilter (optional) 
     * @param maxDateCreatedFilter (optional) 
     * @param minDateCreatedFilter (optional) 
     * @param maxDateUpdatedFilter (optional) 
     * @param minDateUpdatedFilter (optional) 
     * @param emailTemplateNameFilter (optional) 
     * @return Success
     */
    getSeecEmailsToExcel(filter: string | undefined, receiverEmailAddressFilter: string | undefined, emailSubjectFilter: string | undefined, emailBodyFilter: string | undefined, isSentFilter: number | undefined, errorTypeFilter: string | undefined, errorCodeFilter: string | undefined, errorMessageFilter: string | undefined, maxReTryCounterFilter: number | undefined, minReTryCounterFilter: number | undefined, machineNameFilter: string | undefined, maxDateCreatedFilter: DateTime | undefined, minDateCreatedFilter: DateTime | undefined, maxDateUpdatedFilter: DateTime | undefined, minDateUpdatedFilter: DateTime | undefined, emailTemplateNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmails/GetSeecEmailsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (receiverEmailAddressFilter === null)
            throw new Error("The parameter 'receiverEmailAddressFilter' cannot be null.");
        else if (receiverEmailAddressFilter !== undefined)
            url_ += "ReceiverEmailAddressFilter=" + encodeURIComponent("" + receiverEmailAddressFilter) + "&";
        if (emailSubjectFilter === null)
            throw new Error("The parameter 'emailSubjectFilter' cannot be null.");
        else if (emailSubjectFilter !== undefined)
            url_ += "EmailSubjectFilter=" + encodeURIComponent("" + emailSubjectFilter) + "&";
        if (emailBodyFilter === null)
            throw new Error("The parameter 'emailBodyFilter' cannot be null.");
        else if (emailBodyFilter !== undefined)
            url_ += "EmailBodyFilter=" + encodeURIComponent("" + emailBodyFilter) + "&";
        if (isSentFilter === null)
            throw new Error("The parameter 'isSentFilter' cannot be null.");
        else if (isSentFilter !== undefined)
            url_ += "IsSentFilter=" + encodeURIComponent("" + isSentFilter) + "&";
        if (errorTypeFilter === null)
            throw new Error("The parameter 'errorTypeFilter' cannot be null.");
        else if (errorTypeFilter !== undefined)
            url_ += "ErrorTypeFilter=" + encodeURIComponent("" + errorTypeFilter) + "&";
        if (errorCodeFilter === null)
            throw new Error("The parameter 'errorCodeFilter' cannot be null.");
        else if (errorCodeFilter !== undefined)
            url_ += "ErrorCodeFilter=" + encodeURIComponent("" + errorCodeFilter) + "&";
        if (errorMessageFilter === null)
            throw new Error("The parameter 'errorMessageFilter' cannot be null.");
        else if (errorMessageFilter !== undefined)
            url_ += "ErrorMessageFilter=" + encodeURIComponent("" + errorMessageFilter) + "&";
        if (maxReTryCounterFilter === null)
            throw new Error("The parameter 'maxReTryCounterFilter' cannot be null.");
        else if (maxReTryCounterFilter !== undefined)
            url_ += "MaxReTryCounterFilter=" + encodeURIComponent("" + maxReTryCounterFilter) + "&";
        if (minReTryCounterFilter === null)
            throw new Error("The parameter 'minReTryCounterFilter' cannot be null.");
        else if (minReTryCounterFilter !== undefined)
            url_ += "MinReTryCounterFilter=" + encodeURIComponent("" + minReTryCounterFilter) + "&";
        if (machineNameFilter === null)
            throw new Error("The parameter 'machineNameFilter' cannot be null.");
        else if (machineNameFilter !== undefined)
            url_ += "MachineNameFilter=" + encodeURIComponent("" + machineNameFilter) + "&";
        if (maxDateCreatedFilter === null)
            throw new Error("The parameter 'maxDateCreatedFilter' cannot be null.");
        else if (maxDateCreatedFilter !== undefined)
            url_ += "MaxDateCreatedFilter=" + encodeURIComponent(maxDateCreatedFilter ? "" + maxDateCreatedFilter.toString() : "") + "&";
        if (minDateCreatedFilter === null)
            throw new Error("The parameter 'minDateCreatedFilter' cannot be null.");
        else if (minDateCreatedFilter !== undefined)
            url_ += "MinDateCreatedFilter=" + encodeURIComponent(minDateCreatedFilter ? "" + minDateCreatedFilter.toString() : "") + "&";
        if (maxDateUpdatedFilter === null)
            throw new Error("The parameter 'maxDateUpdatedFilter' cannot be null.");
        else if (maxDateUpdatedFilter !== undefined)
            url_ += "MaxDateUpdatedFilter=" + encodeURIComponent(maxDateUpdatedFilter ? "" + maxDateUpdatedFilter.toString() : "") + "&";
        if (minDateUpdatedFilter === null)
            throw new Error("The parameter 'minDateUpdatedFilter' cannot be null.");
        else if (minDateUpdatedFilter !== undefined)
            url_ += "MinDateUpdatedFilter=" + encodeURIComponent(minDateUpdatedFilter ? "" + minDateUpdatedFilter.toString() : "") + "&";
        if (emailTemplateNameFilter === null)
            throw new Error("The parameter 'emailTemplateNameFilter' cannot be null.");
        else if (emailTemplateNameFilter !== undefined)
            url_ += "EmailTemplateNameFilter=" + encodeURIComponent("" + emailTemplateNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecEmailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecEmailsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeecEmailsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllEmailTemplateForTableDropdown(): Observable<SeecEmailEmailTemplateLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmails/GetAllEmailTemplateForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmailTemplateForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmailTemplateForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeecEmailEmailTemplateLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeecEmailEmailTemplateLookupTableDto[]>;
        }));
    }

    protected processGetAllEmailTemplateForTableDropdown(response: HttpResponseBase): Observable<SeecEmailEmailTemplateLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeecEmailEmailTemplateLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SeecEmailTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param emailSubjectFilter (optional) 
     * @param isTemplateActiveFilter (optional) 
     * @param maxDateCreatedFilter (optional) 
     * @param minDateCreatedFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, emailSubjectFilter: string | undefined, isTemplateActiveFilter: number | undefined, maxDateCreatedFilter: DateTime | undefined, minDateCreatedFilter: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSeecEmailTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmailTemplates/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (emailSubjectFilter === null)
            throw new Error("The parameter 'emailSubjectFilter' cannot be null.");
        else if (emailSubjectFilter !== undefined)
            url_ += "EmailSubjectFilter=" + encodeURIComponent("" + emailSubjectFilter) + "&";
        if (isTemplateActiveFilter === null)
            throw new Error("The parameter 'isTemplateActiveFilter' cannot be null.");
        else if (isTemplateActiveFilter !== undefined)
            url_ += "IsTemplateActiveFilter=" + encodeURIComponent("" + isTemplateActiveFilter) + "&";
        if (maxDateCreatedFilter === null)
            throw new Error("The parameter 'maxDateCreatedFilter' cannot be null.");
        else if (maxDateCreatedFilter !== undefined)
            url_ += "MaxDateCreatedFilter=" + encodeURIComponent(maxDateCreatedFilter ? "" + maxDateCreatedFilter.toString() : "") + "&";
        if (minDateCreatedFilter === null)
            throw new Error("The parameter 'minDateCreatedFilter' cannot be null.");
        else if (minDateCreatedFilter !== undefined)
            url_ += "MinDateCreatedFilter=" + encodeURIComponent(minDateCreatedFilter ? "" + minDateCreatedFilter.toString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeecEmailTemplateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeecEmailTemplateForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeecEmailTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeecEmailTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSeecEmailTemplateForView(id: number | undefined): Observable<GetSeecEmailTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmailTemplates/GetSeecEmailTemplateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecEmailTemplateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecEmailTemplateForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeecEmailTemplateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeecEmailTemplateForViewDto>;
        }));
    }

    protected processGetSeecEmailTemplateForView(response: HttpResponseBase): Observable<GetSeecEmailTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeecEmailTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSeecEmailTemplateForEdit(id: number | undefined): Observable<GetSeecEmailTemplateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmailTemplates/GetSeecEmailTemplateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecEmailTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecEmailTemplateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeecEmailTemplateForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeecEmailTemplateForEditOutput>;
        }));
    }

    protected processGetSeecEmailTemplateForEdit(response: HttpResponseBase): Observable<GetSeecEmailTemplateForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeecEmailTemplateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSeecEmailTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmailTemplates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmailTemplates/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param emailSubjectFilter (optional) 
     * @param isTemplateActiveFilter (optional) 
     * @param maxDateCreatedFilter (optional) 
     * @param minDateCreatedFilter (optional) 
     * @return Success
     */
    getSeecEmailTemplatesToExcel(filter: string | undefined, nameFilter: string | undefined, emailSubjectFilter: string | undefined, isTemplateActiveFilter: number | undefined, maxDateCreatedFilter: DateTime | undefined, minDateCreatedFilter: DateTime | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecEmailTemplates/GetSeecEmailTemplatesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (emailSubjectFilter === null)
            throw new Error("The parameter 'emailSubjectFilter' cannot be null.");
        else if (emailSubjectFilter !== undefined)
            url_ += "EmailSubjectFilter=" + encodeURIComponent("" + emailSubjectFilter) + "&";
        if (isTemplateActiveFilter === null)
            throw new Error("The parameter 'isTemplateActiveFilter' cannot be null.");
        else if (isTemplateActiveFilter !== undefined)
            url_ += "IsTemplateActiveFilter=" + encodeURIComponent("" + isTemplateActiveFilter) + "&";
        if (maxDateCreatedFilter === null)
            throw new Error("The parameter 'maxDateCreatedFilter' cannot be null.");
        else if (maxDateCreatedFilter !== undefined)
            url_ += "MaxDateCreatedFilter=" + encodeURIComponent(maxDateCreatedFilter ? "" + maxDateCreatedFilter.toString() : "") + "&";
        if (minDateCreatedFilter === null)
            throw new Error("The parameter 'minDateCreatedFilter' cannot be null.");
        else if (minDateCreatedFilter !== undefined)
            url_ += "MinDateCreatedFilter=" + encodeURIComponent(minDateCreatedFilter ? "" + minDateCreatedFilter.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecEmailTemplatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecEmailTemplatesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeecEmailTemplatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SeecSMSsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param mobileNumberFilter (optional) 
     * @param messageBodyFilter (optional) 
     * @param isDeliveryRequiredFilter (optional) 
     * @param transactionIDFilter (optional) 
     * @param isSentFilter (optional) 
     * @param errorTypeFilter (optional) 
     * @param errorCodeFilter (optional) 
     * @param errorMessageFilter (optional) 
     * @param maxReTryCounterFilter (optional) 
     * @param minReTryCounterFilter (optional) 
     * @param machineNameFilter (optional) 
     * @param maxDateCreatedFilter (optional) 
     * @param minDateCreatedFilter (optional) 
     * @param maxDateUpdatedFilter (optional) 
     * @param minDateUpdatedFilter (optional) 
     * @param maxSentDatetimeFilter (optional) 
     * @param minSentDatetimeFilter (optional) 
     * @param smsTemplateNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, mobileNumberFilter: string | undefined, messageBodyFilter: string | undefined, isDeliveryRequiredFilter: number | undefined, transactionIDFilter: string | undefined, isSentFilter: number | undefined, errorTypeFilter: string | undefined, errorCodeFilter: string | undefined, errorMessageFilter: string | undefined, maxReTryCounterFilter: number | undefined, minReTryCounterFilter: number | undefined, machineNameFilter: string | undefined, maxDateCreatedFilter: DateTime | undefined, minDateCreatedFilter: DateTime | undefined, maxDateUpdatedFilter: DateTime | undefined, minDateUpdatedFilter: DateTime | undefined, maxSentDatetimeFilter: DateTime | undefined, minSentDatetimeFilter: DateTime | undefined, smsTemplateNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSeecSMSForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecSMSs/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (mobileNumberFilter === null)
            throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
        else if (mobileNumberFilter !== undefined)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&";
        if (messageBodyFilter === null)
            throw new Error("The parameter 'messageBodyFilter' cannot be null.");
        else if (messageBodyFilter !== undefined)
            url_ += "MessageBodyFilter=" + encodeURIComponent("" + messageBodyFilter) + "&";
        if (isDeliveryRequiredFilter === null)
            throw new Error("The parameter 'isDeliveryRequiredFilter' cannot be null.");
        else if (isDeliveryRequiredFilter !== undefined)
            url_ += "IsDeliveryRequiredFilter=" + encodeURIComponent("" + isDeliveryRequiredFilter) + "&";
        if (transactionIDFilter === null)
            throw new Error("The parameter 'transactionIDFilter' cannot be null.");
        else if (transactionIDFilter !== undefined)
            url_ += "TransactionIDFilter=" + encodeURIComponent("" + transactionIDFilter) + "&";
        if (isSentFilter === null)
            throw new Error("The parameter 'isSentFilter' cannot be null.");
        else if (isSentFilter !== undefined)
            url_ += "IsSentFilter=" + encodeURIComponent("" + isSentFilter) + "&";
        if (errorTypeFilter === null)
            throw new Error("The parameter 'errorTypeFilter' cannot be null.");
        else if (errorTypeFilter !== undefined)
            url_ += "ErrorTypeFilter=" + encodeURIComponent("" + errorTypeFilter) + "&";
        if (errorCodeFilter === null)
            throw new Error("The parameter 'errorCodeFilter' cannot be null.");
        else if (errorCodeFilter !== undefined)
            url_ += "ErrorCodeFilter=" + encodeURIComponent("" + errorCodeFilter) + "&";
        if (errorMessageFilter === null)
            throw new Error("The parameter 'errorMessageFilter' cannot be null.");
        else if (errorMessageFilter !== undefined)
            url_ += "ErrorMessageFilter=" + encodeURIComponent("" + errorMessageFilter) + "&";
        if (maxReTryCounterFilter === null)
            throw new Error("The parameter 'maxReTryCounterFilter' cannot be null.");
        else if (maxReTryCounterFilter !== undefined)
            url_ += "MaxReTryCounterFilter=" + encodeURIComponent("" + maxReTryCounterFilter) + "&";
        if (minReTryCounterFilter === null)
            throw new Error("The parameter 'minReTryCounterFilter' cannot be null.");
        else if (minReTryCounterFilter !== undefined)
            url_ += "MinReTryCounterFilter=" + encodeURIComponent("" + minReTryCounterFilter) + "&";
        if (machineNameFilter === null)
            throw new Error("The parameter 'machineNameFilter' cannot be null.");
        else if (machineNameFilter !== undefined)
            url_ += "MachineNameFilter=" + encodeURIComponent("" + machineNameFilter) + "&";
        if (maxDateCreatedFilter === null)
            throw new Error("The parameter 'maxDateCreatedFilter' cannot be null.");
        else if (maxDateCreatedFilter !== undefined)
            url_ += "MaxDateCreatedFilter=" + encodeURIComponent(maxDateCreatedFilter ? "" + maxDateCreatedFilter.toString() : "") + "&";
        if (minDateCreatedFilter === null)
            throw new Error("The parameter 'minDateCreatedFilter' cannot be null.");
        else if (minDateCreatedFilter !== undefined)
            url_ += "MinDateCreatedFilter=" + encodeURIComponent(minDateCreatedFilter ? "" + minDateCreatedFilter.toString() : "") + "&";
        if (maxDateUpdatedFilter === null)
            throw new Error("The parameter 'maxDateUpdatedFilter' cannot be null.");
        else if (maxDateUpdatedFilter !== undefined)
            url_ += "MaxDateUpdatedFilter=" + encodeURIComponent(maxDateUpdatedFilter ? "" + maxDateUpdatedFilter.toString() : "") + "&";
        if (minDateUpdatedFilter === null)
            throw new Error("The parameter 'minDateUpdatedFilter' cannot be null.");
        else if (minDateUpdatedFilter !== undefined)
            url_ += "MinDateUpdatedFilter=" + encodeURIComponent(minDateUpdatedFilter ? "" + minDateUpdatedFilter.toString() : "") + "&";
        if (maxSentDatetimeFilter === null)
            throw new Error("The parameter 'maxSentDatetimeFilter' cannot be null.");
        else if (maxSentDatetimeFilter !== undefined)
            url_ += "MaxSentDatetimeFilter=" + encodeURIComponent(maxSentDatetimeFilter ? "" + maxSentDatetimeFilter.toString() : "") + "&";
        if (minSentDatetimeFilter === null)
            throw new Error("The parameter 'minSentDatetimeFilter' cannot be null.");
        else if (minSentDatetimeFilter !== undefined)
            url_ += "MinSentDatetimeFilter=" + encodeURIComponent(minSentDatetimeFilter ? "" + minSentDatetimeFilter.toString() : "") + "&";
        if (smsTemplateNameFilter === null)
            throw new Error("The parameter 'smsTemplateNameFilter' cannot be null.");
        else if (smsTemplateNameFilter !== undefined)
            url_ += "SmsTemplateNameFilter=" + encodeURIComponent("" + smsTemplateNameFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeecSMSForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeecSMSForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeecSMSForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeecSMSForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSeecSMSForView(id: number | undefined): Observable<GetSeecSMSForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecSMSs/GetSeecSMSForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecSMSForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecSMSForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeecSMSForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeecSMSForViewDto>;
        }));
    }

    protected processGetSeecSMSForView(response: HttpResponseBase): Observable<GetSeecSMSForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeecSMSForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSeecSMSForEdit(id: number | undefined): Observable<GetSeecSMSForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeecSMSs/GetSeecSMSForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecSMSForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecSMSForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeecSMSForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeecSMSForEditOutput>;
        }));
    }

    protected processGetSeecSMSForEdit(response: HttpResponseBase): Observable<GetSeecSMSForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeecSMSForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSeecSMSDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeecSMSs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeecSMSs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param mobileNumberFilter (optional) 
     * @param messageBodyFilter (optional) 
     * @param isDeliveryRequiredFilter (optional) 
     * @param transactionIDFilter (optional) 
     * @param isSentFilter (optional) 
     * @param errorTypeFilter (optional) 
     * @param errorCodeFilter (optional) 
     * @param errorMessageFilter (optional) 
     * @param maxReTryCounterFilter (optional) 
     * @param minReTryCounterFilter (optional) 
     * @param machineNameFilter (optional) 
     * @param maxDateCreatedFilter (optional) 
     * @param minDateCreatedFilter (optional) 
     * @param maxDateUpdatedFilter (optional) 
     * @param minDateUpdatedFilter (optional) 
     * @param maxSentDatetimeFilter (optional) 
     * @param minSentDatetimeFilter (optional) 
     * @param smsTemplateNameFilter (optional) 
     * @return Success
     */
    getSeecSMSsToExcel(filter: string | undefined, mobileNumberFilter: string | undefined, messageBodyFilter: string | undefined, isDeliveryRequiredFilter: number | undefined, transactionIDFilter: string | undefined, isSentFilter: number | undefined, errorTypeFilter: string | undefined, errorCodeFilter: string | undefined, errorMessageFilter: string | undefined, maxReTryCounterFilter: number | undefined, minReTryCounterFilter: number | undefined, machineNameFilter: string | undefined, maxDateCreatedFilter: DateTime | undefined, minDateCreatedFilter: DateTime | undefined, maxDateUpdatedFilter: DateTime | undefined, minDateUpdatedFilter: DateTime | undefined, maxSentDatetimeFilter: DateTime | undefined, minSentDatetimeFilter: DateTime | undefined, smsTemplateNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecSMSs/GetSeecSMSsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (mobileNumberFilter === null)
            throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
        else if (mobileNumberFilter !== undefined)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&";
        if (messageBodyFilter === null)
            throw new Error("The parameter 'messageBodyFilter' cannot be null.");
        else if (messageBodyFilter !== undefined)
            url_ += "MessageBodyFilter=" + encodeURIComponent("" + messageBodyFilter) + "&";
        if (isDeliveryRequiredFilter === null)
            throw new Error("The parameter 'isDeliveryRequiredFilter' cannot be null.");
        else if (isDeliveryRequiredFilter !== undefined)
            url_ += "IsDeliveryRequiredFilter=" + encodeURIComponent("" + isDeliveryRequiredFilter) + "&";
        if (transactionIDFilter === null)
            throw new Error("The parameter 'transactionIDFilter' cannot be null.");
        else if (transactionIDFilter !== undefined)
            url_ += "TransactionIDFilter=" + encodeURIComponent("" + transactionIDFilter) + "&";
        if (isSentFilter === null)
            throw new Error("The parameter 'isSentFilter' cannot be null.");
        else if (isSentFilter !== undefined)
            url_ += "IsSentFilter=" + encodeURIComponent("" + isSentFilter) + "&";
        if (errorTypeFilter === null)
            throw new Error("The parameter 'errorTypeFilter' cannot be null.");
        else if (errorTypeFilter !== undefined)
            url_ += "ErrorTypeFilter=" + encodeURIComponent("" + errorTypeFilter) + "&";
        if (errorCodeFilter === null)
            throw new Error("The parameter 'errorCodeFilter' cannot be null.");
        else if (errorCodeFilter !== undefined)
            url_ += "ErrorCodeFilter=" + encodeURIComponent("" + errorCodeFilter) + "&";
        if (errorMessageFilter === null)
            throw new Error("The parameter 'errorMessageFilter' cannot be null.");
        else if (errorMessageFilter !== undefined)
            url_ += "ErrorMessageFilter=" + encodeURIComponent("" + errorMessageFilter) + "&";
        if (maxReTryCounterFilter === null)
            throw new Error("The parameter 'maxReTryCounterFilter' cannot be null.");
        else if (maxReTryCounterFilter !== undefined)
            url_ += "MaxReTryCounterFilter=" + encodeURIComponent("" + maxReTryCounterFilter) + "&";
        if (minReTryCounterFilter === null)
            throw new Error("The parameter 'minReTryCounterFilter' cannot be null.");
        else if (minReTryCounterFilter !== undefined)
            url_ += "MinReTryCounterFilter=" + encodeURIComponent("" + minReTryCounterFilter) + "&";
        if (machineNameFilter === null)
            throw new Error("The parameter 'machineNameFilter' cannot be null.");
        else if (machineNameFilter !== undefined)
            url_ += "MachineNameFilter=" + encodeURIComponent("" + machineNameFilter) + "&";
        if (maxDateCreatedFilter === null)
            throw new Error("The parameter 'maxDateCreatedFilter' cannot be null.");
        else if (maxDateCreatedFilter !== undefined)
            url_ += "MaxDateCreatedFilter=" + encodeURIComponent(maxDateCreatedFilter ? "" + maxDateCreatedFilter.toString() : "") + "&";
        if (minDateCreatedFilter === null)
            throw new Error("The parameter 'minDateCreatedFilter' cannot be null.");
        else if (minDateCreatedFilter !== undefined)
            url_ += "MinDateCreatedFilter=" + encodeURIComponent(minDateCreatedFilter ? "" + minDateCreatedFilter.toString() : "") + "&";
        if (maxDateUpdatedFilter === null)
            throw new Error("The parameter 'maxDateUpdatedFilter' cannot be null.");
        else if (maxDateUpdatedFilter !== undefined)
            url_ += "MaxDateUpdatedFilter=" + encodeURIComponent(maxDateUpdatedFilter ? "" + maxDateUpdatedFilter.toString() : "") + "&";
        if (minDateUpdatedFilter === null)
            throw new Error("The parameter 'minDateUpdatedFilter' cannot be null.");
        else if (minDateUpdatedFilter !== undefined)
            url_ += "MinDateUpdatedFilter=" + encodeURIComponent(minDateUpdatedFilter ? "" + minDateUpdatedFilter.toString() : "") + "&";
        if (maxSentDatetimeFilter === null)
            throw new Error("The parameter 'maxSentDatetimeFilter' cannot be null.");
        else if (maxSentDatetimeFilter !== undefined)
            url_ += "MaxSentDatetimeFilter=" + encodeURIComponent(maxSentDatetimeFilter ? "" + maxSentDatetimeFilter.toString() : "") + "&";
        if (minSentDatetimeFilter === null)
            throw new Error("The parameter 'minSentDatetimeFilter' cannot be null.");
        else if (minSentDatetimeFilter !== undefined)
            url_ += "MinSentDatetimeFilter=" + encodeURIComponent(minSentDatetimeFilter ? "" + minSentDatetimeFilter.toString() : "") + "&";
        if (smsTemplateNameFilter === null)
            throw new Error("The parameter 'smsTemplateNameFilter' cannot be null.");
        else if (smsTemplateNameFilter !== undefined)
            url_ += "SmsTemplateNameFilter=" + encodeURIComponent("" + smsTemplateNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecSMSsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecSMSsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeecSMSsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllSmsTemplateForTableDropdown(): Observable<SeecSMSSmsTemplateLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SeecSMSs/GetAllSmsTemplateForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSmsTemplateForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSmsTemplateForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeecSMSSmsTemplateLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeecSMSSmsTemplateLookupTableDto[]>;
        }));
    }

    protected processGetAllSmsTemplateForTableDropdown(response: HttpResponseBase): Observable<SeecSMSSmsTemplateLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeecSMSSmsTemplateLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SeecSmsTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param smsTemplateBodyFilter (optional) 
     * @param isTemplateActiveFilter (optional) 
     * @param maxDateCreatedFilter (optional) 
     * @param minDateCreatedFilter (optional) 
     * @param maxDateUpdatedFilter (optional) 
     * @param minDateUpdatedFilter (optional) 
     * @param gracePeriodFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, smsTemplateBodyFilter: string | undefined, isTemplateActiveFilter: number | undefined, maxDateCreatedFilter: DateTime | undefined, minDateCreatedFilter: DateTime | undefined, maxDateUpdatedFilter: DateTime | undefined, minDateUpdatedFilter: DateTime | undefined, gracePeriodFilter: string | undefined, descriptionFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSeecSmsTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecSmsTemplates/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (smsTemplateBodyFilter === null)
            throw new Error("The parameter 'smsTemplateBodyFilter' cannot be null.");
        else if (smsTemplateBodyFilter !== undefined)
            url_ += "SmsTemplateBodyFilter=" + encodeURIComponent("" + smsTemplateBodyFilter) + "&";
        if (isTemplateActiveFilter === null)
            throw new Error("The parameter 'isTemplateActiveFilter' cannot be null.");
        else if (isTemplateActiveFilter !== undefined)
            url_ += "IsTemplateActiveFilter=" + encodeURIComponent("" + isTemplateActiveFilter) + "&";
        if (maxDateCreatedFilter === null)
            throw new Error("The parameter 'maxDateCreatedFilter' cannot be null.");
        else if (maxDateCreatedFilter !== undefined)
            url_ += "MaxDateCreatedFilter=" + encodeURIComponent(maxDateCreatedFilter ? "" + maxDateCreatedFilter.toString() : "") + "&";
        if (minDateCreatedFilter === null)
            throw new Error("The parameter 'minDateCreatedFilter' cannot be null.");
        else if (minDateCreatedFilter !== undefined)
            url_ += "MinDateCreatedFilter=" + encodeURIComponent(minDateCreatedFilter ? "" + minDateCreatedFilter.toString() : "") + "&";
        if (maxDateUpdatedFilter === null)
            throw new Error("The parameter 'maxDateUpdatedFilter' cannot be null.");
        else if (maxDateUpdatedFilter !== undefined)
            url_ += "MaxDateUpdatedFilter=" + encodeURIComponent(maxDateUpdatedFilter ? "" + maxDateUpdatedFilter.toString() : "") + "&";
        if (minDateUpdatedFilter === null)
            throw new Error("The parameter 'minDateUpdatedFilter' cannot be null.");
        else if (minDateUpdatedFilter !== undefined)
            url_ += "MinDateUpdatedFilter=" + encodeURIComponent(minDateUpdatedFilter ? "" + minDateUpdatedFilter.toString() : "") + "&";
        if (gracePeriodFilter === null)
            throw new Error("The parameter 'gracePeriodFilter' cannot be null.");
        else if (gracePeriodFilter !== undefined)
            url_ += "GracePeriodFilter=" + encodeURIComponent("" + gracePeriodFilter) + "&";
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSeecSmsTemplateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSeecSmsTemplateForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeecSmsTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSeecSmsTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSeecSmsTemplateForView(id: number | undefined): Observable<GetSeecSmsTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecSmsTemplates/GetSeecSmsTemplateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecSmsTemplateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecSmsTemplateForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeecSmsTemplateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeecSmsTemplateForViewDto>;
        }));
    }

    protected processGetSeecSmsTemplateForView(response: HttpResponseBase): Observable<GetSeecSmsTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeecSmsTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSeecSmsTemplateForEdit(id: number | undefined): Observable<GetSeecSmsTemplateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeecSmsTemplates/GetSeecSmsTemplateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecSmsTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecSmsTemplateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeecSmsTemplateForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeecSmsTemplateForEditOutput>;
        }));
    }

    protected processGetSeecSmsTemplateForEdit(response: HttpResponseBase): Observable<GetSeecSmsTemplateForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSeecSmsTemplateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSeecSmsTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeecSmsTemplates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeecSmsTemplates/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param smsTemplateBodyFilter (optional) 
     * @param isTemplateActiveFilter (optional) 
     * @param maxDateCreatedFilter (optional) 
     * @param minDateCreatedFilter (optional) 
     * @param maxDateUpdatedFilter (optional) 
     * @param minDateUpdatedFilter (optional) 
     * @param gracePeriodFilter (optional) 
     * @param descriptionFilter (optional) 
     * @return Success
     */
    getSeecSmsTemplatesToExcel(filter: string | undefined, nameFilter: string | undefined, smsTemplateBodyFilter: string | undefined, isTemplateActiveFilter: number | undefined, maxDateCreatedFilter: DateTime | undefined, minDateCreatedFilter: DateTime | undefined, maxDateUpdatedFilter: DateTime | undefined, minDateUpdatedFilter: DateTime | undefined, gracePeriodFilter: string | undefined, descriptionFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SeecSmsTemplates/GetSeecSmsTemplatesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (smsTemplateBodyFilter === null)
            throw new Error("The parameter 'smsTemplateBodyFilter' cannot be null.");
        else if (smsTemplateBodyFilter !== undefined)
            url_ += "SmsTemplateBodyFilter=" + encodeURIComponent("" + smsTemplateBodyFilter) + "&";
        if (isTemplateActiveFilter === null)
            throw new Error("The parameter 'isTemplateActiveFilter' cannot be null.");
        else if (isTemplateActiveFilter !== undefined)
            url_ += "IsTemplateActiveFilter=" + encodeURIComponent("" + isTemplateActiveFilter) + "&";
        if (maxDateCreatedFilter === null)
            throw new Error("The parameter 'maxDateCreatedFilter' cannot be null.");
        else if (maxDateCreatedFilter !== undefined)
            url_ += "MaxDateCreatedFilter=" + encodeURIComponent(maxDateCreatedFilter ? "" + maxDateCreatedFilter.toString() : "") + "&";
        if (minDateCreatedFilter === null)
            throw new Error("The parameter 'minDateCreatedFilter' cannot be null.");
        else if (minDateCreatedFilter !== undefined)
            url_ += "MinDateCreatedFilter=" + encodeURIComponent(minDateCreatedFilter ? "" + minDateCreatedFilter.toString() : "") + "&";
        if (maxDateUpdatedFilter === null)
            throw new Error("The parameter 'maxDateUpdatedFilter' cannot be null.");
        else if (maxDateUpdatedFilter !== undefined)
            url_ += "MaxDateUpdatedFilter=" + encodeURIComponent(maxDateUpdatedFilter ? "" + maxDateUpdatedFilter.toString() : "") + "&";
        if (minDateUpdatedFilter === null)
            throw new Error("The parameter 'minDateUpdatedFilter' cannot be null.");
        else if (minDateUpdatedFilter !== undefined)
            url_ += "MinDateUpdatedFilter=" + encodeURIComponent(minDateUpdatedFilter ? "" + minDateUpdatedFilter.toString() : "") + "&";
        if (gracePeriodFilter === null)
            throw new Error("The parameter 'gracePeriodFilter' cannot be null.");
        else if (gracePeriodFilter !== undefined)
            url_ += "GracePeriodFilter=" + encodeURIComponent("" + gracePeriodFilter) + "&";
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecSmsTemplatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecSmsTemplatesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetSeecSmsTemplatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServicesLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param serviceLogFolderName (optional) 
     * @return Success
     */
    downloadAllLogs(serviceLogFolderName: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ServicesLog/DownloadAllLogs?";
        if (serviceLogFolderName === null)
            throw new Error("The parameter 'serviceLogFolderName' cannot be null.");
        else if (serviceLogFolderName !== undefined)
            url_ += "ServiceLogFolderName=" + encodeURIComponent("" + serviceLogFolderName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAllLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAllLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadAllLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SMSsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSMSForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SMSs/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSMSForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSMSForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSMSForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSMSForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSMSForView(id: number | undefined): Observable<GetSMSForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SMSs/GetSMSForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMSForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMSForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSMSForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSMSForViewDto>;
        }));
    }

    protected processGetSMSForView(response: HttpResponseBase): Observable<GetSMSForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSMSForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSMSForEdit(id: number | undefined): Observable<GetSMSForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SMSs/GetSMSForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMSForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMSForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSMSForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSMSForEditOutput>;
        }));
    }

    protected processGetSMSForEdit(response: HttpResponseBase): Observable<GetSMSForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSMSForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSMSDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SMSs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SMSs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SmsTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSmsTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SmsTemplates/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSmsTemplateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSmsTemplateForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSmsTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSmsTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSmsTemplateForView(id: number | undefined): Observable<GetSmsTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SmsTemplates/GetSmsTemplateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmsTemplateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmsTemplateForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSmsTemplateForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSmsTemplateForViewDto>;
        }));
    }

    protected processGetSmsTemplateForView(response: HttpResponseBase): Observable<GetSmsTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSmsTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSmsTemplateForEdit(id: number | undefined): Observable<GetSmsTemplateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SmsTemplates/GetSmsTemplateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmsTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmsTemplateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSmsTemplateForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSmsTemplateForEditOutput>;
        }));
    }

    protected processGetSmsTemplateForEdit(response: HttpResponseBase): Observable<GetSmsTemplateForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSmsTemplateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSmsTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SmsTemplates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SmsTemplates/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StreetlightAssetInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param organizationUnitIdFilter (optional) 
     * @param regionIdFilter (optional) 
     * @param lightingTypeIdFilter (optional) 
     * @param serviceProviderIdFilter (optional) 
     * @param operationalStatusFilter (optional) 
     * @param tarshidRetrofitFilter (optional) 
     * @param yearBuiltFromFilter (optional) 
     * @param yearBuiltToFilter (optional) 
     * @param lastRetrofitYearFromFilter (optional) 
     * @param lastRetrofitYearToFilter (optional) 
     * @param numberOfStreetlightsFromFilter (optional) 
     * @param numberOfStreetlightsToFilter (optional) 
     * @param createdDateFromFilter (optional) 
     * @param createdDateToFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(organizationUnitIdFilter: number | undefined, regionIdFilter: number | undefined, lightingTypeIdFilter: number | undefined, serviceProviderIdFilter: number | undefined, operationalStatusFilter: number | undefined, tarshidRetrofitFilter: boolean | undefined, yearBuiltFromFilter: string | undefined, yearBuiltToFilter: string | undefined, lastRetrofitYearFromFilter: string | undefined, lastRetrofitYearToFilter: string | undefined, numberOfStreetlightsFromFilter: number | undefined, numberOfStreetlightsToFilter: number | undefined, createdDateFromFilter: DateTime | undefined, createdDateToFilter: DateTime | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetStreetlightAssetInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StreetlightAssetInfos/GetAll?";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (regionIdFilter === null)
            throw new Error("The parameter 'regionIdFilter' cannot be null.");
        else if (regionIdFilter !== undefined)
            url_ += "RegionIdFilter=" + encodeURIComponent("" + regionIdFilter) + "&";
        if (lightingTypeIdFilter === null)
            throw new Error("The parameter 'lightingTypeIdFilter' cannot be null.");
        else if (lightingTypeIdFilter !== undefined)
            url_ += "LightingTypeIdFilter=" + encodeURIComponent("" + lightingTypeIdFilter) + "&";
        if (serviceProviderIdFilter === null)
            throw new Error("The parameter 'serviceProviderIdFilter' cannot be null.");
        else if (serviceProviderIdFilter !== undefined)
            url_ += "ServiceProviderIdFilter=" + encodeURIComponent("" + serviceProviderIdFilter) + "&";
        if (operationalStatusFilter === null)
            throw new Error("The parameter 'operationalStatusFilter' cannot be null.");
        else if (operationalStatusFilter !== undefined)
            url_ += "OperationalStatusFilter=" + encodeURIComponent("" + operationalStatusFilter) + "&";
        if (tarshidRetrofitFilter === null)
            throw new Error("The parameter 'tarshidRetrofitFilter' cannot be null.");
        else if (tarshidRetrofitFilter !== undefined)
            url_ += "TarshidRetrofitFilter=" + encodeURIComponent("" + tarshidRetrofitFilter) + "&";
        if (yearBuiltFromFilter === null)
            throw new Error("The parameter 'yearBuiltFromFilter' cannot be null.");
        else if (yearBuiltFromFilter !== undefined)
            url_ += "YearBuiltFromFilter=" + encodeURIComponent("" + yearBuiltFromFilter) + "&";
        if (yearBuiltToFilter === null)
            throw new Error("The parameter 'yearBuiltToFilter' cannot be null.");
        else if (yearBuiltToFilter !== undefined)
            url_ += "YearBuiltToFilter=" + encodeURIComponent("" + yearBuiltToFilter) + "&";
        if (lastRetrofitYearFromFilter === null)
            throw new Error("The parameter 'lastRetrofitYearFromFilter' cannot be null.");
        else if (lastRetrofitYearFromFilter !== undefined)
            url_ += "LastRetrofitYearFromFilter=" + encodeURIComponent("" + lastRetrofitYearFromFilter) + "&";
        if (lastRetrofitYearToFilter === null)
            throw new Error("The parameter 'lastRetrofitYearToFilter' cannot be null.");
        else if (lastRetrofitYearToFilter !== undefined)
            url_ += "LastRetrofitYearToFilter=" + encodeURIComponent("" + lastRetrofitYearToFilter) + "&";
        if (numberOfStreetlightsFromFilter === null)
            throw new Error("The parameter 'numberOfStreetlightsFromFilter' cannot be null.");
        else if (numberOfStreetlightsFromFilter !== undefined)
            url_ += "NumberOfStreetlightsFromFilter=" + encodeURIComponent("" + numberOfStreetlightsFromFilter) + "&";
        if (numberOfStreetlightsToFilter === null)
            throw new Error("The parameter 'numberOfStreetlightsToFilter' cannot be null.");
        else if (numberOfStreetlightsToFilter !== undefined)
            url_ += "NumberOfStreetlightsToFilter=" + encodeURIComponent("" + numberOfStreetlightsToFilter) + "&";
        if (createdDateFromFilter === null)
            throw new Error("The parameter 'createdDateFromFilter' cannot be null.");
        else if (createdDateFromFilter !== undefined)
            url_ += "CreatedDateFromFilter=" + encodeURIComponent(createdDateFromFilter ? "" + createdDateFromFilter.toString() : "") + "&";
        if (createdDateToFilter === null)
            throw new Error("The parameter 'createdDateToFilter' cannot be null.");
        else if (createdDateToFilter !== undefined)
            url_ += "CreatedDateToFilter=" + encodeURIComponent(createdDateToFilter ? "" + createdDateToFilter.toString() : "") + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetStreetlightAssetInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetStreetlightAssetInfoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetStreetlightAssetInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetStreetlightAssetInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStreetlightAssetInfoForView(id: number | undefined): Observable<GetStreetlightAssetInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StreetlightAssetInfos/GetStreetlightAssetInfoForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStreetlightAssetInfoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStreetlightAssetInfoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStreetlightAssetInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStreetlightAssetInfoForViewDto>;
        }));
    }

    protected processGetStreetlightAssetInfoForView(response: HttpResponseBase): Observable<GetStreetlightAssetInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStreetlightAssetInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditStreetlightAssetInfoDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StreetlightAssetInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StreetlightAssetInfos/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedia(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/StreetlightAssetInfos/UploadMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadMedia(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationUnitIdFilter (optional) 
     * @param regionIdFilter (optional) 
     * @param lightingTypeIdFilter (optional) 
     * @param serviceProviderIdFilter (optional) 
     * @param operationalStatusFilter (optional) 
     * @param tarshidRetrofitFilter (optional) 
     * @param yearBuiltFromFilter (optional) 
     * @param yearBuiltToFilter (optional) 
     * @param lastRetrofitYearFromFilter (optional) 
     * @param lastRetrofitYearToFilter (optional) 
     * @param numberOfStreetlightsFromFilter (optional) 
     * @param numberOfStreetlightsToFilter (optional) 
     * @param createdDateFromFilter (optional) 
     * @param createdDateToFilter (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getStreetlightAssetsToExcel(organizationUnitIdFilter: number | undefined, regionIdFilter: number | undefined, lightingTypeIdFilter: number | undefined, serviceProviderIdFilter: number | undefined, operationalStatusFilter: number | undefined, tarshidRetrofitFilter: boolean | undefined, yearBuiltFromFilter: string | undefined, yearBuiltToFilter: string | undefined, lastRetrofitYearFromFilter: string | undefined, lastRetrofitYearToFilter: string | undefined, numberOfStreetlightsFromFilter: number | undefined, numberOfStreetlightsToFilter: number | undefined, createdDateFromFilter: DateTime | undefined, createdDateToFilter: DateTime | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/StreetlightAssetInfos/GetStreetlightAssetsToExcel?";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (regionIdFilter === null)
            throw new Error("The parameter 'regionIdFilter' cannot be null.");
        else if (regionIdFilter !== undefined)
            url_ += "RegionIdFilter=" + encodeURIComponent("" + regionIdFilter) + "&";
        if (lightingTypeIdFilter === null)
            throw new Error("The parameter 'lightingTypeIdFilter' cannot be null.");
        else if (lightingTypeIdFilter !== undefined)
            url_ += "LightingTypeIdFilter=" + encodeURIComponent("" + lightingTypeIdFilter) + "&";
        if (serviceProviderIdFilter === null)
            throw new Error("The parameter 'serviceProviderIdFilter' cannot be null.");
        else if (serviceProviderIdFilter !== undefined)
            url_ += "ServiceProviderIdFilter=" + encodeURIComponent("" + serviceProviderIdFilter) + "&";
        if (operationalStatusFilter === null)
            throw new Error("The parameter 'operationalStatusFilter' cannot be null.");
        else if (operationalStatusFilter !== undefined)
            url_ += "OperationalStatusFilter=" + encodeURIComponent("" + operationalStatusFilter) + "&";
        if (tarshidRetrofitFilter === null)
            throw new Error("The parameter 'tarshidRetrofitFilter' cannot be null.");
        else if (tarshidRetrofitFilter !== undefined)
            url_ += "TarshidRetrofitFilter=" + encodeURIComponent("" + tarshidRetrofitFilter) + "&";
        if (yearBuiltFromFilter === null)
            throw new Error("The parameter 'yearBuiltFromFilter' cannot be null.");
        else if (yearBuiltFromFilter !== undefined)
            url_ += "YearBuiltFromFilter=" + encodeURIComponent("" + yearBuiltFromFilter) + "&";
        if (yearBuiltToFilter === null)
            throw new Error("The parameter 'yearBuiltToFilter' cannot be null.");
        else if (yearBuiltToFilter !== undefined)
            url_ += "YearBuiltToFilter=" + encodeURIComponent("" + yearBuiltToFilter) + "&";
        if (lastRetrofitYearFromFilter === null)
            throw new Error("The parameter 'lastRetrofitYearFromFilter' cannot be null.");
        else if (lastRetrofitYearFromFilter !== undefined)
            url_ += "LastRetrofitYearFromFilter=" + encodeURIComponent("" + lastRetrofitYearFromFilter) + "&";
        if (lastRetrofitYearToFilter === null)
            throw new Error("The parameter 'lastRetrofitYearToFilter' cannot be null.");
        else if (lastRetrofitYearToFilter !== undefined)
            url_ += "LastRetrofitYearToFilter=" + encodeURIComponent("" + lastRetrofitYearToFilter) + "&";
        if (numberOfStreetlightsFromFilter === null)
            throw new Error("The parameter 'numberOfStreetlightsFromFilter' cannot be null.");
        else if (numberOfStreetlightsFromFilter !== undefined)
            url_ += "NumberOfStreetlightsFromFilter=" + encodeURIComponent("" + numberOfStreetlightsFromFilter) + "&";
        if (numberOfStreetlightsToFilter === null)
            throw new Error("The parameter 'numberOfStreetlightsToFilter' cannot be null.");
        else if (numberOfStreetlightsToFilter !== undefined)
            url_ += "NumberOfStreetlightsToFilter=" + encodeURIComponent("" + numberOfStreetlightsToFilter) + "&";
        if (createdDateFromFilter === null)
            throw new Error("The parameter 'createdDateFromFilter' cannot be null.");
        else if (createdDateFromFilter !== undefined)
            url_ += "CreatedDateFromFilter=" + encodeURIComponent(createdDateFromFilter ? "" + createdDateFromFilter.toString() : "") + "&";
        if (createdDateToFilter === null)
            throw new Error("The parameter 'createdDateToFilter' cannot be null.");
        else if (createdDateToFilter !== undefined)
            url_ += "CreatedDateToFilter=" + encodeURIComponent(createdDateToFilter ? "" + createdDateToFilter.toString() : "") + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStreetlightAssetsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStreetlightAssetsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetStreetlightAssetsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubActivitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param mainActivityName_ArFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, mainActivityName_ArFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSubActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SubActivities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (mainActivityName_ArFilter === null)
            throw new Error("The parameter 'mainActivityName_ArFilter' cannot be null.");
        else if (mainActivityName_ArFilter !== undefined)
            url_ += "MainActivityName_ArFilter=" + encodeURIComponent("" + mainActivityName_ArFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetSubActivityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetSubActivityForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSubActivityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSubActivityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSubActivityForView(id: number | undefined): Observable<GetSubActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SubActivities/GetSubActivityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubActivityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubActivityForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubActivityForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubActivityForViewDto>;
        }));
    }

    protected processGetSubActivityForView(response: HttpResponseBase): Observable<GetSubActivityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubActivityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSubActivityForEdit(id: number | undefined): Observable<GetSubActivityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SubActivities/GetSubActivityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubActivityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubActivityForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubActivityForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubActivityForEditOutput>;
        }));
    }

    protected processGetSubActivityForEdit(response: HttpResponseBase): Observable<GetSubActivityForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubActivityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSubActivityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubActivities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubActivities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllMainActivityForTableDropdown(): Observable<SubActivityMainActivityLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SubActivities/GetAllMainActivityForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMainActivityForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMainActivityForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubActivityMainActivityLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubActivityMainActivityLookupTableDto[]>;
        }));
    }

    protected processGetAllMainActivityForTableDropdown(response: HttpResponseBase): Observable<SubActivityMainActivityLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubActivityMainActivityLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TeamMembersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUsers(body: GetUsersInput | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @param editUserId (optional) 
     * @return Success
     */
    getMemberRequestForEdit(requestId: number | undefined, editUserId: number | undefined): Observable<GetMemberRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/GetMemberRequestForEdit?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (editUserId === null)
            throw new Error("The parameter 'editUserId' cannot be null.");
        else if (editUserId !== undefined)
            url_ += "editUserId=" + encodeURIComponent("" + editUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberRequestForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberRequestForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMemberRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMemberRequestForEditOutput>;
        }));
    }

    protected processGetMemberRequestForEdit(response: HttpResponseBase): Observable<GetMemberRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGovCurrentUserRole(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/GetGovCurrentUserRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGovCurrentUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGovCurrentUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetGovCurrentUserRole(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationUnitId (optional) 
     * @return Success
     */
    getOrgTeamLeadId(organizationUnitId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/GetOrgTeamLeadId?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgTeamLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgTeamLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetOrgTeamLeadId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditMemberRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: CreateOrEditMemberRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitForTierA(body: CreateOrEditMemberRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/SubmitForTierA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitForTierA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitForTierA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmitForTierA(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadNewAttachment(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/UploadNewAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadNewAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadNewAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadNewAttachment(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationTypeId (optional) 
     * @param roleNames (optional) 
     * @return Success
     */
    getOrganizationTypeRoles(organizationTypeId: number | undefined, roleNames: string[] | undefined): Observable<UserRoleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/GetOrganizationTypeRoles?";
        if (organizationTypeId === null)
            throw new Error("The parameter 'organizationTypeId' cannot be null.");
        else if (organizationTypeId !== undefined)
            url_ += "OrganizationTypeId=" + encodeURIComponent("" + organizationTypeId) + "&";
        if (roleNames === null)
            throw new Error("The parameter 'roleNames' cannot be null.");
        else if (roleNames !== undefined)
            roleNames && roleNames.forEach(item => { url_ += "RoleNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationTypeRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationTypeRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto[]>;
        }));
    }

    protected processGetOrganizationTypeRoles(response: HttpResponseBase): Observable<UserRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestType (optional) 
     * @param body (optional) 
     * @return Success
     */
    checkRedundantUser(requestType: number | undefined, body: MemberDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/CheckRedundantUser?";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckRedundantUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckRedundantUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckRedundantUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveTeamMemberRequest(body: RequestInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/ApproveTeamMemberRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveTeamMemberRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveTeamMemberRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveTeamMemberRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectTeamMemberRequest(body: RequestInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TeamMembers/RejectTeamMemberRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectTeamMemberRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectTeamMemberRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectTeamMemberRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTenants(filter: string | undefined, subscriptionEndDateStart: DateTime | undefined, subscriptionEndDateEnd: DateTime | undefined, creationDateStart: DateTime | undefined, creationDateEnd: DateTime | undefined, editionId: number | undefined, editionIdSpecified: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart === null)
            throw new Error("The parameter 'subscriptionEndDateStart' cannot be null.");
        else if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toString() : "") + "&";
        if (subscriptionEndDateEnd === null)
            throw new Error("The parameter 'subscriptionEndDateEnd' cannot be null.");
        else if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toString() : "") + "&";
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toString() : "") + "&";
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toString() : "") + "&";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListDto>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantEditDto>;
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getTenantLogo(skin: string, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/TenantCustomization/GetTenantLogo/{skin}/{tenantId}?";
        if (skin === undefined || skin === null)
            throw new Error("The parameter 'skin' must be defined.");
        url_ = url_.replace("{skin}", encodeURIComponent("" + skin));
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTenantLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMemberActivityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMemberActivityOutput>;
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardDataOutput>;
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTopStats(): Observable<GetTopStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTopStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTopStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTopStatsOutput>;
        }));
    }

    protected processGetTopStats(response: HttpResponseBase): Observable<GetTopStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTopStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfitShare(): Observable<GetProfitShareOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProfitShare";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfitShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfitShare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfitShareOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfitShareOutput>;
        }));
    }

    protected processGetProfitShare(response: HttpResponseBase): Observable<GetProfitShareOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfitShareOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDailySales(): Observable<GetDailySalesOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailySales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailySales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailySales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDailySalesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDailySalesOutput>;
        }));
    }

    protected processGetDailySales(response: HttpResponseBase): Observable<GetDailySalesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDailySalesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesSummaryOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesSummaryOutput>;
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRegionalStats(): Observable<GetRegionalStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionalStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionalStatsOutput>;
        }));
    }

    protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionalStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGeneralStats(): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneralStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneralStatsOutput>;
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterTenantOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterTenantOutput>;
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionsSelectOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionsSelectOutput>;
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionSelectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionSelectDto>;
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSeecSettings(): Observable<SeecSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetSeecSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeecSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeecSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeecSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeecSettingsEditDto>;
        }));
    }

    protected processGetSeecSettings(response: HttpResponseBase): Observable<SeecSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeecSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInactiveEntitiesSeecSettings(body: SeecSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateInactiveEntitiesSeecSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInactiveEntitiesSeecSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInactiveEntitiesSeecSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInactiveEntitiesSeecSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param kwhPrice (optional) 
     * @return Success
     */
    updateElectricityConsumptionUnitSettings(kwhPrice: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateElectricityConsumptionUnitSettings?";
        if (kwhPrice === null)
            throw new Error("The parameter 'kwhPrice' cannot be null.");
        else if (kwhPrice !== undefined)
            url_ += "KwhPrice=" + encodeURIComponent("" + kwhPrice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateElectricityConsumptionUnitSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateElectricityConsumptionUnitSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateElectricityConsumptionUnitSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param noOfDaysForGovRequestAutoApproval (optional) 
     * @return Success
     */
    updateNoOfDaysForGovRequestAutoApprovalSettings(noOfDaysForGovRequestAutoApproval: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateNoOfDaysForGovRequestAutoApprovalSettings?";
        if (noOfDaysForGovRequestAutoApproval === null)
            throw new Error("The parameter 'noOfDaysForGovRequestAutoApproval' cannot be null.");
        else if (noOfDaysForGovRequestAutoApproval !== undefined)
            url_ += "NoOfDaysForGovRequestAutoApproval=" + encodeURIComponent("" + noOfDaysForGovRequestAutoApproval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNoOfDaysForGovRequestAutoApprovalSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNoOfDaysForGovRequestAutoApprovalSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNoOfDaysForGovRequestAutoApprovalSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TestApiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    index(): Observable<void> {
        let url_ = this.baseUrl + "/api/TestApi/Index";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIndex(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
        else
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId === null)
            throw new Error("The parameter 'selectedTimezoneId' cannot be null.");
        else if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticateByIdentificationNumber(body: IdentificationAuthModel | undefined): Observable<IdentitifcationAuthResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateByIdentificationNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateByIdentificationNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateByIdentificationNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentitifcationAuthResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentitifcationAuthResultModel>;
        }));
    }

    protected processAuthenticateByIdentificationNumber(response: HttpResponseBase): Observable<IdentitifcationAuthResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentitifcationAuthResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyIdentificationOtp(body: VerifyIdentificationOtpModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyIdentificationOtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyIdentificationOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyIdentificationOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processVerifyIdentificationOtp(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendIdentificationOtp(body: number | undefined): Observable<IdentitifcationAuthResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ResendIdentificationOtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendIdentificationOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendIdentificationOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentitifcationAuthResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentitifcationAuthResultModel>;
        }));
    }

    protected processResendIdentificationOtp(response: HttpResponseBase): Observable<IdentitifcationAuthResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentitifcationAuthResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    nafathLoginUrl(): Observable<NafathLoginUrlResponse> {
        let url_ = this.baseUrl + "/api/TokenAuth/NafathLoginUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNafathLoginUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNafathLoginUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NafathLoginUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NafathLoginUrlResponse>;
        }));
    }

    protected processNafathLoginUrl(response: HttpResponseBase): Observable<NafathLoginUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NafathLoginUrlResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param state (optional) 
     * @return Success
     */
    nafathCallback(state: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/NafathCallback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (state === null || state === undefined)
            throw new Error("The parameter 'state' cannot be null.");
        else
            content_.append("State", state.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNafathCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNafathCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNafathCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param hashedState (optional) 
     * @return Success
     */
    nafathStatus(hashedState: string | undefined): Observable<NafathStatusResponse> {
        let url_ = this.baseUrl + "/api/TokenAuth/NafathStatus?";
        if (hashedState === null)
            throw new Error("The parameter 'hashedState' cannot be null.");
        else if (hashedState !== undefined)
            url_ += "hashedState=" + encodeURIComponent("" + hashedState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNafathStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNafathStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NafathStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NafathStatusResponse>;
        }));
    }

    protected processNafathStatus(response: HttpResponseBase): Observable<NafathStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NafathStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    nafathExchange(body: NafathExchangeInput | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/NafathExchange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNafathExchange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNafathExchange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processNafathExchange(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refreshToken (optional) 
     * @return Success
     */
    refreshToken(refreshToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken === null)
            throw new Error("The parameter 'refreshToken' cannot be null.");
        else if (refreshToken !== undefined)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken === null)
            throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    openPowerBi(token: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/OpenPowerBi?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenPowerBi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenPowerBi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpenPowerBi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userDelegationId (optional) 
     * @param impersonationToken (optional) 
     * @return Success
     */
    delegatedImpersonatedAuthenticate(userDelegationId: number | undefined, impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/DelegatedImpersonatedAuthenticate?";
        if (userDelegationId === null)
            throw new Error("The parameter 'userDelegationId' cannot be null.");
        else if (userDelegationId !== undefined)
            url_ += "userDelegationId=" + encodeURIComponent("" + userDelegationId) + "&";
        if (impersonationToken === null)
            throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processDelegatedImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken === null)
            throw new Error("The parameter 'switchAccountToken' cannot be null.");
        else if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchedAccountAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchedAccountAuthenticateResultModel>;
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param message (optional) 
     * @param severity (optional) 
     * @return Success
     */
    testNotification(message: string | undefined, severity: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity === null)
            throw new Error("The parameter 'severity' cannot be null.");
        else if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validatePToken(body: BIRequestModel | undefined): Observable<BIResponseModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ValidatePToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BIResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BIResponseModel>;
        }));
    }

    protected processValidatePToken(response: HttpResponseBase): Observable<BIResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BIResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TopicsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param topicNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, topicNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTopicForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Topics/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (topicNameFilter === null)
            throw new Error("The parameter 'topicNameFilter' cannot be null.");
        else if (topicNameFilter !== undefined)
            url_ += "TopicNameFilter=" + encodeURIComponent("" + topicNameFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTopicForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTopicForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTopicForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTopicForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTopicForView(id: number | undefined): Observable<GetTopicForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Topics/GetTopicForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopicForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopicForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTopicForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTopicForViewDto>;
        }));
    }

    protected processGetTopicForView(response: HttpResponseBase): Observable<GetTopicForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTopicForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTopicForEdit(id: number | undefined): Observable<GetTopicForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Topics/GetTopicForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopicForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopicForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTopicForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTopicForEditOutput>;
        }));
    }

    protected processGetTopicForEdit(response: HttpResponseBase): Observable<GetTopicForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTopicForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTopicDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Topics/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Topics/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrainingPackageRequestsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: CreateOrEditTrainingPackageRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackageRequests/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param organizationIdFilter (optional) 
     * @param requestNumberFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param onlyAssignedToMeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, organizationIdFilter: number | undefined, requestNumberFilter: string | undefined, requestStatusIdFilter: RequestStatusEnum | undefined, onlyAssignedToMeFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTrainingPackageRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackageRequests/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (onlyAssignedToMeFilter === null)
            throw new Error("The parameter 'onlyAssignedToMeFilter' cannot be null.");
        else if (onlyAssignedToMeFilter !== undefined)
            url_ += "OnlyAssignedToMeFilter=" + encodeURIComponent("" + onlyAssignedToMeFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTrainingPackageRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTrainingPackageRequestForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTrainingPackageRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTrainingPackageRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param requestId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getExpectedSessionDataList(filter: string | undefined, requestId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTrainingPackageDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackageRequests/GetExpectedSessionDataList?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "RequestId=" + encodeURIComponent("" + requestId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpectedSessionDataList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpectedSessionDataList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTrainingPackageDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTrainingPackageDetailsDto>;
        }));
    }

    protected processGetExpectedSessionDataList(response: HttpResponseBase): Observable<PagedResultDtoOfTrainingPackageDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTrainingPackageDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getTrainingPackageRequestForEdit(requestId: number | undefined): Observable<GetTrainingPackageRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackageRequests/GetTrainingPackageRequestForEdit?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingPackageRequestForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingPackageRequestForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrainingPackageRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrainingPackageRequestForEditOutput>;
        }));
    }

    protected processGetTrainingPackageRequestForEdit(response: HttpResponseBase): Observable<GetTrainingPackageRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrainingPackageRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getTrainingPackageRequestForView(requestId: number | undefined): Observable<GetTrainingPackageRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackageRequests/GetTrainingPackageRequestForView?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingPackageRequestForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingPackageRequestForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrainingPackageRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrainingPackageRequestForViewDto>;
        }));
    }

    protected processGetTrainingPackageRequestForView(response: HttpResponseBase): Observable<GetTrainingPackageRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrainingPackageRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackageRequests/GetMyTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMyTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrainingPackagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTrainingPackageForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackages/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTrainingPackageForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTrainingPackageForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTrainingPackageForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTrainingPackageForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTrainingPackageForEdit(id: number | undefined): Observable<GetTrainingPackageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackages/GetTrainingPackageForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingPackageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingPackageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrainingPackageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrainingPackageForEditOutput>;
        }));
    }

    protected processGetTrainingPackageForEdit(response: HttpResponseBase): Observable<GetTrainingPackageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrainingPackageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTrainingPackageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackages/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackages/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetTrainingPackageForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackages/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrainingPackageForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrainingPackageForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetTrainingPackageForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrainingPackageForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadAttachment(body: MediaLibraryInputDto | undefined): Observable<MediaLibraryOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingPackages/UploadAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaLibraryOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaLibraryOutputDto>;
        }));
    }

    protected processUploadAttachment(response: HttpResponseBase): Observable<MediaLibraryOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaLibraryOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrainingRequestsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMyTaskCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetMyTaskCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyTaskCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyTaskCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMyTaskCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reservedSeatsFilter (optional) 
     * @param organizationIdFilter (optional) 
     * @param requestNumberFilter (optional) 
     * @param sectorFilter (optional) 
     * @param requestStatusIdFilter (optional) 
     * @param onlyAssignedToMeFilter (optional) 
     * @param currentUnitIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(reservedSeatsFilter: number | undefined, organizationIdFilter: number | undefined, requestNumberFilter: string | undefined, sectorFilter: number | undefined, requestStatusIdFilter: number | undefined, onlyAssignedToMeFilter: boolean | undefined, currentUnitIdFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTrainingRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetAll?";
        if (reservedSeatsFilter === null)
            throw new Error("The parameter 'reservedSeatsFilter' cannot be null.");
        else if (reservedSeatsFilter !== undefined)
            url_ += "ReservedSeatsFilter=" + encodeURIComponent("" + reservedSeatsFilter) + "&";
        if (organizationIdFilter === null)
            throw new Error("The parameter 'organizationIdFilter' cannot be null.");
        else if (organizationIdFilter !== undefined)
            url_ += "OrganizationIdFilter=" + encodeURIComponent("" + organizationIdFilter) + "&";
        if (requestNumberFilter === null)
            throw new Error("The parameter 'requestNumberFilter' cannot be null.");
        else if (requestNumberFilter !== undefined)
            url_ += "RequestNumberFilter=" + encodeURIComponent("" + requestNumberFilter) + "&";
        if (sectorFilter === null)
            throw new Error("The parameter 'sectorFilter' cannot be null.");
        else if (sectorFilter !== undefined)
            url_ += "SectorFilter=" + encodeURIComponent("" + sectorFilter) + "&";
        if (requestStatusIdFilter === null)
            throw new Error("The parameter 'requestStatusIdFilter' cannot be null.");
        else if (requestStatusIdFilter !== undefined)
            url_ += "RequestStatusIdFilter=" + encodeURIComponent("" + requestStatusIdFilter) + "&";
        if (onlyAssignedToMeFilter === null)
            throw new Error("The parameter 'onlyAssignedToMeFilter' cannot be null.");
        else if (onlyAssignedToMeFilter !== undefined)
            url_ += "OnlyAssignedToMeFilter=" + encodeURIComponent("" + onlyAssignedToMeFilter) + "&";
        if (currentUnitIdFilter === null)
            throw new Error("The parameter 'currentUnitIdFilter' cannot be null.");
        else if (currentUnitIdFilter !== undefined)
            url_ += "CurrentUnitIdFilter=" + encodeURIComponent("" + currentUnitIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTrainingRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTrainingRequestForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTrainingRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTrainingRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDateFilter (optional) 
     * @param startTimeFilter (optional) 
     * @param endDateFilter (optional) 
     * @param endTimeFilter (optional) 
     * @param registrationStartDateFilter (optional) 
     * @param registrationStartTimeFilter (optional) 
     * @param registrationEndDateFilter (optional) 
     * @param registrationEndTimeFilter (optional) 
     * @param cancellationDeadlineFilter (optional) 
     * @param availableSeatsFilter (optional) 
     * @param topicIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCourses(startDateFilter: DateTime | undefined, startTimeFilter: string | undefined, endDateFilter: DateTime | undefined, endTimeFilter: string | undefined, registrationStartDateFilter: DateTime | undefined, registrationStartTimeFilter: string | undefined, registrationEndDateFilter: DateTime | undefined, registrationEndTimeFilter: string | undefined, cancellationDeadlineFilter: number | undefined, availableSeatsFilter: number | undefined, topicIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCourseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetCourses?";
        if (startDateFilter === null)
            throw new Error("The parameter 'startDateFilter' cannot be null.");
        else if (startDateFilter !== undefined)
            url_ += "StartDateFilter=" + encodeURIComponent(startDateFilter ? "" + startDateFilter.toString() : "") + "&";
        if (startTimeFilter === null)
            throw new Error("The parameter 'startTimeFilter' cannot be null.");
        else if (startTimeFilter !== undefined)
            url_ += "StartTimeFilter=" + encodeURIComponent("" + startTimeFilter) + "&";
        if (endDateFilter === null)
            throw new Error("The parameter 'endDateFilter' cannot be null.");
        else if (endDateFilter !== undefined)
            url_ += "EndDateFilter=" + encodeURIComponent(endDateFilter ? "" + endDateFilter.toString() : "") + "&";
        if (endTimeFilter === null)
            throw new Error("The parameter 'endTimeFilter' cannot be null.");
        else if (endTimeFilter !== undefined)
            url_ += "EndTimeFilter=" + encodeURIComponent("" + endTimeFilter) + "&";
        if (registrationStartDateFilter === null)
            throw new Error("The parameter 'registrationStartDateFilter' cannot be null.");
        else if (registrationStartDateFilter !== undefined)
            url_ += "RegistrationStartDateFilter=" + encodeURIComponent(registrationStartDateFilter ? "" + registrationStartDateFilter.toString() : "") + "&";
        if (registrationStartTimeFilter === null)
            throw new Error("The parameter 'registrationStartTimeFilter' cannot be null.");
        else if (registrationStartTimeFilter !== undefined)
            url_ += "RegistrationStartTimeFilter=" + encodeURIComponent("" + registrationStartTimeFilter) + "&";
        if (registrationEndDateFilter === null)
            throw new Error("The parameter 'registrationEndDateFilter' cannot be null.");
        else if (registrationEndDateFilter !== undefined)
            url_ += "RegistrationEndDateFilter=" + encodeURIComponent(registrationEndDateFilter ? "" + registrationEndDateFilter.toString() : "") + "&";
        if (registrationEndTimeFilter === null)
            throw new Error("The parameter 'registrationEndTimeFilter' cannot be null.");
        else if (registrationEndTimeFilter !== undefined)
            url_ += "RegistrationEndTimeFilter=" + encodeURIComponent("" + registrationEndTimeFilter) + "&";
        if (cancellationDeadlineFilter === null)
            throw new Error("The parameter 'cancellationDeadlineFilter' cannot be null.");
        else if (cancellationDeadlineFilter !== undefined)
            url_ += "CancellationDeadlineFilter=" + encodeURIComponent("" + cancellationDeadlineFilter) + "&";
        if (availableSeatsFilter === null)
            throw new Error("The parameter 'availableSeatsFilter' cannot be null.");
        else if (availableSeatsFilter !== undefined)
            url_ += "AvailableSeatsFilter=" + encodeURIComponent("" + availableSeatsFilter) + "&";
        if (topicIdFilter === null)
            throw new Error("The parameter 'topicIdFilter' cannot be null.");
        else if (topicIdFilter !== undefined)
            url_ += "TopicIdFilter=" + encodeURIComponent("" + topicIdFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetCourseForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetCourseForViewDto>;
        }));
    }

    protected processGetCourses(response: HttpResponseBase): Observable<PagedResultDtoOfGetCourseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCourseForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getTrainingRequestForView(requestId: number | undefined): Observable<GetTrainingRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetTrainingRequestForView?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingRequestForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingRequestForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrainingRequestForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrainingRequestForViewDto>;
        }));
    }

    protected processGetTrainingRequestForView(response: HttpResponseBase): Observable<GetTrainingRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrainingRequestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTrainingRequestForEdit(id: number | undefined): Observable<GetTrainingRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetTrainingRequestForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingRequestForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingRequestForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrainingRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrainingRequestForEditOutput>;
        }));
    }

    protected processGetTrainingRequestForEdit(response: HttpResponseBase): Observable<GetTrainingRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrainingRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    getTrainingRequestDefaultData(courseId: number | undefined): Observable<GetTrainingRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetTrainingRequestDefaultData?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingRequestDefaultData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingRequestDefaultData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrainingRequestForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrainingRequestForEditOutput>;
        }));
    }

    protected processGetTrainingRequestDefaultData(response: HttpResponseBase): Observable<GetTrainingRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrainingRequestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param courseId (optional) 
     * @param trainngRequestId (optional) 
     * @return Success
     */
    getNumberOfAvailabeSeats(courseId: number | undefined, trainngRequestId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetNumberOfAvailabeSeats?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (trainngRequestId === null)
            throw new Error("The parameter 'trainngRequestId' cannot be null.");
        else if (trainngRequestId !== undefined)
            url_ += "trainngRequestId=" + encodeURIComponent("" + trainngRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfAvailabeSeats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfAvailabeSeats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberOfAvailabeSeats(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param iDNumber (optional) 
     * @param courseId (optional) 
     * @param trainngRequestId (optional) 
     * @return Success
     */
    checkIdNumberUniqnessForCourse(iDNumber: string | undefined, courseId: number | undefined, trainngRequestId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/CheckIdNumberUniqnessForCourse?";
        if (iDNumber === null)
            throw new Error("The parameter 'iDNumber' cannot be null.");
        else if (iDNumber !== undefined)
            url_ += "IDNumber=" + encodeURIComponent("" + iDNumber) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (trainngRequestId === null)
            throw new Error("The parameter 'trainngRequestId' cannot be null.");
        else if (trainngRequestId !== undefined)
            url_ += "trainngRequestId=" + encodeURIComponent("" + trainngRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIdNumberUniqnessForCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIdNumberUniqnessForCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIdNumberUniqnessForCourse(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    courseRegisterationBussinessCheck(courseId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/CourseRegisterationBussinessCheck?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCourseRegisterationBussinessCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCourseRegisterationBussinessCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCourseRegisterationBussinessCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    courseRegisterationEndIsDue(courseId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/CourseRegisterationEndIsDue?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCourseRegisterationEndIsDue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCourseRegisterationEndIsDue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCourseRegisterationEndIsDue(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTrainingRequestDto | undefined): Observable<TrainingRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingRequestDto>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<TrainingRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    checkNewAttenaceRequestRules(courseId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/CheckNewAttenaceRequestRules?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckNewAttenaceRequestRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckNewAttenaceRequestRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckNewAttenaceRequestRules(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationId (optional) 
     * @param courseId (optional) 
     * @return Success
     */
    chekDuplicateData(organizationId: number | undefined, courseId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/ChekDuplicateData?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChekDuplicateData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChekDuplicateData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChekDuplicateData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationId (optional) 
     * @param courseId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    deleteDraftDataIfExists(organizationId: number | undefined, courseId: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/DeleteDraftDataIfExists?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "CourseId=" + encodeURIComponent("" + courseId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDraftDataIfExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDraftDataIfExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDraftDataIfExists(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateReservedSeats(body: CreateOrEditTrainingRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/UpdateReservedSeats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReservedSeats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReservedSeats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateReservedSeats(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submitDate (optional) 
     * @param body (optional) 
     * @return Success
     */
    submitRequest(submitDate: DateTime | undefined, body: CreateOrEditTrainingRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/SubmitRequest?";
        if (submitDate === null)
            throw new Error("The parameter 'submitDate' cannot be null.");
        else if (submitDate !== undefined)
            url_ += "SubmitDate=" + encodeURIComponent(submitDate ? "" + submitDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmitRequest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAttendeeInfo(body: CreateOrEditAttendeeInfoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/CreateAttendeeInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAttendeeInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAttendeeInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateAttendeeInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trainingRequestId (optional) 
     * @return Success
     */
    getCurrentAttendeeList(trainingRequestId: number | undefined): Observable<GetAttendeeInfoForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetCurrentAttendeeList?";
        if (trainingRequestId === null)
            throw new Error("The parameter 'trainingRequestId' cannot be null.");
        else if (trainingRequestId !== undefined)
            url_ += "TrainingRequestId=" + encodeURIComponent("" + trainingRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentAttendeeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentAttendeeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAttendeeInfoForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAttendeeInfoForViewDto[]>;
        }));
    }

    protected processGetCurrentAttendeeList(response: HttpResponseBase): Observable<GetAttendeeInfoForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAttendeeInfoForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationUnitForTableDropdown(): Observable<TrainingRequestOrganizationUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetAllOrganizationUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingRequestOrganizationUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingRequestOrganizationUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationUnitForTableDropdown(response: HttpResponseBase): Observable<TrainingRequestOrganizationUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingRequestOrganizationUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCourseForTableDropdown(): Observable<TrainingRequestCourseLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetAllCourseForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCourseForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCourseForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingRequestCourseLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingRequestCourseLookupTableDto[]>;
        }));
    }

    protected processGetAllCourseForTableDropdown(response: HttpResponseBase): Observable<TrainingRequestCourseLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingRequestCourseLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllRequestForTableDropdown(): Observable<TrainingRequestRequestLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrainingRequests/GetAllRequestForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRequestForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRequestForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingRequestRequestLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingRequestRequestLookupTableDto[]>;
        }));
    }

    protected processGetAllRequestForTableDropdown(response: HttpResponseBase): Observable<TrainingRequestRequestLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingRequestRequestLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TwitterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRequestToken(): Observable<TwitterGetRequestTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetRequestToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetRequestTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetRequestTokenResponse>;
        }));
    }

    protected processGetRequestToken(response: HttpResponseBase): Observable<TwitterGetRequestTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetRequestTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param verifier (optional) 
     * @return Success
     */
    getAccessToken(token: string | undefined, verifier: string | undefined): Observable<TwitterGetAccessTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetAccessToken?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (verifier === null)
            throw new Error("The parameter 'verifier' cannot be null.");
        else if (verifier !== undefined)
            url_ += "verifier=" + encodeURIComponent("" + verifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetAccessTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetAccessTokenResponse>;
        }));
    }

    protected processGetAccessToken(response: HttpResponseBase): Observable<TwitterGetAccessTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetAccessTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeSettingsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeSettingsDto[]>;
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param themeName (optional) 
     * @return Success
     */
    changeThemeWithDefaultValues(themeName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName === null)
            throw new Error("The parameter 'themeName' cannot be null.");
        else if (themeName !== undefined)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUsers(body: GetUsersInput | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationTypeId (optional) 
     * @param sectorId (optional) 
     * @param organizationUnitId (optional) 
     * @param role (optional) 
     * @param sectorsIds (optional) 
     * @param isActive (optional) 
     * @param userName (optional) 
     * @param fullName (optional) 
     * @param phoneNumber (optional) 
     * @param sorting (optional) 
     * @param identificationNumber (optional) 
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param onlyLockedUsers (optional) 
     * @param emailAddress (optional) 
     * @param excludeRoleId (optional) 
     * @param isCurrentUserTechAdmin (optional) 
     * @param filterUnitIds (optional) 
     * @param filterSectorIds (optional) 
     * @return Success
     */
    getUsersToExcel(organizationTypeId: number | undefined, sectorId: number | undefined, organizationUnitId: number | undefined, role: number | undefined, sectorsIds: string[] | undefined, isActive: boolean | undefined, userName: string | undefined, fullName: string | undefined, phoneNumber: string | undefined, sorting: string | undefined, identificationNumber: string | undefined, filter: string | undefined, permissions: string[] | undefined, onlyLockedUsers: boolean | undefined, emailAddress: string | undefined, excludeRoleId: number | undefined, isCurrentUserTechAdmin: boolean | undefined, filterUnitIds: string[] | undefined, filterSectorIds: string[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (organizationTypeId === null)
            throw new Error("The parameter 'organizationTypeId' cannot be null.");
        else if (organizationTypeId !== undefined)
            url_ += "OrganizationTypeId=" + encodeURIComponent("" + organizationTypeId) + "&";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "SectorId=" + encodeURIComponent("" + sectorId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (sectorsIds === null)
            throw new Error("The parameter 'sectorsIds' cannot be null.");
        else if (sectorsIds !== undefined)
            sectorsIds && sectorsIds.forEach(item => { url_ += "SectorsIds=" + encodeURIComponent("" + item) + "&"; });
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (fullName === null)
            throw new Error("The parameter 'fullName' cannot be null.");
        else if (fullName !== undefined)
            url_ += "FullName=" + encodeURIComponent("" + fullName) + "&";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (identificationNumber === null)
            throw new Error("The parameter 'identificationNumber' cannot be null.");
        else if (identificationNumber !== undefined)
            url_ += "IdentificationNumber=" + encodeURIComponent("" + identificationNumber) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (excludeRoleId === null)
            throw new Error("The parameter 'excludeRoleId' cannot be null.");
        else if (excludeRoleId !== undefined)
            url_ += "ExcludeRoleId=" + encodeURIComponent("" + excludeRoleId) + "&";
        if (isCurrentUserTechAdmin === null)
            throw new Error("The parameter 'isCurrentUserTechAdmin' cannot be null.");
        else if (isCurrentUserTechAdmin !== undefined)
            url_ += "IsCurrentUserTechAdmin=" + encodeURIComponent("" + isCurrentUserTechAdmin) + "&";
        if (filterUnitIds === null)
            throw new Error("The parameter 'filterUnitIds' cannot be null.");
        else if (filterUnitIds !== undefined)
            filterUnitIds && filterUnitIds.forEach(item => { url_ += "FilterUnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterSectorIds === null)
            throw new Error("The parameter 'filterSectorIds' cannot be null.");
        else if (filterSectorIds !== undefined)
            filterSectorIds && filterSectorIds.forEach(item => { url_ += "FilterSectorIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTecAdminUserListFilter(): Observable<TechAdminUserListFilter> {
        let url_ = this.baseUrl + "/api/services/app/User/GetTecAdminUserListFilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTecAdminUserListFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTecAdminUserListFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TechAdminUserListFilter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TechAdminUserListFilter>;
        }));
    }

    protected processGetTecAdminUserListFilter(response: HttpResponseBase): Observable<TechAdminUserListFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TechAdminUserListFilter.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserForView(userId: number | undefined): Observable<GetUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForView?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForViewDto>;
        }));
    }

    protected processGetUserForView(response: HttpResponseBase): Observable<GetUserForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationUnitId (optional) 
     * @return Success
     */
    getUsersByOrganizationId(organizationUnitId: number | undefined): Observable<GetUserForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersByOrganizationId?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByOrganizationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByOrganizationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForViewDto[]>;
        }));
    }

    protected processGetUsersByOrganizationId(response: HttpResponseBase): Observable<GetUserForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserSectors(userId: number | undefined): Observable<UserSectorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserSectors?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSectorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSectorDto[]>;
        }));
    }

    protected processGetUserSectors(response: HttpResponseBase): Observable<UserSectorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSectorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSectorsByUserType(): Observable<UserSectorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetSectorsByUserType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSectorsByUserType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSectorsByUserType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSectorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSectorDto[]>;
        }));
    }

    protected processGetSectorsByUserType(response: HttpResponseBase): Observable<UserSectorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSectorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserRoles(): Observable<UserRoleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto[]>;
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<UserRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserRolesForProfile(userId: number | undefined): Observable<UserRoleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserRolesForProfile?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRolesForProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRolesForProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto[]>;
        }));
    }

    protected processGetUserRolesForProfile(response: HttpResponseBase): Observable<UserRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationUnitId (optional) 
     * @return Success
     */
    getOrgTeamLeadId(organizationUnitId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/GetOrgTeamLeadId?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrgTeamLeadId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrgTeamLeadId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetOrgTeamLeadId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateDeActivate(body: UserListDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ActivateDeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ActivateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deactivateUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeactivateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleName (optional) 
     * @return Success
     */
    getRoleIdByName(roleName: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoleIdByName?";
        if (roleName === null)
            throw new Error("The parameter 'roleName' cannot be null.");
        else if (roleName !== undefined)
            url_ += "RoleName=" + encodeURIComponent("" + roleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleIdByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleIdByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetRoleIdByName(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRelativeCurrentUserRole(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRelativeCurrentUserRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelativeCurrentUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelativeCurrentUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRelativeCurrentUserRole(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationTypeId (optional) 
     * @return Success
     */
    getOrganizationTypeUnits(organizationTypeId: number | undefined): Observable<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetOrganizationTypeUnits?";
        if (organizationTypeId === null)
            throw new Error("The parameter 'organizationTypeId' cannot be null.");
        else if (organizationTypeId !== undefined)
            url_ += "OrganizationTypeId=" + encodeURIComponent("" + organizationTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationTypeUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationTypeUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto[]>;
        }));
    }

    protected processGetOrganizationTypeUnits(response: HttpResponseBase): Observable<OrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationTypeId (optional) 
     * @param includeEmptyOption (optional) 
     * @param sectorIdsFilter (optional) 
     * @param currentUserSectorsFilter (optional) 
     * @return Success
     */
    getOrganizaitonUnitTreeNodes(organizationTypeId: number | undefined, includeEmptyOption: boolean | undefined, sectorIdsFilter: number[] | undefined, currentUserSectorsFilter: boolean | undefined): Observable<OrganizationUnitTreeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetOrganizaitonUnitTreeNodes?";
        if (organizationTypeId === null)
            throw new Error("The parameter 'organizationTypeId' cannot be null.");
        else if (organizationTypeId !== undefined)
            url_ += "OrganizationTypeId=" + encodeURIComponent("" + organizationTypeId) + "&";
        if (includeEmptyOption === null)
            throw new Error("The parameter 'includeEmptyOption' cannot be null.");
        else if (includeEmptyOption !== undefined)
            url_ += "includeEmptyOption=" + encodeURIComponent("" + includeEmptyOption) + "&";
        if (sectorIdsFilter === null)
            throw new Error("The parameter 'sectorIdsFilter' cannot be null.");
        else if (sectorIdsFilter !== undefined)
            sectorIdsFilter && sectorIdsFilter.forEach(item => { url_ += "SectorIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (currentUserSectorsFilter === null)
            throw new Error("The parameter 'currentUserSectorsFilter' cannot be null.");
        else if (currentUserSectorsFilter !== undefined)
            url_ += "CurrentUserSectorsFilter=" + encodeURIComponent("" + currentUserSectorsFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizaitonUnitTreeNodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizaitonUnitTreeNodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitTreeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitTreeModelDto>;
        }));
    }

    protected processGetOrganizaitonUnitTreeNodes(response: HttpResponseBase): Observable<OrganizationUnitTreeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitTreeModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizaitonUnitId (optional) 
     * @param organizaitonUnitTypeId (optional) 
     * @return Success
     */
    getUserOrganizationUnitTreeNode(organizaitonUnitId: number | undefined, organizaitonUnitTypeId: number | undefined): Observable<TreeNodesDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserOrganizationUnitTreeNode?";
        if (organizaitonUnitId === null)
            throw new Error("The parameter 'organizaitonUnitId' cannot be null.");
        else if (organizaitonUnitId !== undefined)
            url_ += "organizaitonUnitId=" + encodeURIComponent("" + organizaitonUnitId) + "&";
        if (organizaitonUnitTypeId === null)
            throw new Error("The parameter 'organizaitonUnitTypeId' cannot be null.");
        else if (organizaitonUnitTypeId !== undefined)
            url_ += "organizaitonUnitTypeId=" + encodeURIComponent("" + organizaitonUnitTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserOrganizationUnitTreeNode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserOrganizationUnitTreeNode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeNodesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeNodesDto>;
        }));
    }

    protected processGetUserOrganizationUnitTreeNode(response: HttpResponseBase): Observable<TreeNodesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeNodesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationTypeId (optional) 
     * @param includeSeecAdminRole (optional) 
     * @return Success
     */
    getOrganizationTypeRoles(organizationTypeId: number | undefined, includeSeecAdminRole: boolean | undefined): Observable<UserRoleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetOrganizationTypeRoles?";
        if (organizationTypeId === null)
            throw new Error("The parameter 'organizationTypeId' cannot be null.");
        else if (organizationTypeId !== undefined)
            url_ += "OrganizationTypeId=" + encodeURIComponent("" + organizationTypeId) + "&";
        if (includeSeecAdminRole === null)
            throw new Error("The parameter 'includeSeecAdminRole' cannot be null.");
        else if (includeSeecAdminRole !== undefined)
            url_ += "IncludeSeecAdminRole=" + encodeURIComponent("" + includeSeecAdminRole) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationTypeRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationTypeRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto[]>;
        }));
    }

    protected processGetOrganizationTypeRoles(response: HttpResponseBase): Observable<UserRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fillUserLatestAction(body: UserListDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/FillUserLatestAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillUserLatestAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillUserLatestAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFillUserLatestAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCurrentSeecTechsData(): Observable<SeecTechInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetCurrentSeecTechsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentSeecTechsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentSeecTechsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SeecTechInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SeecTechInfo[]>;
        }));
    }

    protected processGetCurrentSeecTechsData(response: HttpResponseBase): Observable<SeecTechInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeecTechInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDelegationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getDelegatedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfUserDelegationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetDelegatedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegatedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegatedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserDelegationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserDelegationDto>;
        }));
    }

    protected processGetDelegatedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserDelegationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserDelegationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delegateNewUser(body: CreateUserDelegationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/DelegateNewUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateNewUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateNewUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelegateNewUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeDelegation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/RemoveDelegation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDelegation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDelegation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveDelegation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getActiveUserDelegations(): Observable<UserDelegationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetActiveUserDelegations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUserDelegations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUserDelegations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDelegationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDelegationDto[]>;
        }));
    }

    protected processGetActiveUserDelegations(response: HttpResponseBase): Observable<UserDelegationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDelegationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param result (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserLoginAttempts(filter: string | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, result: AbpLoginResultType | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetUserLoginAttempts?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (result === null)
            throw new Error("The parameter 'result' cannot be null.");
        else if (result !== undefined)
            url_ += "Result=" + encodeURIComponent("" + result) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
        }));
    }

    protected processGetUserLoginAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserSectorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param userNameFilter (optional) 
     * @param sectorName_EnFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, userNameFilter: string | undefined, sectorName_EnFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetUserSectorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSectors/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userNameFilter === null)
            throw new Error("The parameter 'userNameFilter' cannot be null.");
        else if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&";
        if (sectorName_EnFilter === null)
            throw new Error("The parameter 'sectorName_EnFilter' cannot be null.");
        else if (sectorName_EnFilter !== undefined)
            url_ += "SectorName_EnFilter=" + encodeURIComponent("" + sectorName_EnFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetUserSectorForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetUserSectorForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUserSectorForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetUserSectorForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserSectorForView(id: number | undefined): Observable<GetUserSectorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSectors/GetUserSectorForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSectorForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSectorForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserSectorForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserSectorForViewDto>;
        }));
    }

    protected processGetUserSectorForView(response: HttpResponseBase): Observable<GetUserSectorForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserSectorForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserSectorForEdit(id: number | undefined): Observable<GetUserSectorForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserSectors/GetUserSectorForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSectorForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSectorForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserSectorForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserSectorForEditOutput>;
        }));
    }

    protected processGetUserSectorForEdit(response: HttpResponseBase): Observable<GetUserSectorForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserSectorForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditUserSectorDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserSectors/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserSectors/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param userNameFilter (optional) 
     * @param sectorName_EnFilter (optional) 
     * @return Success
     */
    getUserSectorsToExcel(filter: string | undefined, userNameFilter: string | undefined, sectorName_EnFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSectors/GetUserSectorsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userNameFilter === null)
            throw new Error("The parameter 'userNameFilter' cannot be null.");
        else if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&";
        if (sectorName_EnFilter === null)
            throw new Error("The parameter 'sectorName_EnFilter' cannot be null.");
        else if (sectorName_EnFilter !== undefined)
            url_ += "SectorName_EnFilter=" + encodeURIComponent("" + sectorName_EnFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSectorsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSectorsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUserSectorsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllUserForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfUserSectorUserLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSectors/GetAllUserForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserForLookupTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserSectorUserLookupTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserSectorUserLookupTableDto>;
        }));
    }

    protected processGetAllUserForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfUserSectorUserLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserSectorUserLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllSectorForTableDropdown(): Observable<UserSectorSectorLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserSectors/GetAllSectorForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSectorForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSectorForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSectorSectorLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSectorSectorLookupTableDto[]>;
        }));
    }

    protected processGetAllSectorForTableDropdown(response: HttpResponseBase): Observable<UserSectorSectorLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSectorSectorLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserSubmissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: CreateUserSubmissionDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UserSubmission/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeStatus(body: ChangeUserSubmissionStatusDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UserSubmission/ChangeStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processChangeStatus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetUserSubmissionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSubmission/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserSubmissionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserSubmissionForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetUserSubmissionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserSubmissionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param category (optional) 
     * @param status (optional) 
     * @param creationTime (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, category: number | undefined, status: number | undefined, creationTime: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetUserSubmissionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSubmission/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (creationTime === null)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetUserSubmissionForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetUserSubmissionForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUserSubmissionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetUserSubmissionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VehicleInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param structureNumberFilter (optional) 
     * @param manufacturingYearFilter (optional) 
     * @param fuelEconomyFilter (optional) 
     * @param organizationUnitIdFilter (optional) 
     * @param carModelName_ArFilter (optional) 
     * @param manufactureCompanyName_ArFilter (optional) 
     * @param fuelTypeName_ArFilter (optional) 
     * @param carModelFilterId (optional) 
     * @param manufactureCompanyFilterId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(structureNumberFilter: string | undefined, manufacturingYearFilter: number | undefined, fuelEconomyFilter: number | undefined, organizationUnitIdFilter: number | undefined, carModelName_ArFilter: string | undefined, manufactureCompanyName_ArFilter: string | undefined, fuelTypeName_ArFilter: string | undefined, carModelFilterId: number | undefined, manufactureCompanyFilterId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultExtendedDtoOfGetVehicleInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleInfos/GetAll?";
        if (structureNumberFilter === null)
            throw new Error("The parameter 'structureNumberFilter' cannot be null.");
        else if (structureNumberFilter !== undefined)
            url_ += "StructureNumberFilter=" + encodeURIComponent("" + structureNumberFilter) + "&";
        if (manufacturingYearFilter === null)
            throw new Error("The parameter 'manufacturingYearFilter' cannot be null.");
        else if (manufacturingYearFilter !== undefined)
            url_ += "ManufacturingYearFilter=" + encodeURIComponent("" + manufacturingYearFilter) + "&";
        if (fuelEconomyFilter === null)
            throw new Error("The parameter 'fuelEconomyFilter' cannot be null.");
        else if (fuelEconomyFilter !== undefined)
            url_ += "FuelEconomyFilter=" + encodeURIComponent("" + fuelEconomyFilter) + "&";
        if (organizationUnitIdFilter === null)
            throw new Error("The parameter 'organizationUnitIdFilter' cannot be null.");
        else if (organizationUnitIdFilter !== undefined)
            url_ += "OrganizationUnitIdFilter=" + encodeURIComponent("" + organizationUnitIdFilter) + "&";
        if (carModelName_ArFilter === null)
            throw new Error("The parameter 'carModelName_ArFilter' cannot be null.");
        else if (carModelName_ArFilter !== undefined)
            url_ += "CarModelName_ArFilter=" + encodeURIComponent("" + carModelName_ArFilter) + "&";
        if (manufactureCompanyName_ArFilter === null)
            throw new Error("The parameter 'manufactureCompanyName_ArFilter' cannot be null.");
        else if (manufactureCompanyName_ArFilter !== undefined)
            url_ += "ManufactureCompanyName_ArFilter=" + encodeURIComponent("" + manufactureCompanyName_ArFilter) + "&";
        if (fuelTypeName_ArFilter === null)
            throw new Error("The parameter 'fuelTypeName_ArFilter' cannot be null.");
        else if (fuelTypeName_ArFilter !== undefined)
            url_ += "FuelTypeName_ArFilter=" + encodeURIComponent("" + fuelTypeName_ArFilter) + "&";
        if (carModelFilterId === null)
            throw new Error("The parameter 'carModelFilterId' cannot be null.");
        else if (carModelFilterId !== undefined)
            url_ += "CarModelFilterId=" + encodeURIComponent("" + carModelFilterId) + "&";
        if (manufactureCompanyFilterId === null)
            throw new Error("The parameter 'manufactureCompanyFilterId' cannot be null.");
        else if (manufactureCompanyFilterId !== undefined)
            url_ += "ManufactureCompanyFilterId=" + encodeURIComponent("" + manufactureCompanyFilterId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultExtendedDtoOfGetVehicleInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultExtendedDtoOfGetVehicleInfoForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultExtendedDtoOfGetVehicleInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultExtendedDtoOfGetVehicleInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVehicleInfoForView(id: number | undefined): Observable<GetVehicleInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleInfos/GetVehicleInfoForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleInfoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleInfoForView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetVehicleInfoForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetVehicleInfoForViewDto>;
        }));
    }

    protected processGetVehicleInfoForView(response: HttpResponseBase): Observable<GetVehicleInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVehicleInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVehicleInfoForEdit(id: number | undefined): Observable<GetVehicleInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VehicleInfos/GetVehicleInfoForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleInfoForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetVehicleInfoForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetVehicleInfoForEditOutput>;
        }));
    }

    protected processGetVehicleInfoForEdit(response: HttpResponseBase): Observable<GetVehicleInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVehicleInfoForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditVehicleInfoDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VehicleInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VehicleInfos/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllOrganizationUnitForTableDropdown(): Observable<VehicleInfoOrganizationUnitLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VehicleInfos/GetAllOrganizationUnitForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationUnitForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationUnitForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleInfoOrganizationUnitLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleInfoOrganizationUnitLookupTableDto[]>;
        }));
    }

    protected processGetAllOrganizationUnitForTableDropdown(response: HttpResponseBase): Observable<VehicleInfoOrganizationUnitLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleInfoOrganizationUnitLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCarModelForTableDropdown(): Observable<VehicleInfoCarModelLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VehicleInfos/GetAllCarModelForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCarModelForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCarModelForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleInfoCarModelLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleInfoCarModelLookupTableDto[]>;
        }));
    }

    protected processGetAllCarModelForTableDropdown(response: HttpResponseBase): Observable<VehicleInfoCarModelLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleInfoCarModelLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllManufactureCompanyForTableDropdown(): Observable<VehicleInfoManufactureCompanyLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VehicleInfos/GetAllManufactureCompanyForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllManufactureCompanyForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllManufactureCompanyForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleInfoManufactureCompanyLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleInfoManufactureCompanyLookupTableDto[]>;
        }));
    }

    protected processGetAllManufactureCompanyForTableDropdown(response: HttpResponseBase): Observable<VehicleInfoManufactureCompanyLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleInfoManufactureCompanyLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllFuelTypeForTableDropdown(): Observable<VehicleInfoFuelTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VehicleInfos/GetAllFuelTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFuelTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFuelTypeForTableDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleInfoFuelTypeLookupTableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleInfoFuelTypeLookupTableDto[]>;
        }));
    }

    protected processGetAllFuelTypeForTableDropdown(response: HttpResponseBase): Observable<VehicleInfoFuelTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleInfoFuelTypeLookupTableDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param numberOfVehicles (optional) 
     * @return Success
     */
    updateNumberOfVehicles(id: number | undefined, numberOfVehicles: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VehicleInfos/UpdateNumberOfVehicles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (numberOfVehicles === null)
            throw new Error("The parameter 'numberOfVehicles' cannot be null.");
        else if (numberOfVehicles !== undefined)
            url_ += "numberOfVehicles=" + encodeURIComponent("" + numberOfVehicles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNumberOfVehicles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNumberOfVehicles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNumberOfVehicles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AboutSeecDto implements IAboutSeecDto {
    centerPrefDescription!: string | undefined;
    aboutProgramDescription!: string | undefined;
    technicalSideDescription!: string | undefined;
    awarenessSideDescription!: string | undefined;
    traningSideDescription!: string | undefined;
    isPublished!: boolean;
    publishedby!: UserViewDto;
    publishDate!: DateTime | undefined;
    version!: number;
    isLatest!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAboutSeecDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.centerPrefDescription = _data["centerPrefDescription"];
            this.aboutProgramDescription = _data["aboutProgramDescription"];
            this.technicalSideDescription = _data["technicalSideDescription"];
            this.awarenessSideDescription = _data["awarenessSideDescription"];
            this.traningSideDescription = _data["traningSideDescription"];
            this.isPublished = _data["isPublished"];
            this.publishedby = _data["publishedby"] ? UserViewDto.fromJS(_data["publishedby"]) : <any>undefined;
            this.publishDate = _data["publishDate"] ? DateTime.fromISO(_data["publishDate"].toString()) : <any>undefined;
            this.version = _data["version"];
            this.isLatest = _data["isLatest"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AboutSeecDto {
        data = typeof data === 'object' ? data : {};
        let result = new AboutSeecDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["centerPrefDescription"] = this.centerPrefDescription;
        data["aboutProgramDescription"] = this.aboutProgramDescription;
        data["technicalSideDescription"] = this.technicalSideDescription;
        data["awarenessSideDescription"] = this.awarenessSideDescription;
        data["traningSideDescription"] = this.traningSideDescription;
        data["isPublished"] = this.isPublished;
        data["publishedby"] = this.publishedby ? this.publishedby.toJSON() : <any>undefined;
        data["publishDate"] = this.publishDate ? this.publishDate.toString() : <any>undefined;
        data["version"] = this.version;
        data["isLatest"] = this.isLatest;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAboutSeecDto {
    centerPrefDescription: string | undefined;
    aboutProgramDescription: string | undefined;
    technicalSideDescription: string | undefined;
    awarenessSideDescription: string | undefined;
    traningSideDescription: string | undefined;
    isPublished: boolean;
    publishedby: UserViewDto;
    publishDate: DateTime | undefined;
    version: number;
    isLatest: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum AbpLoginResultType {
    Success = 1,
    InvalidUserNameOrEmailAddress = 2,
    InvalidPassword = 3,
    UserIsNotActive = 4,
    InvalidTenancyName = 5,
    TenantIsNotActive = 6,
    UserEmailIsNotConfirmed = 7,
    UnknownExternalLogin = 8,
    LockedOut = 9,
    UserPhoneNumberIsNotConfirmed = 10,
    FailedForOtherReason = 11,
}

export enum ActionType {
    All = 0,
    CreateAnotherUser = 1,
    EditAnotherUser = 2,
    DeleteAnotherUser = 3,
    UpdateProfile = 4,
    AcceptRequests = 5,
    RejectRequests = 6,
    CreateRequests = 7,
    UpdateRequests = 8,
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class AddNewPageInput implements IAddNewPageInput {
    dashboardName!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IAddNewPageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.name = _data["name"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): AddNewPageInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    }
}

export interface IAddNewPageInput {
    dashboardName: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class AddNewPageOutput implements IAddNewPageOutput {
    pageId!: string | undefined;

    constructor(data?: IAddNewPageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
        }
    }

    static fromJS(data: any): AddNewPageOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        return data;
    }
}

export interface IAddNewPageOutput {
    pageId: string | undefined;
}

export class AddWidgetInput implements IAddWidgetInput {
    widgetId!: string | undefined;
    pageId!: string | undefined;
    dashboardName!: string | undefined;
    width!: number;
    height!: number;
    application!: string | undefined;

    constructor(data?: IAddWidgetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.pageId = _data["pageId"];
            this.dashboardName = _data["dashboardName"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): AddWidgetInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddWidgetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["pageId"] = this.pageId;
        data["dashboardName"] = this.dashboardName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["application"] = this.application;
        return data;
    }
}

export interface IAddWidgetInput {
    widgetId: string | undefined;
    pageId: string | undefined;
    dashboardName: string | undefined;
    width: number;
    height: number;
    application: string | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: DateTime;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    userDelegationIsEnabled!: boolean;
    twoFactorCodeExpireSeconds!: number;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
            this.twoFactorCodeExpireSeconds = _data["twoFactorCodeExpireSeconds"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
        data["twoFactorCodeExpireSeconds"] = this.twoFactorCodeExpireSeconds;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: DateTime;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    userDelegationIsEnabled: boolean;
    twoFactorCodeExpireSeconds: number;
    features: { [key: string]: boolean; } | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverSiteUrl = _data["serverSiteUrl"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class AreaOfImprovementDto implements IAreaOfImprovementDto {
    parentId!: number | undefined;
    name_Ar!: string | undefined;
    name_En!: string | undefined;
    code!: string | undefined;
    isSubEntity!: boolean;
    isFuel!: boolean;
    parent_Name_Ar!: string | undefined;
    root_Name_Ar!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAreaOfImprovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.name_Ar = _data["name_Ar"];
            this.name_En = _data["name_En"];
            this.code = _data["code"];
            this.isSubEntity = _data["isSubEntity"];
            this.isFuel = _data["isFuel"];
            this.parent_Name_Ar = _data["parent_Name_Ar"];
            this.root_Name_Ar = _data["root_Name_Ar"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AreaOfImprovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaOfImprovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["name_Ar"] = this.name_Ar;
        data["name_En"] = this.name_En;
        data["code"] = this.code;
        data["isSubEntity"] = this.isSubEntity;
        data["isFuel"] = this.isFuel;
        data["parent_Name_Ar"] = this.parent_Name_Ar;
        data["root_Name_Ar"] = this.root_Name_Ar;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAreaOfImprovementDto {
    parentId: number | undefined;
    name_Ar: string | undefined;
    name_En: string | undefined;
    code: string | undefined;
    isSubEntity: boolean;
    isFuel: boolean;
    parent_Name_Ar: string | undefined;
    root_Name_Ar: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class AssetImportColumnValidationDto implements IAssetImportColumnValidationDto {
    columnIndex!: number;
    columnLetter!: string | undefined;
    expectedName!: string | undefined;
    actualHeader!: string | undefined;
    isPresent!: boolean;

    constructor(data?: IAssetImportColumnValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnIndex = _data["columnIndex"];
            this.columnLetter = _data["columnLetter"];
            this.expectedName = _data["expectedName"];
            this.actualHeader = _data["actualHeader"];
            this.isPresent = _data["isPresent"];
        }
    }

    static fromJS(data: any): AssetImportColumnValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportColumnValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnIndex"] = this.columnIndex;
        data["columnLetter"] = this.columnLetter;
        data["expectedName"] = this.expectedName;
        data["actualHeader"] = this.actualHeader;
        data["isPresent"] = this.isPresent;
        return data;
    }
}

export interface IAssetImportColumnValidationDto {
    columnIndex: number;
    columnLetter: string | undefined;
    expectedName: string | undefined;
    actualHeader: string | undefined;
    isPresent: boolean;
}

export class AssetImportInputDto implements IAssetImportInputDto {
    organizationUnitId!: number;
    fileContent!: string;
    fileName!: string | undefined;
    fileDescription!: string | undefined;
    bulkReferenceNumber!: string | undefined;

    constructor(data?: IAssetImportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.fileContent = _data["fileContent"];
            this.fileName = _data["fileName"];
            this.fileDescription = _data["fileDescription"];
            this.bulkReferenceNumber = _data["bulkReferenceNumber"];
        }
    }

    static fromJS(data: any): AssetImportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["fileContent"] = this.fileContent;
        data["fileName"] = this.fileName;
        data["fileDescription"] = this.fileDescription;
        data["bulkReferenceNumber"] = this.bulkReferenceNumber;
        return data;
    }
}

export interface IAssetImportInputDto {
    organizationUnitId: number;
    fileContent: string;
    fileName: string | undefined;
    fileDescription: string | undefined;
    bulkReferenceNumber: string | undefined;
}

export class AssetImportRowErrorDto implements IAssetImportRowErrorDto {
    sheet!: string | undefined;
    rowNumber!: number;
    errors!: string[] | undefined;

    constructor(data?: IAssetImportRowErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sheet = _data["sheet"];
            this.rowNumber = _data["rowNumber"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetImportRowErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportRowErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sheet"] = this.sheet;
        data["rowNumber"] = this.rowNumber;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IAssetImportRowErrorDto {
    sheet: string | undefined;
    rowNumber: number;
    errors: string[] | undefined;
}

export class AssetImportSheetValidationDto implements IAssetImportSheetValidationDto {
    sheetName!: string | undefined;
    sheetFound!: boolean;
    expectedColumnCount!: number;
    totalColumnsFound!: number;
    rowsFound!: number;
    validColumns!: AssetImportColumnValidationDto[] | undefined;
    missingColumns!: AssetImportColumnValidationDto[] | undefined;
    unexpectedColumns!: AssetImportColumnValidationDto[] | undefined;

    constructor(data?: IAssetImportSheetValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sheetName = _data["sheetName"];
            this.sheetFound = _data["sheetFound"];
            this.expectedColumnCount = _data["expectedColumnCount"];
            this.totalColumnsFound = _data["totalColumnsFound"];
            this.rowsFound = _data["rowsFound"];
            if (Array.isArray(_data["validColumns"])) {
                this.validColumns = [] as any;
                for (let item of _data["validColumns"])
                    this.validColumns!.push(AssetImportColumnValidationDto.fromJS(item));
            }
            if (Array.isArray(_data["missingColumns"])) {
                this.missingColumns = [] as any;
                for (let item of _data["missingColumns"])
                    this.missingColumns!.push(AssetImportColumnValidationDto.fromJS(item));
            }
            if (Array.isArray(_data["unexpectedColumns"])) {
                this.unexpectedColumns = [] as any;
                for (let item of _data["unexpectedColumns"])
                    this.unexpectedColumns!.push(AssetImportColumnValidationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetImportSheetValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportSheetValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sheetName"] = this.sheetName;
        data["sheetFound"] = this.sheetFound;
        data["expectedColumnCount"] = this.expectedColumnCount;
        data["totalColumnsFound"] = this.totalColumnsFound;
        data["rowsFound"] = this.rowsFound;
        if (Array.isArray(this.validColumns)) {
            data["validColumns"] = [];
            for (let item of this.validColumns)
                data["validColumns"].push(item.toJSON());
        }
        if (Array.isArray(this.missingColumns)) {
            data["missingColumns"] = [];
            for (let item of this.missingColumns)
                data["missingColumns"].push(item.toJSON());
        }
        if (Array.isArray(this.unexpectedColumns)) {
            data["unexpectedColumns"] = [];
            for (let item of this.unexpectedColumns)
                data["unexpectedColumns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetImportSheetValidationDto {
    sheetName: string | undefined;
    sheetFound: boolean;
    expectedColumnCount: number;
    totalColumnsFound: number;
    rowsFound: number;
    validColumns: AssetImportColumnValidationDto[] | undefined;
    missingColumns: AssetImportColumnValidationDto[] | undefined;
    unexpectedColumns: AssetImportColumnValidationDto[] | undefined;
}

export class AssetImportStructureValidationResultDto implements IAssetImportStructureValidationResultDto {
    bulkReferenceNumber!: string | undefined;
    organizationName!: string | undefined;
    uploadedBy!: string | undefined;
    totalSheetsExpected!: number;
    totalSheetsFound!: number;
    missingSheets!: string[] | undefined;
    sheetsValidation!: AssetImportSheetValidationDto[] | undefined;
    readonly allSheetsValid!: boolean;

    constructor(data?: IAssetImportStructureValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bulkReferenceNumber = _data["bulkReferenceNumber"];
            this.organizationName = _data["organizationName"];
            this.uploadedBy = _data["uploadedBy"];
            this.totalSheetsExpected = _data["totalSheetsExpected"];
            this.totalSheetsFound = _data["totalSheetsFound"];
            if (Array.isArray(_data["missingSheets"])) {
                this.missingSheets = [] as any;
                for (let item of _data["missingSheets"])
                    this.missingSheets!.push(item);
            }
            if (Array.isArray(_data["sheetsValidation"])) {
                this.sheetsValidation = [] as any;
                for (let item of _data["sheetsValidation"])
                    this.sheetsValidation!.push(AssetImportSheetValidationDto.fromJS(item));
            }
            (<any>this).allSheetsValid = _data["allSheetsValid"];
        }
    }

    static fromJS(data: any): AssetImportStructureValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportStructureValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bulkReferenceNumber"] = this.bulkReferenceNumber;
        data["organizationName"] = this.organizationName;
        data["uploadedBy"] = this.uploadedBy;
        data["totalSheetsExpected"] = this.totalSheetsExpected;
        data["totalSheetsFound"] = this.totalSheetsFound;
        if (Array.isArray(this.missingSheets)) {
            data["missingSheets"] = [];
            for (let item of this.missingSheets)
                data["missingSheets"].push(item);
        }
        if (Array.isArray(this.sheetsValidation)) {
            data["sheetsValidation"] = [];
            for (let item of this.sheetsValidation)
                data["sheetsValidation"].push(item.toJSON());
        }
        data["allSheetsValid"] = this.allSheetsValid;
        return data;
    }
}

export interface IAssetImportStructureValidationResultDto {
    bulkReferenceNumber: string | undefined;
    organizationName: string | undefined;
    uploadedBy: string | undefined;
    totalSheetsExpected: number;
    totalSheetsFound: number;
    missingSheets: string[] | undefined;
    sheetsValidation: AssetImportSheetValidationDto[] | undefined;
    allSheetsValid: boolean;
}

export class AssetImportTemplateDto implements IAssetImportTemplateDto {
    fileName!: string | undefined;
    fileMimeType!: string | undefined;
    fileContent!: string | undefined;

    constructor(data?: IAssetImportTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileMimeType = _data["fileMimeType"];
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): AssetImportTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileMimeType"] = this.fileMimeType;
        data["fileContent"] = this.fileContent;
        return data;
    }
}

export interface IAssetImportTemplateDto {
    fileName: string | undefined;
    fileMimeType: string | undefined;
    fileContent: string | undefined;
}

export class AssetImportValidationResultDto implements IAssetImportValidationResultDto {
    bulkReferenceNumber!: string | undefined;
    organizationUnitName!: string | undefined;
    uploadedBy!: string | undefined;
    totalRows!: number;
    passedCount!: number;
    failedCount!: number;
    readonly allPassed!: boolean;
    failedRows!: AssetImportRowErrorDto[] | undefined;

    constructor(data?: IAssetImportValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bulkReferenceNumber = _data["bulkReferenceNumber"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.uploadedBy = _data["uploadedBy"];
            this.totalRows = _data["totalRows"];
            this.passedCount = _data["passedCount"];
            this.failedCount = _data["failedCount"];
            (<any>this).allPassed = _data["allPassed"];
            if (Array.isArray(_data["failedRows"])) {
                this.failedRows = [] as any;
                for (let item of _data["failedRows"])
                    this.failedRows!.push(AssetImportRowErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetImportValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bulkReferenceNumber"] = this.bulkReferenceNumber;
        data["organizationUnitName"] = this.organizationUnitName;
        data["uploadedBy"] = this.uploadedBy;
        data["totalRows"] = this.totalRows;
        data["passedCount"] = this.passedCount;
        data["failedCount"] = this.failedCount;
        data["allPassed"] = this.allPassed;
        if (Array.isArray(this.failedRows)) {
            data["failedRows"] = [];
            for (let item of this.failedRows)
                data["failedRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetImportValidationResultDto {
    bulkReferenceNumber: string | undefined;
    organizationUnitName: string | undefined;
    uploadedBy: string | undefined;
    totalRows: number;
    passedCount: number;
    failedCount: number;
    allPassed: boolean;
    failedRows: AssetImportRowErrorDto[] | undefined;
}

export class AssetTypeWithMeasurementDto implements IAssetTypeWithMeasurementDto {
    id!: number;
    name_En!: string | undefined;
    name_Ar!: string | undefined;
    measurementType!: number | undefined;
    measurementTypeKey!: string | undefined;
    measurementTypeLabel!: string | undefined;

    constructor(data?: IAssetTypeWithMeasurementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name_En = _data["name_En"];
            this.name_Ar = _data["name_Ar"];
            this.measurementType = _data["measurementType"];
            this.measurementTypeKey = _data["measurementTypeKey"];
            this.measurementTypeLabel = _data["measurementTypeLabel"];
        }
    }

    static fromJS(data: any): AssetTypeWithMeasurementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTypeWithMeasurementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name_En"] = this.name_En;
        data["name_Ar"] = this.name_Ar;
        data["measurementType"] = this.measurementType;
        data["measurementTypeKey"] = this.measurementTypeKey;
        data["measurementTypeLabel"] = this.measurementTypeLabel;
        return data;
    }
}

export interface IAssetTypeWithMeasurementDto {
    id: number;
    name_En: string | undefined;
    name_Ar: string | undefined;
    measurementType: number | undefined;
    measurementTypeKey: string | undefined;
    measurementTypeLabel: string | undefined;
}

export class AttendeeInfoDto implements IAttendeeInfoDto {
    attendeeFullName!: string | undefined;
    mobileNumber!: string | undefined;
    email!: string | undefined;
    dateOfBirth!: DateTime;
    idNumber!: string | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    isDeleted!: boolean;
    deletionTime!: DateTime | undefined;
    randomGeneratedIndex!: number | undefined;
    trainingRequestId!: number | undefined;
    courseId!: number;
    id!: number;

    constructor(data?: IAttendeeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendeeFullName = _data["attendeeFullName"];
            this.mobileNumber = _data["mobileNumber"];
            this.email = _data["email"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.idNumber = _data["idNumber"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.randomGeneratedIndex = _data["randomGeneratedIndex"];
            this.trainingRequestId = _data["trainingRequestId"];
            this.courseId = _data["courseId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AttendeeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendeeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendeeFullName"] = this.attendeeFullName;
        data["mobileNumber"] = this.mobileNumber;
        data["email"] = this.email;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : <any>undefined;
        data["idNumber"] = this.idNumber;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["randomGeneratedIndex"] = this.randomGeneratedIndex;
        data["trainingRequestId"] = this.trainingRequestId;
        data["courseId"] = this.courseId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAttendeeInfoDto {
    attendeeFullName: string | undefined;
    mobileNumber: string | undefined;
    email: string | undefined;
    dateOfBirth: DateTime;
    idNumber: string | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    isDeleted: boolean;
    deletionTime: DateTime | undefined;
    randomGeneratedIndex: number | undefined;
    trainingRequestId: number | undefined;
    courseId: number;
    id: number;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: DateTime;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    id!: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? DateTime.fromISO(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: DateTime;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    twoFactorAttemptsExceeded!: boolean;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
            this.twoFactorAttemptsExceeded = _data["twoFactorAttemptsExceeded"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        data["twoFactorAttemptsExceeded"] = this.twoFactorAttemptsExceeded;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    twoFactorAttemptsExceeded: boolean;
}

export class AwarnessContentAwarenessContentClassificationLookupTableDto implements IAwarnessContentAwarenessContentClassificationLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAwarnessContentAwarenessContentClassificationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AwarnessContentAwarenessContentClassificationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwarnessContentAwarenessContentClassificationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAwarnessContentAwarenessContentClassificationLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class AwarnessContentContentTypeLookupTableDto implements IAwarnessContentContentTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAwarnessContentContentTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AwarnessContentContentTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwarnessContentContentTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAwarnessContentContentTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class AwarnessContentDto implements IAwarnessContentDto {
    contentNumber!: string | undefined;
    contentName!: string | undefined;
    attachmentId!: string | undefined;
    awarenessContentClassificationId!: number | undefined;
    contentTypeId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IAwarnessContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentNumber = _data["contentNumber"];
            this.contentName = _data["contentName"];
            this.attachmentId = _data["attachmentId"];
            this.awarenessContentClassificationId = _data["awarenessContentClassificationId"];
            this.contentTypeId = _data["contentTypeId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AwarnessContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwarnessContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentNumber"] = this.contentNumber;
        data["contentName"] = this.contentName;
        data["attachmentId"] = this.attachmentId;
        data["awarenessContentClassificationId"] = this.awarenessContentClassificationId;
        data["contentTypeId"] = this.contentTypeId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAwarnessContentDto {
    contentNumber: string | undefined;
    contentName: string | undefined;
    attachmentId: string | undefined;
    awarenessContentClassificationId: number | undefined;
    contentTypeId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class BaselineResultDto implements IBaselineResultDto {
    baseline!: number;
    isApprovedRequestsFound!: boolean;
    requestMainInfoDto!: RequestMainInfoDto[] | undefined;
    fuelDataDto!: GovFuelDto;

    constructor(data?: IBaselineResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseline = _data["baseline"];
            this.isApprovedRequestsFound = _data["isApprovedRequestsFound"];
            if (Array.isArray(_data["requestMainInfoDto"])) {
                this.requestMainInfoDto = [] as any;
                for (let item of _data["requestMainInfoDto"])
                    this.requestMainInfoDto!.push(RequestMainInfoDto.fromJS(item));
            }
            this.fuelDataDto = _data["fuelDataDto"] ? GovFuelDto.fromJS(_data["fuelDataDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaselineResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaselineResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseline"] = this.baseline;
        data["isApprovedRequestsFound"] = this.isApprovedRequestsFound;
        if (Array.isArray(this.requestMainInfoDto)) {
            data["requestMainInfoDto"] = [];
            for (let item of this.requestMainInfoDto)
                data["requestMainInfoDto"].push(item.toJSON());
        }
        data["fuelDataDto"] = this.fuelDataDto ? this.fuelDataDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBaselineResultDto {
    baseline: number;
    isApprovedRequestsFound: boolean;
    requestMainInfoDto: RequestMainInfoDto[] | undefined;
    fuelDataDto: GovFuelDto;
}

export class BIRequestModel implements IBIRequestModel {
    token!: string | undefined;

    constructor(data?: IBIRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): BIRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new BIRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IBIRequestModel {
    token: string | undefined;
}

export class BIResponseModel implements IBIResponseModel {
    valid!: boolean;
    entityId!: string | undefined;
    username!: string | undefined;

    constructor(data?: IBIResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valid = _data["valid"];
            this.entityId = _data["entityId"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): BIResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BIResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid;
        data["entityId"] = this.entityId;
        data["username"] = this.username;
        return data;
    }
}

export interface IBIResponseModel {
    valid: boolean;
    entityId: string | undefined;
    username: string | undefined;
}

export class BuildingAssetInfoDto implements IBuildingAssetInfoDto {
    refrenceNumber!: string | undefined;
    organizationUnitId!: number | undefined;
    name!: string | undefined;
    address!: string | undefined;
    regionId!: number;
    cityName!: string | undefined;
    ownership!: number | undefined;
    assetTypeId!: number | undefined;
    assetSubTypeId!: number | undefined;
    grossArea!: number;
    numberOfFloors!: number;
    constructionDate!: string | undefined;
    lastRetrofitYear!: string | undefined;
    buildingStatusId!: number;
    tarshidRetrofit!: boolean;
    buildingOccupants!: number;
    operatingHoursPerWeek!: number;
    operationStartTime!: string | undefined;
    notes!: string | undefined;
    attachments!: string | undefined;
    addedStatusId!: number;
    electricityAccounts!: BuildingElectricityAccountDto[] | undefined;
    id!: number;

    constructor(data?: IBuildingAssetInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refrenceNumber = _data["refrenceNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.regionId = _data["regionId"];
            this.cityName = _data["cityName"];
            this.ownership = _data["ownership"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetSubTypeId = _data["assetSubTypeId"];
            this.grossArea = _data["grossArea"];
            this.numberOfFloors = _data["numberOfFloors"];
            this.constructionDate = _data["constructionDate"];
            this.lastRetrofitYear = _data["lastRetrofitYear"];
            this.buildingStatusId = _data["buildingStatusId"];
            this.tarshidRetrofit = _data["tarshidRetrofit"];
            this.buildingOccupants = _data["buildingOccupants"];
            this.operatingHoursPerWeek = _data["operatingHoursPerWeek"];
            this.operationStartTime = _data["operationStartTime"];
            this.notes = _data["notes"];
            this.attachments = _data["attachments"];
            this.addedStatusId = _data["addedStatusId"];
            if (Array.isArray(_data["electricityAccounts"])) {
                this.electricityAccounts = [] as any;
                for (let item of _data["electricityAccounts"])
                    this.electricityAccounts!.push(BuildingElectricityAccountDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BuildingAssetInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingAssetInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refrenceNumber"] = this.refrenceNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["regionId"] = this.regionId;
        data["cityName"] = this.cityName;
        data["ownership"] = this.ownership;
        data["assetTypeId"] = this.assetTypeId;
        data["assetSubTypeId"] = this.assetSubTypeId;
        data["grossArea"] = this.grossArea;
        data["numberOfFloors"] = this.numberOfFloors;
        data["constructionDate"] = this.constructionDate;
        data["lastRetrofitYear"] = this.lastRetrofitYear;
        data["buildingStatusId"] = this.buildingStatusId;
        data["tarshidRetrofit"] = this.tarshidRetrofit;
        data["buildingOccupants"] = this.buildingOccupants;
        data["operatingHoursPerWeek"] = this.operatingHoursPerWeek;
        data["operationStartTime"] = this.operationStartTime;
        data["notes"] = this.notes;
        data["attachments"] = this.attachments;
        data["addedStatusId"] = this.addedStatusId;
        if (Array.isArray(this.electricityAccounts)) {
            data["electricityAccounts"] = [];
            for (let item of this.electricityAccounts)
                data["electricityAccounts"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IBuildingAssetInfoDto {
    refrenceNumber: string | undefined;
    organizationUnitId: number | undefined;
    name: string | undefined;
    address: string | undefined;
    regionId: number;
    cityName: string | undefined;
    ownership: number | undefined;
    assetTypeId: number | undefined;
    assetSubTypeId: number | undefined;
    grossArea: number;
    numberOfFloors: number;
    constructionDate: string | undefined;
    lastRetrofitYear: string | undefined;
    buildingStatusId: number;
    tarshidRetrofit: boolean;
    buildingOccupants: number;
    operatingHoursPerWeek: number;
    operationStartTime: string | undefined;
    notes: string | undefined;
    attachments: string | undefined;
    addedStatusId: number;
    electricityAccounts: BuildingElectricityAccountDto[] | undefined;
    id: number;
}

export class BuildingAssetViewDto implements IBuildingAssetViewDto {
    id!: number;
    refrenceNumber!: string | undefined;
    name!: string | undefined;
    cityName!: string | undefined;
    ownershipName!: string | undefined;
    assetTypeName!: string | undefined;
    assetSubTypeName!: string | undefined;
    grossArea!: number;
    numberOfFloors!: number;
    constructionDate!: string | undefined;
    buildingStatusName!: string | undefined;
    buildingOccupants!: number;
    operatingHoursPerWeek!: number;
    operationStartTime!: string | undefined;
    electricityAccounts!: ElectricityAccountViewDto[] | undefined;

    constructor(data?: IBuildingAssetViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refrenceNumber = _data["refrenceNumber"];
            this.name = _data["name"];
            this.cityName = _data["cityName"];
            this.ownershipName = _data["ownershipName"];
            this.assetTypeName = _data["assetTypeName"];
            this.assetSubTypeName = _data["assetSubTypeName"];
            this.grossArea = _data["grossArea"];
            this.numberOfFloors = _data["numberOfFloors"];
            this.constructionDate = _data["constructionDate"];
            this.buildingStatusName = _data["buildingStatusName"];
            this.buildingOccupants = _data["buildingOccupants"];
            this.operatingHoursPerWeek = _data["operatingHoursPerWeek"];
            this.operationStartTime = _data["operationStartTime"];
            if (Array.isArray(_data["electricityAccounts"])) {
                this.electricityAccounts = [] as any;
                for (let item of _data["electricityAccounts"])
                    this.electricityAccounts!.push(ElectricityAccountViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuildingAssetViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingAssetViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refrenceNumber"] = this.refrenceNumber;
        data["name"] = this.name;
        data["cityName"] = this.cityName;
        data["ownershipName"] = this.ownershipName;
        data["assetTypeName"] = this.assetTypeName;
        data["assetSubTypeName"] = this.assetSubTypeName;
        data["grossArea"] = this.grossArea;
        data["numberOfFloors"] = this.numberOfFloors;
        data["constructionDate"] = this.constructionDate;
        data["buildingStatusName"] = this.buildingStatusName;
        data["buildingOccupants"] = this.buildingOccupants;
        data["operatingHoursPerWeek"] = this.operatingHoursPerWeek;
        data["operationStartTime"] = this.operationStartTime;
        if (Array.isArray(this.electricityAccounts)) {
            data["electricityAccounts"] = [];
            for (let item of this.electricityAccounts)
                data["electricityAccounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBuildingAssetViewDto {
    id: number;
    refrenceNumber: string | undefined;
    name: string | undefined;
    cityName: string | undefined;
    ownershipName: string | undefined;
    assetTypeName: string | undefined;
    assetSubTypeName: string | undefined;
    grossArea: number;
    numberOfFloors: number;
    constructionDate: string | undefined;
    buildingStatusName: string | undefined;
    buildingOccupants: number;
    operatingHoursPerWeek: number;
    operationStartTime: string | undefined;
    electricityAccounts: ElectricityAccountViewDto[] | undefined;
}

export class BuildingElectricityAccountDto implements IBuildingElectricityAccountDto {
    buildingAssetInfoId!: number;
    serviceProviderId!: number;
    seAccountNumber!: string | undefined;
    voltageGroupId!: number;
    hasDistrictCooling!: boolean;
    coolingTariff!: string | undefined;
    isShared!: boolean;
    sharedEntityId!: number | undefined;
    otherOrganizationName!: string | undefined;
    occupancyPercentage!: number | undefined;
    voltageGroupName!: string | undefined;
    serviceProviderName!: string | undefined;
    sharedEntityName!: string | undefined;
    id!: number;

    constructor(data?: IBuildingElectricityAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingAssetInfoId = _data["buildingAssetInfoId"];
            this.serviceProviderId = _data["serviceProviderId"];
            this.seAccountNumber = _data["seAccountNumber"];
            this.voltageGroupId = _data["voltageGroupId"];
            this.hasDistrictCooling = _data["hasDistrictCooling"];
            this.coolingTariff = _data["coolingTariff"];
            this.isShared = _data["isShared"];
            this.sharedEntityId = _data["sharedEntityId"];
            this.otherOrganizationName = _data["otherOrganizationName"];
            this.occupancyPercentage = _data["occupancyPercentage"];
            this.voltageGroupName = _data["voltageGroupName"];
            this.serviceProviderName = _data["serviceProviderName"];
            this.sharedEntityName = _data["sharedEntityName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BuildingElectricityAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingElectricityAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingAssetInfoId"] = this.buildingAssetInfoId;
        data["serviceProviderId"] = this.serviceProviderId;
        data["seAccountNumber"] = this.seAccountNumber;
        data["voltageGroupId"] = this.voltageGroupId;
        data["hasDistrictCooling"] = this.hasDistrictCooling;
        data["coolingTariff"] = this.coolingTariff;
        data["isShared"] = this.isShared;
        data["sharedEntityId"] = this.sharedEntityId;
        data["otherOrganizationName"] = this.otherOrganizationName;
        data["occupancyPercentage"] = this.occupancyPercentage;
        data["voltageGroupName"] = this.voltageGroupName;
        data["serviceProviderName"] = this.serviceProviderName;
        data["sharedEntityName"] = this.sharedEntityName;
        data["id"] = this.id;
        return data;
    }
}

export interface IBuildingElectricityAccountDto {
    buildingAssetInfoId: number;
    serviceProviderId: number;
    seAccountNumber: string | undefined;
    voltageGroupId: number;
    hasDistrictCooling: boolean;
    coolingTariff: string | undefined;
    isShared: boolean;
    sharedEntityId: number | undefined;
    otherOrganizationName: string | undefined;
    occupancyPercentage: number | undefined;
    voltageGroupName: string | undefined;
    serviceProviderName: string | undefined;
    sharedEntityName: string | undefined;
    id: number;
}

export class BuildingEnergyEfficiencySubmissionDto implements IBuildingEnergyEfficiencySubmissionDto {
    requestNumber!: string | undefined;
    hasEnergySavingPolicy!: string | undefined;
    supportingDocument!: string | undefined;
    isOrganizationIndependent!: string | undefined;
    parentOrganization!: string | undefined;
    isBuildingOlderThan12Months!: string | undefined;
    areAccountsLinkedDirectly!: string | undefined;
    doesOrganizationPayElectricityBills!: string | undefined;
    isContractedWithTarsheed!: string | undefined;
    isIncomplete!: boolean;
    buildingName!: string | undefined;
    city!: string | undefined;
    buildingType!: string | undefined;
    buildingStatus!: string | undefined;
    floorsNumber!: number;
    buildingArea!: number;
    buildingUsersCount!: number;
    electricityServiceProvider!: string | undefined;
    consumptionPreviousYear!: number | undefined;
    consumptionCurrentYear!: number | undefined;
    electricityAccounts!: string | undefined;
    energyEfficiencyActivities!: string | undefined;
    providerDocuments!: string | undefined;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    entityName!: string | undefined;
    requestId!: number | undefined;
    submissionCycle!: string | undefined;
    year!: string | undefined;
    buildingAssetId!: number | undefined;
    organizationId!: number | undefined;
    requestStatus!: number | undefined;
    requestStatusName!: string | undefined;
    submitionDate!: DateTime | undefined;
    submittedByUserName!: string | undefined;
    onTimeSubmitted!: boolean | undefined;
    validSubmittionDate!: DateTime | undefined;
    rejectionReason!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IBuildingEnergyEfficiencySubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.hasEnergySavingPolicy = _data["hasEnergySavingPolicy"];
            this.supportingDocument = _data["supportingDocument"];
            this.isOrganizationIndependent = _data["isOrganizationIndependent"];
            this.parentOrganization = _data["parentOrganization"];
            this.isBuildingOlderThan12Months = _data["isBuildingOlderThan12Months"];
            this.areAccountsLinkedDirectly = _data["areAccountsLinkedDirectly"];
            this.doesOrganizationPayElectricityBills = _data["doesOrganizationPayElectricityBills"];
            this.isContractedWithTarsheed = _data["isContractedWithTarsheed"];
            this.isIncomplete = _data["isIncomplete"];
            this.buildingName = _data["buildingName"];
            this.city = _data["city"];
            this.buildingType = _data["buildingType"];
            this.buildingStatus = _data["buildingStatus"];
            this.floorsNumber = _data["floorsNumber"];
            this.buildingArea = _data["buildingArea"];
            this.buildingUsersCount = _data["buildingUsersCount"];
            this.electricityServiceProvider = _data["electricityServiceProvider"];
            this.consumptionPreviousYear = _data["consumptionPreviousYear"];
            this.consumptionCurrentYear = _data["consumptionCurrentYear"];
            this.electricityAccounts = _data["electricityAccounts"];
            this.energyEfficiencyActivities = _data["energyEfficiencyActivities"];
            this.providerDocuments = _data["providerDocuments"];
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.entityName = _data["entityName"];
            this.requestId = _data["requestId"];
            this.submissionCycle = _data["submissionCycle"];
            this.year = _data["year"];
            this.buildingAssetId = _data["buildingAssetId"];
            this.organizationId = _data["organizationId"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusName = _data["requestStatusName"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.submittedByUserName = _data["submittedByUserName"];
            this.onTimeSubmitted = _data["onTimeSubmitted"];
            this.validSubmittionDate = _data["validSubmittionDate"] ? DateTime.fromISO(_data["validSubmittionDate"].toString()) : <any>undefined;
            this.rejectionReason = _data["rejectionReason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BuildingEnergyEfficiencySubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingEnergyEfficiencySubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["hasEnergySavingPolicy"] = this.hasEnergySavingPolicy;
        data["supportingDocument"] = this.supportingDocument;
        data["isOrganizationIndependent"] = this.isOrganizationIndependent;
        data["parentOrganization"] = this.parentOrganization;
        data["isBuildingOlderThan12Months"] = this.isBuildingOlderThan12Months;
        data["areAccountsLinkedDirectly"] = this.areAccountsLinkedDirectly;
        data["doesOrganizationPayElectricityBills"] = this.doesOrganizationPayElectricityBills;
        data["isContractedWithTarsheed"] = this.isContractedWithTarsheed;
        data["isIncomplete"] = this.isIncomplete;
        data["buildingName"] = this.buildingName;
        data["city"] = this.city;
        data["buildingType"] = this.buildingType;
        data["buildingStatus"] = this.buildingStatus;
        data["floorsNumber"] = this.floorsNumber;
        data["buildingArea"] = this.buildingArea;
        data["buildingUsersCount"] = this.buildingUsersCount;
        data["electricityServiceProvider"] = this.electricityServiceProvider;
        data["consumptionPreviousYear"] = this.consumptionPreviousYear;
        data["consumptionCurrentYear"] = this.consumptionCurrentYear;
        data["electricityAccounts"] = this.electricityAccounts;
        data["energyEfficiencyActivities"] = this.energyEfficiencyActivities;
        data["providerDocuments"] = this.providerDocuments;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["entityName"] = this.entityName;
        data["requestId"] = this.requestId;
        data["submissionCycle"] = this.submissionCycle;
        data["year"] = this.year;
        data["buildingAssetId"] = this.buildingAssetId;
        data["organizationId"] = this.organizationId;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusName"] = this.requestStatusName;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["submittedByUserName"] = this.submittedByUserName;
        data["onTimeSubmitted"] = this.onTimeSubmitted;
        data["validSubmittionDate"] = this.validSubmittionDate ? this.validSubmittionDate.toString() : <any>undefined;
        data["rejectionReason"] = this.rejectionReason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBuildingEnergyEfficiencySubmissionDto {
    requestNumber: string | undefined;
    hasEnergySavingPolicy: string | undefined;
    supportingDocument: string | undefined;
    isOrganizationIndependent: string | undefined;
    parentOrganization: string | undefined;
    isBuildingOlderThan12Months: string | undefined;
    areAccountsLinkedDirectly: string | undefined;
    doesOrganizationPayElectricityBills: string | undefined;
    isContractedWithTarsheed: string | undefined;
    isIncomplete: boolean;
    buildingName: string | undefined;
    city: string | undefined;
    buildingType: string | undefined;
    buildingStatus: string | undefined;
    floorsNumber: number;
    buildingArea: number;
    buildingUsersCount: number;
    electricityServiceProvider: string | undefined;
    consumptionPreviousYear: number | undefined;
    consumptionCurrentYear: number | undefined;
    electricityAccounts: string | undefined;
    energyEfficiencyActivities: string | undefined;
    providerDocuments: string | undefined;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    entityName: string | undefined;
    requestId: number | undefined;
    submissionCycle: string | undefined;
    year: string | undefined;
    buildingAssetId: number | undefined;
    organizationId: number | undefined;
    requestStatus: number | undefined;
    requestStatusName: string | undefined;
    submitionDate: DateTime | undefined;
    submittedByUserName: string | undefined;
    onTimeSubmitted: boolean | undefined;
    validSubmittionDate: DateTime | undefined;
    rejectionReason: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class BuildingInfoCityLookupTableDto implements IBuildingInfoCityLookupTableDto {
    id!: number;
    name_Ar!: string | undefined;
    regionId!: number;

    constructor(data?: IBuildingInfoCityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name_Ar = _data["name_Ar"];
            this.regionId = _data["regionId"];
        }
    }

    static fromJS(data: any): BuildingInfoCityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingInfoCityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name_Ar"] = this.name_Ar;
        data["regionId"] = this.regionId;
        return data;
    }
}

export interface IBuildingInfoCityLookupTableDto {
    id: number;
    name_Ar: string | undefined;
    regionId: number;
}

export class BuildingInfoDto implements IBuildingInfoDto {
    name!: string | undefined;
    buildingOccupants!: number;
    constructionDate!: DateTime;
    buildingStatusId!: number | undefined;
    regionId!: number | undefined;
    cityId!: number | undefined;
    organizationUnitId!: number | undefined;
    meterInfoDtos!: MeterInfoDto[] | undefined;
    id!: number;

    constructor(data?: IBuildingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.buildingOccupants = _data["buildingOccupants"];
            this.constructionDate = _data["constructionDate"] ? DateTime.fromISO(_data["constructionDate"].toString()) : <any>undefined;
            this.buildingStatusId = _data["buildingStatusId"];
            this.regionId = _data["regionId"];
            this.cityId = _data["cityId"];
            this.organizationUnitId = _data["organizationUnitId"];
            if (Array.isArray(_data["meterInfoDtos"])) {
                this.meterInfoDtos = [] as any;
                for (let item of _data["meterInfoDtos"])
                    this.meterInfoDtos!.push(MeterInfoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BuildingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["buildingOccupants"] = this.buildingOccupants;
        data["constructionDate"] = this.constructionDate ? this.constructionDate.toString() : <any>undefined;
        data["buildingStatusId"] = this.buildingStatusId;
        data["regionId"] = this.regionId;
        data["cityId"] = this.cityId;
        data["organizationUnitId"] = this.organizationUnitId;
        if (Array.isArray(this.meterInfoDtos)) {
            data["meterInfoDtos"] = [];
            for (let item of this.meterInfoDtos)
                data["meterInfoDtos"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IBuildingInfoDto {
    name: string | undefined;
    buildingOccupants: number;
    constructionDate: DateTime;
    buildingStatusId: number | undefined;
    regionId: number | undefined;
    cityId: number | undefined;
    organizationUnitId: number | undefined;
    meterInfoDtos: MeterInfoDto[] | undefined;
    id: number;
}

export class BuildingInfoRegionLookupTableDto implements IBuildingInfoRegionLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    cities!: BuildingInfoCityLookupTableDto[] | undefined;

    constructor(data?: IBuildingInfoRegionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(BuildingInfoCityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuildingInfoRegionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingInfoRegionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBuildingInfoRegionLookupTableDto {
    id: number;
    displayName: string | undefined;
    cities: BuildingInfoCityLookupTableDto[] | undefined;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class ChangeKnowledgeBankFeaturedState implements IChangeKnowledgeBankFeaturedState {
    knowledgeBankId!: number;
    isFeatured!: boolean;

    constructor(data?: IChangeKnowledgeBankFeaturedState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeBankId = _data["knowledgeBankId"];
            this.isFeatured = _data["isFeatured"];
        }
    }

    static fromJS(data: any): ChangeKnowledgeBankFeaturedState {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeKnowledgeBankFeaturedState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeBankId"] = this.knowledgeBankId;
        data["isFeatured"] = this.isFeatured;
        return data;
    }
}

export interface IChangeKnowledgeBankFeaturedState {
    knowledgeBankId: number;
    isFeatured: boolean;
}

export class ChangeKnowledgeBankPublishStateDto implements IChangeKnowledgeBankPublishStateDto {
    knowledgeBankId!: number;
    publishState!: number;

    constructor(data?: IChangeKnowledgeBankPublishStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeBankId = _data["knowledgeBankId"];
            this.publishState = _data["publishState"];
        }
    }

    static fromJS(data: any): ChangeKnowledgeBankPublishStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeKnowledgeBankPublishStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeBankId"] = this.knowledgeBankId;
        data["publishState"] = this.publishState;
        return data;
    }
}

export interface IChangeKnowledgeBankPublishStateDto {
    knowledgeBankId: number;
    publishState: number;
}

export class ChangeMediaCenterFeatureState implements IChangeMediaCenterFeatureState {
    mediaCenterId!: number;
    isFeatured!: boolean;

    constructor(data?: IChangeMediaCenterFeatureState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaCenterId = _data["mediaCenterId"];
            this.isFeatured = _data["isFeatured"];
        }
    }

    static fromJS(data: any): ChangeMediaCenterFeatureState {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMediaCenterFeatureState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaCenterId"] = this.mediaCenterId;
        data["isFeatured"] = this.isFeatured;
        return data;
    }
}

export interface IChangeMediaCenterFeatureState {
    mediaCenterId: number;
    isFeatured: boolean;
}

export class ChangeMediaCenterPublishStateDto implements IChangeMediaCenterPublishStateDto {
    mediaCenterId!: number;
    publishState!: number;

    constructor(data?: IChangeMediaCenterPublishStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaCenterId = _data["mediaCenterId"];
            this.publishState = _data["publishState"];
        }
    }

    static fromJS(data: any): ChangeMediaCenterPublishStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeMediaCenterPublishStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaCenterId"] = this.mediaCenterId;
        data["publishState"] = this.publishState;
        return data;
    }
}

export interface IChangeMediaCenterPublishStateDto {
    mediaCenterId: number;
    publishState: number;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class ChangePublishStateDto implements IChangePublishStateDto {
    newsId!: string;
    publishState!: number;

    constructor(data?: IChangePublishStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newsId = _data["newsId"];
            this.publishState = _data["publishState"];
        }
    }

    static fromJS(data: any): ChangePublishStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePublishStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsId"] = this.newsId;
        data["publishState"] = this.publishState;
        return data;
    }
}

export interface IChangePublishStateDto {
    newsId: string;
    publishState: number;
}

export class ChangeSecMeterReviewStatusInput implements IChangeSecMeterReviewStatusInput {
    id!: number;
    status!: SeecReviewMetersStatuses;
    reason!: string | undefined;

    constructor(data?: IChangeSecMeterReviewStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ChangeSecMeterReviewStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSecMeterReviewStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IChangeSecMeterReviewStatusInput {
    id: number;
    status: SeecReviewMetersStatuses;
    reason: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangeUserSubmissionStatusDto implements IChangeUserSubmissionStatusDto {
    userSubmissionId!: number;
    status!: number;

    constructor(data?: IChangeUserSubmissionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSubmissionId = _data["userSubmissionId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChangeUserSubmissionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserSubmissionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSubmissionId"] = this.userSubmissionId;
        data["status"] = this.status;
        return data;
    }
}

export interface IChangeUserSubmissionStatusDto {
    userSubmissionId: number;
    status: number;
}

export enum ChartDateInterval {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDatabaseExist = _data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class ClaimAccountDto implements IClaimAccountDto {
    claimAccountNumber!: number;
    organizationUnitId!: number;
    id!: number | undefined;

    constructor(data?: IClaimAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimAccountNumber = _data["claimAccountNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaimAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimAccountNumber"] = this.claimAccountNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["id"] = this.id;
        return data;
    }
}

export interface IClaimAccountDto {
    claimAccountNumber: number;
    organizationUnitId: number;
    id: number | undefined;
}

export class ClaimAccountListDto implements IClaimAccountListDto {
    claimAccountId!: number;
    claimAccountNumber!: number;
    organizationUnitId!: number | undefined;
    organizationUnitName!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IClaimAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimAccountId = _data["claimAccountId"];
            this.claimAccountNumber = _data["claimAccountNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaimAccountListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimAccountId"] = this.claimAccountId;
        data["claimAccountNumber"] = this.claimAccountNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IClaimAccountListDto {
    claimAccountId: number;
    claimAccountNumber: number;
    organizationUnitId: number | undefined;
    organizationUnitName: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class ComparisonDataDto implements IComparisonDataDto {
    governmentData!: GovernmentDataDto;
    providerData!: ProviderDataDto[] | undefined;
    providerChart!: ProviderDataChart[] | undefined;
    electricityEEPData!: ElectricityEEPMonitoringDto;

    constructor(data?: IComparisonDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.governmentData = _data["governmentData"] ? GovernmentDataDto.fromJS(_data["governmentData"]) : <any>undefined;
            if (Array.isArray(_data["providerData"])) {
                this.providerData = [] as any;
                for (let item of _data["providerData"])
                    this.providerData!.push(ProviderDataDto.fromJS(item));
            }
            if (Array.isArray(_data["providerChart"])) {
                this.providerChart = [] as any;
                for (let item of _data["providerChart"])
                    this.providerChart!.push(ProviderDataChart.fromJS(item));
            }
            this.electricityEEPData = _data["electricityEEPData"] ? ElectricityEEPMonitoringDto.fromJS(_data["electricityEEPData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ComparisonDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComparisonDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["governmentData"] = this.governmentData ? this.governmentData.toJSON() : <any>undefined;
        if (Array.isArray(this.providerData)) {
            data["providerData"] = [];
            for (let item of this.providerData)
                data["providerData"].push(item.toJSON());
        }
        if (Array.isArray(this.providerChart)) {
            data["providerChart"] = [];
            for (let item of this.providerChart)
                data["providerChart"].push(item.toJSON());
        }
        data["electricityEEPData"] = this.electricityEEPData ? this.electricityEEPData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IComparisonDataDto {
    governmentData: GovernmentDataDto;
    providerData: ProviderDataDto[] | undefined;
    providerChart: ProviderDataChart[] | undefined;
    electricityEEPData: ElectricityEEPMonitoringDto;
}

export class ConsumerTypesTreeModelDto implements IConsumerTypesTreeModelDto {
    consumerTypesTreeNodes!: TreeNodesDto[] | undefined;
    recordIndexx!: number;
    count!: number;

    constructor(data?: IConsumerTypesTreeModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["consumerTypesTreeNodes"])) {
                this.consumerTypesTreeNodes = [] as any;
                for (let item of _data["consumerTypesTreeNodes"])
                    this.consumerTypesTreeNodes!.push(TreeNodesDto.fromJS(item));
            }
            this.recordIndexx = _data["recordIndexx"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ConsumerTypesTreeModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerTypesTreeModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consumerTypesTreeNodes)) {
            data["consumerTypesTreeNodes"] = [];
            for (let item of this.consumerTypesTreeNodes)
                data["consumerTypesTreeNodes"].push(item.toJSON());
        }
        data["recordIndexx"] = this.recordIndexx;
        data["count"] = this.count;
        return data;
    }
}

export interface IConsumerTypesTreeModelDto {
    consumerTypesTreeNodes: TreeNodesDto[] | undefined;
    recordIndexx: number;
    count: number;
}

export class ConsumptionConsumerTypesDto implements IConsumptionConsumerTypesDto {
    fuelConsumptionDataId!: number;
    consumerSourceTypeId!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IConsumptionConsumerTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelConsumptionDataId = _data["fuelConsumptionDataId"];
            this.consumerSourceTypeId = _data["consumerSourceTypeId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConsumptionConsumerTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionConsumerTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelConsumptionDataId"] = this.fuelConsumptionDataId;
        data["consumerSourceTypeId"] = this.consumerSourceTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IConsumptionConsumerTypesDto {
    fuelConsumptionDataId: number;
    consumerSourceTypeId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ContactUsDto implements IContactUsDto {
    contactCenterNumber!: number;
    contactCenterEmail!: string | undefined;
    centerLoctionLongitude!: number;
    centerLoctionLatitude!: number;
    address!: string | undefined;
    locationUrl!: string | undefined;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    isPublished!: boolean;
    publishedby!: UserViewDto;
    publishDate!: DateTime | undefined;
    version!: number;
    isLatest!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IContactUsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactCenterNumber = _data["contactCenterNumber"];
            this.contactCenterEmail = _data["contactCenterEmail"];
            this.centerLoctionLongitude = _data["centerLoctionLongitude"];
            this.centerLoctionLatitude = _data["centerLoctionLatitude"];
            this.address = _data["address"];
            this.locationUrl = _data["locationUrl"];
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.isPublished = _data["isPublished"];
            this.publishedby = _data["publishedby"] ? UserViewDto.fromJS(_data["publishedby"]) : <any>undefined;
            this.publishDate = _data["publishDate"] ? DateTime.fromISO(_data["publishDate"].toString()) : <any>undefined;
            this.version = _data["version"];
            this.isLatest = _data["isLatest"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ContactUsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactCenterNumber"] = this.contactCenterNumber;
        data["contactCenterEmail"] = this.contactCenterEmail;
        data["centerLoctionLongitude"] = this.centerLoctionLongitude;
        data["centerLoctionLatitude"] = this.centerLoctionLatitude;
        data["address"] = this.address;
        data["locationUrl"] = this.locationUrl;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["isPublished"] = this.isPublished;
        data["publishedby"] = this.publishedby ? this.publishedby.toJSON() : <any>undefined;
        data["publishDate"] = this.publishDate ? this.publishDate.toString() : <any>undefined;
        data["version"] = this.version;
        data["isLatest"] = this.isLatest;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IContactUsDto {
    contactCenterNumber: number;
    contactCenterEmail: string | undefined;
    centerLoctionLongitude: number;
    centerLoctionLatitude: number;
    address: string | undefined;
    locationUrl: string | undefined;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    isPublished: boolean;
    publishedby: UserViewDto;
    publishDate: DateTime | undefined;
    version: number;
    isLatest: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ContactUsForHomeDto implements IContactUsForHomeDto {
    contactCenterNumber!: number;
    contactCenterEmail!: string | undefined;
    centerLoctionLongitude!: number;
    centerLoctionLatitude!: number;
    address!: string | undefined;
    locationUrl!: string | undefined;
    isPublished!: boolean;
    publishDate!: DateTime | undefined;
    version!: number;
    isLatest!: boolean;

    constructor(data?: IContactUsForHomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactCenterNumber = _data["contactCenterNumber"];
            this.contactCenterEmail = _data["contactCenterEmail"];
            this.centerLoctionLongitude = _data["centerLoctionLongitude"];
            this.centerLoctionLatitude = _data["centerLoctionLatitude"];
            this.address = _data["address"];
            this.locationUrl = _data["locationUrl"];
            this.isPublished = _data["isPublished"];
            this.publishDate = _data["publishDate"] ? DateTime.fromISO(_data["publishDate"].toString()) : <any>undefined;
            this.version = _data["version"];
            this.isLatest = _data["isLatest"];
        }
    }

    static fromJS(data: any): ContactUsForHomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUsForHomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactCenterNumber"] = this.contactCenterNumber;
        data["contactCenterEmail"] = this.contactCenterEmail;
        data["centerLoctionLongitude"] = this.centerLoctionLongitude;
        data["centerLoctionLatitude"] = this.centerLoctionLatitude;
        data["address"] = this.address;
        data["locationUrl"] = this.locationUrl;
        data["isPublished"] = this.isPublished;
        data["publishDate"] = this.publishDate ? this.publishDate.toString() : <any>undefined;
        data["version"] = this.version;
        data["isLatest"] = this.isLatest;
        return data;
    }
}

export interface IContactUsForHomeDto {
    contactCenterNumber: number;
    contactCenterEmail: string | undefined;
    centerLoctionLongitude: number;
    centerLoctionLatitude: number;
    address: string | undefined;
    locationUrl: string | undefined;
    isPublished: boolean;
    publishDate: DateTime | undefined;
    version: number;
    isLatest: boolean;
}

export class CoolingStationAssetInfoDto implements ICoolingStationAssetInfoDto {
    refrenceNumber!: string | undefined;
    organizationUnitId!: number;
    description!: string | undefined;
    regionId!: number;
    city!: string | undefined;
    plantCapacityTR!: number;
    actualPlantCapacityTR!: number | undefined;
    plantOperationDate!: string | undefined;
    lastRetrofitDate!: string | undefined;
    numberOfConnectedBuildings!: number;
    connectedBuildingsAreaM2!: number | undefined;
    hasNearbyUnconnectedBuildings!: boolean | undefined;
    technologyType!: number;
    usageType!: number;
    annualEnergyConsumptionKWh!: number;
    annualCoolingProductionTonHours!: number;
    peakCoolingLoadTR!: number | undefined;
    annualWaterConsumptionM3!: number;
    annualPlantEfficiency!: number;
    annualWaterPerformance!: number | undefined;
    hasThermalStorageTank!: boolean;
    thermalStorageCapacityM3!: number | undefined;
    waterType!: number;
    makeupWaterTankCapacityM3!: number | undefined;
    controlSystemTypeId!: number | undefined;
    numberOfChillers!: number | undefined;
    chillerCapacityTR!: number | undefined;
    chillerEnergyEfficiency!: number | undefined;
    numberOfPrimaryChilledWaterPumps!: number | undefined;
    numberOfCoolingTowers!: number | undefined;
    chilledWaterSupplyTemp!: number | undefined;
    chilledWaterReturnTemp!: number | undefined;
    notes!: string | undefined;
    attachments!: string | undefined;
    addedStatusId!: number | undefined;
    createdAt!: DateTime | undefined;
    id!: number;

    constructor(data?: ICoolingStationAssetInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refrenceNumber = _data["refrenceNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.description = _data["description"];
            this.regionId = _data["regionId"];
            this.city = _data["city"];
            this.plantCapacityTR = _data["plantCapacityTR"];
            this.actualPlantCapacityTR = _data["actualPlantCapacityTR"];
            this.plantOperationDate = _data["plantOperationDate"];
            this.lastRetrofitDate = _data["lastRetrofitDate"];
            this.numberOfConnectedBuildings = _data["numberOfConnectedBuildings"];
            this.connectedBuildingsAreaM2 = _data["connectedBuildingsAreaM2"];
            this.hasNearbyUnconnectedBuildings = _data["hasNearbyUnconnectedBuildings"];
            this.technologyType = _data["technologyType"];
            this.usageType = _data["usageType"];
            this.annualEnergyConsumptionKWh = _data["annualEnergyConsumptionKWh"];
            this.annualCoolingProductionTonHours = _data["annualCoolingProductionTonHours"];
            this.peakCoolingLoadTR = _data["peakCoolingLoadTR"];
            this.annualWaterConsumptionM3 = _data["annualWaterConsumptionM3"];
            this.annualPlantEfficiency = _data["annualPlantEfficiency"];
            this.annualWaterPerformance = _data["annualWaterPerformance"];
            this.hasThermalStorageTank = _data["hasThermalStorageTank"];
            this.thermalStorageCapacityM3 = _data["thermalStorageCapacityM3"];
            this.waterType = _data["waterType"];
            this.makeupWaterTankCapacityM3 = _data["makeupWaterTankCapacityM3"];
            this.controlSystemTypeId = _data["controlSystemTypeId"];
            this.numberOfChillers = _data["numberOfChillers"];
            this.chillerCapacityTR = _data["chillerCapacityTR"];
            this.chillerEnergyEfficiency = _data["chillerEnergyEfficiency"];
            this.numberOfPrimaryChilledWaterPumps = _data["numberOfPrimaryChilledWaterPumps"];
            this.numberOfCoolingTowers = _data["numberOfCoolingTowers"];
            this.chilledWaterSupplyTemp = _data["chilledWaterSupplyTemp"];
            this.chilledWaterReturnTemp = _data["chilledWaterReturnTemp"];
            this.notes = _data["notes"];
            this.attachments = _data["attachments"];
            this.addedStatusId = _data["addedStatusId"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CoolingStationAssetInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoolingStationAssetInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refrenceNumber"] = this.refrenceNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["description"] = this.description;
        data["regionId"] = this.regionId;
        data["city"] = this.city;
        data["plantCapacityTR"] = this.plantCapacityTR;
        data["actualPlantCapacityTR"] = this.actualPlantCapacityTR;
        data["plantOperationDate"] = this.plantOperationDate;
        data["lastRetrofitDate"] = this.lastRetrofitDate;
        data["numberOfConnectedBuildings"] = this.numberOfConnectedBuildings;
        data["connectedBuildingsAreaM2"] = this.connectedBuildingsAreaM2;
        data["hasNearbyUnconnectedBuildings"] = this.hasNearbyUnconnectedBuildings;
        data["technologyType"] = this.technologyType;
        data["usageType"] = this.usageType;
        data["annualEnergyConsumptionKWh"] = this.annualEnergyConsumptionKWh;
        data["annualCoolingProductionTonHours"] = this.annualCoolingProductionTonHours;
        data["peakCoolingLoadTR"] = this.peakCoolingLoadTR;
        data["annualWaterConsumptionM3"] = this.annualWaterConsumptionM3;
        data["annualPlantEfficiency"] = this.annualPlantEfficiency;
        data["annualWaterPerformance"] = this.annualWaterPerformance;
        data["hasThermalStorageTank"] = this.hasThermalStorageTank;
        data["thermalStorageCapacityM3"] = this.thermalStorageCapacityM3;
        data["waterType"] = this.waterType;
        data["makeupWaterTankCapacityM3"] = this.makeupWaterTankCapacityM3;
        data["controlSystemTypeId"] = this.controlSystemTypeId;
        data["numberOfChillers"] = this.numberOfChillers;
        data["chillerCapacityTR"] = this.chillerCapacityTR;
        data["chillerEnergyEfficiency"] = this.chillerEnergyEfficiency;
        data["numberOfPrimaryChilledWaterPumps"] = this.numberOfPrimaryChilledWaterPumps;
        data["numberOfCoolingTowers"] = this.numberOfCoolingTowers;
        data["chilledWaterSupplyTemp"] = this.chilledWaterSupplyTemp;
        data["chilledWaterReturnTemp"] = this.chilledWaterReturnTemp;
        data["notes"] = this.notes;
        data["attachments"] = this.attachments;
        data["addedStatusId"] = this.addedStatusId;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICoolingStationAssetInfoDto {
    refrenceNumber: string | undefined;
    organizationUnitId: number;
    description: string | undefined;
    regionId: number;
    city: string | undefined;
    plantCapacityTR: number;
    actualPlantCapacityTR: number | undefined;
    plantOperationDate: string | undefined;
    lastRetrofitDate: string | undefined;
    numberOfConnectedBuildings: number;
    connectedBuildingsAreaM2: number | undefined;
    hasNearbyUnconnectedBuildings: boolean | undefined;
    technologyType: number;
    usageType: number;
    annualEnergyConsumptionKWh: number;
    annualCoolingProductionTonHours: number;
    peakCoolingLoadTR: number | undefined;
    annualWaterConsumptionM3: number;
    annualPlantEfficiency: number;
    annualWaterPerformance: number | undefined;
    hasThermalStorageTank: boolean;
    thermalStorageCapacityM3: number | undefined;
    waterType: number;
    makeupWaterTankCapacityM3: number | undefined;
    controlSystemTypeId: number | undefined;
    numberOfChillers: number | undefined;
    chillerCapacityTR: number | undefined;
    chillerEnergyEfficiency: number | undefined;
    numberOfPrimaryChilledWaterPumps: number | undefined;
    numberOfCoolingTowers: number | undefined;
    chilledWaterSupplyTemp: number | undefined;
    chilledWaterReturnTemp: number | undefined;
    notes: string | undefined;
    attachments: string | undefined;
    addedStatusId: number | undefined;
    createdAt: DateTime | undefined;
    id: number;
}

export class CourseDto implements ICourseDto {
    startDateTime!: DateTime;
    endDateTime!: DateTime;
    registrationStartDateTime!: DateTime;
    registrationEndDateTime!: DateTime;
    cancellationDeadline!: number;
    availableSeats!: number;
    objectives!: string | undefined;
    importantPoints!: string | undefined;
    targetAudience!: string | undefined;
    termAndConditions!: string | undefined;
    topicId!: number;
    courseTypeId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.registrationStartDateTime = _data["registrationStartDateTime"] ? DateTime.fromISO(_data["registrationStartDateTime"].toString()) : <any>undefined;
            this.registrationEndDateTime = _data["registrationEndDateTime"] ? DateTime.fromISO(_data["registrationEndDateTime"].toString()) : <any>undefined;
            this.cancellationDeadline = _data["cancellationDeadline"];
            this.availableSeats = _data["availableSeats"];
            this.objectives = _data["objectives"];
            this.importantPoints = _data["importantPoints"];
            this.targetAudience = _data["targetAudience"];
            this.termAndConditions = _data["termAndConditions"];
            this.topicId = _data["topicId"];
            this.courseTypeId = _data["courseTypeId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["registrationStartDateTime"] = this.registrationStartDateTime ? this.registrationStartDateTime.toString() : <any>undefined;
        data["registrationEndDateTime"] = this.registrationEndDateTime ? this.registrationEndDateTime.toString() : <any>undefined;
        data["cancellationDeadline"] = this.cancellationDeadline;
        data["availableSeats"] = this.availableSeats;
        data["objectives"] = this.objectives;
        data["importantPoints"] = this.importantPoints;
        data["targetAudience"] = this.targetAudience;
        data["termAndConditions"] = this.termAndConditions;
        data["topicId"] = this.topicId;
        data["courseTypeId"] = this.courseTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICourseDto {
    startDateTime: DateTime;
    endDateTime: DateTime;
    registrationStartDateTime: DateTime;
    registrationEndDateTime: DateTime;
    cancellationDeadline: number;
    availableSeats: number;
    objectives: string | undefined;
    importantPoints: string | undefined;
    targetAudience: string | undefined;
    termAndConditions: string | undefined;
    topicId: number;
    courseTypeId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CourseTopicLookupTableDto implements ICourseTopicLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICourseTopicLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CourseTopicLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseTopicLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICourseTopicLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CourseTopicTypeLookupTableDto implements ICourseTopicTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICourseTopicTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CourseTopicTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseTopicTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICourseTopicTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CreateBuildingEnergyEfficiencySubmissionDto implements ICreateBuildingEnergyEfficiencySubmissionDto {
    hasEnergySavingPolicy!: string | undefined;
    supportingDocument!: string | undefined;
    isOrganizationIndependent!: string | undefined;
    parentOrganization!: string | undefined;
    isBuildingOlderThan12Months!: string | undefined;
    areAccountsLinkedDirectly!: string | undefined;
    doesOrganizationPayElectricityBills!: string | undefined;
    isContractedWithTarsheed!: string | undefined;
    isIncomplete!: boolean;
    buildingName!: string | undefined;
    city!: string | undefined;
    neighbourhood!: string | undefined;
    buildingType!: string | undefined;
    buildingStatus!: string | undefined;
    floorsNumber!: number;
    buildingArea!: number;
    buildingAge!: number;
    buildingUsersCount!: number;
    workingHoursCount!: number | undefined;
    conditionerType!: string | undefined;
    electricityServiceProvider!: string | undefined;
    consumptionPreviousYear!: number | undefined;
    consumptionCurrentYear!: number | undefined;
    electricityAccounts!: string | undefined;
    energyEfficiencyActivities!: string | undefined;
    providerDocuments!: string | undefined;
    buildingAssetId!: number | undefined;
    addedStatusId!: number | undefined;
    organizationId!: number | undefined;
    id!: number | undefined;
    requestId!: number | undefined;
    submissionCycle!: string | undefined;
    declaration!: boolean;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: ICreateBuildingEnergyEfficiencySubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasEnergySavingPolicy = _data["hasEnergySavingPolicy"];
            this.supportingDocument = _data["supportingDocument"];
            this.isOrganizationIndependent = _data["isOrganizationIndependent"];
            this.parentOrganization = _data["parentOrganization"];
            this.isBuildingOlderThan12Months = _data["isBuildingOlderThan12Months"];
            this.areAccountsLinkedDirectly = _data["areAccountsLinkedDirectly"];
            this.doesOrganizationPayElectricityBills = _data["doesOrganizationPayElectricityBills"];
            this.isContractedWithTarsheed = _data["isContractedWithTarsheed"];
            this.isIncomplete = _data["isIncomplete"];
            this.buildingName = _data["buildingName"];
            this.city = _data["city"];
            this.neighbourhood = _data["neighbourhood"];
            this.buildingType = _data["buildingType"];
            this.buildingStatus = _data["buildingStatus"];
            this.floorsNumber = _data["floorsNumber"];
            this.buildingArea = _data["buildingArea"];
            this.buildingAge = _data["buildingAge"];
            this.buildingUsersCount = _data["buildingUsersCount"];
            this.workingHoursCount = _data["workingHoursCount"];
            this.conditionerType = _data["conditionerType"];
            this.electricityServiceProvider = _data["electricityServiceProvider"];
            this.consumptionPreviousYear = _data["consumptionPreviousYear"];
            this.consumptionCurrentYear = _data["consumptionCurrentYear"];
            this.electricityAccounts = _data["electricityAccounts"];
            this.energyEfficiencyActivities = _data["energyEfficiencyActivities"];
            this.providerDocuments = _data["providerDocuments"];
            this.buildingAssetId = _data["buildingAssetId"];
            this.addedStatusId = _data["addedStatusId"];
            this.organizationId = _data["organizationId"];
            this.id = _data["id"];
            this.requestId = _data["requestId"];
            this.submissionCycle = _data["submissionCycle"];
            this.declaration = _data["declaration"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateBuildingEnergyEfficiencySubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBuildingEnergyEfficiencySubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasEnergySavingPolicy"] = this.hasEnergySavingPolicy;
        data["supportingDocument"] = this.supportingDocument;
        data["isOrganizationIndependent"] = this.isOrganizationIndependent;
        data["parentOrganization"] = this.parentOrganization;
        data["isBuildingOlderThan12Months"] = this.isBuildingOlderThan12Months;
        data["areAccountsLinkedDirectly"] = this.areAccountsLinkedDirectly;
        data["doesOrganizationPayElectricityBills"] = this.doesOrganizationPayElectricityBills;
        data["isContractedWithTarsheed"] = this.isContractedWithTarsheed;
        data["isIncomplete"] = this.isIncomplete;
        data["buildingName"] = this.buildingName;
        data["city"] = this.city;
        data["neighbourhood"] = this.neighbourhood;
        data["buildingType"] = this.buildingType;
        data["buildingStatus"] = this.buildingStatus;
        data["floorsNumber"] = this.floorsNumber;
        data["buildingArea"] = this.buildingArea;
        data["buildingAge"] = this.buildingAge;
        data["buildingUsersCount"] = this.buildingUsersCount;
        data["workingHoursCount"] = this.workingHoursCount;
        data["conditionerType"] = this.conditionerType;
        data["electricityServiceProvider"] = this.electricityServiceProvider;
        data["consumptionPreviousYear"] = this.consumptionPreviousYear;
        data["consumptionCurrentYear"] = this.consumptionCurrentYear;
        data["electricityAccounts"] = this.electricityAccounts;
        data["energyEfficiencyActivities"] = this.energyEfficiencyActivities;
        data["providerDocuments"] = this.providerDocuments;
        data["buildingAssetId"] = this.buildingAssetId;
        data["addedStatusId"] = this.addedStatusId;
        data["organizationId"] = this.organizationId;
        data["id"] = this.id;
        data["requestId"] = this.requestId;
        data["submissionCycle"] = this.submissionCycle;
        data["declaration"] = this.declaration;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateBuildingEnergyEfficiencySubmissionDto {
    hasEnergySavingPolicy: string | undefined;
    supportingDocument: string | undefined;
    isOrganizationIndependent: string | undefined;
    parentOrganization: string | undefined;
    isBuildingOlderThan12Months: string | undefined;
    areAccountsLinkedDirectly: string | undefined;
    doesOrganizationPayElectricityBills: string | undefined;
    isContractedWithTarsheed: string | undefined;
    isIncomplete: boolean;
    buildingName: string | undefined;
    city: string | undefined;
    neighbourhood: string | undefined;
    buildingType: string | undefined;
    buildingStatus: string | undefined;
    floorsNumber: number;
    buildingArea: number;
    buildingAge: number;
    buildingUsersCount: number;
    workingHoursCount: number | undefined;
    conditionerType: string | undefined;
    electricityServiceProvider: string | undefined;
    consumptionPreviousYear: number | undefined;
    consumptionCurrentYear: number | undefined;
    electricityAccounts: string | undefined;
    energyEfficiencyActivities: string | undefined;
    providerDocuments: string | undefined;
    buildingAssetId: number | undefined;
    addedStatusId: number | undefined;
    organizationId: number | undefined;
    id: number | undefined;
    requestId: number | undefined;
    submissionCycle: string | undefined;
    declaration: boolean;
    lastModificationTime: DateTime | undefined;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionCreateDto.fromJS(_data["edition"]) : new EditionCreateDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[];
}

export class CreateGovElectricityConsumptionDataDto implements ICreateGovElectricityConsumptionDataDto {
    id!: number;
    key!: string | undefined;
    govElectricityId!: number;
    electricityProviderEntityId!: number;
    meterTypeId!: number;
    numberOfOwnedBuildings!: number | undefined;
    consumptionOfOwnedBuildings!: number;
    costOfOwnedBuildings!: number;
    numberOfRentedBuildings!: number | undefined;
    consumptionOfRentedBuildings!: number;
    costOfRentedBuildings!: number;
    numberOfOwnedFloors!: number | undefined;
    consumptionOfOwnedFloors!: number;
    costOfOwnedFloors!: number;
    numberOfRentedFloors!: number | undefined;
    consumptionOfRentedFloors!: number;
    costOfRentedFloors!: number;
    comment!: string | undefined;
    creatorUserId!: number | undefined;
    recordIndex!: number;
    totalConsumptions!: number;
    totalCosts!: number;

    constructor(data?: ICreateGovElectricityConsumptionDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.govElectricityId = _data["govElectricityId"];
            this.electricityProviderEntityId = _data["electricityProviderEntityId"];
            this.meterTypeId = _data["meterTypeId"];
            this.numberOfOwnedBuildings = _data["numberOfOwnedBuildings"];
            this.consumptionOfOwnedBuildings = _data["consumptionOfOwnedBuildings"];
            this.costOfOwnedBuildings = _data["costOfOwnedBuildings"];
            this.numberOfRentedBuildings = _data["numberOfRentedBuildings"];
            this.consumptionOfRentedBuildings = _data["consumptionOfRentedBuildings"];
            this.costOfRentedBuildings = _data["costOfRentedBuildings"];
            this.numberOfOwnedFloors = _data["numberOfOwnedFloors"];
            this.consumptionOfOwnedFloors = _data["consumptionOfOwnedFloors"];
            this.costOfOwnedFloors = _data["costOfOwnedFloors"];
            this.numberOfRentedFloors = _data["numberOfRentedFloors"];
            this.consumptionOfRentedFloors = _data["consumptionOfRentedFloors"];
            this.costOfRentedFloors = _data["costOfRentedFloors"];
            this.comment = _data["comment"];
            this.creatorUserId = _data["creatorUserId"];
            this.recordIndex = _data["recordIndex"];
            this.totalConsumptions = _data["totalConsumptions"];
            this.totalCosts = _data["totalCosts"];
        }
    }

    static fromJS(data: any): CreateGovElectricityConsumptionDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGovElectricityConsumptionDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["govElectricityId"] = this.govElectricityId;
        data["electricityProviderEntityId"] = this.electricityProviderEntityId;
        data["meterTypeId"] = this.meterTypeId;
        data["numberOfOwnedBuildings"] = this.numberOfOwnedBuildings;
        data["consumptionOfOwnedBuildings"] = this.consumptionOfOwnedBuildings;
        data["costOfOwnedBuildings"] = this.costOfOwnedBuildings;
        data["numberOfRentedBuildings"] = this.numberOfRentedBuildings;
        data["consumptionOfRentedBuildings"] = this.consumptionOfRentedBuildings;
        data["costOfRentedBuildings"] = this.costOfRentedBuildings;
        data["numberOfOwnedFloors"] = this.numberOfOwnedFloors;
        data["consumptionOfOwnedFloors"] = this.consumptionOfOwnedFloors;
        data["costOfOwnedFloors"] = this.costOfOwnedFloors;
        data["numberOfRentedFloors"] = this.numberOfRentedFloors;
        data["consumptionOfRentedFloors"] = this.consumptionOfRentedFloors;
        data["costOfRentedFloors"] = this.costOfRentedFloors;
        data["comment"] = this.comment;
        data["creatorUserId"] = this.creatorUserId;
        data["recordIndex"] = this.recordIndex;
        data["totalConsumptions"] = this.totalConsumptions;
        data["totalCosts"] = this.totalCosts;
        return data;
    }
}

export interface ICreateGovElectricityConsumptionDataDto {
    id: number;
    key: string | undefined;
    govElectricityId: number;
    electricityProviderEntityId: number;
    meterTypeId: number;
    numberOfOwnedBuildings: number | undefined;
    consumptionOfOwnedBuildings: number;
    costOfOwnedBuildings: number;
    numberOfRentedBuildings: number | undefined;
    consumptionOfRentedBuildings: number;
    costOfRentedBuildings: number;
    numberOfOwnedFloors: number | undefined;
    consumptionOfOwnedFloors: number;
    costOfOwnedFloors: number;
    numberOfRentedFloors: number | undefined;
    consumptionOfRentedFloors: number;
    costOfRentedFloors: number;
    comment: string | undefined;
    creatorUserId: number | undefined;
    recordIndex: number;
    totalConsumptions: number;
    totalCosts: number;
}

export class CreateOrEditAttendeeInfoDto implements ICreateOrEditAttendeeInfoDto {
    attendeeFullName!: string;
    mobileNumber!: string | undefined;
    email!: string | undefined;
    dateOfBirth!: DateTime;
    idNumber!: string | undefined;
    creationTime!: DateTime;
    lastModificationTime!: DateTime | undefined;
    isDeleted!: boolean;
    deletionTime!: DateTime | undefined;
    randomGeneratedIndex!: number | undefined;
    trainingRequestId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAttendeeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendeeFullName = _data["attendeeFullName"];
            this.mobileNumber = _data["mobileNumber"];
            this.email = _data["email"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.idNumber = _data["idNumber"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.randomGeneratedIndex = _data["randomGeneratedIndex"];
            this.trainingRequestId = _data["trainingRequestId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAttendeeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAttendeeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendeeFullName"] = this.attendeeFullName;
        data["mobileNumber"] = this.mobileNumber;
        data["email"] = this.email;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toString() : <any>undefined;
        data["idNumber"] = this.idNumber;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["randomGeneratedIndex"] = this.randomGeneratedIndex;
        data["trainingRequestId"] = this.trainingRequestId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAttendeeInfoDto {
    attendeeFullName: string;
    mobileNumber: string | undefined;
    email: string | undefined;
    dateOfBirth: DateTime;
    idNumber: string | undefined;
    creationTime: DateTime;
    lastModificationTime: DateTime | undefined;
    isDeleted: boolean;
    deletionTime: DateTime | undefined;
    randomGeneratedIndex: number | undefined;
    trainingRequestId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditAwarnessContentDto implements ICreateOrEditAwarnessContentDto {
    contentNumber!: string | undefined;
    contentName!: string;
    attachmentId!: string | undefined;
    awarenessContentClassificationId!: number;
    contentTypeId!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAwarnessContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentNumber = _data["contentNumber"];
            this.contentName = _data["contentName"];
            this.attachmentId = _data["attachmentId"];
            this.awarenessContentClassificationId = _data["awarenessContentClassificationId"];
            this.contentTypeId = _data["contentTypeId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAwarnessContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAwarnessContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentNumber"] = this.contentNumber;
        data["contentName"] = this.contentName;
        data["attachmentId"] = this.attachmentId;
        data["awarenessContentClassificationId"] = this.awarenessContentClassificationId;
        data["contentTypeId"] = this.contentTypeId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAwarnessContentDto {
    contentNumber: string | undefined;
    contentName: string;
    attachmentId: string | undefined;
    awarenessContentClassificationId: number;
    contentTypeId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditBuildingAssetInfoDto implements ICreateOrEditBuildingAssetInfoDto {
    refrenceNumber!: string | undefined;
    organizationUnitId!: number;
    name!: string;
    address!: string | undefined;
    regionId!: number;
    cityName!: string;
    ownership!: number | undefined;
    assetTypeId!: number | undefined;
    assetSubTypeId!: number | undefined;
    grossArea!: number;
    numberOfFloors!: number;
    constructionDate!: string;
    lastRetrofitYear!: string | undefined;
    buildingStatusId!: number;
    tarshidRetrofit!: boolean;
    buildingOccupants!: number;
    operatingHoursPerWeek!: number;
    operationStartTime!: string;
    notes!: string | undefined;
    attachments!: string | undefined;
    electricityAccounts!: CreateOrEditBuildingElectricityAccountDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBuildingAssetInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refrenceNumber = _data["refrenceNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.regionId = _data["regionId"];
            this.cityName = _data["cityName"];
            this.ownership = _data["ownership"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetSubTypeId = _data["assetSubTypeId"];
            this.grossArea = _data["grossArea"];
            this.numberOfFloors = _data["numberOfFloors"];
            this.constructionDate = _data["constructionDate"];
            this.lastRetrofitYear = _data["lastRetrofitYear"];
            this.buildingStatusId = _data["buildingStatusId"];
            this.tarshidRetrofit = _data["tarshidRetrofit"];
            this.buildingOccupants = _data["buildingOccupants"];
            this.operatingHoursPerWeek = _data["operatingHoursPerWeek"];
            this.operationStartTime = _data["operationStartTime"];
            this.notes = _data["notes"];
            this.attachments = _data["attachments"];
            if (Array.isArray(_data["electricityAccounts"])) {
                this.electricityAccounts = [] as any;
                for (let item of _data["electricityAccounts"])
                    this.electricityAccounts!.push(CreateOrEditBuildingElectricityAccountDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBuildingAssetInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBuildingAssetInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refrenceNumber"] = this.refrenceNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["regionId"] = this.regionId;
        data["cityName"] = this.cityName;
        data["ownership"] = this.ownership;
        data["assetTypeId"] = this.assetTypeId;
        data["assetSubTypeId"] = this.assetSubTypeId;
        data["grossArea"] = this.grossArea;
        data["numberOfFloors"] = this.numberOfFloors;
        data["constructionDate"] = this.constructionDate;
        data["lastRetrofitYear"] = this.lastRetrofitYear;
        data["buildingStatusId"] = this.buildingStatusId;
        data["tarshidRetrofit"] = this.tarshidRetrofit;
        data["buildingOccupants"] = this.buildingOccupants;
        data["operatingHoursPerWeek"] = this.operatingHoursPerWeek;
        data["operationStartTime"] = this.operationStartTime;
        data["notes"] = this.notes;
        data["attachments"] = this.attachments;
        if (Array.isArray(this.electricityAccounts)) {
            data["electricityAccounts"] = [];
            for (let item of this.electricityAccounts)
                data["electricityAccounts"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBuildingAssetInfoDto {
    refrenceNumber: string | undefined;
    organizationUnitId: number;
    name: string;
    address: string | undefined;
    regionId: number;
    cityName: string;
    ownership: number | undefined;
    assetTypeId: number | undefined;
    assetSubTypeId: number | undefined;
    grossArea: number;
    numberOfFloors: number;
    constructionDate: string;
    lastRetrofitYear: string | undefined;
    buildingStatusId: number;
    tarshidRetrofit: boolean;
    buildingOccupants: number;
    operatingHoursPerWeek: number;
    operationStartTime: string;
    notes: string | undefined;
    attachments: string | undefined;
    electricityAccounts: CreateOrEditBuildingElectricityAccountDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditBuildingElectricityAccountDto implements ICreateOrEditBuildingElectricityAccountDto {
    serviceProviderId!: number;
    seAccountNumber!: string;
    voltageGroupId!: number;
    hasDistrictCooling!: boolean;
    coolingTariff!: string | undefined;
    isShared!: boolean;
    sharedEntityId!: number | undefined;
    otherOrganizationName!: string | undefined;
    occupancyPercentage!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBuildingElectricityAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceProviderId = _data["serviceProviderId"];
            this.seAccountNumber = _data["seAccountNumber"];
            this.voltageGroupId = _data["voltageGroupId"];
            this.hasDistrictCooling = _data["hasDistrictCooling"];
            this.coolingTariff = _data["coolingTariff"];
            this.isShared = _data["isShared"];
            this.sharedEntityId = _data["sharedEntityId"];
            this.otherOrganizationName = _data["otherOrganizationName"];
            this.occupancyPercentage = _data["occupancyPercentage"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBuildingElectricityAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBuildingElectricityAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceProviderId"] = this.serviceProviderId;
        data["seAccountNumber"] = this.seAccountNumber;
        data["voltageGroupId"] = this.voltageGroupId;
        data["hasDistrictCooling"] = this.hasDistrictCooling;
        data["coolingTariff"] = this.coolingTariff;
        data["isShared"] = this.isShared;
        data["sharedEntityId"] = this.sharedEntityId;
        data["otherOrganizationName"] = this.otherOrganizationName;
        data["occupancyPercentage"] = this.occupancyPercentage;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBuildingElectricityAccountDto {
    serviceProviderId: number;
    seAccountNumber: string;
    voltageGroupId: number;
    hasDistrictCooling: boolean;
    coolingTariff: string | undefined;
    isShared: boolean;
    sharedEntityId: number | undefined;
    otherOrganizationName: string | undefined;
    occupancyPercentage: number | undefined;
    id: number | undefined;
}

export class CreateOrEditBuildingInfoDto implements ICreateOrEditBuildingInfoDto {
    buildingOccupants!: number;
    constructionDate!: DateTime;
    buildingStatusId!: number;
    regionId!: number;
    cityId!: number;
    organizationUnitId!: number;
    meterInfos!: MeterInfoDto[] | undefined;
    name!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBuildingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingOccupants = _data["buildingOccupants"];
            this.constructionDate = _data["constructionDate"] ? DateTime.fromISO(_data["constructionDate"].toString()) : <any>undefined;
            this.buildingStatusId = _data["buildingStatusId"];
            this.regionId = _data["regionId"];
            this.cityId = _data["cityId"];
            this.organizationUnitId = _data["organizationUnitId"];
            if (Array.isArray(_data["meterInfos"])) {
                this.meterInfos = [] as any;
                for (let item of _data["meterInfos"])
                    this.meterInfos!.push(MeterInfoDto.fromJS(item));
            }
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBuildingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBuildingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingOccupants"] = this.buildingOccupants;
        data["constructionDate"] = this.constructionDate ? this.constructionDate.toString() : <any>undefined;
        data["buildingStatusId"] = this.buildingStatusId;
        data["regionId"] = this.regionId;
        data["cityId"] = this.cityId;
        data["organizationUnitId"] = this.organizationUnitId;
        if (Array.isArray(this.meterInfos)) {
            data["meterInfos"] = [];
            for (let item of this.meterInfos)
                data["meterInfos"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBuildingInfoDto {
    buildingOccupants: number;
    constructionDate: DateTime;
    buildingStatusId: number;
    regionId: number;
    cityId: number;
    organizationUnitId: number;
    meterInfos: MeterInfoDto[] | undefined;
    name: string;
    id: number | undefined;
}

export class CreateOrEditChecklistDto implements ICreateOrEditChecklistDto {
    mainActivities!: MainActivityDto[] | undefined;
    organaizationActivityId!: number | undefined;
    planYear!: string | undefined;

    constructor(data?: ICreateOrEditChecklistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mainActivities"])) {
                this.mainActivities = [] as any;
                for (let item of _data["mainActivities"])
                    this.mainActivities!.push(MainActivityDto.fromJS(item));
            }
            this.organaizationActivityId = _data["organaizationActivityId"];
            this.planYear = _data["planYear"];
        }
    }

    static fromJS(data: any): CreateOrEditChecklistDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditChecklistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mainActivities)) {
            data["mainActivities"] = [];
            for (let item of this.mainActivities)
                data["mainActivities"].push(item.toJSON());
        }
        data["organaizationActivityId"] = this.organaizationActivityId;
        data["planYear"] = this.planYear;
        return data;
    }
}

export interface ICreateOrEditChecklistDto {
    mainActivities: MainActivityDto[] | undefined;
    organaizationActivityId: number | undefined;
    planYear: string | undefined;
}

export class CreateOrEditCoolingStationAssetInfoDto implements ICreateOrEditCoolingStationAssetInfoDto {
    refrenceNumber!: string | undefined;
    organizationUnitId!: number;
    description!: string | undefined;
    regionId!: number;
    city!: string;
    plantCapacityTR!: number;
    actualPlantCapacityTR!: number | undefined;
    plantOperationDate!: string;
    lastRetrofitDate!: string | undefined;
    numberOfConnectedBuildings!: number;
    connectedBuildingsAreaM2!: number | undefined;
    hasNearbyUnconnectedBuildings!: boolean | undefined;
    technologyType!: number;
    usageType!: number;
    annualEnergyConsumptionKWh!: number;
    annualCoolingProductionTonHours!: number;
    peakCoolingLoadTR!: number | undefined;
    annualWaterConsumptionM3!: number;
    annualPlantEfficiency!: number;
    annualWaterPerformance!: number | undefined;
    hasThermalStorageTank!: boolean;
    thermalStorageCapacityM3!: number | undefined;
    waterType!: number;
    makeupWaterTankCapacityM3!: number | undefined;
    controlSystemTypeId!: number | undefined;
    numberOfChillers!: number | undefined;
    chillerCapacityTR!: number | undefined;
    chillerEnergyEfficiency!: number | undefined;
    numberOfPrimaryChilledWaterPumps!: number | undefined;
    numberOfCoolingTowers!: number | undefined;
    chilledWaterSupplyTemp!: number | undefined;
    chilledWaterReturnTemp!: number | undefined;
    notes!: string | undefined;
    attachments!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCoolingStationAssetInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refrenceNumber = _data["refrenceNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.description = _data["description"];
            this.regionId = _data["regionId"];
            this.city = _data["city"];
            this.plantCapacityTR = _data["plantCapacityTR"];
            this.actualPlantCapacityTR = _data["actualPlantCapacityTR"];
            this.plantOperationDate = _data["plantOperationDate"];
            this.lastRetrofitDate = _data["lastRetrofitDate"];
            this.numberOfConnectedBuildings = _data["numberOfConnectedBuildings"];
            this.connectedBuildingsAreaM2 = _data["connectedBuildingsAreaM2"];
            this.hasNearbyUnconnectedBuildings = _data["hasNearbyUnconnectedBuildings"];
            this.technologyType = _data["technologyType"];
            this.usageType = _data["usageType"];
            this.annualEnergyConsumptionKWh = _data["annualEnergyConsumptionKWh"];
            this.annualCoolingProductionTonHours = _data["annualCoolingProductionTonHours"];
            this.peakCoolingLoadTR = _data["peakCoolingLoadTR"];
            this.annualWaterConsumptionM3 = _data["annualWaterConsumptionM3"];
            this.annualPlantEfficiency = _data["annualPlantEfficiency"];
            this.annualWaterPerformance = _data["annualWaterPerformance"];
            this.hasThermalStorageTank = _data["hasThermalStorageTank"];
            this.thermalStorageCapacityM3 = _data["thermalStorageCapacityM3"];
            this.waterType = _data["waterType"];
            this.makeupWaterTankCapacityM3 = _data["makeupWaterTankCapacityM3"];
            this.controlSystemTypeId = _data["controlSystemTypeId"];
            this.numberOfChillers = _data["numberOfChillers"];
            this.chillerCapacityTR = _data["chillerCapacityTR"];
            this.chillerEnergyEfficiency = _data["chillerEnergyEfficiency"];
            this.numberOfPrimaryChilledWaterPumps = _data["numberOfPrimaryChilledWaterPumps"];
            this.numberOfCoolingTowers = _data["numberOfCoolingTowers"];
            this.chilledWaterSupplyTemp = _data["chilledWaterSupplyTemp"];
            this.chilledWaterReturnTemp = _data["chilledWaterReturnTemp"];
            this.notes = _data["notes"];
            this.attachments = _data["attachments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCoolingStationAssetInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCoolingStationAssetInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refrenceNumber"] = this.refrenceNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["description"] = this.description;
        data["regionId"] = this.regionId;
        data["city"] = this.city;
        data["plantCapacityTR"] = this.plantCapacityTR;
        data["actualPlantCapacityTR"] = this.actualPlantCapacityTR;
        data["plantOperationDate"] = this.plantOperationDate;
        data["lastRetrofitDate"] = this.lastRetrofitDate;
        data["numberOfConnectedBuildings"] = this.numberOfConnectedBuildings;
        data["connectedBuildingsAreaM2"] = this.connectedBuildingsAreaM2;
        data["hasNearbyUnconnectedBuildings"] = this.hasNearbyUnconnectedBuildings;
        data["technologyType"] = this.technologyType;
        data["usageType"] = this.usageType;
        data["annualEnergyConsumptionKWh"] = this.annualEnergyConsumptionKWh;
        data["annualCoolingProductionTonHours"] = this.annualCoolingProductionTonHours;
        data["peakCoolingLoadTR"] = this.peakCoolingLoadTR;
        data["annualWaterConsumptionM3"] = this.annualWaterConsumptionM3;
        data["annualPlantEfficiency"] = this.annualPlantEfficiency;
        data["annualWaterPerformance"] = this.annualWaterPerformance;
        data["hasThermalStorageTank"] = this.hasThermalStorageTank;
        data["thermalStorageCapacityM3"] = this.thermalStorageCapacityM3;
        data["waterType"] = this.waterType;
        data["makeupWaterTankCapacityM3"] = this.makeupWaterTankCapacityM3;
        data["controlSystemTypeId"] = this.controlSystemTypeId;
        data["numberOfChillers"] = this.numberOfChillers;
        data["chillerCapacityTR"] = this.chillerCapacityTR;
        data["chillerEnergyEfficiency"] = this.chillerEnergyEfficiency;
        data["numberOfPrimaryChilledWaterPumps"] = this.numberOfPrimaryChilledWaterPumps;
        data["numberOfCoolingTowers"] = this.numberOfCoolingTowers;
        data["chilledWaterSupplyTemp"] = this.chilledWaterSupplyTemp;
        data["chilledWaterReturnTemp"] = this.chilledWaterReturnTemp;
        data["notes"] = this.notes;
        data["attachments"] = this.attachments;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCoolingStationAssetInfoDto {
    refrenceNumber: string | undefined;
    organizationUnitId: number;
    description: string | undefined;
    regionId: number;
    city: string;
    plantCapacityTR: number;
    actualPlantCapacityTR: number | undefined;
    plantOperationDate: string;
    lastRetrofitDate: string | undefined;
    numberOfConnectedBuildings: number;
    connectedBuildingsAreaM2: number | undefined;
    hasNearbyUnconnectedBuildings: boolean | undefined;
    technologyType: number;
    usageType: number;
    annualEnergyConsumptionKWh: number;
    annualCoolingProductionTonHours: number;
    peakCoolingLoadTR: number | undefined;
    annualWaterConsumptionM3: number;
    annualPlantEfficiency: number;
    annualWaterPerformance: number | undefined;
    hasThermalStorageTank: boolean;
    thermalStorageCapacityM3: number | undefined;
    waterType: number;
    makeupWaterTankCapacityM3: number | undefined;
    controlSystemTypeId: number | undefined;
    numberOfChillers: number | undefined;
    chillerCapacityTR: number | undefined;
    chillerEnergyEfficiency: number | undefined;
    numberOfPrimaryChilledWaterPumps: number | undefined;
    numberOfCoolingTowers: number | undefined;
    chilledWaterSupplyTemp: number | undefined;
    chilledWaterReturnTemp: number | undefined;
    notes: string | undefined;
    attachments: string | undefined;
    id: number | undefined;
}

export class CreateOrEditCourseDto implements ICreateOrEditCourseDto {
    startDateTime!: DateTime;
    startTime!: string;
    endDateTime!: DateTime;
    endTime!: string;
    registrationStartDateTime!: DateTime;
    registrationStartTime!: string;
    registrationEndDateTime!: DateTime;
    registrationEndTime!: string;
    cancellationDeadline!: number;
    availableSeats!: number;
    objectives!: string | undefined;
    importantPoints!: string | undefined;
    targetAudience!: string | undefined;
    termAndConditions!: string | undefined;
    topicId!: number;
    courseTypeId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateTime = _data["startDateTime"] ? DateTime.fromISO(_data["startDateTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"];
            this.endDateTime = _data["endDateTime"] ? DateTime.fromISO(_data["endDateTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"];
            this.registrationStartDateTime = _data["registrationStartDateTime"] ? DateTime.fromISO(_data["registrationStartDateTime"].toString()) : <any>undefined;
            this.registrationStartTime = _data["registrationStartTime"];
            this.registrationEndDateTime = _data["registrationEndDateTime"] ? DateTime.fromISO(_data["registrationEndDateTime"].toString()) : <any>undefined;
            this.registrationEndTime = _data["registrationEndTime"];
            this.cancellationDeadline = _data["cancellationDeadline"];
            this.availableSeats = _data["availableSeats"];
            this.objectives = _data["objectives"];
            this.importantPoints = _data["importantPoints"];
            this.targetAudience = _data["targetAudience"];
            this.termAndConditions = _data["termAndConditions"];
            this.topicId = _data["topicId"];
            this.courseTypeId = _data["courseTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toString() : <any>undefined;
        data["endTime"] = this.endTime;
        data["registrationStartDateTime"] = this.registrationStartDateTime ? this.registrationStartDateTime.toString() : <any>undefined;
        data["registrationStartTime"] = this.registrationStartTime;
        data["registrationEndDateTime"] = this.registrationEndDateTime ? this.registrationEndDateTime.toString() : <any>undefined;
        data["registrationEndTime"] = this.registrationEndTime;
        data["cancellationDeadline"] = this.cancellationDeadline;
        data["availableSeats"] = this.availableSeats;
        data["objectives"] = this.objectives;
        data["importantPoints"] = this.importantPoints;
        data["targetAudience"] = this.targetAudience;
        data["termAndConditions"] = this.termAndConditions;
        data["topicId"] = this.topicId;
        data["courseTypeId"] = this.courseTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCourseDto {
    startDateTime: DateTime;
    startTime: string;
    endDateTime: DateTime;
    endTime: string;
    registrationStartDateTime: DateTime;
    registrationStartTime: string;
    registrationEndDateTime: DateTime;
    registrationEndTime: string;
    cancellationDeadline: number;
    availableSeats: number;
    objectives: string | undefined;
    importantPoints: string | undefined;
    targetAudience: string | undefined;
    termAndConditions: string | undefined;
    topicId: number;
    courseTypeId: number;
    id: number | undefined;
}

export class CreateOrEditCustomAreaOfImprovementDto implements ICreateOrEditCustomAreaOfImprovementDto {
    description!: string;
    organizationEEPId!: number | undefined;
    eepAreaOfImprovementId!: number;
    eepAreaOfImprovementNatureId!: number;
    organizationUnitId!: number;
    parentAreaOfImprovment!: string | undefined;
    improvmentNature!: string | undefined;
    isFuel!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCustomAreaOfImprovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.organizationEEPId = _data["organizationEEPId"];
            this.eepAreaOfImprovementId = _data["eepAreaOfImprovementId"];
            this.eepAreaOfImprovementNatureId = _data["eepAreaOfImprovementNatureId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.parentAreaOfImprovment = _data["parentAreaOfImprovment"];
            this.improvmentNature = _data["improvmentNature"];
            this.isFuel = _data["isFuel"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCustomAreaOfImprovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCustomAreaOfImprovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["organizationEEPId"] = this.organizationEEPId;
        data["eepAreaOfImprovementId"] = this.eepAreaOfImprovementId;
        data["eepAreaOfImprovementNatureId"] = this.eepAreaOfImprovementNatureId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["parentAreaOfImprovment"] = this.parentAreaOfImprovment;
        data["improvmentNature"] = this.improvmentNature;
        data["isFuel"] = this.isFuel;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCustomAreaOfImprovementDto {
    description: string;
    organizationEEPId: number | undefined;
    eepAreaOfImprovementId: number;
    eepAreaOfImprovementNatureId: number;
    organizationUnitId: number;
    parentAreaOfImprovment: string | undefined;
    improvmentNature: string | undefined;
    isFuel: boolean | undefined;
    id: number | undefined;
}

export class CreateOrEditEEPRequestDeadlineSettingDto implements ICreateOrEditEEPRequestDeadlineSettingDto {
    year!: string | undefined;
    lastDueDateSubmission!: DateTime | undefined;
    isDefault!: boolean | undefined;
    lastDueDateSubmissionPeriod!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEEPRequestDeadlineSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.lastDueDateSubmission = _data["lastDueDateSubmission"] ? DateTime.fromISO(_data["lastDueDateSubmission"].toString()) : <any>undefined;
            this.isDefault = _data["isDefault"];
            this.lastDueDateSubmissionPeriod = _data["lastDueDateSubmissionPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEEPRequestDeadlineSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEEPRequestDeadlineSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["lastDueDateSubmission"] = this.lastDueDateSubmission ? this.lastDueDateSubmission.toString() : <any>undefined;
        data["isDefault"] = this.isDefault;
        data["lastDueDateSubmissionPeriod"] = this.lastDueDateSubmissionPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEEPRequestDeadlineSettingDto {
    year: string | undefined;
    lastDueDateSubmission: DateTime | undefined;
    isDefault: boolean | undefined;
    lastDueDateSubmissionPeriod: string | undefined;
    id: number | undefined;
}

export class CreateOrEditEfficiencyPlanDto implements ICreateOrEditEfficiencyPlanDto {
    planYear!: string | undefined;
    tabIndex!: number | undefined;
    isDraft!: boolean;
    organizationUnitId!: number;
    requestId!: number | undefined;
    organizationActivityId!: number | undefined;
    electricityEepId!: number | undefined;
    fuelEepId!: number | undefined;
    addFuelEep!: boolean;
    electricityEep!: CreateOrEditOrganizationEEPDto;
    fuelEep!: CreateOrEditOrganizationEEPDto;
    checklist!: CreateOrEditChecklistDto;
    isSubmit!: boolean;
    isAutoApprove!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEfficiencyPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planYear = _data["planYear"];
            this.tabIndex = _data["tabIndex"];
            this.isDraft = _data["isDraft"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.requestId = _data["requestId"];
            this.organizationActivityId = _data["organizationActivityId"];
            this.electricityEepId = _data["electricityEepId"];
            this.fuelEepId = _data["fuelEepId"];
            this.addFuelEep = _data["addFuelEep"];
            this.electricityEep = _data["electricityEep"] ? CreateOrEditOrganizationEEPDto.fromJS(_data["electricityEep"]) : <any>undefined;
            this.fuelEep = _data["fuelEep"] ? CreateOrEditOrganizationEEPDto.fromJS(_data["fuelEep"]) : <any>undefined;
            this.checklist = _data["checklist"] ? CreateOrEditChecklistDto.fromJS(_data["checklist"]) : <any>undefined;
            this.isSubmit = _data["isSubmit"];
            this.isAutoApprove = _data["isAutoApprove"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEfficiencyPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEfficiencyPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planYear"] = this.planYear;
        data["tabIndex"] = this.tabIndex;
        data["isDraft"] = this.isDraft;
        data["organizationUnitId"] = this.organizationUnitId;
        data["requestId"] = this.requestId;
        data["organizationActivityId"] = this.organizationActivityId;
        data["electricityEepId"] = this.electricityEepId;
        data["fuelEepId"] = this.fuelEepId;
        data["addFuelEep"] = this.addFuelEep;
        data["electricityEep"] = this.electricityEep ? this.electricityEep.toJSON() : <any>undefined;
        data["fuelEep"] = this.fuelEep ? this.fuelEep.toJSON() : <any>undefined;
        data["checklist"] = this.checklist ? this.checklist.toJSON() : <any>undefined;
        data["isSubmit"] = this.isSubmit;
        data["isAutoApprove"] = this.isAutoApprove;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEfficiencyPlanDto {
    planYear: string | undefined;
    tabIndex: number | undefined;
    isDraft: boolean;
    organizationUnitId: number;
    requestId: number | undefined;
    organizationActivityId: number | undefined;
    electricityEepId: number | undefined;
    fuelEepId: number | undefined;
    addFuelEep: boolean;
    electricityEep: CreateOrEditOrganizationEEPDto;
    fuelEep: CreateOrEditOrganizationEEPDto;
    checklist: CreateOrEditChecklistDto;
    isSubmit: boolean;
    isAutoApprove: boolean | undefined;
    id: number | undefined;
}

export class CreateOrEditEmailDto implements ICreateOrEditEmailDto {
    senderEmailAddress!: string | undefined;
    receiverEmailAddress!: string;
    emailSubject!: string;
    emailBody!: string;
    isSent!: boolean;
    errorType!: string | undefined;
    errorCode!: string | undefined;
    errorMessage!: string | undefined;
    reTryCounter!: number;
    machineName!: string | undefined;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderEmailAddress = _data["senderEmailAddress"];
            this.receiverEmailAddress = _data["receiverEmailAddress"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.isSent = _data["isSent"];
            this.errorType = _data["errorType"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.reTryCounter = _data["reTryCounter"];
            this.machineName = _data["machineName"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senderEmailAddress"] = this.senderEmailAddress;
        data["receiverEmailAddress"] = this.receiverEmailAddress;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["isSent"] = this.isSent;
        data["errorType"] = this.errorType;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["reTryCounter"] = this.reTryCounter;
        data["machineName"] = this.machineName;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmailDto {
    senderEmailAddress: string | undefined;
    receiverEmailAddress: string;
    emailSubject: string;
    emailBody: string;
    isSent: boolean;
    errorType: string | undefined;
    errorCode: string | undefined;
    errorMessage: string | undefined;
    reTryCounter: number;
    machineName: string | undefined;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    id: number | undefined;
}

export class CreateOrEditEmailTemplateDto implements ICreateOrEditEmailTemplateDto {
    name!: string;
    emailSubject!: string;
    emailBody!: string;
    isTemplateActive!: boolean;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.isTemplateActive = _data["isTemplateActive"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["isTemplateActive"] = this.isTemplateActive;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmailTemplateDto {
    name: string;
    emailSubject: string;
    emailBody: string;
    isTemplateActive: boolean;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    id: number | undefined;
}

export class CreateOrEditFuelAssetInfoDto implements ICreateOrEditFuelAssetInfoDto {
    refrenceNumber!: string | undefined;
    organizationUnitId!: number;
    description!: string | undefined;
    assetTypeId!: number | undefined;
    assetSubTypeId!: number | undefined;
    otherAssetSubTypeName!: string | undefined;
    fuelTypeId!: number;
    fuelUnitId!: number;
    totalFuelConsumptionPerYear!: number;
    manufacturerYear!: string;
    usageMetric!: number | undefined;
    notes!: string | undefined;
    attachments!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFuelAssetInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refrenceNumber = _data["refrenceNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.description = _data["description"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetSubTypeId = _data["assetSubTypeId"];
            this.otherAssetSubTypeName = _data["otherAssetSubTypeName"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.fuelUnitId = _data["fuelUnitId"];
            this.totalFuelConsumptionPerYear = _data["totalFuelConsumptionPerYear"];
            this.manufacturerYear = _data["manufacturerYear"];
            this.usageMetric = _data["usageMetric"];
            this.notes = _data["notes"];
            this.attachments = _data["attachments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFuelAssetInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFuelAssetInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refrenceNumber"] = this.refrenceNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["description"] = this.description;
        data["assetTypeId"] = this.assetTypeId;
        data["assetSubTypeId"] = this.assetSubTypeId;
        data["otherAssetSubTypeName"] = this.otherAssetSubTypeName;
        data["fuelTypeId"] = this.fuelTypeId;
        data["fuelUnitId"] = this.fuelUnitId;
        data["totalFuelConsumptionPerYear"] = this.totalFuelConsumptionPerYear;
        data["manufacturerYear"] = this.manufacturerYear;
        data["usageMetric"] = this.usageMetric;
        data["notes"] = this.notes;
        data["attachments"] = this.attachments;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditFuelAssetInfoDto {
    refrenceNumber: string | undefined;
    organizationUnitId: number;
    description: string | undefined;
    assetTypeId: number | undefined;
    assetSubTypeId: number | undefined;
    otherAssetSubTypeName: string | undefined;
    fuelTypeId: number;
    fuelUnitId: number;
    totalFuelConsumptionPerYear: number;
    manufacturerYear: string;
    usageMetric: number | undefined;
    notes: string | undefined;
    attachments: string | undefined;
    id: number | undefined;
}

export class CreateOrEditFuelProviderDataDto implements ICreateOrEditFuelProviderDataDto {
    year!: string;
    organizationUnitId!: number;
    requestId!: number | undefined;
    fuelProviderUnitId!: number;
    createOrEditFuelProviderDetails!: CreateOrEditFuelProviderDetailDto[] | undefined;
    declaration!: boolean;
    requestComment!: string | undefined;
    requestStatusId!: number | undefined;
    submittedOnTime!: boolean | undefined;
    isManualEntry!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFuelProviderDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.requestId = _data["requestId"];
            this.fuelProviderUnitId = _data["fuelProviderUnitId"];
            if (Array.isArray(_data["createOrEditFuelProviderDetails"])) {
                this.createOrEditFuelProviderDetails = [] as any;
                for (let item of _data["createOrEditFuelProviderDetails"])
                    this.createOrEditFuelProviderDetails!.push(CreateOrEditFuelProviderDetailDto.fromJS(item));
            }
            this.declaration = _data["declaration"];
            this.requestComment = _data["requestComment"];
            this.requestStatusId = _data["requestStatusId"];
            this.submittedOnTime = _data["submittedOnTime"];
            this.isManualEntry = _data["isManualEntry"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFuelProviderDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFuelProviderDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["organizationUnitId"] = this.organizationUnitId;
        data["requestId"] = this.requestId;
        data["fuelProviderUnitId"] = this.fuelProviderUnitId;
        if (Array.isArray(this.createOrEditFuelProviderDetails)) {
            data["createOrEditFuelProviderDetails"] = [];
            for (let item of this.createOrEditFuelProviderDetails)
                data["createOrEditFuelProviderDetails"].push(item.toJSON());
        }
        data["declaration"] = this.declaration;
        data["requestComment"] = this.requestComment;
        data["requestStatusId"] = this.requestStatusId;
        data["submittedOnTime"] = this.submittedOnTime;
        data["isManualEntry"] = this.isManualEntry;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditFuelProviderDataDto {
    year: string;
    organizationUnitId: number;
    requestId: number | undefined;
    fuelProviderUnitId: number;
    createOrEditFuelProviderDetails: CreateOrEditFuelProviderDetailDto[] | undefined;
    declaration: boolean;
    requestComment: string | undefined;
    requestStatusId: number | undefined;
    submittedOnTime: boolean | undefined;
    isManualEntry: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditFuelProviderDetailDto implements ICreateOrEditFuelProviderDetailDto {
    amount!: number;
    quantity!: number;
    fuelProviderDataId!: number;
    fuelTypeId!: number;
    fuelUnitId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFuelProviderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.fuelProviderDataId = _data["fuelProviderDataId"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.fuelUnitId = _data["fuelUnitId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFuelProviderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFuelProviderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["fuelProviderDataId"] = this.fuelProviderDataId;
        data["fuelTypeId"] = this.fuelTypeId;
        data["fuelUnitId"] = this.fuelUnitId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditFuelProviderDetailDto {
    amount: number;
    quantity: number;
    fuelProviderDataId: number;
    fuelTypeId: number;
    fuelUnitId: number;
    id: number | undefined;
}

export class CreateOrEditGeneratorInfoDto implements ICreateOrEditGeneratorInfoDto {
    generatorName!: string;
    startingYear!: DateTime;
    expectedYearRetirement!: DateTime;
    manufacturerName!: string | undefined;
    typeAndModel!: string | undefined;
    dualFuelTechnology!: boolean | undefined;
    fuelName!: string | undefined;
    fuelTankCapacity!: number;
    oilConsumption!: number;
    maximumOperationTime!: number;
    maximumPowerOutput!: number;
    virtualAbility!: number;
    currentAmpere!: number;
    frequency!: number;
    maximumTemperature!: number;
    generatorCapacity!: number;
    totalHeat!: number;
    fuelTypeId!: number | undefined;
    organizationUnitId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGeneratorInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatorName = _data["generatorName"];
            this.startingYear = _data["startingYear"] ? DateTime.fromISO(_data["startingYear"].toString()) : <any>undefined;
            this.expectedYearRetirement = _data["expectedYearRetirement"] ? DateTime.fromISO(_data["expectedYearRetirement"].toString()) : <any>undefined;
            this.manufacturerName = _data["manufacturerName"];
            this.typeAndModel = _data["typeAndModel"];
            this.dualFuelTechnology = _data["dualFuelTechnology"];
            this.fuelName = _data["fuelName"];
            this.fuelTankCapacity = _data["fuelTankCapacity"];
            this.oilConsumption = _data["oilConsumption"];
            this.maximumOperationTime = _data["maximumOperationTime"];
            this.maximumPowerOutput = _data["maximumPowerOutput"];
            this.virtualAbility = _data["virtualAbility"];
            this.currentAmpere = _data["currentAmpere"];
            this.frequency = _data["frequency"];
            this.maximumTemperature = _data["maximumTemperature"];
            this.generatorCapacity = _data["generatorCapacity"];
            this.totalHeat = _data["totalHeat"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGeneratorInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGeneratorInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorName"] = this.generatorName;
        data["startingYear"] = this.startingYear ? this.startingYear.toString() : <any>undefined;
        data["expectedYearRetirement"] = this.expectedYearRetirement ? this.expectedYearRetirement.toString() : <any>undefined;
        data["manufacturerName"] = this.manufacturerName;
        data["typeAndModel"] = this.typeAndModel;
        data["dualFuelTechnology"] = this.dualFuelTechnology;
        data["fuelName"] = this.fuelName;
        data["fuelTankCapacity"] = this.fuelTankCapacity;
        data["oilConsumption"] = this.oilConsumption;
        data["maximumOperationTime"] = this.maximumOperationTime;
        data["maximumPowerOutput"] = this.maximumPowerOutput;
        data["virtualAbility"] = this.virtualAbility;
        data["currentAmpere"] = this.currentAmpere;
        data["frequency"] = this.frequency;
        data["maximumTemperature"] = this.maximumTemperature;
        data["generatorCapacity"] = this.generatorCapacity;
        data["totalHeat"] = this.totalHeat;
        data["fuelTypeId"] = this.fuelTypeId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGeneratorInfoDto {
    generatorName: string;
    startingYear: DateTime;
    expectedYearRetirement: DateTime;
    manufacturerName: string | undefined;
    typeAndModel: string | undefined;
    dualFuelTechnology: boolean | undefined;
    fuelName: string | undefined;
    fuelTankCapacity: number;
    oilConsumption: number;
    maximumOperationTime: number;
    maximumPowerOutput: number;
    virtualAbility: number;
    currentAmpere: number;
    frequency: number;
    maximumTemperature: number;
    generatorCapacity: number;
    totalHeat: number;
    fuelTypeId: number | undefined;
    organizationUnitId: number;
    id: number | undefined;
}

export class CreateOrEditGovAwarnessContentPublicationDto implements ICreateOrEditGovAwarnessContentPublicationDto {
    id!: number | undefined;
    seecContentId!: number;
    publicationDate!: DateTime;
    publicationTypeId!: number;
    publicationDurationInDays!: number;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: ICreateOrEditGovAwarnessContentPublicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seecContentId = _data["seecContentId"];
            this.publicationDate = _data["publicationDate"] ? DateTime.fromISO(_data["publicationDate"].toString()) : <any>undefined;
            this.publicationTypeId = _data["publicationTypeId"];
            this.publicationDurationInDays = _data["publicationDurationInDays"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditGovAwarnessContentPublicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGovAwarnessContentPublicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seecContentId"] = this.seecContentId;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toString() : <any>undefined;
        data["publicationTypeId"] = this.publicationTypeId;
        data["publicationDurationInDays"] = this.publicationDurationInDays;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateOrEditGovAwarnessContentPublicationDto {
    id: number | undefined;
    seecContentId: number;
    publicationDate: DateTime;
    publicationTypeId: number;
    publicationDurationInDays: number;
    lastModificationTime: DateTime | undefined;
}

export class CreateOrEditGovElectricityDto implements ICreateOrEditGovElectricityDto {
    govElectricityConsumptionDataList!: CreateGovElectricityConsumptionDataDto[] | undefined;
    oldElectricityConsumptionData!: CreateGovElectricityConsumptionDataDto[] | undefined;
    submissionCycle!: string;
    year!: string | undefined;
    requestId!: number;
    requestStatus!: RequestStatusEnum;
    requestStatusName!: string | undefined;
    organizationId!: number;
    totalConsumption!: number;
    totalAmount!: number;
    declaration!: boolean;
    rejectionReason!: string | undefined;
    entityId!: number;
    comment!: string | undefined;
    attachments!: string | undefined;
    requestReasons!: string | undefined;
    justificationId!: number | undefined;
    isNotApplicable!: boolean | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICreateOrEditGovElectricityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["govElectricityConsumptionDataList"])) {
                this.govElectricityConsumptionDataList = [] as any;
                for (let item of _data["govElectricityConsumptionDataList"])
                    this.govElectricityConsumptionDataList!.push(CreateGovElectricityConsumptionDataDto.fromJS(item));
            }
            if (Array.isArray(_data["oldElectricityConsumptionData"])) {
                this.oldElectricityConsumptionData = [] as any;
                for (let item of _data["oldElectricityConsumptionData"])
                    this.oldElectricityConsumptionData!.push(CreateGovElectricityConsumptionDataDto.fromJS(item));
            }
            this.submissionCycle = _data["submissionCycle"];
            this.year = _data["year"];
            this.requestId = _data["requestId"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusName = _data["requestStatusName"];
            this.organizationId = _data["organizationId"];
            this.totalConsumption = _data["totalConsumption"];
            this.totalAmount = _data["totalAmount"];
            this.declaration = _data["declaration"];
            this.rejectionReason = _data["rejectionReason"];
            this.entityId = _data["entityId"];
            this.comment = _data["comment"];
            this.attachments = _data["attachments"];
            this.requestReasons = _data["requestReasons"];
            this.justificationId = _data["justificationId"];
            this.isNotApplicable = _data["isNotApplicable"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGovElectricityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGovElectricityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.govElectricityConsumptionDataList)) {
            data["govElectricityConsumptionDataList"] = [];
            for (let item of this.govElectricityConsumptionDataList)
                data["govElectricityConsumptionDataList"].push(item.toJSON());
        }
        if (Array.isArray(this.oldElectricityConsumptionData)) {
            data["oldElectricityConsumptionData"] = [];
            for (let item of this.oldElectricityConsumptionData)
                data["oldElectricityConsumptionData"].push(item.toJSON());
        }
        data["submissionCycle"] = this.submissionCycle;
        data["year"] = this.year;
        data["requestId"] = this.requestId;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusName"] = this.requestStatusName;
        data["organizationId"] = this.organizationId;
        data["totalConsumption"] = this.totalConsumption;
        data["totalAmount"] = this.totalAmount;
        data["declaration"] = this.declaration;
        data["rejectionReason"] = this.rejectionReason;
        data["entityId"] = this.entityId;
        data["comment"] = this.comment;
        data["attachments"] = this.attachments;
        data["requestReasons"] = this.requestReasons;
        data["justificationId"] = this.justificationId;
        data["isNotApplicable"] = this.isNotApplicable;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGovElectricityDto {
    govElectricityConsumptionDataList: CreateGovElectricityConsumptionDataDto[] | undefined;
    oldElectricityConsumptionData: CreateGovElectricityConsumptionDataDto[] | undefined;
    submissionCycle: string;
    year: string | undefined;
    requestId: number;
    requestStatus: RequestStatusEnum;
    requestStatusName: string | undefined;
    organizationId: number;
    totalConsumption: number;
    totalAmount: number;
    declaration: boolean;
    rejectionReason: string | undefined;
    entityId: number;
    comment: string | undefined;
    attachments: string | undefined;
    requestReasons: string | undefined;
    justificationId: number | undefined;
    isNotApplicable: boolean | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrEditGovFuelDto implements ICreateOrEditGovFuelDto {
    requestId!: number;
    requestStatus!: RequestStatusEnum;
    requestStatusName!: string | undefined;
    requestStatusId!: number;
    hasRelatedAssets!: boolean;
    canEditConsumptionData!: boolean;
    canSelectNotApplicable!: boolean;
    isNotApplicable!: boolean;
    submissionCycle!: string | undefined;
    submitionDate!: DateTime | undefined;
    submittedByUserName!: string | undefined;
    declaration!: boolean;
    rejectionReason!: string | undefined;
    fuelConsumptionData!: FuelConsumptionRecordDto[] | undefined;
    oldFuelConsumptionData!: FuelConsumptionRecordDto[] | undefined;
    comment!: string | undefined;
    requestReasons!: string | undefined;
    justificationId!: number | undefined;
    attachments!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICreateOrEditGovFuelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusName = _data["requestStatusName"];
            this.requestStatusId = _data["requestStatusId"];
            this.hasRelatedAssets = _data["hasRelatedAssets"];
            this.canEditConsumptionData = _data["canEditConsumptionData"];
            this.canSelectNotApplicable = _data["canSelectNotApplicable"];
            this.isNotApplicable = _data["isNotApplicable"];
            this.submissionCycle = _data["submissionCycle"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.submittedByUserName = _data["submittedByUserName"];
            this.declaration = _data["declaration"];
            this.rejectionReason = _data["rejectionReason"];
            if (Array.isArray(_data["fuelConsumptionData"])) {
                this.fuelConsumptionData = [] as any;
                for (let item of _data["fuelConsumptionData"])
                    this.fuelConsumptionData!.push(FuelConsumptionRecordDto.fromJS(item));
            }
            if (Array.isArray(_data["oldFuelConsumptionData"])) {
                this.oldFuelConsumptionData = [] as any;
                for (let item of _data["oldFuelConsumptionData"])
                    this.oldFuelConsumptionData!.push(FuelConsumptionRecordDto.fromJS(item));
            }
            this.comment = _data["comment"];
            this.requestReasons = _data["requestReasons"];
            this.justificationId = _data["justificationId"];
            this.attachments = _data["attachments"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGovFuelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGovFuelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusName"] = this.requestStatusName;
        data["requestStatusId"] = this.requestStatusId;
        data["hasRelatedAssets"] = this.hasRelatedAssets;
        data["canEditConsumptionData"] = this.canEditConsumptionData;
        data["canSelectNotApplicable"] = this.canSelectNotApplicable;
        data["isNotApplicable"] = this.isNotApplicable;
        data["submissionCycle"] = this.submissionCycle;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["submittedByUserName"] = this.submittedByUserName;
        data["declaration"] = this.declaration;
        data["rejectionReason"] = this.rejectionReason;
        if (Array.isArray(this.fuelConsumptionData)) {
            data["fuelConsumptionData"] = [];
            for (let item of this.fuelConsumptionData)
                data["fuelConsumptionData"].push(item.toJSON());
        }
        if (Array.isArray(this.oldFuelConsumptionData)) {
            data["oldFuelConsumptionData"] = [];
            for (let item of this.oldFuelConsumptionData)
                data["oldFuelConsumptionData"].push(item.toJSON());
        }
        data["comment"] = this.comment;
        data["requestReasons"] = this.requestReasons;
        data["justificationId"] = this.justificationId;
        data["attachments"] = this.attachments;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGovFuelDto {
    requestId: number;
    requestStatus: RequestStatusEnum;
    requestStatusName: string | undefined;
    requestStatusId: number;
    hasRelatedAssets: boolean;
    canEditConsumptionData: boolean;
    canSelectNotApplicable: boolean;
    isNotApplicable: boolean;
    submissionCycle: string | undefined;
    submitionDate: DateTime | undefined;
    submittedByUserName: string | undefined;
    declaration: boolean;
    rejectionReason: string | undefined;
    fuelConsumptionData: FuelConsumptionRecordDto[] | undefined;
    oldFuelConsumptionData: FuelConsumptionRecordDto[] | undefined;
    comment: string | undefined;
    requestReasons: string | undefined;
    justificationId: number | undefined;
    attachments: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrEditMainActivityDto implements ICreateOrEditMainActivityDto {
    id!: number | undefined;

    constructor(data?: ICreateOrEditMainActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMainActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMainActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMainActivityDto {
    id: number | undefined;
}

export class CreateOrEditMemberRequest implements ICreateOrEditMemberRequest {
    request!: RequestEditDto;
    member!: MemberDto;

    constructor(data?: ICreateOrEditMemberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? RequestEditDto.fromJS(_data["request"]) : <any>undefined;
            this.member = _data["member"] ? MemberDto.fromJS(_data["member"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditMemberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMemberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrEditMemberRequest {
    request: RequestEditDto;
    member: MemberDto;
}

export class CreateOrEditMeterInfoDto implements ICreateOrEditMeterInfoDto {
    meterNumber!: string | undefined;
    premiseId!: number | undefined;
    contractAccount!: number;
    subscriptionNumber!: string | undefined;
    organizationUnitId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMeterInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNumber = _data["meterNumber"];
            this.premiseId = _data["premiseId"];
            this.contractAccount = _data["contractAccount"];
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMeterInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMeterInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNumber"] = this.meterNumber;
        data["premiseId"] = this.premiseId;
        data["contractAccount"] = this.contractAccount;
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMeterInfoDto {
    meterNumber: string | undefined;
    premiseId: number | undefined;
    contractAccount: number;
    subscriptionNumber: string | undefined;
    organizationUnitId: number;
    id: number | undefined;
}

export class CreateOrEditNotificationLogDto implements ICreateOrEditNotificationLogDto {
    message!: string | undefined;
    messageTemplate!: string | undefined;
    level!: string | undefined;
    timeStamp!: DateTime;
    exception!: string | undefined;
    properties!: string | undefined;
    logEvent!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditNotificationLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.messageTemplate = _data["messageTemplate"];
            this.level = _data["level"];
            this.timeStamp = _data["timeStamp"] ? DateTime.fromISO(_data["timeStamp"].toString()) : <any>undefined;
            this.exception = _data["exception"];
            this.properties = _data["properties"];
            this.logEvent = _data["logEvent"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditNotificationLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditNotificationLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["messageTemplate"] = this.messageTemplate;
        data["level"] = this.level;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toString() : <any>undefined;
        data["exception"] = this.exception;
        data["properties"] = this.properties;
        data["logEvent"] = this.logEvent;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditNotificationLogDto {
    message: string | undefined;
    messageTemplate: string | undefined;
    level: string | undefined;
    timeStamp: DateTime;
    exception: string | undefined;
    properties: string | undefined;
    logEvent: string | undefined;
    id: number | undefined;
}

export class CreateOrEditOrganizationActivityDetailDto implements ICreateOrEditOrganizationActivityDetailDto {
    organizationActivityId!: number;
    isChecked!: boolean;
    isFollowExecusion!: boolean | undefined;
    correctiveSteps!: string | undefined;
    subActivityId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOrganizationActivityDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationActivityId = _data["organizationActivityId"];
            this.isChecked = _data["isChecked"];
            this.isFollowExecusion = _data["isFollowExecusion"];
            this.correctiveSteps = _data["correctiveSteps"];
            this.subActivityId = _data["subActivityId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOrganizationActivityDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOrganizationActivityDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationActivityId"] = this.organizationActivityId;
        data["isChecked"] = this.isChecked;
        data["isFollowExecusion"] = this.isFollowExecusion;
        data["correctiveSteps"] = this.correctiveSteps;
        data["subActivityId"] = this.subActivityId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOrganizationActivityDetailDto {
    organizationActivityId: number;
    isChecked: boolean;
    isFollowExecusion: boolean | undefined;
    correctiveSteps: string | undefined;
    subActivityId: number;
    id: number | undefined;
}

export class CreateOrEditOrganizationActivityDto implements ICreateOrEditOrganizationActivityDto {
    organizationUnitId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOrganizationActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOrganizationActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOrganizationActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOrganizationActivityDto {
    organizationUnitId: number;
    id: number | undefined;
}

export class CreateOrEditOrganizationEEPDetailDto implements ICreateOrEditOrganizationEEPDetailDto {
    departmentName!: string;
    activityStartDate!: DateTime;
    activityEndDate!: DateTime;
    expectedEnergySaving!: number | undefined;
    expectedSavingUnitName!: string | undefined;
    achievedEnergySaving!: number | undefined;
    activityRelativeWeight!: number | undefined;
    notes!: string | undefined;
    organizationEEPId!: number;
    expectedEnergySavingUnitId!: number | undefined;
    fuelExpectedEnergySavingUnitId!: number | undefined;
    eepStatusId!: number;
    areaOfImprovementId!: number | undefined;
    isDraft!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOrganizationEEPDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentName = _data["departmentName"];
            this.activityStartDate = _data["activityStartDate"] ? DateTime.fromISO(_data["activityStartDate"].toString()) : <any>undefined;
            this.activityEndDate = _data["activityEndDate"] ? DateTime.fromISO(_data["activityEndDate"].toString()) : <any>undefined;
            this.expectedEnergySaving = _data["expectedEnergySaving"];
            this.expectedSavingUnitName = _data["expectedSavingUnitName"];
            this.achievedEnergySaving = _data["achievedEnergySaving"];
            this.activityRelativeWeight = _data["activityRelativeWeight"];
            this.notes = _data["notes"];
            this.organizationEEPId = _data["organizationEEPId"];
            this.expectedEnergySavingUnitId = _data["expectedEnergySavingUnitId"];
            this.fuelExpectedEnergySavingUnitId = _data["fuelExpectedEnergySavingUnitId"];
            this.eepStatusId = _data["eepStatusId"];
            this.areaOfImprovementId = _data["areaOfImprovementId"];
            this.isDraft = _data["isDraft"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOrganizationEEPDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOrganizationEEPDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentName"] = this.departmentName;
        data["activityStartDate"] = this.activityStartDate ? this.activityStartDate.toString() : <any>undefined;
        data["activityEndDate"] = this.activityEndDate ? this.activityEndDate.toString() : <any>undefined;
        data["expectedEnergySaving"] = this.expectedEnergySaving;
        data["expectedSavingUnitName"] = this.expectedSavingUnitName;
        data["achievedEnergySaving"] = this.achievedEnergySaving;
        data["activityRelativeWeight"] = this.activityRelativeWeight;
        data["notes"] = this.notes;
        data["organizationEEPId"] = this.organizationEEPId;
        data["expectedEnergySavingUnitId"] = this.expectedEnergySavingUnitId;
        data["fuelExpectedEnergySavingUnitId"] = this.fuelExpectedEnergySavingUnitId;
        data["eepStatusId"] = this.eepStatusId;
        data["areaOfImprovementId"] = this.areaOfImprovementId;
        data["isDraft"] = this.isDraft;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOrganizationEEPDetailDto {
    departmentName: string;
    activityStartDate: DateTime;
    activityEndDate: DateTime;
    expectedEnergySaving: number | undefined;
    expectedSavingUnitName: string | undefined;
    achievedEnergySaving: number | undefined;
    activityRelativeWeight: number | undefined;
    notes: string | undefined;
    organizationEEPId: number;
    expectedEnergySavingUnitId: number | undefined;
    fuelExpectedEnergySavingUnitId: number | undefined;
    eepStatusId: number;
    areaOfImprovementId: number | undefined;
    isDraft: boolean | undefined;
    id: number | undefined;
}

export class CreateOrEditOrganizationEEPDto implements ICreateOrEditOrganizationEEPDto {
    subject!: string | undefined;
    baselineYear!: string | undefined;
    planYear!: string | undefined;
    baseline!: number;
    expectedSavingRate!: number | undefined;
    expectedConsumption!: number | undefined;
    implementStartDate!: DateTime | undefined;
    implementEndDate!: DateTime | undefined;
    isFuel!: boolean;
    organizationUnitId!: number;
    organizationUnit!: GetOrganizationUserDto;
    orgTeamLeadId!: number;
    baselineUnitId!: number | undefined;
    fuelBaselineUnitId!: number | undefined;
    creationTime!: DateTime | undefined;
    isDraft!: boolean | undefined;
    tabIndex!: number | undefined;
    submitDate!: DateTime | undefined;
    organizationEEPDetailList!: OrganizationEEPDetailDto[] | undefined;
    memberedAreaOfImprovements!: number[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOrganizationEEPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.baselineYear = _data["baselineYear"];
            this.planYear = _data["planYear"];
            this.baseline = _data["baseline"];
            this.expectedSavingRate = _data["expectedSavingRate"];
            this.expectedConsumption = _data["expectedConsumption"];
            this.implementStartDate = _data["implementStartDate"] ? DateTime.fromISO(_data["implementStartDate"].toString()) : <any>undefined;
            this.implementEndDate = _data["implementEndDate"] ? DateTime.fromISO(_data["implementEndDate"].toString()) : <any>undefined;
            this.isFuel = _data["isFuel"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnit = _data["organizationUnit"] ? GetOrganizationUserDto.fromJS(_data["organizationUnit"]) : <any>undefined;
            this.orgTeamLeadId = _data["orgTeamLeadId"];
            this.baselineUnitId = _data["baselineUnitId"];
            this.fuelBaselineUnitId = _data["fuelBaselineUnitId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.isDraft = _data["isDraft"];
            this.tabIndex = _data["tabIndex"];
            this.submitDate = _data["submitDate"] ? DateTime.fromISO(_data["submitDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["organizationEEPDetailList"])) {
                this.organizationEEPDetailList = [] as any;
                for (let item of _data["organizationEEPDetailList"])
                    this.organizationEEPDetailList!.push(OrganizationEEPDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedAreaOfImprovements"])) {
                this.memberedAreaOfImprovements = [] as any;
                for (let item of _data["memberedAreaOfImprovements"])
                    this.memberedAreaOfImprovements!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOrganizationEEPDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOrganizationEEPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["baselineYear"] = this.baselineYear;
        data["planYear"] = this.planYear;
        data["baseline"] = this.baseline;
        data["expectedSavingRate"] = this.expectedSavingRate;
        data["expectedConsumption"] = this.expectedConsumption;
        data["implementStartDate"] = this.implementStartDate ? this.implementStartDate.toString() : <any>undefined;
        data["implementEndDate"] = this.implementEndDate ? this.implementEndDate.toString() : <any>undefined;
        data["isFuel"] = this.isFuel;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnit"] = this.organizationUnit ? this.organizationUnit.toJSON() : <any>undefined;
        data["orgTeamLeadId"] = this.orgTeamLeadId;
        data["baselineUnitId"] = this.baselineUnitId;
        data["fuelBaselineUnitId"] = this.fuelBaselineUnitId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["isDraft"] = this.isDraft;
        data["tabIndex"] = this.tabIndex;
        data["submitDate"] = this.submitDate ? this.submitDate.toString() : <any>undefined;
        if (Array.isArray(this.organizationEEPDetailList)) {
            data["organizationEEPDetailList"] = [];
            for (let item of this.organizationEEPDetailList)
                data["organizationEEPDetailList"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedAreaOfImprovements)) {
            data["memberedAreaOfImprovements"] = [];
            for (let item of this.memberedAreaOfImprovements)
                data["memberedAreaOfImprovements"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOrganizationEEPDto {
    subject: string | undefined;
    baselineYear: string | undefined;
    planYear: string | undefined;
    baseline: number;
    expectedSavingRate: number | undefined;
    expectedConsumption: number | undefined;
    implementStartDate: DateTime | undefined;
    implementEndDate: DateTime | undefined;
    isFuel: boolean;
    organizationUnitId: number;
    organizationUnit: GetOrganizationUserDto;
    orgTeamLeadId: number;
    baselineUnitId: number | undefined;
    fuelBaselineUnitId: number | undefined;
    creationTime: DateTime | undefined;
    isDraft: boolean | undefined;
    tabIndex: number | undefined;
    submitDate: DateTime | undefined;
    organizationEEPDetailList: OrganizationEEPDetailDto[] | undefined;
    memberedAreaOfImprovements: number[] | undefined;
    id: number | undefined;
}

export class CreateOrEditProviderElectricityDto implements ICreateOrEditProviderElectricityDto {
    year!: string;
    month!: number;
    consumption!: number;
    amount!: number;
    organizationId!: number;
    requestId!: number;
    declaration!: boolean;
    claimAccountDto!: ClaimAccountDto;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProviderElectricityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.consumption = _data["consumption"];
            this.amount = _data["amount"];
            this.organizationId = _data["organizationId"];
            this.requestId = _data["requestId"];
            this.declaration = _data["declaration"];
            this.claimAccountDto = _data["claimAccountDto"] ? ClaimAccountDto.fromJS(_data["claimAccountDto"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProviderElectricityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProviderElectricityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["consumption"] = this.consumption;
        data["amount"] = this.amount;
        data["organizationId"] = this.organizationId;
        data["requestId"] = this.requestId;
        data["declaration"] = this.declaration;
        data["claimAccountDto"] = this.claimAccountDto ? this.claimAccountDto.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProviderElectricityDto {
    year: string;
    month: number;
    consumption: number;
    amount: number;
    organizationId: number;
    requestId: number;
    declaration: boolean;
    claimAccountDto: ClaimAccountDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditRequestPeriodSettingDto implements ICreateOrEditRequestPeriodSettingDto {
    year!: string | undefined;
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    settingPeriodTypeId!: number;
    settingPeriodsRequestTypeId!: number;
    submissionCycleId!: number | undefined;
    isDefault!: boolean | undefined;
    isActive!: boolean | undefined;
    fromPeriod!: string | undefined;
    toPeriod!: string | undefined;
    fromPeriodJson!: DefaultRequestPeriodField;
    toPeriodJson!: DefaultRequestPeriodField;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRequestPeriodSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : <any>undefined;
            this.settingPeriodTypeId = _data["settingPeriodTypeId"];
            this.settingPeriodsRequestTypeId = _data["settingPeriodsRequestTypeId"];
            this.submissionCycleId = _data["submissionCycleId"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.fromPeriod = _data["fromPeriod"];
            this.toPeriod = _data["toPeriod"];
            this.fromPeriodJson = _data["fromPeriodJson"] ? DefaultRequestPeriodField.fromJS(_data["fromPeriodJson"]) : <any>undefined;
            this.toPeriodJson = _data["toPeriodJson"] ? DefaultRequestPeriodField.fromJS(_data["toPeriodJson"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRequestPeriodSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRequestPeriodSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toString() : <any>undefined;
        data["settingPeriodTypeId"] = this.settingPeriodTypeId;
        data["settingPeriodsRequestTypeId"] = this.settingPeriodsRequestTypeId;
        data["submissionCycleId"] = this.submissionCycleId;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["fromPeriod"] = this.fromPeriod;
        data["toPeriod"] = this.toPeriod;
        data["fromPeriodJson"] = this.fromPeriodJson ? this.fromPeriodJson.toJSON() : <any>undefined;
        data["toPeriodJson"] = this.toPeriodJson ? this.toPeriodJson.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRequestPeriodSettingDto {
    year: string | undefined;
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    settingPeriodTypeId: number;
    settingPeriodsRequestTypeId: number;
    submissionCycleId: number | undefined;
    isDefault: boolean | undefined;
    isActive: boolean | undefined;
    fromPeriod: string | undefined;
    toPeriod: string | undefined;
    fromPeriodJson: DefaultRequestPeriodField;
    toPeriodJson: DefaultRequestPeriodField;
    id: number | undefined;
}

export class CreateOrEditSectorDto implements ICreateOrEditSectorDto {
    name_Ar!: string;
    code!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name_Ar = _data["name_Ar"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name_Ar"] = this.name_Ar;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSectorDto {
    name_Ar: string;
    code: string;
    id: number | undefined;
}

export class CreateOrEditSeecEmailDto implements ICreateOrEditSeecEmailDto {
    senderEmailAddress!: string | undefined;
    receiverEmailAddress!: string;
    emailSubject!: string;
    emailBody!: string;
    isSent!: boolean;
    errorType!: string | undefined;
    errorCode!: string | undefined;
    errorMessage!: string | undefined;
    reTryCounter!: number;
    machineName!: string | undefined;
    dateCreated!: DateTime;
    dateUpdated!: DateTime;
    attachmentFile!: string | undefined;
    addtionalData!: string | undefined;
    templateId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeecEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderEmailAddress = _data["senderEmailAddress"];
            this.receiverEmailAddress = _data["receiverEmailAddress"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.isSent = _data["isSent"];
            this.errorType = _data["errorType"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.reTryCounter = _data["reTryCounter"];
            this.machineName = _data["machineName"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.attachmentFile = _data["attachmentFile"];
            this.addtionalData = _data["addtionalData"];
            this.templateId = _data["templateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeecEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeecEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senderEmailAddress"] = this.senderEmailAddress;
        data["receiverEmailAddress"] = this.receiverEmailAddress;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["isSent"] = this.isSent;
        data["errorType"] = this.errorType;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["reTryCounter"] = this.reTryCounter;
        data["machineName"] = this.machineName;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["attachmentFile"] = this.attachmentFile;
        data["addtionalData"] = this.addtionalData;
        data["templateId"] = this.templateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeecEmailDto {
    senderEmailAddress: string | undefined;
    receiverEmailAddress: string;
    emailSubject: string;
    emailBody: string;
    isSent: boolean;
    errorType: string | undefined;
    errorCode: string | undefined;
    errorMessage: string | undefined;
    reTryCounter: number;
    machineName: string | undefined;
    dateCreated: DateTime;
    dateUpdated: DateTime;
    attachmentFile: string | undefined;
    addtionalData: string | undefined;
    templateId: number;
    id: number | undefined;
}

export class CreateOrEditSeecEmailTemplateDto implements ICreateOrEditSeecEmailTemplateDto {
    name!: string;
    emailSubject!: string;
    emailBody!: string | undefined;
    isTemplateActive!: boolean;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeecEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.isTemplateActive = _data["isTemplateActive"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeecEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeecEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["isTemplateActive"] = this.isTemplateActive;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeecEmailTemplateDto {
    name: string;
    emailSubject: string;
    emailBody: string | undefined;
    isTemplateActive: boolean;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    id: number | undefined;
}

export class CreateOrEditSeecSMSDto implements ICreateOrEditSeecSMSDto {
    mobileNumber!: string;
    messageBody!: string | undefined;
    isDeliveryRequired!: boolean;
    transactionID!: string | undefined;
    type!: string | undefined;
    isSent!: boolean;
    errorType!: string | undefined;
    errorCode!: string | undefined;
    errorMessage!: string | undefined;
    reTryCounter!: number;
    machineName!: string | undefined;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    sentDatetime!: DateTime | undefined;
    addtionalData!: string | undefined;
    smsTemplateId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeecSMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileNumber = _data["mobileNumber"];
            this.messageBody = _data["messageBody"];
            this.isDeliveryRequired = _data["isDeliveryRequired"];
            this.transactionID = _data["transactionID"];
            this.type = _data["type"];
            this.isSent = _data["isSent"];
            this.errorType = _data["errorType"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.reTryCounter = _data["reTryCounter"];
            this.machineName = _data["machineName"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.sentDatetime = _data["sentDatetime"] ? DateTime.fromISO(_data["sentDatetime"].toString()) : <any>undefined;
            this.addtionalData = _data["addtionalData"];
            this.smsTemplateId = _data["smsTemplateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeecSMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeecSMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileNumber"] = this.mobileNumber;
        data["messageBody"] = this.messageBody;
        data["isDeliveryRequired"] = this.isDeliveryRequired;
        data["transactionID"] = this.transactionID;
        data["type"] = this.type;
        data["isSent"] = this.isSent;
        data["errorType"] = this.errorType;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["reTryCounter"] = this.reTryCounter;
        data["machineName"] = this.machineName;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["sentDatetime"] = this.sentDatetime ? this.sentDatetime.toString() : <any>undefined;
        data["addtionalData"] = this.addtionalData;
        data["smsTemplateId"] = this.smsTemplateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeecSMSDto {
    mobileNumber: string;
    messageBody: string | undefined;
    isDeliveryRequired: boolean;
    transactionID: string | undefined;
    type: string | undefined;
    isSent: boolean;
    errorType: string | undefined;
    errorCode: string | undefined;
    errorMessage: string | undefined;
    reTryCounter: number;
    machineName: string | undefined;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    sentDatetime: DateTime | undefined;
    addtionalData: string | undefined;
    smsTemplateId: number;
    id: number | undefined;
}

export class CreateOrEditSeecSmsTemplateDto implements ICreateOrEditSeecSmsTemplateDto {
    name!: string;
    smsTemplateBody!: string;
    isTemplateActive!: boolean;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    gracePeriod!: string | undefined;
    description!: string | undefined;
    actor!: string | undefined;
    parameter!: string | undefined;
    addtionalData!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeecSmsTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.smsTemplateBody = _data["smsTemplateBody"];
            this.isTemplateActive = _data["isTemplateActive"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.gracePeriod = _data["gracePeriod"];
            this.description = _data["description"];
            this.actor = _data["actor"];
            this.parameter = _data["parameter"];
            this.addtionalData = _data["addtionalData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeecSmsTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeecSmsTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["smsTemplateBody"] = this.smsTemplateBody;
        data["isTemplateActive"] = this.isTemplateActive;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["gracePeriod"] = this.gracePeriod;
        data["description"] = this.description;
        data["actor"] = this.actor;
        data["parameter"] = this.parameter;
        data["addtionalData"] = this.addtionalData;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeecSmsTemplateDto {
    name: string;
    smsTemplateBody: string;
    isTemplateActive: boolean;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    gracePeriod: string | undefined;
    description: string | undefined;
    actor: string | undefined;
    parameter: string | undefined;
    addtionalData: string | undefined;
    id: number | undefined;
}

export class CreateOrEditSMSDto implements ICreateOrEditSMSDto {
    mobileNumber!: string;
    messageBody!: string;
    isDeliveryRequired!: boolean;
    transactionID!: string | undefined;
    type!: string | undefined;
    isSent!: boolean;
    errorType!: string | undefined;
    errorCode!: string | undefined;
    errorMessage!: string | undefined;
    reTryCounter!: number;
    machineName!: string | undefined;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    sentDatetime!: DateTime | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileNumber = _data["mobileNumber"];
            this.messageBody = _data["messageBody"];
            this.isDeliveryRequired = _data["isDeliveryRequired"];
            this.transactionID = _data["transactionID"];
            this.type = _data["type"];
            this.isSent = _data["isSent"];
            this.errorType = _data["errorType"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.reTryCounter = _data["reTryCounter"];
            this.machineName = _data["machineName"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.sentDatetime = _data["sentDatetime"] ? DateTime.fromISO(_data["sentDatetime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileNumber"] = this.mobileNumber;
        data["messageBody"] = this.messageBody;
        data["isDeliveryRequired"] = this.isDeliveryRequired;
        data["transactionID"] = this.transactionID;
        data["type"] = this.type;
        data["isSent"] = this.isSent;
        data["errorType"] = this.errorType;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["reTryCounter"] = this.reTryCounter;
        data["machineName"] = this.machineName;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["sentDatetime"] = this.sentDatetime ? this.sentDatetime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSMSDto {
    mobileNumber: string;
    messageBody: string;
    isDeliveryRequired: boolean;
    transactionID: string | undefined;
    type: string | undefined;
    isSent: boolean;
    errorType: string | undefined;
    errorCode: string | undefined;
    errorMessage: string | undefined;
    reTryCounter: number;
    machineName: string | undefined;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    sentDatetime: DateTime | undefined;
    id: number | undefined;
}

export class CreateOrEditSmsTemplateDto implements ICreateOrEditSmsTemplateDto {
    name!: string;
    smsTemplateBody!: string;
    isTemplateActive!: boolean;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    gracePeriod!: string | undefined;
    description!: string | undefined;
    actor!: string | undefined;
    parameter!: string | undefined;
    addtionalData!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSmsTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.smsTemplateBody = _data["smsTemplateBody"];
            this.isTemplateActive = _data["isTemplateActive"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.gracePeriod = _data["gracePeriod"];
            this.description = _data["description"];
            this.actor = _data["actor"];
            this.parameter = _data["parameter"];
            this.addtionalData = _data["addtionalData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSmsTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSmsTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["smsTemplateBody"] = this.smsTemplateBody;
        data["isTemplateActive"] = this.isTemplateActive;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["gracePeriod"] = this.gracePeriod;
        data["description"] = this.description;
        data["actor"] = this.actor;
        data["parameter"] = this.parameter;
        data["addtionalData"] = this.addtionalData;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSmsTemplateDto {
    name: string;
    smsTemplateBody: string;
    isTemplateActive: boolean;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    gracePeriod: string | undefined;
    description: string | undefined;
    actor: string | undefined;
    parameter: string | undefined;
    addtionalData: string | undefined;
    id: number | undefined;
}

export class CreateOrEditStreetlightAssetInfoDto implements ICreateOrEditStreetlightAssetInfoDto {
    refrenceNumber!: string | undefined;
    organizationUnitId!: number;
    description!: string;
    regionId!: number;
    cityName!: string;
    lightingTypeId!: number;
    numberOfStreetlights!: number;
    yearBuilt!: string;
    lastRetrofitYear!: string | undefined;
    operationalStatus!: number;
    maintenanceCycle!: number;
    tarshidRetrofit!: boolean;
    serviceProviderId!: number;
    seAccountNumber!: string;
    operatingHoursPerWeek!: number;
    operationStartTime!: string;
    notes!: string | undefined;
    attachments!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditStreetlightAssetInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refrenceNumber = _data["refrenceNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.description = _data["description"];
            this.regionId = _data["regionId"];
            this.cityName = _data["cityName"];
            this.lightingTypeId = _data["lightingTypeId"];
            this.numberOfStreetlights = _data["numberOfStreetlights"];
            this.yearBuilt = _data["yearBuilt"];
            this.lastRetrofitYear = _data["lastRetrofitYear"];
            this.operationalStatus = _data["operationalStatus"];
            this.maintenanceCycle = _data["maintenanceCycle"];
            this.tarshidRetrofit = _data["tarshidRetrofit"];
            this.serviceProviderId = _data["serviceProviderId"];
            this.seAccountNumber = _data["seAccountNumber"];
            this.operatingHoursPerWeek = _data["operatingHoursPerWeek"];
            this.operationStartTime = _data["operationStartTime"];
            this.notes = _data["notes"];
            this.attachments = _data["attachments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditStreetlightAssetInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStreetlightAssetInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refrenceNumber"] = this.refrenceNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["description"] = this.description;
        data["regionId"] = this.regionId;
        data["cityName"] = this.cityName;
        data["lightingTypeId"] = this.lightingTypeId;
        data["numberOfStreetlights"] = this.numberOfStreetlights;
        data["yearBuilt"] = this.yearBuilt;
        data["lastRetrofitYear"] = this.lastRetrofitYear;
        data["operationalStatus"] = this.operationalStatus;
        data["maintenanceCycle"] = this.maintenanceCycle;
        data["tarshidRetrofit"] = this.tarshidRetrofit;
        data["serviceProviderId"] = this.serviceProviderId;
        data["seAccountNumber"] = this.seAccountNumber;
        data["operatingHoursPerWeek"] = this.operatingHoursPerWeek;
        data["operationStartTime"] = this.operationStartTime;
        data["notes"] = this.notes;
        data["attachments"] = this.attachments;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditStreetlightAssetInfoDto {
    refrenceNumber: string | undefined;
    organizationUnitId: number;
    description: string;
    regionId: number;
    cityName: string;
    lightingTypeId: number;
    numberOfStreetlights: number;
    yearBuilt: string;
    lastRetrofitYear: string | undefined;
    operationalStatus: number;
    maintenanceCycle: number;
    tarshidRetrofit: boolean;
    serviceProviderId: number;
    seAccountNumber: string;
    operatingHoursPerWeek: number;
    operationStartTime: string;
    notes: string | undefined;
    attachments: string | undefined;
    id: number | undefined;
}

export class CreateOrEditSubActivityDto implements ICreateOrEditSubActivityDto {
    mainActivityId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSubActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainActivityId = _data["mainActivityId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSubActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSubActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainActivityId"] = this.mainActivityId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSubActivityDto {
    mainActivityId: number;
    id: number | undefined;
}

export class CreateOrEditTopicDto implements ICreateOrEditTopicDto {
    topicName!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicName = _data["topicName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicName"] = this.topicName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTopicDto {
    topicName: string;
    id: number | undefined;
}

export class CreateOrEditTrainingPackageDto implements ICreateOrEditTrainingPackageDto {
    packageName!: string;
    attachmentId!: string;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTrainingPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageName = _data["packageName"];
            this.attachmentId = _data["attachmentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTrainingPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTrainingPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageName"] = this.packageName;
        data["attachmentId"] = this.attachmentId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTrainingPackageDto {
    packageName: string;
    attachmentId: string;
    id: number | undefined;
}

export class CreateOrEditTrainingPackageRequestDto implements ICreateOrEditTrainingPackageRequestDto {
    requestId!: number;
    trainingSessions!: number;
    organizationId!: number;
    trainingPackageId!: number;
    trainingPackageDetails!: TrainingPackageDetailsDto[] | undefined;
    requestStatus!: RequestStatusEnum;
    requestStatusName!: string | undefined;
    rejectionReason!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTrainingPackageRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.trainingSessions = _data["trainingSessions"];
            this.organizationId = _data["organizationId"];
            this.trainingPackageId = _data["trainingPackageId"];
            if (Array.isArray(_data["trainingPackageDetails"])) {
                this.trainingPackageDetails = [] as any;
                for (let item of _data["trainingPackageDetails"])
                    this.trainingPackageDetails!.push(TrainingPackageDetailsDto.fromJS(item));
            }
            this.requestStatus = _data["requestStatus"];
            this.requestStatusName = _data["requestStatusName"];
            this.rejectionReason = _data["rejectionReason"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTrainingPackageRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTrainingPackageRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["trainingSessions"] = this.trainingSessions;
        data["organizationId"] = this.organizationId;
        data["trainingPackageId"] = this.trainingPackageId;
        if (Array.isArray(this.trainingPackageDetails)) {
            data["trainingPackageDetails"] = [];
            for (let item of this.trainingPackageDetails)
                data["trainingPackageDetails"].push(item.toJSON());
        }
        data["requestStatus"] = this.requestStatus;
        data["requestStatusName"] = this.requestStatusName;
        data["rejectionReason"] = this.rejectionReason;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTrainingPackageRequestDto {
    requestId: number;
    trainingSessions: number;
    organizationId: number;
    trainingPackageId: number;
    trainingPackageDetails: TrainingPackageDetailsDto[] | undefined;
    requestStatus: RequestStatusEnum;
    requestStatusName: string | undefined;
    rejectionReason: string | undefined;
    id: number | undefined;
}

export class CreateOrEditTrainingRequestDto implements ICreateOrEditTrainingRequestDto {
    reservedSeats!: number;
    isDraft!: boolean;
    organizationUnitId!: number;
    courseId!: number;
    requestId!: number | undefined;
    tabIndex!: number | undefined;
    isSubmit!: boolean;
    attendeeInfoList!: CreateOrEditAttendeeInfoDto[] | undefined;
    attachmentId!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTrainingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservedSeats = _data["reservedSeats"];
            this.isDraft = _data["isDraft"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.courseId = _data["courseId"];
            this.requestId = _data["requestId"];
            this.tabIndex = _data["tabIndex"];
            this.isSubmit = _data["isSubmit"];
            if (Array.isArray(_data["attendeeInfoList"])) {
                this.attendeeInfoList = [] as any;
                for (let item of _data["attendeeInfoList"])
                    this.attendeeInfoList!.push(CreateOrEditAttendeeInfoDto.fromJS(item));
            }
            this.attachmentId = _data["attachmentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTrainingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTrainingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservedSeats"] = this.reservedSeats;
        data["isDraft"] = this.isDraft;
        data["organizationUnitId"] = this.organizationUnitId;
        data["courseId"] = this.courseId;
        data["requestId"] = this.requestId;
        data["tabIndex"] = this.tabIndex;
        data["isSubmit"] = this.isSubmit;
        if (Array.isArray(this.attendeeInfoList)) {
            data["attendeeInfoList"] = [];
            for (let item of this.attendeeInfoList)
                data["attendeeInfoList"].push(item.toJSON());
        }
        data["attachmentId"] = this.attachmentId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTrainingRequestDto {
    reservedSeats: number;
    isDraft: boolean;
    organizationUnitId: number;
    courseId: number;
    requestId: number | undefined;
    tabIndex: number | undefined;
    isSubmit: boolean;
    attendeeInfoList: CreateOrEditAttendeeInfoDto[] | undefined;
    attachmentId: string | undefined;
    id: number | undefined;
}

export class CreateOrEditUserSectorDto implements ICreateOrEditUserSectorDto {
    userId!: number;
    sectorId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUserSectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.sectorId = _data["sectorId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUserSectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUserSectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["sectorId"] = this.sectorId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditUserSectorDto {
    userId: number;
    sectorId: number;
    id: number | undefined;
}

export class CreateOrEditVehicleInfoDto implements ICreateOrEditVehicleInfoDto {
    structureNumber!: string;
    manufacturingYear!: number | undefined;
    fuelEconomy!: number | undefined;
    organizationUnitId!: number;
    carModelId!: number | undefined;
    manufactureCompanyId!: number | undefined;
    fuelTypeId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVehicleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureNumber = _data["structureNumber"];
            this.manufacturingYear = _data["manufacturingYear"];
            this.fuelEconomy = _data["fuelEconomy"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.carModelId = _data["carModelId"];
            this.manufactureCompanyId = _data["manufactureCompanyId"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVehicleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVehicleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureNumber"] = this.structureNumber;
        data["manufacturingYear"] = this.manufacturingYear;
        data["fuelEconomy"] = this.fuelEconomy;
        data["organizationUnitId"] = this.organizationUnitId;
        data["carModelId"] = this.carModelId;
        data["manufactureCompanyId"] = this.manufactureCompanyId;
        data["fuelTypeId"] = this.fuelTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditVehicleInfoDto {
    structureNumber: string;
    manufacturingYear: number | undefined;
    fuelEconomy: number | undefined;
    organizationUnitId: number;
    carModelId: number | undefined;
    manufactureCompanyId: number | undefined;
    fuelTypeId: number | undefined;
    id: number | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    sectorId!: number | undefined;
    sectorCode!: string | undefined;
    parentId!: number | undefined;
    memberCount!: number;
    roleCount!: number;
    sectorName_En!: string | undefined;
    tenantId!: number | undefined;
    name_En!: string | undefined;
    name_Ar!: string;
    organizationTypeId!: number;
    govCode!: string;
    isSubEntity!: boolean;
    claimAccounts!: ClaimAccountDto[] | undefined;
    teamMember!: CreateOrUpdateUserInput;
    isActive!: boolean | undefined;
    organizationTierId!: number | undefined;
    mustPassTierAFirst!: boolean | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectorId = _data["sectorId"];
            this.sectorCode = _data["sectorCode"];
            this.parentId = _data["parentId"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.sectorName_En = _data["sectorName_En"];
            this.tenantId = _data["tenantId"];
            this.name_En = _data["name_En"];
            this.name_Ar = _data["name_Ar"];
            this.organizationTypeId = _data["organizationTypeId"];
            this.govCode = _data["govCode"];
            this.isSubEntity = _data["isSubEntity"];
            if (Array.isArray(_data["ClaimAccounts"])) {
                this.claimAccounts = [] as any;
                for (let item of _data["ClaimAccounts"])
                    this.claimAccounts!.push(ClaimAccountDto.fromJS(item));
            }
            this.teamMember = _data["teamMember"] ? CreateOrUpdateUserInput.fromJS(_data["teamMember"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.organizationTierId = _data["organizationTierId"];
            this.mustPassTierAFirst = _data["mustPassTierAFirst"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectorId"] = this.sectorId;
        data["sectorCode"] = this.sectorCode;
        data["parentId"] = this.parentId;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["sectorName_En"] = this.sectorName_En;
        data["tenantId"] = this.tenantId;
        data["name_En"] = this.name_En;
        data["name_Ar"] = this.name_Ar;
        data["organizationTypeId"] = this.organizationTypeId;
        data["govCode"] = this.govCode;
        data["isSubEntity"] = this.isSubEntity;
        if (Array.isArray(this.claimAccounts)) {
            data["ClaimAccounts"] = [];
            for (let item of this.claimAccounts)
                data["ClaimAccounts"].push(item.toJSON());
        }
        data["teamMember"] = this.teamMember ? this.teamMember.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["organizationTierId"] = this.organizationTierId;
        data["mustPassTierAFirst"] = this.mustPassTierAFirst;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    sectorId: number | undefined;
    sectorCode: string | undefined;
    parentId: number | undefined;
    memberCount: number;
    roleCount: number;
    sectorName_En: string | undefined;
    tenantId: number | undefined;
    name_En: string | undefined;
    name_Ar: string;
    organizationTypeId: number;
    govCode: string;
    isSubEntity: boolean;
    claimAccounts: ClaimAccountDto[] | undefined;
    teamMember: CreateOrUpdateUserInput;
    isActive: boolean | undefined;
    organizationTierId: number | undefined;
    mustPassTierAFirst: boolean | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrUpdateAboutSeecDto implements ICreateOrUpdateAboutSeecDto {
    centerPrefDescription!: string;
    aboutProgramDescription!: string;
    technicalSideDescription!: string;
    awarenessSideDescription!: string;
    traningSideDescription!: string;
    isPublished!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrUpdateAboutSeecDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.centerPrefDescription = _data["centerPrefDescription"];
            this.aboutProgramDescription = _data["aboutProgramDescription"];
            this.technicalSideDescription = _data["technicalSideDescription"];
            this.awarenessSideDescription = _data["awarenessSideDescription"];
            this.traningSideDescription = _data["traningSideDescription"];
            this.isPublished = _data["isPublished"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateAboutSeecDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAboutSeecDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["centerPrefDescription"] = this.centerPrefDescription;
        data["aboutProgramDescription"] = this.aboutProgramDescription;
        data["technicalSideDescription"] = this.technicalSideDescription;
        data["awarenessSideDescription"] = this.awarenessSideDescription;
        data["traningSideDescription"] = this.traningSideDescription;
        data["isPublished"] = this.isPublished;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateAboutSeecDto {
    centerPrefDescription: string;
    aboutProgramDescription: string;
    technicalSideDescription: string;
    awarenessSideDescription: string;
    traningSideDescription: string;
    isPublished: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrUpdateContactUsDto implements ICreateOrUpdateContactUsDto {
    contactCenterNumber!: number;
    contactCenterEmail!: string;
    centerLoctionLongitude!: number;
    centerLoctionLatitude!: number;
    address!: string;
    locationUrl!: string | undefined;
    isPublished!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrUpdateContactUsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactCenterNumber = _data["contactCenterNumber"];
            this.contactCenterEmail = _data["contactCenterEmail"];
            this.centerLoctionLongitude = _data["centerLoctionLongitude"];
            this.centerLoctionLatitude = _data["centerLoctionLatitude"];
            this.address = _data["address"];
            this.locationUrl = _data["locationUrl"];
            this.isPublished = _data["isPublished"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateContactUsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateContactUsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactCenterNumber"] = this.contactCenterNumber;
        data["contactCenterEmail"] = this.contactCenterEmail;
        data["centerLoctionLongitude"] = this.centerLoctionLongitude;
        data["centerLoctionLatitude"] = this.centerLoctionLatitude;
        data["address"] = this.address;
        data["locationUrl"] = this.locationUrl;
        data["isPublished"] = this.isPublished;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateContactUsDto {
    contactCenterNumber: number;
    contactCenterEmail: string;
    centerLoctionLongitude: number;
    centerLoctionLatitude: number;
    address: string;
    locationUrl: string | undefined;
    isPublished: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrUpdateFAQCategoryDto implements ICreateOrUpdateFAQCategoryDto {
    categoryName!: string;
    viewOrder!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrUpdateFAQCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"];
            this.viewOrder = _data["viewOrder"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateFAQCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateFAQCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        data["viewOrder"] = this.viewOrder;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateFAQCategoryDto {
    categoryName: string;
    viewOrder: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrUpdateFAQDto implements ICreateOrUpdateFAQDto {
    question!: string;
    answer!: string;
    faqCategoryId!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrUpdateFAQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.answer = _data["answer"];
            this.faqCategoryId = _data["faqCategoryId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateFAQDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateFAQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["faqCategoryId"] = this.faqCategoryId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateFAQDto {
    question: string;
    answer: string;
    faqCategoryId: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrUpdateKnowledgeBankDto implements ICreateOrUpdateKnowledgeBankDto {
    title!: string;
    description!: string;
    attachmnets!: string | undefined;
    category!: KnowledgeBankCategory;
    publishState!: KnowledgeBankPublishStatus;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrUpdateKnowledgeBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.attachmnets = _data["attachmnets"];
            this.category = _data["category"];
            this.publishState = _data["publishState"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateKnowledgeBankDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateKnowledgeBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["attachmnets"] = this.attachmnets;
        data["category"] = this.category;
        data["publishState"] = this.publishState;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateKnowledgeBankDto {
    title: string;
    description: string;
    attachmnets: string | undefined;
    category: KnowledgeBankCategory;
    publishState: KnowledgeBankPublishStatus;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class CreateOrUpdateMediaCenterDto implements ICreateOrUpdateMediaCenterDto {
    title!: string | undefined;
    date!: DateTime;
    summery!: string | undefined;
    content!: string | undefined;
    category!: MediaCenterCategory;
    publishState!: MediaCenterPublishStatus;
    vidioAttachments!: string | undefined;
    imageAttachments!: string | undefined;
    isFeatured!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrUpdateMediaCenterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.summery = _data["summery"];
            this.content = _data["content"];
            this.category = _data["category"];
            this.publishState = _data["publishState"];
            this.vidioAttachments = _data["vidioAttachments"];
            this.imageAttachments = _data["imageAttachments"];
            this.isFeatured = _data["isFeatured"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMediaCenterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMediaCenterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["summery"] = this.summery;
        data["content"] = this.content;
        data["category"] = this.category;
        data["publishState"] = this.publishState;
        data["vidioAttachments"] = this.vidioAttachments;
        data["imageAttachments"] = this.imageAttachments;
        data["isFeatured"] = this.isFeatured;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateMediaCenterDto {
    title: string | undefined;
    date: DateTime;
    summery: string | undefined;
    content: string | undefined;
    category: MediaCenterCategory;
    publishState: MediaCenterPublishStatus;
    vidioAttachments: string | undefined;
    imageAttachments: string | undefined;
    isFeatured: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrUpdateNewsDto implements ICreateOrUpdateNewsDto {
    newsTitle!: string;
    importanceType!: NewsImportanceType;
    publishState!: NewsPublishState;
    newsBody!: string;
    newsImageId!: string | undefined;
    newsVideoId!: string | undefined;
    currentVersion!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: string | undefined;

    constructor(data?: ICreateOrUpdateNewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newsTitle = _data["newsTitle"];
            this.importanceType = _data["importanceType"];
            this.publishState = _data["publishState"];
            this.newsBody = _data["newsBody"];
            this.newsImageId = _data["newsImageId"];
            this.newsVideoId = _data["newsVideoId"];
            this.currentVersion = _data["currentVersion"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateNewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsTitle"] = this.newsTitle;
        data["importanceType"] = this.importanceType;
        data["publishState"] = this.publishState;
        data["newsBody"] = this.newsBody;
        data["newsImageId"] = this.newsImageId;
        data["newsVideoId"] = this.newsVideoId;
        data["currentVersion"] = this.currentVersion;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateNewsDto {
    newsTitle: string;
    importanceType: NewsImportanceType;
    publishState: NewsPublishState;
    newsBody: string;
    newsImageId: string | undefined;
    newsVideoId: string | undefined;
    currentVersion: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: string | undefined;
}

export class CreateOrUpdateReferenceDto implements ICreateOrUpdateReferenceDto {
    referenceTitle!: string;
    attachmentId!: string;
    referenceDescription!: string;
    targetedUsers!: string;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: string | undefined;

    constructor(data?: ICreateOrUpdateReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceTitle = _data["referenceTitle"];
            this.attachmentId = _data["attachmentId"];
            this.referenceDescription = _data["referenceDescription"];
            this.targetedUsers = _data["targetedUsers"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceTitle"] = this.referenceTitle;
        data["attachmentId"] = this.attachmentId;
        data["referenceDescription"] = this.referenceDescription;
        data["targetedUsers"] = this.targetedUsers;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateReferenceDto {
    referenceTitle: string;
    attachmentId: string;
    referenceDescription: string;
    targetedUsers: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: string | undefined;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[] | undefined;
    assignedSectorsIds!: number[] | undefined;
    addAsSeecAdmin!: boolean | undefined;
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    selectedOrganizationUnitCode!: string | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            if (Array.isArray(_data["assignedSectorsIds"])) {
                this.assignedSectorsIds = [] as any;
                for (let item of _data["assignedSectorsIds"])
                    this.assignedSectorsIds!.push(item);
            }
            this.addAsSeecAdmin = _data["addAsSeecAdmin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            this.selectedOrganizationUnitCode = _data["selectedOrganizationUnitCode"];
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        if (Array.isArray(this.assignedSectorsIds)) {
            data["assignedSectorsIds"] = [];
            for (let item of this.assignedSectorsIds)
                data["assignedSectorsIds"].push(item);
        }
        data["addAsSeecAdmin"] = this.addAsSeecAdmin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        data["selectedOrganizationUnitCode"] = this.selectedOrganizationUnitCode;
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[] | undefined;
    assignedSectorsIds: number[] | undefined;
    addAsSeecAdmin: boolean | undefined;
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    selectedOrganizationUnitCode: string | undefined;
}

export class CreateReopenRequestDto implements ICreateReopenRequestDto {
    attachments!: string[] | undefined;
    requestReasons!: string | undefined;
    requestTypeId!: number;
    baseRequestId!: number;
    entityId!: number | undefined;

    constructor(data?: ICreateReopenRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(item);
            }
            this.requestReasons = _data["requestReasons"];
            this.requestTypeId = _data["requestTypeId"];
            this.baseRequestId = _data["baseRequestId"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): CreateReopenRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReopenRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        data["requestReasons"] = this.requestReasons;
        data["requestTypeId"] = this.requestTypeId;
        data["baseRequestId"] = this.baseRequestId;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface ICreateReopenRequestDto {
    attachments: string[] | undefined;
    requestReasons: string | undefined;
    requestTypeId: number;
    baseRequestId: number;
    entityId: number | undefined;
}

export class CreateRequestInput implements ICreateRequestInput {
    requestJson!: string | undefined;
    requestTypeId!: RequestTypesEnum;

    constructor(data?: ICreateRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestJson = _data["requestJson"];
            this.requestTypeId = _data["requestTypeId"];
        }
    }

    static fromJS(data: any): CreateRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestJson"] = this.requestJson;
        data["requestTypeId"] = this.requestTypeId;
        return data;
    }
}

export interface ICreateRequestInput {
    requestJson: string | undefined;
    requestTypeId: RequestTypesEnum;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
}

export class CreateUserDelegationDto implements ICreateUserDelegationDto {
    targetUserId!: number;
    startTime!: DateTime;
    endTime!: DateTime;

    constructor(data?: ICreateUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUserId = _data["targetUserId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserId"] = this.targetUserId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateUserDelegationDto {
    targetUserId: number;
    startTime: DateTime;
    endTime: DateTime;
}

export class CreateUserSubmissionDto implements ICreateUserSubmissionDto {
    fullName!: string;
    email!: string;
    phoneNumber!: string;
    subject!: string;
    message!: string;
    category!: UserSubmissionCategory;

    constructor(data?: ICreateUserSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): CreateUserSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["category"] = this.category;
        return data;
    }
}

export interface ICreateUserSubmissionDto {
    fullName: string;
    email: string;
    phoneNumber: string;
    subject: string;
    message: string;
    category: UserSubmissionCategory;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    userRoles!: UserRoleDto[] | undefined;
    userSectors!: UserSectorDto[] | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["userSectors"])) {
                this.userSectors = [] as any;
                for (let item of _data["userSectors"])
                    this.userSectors!.push(UserSectorDto.fromJS(item));
            }
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.userSectors)) {
            data["userSectors"] = [];
            for (let item of this.userSectors)
                data["userSectors"].push(item.toJSON());
        }
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    userRoles: UserRoleDto[] | undefined;
    userSectors: UserSectorDto[] | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class CustomAreaOfImprovementDto implements ICustomAreaOfImprovementDto {
    organizationEEPId!: number | undefined;
    eepAreaOfImprovementId!: number;
    eepAreaOfImprovementNatureId!: number;
    organizationUnitId!: number;
    isFuel!: boolean | undefined;
    id!: number;

    constructor(data?: ICustomAreaOfImprovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationEEPId = _data["organizationEEPId"];
            this.eepAreaOfImprovementId = _data["eepAreaOfImprovementId"];
            this.eepAreaOfImprovementNatureId = _data["eepAreaOfImprovementNatureId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.isFuel = _data["isFuel"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomAreaOfImprovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAreaOfImprovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationEEPId"] = this.organizationEEPId;
        data["eepAreaOfImprovementId"] = this.eepAreaOfImprovementId;
        data["eepAreaOfImprovementNatureId"] = this.eepAreaOfImprovementNatureId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["isFuel"] = this.isFuel;
        data["id"] = this.id;
        return data;
    }
}

export interface ICustomAreaOfImprovementDto {
    organizationEEPId: number | undefined;
    eepAreaOfImprovementId: number;
    eepAreaOfImprovementNatureId: number;
    organizationUnitId: number;
    isFuel: boolean | undefined;
    id: number;
}

export class CustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto implements ICustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    nameEn!: string | undefined;
    isFuel!: boolean;

    constructor(data?: ICustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.nameEn = _data["nameEn"];
            this.isFuel = _data["isFuel"];
        }
    }

    static fromJS(data: any): CustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["nameEn"] = this.nameEn;
        data["isFuel"] = this.isFuel;
        return data;
    }
}

export interface ICustomAreaOfImprovementEEPAreaOfImprovementLookupTableDto {
    id: number;
    displayName: string | undefined;
    nameEn: string | undefined;
    isFuel: boolean;
}

export class CustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto implements ICustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    nameEn!: string | undefined;
    isFuel!: boolean;

    constructor(data?: ICustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.nameEn = _data["nameEn"];
            this.isFuel = _data["isFuel"];
        }
    }

    static fromJS(data: any): CustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["nameEn"] = this.nameEn;
        data["isFuel"] = this.isFuel;
        return data;
    }
}

export interface ICustomAreaOfImprovementEEPAreaOfImprovementNatureLookupTableDto {
    id: number;
    displayName: string | undefined;
    nameEn: string | undefined;
    isFuel: boolean;
}

export class CustomAreaOfImprovementOrganizationEEPLookupTableDto implements ICustomAreaOfImprovementOrganizationEEPLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICustomAreaOfImprovementOrganizationEEPLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CustomAreaOfImprovementOrganizationEEPLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAreaOfImprovementOrganizationEEPLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICustomAreaOfImprovementOrganizationEEPLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CustomAreaOfImprovementOrganizationUnitLookupTableDto implements ICustomAreaOfImprovementOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICustomAreaOfImprovementOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CustomAreaOfImprovementOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAreaOfImprovementOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICustomAreaOfImprovementOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class Dashboard implements IDashboard {
    dashboardName!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboard {
    dashboardName: string | undefined;
    pages: Page[] | undefined;
}

export class DashboardOutput implements IDashboardOutput {
    name!: string | undefined;
    widgets!: WidgetOutput[] | undefined;

    constructor(data?: IDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(WidgetOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardOutput {
    name: string | undefined;
    widgets: WidgetOutput[] | undefined;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString!: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateString = _data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data;
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export class DefaultRequestPeriodField implements IDefaultRequestPeriodField {
    day!: number;
    month!: number;

    constructor(data?: IDefaultRequestPeriodField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): DefaultRequestPeriodField {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultRequestPeriodField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["month"] = this.month;
        return data;
    }
}

export interface IDefaultRequestPeriodField {
    day: number;
    month: number;
}

export class DelegatedImpersonateInput implements IDelegatedImpersonateInput {
    userDelegationId!: number;

    constructor(data?: IDelegatedImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDelegationId = _data["userDelegationId"];
        }
    }

    static fromJS(data: any): DelegatedImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DelegatedImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDelegationId"] = this.userDelegationId;
        return data;
    }
}

export interface IDelegatedImpersonateInput {
    userDelegationId: number;
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    expiringEditionId: number | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;
    id!: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.trialDayCount = _data["trialDayCount"];
            this.expiringEditionDisplayName = _data["expiringEditionDisplayName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
    id: number;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;
    additionalData!: AdditionalData | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.isFree = _data["isFree"];
            this.additionalData = _data["additionalData"] ? AdditionalData.fromJS(_data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
    additionalData: AdditionalData | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of _data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(_data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class EepPlanHeaderDto implements IEepPlanHeaderDto {
    organizationUnit!: GetOrganizationUserDto;
    govTeamLeadName!: string | undefined;
    planYear!: string | undefined;
    planSubmitDate!: DateTime | undefined;
    createDate!: DateTime | undefined;

    constructor(data?: IEepPlanHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnit = _data["organizationUnit"] ? GetOrganizationUserDto.fromJS(_data["organizationUnit"]) : <any>undefined;
            this.govTeamLeadName = _data["govTeamLeadName"];
            this.planYear = _data["planYear"];
            this.planSubmitDate = _data["planSubmitDate"] ? DateTime.fromISO(_data["planSubmitDate"].toString()) : <any>undefined;
            this.createDate = _data["createDate"] ? DateTime.fromISO(_data["createDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EepPlanHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new EepPlanHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnit"] = this.organizationUnit ? this.organizationUnit.toJSON() : <any>undefined;
        data["govTeamLeadName"] = this.govTeamLeadName;
        data["planYear"] = this.planYear;
        data["planSubmitDate"] = this.planSubmitDate ? this.planSubmitDate.toString() : <any>undefined;
        data["createDate"] = this.createDate ? this.createDate.toString() : <any>undefined;
        return data;
    }
}

export interface IEepPlanHeaderDto {
    organizationUnit: GetOrganizationUserDto;
    govTeamLeadName: string | undefined;
    planYear: string | undefined;
    planSubmitDate: DateTime | undefined;
    createDate: DateTime | undefined;
}

export class EEPRequestDeadlineSettingDto implements IEEPRequestDeadlineSettingDto {
    year!: string | undefined;
    lastDueDateSubmission!: DateTime | undefined;
    isDefault!: boolean | undefined;
    lastDueDateSubmissionPeriod!: string | undefined;
    id!: number;

    constructor(data?: IEEPRequestDeadlineSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.lastDueDateSubmission = _data["lastDueDateSubmission"] ? DateTime.fromISO(_data["lastDueDateSubmission"].toString()) : <any>undefined;
            this.isDefault = _data["isDefault"];
            this.lastDueDateSubmissionPeriod = _data["lastDueDateSubmissionPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EEPRequestDeadlineSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EEPRequestDeadlineSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["lastDueDateSubmission"] = this.lastDueDateSubmission ? this.lastDueDateSubmission.toString() : <any>undefined;
        data["isDefault"] = this.isDefault;
        data["lastDueDateSubmissionPeriod"] = this.lastDueDateSubmissionPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface IEEPRequestDeadlineSettingDto {
    year: string | undefined;
    lastDueDateSubmission: DateTime | undefined;
    isDefault: boolean | undefined;
    lastDueDateSubmissionPeriod: string | undefined;
    id: number;
}

export class EfficiencyPlanDto implements IEfficiencyPlanDto {
    planYear!: string | undefined;
    isDraft!: boolean;
    organizationUnitId!: number;
    requestId!: number | undefined;
    organizationActivityId!: number | undefined;
    electricityEepId!: number | undefined;
    fuelEepId!: number | undefined;
    addFuelEep!: boolean;
    isAutoApproved!: boolean | undefined;
    submitionDate!: DateTime | undefined;
    onTimeSubmitted!: boolean;
    requestNumber!: string | undefined;
    requestStatus!: number;
    requestStatusName!: string | undefined;
    submittedByUserName!: string | undefined;
    submittedByPhoneNumber!: string | undefined;
    createdByUserName!: string | undefined;
    createdByPhoneNumber!: string | undefined;
    id!: number;

    constructor(data?: IEfficiencyPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planYear = _data["planYear"];
            this.isDraft = _data["isDraft"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.requestId = _data["requestId"];
            this.organizationActivityId = _data["organizationActivityId"];
            this.electricityEepId = _data["electricityEepId"];
            this.fuelEepId = _data["fuelEepId"];
            this.addFuelEep = _data["addFuelEep"];
            this.isAutoApproved = _data["isAutoApproved"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.onTimeSubmitted = _data["onTimeSubmitted"];
            this.requestNumber = _data["requestNumber"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusName = _data["requestStatusName"];
            this.submittedByUserName = _data["submittedByUserName"];
            this.submittedByPhoneNumber = _data["submittedByPhoneNumber"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdByPhoneNumber = _data["createdByPhoneNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EfficiencyPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new EfficiencyPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planYear"] = this.planYear;
        data["isDraft"] = this.isDraft;
        data["organizationUnitId"] = this.organizationUnitId;
        data["requestId"] = this.requestId;
        data["organizationActivityId"] = this.organizationActivityId;
        data["electricityEepId"] = this.electricityEepId;
        data["fuelEepId"] = this.fuelEepId;
        data["addFuelEep"] = this.addFuelEep;
        data["isAutoApproved"] = this.isAutoApproved;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["onTimeSubmitted"] = this.onTimeSubmitted;
        data["requestNumber"] = this.requestNumber;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusName"] = this.requestStatusName;
        data["submittedByUserName"] = this.submittedByUserName;
        data["submittedByPhoneNumber"] = this.submittedByPhoneNumber;
        data["createdByUserName"] = this.createdByUserName;
        data["createdByPhoneNumber"] = this.createdByPhoneNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IEfficiencyPlanDto {
    planYear: string | undefined;
    isDraft: boolean;
    organizationUnitId: number;
    requestId: number | undefined;
    organizationActivityId: number | undefined;
    electricityEepId: number | undefined;
    fuelEepId: number | undefined;
    addFuelEep: boolean;
    isAutoApproved: boolean | undefined;
    submitionDate: DateTime | undefined;
    onTimeSubmitted: boolean;
    requestNumber: string | undefined;
    requestStatus: number;
    requestStatusName: string | undefined;
    submittedByUserName: string | undefined;
    submittedByPhoneNumber: string | undefined;
    createdByUserName: string | undefined;
    createdByPhoneNumber: string | undefined;
    id: number;
}

export class EfficiencyPlanDuplicateResultDto implements IEfficiencyPlanDuplicateResultDto {
    id!: number | undefined;
    isDraft!: boolean;
    duplicateDataFound!: boolean;

    constructor(data?: IEfficiencyPlanDuplicateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDraft = _data["isDraft"];
            this.duplicateDataFound = _data["duplicateDataFound"];
        }
    }

    static fromJS(data: any): EfficiencyPlanDuplicateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EfficiencyPlanDuplicateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDraft"] = this.isDraft;
        data["duplicateDataFound"] = this.duplicateDataFound;
        return data;
    }
}

export interface IEfficiencyPlanDuplicateResultDto {
    id: number | undefined;
    isDraft: boolean;
    duplicateDataFound: boolean;
}

export class EfficiencyPlanOrganizationActivityLookupTableDto implements IEfficiencyPlanOrganizationActivityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IEfficiencyPlanOrganizationActivityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EfficiencyPlanOrganizationActivityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EfficiencyPlanOrganizationActivityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEfficiencyPlanOrganizationActivityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class EfficiencyPlanOrganizationEEPLookupTableDto implements IEfficiencyPlanOrganizationEEPLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IEfficiencyPlanOrganizationEEPLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EfficiencyPlanOrganizationEEPLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EfficiencyPlanOrganizationEEPLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEfficiencyPlanOrganizationEEPLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class EfficiencyPlanOrganizationUnitLookupTableDto implements IEfficiencyPlanOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IEfficiencyPlanOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EfficiencyPlanOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EfficiencyPlanOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEfficiencyPlanOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class EfficiencyPlanRequestLookupTableDto implements IEfficiencyPlanRequestLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IEfficiencyPlanRequestLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EfficiencyPlanRequestLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EfficiencyPlanRequestLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEfficiencyPlanRequestLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ElectricityAccountViewDto implements IElectricityAccountViewDto {
    accountNumber!: string | undefined;
    serviceProviderName!: string | undefined;

    constructor(data?: IElectricityAccountViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.serviceProviderName = _data["serviceProviderName"];
        }
    }

    static fromJS(data: any): ElectricityAccountViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityAccountViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["serviceProviderName"] = this.serviceProviderName;
        return data;
    }
}

export interface IElectricityAccountViewDto {
    accountNumber: string | undefined;
    serviceProviderName: string | undefined;
}

export class ElectricityComparisonReportFiltersDto implements IElectricityComparisonReportFiltersDto {
    availablePeriods!: ElectricityComparisonReportPeriodDto[] | undefined;

    constructor(data?: IElectricityComparisonReportFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availablePeriods"])) {
                this.availablePeriods = [] as any;
                for (let item of _data["availablePeriods"])
                    this.availablePeriods!.push(ElectricityComparisonReportPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElectricityComparisonReportFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityComparisonReportFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availablePeriods)) {
            data["availablePeriods"] = [];
            for (let item of this.availablePeriods)
                data["availablePeriods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IElectricityComparisonReportFiltersDto {
    availablePeriods: ElectricityComparisonReportPeriodDto[] | undefined;
}

export class ElectricityComparisonReportPeriodDto implements IElectricityComparisonReportPeriodDto {
    year!: number;
    half!: ReportHalf;

    constructor(data?: IElectricityComparisonReportPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.half = _data["half"];
        }
    }

    static fromJS(data: any): ElectricityComparisonReportPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityComparisonReportPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["half"] = this.half;
        return data;
    }
}

export interface IElectricityComparisonReportPeriodDto {
    year: number;
    half: ReportHalf;
}

export class ElectricityConsumptionReportEntityRowDto implements IElectricityConsumptionReportEntityRowDto {
    entityId!: number;
    entityCode!: string | undefined;
    entityNameAr!: string | undefined;
    entityNameEn!: string | undefined;
    sectorNameAr!: string | undefined;
    sectorNameEn!: string | undefined;
    totalSubmittedRequestsCount!: number;
    totalBuildings!: number;
    totalConsumptionsKWh!: number;
    totalApprovedConsumptionsKWh!: number;
    totalAmountAccepted!: number;
    totalAmount!: number;
    requests!: ElectricityConsumptionReportRequestDto[] | undefined;

    constructor(data?: IElectricityConsumptionReportEntityRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityCode = _data["entityCode"];
            this.entityNameAr = _data["entityNameAr"];
            this.entityNameEn = _data["entityNameEn"];
            this.sectorNameAr = _data["sectorNameAr"];
            this.sectorNameEn = _data["sectorNameEn"];
            this.totalSubmittedRequestsCount = _data["totalSubmittedRequestsCount"];
            this.totalBuildings = _data["totalBuildings"];
            this.totalConsumptionsKWh = _data["totalConsumptionsKWh"];
            this.totalApprovedConsumptionsKWh = _data["totalApprovedConsumptionsKWh"];
            this.totalAmountAccepted = _data["totalAmountAccepted"];
            this.totalAmount = _data["totalAmount"];
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(ElectricityConsumptionReportRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElectricityConsumptionReportEntityRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityConsumptionReportEntityRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityCode"] = this.entityCode;
        data["entityNameAr"] = this.entityNameAr;
        data["entityNameEn"] = this.entityNameEn;
        data["sectorNameAr"] = this.sectorNameAr;
        data["sectorNameEn"] = this.sectorNameEn;
        data["totalSubmittedRequestsCount"] = this.totalSubmittedRequestsCount;
        data["totalBuildings"] = this.totalBuildings;
        data["totalConsumptionsKWh"] = this.totalConsumptionsKWh;
        data["totalApprovedConsumptionsKWh"] = this.totalApprovedConsumptionsKWh;
        data["totalAmountAccepted"] = this.totalAmountAccepted;
        data["totalAmount"] = this.totalAmount;
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IElectricityConsumptionReportEntityRowDto {
    entityId: number;
    entityCode: string | undefined;
    entityNameAr: string | undefined;
    entityNameEn: string | undefined;
    sectorNameAr: string | undefined;
    sectorNameEn: string | undefined;
    totalSubmittedRequestsCount: number;
    totalBuildings: number;
    totalConsumptionsKWh: number;
    totalApprovedConsumptionsKWh: number;
    totalAmountAccepted: number;
    totalAmount: number;
    requests: ElectricityConsumptionReportRequestDto[] | undefined;
}

export class ElectricityConsumptionReportFiltersDto implements IElectricityConsumptionReportFiltersDto {
    years!: number[] | undefined;
    submissionCycles!: string[] | undefined;

    constructor(data?: IElectricityConsumptionReportFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(item);
            }
            if (Array.isArray(_data["submissionCycles"])) {
                this.submissionCycles = [] as any;
                for (let item of _data["submissionCycles"])
                    this.submissionCycles!.push(item);
            }
        }
    }

    static fromJS(data: any): ElectricityConsumptionReportFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityConsumptionReportFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item);
        }
        if (Array.isArray(this.submissionCycles)) {
            data["submissionCycles"] = [];
            for (let item of this.submissionCycles)
                data["submissionCycles"].push(item);
        }
        return data;
    }
}

export interface IElectricityConsumptionReportFiltersDto {
    years: number[] | undefined;
    submissionCycles: string[] | undefined;
}

export class ElectricityConsumptionReportRequestDto implements IElectricityConsumptionReportRequestDto {
    requestId!: number;
    requestNumber!: string | undefined;
    submitionDate!: DateTime | undefined;
    year!: string | undefined;
    requestStatusId!: number;
    requestStatusName!: string | undefined;
    isNotApplicable!: boolean;
    meterTypes!: string | undefined;
    electricityProviders!: string | undefined;
    totalConsumptionKWh!: number;
    totalAmountSAR!: number;
    justificationName!: string | undefined;
    comment!: string | undefined;

    constructor(data?: IElectricityConsumptionReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestNumber = _data["requestNumber"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.year = _data["year"];
            this.requestStatusId = _data["requestStatusId"];
            this.requestStatusName = _data["requestStatusName"];
            this.isNotApplicable = _data["isNotApplicable"];
            this.meterTypes = _data["meterTypes"];
            this.electricityProviders = _data["electricityProviders"];
            this.totalConsumptionKWh = _data["totalConsumptionKWh"];
            this.totalAmountSAR = _data["totalAmountSAR"];
            this.justificationName = _data["justificationName"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ElectricityConsumptionReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityConsumptionReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestNumber"] = this.requestNumber;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["year"] = this.year;
        data["requestStatusId"] = this.requestStatusId;
        data["requestStatusName"] = this.requestStatusName;
        data["isNotApplicable"] = this.isNotApplicable;
        data["meterTypes"] = this.meterTypes;
        data["electricityProviders"] = this.electricityProviders;
        data["totalConsumptionKWh"] = this.totalConsumptionKWh;
        data["totalAmountSAR"] = this.totalAmountSAR;
        data["justificationName"] = this.justificationName;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IElectricityConsumptionReportRequestDto {
    requestId: number;
    requestNumber: string | undefined;
    submitionDate: DateTime | undefined;
    year: string | undefined;
    requestStatusId: number;
    requestStatusName: string | undefined;
    isNotApplicable: boolean;
    meterTypes: string | undefined;
    electricityProviders: string | undefined;
    totalConsumptionKWh: number;
    totalAmountSAR: number;
    justificationName: string | undefined;
    comment: string | undefined;
}

export class ElectricityConsumptionReportSummaryDto implements IElectricityConsumptionReportSummaryDto {
    totalApprovedConsumptionKWh!: number;
    totalApprovedAmountSAR!: number;
    totalSubmittedRequestsCount!: number;
    totalEntitiesCount!: number;
    totalApprovedRequestsCount!: number;
    totalModifiedOrRejectedRequestsCount!: number;

    constructor(data?: IElectricityConsumptionReportSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalApprovedConsumptionKWh = _data["totalApprovedConsumptionKWh"];
            this.totalApprovedAmountSAR = _data["totalApprovedAmountSAR"];
            this.totalSubmittedRequestsCount = _data["totalSubmittedRequestsCount"];
            this.totalEntitiesCount = _data["totalEntitiesCount"];
            this.totalApprovedRequestsCount = _data["totalApprovedRequestsCount"];
            this.totalModifiedOrRejectedRequestsCount = _data["totalModifiedOrRejectedRequestsCount"];
        }
    }

    static fromJS(data: any): ElectricityConsumptionReportSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityConsumptionReportSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalApprovedConsumptionKWh"] = this.totalApprovedConsumptionKWh;
        data["totalApprovedAmountSAR"] = this.totalApprovedAmountSAR;
        data["totalSubmittedRequestsCount"] = this.totalSubmittedRequestsCount;
        data["totalEntitiesCount"] = this.totalEntitiesCount;
        data["totalApprovedRequestsCount"] = this.totalApprovedRequestsCount;
        data["totalModifiedOrRejectedRequestsCount"] = this.totalModifiedOrRejectedRequestsCount;
        return data;
    }
}

export interface IElectricityConsumptionReportSummaryDto {
    totalApprovedConsumptionKWh: number;
    totalApprovedAmountSAR: number;
    totalSubmittedRequestsCount: number;
    totalEntitiesCount: number;
    totalApprovedRequestsCount: number;
    totalModifiedOrRejectedRequestsCount: number;
}

export class ElectricityCycleConsumptionJson implements IElectricityCycleConsumptionJson {
    submissionCycle!: string | undefined;
    totalBuildings!: number;
    totalConsumption_kWh!: number;
    totalAmount_SAR!: number;

    constructor(data?: IElectricityCycleConsumptionJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionCycle = _data["submissionCycle"];
            this.totalBuildings = _data["totalBuildings"];
            this.totalConsumption_kWh = _data["totalConsumption_kWh"];
            this.totalAmount_SAR = _data["totalAmount_SAR"];
        }
    }

    static fromJS(data: any): ElectricityCycleConsumptionJson {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityCycleConsumptionJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionCycle"] = this.submissionCycle;
        data["totalBuildings"] = this.totalBuildings;
        data["totalConsumption_kWh"] = this.totalConsumption_kWh;
        data["totalAmount_SAR"] = this.totalAmount_SAR;
        return data;
    }
}

export interface IElectricityCycleConsumptionJson {
    submissionCycle: string | undefined;
    totalBuildings: number;
    totalConsumption_kWh: number;
    totalAmount_SAR: number;
}

export class ElectricityEEPMonitoringDto implements IElectricityEEPMonitoringDto {
    eepActivites!: GetOrganizationEEPDetailByOrgEppIdDto[] | undefined;
    totalExpectedEnergySavingRate!: number | undefined;
    totalActualSavingRate!: number | undefined;
    requestStatus!: number;

    constructor(data?: IElectricityEEPMonitoringDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["eepActivites"])) {
                this.eepActivites = [] as any;
                for (let item of _data["eepActivites"])
                    this.eepActivites!.push(GetOrganizationEEPDetailByOrgEppIdDto.fromJS(item));
            }
            this.totalExpectedEnergySavingRate = _data["totalExpectedEnergySavingRate"];
            this.totalActualSavingRate = _data["totalActualSavingRate"];
            this.requestStatus = _data["requestStatus"];
        }
    }

    static fromJS(data: any): ElectricityEEPMonitoringDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityEEPMonitoringDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.eepActivites)) {
            data["eepActivites"] = [];
            for (let item of this.eepActivites)
                data["eepActivites"].push(item.toJSON());
        }
        data["totalExpectedEnergySavingRate"] = this.totalExpectedEnergySavingRate;
        data["totalActualSavingRate"] = this.totalActualSavingRate;
        data["requestStatus"] = this.requestStatus;
        return data;
    }
}

export interface IElectricityEEPMonitoringDto {
    eepActivites: GetOrganizationEEPDetailByOrgEppIdDto[] | undefined;
    totalExpectedEnergySavingRate: number | undefined;
    totalActualSavingRate: number | undefined;
    requestStatus: number;
}

export class ElectricityHistoricalConsumptionRowDto implements IElectricityHistoricalConsumptionRowDto {
    newOrgCode!: string | undefined;
    nameAr!: string | undefined;
    nameEn!: string | undefined;
    oldOrgId!: number | undefined;
    oldOrgCode!: string | undefined;
    year!: number;
    submissionCycle!: string | undefined;
    totalBuildings!: number;
    totalConsumptionKWh!: number;
    totalAmountSAR!: number;

    constructor(data?: IElectricityHistoricalConsumptionRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newOrgCode = _data["newOrgCode"];
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
            this.oldOrgId = _data["oldOrgId"];
            this.oldOrgCode = _data["oldOrgCode"];
            this.year = _data["year"];
            this.submissionCycle = _data["submissionCycle"];
            this.totalBuildings = _data["totalBuildings"];
            this.totalConsumptionKWh = _data["totalConsumptionKWh"];
            this.totalAmountSAR = _data["totalAmountSAR"];
        }
    }

    static fromJS(data: any): ElectricityHistoricalConsumptionRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityHistoricalConsumptionRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newOrgCode"] = this.newOrgCode;
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        data["oldOrgId"] = this.oldOrgId;
        data["oldOrgCode"] = this.oldOrgCode;
        data["year"] = this.year;
        data["submissionCycle"] = this.submissionCycle;
        data["totalBuildings"] = this.totalBuildings;
        data["totalConsumptionKWh"] = this.totalConsumptionKWh;
        data["totalAmountSAR"] = this.totalAmountSAR;
        return data;
    }
}

export interface IElectricityHistoricalConsumptionRowDto {
    newOrgCode: string | undefined;
    nameAr: string | undefined;
    nameEn: string | undefined;
    oldOrgId: number | undefined;
    oldOrgCode: string | undefined;
    year: number;
    submissionCycle: string | undefined;
    totalBuildings: number;
    totalConsumptionKWh: number;
    totalAmountSAR: number;
}

export class ElectricityHistoricalDropdownsDto implements IElectricityHistoricalDropdownsDto {
    years!: number[] | undefined;
    submissionCycles!: string[] | undefined;

    constructor(data?: IElectricityHistoricalDropdownsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(item);
            }
            if (Array.isArray(_data["submissionCycles"])) {
                this.submissionCycles = [] as any;
                for (let item of _data["submissionCycles"])
                    this.submissionCycles!.push(item);
            }
        }
    }

    static fromJS(data: any): ElectricityHistoricalDropdownsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricityHistoricalDropdownsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item);
        }
        if (Array.isArray(this.submissionCycles)) {
            data["submissionCycles"] = [];
            for (let item of this.submissionCycles)
                data["submissionCycles"].push(item);
        }
        return data;
    }
}

export interface IElectricityHistoricalDropdownsDto {
    years: number[] | undefined;
    submissionCycles: string[] | undefined;
}

export class EmailDto implements IEmailDto {
    senderEmailAddress!: string | undefined;
    receiverEmailAddress!: string | undefined;
    emailSubject!: string | undefined;
    emailBody!: string | undefined;
    isSent!: boolean;
    errorType!: string | undefined;
    errorCode!: string | undefined;
    errorMessage!: string | undefined;
    reTryCounter!: number;
    machineName!: string | undefined;
    id!: number;

    constructor(data?: IEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.senderEmailAddress = _data["senderEmailAddress"];
            this.receiverEmailAddress = _data["receiverEmailAddress"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.isSent = _data["isSent"];
            this.errorType = _data["errorType"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.reTryCounter = _data["reTryCounter"];
            this.machineName = _data["machineName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senderEmailAddress"] = this.senderEmailAddress;
        data["receiverEmailAddress"] = this.receiverEmailAddress;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["isSent"] = this.isSent;
        data["errorType"] = this.errorType;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["reTryCounter"] = this.reTryCounter;
        data["machineName"] = this.machineName;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmailDto {
    senderEmailAddress: string | undefined;
    receiverEmailAddress: string | undefined;
    emailSubject: string | undefined;
    emailBody: string | undefined;
    isSent: boolean;
    errorType: string | undefined;
    errorCode: string | undefined;
    errorMessage: string | undefined;
    reTryCounter: number;
    machineName: string | undefined;
    id: number;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class EmailTemplateDto implements IEmailTemplateDto {
    id!: number;

    constructor(data?: IEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEmailTemplateDto {
    id: number;
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: DateTime;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    id!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.changeType = _data["changeType"];
            (<any>this).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: DateTime;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.remainingDayCount = _data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        (<any>this.additionalParams)![key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    (<any>data["additionalParams"])[key] = (<any>this.additionalParams)[key];
            }
        }
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class ExternalLoginProviderSettingsEditDto implements IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated!: boolean;
    facebook!: FacebookExternalLoginProviderSettings;
    google_IsDeactivated!: boolean;
    google!: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated!: boolean;
    twitter!: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated!: boolean;
    microsoft!: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated!: boolean;
    openIdConnect!: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping!: JsonClaimMapDto[] | undefined;
    wsFederation_IsDeactivated!: boolean;
    wsFederation!: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping!: JsonClaimMapDto[] | undefined;

    constructor(data?: IExternalLoginProviderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facebook_IsDeactivated = _data["facebook_IsDeactivated"];
            this.facebook = _data["facebook"] ? FacebookExternalLoginProviderSettings.fromJS(_data["facebook"]) : <any>undefined;
            this.google_IsDeactivated = _data["google_IsDeactivated"];
            this.google = _data["google"] ? GoogleExternalLoginProviderSettings.fromJS(_data["google"]) : <any>undefined;
            this.twitter_IsDeactivated = _data["twitter_IsDeactivated"];
            this.twitter = _data["twitter"] ? TwitterExternalLoginProviderSettings.fromJS(_data["twitter"]) : <any>undefined;
            this.microsoft_IsDeactivated = _data["microsoft_IsDeactivated"];
            this.microsoft = _data["microsoft"] ? MicrosoftExternalLoginProviderSettings.fromJS(_data["microsoft"]) : <any>undefined;
            this.openIdConnect_IsDeactivated = _data["openIdConnect_IsDeactivated"];
            this.openIdConnect = _data["openIdConnect"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["openIdConnect"]) : <any>undefined;
            if (Array.isArray(_data["openIdConnectClaimsMapping"])) {
                this.openIdConnectClaimsMapping = [] as any;
                for (let item of _data["openIdConnectClaimsMapping"])
                    this.openIdConnectClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            this.wsFederation_IsDeactivated = _data["wsFederation_IsDeactivated"];
            this.wsFederation = _data["wsFederation"] ? WsFederationExternalLoginProviderSettings.fromJS(_data["wsFederation"]) : <any>undefined;
            if (Array.isArray(_data["wsFederationClaimsMapping"])) {
                this.wsFederationClaimsMapping = [] as any;
                for (let item of _data["wsFederationClaimsMapping"])
                    this.wsFederationClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebook_IsDeactivated"] = this.facebook_IsDeactivated;
        data["facebook"] = this.facebook ? this.facebook.toJSON() : <any>undefined;
        data["google_IsDeactivated"] = this.google_IsDeactivated;
        data["google"] = this.google ? this.google.toJSON() : <any>undefined;
        data["twitter_IsDeactivated"] = this.twitter_IsDeactivated;
        data["twitter"] = this.twitter ? this.twitter.toJSON() : <any>undefined;
        data["microsoft_IsDeactivated"] = this.microsoft_IsDeactivated;
        data["microsoft"] = this.microsoft ? this.microsoft.toJSON() : <any>undefined;
        data["openIdConnect_IsDeactivated"] = this.openIdConnect_IsDeactivated;
        data["openIdConnect"] = this.openIdConnect ? this.openIdConnect.toJSON() : <any>undefined;
        if (Array.isArray(this.openIdConnectClaimsMapping)) {
            data["openIdConnectClaimsMapping"] = [];
            for (let item of this.openIdConnectClaimsMapping)
                data["openIdConnectClaimsMapping"].push(item.toJSON());
        }
        data["wsFederation_IsDeactivated"] = this.wsFederation_IsDeactivated;
        data["wsFederation"] = this.wsFederation ? this.wsFederation.toJSON() : <any>undefined;
        if (Array.isArray(this.wsFederationClaimsMapping)) {
            data["wsFederationClaimsMapping"] = [];
            for (let item of this.wsFederationClaimsMapping)
                data["wsFederationClaimsMapping"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated: boolean;
    facebook: FacebookExternalLoginProviderSettings;
    google_IsDeactivated: boolean;
    google: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated: boolean;
    twitter: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated: boolean;
    microsoft: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated: boolean;
    openIdConnect: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping: JsonClaimMapDto[] | undefined;
    wsFederation_IsDeactivated: boolean;
    wsFederation: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping: JsonClaimMapDto[] | undefined;
}

export class ExternalLoginSettingsDto implements IExternalLoginSettingsDto {
    enabledSocialLoginSettings!: string[] | undefined;

    constructor(data?: IExternalLoginSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enabledSocialLoginSettings"])) {
                this.enabledSocialLoginSettings = [] as any;
                for (let item of _data["enabledSocialLoginSettings"])
                    this.enabledSocialLoginSettings!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalLoginSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enabledSocialLoginSettings)) {
            data["enabledSocialLoginSettings"] = [];
            for (let item of this.enabledSocialLoginSettings)
                data["enabledSocialLoginSettings"].push(item);
        }
        return data;
    }
}

export interface IExternalLoginSettingsDto {
    enabledSocialLoginSettings: string[] | undefined;
}

export class FacebookExternalLoginProviderSettings implements IFacebookExternalLoginProviderSettings {
    appId!: string | undefined;
    appSecret!: string | undefined;

    constructor(data?: IFacebookExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appSecret = _data["appSecret"];
        }
    }

    static fromJS(data: any): FacebookExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FacebookExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appSecret"] = this.appSecret;
        return data;
    }
}

export interface IFacebookExternalLoginProviderSettings {
    appId: string | undefined;
    appSecret: string | undefined;
}

export class FAQCategoryDto implements IFAQCategoryDto {
    categoryName!: string | undefined;
    viewOrder!: number;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IFAQCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"];
            this.viewOrder = _data["viewOrder"];
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FAQCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FAQCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        data["viewOrder"] = this.viewOrder;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IFAQCategoryDto {
    categoryName: string | undefined;
    viewOrder: number;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class FAQCategoryForHomeDto implements IFAQCategoryForHomeDto {
    categoryName!: string | undefined;
    viewOrder!: number;

    constructor(data?: IFAQCategoryForHomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"];
            this.viewOrder = _data["viewOrder"];
        }
    }

    static fromJS(data: any): FAQCategoryForHomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FAQCategoryForHomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        data["viewOrder"] = this.viewOrder;
        return data;
    }
}

export interface IFAQCategoryForHomeDto {
    categoryName: string | undefined;
    viewOrder: number;
}

export class FAQDto implements IFAQDto {
    question!: string | undefined;
    answer!: string | undefined;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    faqCategory!: FAQCategoryDto;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IFAQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.answer = _data["answer"];
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.faqCategory = _data["faqCategory"] ? FAQCategoryDto.fromJS(_data["faqCategory"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FAQDto {
        data = typeof data === 'object' ? data : {};
        let result = new FAQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["faqCategory"] = this.faqCategory ? this.faqCategory.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IFAQDto {
    question: string | undefined;
    answer: string | undefined;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    faqCategory: FAQCategoryDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class FAQForHomeDto implements IFAQForHomeDto {
    question!: string | undefined;
    answer!: string | undefined;
    faqCategory!: FAQCategoryForHomeDto;

    constructor(data?: IFAQForHomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.answer = _data["answer"];
            this.faqCategory = _data["faqCategory"] ? FAQCategoryForHomeDto.fromJS(_data["faqCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FAQForHomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FAQForHomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["faqCategory"] = this.faqCategory ? this.faqCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFAQForHomeDto {
    question: string | undefined;
    answer: string | undefined;
    faqCategory: FAQCategoryForHomeDto;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;
    itemSource!: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string | undefined;
    fileToken!: string;
    maximumReached!: boolean;
    fileUId!: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
            this.maximumReached = _data["maximumReached"];
            this.fileUId = _data["fileUId"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        data["maximumReached"] = this.maximumReached;
        data["fileUId"] = this.fileUId;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
    maximumReached: boolean;
    fileUId: string | undefined;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitRolesInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId!: number | undefined;
    excludeCurrentUser!: boolean;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.excludeCurrentUser = _data["excludeCurrentUser"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["excludeCurrentUser"] = this.excludeCurrentUser;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    excludeCurrentUser: boolean;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
            this.textHtmlColor = _data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FuelAssetInfoDto implements IFuelAssetInfoDto {
    refrenceNumber!: string | undefined;
    organizationUnitId!: number;
    description!: string | undefined;
    assetTypeId!: number | undefined;
    assetSubTypeId!: number | undefined;
    otherAssetSubTypeName!: string | undefined;
    fuelTypeId!: number;
    fuelUnitId!: number;
    totalFuelConsumptionPerYear!: number;
    manufacturerYear!: string | undefined;
    usageMetric!: number | undefined;
    notes!: string | undefined;
    attachments!: string | undefined;
    addedStatusId!: number | undefined;
    createdAt!: DateTime;
    id!: number;

    constructor(data?: IFuelAssetInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refrenceNumber = _data["refrenceNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.description = _data["description"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetSubTypeId = _data["assetSubTypeId"];
            this.otherAssetSubTypeName = _data["otherAssetSubTypeName"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.fuelUnitId = _data["fuelUnitId"];
            this.totalFuelConsumptionPerYear = _data["totalFuelConsumptionPerYear"];
            this.manufacturerYear = _data["manufacturerYear"];
            this.usageMetric = _data["usageMetric"];
            this.notes = _data["notes"];
            this.attachments = _data["attachments"];
            this.addedStatusId = _data["addedStatusId"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FuelAssetInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelAssetInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refrenceNumber"] = this.refrenceNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["description"] = this.description;
        data["assetTypeId"] = this.assetTypeId;
        data["assetSubTypeId"] = this.assetSubTypeId;
        data["otherAssetSubTypeName"] = this.otherAssetSubTypeName;
        data["fuelTypeId"] = this.fuelTypeId;
        data["fuelUnitId"] = this.fuelUnitId;
        data["totalFuelConsumptionPerYear"] = this.totalFuelConsumptionPerYear;
        data["manufacturerYear"] = this.manufacturerYear;
        data["usageMetric"] = this.usageMetric;
        data["notes"] = this.notes;
        data["attachments"] = this.attachments;
        data["addedStatusId"] = this.addedStatusId;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IFuelAssetInfoDto {
    refrenceNumber: string | undefined;
    organizationUnitId: number;
    description: string | undefined;
    assetTypeId: number | undefined;
    assetSubTypeId: number | undefined;
    otherAssetSubTypeName: string | undefined;
    fuelTypeId: number;
    fuelUnitId: number;
    totalFuelConsumptionPerYear: number;
    manufacturerYear: string | undefined;
    usageMetric: number | undefined;
    notes: string | undefined;
    attachments: string | undefined;
    addedStatusId: number | undefined;
    createdAt: DateTime;
    id: number;
}

export class FuelComparisonData implements IFuelComparisonData {
    governmentData!: FuelConsumptionDataForViewDto[] | undefined;
    providerData!: FuelConsumptionDataForViewDto[] | undefined;

    constructor(data?: IFuelComparisonData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["governmentData"])) {
                this.governmentData = [] as any;
                for (let item of _data["governmentData"])
                    this.governmentData!.push(FuelConsumptionDataForViewDto.fromJS(item));
            }
            if (Array.isArray(_data["providerData"])) {
                this.providerData = [] as any;
                for (let item of _data["providerData"])
                    this.providerData!.push(FuelConsumptionDataForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FuelComparisonData {
        data = typeof data === 'object' ? data : {};
        let result = new FuelComparisonData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.governmentData)) {
            data["governmentData"] = [];
            for (let item of this.governmentData)
                data["governmentData"].push(item.toJSON());
        }
        if (Array.isArray(this.providerData)) {
            data["providerData"] = [];
            for (let item of this.providerData)
                data["providerData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFuelComparisonData {
    governmentData: FuelConsumptionDataForViewDto[] | undefined;
    providerData: FuelConsumptionDataForViewDto[] | undefined;
}

export class FuelConsumptionDataForViewDto implements IFuelConsumptionDataForViewDto {
    fuelUnitId!: number;
    fuelUnitName!: string | undefined;
    otherFuelUnitName!: string | undefined;
    fuelTypeId!: number;
    fuelTypeName!: string | undefined;
    totalQuantity!: number;
    totalAmount!: number;

    constructor(data?: IFuelConsumptionDataForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelUnitId = _data["fuelUnitId"];
            this.fuelUnitName = _data["fuelUnitName"];
            this.otherFuelUnitName = _data["otherFuelUnitName"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.fuelTypeName = _data["fuelTypeName"];
            this.totalQuantity = _data["totalQuantity"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): FuelConsumptionDataForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelConsumptionDataForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelUnitId"] = this.fuelUnitId;
        data["fuelUnitName"] = this.fuelUnitName;
        data["otherFuelUnitName"] = this.otherFuelUnitName;
        data["fuelTypeId"] = this.fuelTypeId;
        data["fuelTypeName"] = this.fuelTypeName;
        data["totalQuantity"] = this.totalQuantity;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IFuelConsumptionDataForViewDto {
    fuelUnitId: number;
    fuelUnitName: string | undefined;
    otherFuelUnitName: string | undefined;
    fuelTypeId: number;
    fuelTypeName: string | undefined;
    totalQuantity: number;
    totalAmount: number;
}

export class FuelConsumptionJson implements IFuelConsumptionJson {
    fuelType!: string | undefined;
    quantity!: number;
    consumedQuantity!: number;
    unit!: string | undefined;
    cost_SAR!: number;

    constructor(data?: IFuelConsumptionJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelType = _data["fuelType"];
            this.quantity = _data["quantity"];
            this.consumedQuantity = _data["consumedQuantity"];
            this.unit = _data["unit"];
            this.cost_SAR = _data["cost_SAR"];
        }
    }

    static fromJS(data: any): FuelConsumptionJson {
        data = typeof data === 'object' ? data : {};
        let result = new FuelConsumptionJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelType"] = this.fuelType;
        data["quantity"] = this.quantity;
        data["consumedQuantity"] = this.consumedQuantity;
        data["unit"] = this.unit;
        data["cost_SAR"] = this.cost_SAR;
        return data;
    }
}

export interface IFuelConsumptionJson {
    fuelType: string | undefined;
    quantity: number;
    consumedQuantity: number;
    unit: string | undefined;
    cost_SAR: number;
}

export class FuelConsumptionRecordDto implements IFuelConsumptionRecordDto {
    consumerTypeId!: string | undefined;
    selectedConsumerType!: TreeNodesDto;
    serializedSelectedConsumerTypes!: string | undefined;
    quantity!: number;
    fuelTypeId!: number;
    consumedQuantity!: number;
    unitOfConsumptionId!: number;
    cost!: number;
    recordIndex!: number;
    fuelProviderEntityId!: number | undefined;
    fuelProviderValue!: string | undefined;
    otherFuelProviderName!: string | undefined;
    otherFuelType!: string | undefined;
    isParent!: boolean | undefined;
    isSelectedFuelType!: boolean | undefined;
    quantityMessage!: string | undefined;
    consumptionConsumerTypes!: ConsumptionConsumerTypesDto[] | undefined;
    selectedFuelTypes!: LookupDto[] | undefined;
    providerName!: string | undefined;
    consumerTypeName!: string | undefined;
    consumerTypeDescription!: string | undefined;
    unitName!: string | undefined;
    fuelTypeName!: string | undefined;
    attachment!: string | undefined;
    key!: string | undefined;
    contractAgreementTypeId!: number | undefined;
    vehicleTypeId!: number | undefined;
    comment!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IFuelConsumptionRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerTypeId = _data["consumerTypeId"];
            this.selectedConsumerType = _data["selectedConsumerType"] ? TreeNodesDto.fromJS(_data["selectedConsumerType"]) : <any>undefined;
            this.serializedSelectedConsumerTypes = _data["serializedSelectedConsumerTypes"];
            this.quantity = _data["quantity"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.consumedQuantity = _data["consumedQuantity"];
            this.unitOfConsumptionId = _data["unitOfConsumptionId"];
            this.cost = _data["cost"];
            this.recordIndex = _data["recordIndex"];
            this.fuelProviderEntityId = _data["fuelProviderEntityId"];
            this.fuelProviderValue = _data["fuelProviderValue"];
            this.otherFuelProviderName = _data["otherFuelProviderName"];
            this.otherFuelType = _data["otherFuelType"];
            this.isParent = _data["isParent"];
            this.isSelectedFuelType = _data["isSelectedFuelType"];
            this.quantityMessage = _data["quantityMessage"];
            if (Array.isArray(_data["consumptionConsumerTypes"])) {
                this.consumptionConsumerTypes = [] as any;
                for (let item of _data["consumptionConsumerTypes"])
                    this.consumptionConsumerTypes!.push(ConsumptionConsumerTypesDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedFuelTypes"])) {
                this.selectedFuelTypes = [] as any;
                for (let item of _data["selectedFuelTypes"])
                    this.selectedFuelTypes!.push(LookupDto.fromJS(item));
            }
            this.providerName = _data["providerName"];
            this.consumerTypeName = _data["consumerTypeName"];
            this.consumerTypeDescription = _data["consumerTypeDescription"];
            this.unitName = _data["unitName"];
            this.fuelTypeName = _data["fuelTypeName"];
            this.attachment = _data["attachment"];
            this.key = _data["key"];
            this.contractAgreementTypeId = _data["contractAgreementTypeId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.comment = _data["comment"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FuelConsumptionRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelConsumptionRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerTypeId"] = this.consumerTypeId;
        data["selectedConsumerType"] = this.selectedConsumerType ? this.selectedConsumerType.toJSON() : <any>undefined;
        data["serializedSelectedConsumerTypes"] = this.serializedSelectedConsumerTypes;
        data["quantity"] = this.quantity;
        data["fuelTypeId"] = this.fuelTypeId;
        data["consumedQuantity"] = this.consumedQuantity;
        data["unitOfConsumptionId"] = this.unitOfConsumptionId;
        data["cost"] = this.cost;
        data["recordIndex"] = this.recordIndex;
        data["fuelProviderEntityId"] = this.fuelProviderEntityId;
        data["fuelProviderValue"] = this.fuelProviderValue;
        data["otherFuelProviderName"] = this.otherFuelProviderName;
        data["otherFuelType"] = this.otherFuelType;
        data["isParent"] = this.isParent;
        data["isSelectedFuelType"] = this.isSelectedFuelType;
        data["quantityMessage"] = this.quantityMessage;
        if (Array.isArray(this.consumptionConsumerTypes)) {
            data["consumptionConsumerTypes"] = [];
            for (let item of this.consumptionConsumerTypes)
                data["consumptionConsumerTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedFuelTypes)) {
            data["selectedFuelTypes"] = [];
            for (let item of this.selectedFuelTypes)
                data["selectedFuelTypes"].push(item.toJSON());
        }
        data["providerName"] = this.providerName;
        data["consumerTypeName"] = this.consumerTypeName;
        data["consumerTypeDescription"] = this.consumerTypeDescription;
        data["unitName"] = this.unitName;
        data["fuelTypeName"] = this.fuelTypeName;
        data["attachment"] = this.attachment;
        data["key"] = this.key;
        data["contractAgreementTypeId"] = this.contractAgreementTypeId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["comment"] = this.comment;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IFuelConsumptionRecordDto {
    consumerTypeId: string | undefined;
    selectedConsumerType: TreeNodesDto;
    serializedSelectedConsumerTypes: string | undefined;
    quantity: number;
    fuelTypeId: number;
    consumedQuantity: number;
    unitOfConsumptionId: number;
    cost: number;
    recordIndex: number;
    fuelProviderEntityId: number | undefined;
    fuelProviderValue: string | undefined;
    otherFuelProviderName: string | undefined;
    otherFuelType: string | undefined;
    isParent: boolean | undefined;
    isSelectedFuelType: boolean | undefined;
    quantityMessage: string | undefined;
    consumptionConsumerTypes: ConsumptionConsumerTypesDto[] | undefined;
    selectedFuelTypes: LookupDto[] | undefined;
    providerName: string | undefined;
    consumerTypeName: string | undefined;
    consumerTypeDescription: string | undefined;
    unitName: string | undefined;
    fuelTypeName: string | undefined;
    attachment: string | undefined;
    key: string | undefined;
    contractAgreementTypeId: number | undefined;
    vehicleTypeId: number | undefined;
    comment: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class FuelConsumptionReportEntityRowDto implements IFuelConsumptionReportEntityRowDto {
    entityId!: number;
    entityCode!: string | undefined;
    entityNameAr!: string | undefined;
    entityNameEn!: string | undefined;
    totalApprovedCost!: number;
    sectorNameAr!: string | undefined;
    sectorNameEn!: string | undefined;
    consumptionByUnit!: FuelUnitAmountDto[] | undefined;
    requests!: FuelConsumptionReportRequestDto[] | undefined;

    constructor(data?: IFuelConsumptionReportEntityRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityCode = _data["entityCode"];
            this.entityNameAr = _data["entityNameAr"];
            this.entityNameEn = _data["entityNameEn"];
            this.totalApprovedCost = _data["totalApprovedCost"];
            this.sectorNameAr = _data["sectorNameAr"];
            this.sectorNameEn = _data["sectorNameEn"];
            if (Array.isArray(_data["consumptionByUnit"])) {
                this.consumptionByUnit = [] as any;
                for (let item of _data["consumptionByUnit"])
                    this.consumptionByUnit!.push(FuelUnitAmountDto.fromJS(item));
            }
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(FuelConsumptionReportRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FuelConsumptionReportEntityRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelConsumptionReportEntityRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityCode"] = this.entityCode;
        data["entityNameAr"] = this.entityNameAr;
        data["entityNameEn"] = this.entityNameEn;
        data["totalApprovedCost"] = this.totalApprovedCost;
        data["sectorNameAr"] = this.sectorNameAr;
        data["sectorNameEn"] = this.sectorNameEn;
        if (Array.isArray(this.consumptionByUnit)) {
            data["consumptionByUnit"] = [];
            for (let item of this.consumptionByUnit)
                data["consumptionByUnit"].push(item.toJSON());
        }
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFuelConsumptionReportEntityRowDto {
    entityId: number;
    entityCode: string | undefined;
    entityNameAr: string | undefined;
    entityNameEn: string | undefined;
    totalApprovedCost: number;
    sectorNameAr: string | undefined;
    sectorNameEn: string | undefined;
    consumptionByUnit: FuelUnitAmountDto[] | undefined;
    requests: FuelConsumptionReportRequestDto[] | undefined;
}

export class FuelConsumptionReportFiltersDto implements IFuelConsumptionReportFiltersDto {
    years!: number[] | undefined;

    constructor(data?: IFuelConsumptionReportFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(item);
            }
        }
    }

    static fromJS(data: any): FuelConsumptionReportFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelConsumptionReportFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item);
        }
        return data;
    }
}

export interface IFuelConsumptionReportFiltersDto {
    years: number[] | undefined;
}

export class FuelConsumptionReportRequestDto implements IFuelConsumptionReportRequestDto {
    requestId!: number;
    requestNumber!: string | undefined;
    submissionDate!: DateTime | undefined;
    fuelTypes!: string | undefined;
    consumptionByUnit!: FuelUnitAmountDto[] | undefined;
    contractAgreementTypes!: string | undefined;
    vehicleTypes!: string | undefined;
    fuelProviders!: string | undefined;
    requestStatusId!: number;
    requestStatusName!: string | undefined;
    isNotApplicable!: boolean;

    constructor(data?: IFuelConsumptionReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestNumber = _data["requestNumber"];
            this.submissionDate = _data["submissionDate"] ? DateTime.fromISO(_data["submissionDate"].toString()) : <any>undefined;
            this.fuelTypes = _data["fuelTypes"];
            if (Array.isArray(_data["consumptionByUnit"])) {
                this.consumptionByUnit = [] as any;
                for (let item of _data["consumptionByUnit"])
                    this.consumptionByUnit!.push(FuelUnitAmountDto.fromJS(item));
            }
            this.contractAgreementTypes = _data["contractAgreementTypes"];
            this.vehicleTypes = _data["vehicleTypes"];
            this.fuelProviders = _data["fuelProviders"];
            this.requestStatusId = _data["requestStatusId"];
            this.requestStatusName = _data["requestStatusName"];
            this.isNotApplicable = _data["isNotApplicable"];
        }
    }

    static fromJS(data: any): FuelConsumptionReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelConsumptionReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestNumber"] = this.requestNumber;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toString() : <any>undefined;
        data["fuelTypes"] = this.fuelTypes;
        if (Array.isArray(this.consumptionByUnit)) {
            data["consumptionByUnit"] = [];
            for (let item of this.consumptionByUnit)
                data["consumptionByUnit"].push(item.toJSON());
        }
        data["contractAgreementTypes"] = this.contractAgreementTypes;
        data["vehicleTypes"] = this.vehicleTypes;
        data["fuelProviders"] = this.fuelProviders;
        data["requestStatusId"] = this.requestStatusId;
        data["requestStatusName"] = this.requestStatusName;
        data["isNotApplicable"] = this.isNotApplicable;
        return data;
    }
}

export interface IFuelConsumptionReportRequestDto {
    requestId: number;
    requestNumber: string | undefined;
    submissionDate: DateTime | undefined;
    fuelTypes: string | undefined;
    consumptionByUnit: FuelUnitAmountDto[] | undefined;
    contractAgreementTypes: string | undefined;
    vehicleTypes: string | undefined;
    fuelProviders: string | undefined;
    requestStatusId: number;
    requestStatusName: string | undefined;
    isNotApplicable: boolean;
}

export class FuelConsumptionReportSummaryDto implements IFuelConsumptionReportSummaryDto {
    totalConsumptionQuantity!: number;
    totalCost!: number;
    totalSubmittedRequestsCount!: number;
    totalAcceptedRequestsCount!: number;
    totalGovEntitiesCount!: number;
    totalModifiedOrRejectedRequestsCount!: number;

    constructor(data?: IFuelConsumptionReportSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalConsumptionQuantity = _data["totalConsumptionQuantity"];
            this.totalCost = _data["totalCost"];
            this.totalSubmittedRequestsCount = _data["totalSubmittedRequestsCount"];
            this.totalAcceptedRequestsCount = _data["totalAcceptedRequestsCount"];
            this.totalGovEntitiesCount = _data["totalGovEntitiesCount"];
            this.totalModifiedOrRejectedRequestsCount = _data["totalModifiedOrRejectedRequestsCount"];
        }
    }

    static fromJS(data: any): FuelConsumptionReportSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelConsumptionReportSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalConsumptionQuantity"] = this.totalConsumptionQuantity;
        data["totalCost"] = this.totalCost;
        data["totalSubmittedRequestsCount"] = this.totalSubmittedRequestsCount;
        data["totalAcceptedRequestsCount"] = this.totalAcceptedRequestsCount;
        data["totalGovEntitiesCount"] = this.totalGovEntitiesCount;
        data["totalModifiedOrRejectedRequestsCount"] = this.totalModifiedOrRejectedRequestsCount;
        return data;
    }
}

export interface IFuelConsumptionReportSummaryDto {
    totalConsumptionQuantity: number;
    totalCost: number;
    totalSubmittedRequestsCount: number;
    totalAcceptedRequestsCount: number;
    totalGovEntitiesCount: number;
    totalModifiedOrRejectedRequestsCount: number;
}

export class FuelConsumptionReportYearsDto implements IFuelConsumptionReportYearsDto {
    availableYears!: number[] | undefined;

    constructor(data?: IFuelConsumptionReportYearsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableYears"])) {
                this.availableYears = [] as any;
                for (let item of _data["availableYears"])
                    this.availableYears!.push(item);
            }
        }
    }

    static fromJS(data: any): FuelConsumptionReportYearsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelConsumptionReportYearsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableYears)) {
            data["availableYears"] = [];
            for (let item of this.availableYears)
                data["availableYears"].push(item);
        }
        return data;
    }
}

export interface IFuelConsumptionReportYearsDto {
    availableYears: number[] | undefined;
}

export class FuelConsumptionSummaryDto implements IFuelConsumptionSummaryDto {
    fuelTypeIdSum!: number;
    unitIdSum!: number;
    fuelTypeSum!: string | undefined;
    fuelUnitSum!: string | undefined;
    totalConsumedQuantitySum!: number;

    constructor(data?: IFuelConsumptionSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelTypeIdSum = _data["fuelTypeIdSum"];
            this.unitIdSum = _data["unitIdSum"];
            this.fuelTypeSum = _data["fuelTypeSum"];
            this.fuelUnitSum = _data["fuelUnitSum"];
            this.totalConsumedQuantitySum = _data["totalConsumedQuantitySum"];
        }
    }

    static fromJS(data: any): FuelConsumptionSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelConsumptionSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelTypeIdSum"] = this.fuelTypeIdSum;
        data["unitIdSum"] = this.unitIdSum;
        data["fuelTypeSum"] = this.fuelTypeSum;
        data["fuelUnitSum"] = this.fuelUnitSum;
        data["totalConsumedQuantitySum"] = this.totalConsumedQuantitySum;
        return data;
    }
}

export interface IFuelConsumptionSummaryDto {
    fuelTypeIdSum: number;
    unitIdSum: number;
    fuelTypeSum: string | undefined;
    fuelUnitSum: string | undefined;
    totalConsumedQuantitySum: number;
}

export class FuelHistoricalConsumptionRowDto implements IFuelHistoricalConsumptionRowDto {
    newOrgCode!: string | undefined;
    nameAr!: string | undefined;
    nameEn!: string | undefined;
    oldOrgId!: number | undefined;
    oldOrgCode!: string | undefined;
    year!: number;
    fuelType!: string | undefined;
    quantity!: number;
    consumedQuantity!: number;
    unit!: string | undefined;
    costSAR!: number;

    constructor(data?: IFuelHistoricalConsumptionRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newOrgCode = _data["newOrgCode"];
            this.nameAr = _data["nameAr"];
            this.nameEn = _data["nameEn"];
            this.oldOrgId = _data["oldOrgId"];
            this.oldOrgCode = _data["oldOrgCode"];
            this.year = _data["year"];
            this.fuelType = _data["fuelType"];
            this.quantity = _data["quantity"];
            this.consumedQuantity = _data["consumedQuantity"];
            this.unit = _data["unit"];
            this.costSAR = _data["costSAR"];
        }
    }

    static fromJS(data: any): FuelHistoricalConsumptionRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelHistoricalConsumptionRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newOrgCode"] = this.newOrgCode;
        data["nameAr"] = this.nameAr;
        data["nameEn"] = this.nameEn;
        data["oldOrgId"] = this.oldOrgId;
        data["oldOrgCode"] = this.oldOrgCode;
        data["year"] = this.year;
        data["fuelType"] = this.fuelType;
        data["quantity"] = this.quantity;
        data["consumedQuantity"] = this.consumedQuantity;
        data["unit"] = this.unit;
        data["costSAR"] = this.costSAR;
        return data;
    }
}

export interface IFuelHistoricalConsumptionRowDto {
    newOrgCode: string | undefined;
    nameAr: string | undefined;
    nameEn: string | undefined;
    oldOrgId: number | undefined;
    oldOrgCode: string | undefined;
    year: number;
    fuelType: string | undefined;
    quantity: number;
    consumedQuantity: number;
    unit: string | undefined;
    costSAR: number;
}

export class FuelHistoricalDropdownsDto implements IFuelHistoricalDropdownsDto {
    years!: number[] | undefined;
    fuelTypes!: string[] | undefined;
    units!: string[] | undefined;

    constructor(data?: IFuelHistoricalDropdownsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(item);
            }
            if (Array.isArray(_data["fuelTypes"])) {
                this.fuelTypes = [] as any;
                for (let item of _data["fuelTypes"])
                    this.fuelTypes!.push(item);
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(item);
            }
        }
    }

    static fromJS(data: any): FuelHistoricalDropdownsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelHistoricalDropdownsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item);
        }
        if (Array.isArray(this.fuelTypes)) {
            data["fuelTypes"] = [];
            for (let item of this.fuelTypes)
                data["fuelTypes"].push(item);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item);
        }
        return data;
    }
}

export interface IFuelHistoricalDropdownsDto {
    years: number[] | undefined;
    fuelTypes: string[] | undefined;
    units: string[] | undefined;
}

export class FuelProviderDataDto implements IFuelProviderDataDto {
    year!: string | undefined;
    organizationUnitId!: number;
    requestId!: number | undefined;
    organizationUnitFk!: OrganizationUnitDto;
    fuelProviderUnitId!: number;
    fuelProviderUnitFk!: OrganizationUnitDto;
    requestNumber!: string | undefined;
    requestCreationTime!: DateTime | undefined;
    requestStatusId!: number;
    requestStatus!: string | undefined;
    isManualEntry!: boolean;
    id!: number;

    constructor(data?: IFuelProviderDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.requestId = _data["requestId"];
            this.organizationUnitFk = _data["organizationUnitFk"] ? OrganizationUnitDto.fromJS(_data["organizationUnitFk"]) : <any>undefined;
            this.fuelProviderUnitId = _data["fuelProviderUnitId"];
            this.fuelProviderUnitFk = _data["fuelProviderUnitFk"] ? OrganizationUnitDto.fromJS(_data["fuelProviderUnitFk"]) : <any>undefined;
            this.requestNumber = _data["requestNumber"];
            this.requestCreationTime = _data["requestCreationTime"] ? DateTime.fromISO(_data["requestCreationTime"].toString()) : <any>undefined;
            this.requestStatusId = _data["requestStatusId"];
            this.requestStatus = _data["requestStatus"];
            this.isManualEntry = _data["isManualEntry"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FuelProviderDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelProviderDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["organizationUnitId"] = this.organizationUnitId;
        data["requestId"] = this.requestId;
        data["organizationUnitFk"] = this.organizationUnitFk ? this.organizationUnitFk.toJSON() : <any>undefined;
        data["fuelProviderUnitId"] = this.fuelProviderUnitId;
        data["fuelProviderUnitFk"] = this.fuelProviderUnitFk ? this.fuelProviderUnitFk.toJSON() : <any>undefined;
        data["requestNumber"] = this.requestNumber;
        data["requestCreationTime"] = this.requestCreationTime ? this.requestCreationTime.toString() : <any>undefined;
        data["requestStatusId"] = this.requestStatusId;
        data["requestStatus"] = this.requestStatus;
        data["isManualEntry"] = this.isManualEntry;
        data["id"] = this.id;
        return data;
    }
}

export interface IFuelProviderDataDto {
    year: string | undefined;
    organizationUnitId: number;
    requestId: number | undefined;
    organizationUnitFk: OrganizationUnitDto;
    fuelProviderUnitId: number;
    fuelProviderUnitFk: OrganizationUnitDto;
    requestNumber: string | undefined;
    requestCreationTime: DateTime | undefined;
    requestStatusId: number;
    requestStatus: string | undefined;
    isManualEntry: boolean;
    id: number;
}

export class FuelProviderDataOrganizationUnitLookupTableDto implements IFuelProviderDataOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFuelProviderDataOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): FuelProviderDataOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelProviderDataOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IFuelProviderDataOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FuelProviderDataRequestLookupTableDto implements IFuelProviderDataRequestLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFuelProviderDataRequestLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): FuelProviderDataRequestLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelProviderDataRequestLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IFuelProviderDataRequestLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FuelProviderDetailDto implements IFuelProviderDetailDto {
    amount!: number;
    quantity!: number;
    fuelProviderDataId!: number;
    fuelTypeId!: number;
    fuelUnitId!: number;
    id!: number;

    constructor(data?: IFuelProviderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.fuelProviderDataId = _data["fuelProviderDataId"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.fuelUnitId = _data["fuelUnitId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FuelProviderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelProviderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["fuelProviderDataId"] = this.fuelProviderDataId;
        data["fuelTypeId"] = this.fuelTypeId;
        data["fuelUnitId"] = this.fuelUnitId;
        data["id"] = this.id;
        return data;
    }
}

export interface IFuelProviderDetailDto {
    amount: number;
    quantity: number;
    fuelProviderDataId: number;
    fuelTypeId: number;
    fuelUnitId: number;
    id: number;
}

export class FuelProviderDetailFuelProviderDataLookupTableDto implements IFuelProviderDetailFuelProviderDataLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFuelProviderDetailFuelProviderDataLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): FuelProviderDetailFuelProviderDataLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelProviderDetailFuelProviderDataLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IFuelProviderDetailFuelProviderDataLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FuelProviderDetailFuelTypeLookupTableDto implements IFuelProviderDetailFuelTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFuelProviderDetailFuelTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): FuelProviderDetailFuelTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelProviderDetailFuelTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IFuelProviderDetailFuelTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FuelProviderDetailFuelUnitLookupTableDto implements IFuelProviderDetailFuelUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFuelProviderDetailFuelUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): FuelProviderDetailFuelUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelProviderDetailFuelUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IFuelProviderDetailFuelUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FuelUnitAmountDto implements IFuelUnitAmountDto {
    unitNameAr!: string | undefined;
    unitNameEn!: string | undefined;
    totalConsumedQuantity!: number;
    totalCost!: number;

    constructor(data?: IFuelUnitAmountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitNameAr = _data["unitNameAr"];
            this.unitNameEn = _data["unitNameEn"];
            this.totalConsumedQuantity = _data["totalConsumedQuantity"];
            this.totalCost = _data["totalCost"];
        }
    }

    static fromJS(data: any): FuelUnitAmountDto {
        data = typeof data === 'object' ? data : {};
        let result = new FuelUnitAmountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitNameAr"] = this.unitNameAr;
        data["unitNameEn"] = this.unitNameEn;
        data["totalConsumedQuantity"] = this.totalConsumedQuantity;
        data["totalCost"] = this.totalCost;
        return data;
    }
}

export interface IFuelUnitAmountDto {
    unitNameAr: string | undefined;
    unitNameEn: string | undefined;
    totalConsumedQuantity: number;
    totalCost: number;
}

export class GeBaselineOutputForEep implements IGeBaselineOutputForEep {
    electricityBaselineResultDto!: BaselineResultDto;
    fuelBaselineResultDto!: BaselineResultDto;

    constructor(data?: IGeBaselineOutputForEep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.electricityBaselineResultDto = _data["electricityBaselineResultDto"] ? BaselineResultDto.fromJS(_data["electricityBaselineResultDto"]) : <any>undefined;
            this.fuelBaselineResultDto = _data["fuelBaselineResultDto"] ? BaselineResultDto.fromJS(_data["fuelBaselineResultDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeBaselineOutputForEep {
        data = typeof data === 'object' ? data : {};
        let result = new GeBaselineOutputForEep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["electricityBaselineResultDto"] = this.electricityBaselineResultDto ? this.electricityBaselineResultDto.toJSON() : <any>undefined;
        data["fuelBaselineResultDto"] = this.fuelBaselineResultDto ? this.fuelBaselineResultDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeBaselineOutputForEep {
    electricityBaselineResultDto: BaselineResultDto;
    fuelBaselineResultDto: BaselineResultDto;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class GeneratorInfoDto implements IGeneratorInfoDto {
    generatorName!: string | undefined;
    startingYear!: DateTime;
    expectedYearRetirement!: DateTime;
    manufacturerName!: string | undefined;
    typeAndModel!: string | undefined;
    dualFuelTechnology!: boolean | undefined;
    fuelName!: string | undefined;
    fuelTankCapacity!: number;
    oilConsumption!: number;
    maximumOperationTime!: number;
    maximumPowerOutput!: number;
    virtualAbility!: number;
    currentAmpere!: number;
    frequency!: number;
    maximumTemperature!: number;
    generatorCapacity!: number;
    totalHeat!: number;
    fuelTypeId!: number | undefined;
    organizationUnitId!: number | undefined;
    id!: number;

    constructor(data?: IGeneratorInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatorName = _data["generatorName"];
            this.startingYear = _data["startingYear"] ? DateTime.fromISO(_data["startingYear"].toString()) : <any>undefined;
            this.expectedYearRetirement = _data["expectedYearRetirement"] ? DateTime.fromISO(_data["expectedYearRetirement"].toString()) : <any>undefined;
            this.manufacturerName = _data["manufacturerName"];
            this.typeAndModel = _data["typeAndModel"];
            this.dualFuelTechnology = _data["dualFuelTechnology"];
            this.fuelName = _data["fuelName"];
            this.fuelTankCapacity = _data["fuelTankCapacity"];
            this.oilConsumption = _data["oilConsumption"];
            this.maximumOperationTime = _data["maximumOperationTime"];
            this.maximumPowerOutput = _data["maximumPowerOutput"];
            this.virtualAbility = _data["virtualAbility"];
            this.currentAmpere = _data["currentAmpere"];
            this.frequency = _data["frequency"];
            this.maximumTemperature = _data["maximumTemperature"];
            this.generatorCapacity = _data["generatorCapacity"];
            this.totalHeat = _data["totalHeat"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GeneratorInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratorInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorName"] = this.generatorName;
        data["startingYear"] = this.startingYear ? this.startingYear.toString() : <any>undefined;
        data["expectedYearRetirement"] = this.expectedYearRetirement ? this.expectedYearRetirement.toString() : <any>undefined;
        data["manufacturerName"] = this.manufacturerName;
        data["typeAndModel"] = this.typeAndModel;
        data["dualFuelTechnology"] = this.dualFuelTechnology;
        data["fuelName"] = this.fuelName;
        data["fuelTankCapacity"] = this.fuelTankCapacity;
        data["oilConsumption"] = this.oilConsumption;
        data["maximumOperationTime"] = this.maximumOperationTime;
        data["maximumPowerOutput"] = this.maximumPowerOutput;
        data["virtualAbility"] = this.virtualAbility;
        data["currentAmpere"] = this.currentAmpere;
        data["frequency"] = this.frequency;
        data["maximumTemperature"] = this.maximumTemperature;
        data["generatorCapacity"] = this.generatorCapacity;
        data["totalHeat"] = this.totalHeat;
        data["fuelTypeId"] = this.fuelTypeId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGeneratorInfoDto {
    generatorName: string | undefined;
    startingYear: DateTime;
    expectedYearRetirement: DateTime;
    manufacturerName: string | undefined;
    typeAndModel: string | undefined;
    dualFuelTechnology: boolean | undefined;
    fuelName: string | undefined;
    fuelTankCapacity: number;
    oilConsumption: number;
    maximumOperationTime: number;
    maximumPowerOutput: number;
    virtualAbility: number;
    currentAmpere: number;
    frequency: number;
    maximumTemperature: number;
    generatorCapacity: number;
    totalHeat: number;
    fuelTypeId: number | undefined;
    organizationUnitId: number | undefined;
    id: number;
}

export class GeneratorInfoFuelTypeLookupTableDto implements IGeneratorInfoFuelTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGeneratorInfoFuelTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): GeneratorInfoFuelTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratorInfoFuelTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGeneratorInfoFuelTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GeneratorInfoOrganizationUnitLookupTableDto implements IGeneratorInfoOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGeneratorInfoOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): GeneratorInfoOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratorInfoOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGeneratorInfoOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GetAboutSeecForViewDto implements IGetAboutSeecForViewDto {
    aboutSeec!: AboutSeecDto;
    creationBy!: string | undefined;
    modifiedBy!: string | undefined;

    constructor(data?: IGetAboutSeecForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aboutSeec = _data["aboutSeec"] ? AboutSeecDto.fromJS(_data["aboutSeec"]) : <any>undefined;
            this.creationBy = _data["creationBy"];
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): GetAboutSeecForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAboutSeecForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aboutSeec"] = this.aboutSeec ? this.aboutSeec.toJSON() : <any>undefined;
        data["creationBy"] = this.creationBy;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IGetAboutSeecForViewDto {
    aboutSeec: AboutSeecDto;
    creationBy: string | undefined;
    modifiedBy: string | undefined;
}

export class GetAttendeeInfoForEditOutput implements IGetAttendeeInfoForEditOutput {
    attendeeInfo!: CreateOrEditAttendeeInfoDto;

    constructor(data?: IGetAttendeeInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendeeInfo = _data["attendeeInfo"] ? CreateOrEditAttendeeInfoDto.fromJS(_data["attendeeInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAttendeeInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendeeInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendeeInfo"] = this.attendeeInfo ? this.attendeeInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAttendeeInfoForEditOutput {
    attendeeInfo: CreateOrEditAttendeeInfoDto;
}

export class GetAttendeeInfoForViewDto implements IGetAttendeeInfoForViewDto {
    attendeeInfo!: AttendeeInfoDto;

    constructor(data?: IGetAttendeeInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attendeeInfo = _data["attendeeInfo"] ? AttendeeInfoDto.fromJS(_data["attendeeInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAttendeeInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendeeInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendeeInfo"] = this.attendeeInfo ? this.attendeeInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAttendeeInfoForViewDto {
    attendeeInfo: AttendeeInfoDto;
}

export class GetAwarnessContentForEditOutput implements IGetAwarnessContentForEditOutput {
    awarnessContent!: CreateOrEditAwarnessContentDto;
    awarenessContentClassificationName_Ar!: string | undefined;
    contentTypeName_Ar!: string | undefined;
    createdByName!: string | undefined;

    constructor(data?: IGetAwarnessContentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.awarnessContent = _data["awarnessContent"] ? CreateOrEditAwarnessContentDto.fromJS(_data["awarnessContent"]) : <any>undefined;
            this.awarenessContentClassificationName_Ar = _data["awarenessContentClassificationName_Ar"];
            this.contentTypeName_Ar = _data["contentTypeName_Ar"];
            this.createdByName = _data["createdByName"];
        }
    }

    static fromJS(data: any): GetAwarnessContentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAwarnessContentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["awarnessContent"] = this.awarnessContent ? this.awarnessContent.toJSON() : <any>undefined;
        data["awarenessContentClassificationName_Ar"] = this.awarenessContentClassificationName_Ar;
        data["contentTypeName_Ar"] = this.contentTypeName_Ar;
        data["createdByName"] = this.createdByName;
        return data;
    }
}

export interface IGetAwarnessContentForEditOutput {
    awarnessContent: CreateOrEditAwarnessContentDto;
    awarenessContentClassificationName_Ar: string | undefined;
    contentTypeName_Ar: string | undefined;
    createdByName: string | undefined;
}

export class GetAwarnessContentForViewDto implements IGetAwarnessContentForViewDto {
    awarnessContent!: AwarnessContentDto;
    awarnessContentCreatorName!: string | undefined;
    awarenessContentClassificationName_Ar!: string | undefined;
    contentTypeName_Ar!: string | undefined;
    createdByName!: string | undefined;
    modifyedByName!: string | undefined;

    constructor(data?: IGetAwarnessContentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.awarnessContent = _data["awarnessContent"] ? AwarnessContentDto.fromJS(_data["awarnessContent"]) : <any>undefined;
            this.awarnessContentCreatorName = _data["awarnessContentCreatorName"];
            this.awarenessContentClassificationName_Ar = _data["awarenessContentClassificationName_Ar"];
            this.contentTypeName_Ar = _data["contentTypeName_Ar"];
            this.createdByName = _data["createdByName"];
            this.modifyedByName = _data["modifyedByName"];
        }
    }

    static fromJS(data: any): GetAwarnessContentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAwarnessContentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["awarnessContent"] = this.awarnessContent ? this.awarnessContent.toJSON() : <any>undefined;
        data["awarnessContentCreatorName"] = this.awarnessContentCreatorName;
        data["awarenessContentClassificationName_Ar"] = this.awarenessContentClassificationName_Ar;
        data["contentTypeName_Ar"] = this.contentTypeName_Ar;
        data["createdByName"] = this.createdByName;
        data["modifyedByName"] = this.modifyedByName;
        return data;
    }
}

export interface IGetAwarnessContentForViewDto {
    awarnessContent: AwarnessContentDto;
    awarnessContentCreatorName: string | undefined;
    awarenessContentClassificationName_Ar: string | undefined;
    contentTypeName_Ar: string | undefined;
    createdByName: string | undefined;
    modifyedByName: string | undefined;
}

export class GetBuildingAssetInfoForViewDto implements IGetBuildingAssetInfoForViewDto {
    buildingAssetInfo!: BuildingAssetInfoDto;
    regionName_Ar!: string | undefined;
    buildingStatus_Ar!: string | undefined;
    assetTypeName_Ar!: string | undefined;
    assetSubTypeName_Ar!: string | undefined;
    ownershipName_Ar!: string | undefined;

    constructor(data?: IGetBuildingAssetInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingAssetInfo = _data["buildingAssetInfo"] ? BuildingAssetInfoDto.fromJS(_data["buildingAssetInfo"]) : <any>undefined;
            this.regionName_Ar = _data["regionName_Ar"];
            this.buildingStatus_Ar = _data["buildingStatus_Ar"];
            this.assetTypeName_Ar = _data["assetTypeName_Ar"];
            this.assetSubTypeName_Ar = _data["assetSubTypeName_Ar"];
            this.ownershipName_Ar = _data["ownershipName_Ar"];
        }
    }

    static fromJS(data: any): GetBuildingAssetInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingAssetInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingAssetInfo"] = this.buildingAssetInfo ? this.buildingAssetInfo.toJSON() : <any>undefined;
        data["regionName_Ar"] = this.regionName_Ar;
        data["buildingStatus_Ar"] = this.buildingStatus_Ar;
        data["assetTypeName_Ar"] = this.assetTypeName_Ar;
        data["assetSubTypeName_Ar"] = this.assetSubTypeName_Ar;
        data["ownershipName_Ar"] = this.ownershipName_Ar;
        return data;
    }
}

export interface IGetBuildingAssetInfoForViewDto {
    buildingAssetInfo: BuildingAssetInfoDto;
    regionName_Ar: string | undefined;
    buildingStatus_Ar: string | undefined;
    assetTypeName_Ar: string | undefined;
    assetSubTypeName_Ar: string | undefined;
    ownershipName_Ar: string | undefined;
}

export class GetBuildingEnergyEfficiencySubmissionForEditOutput implements IGetBuildingEnergyEfficiencySubmissionForEditOutput {
    buildingEnergyEfficiencySubmission!: CreateBuildingEnergyEfficiencySubmissionDto;
    request!: RequestDto;
    requestStatus!: number;
    requestStatusName!: string | undefined;
    rejectionReason!: string | undefined;

    constructor(data?: IGetBuildingEnergyEfficiencySubmissionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingEnergyEfficiencySubmission = _data["buildingEnergyEfficiencySubmission"] ? CreateBuildingEnergyEfficiencySubmissionDto.fromJS(_data["buildingEnergyEfficiencySubmission"]) : <any>undefined;
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.requestStatus = _data["requestStatus"];
            this.requestStatusName = _data["requestStatusName"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): GetBuildingEnergyEfficiencySubmissionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingEnergyEfficiencySubmissionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingEnergyEfficiencySubmission"] = this.buildingEnergyEfficiencySubmission ? this.buildingEnergyEfficiencySubmission.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusName"] = this.requestStatusName;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }
}

export interface IGetBuildingEnergyEfficiencySubmissionForEditOutput {
    buildingEnergyEfficiencySubmission: CreateBuildingEnergyEfficiencySubmissionDto;
    request: RequestDto;
    requestStatus: number;
    requestStatusName: string | undefined;
    rejectionReason: string | undefined;
}

export class GetBuildingEnergyEfficiencySubmissionForViewDto implements IGetBuildingEnergyEfficiencySubmissionForViewDto {
    buildingEnergyEfficiencySubmission!: BuildingEnergyEfficiencySubmissionDto;
    requestHistoryList!: RequestHistoryDto[] | undefined;
    seecTech!: UserViewDto;
    myRequestsCount!: number;

    constructor(data?: IGetBuildingEnergyEfficiencySubmissionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingEnergyEfficiencySubmission = _data["buildingEnergyEfficiencySubmission"] ? BuildingEnergyEfficiencySubmissionDto.fromJS(_data["buildingEnergyEfficiencySubmission"]) : <any>undefined;
            if (Array.isArray(_data["requestHistoryList"])) {
                this.requestHistoryList = [] as any;
                for (let item of _data["requestHistoryList"])
                    this.requestHistoryList!.push(RequestHistoryDto.fromJS(item));
            }
            this.seecTech = _data["seecTech"] ? UserViewDto.fromJS(_data["seecTech"]) : <any>undefined;
            this.myRequestsCount = _data["myRequestsCount"];
        }
    }

    static fromJS(data: any): GetBuildingEnergyEfficiencySubmissionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingEnergyEfficiencySubmissionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingEnergyEfficiencySubmission"] = this.buildingEnergyEfficiencySubmission ? this.buildingEnergyEfficiencySubmission.toJSON() : <any>undefined;
        if (Array.isArray(this.requestHistoryList)) {
            data["requestHistoryList"] = [];
            for (let item of this.requestHistoryList)
                data["requestHistoryList"].push(item.toJSON());
        }
        data["seecTech"] = this.seecTech ? this.seecTech.toJSON() : <any>undefined;
        data["myRequestsCount"] = this.myRequestsCount;
        return data;
    }
}

export interface IGetBuildingEnergyEfficiencySubmissionForViewDto {
    buildingEnergyEfficiencySubmission: BuildingEnergyEfficiencySubmissionDto;
    requestHistoryList: RequestHistoryDto[] | undefined;
    seecTech: UserViewDto;
    myRequestsCount: number;
}

export class GetBuildingInfoForEditOutput implements IGetBuildingInfoForEditOutput {
    buildingInfo!: CreateOrEditBuildingInfoDto;
    regionName_Ar!: string | undefined;
    cityName_Ar!: string | undefined;

    constructor(data?: IGetBuildingInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingInfo = _data["buildingInfo"] ? CreateOrEditBuildingInfoDto.fromJS(_data["buildingInfo"]) : <any>undefined;
            this.regionName_Ar = _data["regionName_Ar"];
            this.cityName_Ar = _data["cityName_Ar"];
        }
    }

    static fromJS(data: any): GetBuildingInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingInfo"] = this.buildingInfo ? this.buildingInfo.toJSON() : <any>undefined;
        data["regionName_Ar"] = this.regionName_Ar;
        data["cityName_Ar"] = this.cityName_Ar;
        return data;
    }
}

export interface IGetBuildingInfoForEditOutput {
    buildingInfo: CreateOrEditBuildingInfoDto;
    regionName_Ar: string | undefined;
    cityName_Ar: string | undefined;
}

export class GetBuildingInfoForViewDto implements IGetBuildingInfoForViewDto {
    buildingInfo!: BuildingInfoDto;
    regionName_Ar!: string | undefined;
    cityName_Ar!: string | undefined;
    buildingStatus_Ar!: string | undefined;

    constructor(data?: IGetBuildingInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingInfo = _data["buildingInfo"] ? BuildingInfoDto.fromJS(_data["buildingInfo"]) : <any>undefined;
            this.regionName_Ar = _data["regionName_Ar"];
            this.cityName_Ar = _data["cityName_Ar"];
            this.buildingStatus_Ar = _data["buildingStatus_Ar"];
        }
    }

    static fromJS(data: any): GetBuildingInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingInfo"] = this.buildingInfo ? this.buildingInfo.toJSON() : <any>undefined;
        data["regionName_Ar"] = this.regionName_Ar;
        data["cityName_Ar"] = this.cityName_Ar;
        data["buildingStatus_Ar"] = this.buildingStatus_Ar;
        return data;
    }
}

export interface IGetBuildingInfoForViewDto {
    buildingInfo: BuildingInfoDto;
    regionName_Ar: string | undefined;
    cityName_Ar: string | undefined;
    buildingStatus_Ar: string | undefined;
}

export class GetContactUsForHomeViewDto implements IGetContactUsForHomeViewDto {
    contactUs!: ContactUsForHomeDto;

    constructor(data?: IGetContactUsForHomeViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactUs = _data["contactUs"] ? ContactUsForHomeDto.fromJS(_data["contactUs"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetContactUsForHomeViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactUsForHomeViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactUs"] = this.contactUs ? this.contactUs.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetContactUsForHomeViewDto {
    contactUs: ContactUsForHomeDto;
}

export class GetContactUsForViewDto implements IGetContactUsForViewDto {
    contactUs!: ContactUsDto;

    constructor(data?: IGetContactUsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactUs = _data["contactUs"] ? ContactUsDto.fromJS(_data["contactUs"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetContactUsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactUsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactUs"] = this.contactUs ? this.contactUs.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetContactUsForViewDto {
    contactUs: ContactUsDto;
}

export class GetCoolingStationAssetInfoForViewDto implements IGetCoolingStationAssetInfoForViewDto {
    coolingStationAssetInfo!: CoolingStationAssetInfoDto;
    regionName_Ar!: string | undefined;
    technologyTypeName_Ar!: string | undefined;
    usageTypeName_Ar!: string | undefined;
    waterTypeName_Ar!: string | undefined;
    controlSystemTypeName_Ar!: string | undefined;

    constructor(data?: IGetCoolingStationAssetInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coolingStationAssetInfo = _data["coolingStationAssetInfo"] ? CoolingStationAssetInfoDto.fromJS(_data["coolingStationAssetInfo"]) : <any>undefined;
            this.regionName_Ar = _data["regionName_Ar"];
            this.technologyTypeName_Ar = _data["technologyTypeName_Ar"];
            this.usageTypeName_Ar = _data["usageTypeName_Ar"];
            this.waterTypeName_Ar = _data["waterTypeName_Ar"];
            this.controlSystemTypeName_Ar = _data["controlSystemTypeName_Ar"];
        }
    }

    static fromJS(data: any): GetCoolingStationAssetInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoolingStationAssetInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coolingStationAssetInfo"] = this.coolingStationAssetInfo ? this.coolingStationAssetInfo.toJSON() : <any>undefined;
        data["regionName_Ar"] = this.regionName_Ar;
        data["technologyTypeName_Ar"] = this.technologyTypeName_Ar;
        data["usageTypeName_Ar"] = this.usageTypeName_Ar;
        data["waterTypeName_Ar"] = this.waterTypeName_Ar;
        data["controlSystemTypeName_Ar"] = this.controlSystemTypeName_Ar;
        return data;
    }
}

export interface IGetCoolingStationAssetInfoForViewDto {
    coolingStationAssetInfo: CoolingStationAssetInfoDto;
    regionName_Ar: string | undefined;
    technologyTypeName_Ar: string | undefined;
    usageTypeName_Ar: string | undefined;
    waterTypeName_Ar: string | undefined;
    controlSystemTypeName_Ar: string | undefined;
}

export class GetCourseForEditOutput implements IGetCourseForEditOutput {
    course!: CreateOrEditCourseDto;
    topicTopicName!: string | undefined;
    topicTypeName_Ar!: string | undefined;

    constructor(data?: IGetCourseForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.course = _data["course"] ? CreateOrEditCourseDto.fromJS(_data["course"]) : <any>undefined;
            this.topicTopicName = _data["topicTopicName"];
            this.topicTypeName_Ar = _data["topicTypeName_Ar"];
        }
    }

    static fromJS(data: any): GetCourseForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCourseForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["course"] = this.course ? this.course.toJSON() : <any>undefined;
        data["topicTopicName"] = this.topicTopicName;
        data["topicTypeName_Ar"] = this.topicTypeName_Ar;
        return data;
    }
}

export interface IGetCourseForEditOutput {
    course: CreateOrEditCourseDto;
    topicTopicName: string | undefined;
    topicTypeName_Ar: string | undefined;
}

export class GetCourseForViewDto implements IGetCourseForViewDto {
    course!: CourseDto;
    topicTopicName!: string | undefined;
    topicTypeName_Ar!: string | undefined;
    createdBy!: string | undefined;
    modifiedBy!: string | undefined;
    courseStatus!: string | undefined;
    totalCourseDays!: number | undefined;
    actualAvialableSeats!: number | undefined;

    constructor(data?: IGetCourseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.course = _data["course"] ? CourseDto.fromJS(_data["course"]) : <any>undefined;
            this.topicTopicName = _data["topicTopicName"];
            this.topicTypeName_Ar = _data["topicTypeName_Ar"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.courseStatus = _data["courseStatus"];
            this.totalCourseDays = _data["totalCourseDays"];
            this.actualAvialableSeats = _data["actualAvialableSeats"];
        }
    }

    static fromJS(data: any): GetCourseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCourseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["course"] = this.course ? this.course.toJSON() : <any>undefined;
        data["topicTopicName"] = this.topicTopicName;
        data["topicTypeName_Ar"] = this.topicTypeName_Ar;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["courseStatus"] = this.courseStatus;
        data["totalCourseDays"] = this.totalCourseDays;
        data["actualAvialableSeats"] = this.actualAvialableSeats;
        return data;
    }
}

export interface IGetCourseForViewDto {
    course: CourseDto;
    topicTopicName: string | undefined;
    topicTypeName_Ar: string | undefined;
    createdBy: string | undefined;
    modifiedBy: string | undefined;
    courseStatus: string | undefined;
    totalCourseDays: number | undefined;
    actualAvialableSeats: number | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    impersonatorUser!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    impersonatorTenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.impersonatorUser = _data["impersonatorUser"] ? UserLoginInfoDto.fromJS(_data["impersonatorUser"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.impersonatorTenant = _data["impersonatorTenant"] ? TenantLoginInfoDto.fromJS(_data["impersonatorTenant"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["impersonatorUser"] = this.impersonatorUser ? this.impersonatorUser.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["impersonatorTenant"] = this.impersonatorTenant ? this.impersonatorTenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    impersonatorUser: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    impersonatorTenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
}

export class GetCustomAreaOfImprovementForEditOutput implements IGetCustomAreaOfImprovementForEditOutput {
    customAreaOfImprovement!: CreateOrEditCustomAreaOfImprovementDto;
    organizationEEPPlanYear!: string | undefined;
    eepAreaOfImprovementName_Ar!: string | undefined;
    eepAreaOfImprovementNatureName_Ar!: string | undefined;
    organizationUnitDisplayName!: string | undefined;

    constructor(data?: IGetCustomAreaOfImprovementForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customAreaOfImprovement = _data["customAreaOfImprovement"] ? CreateOrEditCustomAreaOfImprovementDto.fromJS(_data["customAreaOfImprovement"]) : <any>undefined;
            this.organizationEEPPlanYear = _data["organizationEEPPlanYear"];
            this.eepAreaOfImprovementName_Ar = _data["eepAreaOfImprovementName_Ar"];
            this.eepAreaOfImprovementNatureName_Ar = _data["eepAreaOfImprovementNatureName_Ar"];
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
        }
    }

    static fromJS(data: any): GetCustomAreaOfImprovementForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomAreaOfImprovementForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customAreaOfImprovement"] = this.customAreaOfImprovement ? this.customAreaOfImprovement.toJSON() : <any>undefined;
        data["organizationEEPPlanYear"] = this.organizationEEPPlanYear;
        data["eepAreaOfImprovementName_Ar"] = this.eepAreaOfImprovementName_Ar;
        data["eepAreaOfImprovementNatureName_Ar"] = this.eepAreaOfImprovementNatureName_Ar;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        return data;
    }
}

export interface IGetCustomAreaOfImprovementForEditOutput {
    customAreaOfImprovement: CreateOrEditCustomAreaOfImprovementDto;
    organizationEEPPlanYear: string | undefined;
    eepAreaOfImprovementName_Ar: string | undefined;
    eepAreaOfImprovementNatureName_Ar: string | undefined;
    organizationUnitDisplayName: string | undefined;
}

export class GetCustomAreaOfImprovementForViewDto implements IGetCustomAreaOfImprovementForViewDto {
    customAreaOfImprovement!: CustomAreaOfImprovementDto;
    organizationEEPPlanYear!: string | undefined;
    eepAreaOfImprovementName_Ar!: string | undefined;
    eepAreaOfImprovementNatureName_Ar!: string | undefined;
    organizationUnitDisplayName!: string | undefined;

    constructor(data?: IGetCustomAreaOfImprovementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customAreaOfImprovement = _data["customAreaOfImprovement"] ? CustomAreaOfImprovementDto.fromJS(_data["customAreaOfImprovement"]) : <any>undefined;
            this.organizationEEPPlanYear = _data["organizationEEPPlanYear"];
            this.eepAreaOfImprovementName_Ar = _data["eepAreaOfImprovementName_Ar"];
            this.eepAreaOfImprovementNatureName_Ar = _data["eepAreaOfImprovementNatureName_Ar"];
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
        }
    }

    static fromJS(data: any): GetCustomAreaOfImprovementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomAreaOfImprovementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customAreaOfImprovement"] = this.customAreaOfImprovement ? this.customAreaOfImprovement.toJSON() : <any>undefined;
        data["organizationEEPPlanYear"] = this.organizationEEPPlanYear;
        data["eepAreaOfImprovementName_Ar"] = this.eepAreaOfImprovementName_Ar;
        data["eepAreaOfImprovementNatureName_Ar"] = this.eepAreaOfImprovementNatureName_Ar;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        return data;
    }
}

export interface IGetCustomAreaOfImprovementForViewDto {
    customAreaOfImprovement: CustomAreaOfImprovementDto;
    organizationEEPPlanYear: string | undefined;
    eepAreaOfImprovementName_Ar: string | undefined;
    eepAreaOfImprovementNatureName_Ar: string | undefined;
    organizationUnitDisplayName: string | undefined;
}

export class GetDailySalesOutput implements IGetDailySalesOutput {
    dailySales!: number[] | undefined;

    constructor(data?: IGetDailySalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDailySalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailySalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        return data;
    }
}

export interface IGetDailySalesOutput {
    dailySales: number[] | undefined;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;
    dailySales!: number[] | undefined;
    profitShares!: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GetEEPRequestDeadlineSettingForEditOutput implements IGetEEPRequestDeadlineSettingForEditOutput {
    eepRequestDeadlineSetting!: CreateOrEditEEPRequestDeadlineSettingDto;

    constructor(data?: IGetEEPRequestDeadlineSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eepRequestDeadlineSetting = _data["eepRequestDeadlineSetting"] ? CreateOrEditEEPRequestDeadlineSettingDto.fromJS(_data["eepRequestDeadlineSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEEPRequestDeadlineSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEEPRequestDeadlineSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eepRequestDeadlineSetting"] = this.eepRequestDeadlineSetting ? this.eepRequestDeadlineSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEEPRequestDeadlineSettingForEditOutput {
    eepRequestDeadlineSetting: CreateOrEditEEPRequestDeadlineSettingDto;
}

export class GetEEPRequestDeadlineSettingForViewDto implements IGetEEPRequestDeadlineSettingForViewDto {
    eepRequestDeadlineSetting!: EEPRequestDeadlineSettingDto;

    constructor(data?: IGetEEPRequestDeadlineSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eepRequestDeadlineSetting = _data["eepRequestDeadlineSetting"] ? EEPRequestDeadlineSettingDto.fromJS(_data["eepRequestDeadlineSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEEPRequestDeadlineSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEEPRequestDeadlineSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eepRequestDeadlineSetting"] = this.eepRequestDeadlineSetting ? this.eepRequestDeadlineSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEEPRequestDeadlineSettingForViewDto {
    eepRequestDeadlineSetting: EEPRequestDeadlineSettingDto;
}

export class GetEfficiencyPlanForEditOutput implements IGetEfficiencyPlanForEditOutput {
    efficiencyPlan!: CreateOrEditEfficiencyPlanDto;
    allElectricityAreaOfImprovements!: AreaOfImprovementDto[] | undefined;
    allFuelAreaOfImprovements!: AreaOfImprovementDto[] | undefined;
    organizationUnitDisplayName!: string | undefined;
    requestRejectionReason!: string | undefined;
    organizationActivityPlanYear!: string | undefined;
    organizationEEPPlanYear!: string | undefined;
    organizationEEPSubject2!: string | undefined;
    planHeaderDto!: EepPlanHeaderDto;
    request!: RequestDto;
    requestStatus!: number;

    constructor(data?: IGetEfficiencyPlanForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.efficiencyPlan = _data["efficiencyPlan"] ? CreateOrEditEfficiencyPlanDto.fromJS(_data["efficiencyPlan"]) : <any>undefined;
            if (Array.isArray(_data["allElectricityAreaOfImprovements"])) {
                this.allElectricityAreaOfImprovements = [] as any;
                for (let item of _data["allElectricityAreaOfImprovements"])
                    this.allElectricityAreaOfImprovements!.push(AreaOfImprovementDto.fromJS(item));
            }
            if (Array.isArray(_data["allFuelAreaOfImprovements"])) {
                this.allFuelAreaOfImprovements = [] as any;
                for (let item of _data["allFuelAreaOfImprovements"])
                    this.allFuelAreaOfImprovements!.push(AreaOfImprovementDto.fromJS(item));
            }
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
            this.requestRejectionReason = _data["requestRejectionReason"];
            this.organizationActivityPlanYear = _data["organizationActivityPlanYear"];
            this.organizationEEPPlanYear = _data["organizationEEPPlanYear"];
            this.organizationEEPSubject2 = _data["organizationEEPSubject2"];
            this.planHeaderDto = _data["planHeaderDto"] ? EepPlanHeaderDto.fromJS(_data["planHeaderDto"]) : <any>undefined;
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.requestStatus = _data["requestStatus"];
        }
    }

    static fromJS(data: any): GetEfficiencyPlanForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEfficiencyPlanForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["efficiencyPlan"] = this.efficiencyPlan ? this.efficiencyPlan.toJSON() : <any>undefined;
        if (Array.isArray(this.allElectricityAreaOfImprovements)) {
            data["allElectricityAreaOfImprovements"] = [];
            for (let item of this.allElectricityAreaOfImprovements)
                data["allElectricityAreaOfImprovements"].push(item.toJSON());
        }
        if (Array.isArray(this.allFuelAreaOfImprovements)) {
            data["allFuelAreaOfImprovements"] = [];
            for (let item of this.allFuelAreaOfImprovements)
                data["allFuelAreaOfImprovements"].push(item.toJSON());
        }
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        data["requestRejectionReason"] = this.requestRejectionReason;
        data["organizationActivityPlanYear"] = this.organizationActivityPlanYear;
        data["organizationEEPPlanYear"] = this.organizationEEPPlanYear;
        data["organizationEEPSubject2"] = this.organizationEEPSubject2;
        data["planHeaderDto"] = this.planHeaderDto ? this.planHeaderDto.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["requestStatus"] = this.requestStatus;
        return data;
    }
}

export interface IGetEfficiencyPlanForEditOutput {
    efficiencyPlan: CreateOrEditEfficiencyPlanDto;
    allElectricityAreaOfImprovements: AreaOfImprovementDto[] | undefined;
    allFuelAreaOfImprovements: AreaOfImprovementDto[] | undefined;
    organizationUnitDisplayName: string | undefined;
    requestRejectionReason: string | undefined;
    organizationActivityPlanYear: string | undefined;
    organizationEEPPlanYear: string | undefined;
    organizationEEPSubject2: string | undefined;
    planHeaderDto: EepPlanHeaderDto;
    request: RequestDto;
    requestStatus: number;
}

export class GetEfficiencyPlanForViewDto implements IGetEfficiencyPlanForViewDto {
    efficiencyPlan!: EfficiencyPlanDto;
    organizationUnitDisplayName!: string | undefined;
    requestRejectionReason!: string | undefined;
    organizationActivityPlanYear!: string | undefined;
    organizationEEPPlanYear!: string | undefined;
    organizationEEPSubject2!: string | undefined;
    planHeaderDto!: EepPlanHeaderDto;
    request!: RequestDto;
    myRequestsCount!: number;

    constructor(data?: IGetEfficiencyPlanForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.efficiencyPlan = _data["efficiencyPlan"] ? EfficiencyPlanDto.fromJS(_data["efficiencyPlan"]) : <any>undefined;
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
            this.requestRejectionReason = _data["requestRejectionReason"];
            this.organizationActivityPlanYear = _data["organizationActivityPlanYear"];
            this.organizationEEPPlanYear = _data["organizationEEPPlanYear"];
            this.organizationEEPSubject2 = _data["organizationEEPSubject2"];
            this.planHeaderDto = _data["planHeaderDto"] ? EepPlanHeaderDto.fromJS(_data["planHeaderDto"]) : <any>undefined;
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.myRequestsCount = _data["myRequestsCount"];
        }
    }

    static fromJS(data: any): GetEfficiencyPlanForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEfficiencyPlanForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["efficiencyPlan"] = this.efficiencyPlan ? this.efficiencyPlan.toJSON() : <any>undefined;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        data["requestRejectionReason"] = this.requestRejectionReason;
        data["organizationActivityPlanYear"] = this.organizationActivityPlanYear;
        data["organizationEEPPlanYear"] = this.organizationEEPPlanYear;
        data["organizationEEPSubject2"] = this.organizationEEPSubject2;
        data["planHeaderDto"] = this.planHeaderDto ? this.planHeaderDto.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["myRequestsCount"] = this.myRequestsCount;
        return data;
    }
}

export interface IGetEfficiencyPlanForViewDto {
    efficiencyPlan: EfficiencyPlanDto;
    organizationUnitDisplayName: string | undefined;
    requestRejectionReason: string | undefined;
    organizationActivityPlanYear: string | undefined;
    organizationEEPPlanYear: string | undefined;
    organizationEEPSubject2: string | undefined;
    planHeaderDto: EepPlanHeaderDto;
    request: RequestDto;
    myRequestsCount: number;
}

export class GetElectricityConsumptionReportOutput implements IGetElectricityConsumptionReportOutput {
    summary!: ElectricityConsumptionReportSummaryDto;
    entities!: PagedResultDtoOfElectricityConsumptionReportEntityRowDto;

    constructor(data?: IGetElectricityConsumptionReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? ElectricityConsumptionReportSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            this.entities = _data["entities"] ? PagedResultDtoOfElectricityConsumptionReportEntityRowDto.fromJS(_data["entities"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetElectricityConsumptionReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetElectricityConsumptionReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["entities"] = this.entities ? this.entities.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetElectricityConsumptionReportOutput {
    summary: ElectricityConsumptionReportSummaryDto;
    entities: PagedResultDtoOfElectricityConsumptionReportEntityRowDto;
}

export class GetEmailForEditOutput implements IGetEmailForEditOutput {
    email!: CreateOrEditEmailDto;

    constructor(data?: IGetEmailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] ? CreateOrEditEmailDto.fromJS(_data["email"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmailForEditOutput {
    email: CreateOrEditEmailDto;
}

export class GetEmailForViewDto implements IGetEmailForViewDto {
    email!: EmailDto;

    constructor(data?: IGetEmailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] ? EmailDto.fromJS(_data["email"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmailForViewDto {
    email: EmailDto;
}

export class GetEmailTemplateForEditOutput implements IGetEmailTemplateForEditOutput {
    emailTemplate!: CreateOrEditEmailTemplateDto;

    constructor(data?: IGetEmailTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplate = _data["emailTemplate"] ? CreateOrEditEmailTemplateDto.fromJS(_data["emailTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmailTemplateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmailTemplateForEditOutput {
    emailTemplate: CreateOrEditEmailTemplateDto;
}

export class GetEmailTemplateForViewDto implements IGetEmailTemplateForViewDto {
    emailTemplate!: EmailTemplateDto;

    constructor(data?: IGetEmailTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplate = _data["emailTemplate"] ? EmailTemplateDto.fromJS(_data["emailTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmailTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmailTemplateForViewDto {
    emailTemplate: EmailTemplateDto;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
    expiringTenants!: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount!: number;
    maxExpiringTenantsShownCount!: number;
    subscriptionEndDateStart!: DateTime;
    subscriptionEndDateEnd!: DateTime;

    constructor(data?: IGetExpiringTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of _data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = _data["subscriptionEndDateStart"] ? DateTime.fromISO(_data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"] ? DateTime.fromISO(_data["subscriptionEndDateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExpiringTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toString() : <any>undefined;
        return data;
    }
}

export interface IGetExpiringTenantsOutput {
    expiringTenants: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount: number;
    maxExpiringTenantsShownCount: number;
    subscriptionEndDateStart: DateTime;
    subscriptionEndDateEnd: DateTime;
}

export class GetFAQCategoryForViewDto implements IGetFAQCategoryForViewDto {
    faqCategory!: FAQCategoryDto;

    constructor(data?: IGetFAQCategoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faqCategory = _data["faqCategory"] ? FAQCategoryDto.fromJS(_data["faqCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFAQCategoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFAQCategoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faqCategory"] = this.faqCategory ? this.faqCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFAQCategoryForViewDto {
    faqCategory: FAQCategoryDto;
}

export class GetFAQForHomeViewDto implements IGetFAQForHomeViewDto {
    faq!: FAQForHomeDto;

    constructor(data?: IGetFAQForHomeViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faq = _data["faq"] ? FAQForHomeDto.fromJS(_data["faq"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFAQForHomeViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFAQForHomeViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faq"] = this.faq ? this.faq.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFAQForHomeViewDto {
    faq: FAQForHomeDto;
}

export class GetFAQForViewDto implements IGetFAQForViewDto {
    faq!: FAQDto;

    constructor(data?: IGetFAQForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faq = _data["faq"] ? FAQDto.fromJS(_data["faq"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFAQForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFAQForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faq"] = this.faq ? this.faq.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFAQForViewDto {
    faq: FAQDto;
}

export class GetFuelAssetInfoForViewDto implements IGetFuelAssetInfoForViewDto {
    fuelAssetInfo!: FuelAssetInfoDto;
    assetTypeName_Ar!: string | undefined;
    assetSubTypeName_Ar!: string | undefined;
    fuelTypeName_Ar!: string | undefined;
    fuelUnitName_Ar!: string | undefined;
    measurementTypeKey!: string | undefined;
    measurementTypeLabel!: string | undefined;

    constructor(data?: IGetFuelAssetInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelAssetInfo = _data["fuelAssetInfo"] ? FuelAssetInfoDto.fromJS(_data["fuelAssetInfo"]) : <any>undefined;
            this.assetTypeName_Ar = _data["assetTypeName_Ar"];
            this.assetSubTypeName_Ar = _data["assetSubTypeName_Ar"];
            this.fuelTypeName_Ar = _data["fuelTypeName_Ar"];
            this.fuelUnitName_Ar = _data["fuelUnitName_Ar"];
            this.measurementTypeKey = _data["measurementTypeKey"];
            this.measurementTypeLabel = _data["measurementTypeLabel"];
        }
    }

    static fromJS(data: any): GetFuelAssetInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFuelAssetInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelAssetInfo"] = this.fuelAssetInfo ? this.fuelAssetInfo.toJSON() : <any>undefined;
        data["assetTypeName_Ar"] = this.assetTypeName_Ar;
        data["assetSubTypeName_Ar"] = this.assetSubTypeName_Ar;
        data["fuelTypeName_Ar"] = this.fuelTypeName_Ar;
        data["fuelUnitName_Ar"] = this.fuelUnitName_Ar;
        data["measurementTypeKey"] = this.measurementTypeKey;
        data["measurementTypeLabel"] = this.measurementTypeLabel;
        return data;
    }
}

export interface IGetFuelAssetInfoForViewDto {
    fuelAssetInfo: FuelAssetInfoDto;
    assetTypeName_Ar: string | undefined;
    assetSubTypeName_Ar: string | undefined;
    fuelTypeName_Ar: string | undefined;
    fuelUnitName_Ar: string | undefined;
    measurementTypeKey: string | undefined;
    measurementTypeLabel: string | undefined;
}

export class GetFuelConsumptionReportOutput implements IGetFuelConsumptionReportOutput {
    summary!: FuelConsumptionReportSummaryDto;
    entities!: PagedResultDtoOfFuelConsumptionReportEntityRowDto;

    constructor(data?: IGetFuelConsumptionReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? FuelConsumptionReportSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            this.entities = _data["entities"] ? PagedResultDtoOfFuelConsumptionReportEntityRowDto.fromJS(_data["entities"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFuelConsumptionReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFuelConsumptionReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["entities"] = this.entities ? this.entities.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFuelConsumptionReportOutput {
    summary: FuelConsumptionReportSummaryDto;
    entities: PagedResultDtoOfFuelConsumptionReportEntityRowDto;
}

export class GetFuelProviderDataForEditOutput implements IGetFuelProviderDataForEditOutput {
    organizationUnitTreeModelDto!: OrganizationUnitTreeModelDto;
    organizationUnitHeader!: GetOrganizationUserDto;
    fuelProviderData!: CreateOrEditFuelProviderDataDto;
    organizationUnitDisplayName!: string | undefined;
    rejectionReason!: string | undefined;
    request!: RequestDto;
    requestStatus!: number;
    createOrEditFuelProviderDetails!: CreateOrEditFuelProviderDetailDto[] | undefined;

    constructor(data?: IGetFuelProviderDataForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitTreeModelDto = _data["organizationUnitTreeModelDto"] ? OrganizationUnitTreeModelDto.fromJS(_data["organizationUnitTreeModelDto"]) : <any>undefined;
            this.organizationUnitHeader = _data["organizationUnitHeader"] ? GetOrganizationUserDto.fromJS(_data["organizationUnitHeader"]) : <any>undefined;
            this.fuelProviderData = _data["fuelProviderData"] ? CreateOrEditFuelProviderDataDto.fromJS(_data["fuelProviderData"]) : <any>undefined;
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
            this.rejectionReason = _data["rejectionReason"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.requestStatus = _data["requestStatus"];
            if (Array.isArray(_data["createOrEditFuelProviderDetails"])) {
                this.createOrEditFuelProviderDetails = [] as any;
                for (let item of _data["createOrEditFuelProviderDetails"])
                    this.createOrEditFuelProviderDetails!.push(CreateOrEditFuelProviderDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFuelProviderDataForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFuelProviderDataForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitTreeModelDto"] = this.organizationUnitTreeModelDto ? this.organizationUnitTreeModelDto.toJSON() : <any>undefined;
        data["organizationUnitHeader"] = this.organizationUnitHeader ? this.organizationUnitHeader.toJSON() : <any>undefined;
        data["fuelProviderData"] = this.fuelProviderData ? this.fuelProviderData.toJSON() : <any>undefined;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        data["rejectionReason"] = this.rejectionReason;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["requestStatus"] = this.requestStatus;
        if (Array.isArray(this.createOrEditFuelProviderDetails)) {
            data["createOrEditFuelProviderDetails"] = [];
            for (let item of this.createOrEditFuelProviderDetails)
                data["createOrEditFuelProviderDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFuelProviderDataForEditOutput {
    organizationUnitTreeModelDto: OrganizationUnitTreeModelDto;
    organizationUnitHeader: GetOrganizationUserDto;
    fuelProviderData: CreateOrEditFuelProviderDataDto;
    organizationUnitDisplayName: string | undefined;
    rejectionReason: string | undefined;
    request: RequestDto;
    requestStatus: number;
    createOrEditFuelProviderDetails: CreateOrEditFuelProviderDetailDto[] | undefined;
}

export class GetFuelProviderDataForViewDto implements IGetFuelProviderDataForViewDto {
    fuelProviderData!: FuelProviderDataDto;
    organizationUnitDisplayName!: string | undefined;
    organizationUnitcode!: string | undefined;
    fuelProviderUnitDisplayName!: string | undefined;
    fuelProviderUnitCode!: string | undefined;
    requestRejectionReason!: string | undefined;
    getRequestForView!: GetRequestsForViewDto;
    fuelProviderDetails!: GetFuelProviderDetailForViewDto[] | undefined;
    actionerId!: number | undefined;
    requestTypeId!: number;

    constructor(data?: IGetFuelProviderDataForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelProviderData = _data["fuelProviderData"] ? FuelProviderDataDto.fromJS(_data["fuelProviderData"]) : <any>undefined;
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
            this.organizationUnitcode = _data["organizationUnitcode"];
            this.fuelProviderUnitDisplayName = _data["fuelProviderUnitDisplayName"];
            this.fuelProviderUnitCode = _data["fuelProviderUnitCode"];
            this.requestRejectionReason = _data["requestRejectionReason"];
            this.getRequestForView = _data["getRequestForView"] ? GetRequestsForViewDto.fromJS(_data["getRequestForView"]) : <any>undefined;
            if (Array.isArray(_data["fuelProviderDetails"])) {
                this.fuelProviderDetails = [] as any;
                for (let item of _data["fuelProviderDetails"])
                    this.fuelProviderDetails!.push(GetFuelProviderDetailForViewDto.fromJS(item));
            }
            this.actionerId = _data["actionerId"];
            this.requestTypeId = _data["requestTypeId"];
        }
    }

    static fromJS(data: any): GetFuelProviderDataForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFuelProviderDataForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelProviderData"] = this.fuelProviderData ? this.fuelProviderData.toJSON() : <any>undefined;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        data["organizationUnitcode"] = this.organizationUnitcode;
        data["fuelProviderUnitDisplayName"] = this.fuelProviderUnitDisplayName;
        data["fuelProviderUnitCode"] = this.fuelProviderUnitCode;
        data["requestRejectionReason"] = this.requestRejectionReason;
        data["getRequestForView"] = this.getRequestForView ? this.getRequestForView.toJSON() : <any>undefined;
        if (Array.isArray(this.fuelProviderDetails)) {
            data["fuelProviderDetails"] = [];
            for (let item of this.fuelProviderDetails)
                data["fuelProviderDetails"].push(item.toJSON());
        }
        data["actionerId"] = this.actionerId;
        data["requestTypeId"] = this.requestTypeId;
        return data;
    }
}

export interface IGetFuelProviderDataForViewDto {
    fuelProviderData: FuelProviderDataDto;
    organizationUnitDisplayName: string | undefined;
    organizationUnitcode: string | undefined;
    fuelProviderUnitDisplayName: string | undefined;
    fuelProviderUnitCode: string | undefined;
    requestRejectionReason: string | undefined;
    getRequestForView: GetRequestsForViewDto;
    fuelProviderDetails: GetFuelProviderDetailForViewDto[] | undefined;
    actionerId: number | undefined;
    requestTypeId: number;
}

export class GetFuelProviderDetailForEditOutput implements IGetFuelProviderDetailForEditOutput {
    fuelProviderDetail!: CreateOrEditFuelProviderDetailDto;
    fuelProviderDataYear!: string | undefined;
    fuelTypeName_Ar!: string | undefined;
    fuelUnitName_Ar!: string | undefined;

    constructor(data?: IGetFuelProviderDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelProviderDetail = _data["fuelProviderDetail"] ? CreateOrEditFuelProviderDetailDto.fromJS(_data["fuelProviderDetail"]) : <any>undefined;
            this.fuelProviderDataYear = _data["fuelProviderDataYear"];
            this.fuelTypeName_Ar = _data["fuelTypeName_Ar"];
            this.fuelUnitName_Ar = _data["fuelUnitName_Ar"];
        }
    }

    static fromJS(data: any): GetFuelProviderDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFuelProviderDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelProviderDetail"] = this.fuelProviderDetail ? this.fuelProviderDetail.toJSON() : <any>undefined;
        data["fuelProviderDataYear"] = this.fuelProviderDataYear;
        data["fuelTypeName_Ar"] = this.fuelTypeName_Ar;
        data["fuelUnitName_Ar"] = this.fuelUnitName_Ar;
        return data;
    }
}

export interface IGetFuelProviderDetailForEditOutput {
    fuelProviderDetail: CreateOrEditFuelProviderDetailDto;
    fuelProviderDataYear: string | undefined;
    fuelTypeName_Ar: string | undefined;
    fuelUnitName_Ar: string | undefined;
}

export class GetFuelProviderDetailForViewDto implements IGetFuelProviderDetailForViewDto {
    fuelProviderDetail!: FuelProviderDetailDto;
    fuelProviderDataYear!: string | undefined;
    fuelTypeName_Ar!: string | undefined;
    fuelUnitName_Ar!: string | undefined;

    constructor(data?: IGetFuelProviderDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelProviderDetail = _data["fuelProviderDetail"] ? FuelProviderDetailDto.fromJS(_data["fuelProviderDetail"]) : <any>undefined;
            this.fuelProviderDataYear = _data["fuelProviderDataYear"];
            this.fuelTypeName_Ar = _data["fuelTypeName_Ar"];
            this.fuelUnitName_Ar = _data["fuelUnitName_Ar"];
        }
    }

    static fromJS(data: any): GetFuelProviderDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFuelProviderDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelProviderDetail"] = this.fuelProviderDetail ? this.fuelProviderDetail.toJSON() : <any>undefined;
        data["fuelProviderDataYear"] = this.fuelProviderDataYear;
        data["fuelTypeName_Ar"] = this.fuelTypeName_Ar;
        data["fuelUnitName_Ar"] = this.fuelUnitName_Ar;
        return data;
    }
}

export interface IGetFuelProviderDetailForViewDto {
    fuelProviderDetail: FuelProviderDetailDto;
    fuelProviderDataYear: string | undefined;
    fuelTypeName_Ar: string | undefined;
    fuelUnitName_Ar: string | undefined;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class GetGeneratorInfoForEditOutput implements IGetGeneratorInfoForEditOutput {
    generatorInfo!: CreateOrEditGeneratorInfoDto;
    fuelTypeName_Ar!: string | undefined;
    organizationUnitDisplayName!: string | undefined;

    constructor(data?: IGetGeneratorInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatorInfo = _data["generatorInfo"] ? CreateOrEditGeneratorInfoDto.fromJS(_data["generatorInfo"]) : <any>undefined;
            this.fuelTypeName_Ar = _data["fuelTypeName_Ar"];
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
        }
    }

    static fromJS(data: any): GetGeneratorInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneratorInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorInfo"] = this.generatorInfo ? this.generatorInfo.toJSON() : <any>undefined;
        data["fuelTypeName_Ar"] = this.fuelTypeName_Ar;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        return data;
    }
}

export interface IGetGeneratorInfoForEditOutput {
    generatorInfo: CreateOrEditGeneratorInfoDto;
    fuelTypeName_Ar: string | undefined;
    organizationUnitDisplayName: string | undefined;
}

export class GetGeneratorInfoForViewDto implements IGetGeneratorInfoForViewDto {
    generatorInfo!: GeneratorInfoDto;
    fuelTypeName_Ar!: string | undefined;
    organizationUnitDisplayName!: string | undefined;

    constructor(data?: IGetGeneratorInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatorInfo = _data["generatorInfo"] ? GeneratorInfoDto.fromJS(_data["generatorInfo"]) : <any>undefined;
            this.fuelTypeName_Ar = _data["fuelTypeName_Ar"];
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
        }
    }

    static fromJS(data: any): GetGeneratorInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneratorInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorInfo"] = this.generatorInfo ? this.generatorInfo.toJSON() : <any>undefined;
        data["fuelTypeName_Ar"] = this.fuelTypeName_Ar;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        return data;
    }
}

export interface IGetGeneratorInfoForViewDto {
    generatorInfo: GeneratorInfoDto;
    fuelTypeName_Ar: string | undefined;
    organizationUnitDisplayName: string | undefined;
}

export class GetGovElectricityForEditOutput implements IGetGovElectricityForEditOutput {
    govElectricity!: CreateOrEditGovElectricityDto;
    request!: RequestDto;

    constructor(data?: IGetGovElectricityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.govElectricity = _data["govElectricity"] ? CreateOrEditGovElectricityDto.fromJS(_data["govElectricity"]) : <any>undefined;
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGovElectricityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGovElectricityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["govElectricity"] = this.govElectricity ? this.govElectricity.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGovElectricityForEditOutput {
    govElectricity: CreateOrEditGovElectricityDto;
    request: RequestDto;
}

export class GetGovElectricityForViewDto implements IGetGovElectricityForViewDto {
    govElectricity!: GovElectricityDto;
    requestHistiryList!: RequestHistoryDto[] | undefined;
    myRequestsCount!: number;

    constructor(data?: IGetGovElectricityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.govElectricity = _data["govElectricity"] ? GovElectricityDto.fromJS(_data["govElectricity"]) : <any>undefined;
            if (Array.isArray(_data["requestHistiryList"])) {
                this.requestHistiryList = [] as any;
                for (let item of _data["requestHistiryList"])
                    this.requestHistiryList!.push(RequestHistoryDto.fromJS(item));
            }
            this.myRequestsCount = _data["myRequestsCount"];
        }
    }

    static fromJS(data: any): GetGovElectricityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGovElectricityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["govElectricity"] = this.govElectricity ? this.govElectricity.toJSON() : <any>undefined;
        if (Array.isArray(this.requestHistiryList)) {
            data["requestHistiryList"] = [];
            for (let item of this.requestHistiryList)
                data["requestHistiryList"].push(item.toJSON());
        }
        data["myRequestsCount"] = this.myRequestsCount;
        return data;
    }
}

export interface IGetGovElectricityForViewDto {
    govElectricity: GovElectricityDto;
    requestHistiryList: RequestHistoryDto[] | undefined;
    myRequestsCount: number;
}

export class GetGovFuelForEditOutput implements IGetGovFuelForEditOutput {
    govFuel!: CreateOrEditGovFuelDto;
    request!: RequestDto;

    constructor(data?: IGetGovFuelForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.govFuel = _data["govFuel"] ? CreateOrEditGovFuelDto.fromJS(_data["govFuel"]) : <any>undefined;
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGovFuelForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGovFuelForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["govFuel"] = this.govFuel ? this.govFuel.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGovFuelForEditOutput {
    govFuel: CreateOrEditGovFuelDto;
    request: RequestDto;
}

export class GetGovFuelForViewDto implements IGetGovFuelForViewDto {
    govFuel!: GovFuelDto;
    requestHistiryList!: RequestHistoryDto[] | undefined;
    request!: RequestDto;
    requestNumber!: string | undefined;
    myRequestsCount!: number;

    constructor(data?: IGetGovFuelForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.govFuel = _data["govFuel"] ? GovFuelDto.fromJS(_data["govFuel"]) : <any>undefined;
            if (Array.isArray(_data["requestHistiryList"])) {
                this.requestHistiryList = [] as any;
                for (let item of _data["requestHistiryList"])
                    this.requestHistiryList!.push(RequestHistoryDto.fromJS(item));
            }
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.requestNumber = _data["requestNumber"];
            this.myRequestsCount = _data["myRequestsCount"];
        }
    }

    static fromJS(data: any): GetGovFuelForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGovFuelForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["govFuel"] = this.govFuel ? this.govFuel.toJSON() : <any>undefined;
        if (Array.isArray(this.requestHistiryList)) {
            data["requestHistiryList"] = [];
            for (let item of this.requestHistiryList)
                data["requestHistiryList"].push(item.toJSON());
        }
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["requestNumber"] = this.requestNumber;
        data["myRequestsCount"] = this.myRequestsCount;
        return data;
    }
}

export interface IGetGovFuelForViewDto {
    govFuel: GovFuelDto;
    requestHistiryList: RequestHistoryDto[] | undefined;
    request: RequestDto;
    requestNumber: string | undefined;
    myRequestsCount: number;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetKnowledgeBankForViewDto implements IGetKnowledgeBankForViewDto {
    knowledgeBank!: KnowledgeBankDto;

    constructor(data?: IGetKnowledgeBankForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knowledgeBank = _data["knowledgeBank"] ? KnowledgeBankDto.fromJS(_data["knowledgeBank"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetKnowledgeBankForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetKnowledgeBankForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knowledgeBank"] = this.knowledgeBank ? this.knowledgeBank.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetKnowledgeBankForViewDto {
    knowledgeBank: KnowledgeBankDto;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : <any>undefined;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageName = _data["defaultLanguageName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class GetLogInboxOutput implements IGetLogInboxOutput {
    actionType!: ActionType;
    roleId!: number;
    userName!: string | undefined;
    roleName!: string | undefined;
    affectedUser!: string | undefined;
    actionTime!: DateTime;

    constructor(data?: IGetLogInboxOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.roleId = _data["roleId"];
            this.userName = _data["userName"];
            this.roleName = _data["roleName"];
            this.affectedUser = _data["affectedUser"];
            this.actionTime = _data["actionTime"] ? DateTime.fromISO(_data["actionTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLogInboxOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLogInboxOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["roleId"] = this.roleId;
        data["userName"] = this.userName;
        data["roleName"] = this.roleName;
        data["affectedUser"] = this.affectedUser;
        data["actionTime"] = this.actionTime ? this.actionTime.toString() : <any>undefined;
        return data;
    }
}

export interface IGetLogInboxOutput {
    actionType: ActionType;
    roleId: number;
    userName: string | undefined;
    roleName: string | undefined;
    affectedUser: string | undefined;
    actionTime: DateTime;
}

export class GetMainActivityForEditOutput implements IGetMainActivityForEditOutput {
    mainActivity!: CreateOrEditMainActivityDto;

    constructor(data?: IGetMainActivityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainActivity = _data["mainActivity"] ? CreateOrEditMainActivityDto.fromJS(_data["mainActivity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMainActivityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMainActivityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainActivity"] = this.mainActivity ? this.mainActivity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMainActivityForEditOutput {
    mainActivity: CreateOrEditMainActivityDto;
}

export class GetMainActivityForViewDto implements IGetMainActivityForViewDto {
    mainActivity!: MainActivityDto;

    constructor(data?: IGetMainActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainActivity = _data["mainActivity"] ? MainActivityDto.fromJS(_data["mainActivity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMainActivityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMainActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainActivity"] = this.mainActivity ? this.mainActivity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMainActivityForViewDto {
    mainActivity: MainActivityDto;
}

export class GetMediaCenterForViewDto implements IGetMediaCenterForViewDto {
    mediaCenter!: MediaCenterDto;
    vidioAttachmentUrls!: string | undefined;
    imageAttachmentUrls!: string | undefined;

    constructor(data?: IGetMediaCenterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mediaCenter = _data["mediaCenter"] ? MediaCenterDto.fromJS(_data["mediaCenter"]) : <any>undefined;
            this.vidioAttachmentUrls = _data["vidioAttachmentUrls"];
            this.imageAttachmentUrls = _data["imageAttachmentUrls"];
        }
    }

    static fromJS(data: any): GetMediaCenterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMediaCenterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaCenter"] = this.mediaCenter ? this.mediaCenter.toJSON() : <any>undefined;
        data["vidioAttachmentUrls"] = this.vidioAttachmentUrls;
        data["imageAttachmentUrls"] = this.imageAttachmentUrls;
        return data;
    }
}

export interface IGetMediaCenterForViewDto {
    mediaCenter: MediaCenterDto;
    vidioAttachmentUrls: string | undefined;
    imageAttachmentUrls: string | undefined;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of _data["memberActivities"])
                    this.memberActivities!.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export class GetMemberRequestForEditOutput implements IGetMemberRequestForEditOutput {
    request!: RequestEditDto;
    member!: MemberDto;
    organizationUnitId!: number | undefined;
    roles!: UserRoleDto[] | undefined;
    organizationUnitHeader!: OrganizationUnitHeaderDto;

    constructor(data?: IGetMemberRequestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? RequestEditDto.fromJS(_data["request"]) : <any>undefined;
            this.member = _data["member"] ? MemberDto.fromJS(_data["member"]) : <any>undefined;
            this.organizationUnitId = _data["organizationUnitId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            this.organizationUnitHeader = _data["organizationUnitHeader"] ? OrganizationUnitHeaderDto.fromJS(_data["organizationUnitHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMemberRequestForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberRequestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["organizationUnitId"] = this.organizationUnitId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["organizationUnitHeader"] = this.organizationUnitHeader ? this.organizationUnitHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMemberRequestForEditOutput {
    request: RequestEditDto;
    member: MemberDto;
    organizationUnitId: number | undefined;
    roles: UserRoleDto[] | undefined;
    organizationUnitHeader: OrganizationUnitHeaderDto;
}

export class GetMeterInfoForEditOutput implements IGetMeterInfoForEditOutput {
    meterInfo!: CreateOrEditMeterInfoDto;
    organizationUnitDisplayName!: string | undefined;

    constructor(data?: IGetMeterInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterInfo = _data["meterInfo"] ? CreateOrEditMeterInfoDto.fromJS(_data["meterInfo"]) : <any>undefined;
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
        }
    }

    static fromJS(data: any): GetMeterInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeterInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterInfo"] = this.meterInfo ? this.meterInfo.toJSON() : <any>undefined;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        return data;
    }
}

export interface IGetMeterInfoForEditOutput {
    meterInfo: CreateOrEditMeterInfoDto;
    organizationUnitDisplayName: string | undefined;
}

export class GetMeterInfoForViewDto implements IGetMeterInfoForViewDto {
    meterInfo!: MeterInfoDto;
    organizationUnitDisplayName!: string | undefined;

    constructor(data?: IGetMeterInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterInfo = _data["meterInfo"] ? MeterInfoDto.fromJS(_data["meterInfo"]) : <any>undefined;
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
        }
    }

    static fromJS(data: any): GetMeterInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeterInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterInfo"] = this.meterInfo ? this.meterInfo.toJSON() : <any>undefined;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        return data;
    }
}

export interface IGetMeterInfoForViewDto {
    meterInfo: MeterInfoDto;
    organizationUnitDisplayName: string | undefined;
}

export class GetNewsForEditDto implements IGetNewsForEditDto {
    news!: NewsDto;
    newsDraft!: NewsVersionDto;

    constructor(data?: IGetNewsForEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.news = _data["news"] ? NewsDto.fromJS(_data["news"]) : <any>undefined;
            this.newsDraft = _data["newsDraft"] ? NewsVersionDto.fromJS(_data["newsDraft"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNewsForEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsForEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["news"] = this.news ? this.news.toJSON() : <any>undefined;
        data["newsDraft"] = this.newsDraft ? this.newsDraft.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNewsForEditDto {
    news: NewsDto;
    newsDraft: NewsVersionDto;
}

export class GetNewsForViewDto implements IGetNewsForViewDto {
    news!: NewsDto;
    draftId!: string | undefined;

    constructor(data?: IGetNewsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.news = _data["news"] ? NewsDto.fromJS(_data["news"]) : <any>undefined;
            this.draftId = _data["draftId"];
        }
    }

    static fromJS(data: any): GetNewsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["news"] = this.news ? this.news.toJSON() : <any>undefined;
        data["draftId"] = this.draftId;
        return data;
    }
}

export interface IGetNewsForViewDto {
    news: NewsDto;
    draftId: string | undefined;
}

export class GetNewsVersionForViewDto implements IGetNewsVersionForViewDto {
    newsVersionDto!: NewsVersionDto;

    constructor(data?: IGetNewsVersionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newsVersionDto = _data["newsVersionDto"] ? NewsVersionDto.fromJS(_data["newsVersionDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNewsVersionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsVersionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsVersionDto"] = this.newsVersionDto ? this.newsVersionDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNewsVersionForViewDto {
    newsVersionDto: NewsVersionDto;
}

export class GetNotificationLogForEditOutput implements IGetNotificationLogForEditOutput {
    notificationLog!: CreateOrEditNotificationLogDto;

    constructor(data?: IGetNotificationLogForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationLog = _data["notificationLog"] ? CreateOrEditNotificationLogDto.fromJS(_data["notificationLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNotificationLogForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationLogForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationLog"] = this.notificationLog ? this.notificationLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNotificationLogForEditOutput {
    notificationLog: CreateOrEditNotificationLogDto;
}

export class GetNotificationLogForViewDto implements IGetNotificationLogForViewDto {
    notificationLog!: NotificationLogDto;

    constructor(data?: IGetNotificationLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationLog = _data["notificationLog"] ? NotificationLogDto.fromJS(_data["notificationLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNotificationLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationLog"] = this.notificationLog ? this.notificationLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNotificationLogForViewDto {
    notificationLog: NotificationLogDto;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number;
    totalCount!: number;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class GetOldRequestsResponseDTO implements IGetOldRequestsResponseDTO {
    id!: number;
    submissionCycle!: string | undefined;
    totalAmount!: number;
    totalConsumption!: number;
    totalConsumptionBTU!: number;
    totalConsumptionFluid!: number;
    fuelUnitId!: number;

    constructor(data?: IGetOldRequestsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submissionCycle = _data["submissionCycle"];
            this.totalAmount = _data["totalAmount"];
            this.totalConsumption = _data["totalConsumption"];
            this.totalConsumptionBTU = _data["totalConsumptionBTU"];
            this.totalConsumptionFluid = _data["totalConsumptionFluid"];
            this.fuelUnitId = _data["fuelUnitId"];
        }
    }

    static fromJS(data: any): GetOldRequestsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetOldRequestsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submissionCycle"] = this.submissionCycle;
        data["totalAmount"] = this.totalAmount;
        data["totalConsumption"] = this.totalConsumption;
        data["totalConsumptionBTU"] = this.totalConsumptionBTU;
        data["totalConsumptionFluid"] = this.totalConsumptionFluid;
        data["fuelUnitId"] = this.fuelUnitId;
        return data;
    }
}

export interface IGetOldRequestsResponseDTO {
    id: number;
    submissionCycle: string | undefined;
    totalAmount: number;
    totalConsumption: number;
    totalConsumptionBTU: number;
    totalConsumptionFluid: number;
    fuelUnitId: number;
}

export class GetOrganizationActivityDetailForViewDto implements IGetOrganizationActivityDetailForViewDto {
    organizationActivityDetail!: OrganizationActivityDetailDto;
    subActivityName_Ar!: string | undefined;

    constructor(data?: IGetOrganizationActivityDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationActivityDetail = _data["organizationActivityDetail"] ? OrganizationActivityDetailDto.fromJS(_data["organizationActivityDetail"]) : <any>undefined;
            this.subActivityName_Ar = _data["subActivityName_Ar"];
        }
    }

    static fromJS(data: any): GetOrganizationActivityDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationActivityDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationActivityDetail"] = this.organizationActivityDetail ? this.organizationActivityDetail.toJSON() : <any>undefined;
        data["subActivityName_Ar"] = this.subActivityName_Ar;
        return data;
    }
}

export interface IGetOrganizationActivityDetailForViewDto {
    organizationActivityDetail: OrganizationActivityDetailDto;
    subActivityName_Ar: string | undefined;
}

export class GetOrganizationActivityForEditOutput implements IGetOrganizationActivityForEditOutput {
    organizationActivity!: CreateOrEditOrganizationActivityDto;
    organizationUnitDisplayName!: string | undefined;

    constructor(data?: IGetOrganizationActivityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationActivity = _data["organizationActivity"] ? CreateOrEditOrganizationActivityDto.fromJS(_data["organizationActivity"]) : <any>undefined;
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
        }
    }

    static fromJS(data: any): GetOrganizationActivityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationActivityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationActivity"] = this.organizationActivity ? this.organizationActivity.toJSON() : <any>undefined;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        return data;
    }
}

export interface IGetOrganizationActivityForEditOutput {
    organizationActivity: CreateOrEditOrganizationActivityDto;
    organizationUnitDisplayName: string | undefined;
}

export class GetOrganizationActivityForViewDto implements IGetOrganizationActivityForViewDto {
    organizationActivity!: OrganizationActivityDto;
    organizationUnitDisplayName!: string | undefined;
    creatorUser!: string | undefined;

    constructor(data?: IGetOrganizationActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationActivity = _data["organizationActivity"] ? OrganizationActivityDto.fromJS(_data["organizationActivity"]) : <any>undefined;
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
            this.creatorUser = _data["creatorUser"];
        }
    }

    static fromJS(data: any): GetOrganizationActivityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationActivity"] = this.organizationActivity ? this.organizationActivity.toJSON() : <any>undefined;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        data["creatorUser"] = this.creatorUser;
        return data;
    }
}

export interface IGetOrganizationActivityForViewDto {
    organizationActivity: OrganizationActivityDto;
    organizationUnitDisplayName: string | undefined;
    creatorUser: string | undefined;
}

export class GetOrganizationEEPDetailByOrgEppIdDto implements IGetOrganizationEEPDetailByOrgEppIdDto {
    id!: number;
    areaOfImprovementName_Ar!: string | undefined;
    areaOfImprovementParent!: string | undefined;
    areaOfImprovementNature!: string | undefined;
    departmentName!: string | undefined;
    activityStartDate!: DateTime;
    activityEndDate!: DateTime;
    expectedEnergySaving!: number | undefined;
    expectedSavingUnitName!: string | undefined;
    achievedEnergySaving!: number | undefined;
    statusName_Ar!: string | undefined;
    activityRelativeWeight!: number | undefined;
    notes!: string | undefined;
    unitName_Ar!: string | undefined;

    constructor(data?: IGetOrganizationEEPDetailByOrgEppIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.areaOfImprovementName_Ar = _data["areaOfImprovementName_Ar"];
            this.areaOfImprovementParent = _data["areaOfImprovementParent"];
            this.areaOfImprovementNature = _data["areaOfImprovementNature"];
            this.departmentName = _data["departmentName"];
            this.activityStartDate = _data["activityStartDate"] ? DateTime.fromISO(_data["activityStartDate"].toString()) : <any>undefined;
            this.activityEndDate = _data["activityEndDate"] ? DateTime.fromISO(_data["activityEndDate"].toString()) : <any>undefined;
            this.expectedEnergySaving = _data["expectedEnergySaving"];
            this.expectedSavingUnitName = _data["expectedSavingUnitName"];
            this.achievedEnergySaving = _data["achievedEnergySaving"];
            this.statusName_Ar = _data["statusName_Ar"];
            this.activityRelativeWeight = _data["activityRelativeWeight"];
            this.notes = _data["notes"];
            this.unitName_Ar = _data["unitName_Ar"];
        }
    }

    static fromJS(data: any): GetOrganizationEEPDetailByOrgEppIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationEEPDetailByOrgEppIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["areaOfImprovementName_Ar"] = this.areaOfImprovementName_Ar;
        data["areaOfImprovementParent"] = this.areaOfImprovementParent;
        data["areaOfImprovementNature"] = this.areaOfImprovementNature;
        data["departmentName"] = this.departmentName;
        data["activityStartDate"] = this.activityStartDate ? this.activityStartDate.toString() : <any>undefined;
        data["activityEndDate"] = this.activityEndDate ? this.activityEndDate.toString() : <any>undefined;
        data["expectedEnergySaving"] = this.expectedEnergySaving;
        data["expectedSavingUnitName"] = this.expectedSavingUnitName;
        data["achievedEnergySaving"] = this.achievedEnergySaving;
        data["statusName_Ar"] = this.statusName_Ar;
        data["activityRelativeWeight"] = this.activityRelativeWeight;
        data["notes"] = this.notes;
        data["unitName_Ar"] = this.unitName_Ar;
        return data;
    }
}

export interface IGetOrganizationEEPDetailByOrgEppIdDto {
    id: number;
    areaOfImprovementName_Ar: string | undefined;
    areaOfImprovementParent: string | undefined;
    areaOfImprovementNature: string | undefined;
    departmentName: string | undefined;
    activityStartDate: DateTime;
    activityEndDate: DateTime;
    expectedEnergySaving: number | undefined;
    expectedSavingUnitName: string | undefined;
    achievedEnergySaving: number | undefined;
    statusName_Ar: string | undefined;
    activityRelativeWeight: number | undefined;
    notes: string | undefined;
    unitName_Ar: string | undefined;
}

export class GetOrganizationEEPDetailForEditOutput implements IGetOrganizationEEPDetailForEditOutput {
    organizationEEPDetail!: CreateOrEditOrganizationEEPDetailDto;
    organizationEEPSubject!: string | undefined;
    unitName_Ar!: string | undefined;
    eepStatusName_Ar!: string | undefined;
    areaOfImprovementName_Ar!: string | undefined;

    constructor(data?: IGetOrganizationEEPDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationEEPDetail = _data["organizationEEPDetail"] ? CreateOrEditOrganizationEEPDetailDto.fromJS(_data["organizationEEPDetail"]) : <any>undefined;
            this.organizationEEPSubject = _data["organizationEEPSubject"];
            this.unitName_Ar = _data["unitName_Ar"];
            this.eepStatusName_Ar = _data["eepStatusName_Ar"];
            this.areaOfImprovementName_Ar = _data["areaOfImprovementName_Ar"];
        }
    }

    static fromJS(data: any): GetOrganizationEEPDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationEEPDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationEEPDetail"] = this.organizationEEPDetail ? this.organizationEEPDetail.toJSON() : <any>undefined;
        data["organizationEEPSubject"] = this.organizationEEPSubject;
        data["unitName_Ar"] = this.unitName_Ar;
        data["eepStatusName_Ar"] = this.eepStatusName_Ar;
        data["areaOfImprovementName_Ar"] = this.areaOfImprovementName_Ar;
        return data;
    }
}

export interface IGetOrganizationEEPDetailForEditOutput {
    organizationEEPDetail: CreateOrEditOrganizationEEPDetailDto;
    organizationEEPSubject: string | undefined;
    unitName_Ar: string | undefined;
    eepStatusName_Ar: string | undefined;
    areaOfImprovementName_Ar: string | undefined;
}

export class GetOrganizationEEPDetailForViewDto implements IGetOrganizationEEPDetailForViewDto {
    organizationEEPDetail!: OrganizationEEPDetailDto;
    organizationEEPSubject!: string | undefined;
    unitName_Ar!: string | undefined;
    fuelUnitName_Ar!: string | undefined;
    eepStatusName_Ar!: string | undefined;

    constructor(data?: IGetOrganizationEEPDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationEEPDetail = _data["organizationEEPDetail"] ? OrganizationEEPDetailDto.fromJS(_data["organizationEEPDetail"]) : <any>undefined;
            this.organizationEEPSubject = _data["organizationEEPSubject"];
            this.unitName_Ar = _data["unitName_Ar"];
            this.fuelUnitName_Ar = _data["fuelUnitName_Ar"];
            this.eepStatusName_Ar = _data["eepStatusName_Ar"];
        }
    }

    static fromJS(data: any): GetOrganizationEEPDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationEEPDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationEEPDetail"] = this.organizationEEPDetail ? this.organizationEEPDetail.toJSON() : <any>undefined;
        data["organizationEEPSubject"] = this.organizationEEPSubject;
        data["unitName_Ar"] = this.unitName_Ar;
        data["fuelUnitName_Ar"] = this.fuelUnitName_Ar;
        data["eepStatusName_Ar"] = this.eepStatusName_Ar;
        return data;
    }
}

export interface IGetOrganizationEEPDetailForViewDto {
    organizationEEPDetail: OrganizationEEPDetailDto;
    organizationEEPSubject: string | undefined;
    unitName_Ar: string | undefined;
    fuelUnitName_Ar: string | undefined;
    eepStatusName_Ar: string | undefined;
}

export class GetOrganizationEEPForEditOutput implements IGetOrganizationEEPForEditOutput {
    organizationEEP!: CreateOrEditOrganizationEEPDto;
    unitName_Ar!: string | undefined;
    baselinePeriodName_Ar!: string | undefined;
    allAreaOfImprovements!: AreaOfImprovementDto[] | undefined;
    memberedAreaOfImprovements!: number[] | undefined;
    planHeaderDto!: EepPlanHeaderDto;

    constructor(data?: IGetOrganizationEEPForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationEEP = _data["organizationEEP"] ? CreateOrEditOrganizationEEPDto.fromJS(_data["organizationEEP"]) : <any>undefined;
            this.unitName_Ar = _data["unitName_Ar"];
            this.baselinePeriodName_Ar = _data["baselinePeriodName_Ar"];
            if (Array.isArray(_data["allAreaOfImprovements"])) {
                this.allAreaOfImprovements = [] as any;
                for (let item of _data["allAreaOfImprovements"])
                    this.allAreaOfImprovements!.push(AreaOfImprovementDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedAreaOfImprovements"])) {
                this.memberedAreaOfImprovements = [] as any;
                for (let item of _data["memberedAreaOfImprovements"])
                    this.memberedAreaOfImprovements!.push(item);
            }
            this.planHeaderDto = _data["planHeaderDto"] ? EepPlanHeaderDto.fromJS(_data["planHeaderDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrganizationEEPForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationEEPForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationEEP"] = this.organizationEEP ? this.organizationEEP.toJSON() : <any>undefined;
        data["unitName_Ar"] = this.unitName_Ar;
        data["baselinePeriodName_Ar"] = this.baselinePeriodName_Ar;
        if (Array.isArray(this.allAreaOfImprovements)) {
            data["allAreaOfImprovements"] = [];
            for (let item of this.allAreaOfImprovements)
                data["allAreaOfImprovements"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedAreaOfImprovements)) {
            data["memberedAreaOfImprovements"] = [];
            for (let item of this.memberedAreaOfImprovements)
                data["memberedAreaOfImprovements"].push(item);
        }
        data["planHeaderDto"] = this.planHeaderDto ? this.planHeaderDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrganizationEEPForEditOutput {
    organizationEEP: CreateOrEditOrganizationEEPDto;
    unitName_Ar: string | undefined;
    baselinePeriodName_Ar: string | undefined;
    allAreaOfImprovements: AreaOfImprovementDto[] | undefined;
    memberedAreaOfImprovements: number[] | undefined;
    planHeaderDto: EepPlanHeaderDto;
}

export class GetOrganizationEEPForViewDto implements IGetOrganizationEEPForViewDto {
    organizationEEP!: OrganizationEEPDto;
    organizationUnitDisplayName!: string | undefined;
    organizationCode!: string | undefined;
    secorName_Ar!: string | undefined;
    userName!: string | undefined;
    unitName_Ar!: string | undefined;
    activitesStartDate!: DateTime | undefined;
    activitesEndDate!: DateTime | undefined;
    totalAmountOfAbundanceAchieved!: number | undefined;
    totalExpectedEnergySavingRate!: number | undefined;
    totalRelativeWeight!: number | undefined;
    totalExpectedConsumption!: number | undefined;
    formatedActivitesStartDate!: string | undefined;
    formatedActivitesEndDate!: string | undefined;
    organizationUnitObj!: OrganizationUnit;

    constructor(data?: IGetOrganizationEEPForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationEEP = _data["organizationEEP"] ? OrganizationEEPDto.fromJS(_data["organizationEEP"]) : <any>undefined;
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
            this.organizationCode = _data["organizationCode"];
            this.secorName_Ar = _data["secorName_Ar"];
            this.userName = _data["userName"];
            this.unitName_Ar = _data["unitName_Ar"];
            this.activitesStartDate = _data["activitesStartDate"] ? DateTime.fromISO(_data["activitesStartDate"].toString()) : <any>undefined;
            this.activitesEndDate = _data["activitesEndDate"] ? DateTime.fromISO(_data["activitesEndDate"].toString()) : <any>undefined;
            this.totalAmountOfAbundanceAchieved = _data["totalAmountOfAbundanceAchieved"];
            this.totalExpectedEnergySavingRate = _data["totalExpectedEnergySavingRate"];
            this.totalRelativeWeight = _data["totalRelativeWeight"];
            this.totalExpectedConsumption = _data["totalExpectedConsumption"];
            this.formatedActivitesStartDate = _data["formatedActivitesStartDate"];
            this.formatedActivitesEndDate = _data["formatedActivitesEndDate"];
            this.organizationUnitObj = _data["organizationUnitObj"] ? OrganizationUnit.fromJS(_data["organizationUnitObj"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrganizationEEPForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationEEPForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationEEP"] = this.organizationEEP ? this.organizationEEP.toJSON() : <any>undefined;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        data["organizationCode"] = this.organizationCode;
        data["secorName_Ar"] = this.secorName_Ar;
        data["userName"] = this.userName;
        data["unitName_Ar"] = this.unitName_Ar;
        data["activitesStartDate"] = this.activitesStartDate ? this.activitesStartDate.toString() : <any>undefined;
        data["activitesEndDate"] = this.activitesEndDate ? this.activitesEndDate.toString() : <any>undefined;
        data["totalAmountOfAbundanceAchieved"] = this.totalAmountOfAbundanceAchieved;
        data["totalExpectedEnergySavingRate"] = this.totalExpectedEnergySavingRate;
        data["totalRelativeWeight"] = this.totalRelativeWeight;
        data["totalExpectedConsumption"] = this.totalExpectedConsumption;
        data["formatedActivitesStartDate"] = this.formatedActivitesStartDate;
        data["formatedActivitesEndDate"] = this.formatedActivitesEndDate;
        data["organizationUnitObj"] = this.organizationUnitObj ? this.organizationUnitObj.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrganizationEEPForViewDto {
    organizationEEP: OrganizationEEPDto;
    organizationUnitDisplayName: string | undefined;
    organizationCode: string | undefined;
    secorName_Ar: string | undefined;
    userName: string | undefined;
    unitName_Ar: string | undefined;
    activitesStartDate: DateTime | undefined;
    activitesEndDate: DateTime | undefined;
    totalAmountOfAbundanceAchieved: number | undefined;
    totalExpectedEnergySavingRate: number | undefined;
    totalRelativeWeight: number | undefined;
    totalExpectedConsumption: number | undefined;
    formatedActivitesStartDate: string | undefined;
    formatedActivitesEndDate: string | undefined;
    organizationUnitObj: OrganizationUnit;
}

export class GetOrganizationForViewDto implements IGetOrganizationForViewDto {
    organization!: OrganizationUnitDto;

    constructor(data?: IGetOrganizationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organization = _data["organization"] ? OrganizationUnitDto.fromJS(_data["organization"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrganizationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrganizationForViewDto {
    organization: OrganizationUnitDto;
}

export class GetOrganizationUserDto implements IGetOrganizationUserDto {
    sectorName!: string | undefined;
    organizationName!: string | undefined;
    parentOrganizationName!: string | undefined;
    govCode!: string | undefined;
    user!: UserViewDto;
    id!: number;
    organizationTypeId!: number;
    claimAccounts!: ClaimAccountDto[] | undefined;

    constructor(data?: IGetOrganizationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectorName = _data["sectorName"];
            this.organizationName = _data["organizationName"];
            this.parentOrganizationName = _data["parentOrganizationName"];
            this.govCode = _data["govCode"];
            this.user = _data["user"] ? UserViewDto.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.organizationTypeId = _data["organizationTypeId"];
            if (Array.isArray(_data["claimAccounts"])) {
                this.claimAccounts = [] as any;
                for (let item of _data["claimAccounts"])
                    this.claimAccounts!.push(ClaimAccountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrganizationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectorName"] = this.sectorName;
        data["organizationName"] = this.organizationName;
        data["parentOrganizationName"] = this.parentOrganizationName;
        data["govCode"] = this.govCode;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["organizationTypeId"] = this.organizationTypeId;
        if (Array.isArray(this.claimAccounts)) {
            data["claimAccounts"] = [];
            for (let item of this.claimAccounts)
                data["claimAccounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrganizationUserDto {
    sectorName: string | undefined;
    organizationName: string | undefined;
    parentOrganizationName: string | undefined;
    govCode: string | undefined;
    user: UserViewDto;
    id: number;
    organizationTypeId: number;
    claimAccounts: ClaimAccountDto[] | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class GetProfitShareOutput implements IGetProfitShareOutput {
    profitShares!: number[] | undefined;

    constructor(data?: IGetProfitShareOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetProfitShareOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfitShareOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetProfitShareOutput {
    profitShares: number[] | undefined;
}

export class GetProviderElectricityForEditOutput implements IGetProviderElectricityForEditOutput {
    providerElectricity!: CreateOrEditProviderElectricityDto;
    request!: RequestDto;
    rejectionResaon!: string | undefined;
    requestStatus!: number;

    constructor(data?: IGetProviderElectricityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerElectricity = _data["providerElectricity"] ? CreateOrEditProviderElectricityDto.fromJS(_data["providerElectricity"]) : <any>undefined;
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.rejectionResaon = _data["rejectionResaon"];
            this.requestStatus = _data["requestStatus"];
        }
    }

    static fromJS(data: any): GetProviderElectricityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProviderElectricityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerElectricity"] = this.providerElectricity ? this.providerElectricity.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["rejectionResaon"] = this.rejectionResaon;
        data["requestStatus"] = this.requestStatus;
        return data;
    }
}

export interface IGetProviderElectricityForEditOutput {
    providerElectricity: CreateOrEditProviderElectricityDto;
    request: RequestDto;
    rejectionResaon: string | undefined;
    requestStatus: number;
}

export class GetProviderElectricityForViewDto implements IGetProviderElectricityForViewDto {
    providerElectricity!: ProviderElectricityDto;
    requestDto!: ProRequestDto;
    organizationUnit!: OrganizationUnitDto;
    requestHistiryList!: RequestHistoryDto[] | undefined;
    myRequestsCount!: number;

    constructor(data?: IGetProviderElectricityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerElectricity = _data["providerElectricity"] ? ProviderElectricityDto.fromJS(_data["providerElectricity"]) : <any>undefined;
            this.requestDto = _data["requestDto"] ? ProRequestDto.fromJS(_data["requestDto"]) : <any>undefined;
            this.organizationUnit = _data["organizationUnit"] ? OrganizationUnitDto.fromJS(_data["organizationUnit"]) : <any>undefined;
            if (Array.isArray(_data["requestHistiryList"])) {
                this.requestHistiryList = [] as any;
                for (let item of _data["requestHistiryList"])
                    this.requestHistiryList!.push(RequestHistoryDto.fromJS(item));
            }
            this.myRequestsCount = _data["myRequestsCount"];
        }
    }

    static fromJS(data: any): GetProviderElectricityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProviderElectricityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerElectricity"] = this.providerElectricity ? this.providerElectricity.toJSON() : <any>undefined;
        data["requestDto"] = this.requestDto ? this.requestDto.toJSON() : <any>undefined;
        data["organizationUnit"] = this.organizationUnit ? this.organizationUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.requestHistiryList)) {
            data["requestHistiryList"] = [];
            for (let item of this.requestHistiryList)
                data["requestHistiryList"].push(item.toJSON());
        }
        data["myRequestsCount"] = this.myRequestsCount;
        return data;
    }
}

export interface IGetProviderElectricityForViewDto {
    providerElectricity: ProviderElectricityDto;
    requestDto: ProRequestDto;
    organizationUnit: OrganizationUnitDto;
    requestHistiryList: RequestHistoryDto[] | undefined;
    myRequestsCount: number;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
    recentTenantsDayCount!: number;
    maxRecentTenantsShownCount!: number;
    tenantCreationStartDate!: DateTime;
    recentTenants!: RecentTenant[] | undefined;

    constructor(data?: IGetRecentTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recentTenantsDayCount = _data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = _data["tenantCreationStartDate"] ? DateTime.fromISO(_data["tenantCreationStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of _data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecentTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toString() : <any>undefined;
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecentTenantsOutput {
    recentTenantsDayCount: number;
    maxRecentTenantsShownCount: number;
    tenantCreationStartDate: DateTime;
    recentTenants: RecentTenant[] | undefined;
}

export class GetReferenceForViewDto implements IGetReferenceForViewDto {
    reference!: ReferenceDto;

    constructor(data?: IGetReferenceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"] ? ReferenceDto.fromJS(_data["reference"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReferenceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferenceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference ? this.reference.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReferenceForViewDto {
    reference: ReferenceDto;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
    stats!: RegionalStatCountry[] | undefined;

    constructor(data?: IGetRegionalStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(RegionalStatCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegionalStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRegionalStatsOutput {
    stats: RegionalStatCountry[] | undefined;
}

export class GetRequestPeriodSettingForEditOutput implements IGetRequestPeriodSettingForEditOutput {
    requestPeriodSetting!: CreateOrEditRequestPeriodSettingDto;
    settingPeriodTypeName_Ar!: string | undefined;
    settingPeriodsRequestTypeName_Ar!: string | undefined;
    settingPeriodsRequestTypeName_En!: string | undefined;
    submissionCycleName_Ar!: string | undefined;
    submissionCycleName_En!: string | undefined;

    constructor(data?: IGetRequestPeriodSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestPeriodSetting = _data["requestPeriodSetting"] ? CreateOrEditRequestPeriodSettingDto.fromJS(_data["requestPeriodSetting"]) : <any>undefined;
            this.settingPeriodTypeName_Ar = _data["settingPeriodTypeName_Ar"];
            this.settingPeriodsRequestTypeName_Ar = _data["settingPeriodsRequestTypeName_Ar"];
            this.settingPeriodsRequestTypeName_En = _data["settingPeriodsRequestTypeName_En"];
            this.submissionCycleName_Ar = _data["submissionCycleName_Ar"];
            this.submissionCycleName_En = _data["submissionCycleName_En"];
        }
    }

    static fromJS(data: any): GetRequestPeriodSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestPeriodSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestPeriodSetting"] = this.requestPeriodSetting ? this.requestPeriodSetting.toJSON() : <any>undefined;
        data["settingPeriodTypeName_Ar"] = this.settingPeriodTypeName_Ar;
        data["settingPeriodsRequestTypeName_Ar"] = this.settingPeriodsRequestTypeName_Ar;
        data["settingPeriodsRequestTypeName_En"] = this.settingPeriodsRequestTypeName_En;
        data["submissionCycleName_Ar"] = this.submissionCycleName_Ar;
        data["submissionCycleName_En"] = this.submissionCycleName_En;
        return data;
    }
}

export interface IGetRequestPeriodSettingForEditOutput {
    requestPeriodSetting: CreateOrEditRequestPeriodSettingDto;
    settingPeriodTypeName_Ar: string | undefined;
    settingPeriodsRequestTypeName_Ar: string | undefined;
    settingPeriodsRequestTypeName_En: string | undefined;
    submissionCycleName_Ar: string | undefined;
    submissionCycleName_En: string | undefined;
}

export class GetRequestPeriodSettingForViewDto implements IGetRequestPeriodSettingForViewDto {
    requestPeriodSetting!: RequestPeriodSettingDto;
    settingPeriodTypeName_Ar!: string | undefined;
    settingPeriodsRequestTypeName_Ar!: string | undefined;
    submissionCycleName_Ar!: string | undefined;
    monthlySubmissionCycle!: string | undefined;

    constructor(data?: IGetRequestPeriodSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestPeriodSetting = _data["requestPeriodSetting"] ? RequestPeriodSettingDto.fromJS(_data["requestPeriodSetting"]) : <any>undefined;
            this.settingPeriodTypeName_Ar = _data["settingPeriodTypeName_Ar"];
            this.settingPeriodsRequestTypeName_Ar = _data["settingPeriodsRequestTypeName_Ar"];
            this.submissionCycleName_Ar = _data["submissionCycleName_Ar"];
            this.monthlySubmissionCycle = _data["monthlySubmissionCycle"];
        }
    }

    static fromJS(data: any): GetRequestPeriodSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestPeriodSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestPeriodSetting"] = this.requestPeriodSetting ? this.requestPeriodSetting.toJSON() : <any>undefined;
        data["settingPeriodTypeName_Ar"] = this.settingPeriodTypeName_Ar;
        data["settingPeriodsRequestTypeName_Ar"] = this.settingPeriodsRequestTypeName_Ar;
        data["submissionCycleName_Ar"] = this.submissionCycleName_Ar;
        data["monthlySubmissionCycle"] = this.monthlySubmissionCycle;
        return data;
    }
}

export interface IGetRequestPeriodSettingForViewDto {
    requestPeriodSetting: RequestPeriodSettingDto;
    settingPeriodTypeName_Ar: string | undefined;
    settingPeriodsRequestTypeName_Ar: string | undefined;
    submissionCycleName_Ar: string | undefined;
    monthlySubmissionCycle: string | undefined;
}

export class GetRequestsForViewDto implements IGetRequestsForViewDto {
    request!: RequestDto;
    requestHistoryList!: RequestHistoryDto[] | undefined;
    requestStatusName_Ar!: string | undefined;
    requestTypesName_Ar!: string | undefined;
    organizationUnit_NameAr!: string | undefined;
    parentOrganizationName!: string | undefined;
    submittedBySureName!: string | undefined;
    assignedToSureName!: string | undefined;
    myRequestsCount!: number;
    requestCompareResult!: RequestCompareResult;
    courseTopicName!: string | undefined;
    seecTech!: UserViewDto;

    constructor(data?: IGetRequestsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["requestHistoryList"])) {
                this.requestHistoryList = [] as any;
                for (let item of _data["requestHistoryList"])
                    this.requestHistoryList!.push(RequestHistoryDto.fromJS(item));
            }
            this.requestStatusName_Ar = _data["requestStatusName_Ar"];
            this.requestTypesName_Ar = _data["requestTypesName_Ar"];
            this.organizationUnit_NameAr = _data["organizationUnit_NameAr"];
            this.parentOrganizationName = _data["parentOrganizationName"];
            this.submittedBySureName = _data["submittedBySureName"];
            this.assignedToSureName = _data["assignedToSureName"];
            this.myRequestsCount = _data["myRequestsCount"];
            this.requestCompareResult = _data["requestCompareResult"] ? RequestCompareResult.fromJS(_data["requestCompareResult"]) : <any>undefined;
            this.courseTopicName = _data["courseTopicName"];
            this.seecTech = _data["seecTech"] ? UserViewDto.fromJS(_data["seecTech"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRequestsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.requestHistoryList)) {
            data["requestHistoryList"] = [];
            for (let item of this.requestHistoryList)
                data["requestHistoryList"].push(item.toJSON());
        }
        data["requestStatusName_Ar"] = this.requestStatusName_Ar;
        data["requestTypesName_Ar"] = this.requestTypesName_Ar;
        data["organizationUnit_NameAr"] = this.organizationUnit_NameAr;
        data["parentOrganizationName"] = this.parentOrganizationName;
        data["submittedBySureName"] = this.submittedBySureName;
        data["assignedToSureName"] = this.assignedToSureName;
        data["myRequestsCount"] = this.myRequestsCount;
        data["requestCompareResult"] = this.requestCompareResult ? this.requestCompareResult.toJSON() : <any>undefined;
        data["courseTopicName"] = this.courseTopicName;
        data["seecTech"] = this.seecTech ? this.seecTech.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRequestsForViewDto {
    request: RequestDto;
    requestHistoryList: RequestHistoryDto[] | undefined;
    requestStatusName_Ar: string | undefined;
    requestTypesName_Ar: string | undefined;
    organizationUnit_NameAr: string | undefined;
    parentOrganizationName: string | undefined;
    submittedBySureName: string | undefined;
    assignedToSureName: string | undefined;
    myRequestsCount: number;
    requestCompareResult: RequestCompareResult;
    courseTopicName: string | undefined;
    seecTech: UserViewDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetRolesInput implements IGetRolesInput {
    permissions!: string[] | undefined;

    constructor(data?: IGetRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IGetRolesInput {
    permissions: string[] | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSalesSummaryOutput {
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    salesSummary: SalesSummaryData[] | undefined;
}

export class GetSecMeterForDetailsDto implements IGetSecMeterForDetailsDto {
    secMeter!: SecMeterDto;
    organizationUnitId!: number | undefined;
    organizationName_Ar!: string | undefined;
    organizationName_En!: string | undefined;
    reviewStatusName_Ar!: string | undefined;
    latestSnapshot!: SecMeterSnapshotDto;
    canReview!: boolean;

    constructor(data?: IGetSecMeterForDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secMeter = _data["secMeter"] ? SecMeterDto.fromJS(_data["secMeter"]) : <any>undefined;
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationName_Ar = _data["organizationName_Ar"];
            this.organizationName_En = _data["organizationName_En"];
            this.reviewStatusName_Ar = _data["reviewStatusName_Ar"];
            this.latestSnapshot = _data["latestSnapshot"] ? SecMeterSnapshotDto.fromJS(_data["latestSnapshot"]) : <any>undefined;
            this.canReview = _data["canReview"];
        }
    }

    static fromJS(data: any): GetSecMeterForDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecMeterForDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secMeter"] = this.secMeter ? this.secMeter.toJSON() : <any>undefined;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationName_Ar"] = this.organizationName_Ar;
        data["organizationName_En"] = this.organizationName_En;
        data["reviewStatusName_Ar"] = this.reviewStatusName_Ar;
        data["latestSnapshot"] = this.latestSnapshot ? this.latestSnapshot.toJSON() : <any>undefined;
        data["canReview"] = this.canReview;
        return data;
    }
}

export interface IGetSecMeterForDetailsDto {
    secMeter: SecMeterDto;
    organizationUnitId: number | undefined;
    organizationName_Ar: string | undefined;
    organizationName_En: string | undefined;
    reviewStatusName_Ar: string | undefined;
    latestSnapshot: SecMeterSnapshotDto;
    canReview: boolean;
}

export class GetSecMeterForViewDto implements IGetSecMeterForViewDto {
    secMeter!: SecMeterDto;
    organizationUnitId!: number | undefined;
    organizationName_Ar!: string | undefined;
    organizationName_En!: string | undefined;
    reviewStatusName_Ar!: string | undefined;
    meterNumber!: string | undefined;
    region!: string | undefined;
    city!: string | undefined;

    constructor(data?: IGetSecMeterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secMeter = _data["secMeter"] ? SecMeterDto.fromJS(_data["secMeter"]) : <any>undefined;
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationName_Ar = _data["organizationName_Ar"];
            this.organizationName_En = _data["organizationName_En"];
            this.reviewStatusName_Ar = _data["reviewStatusName_Ar"];
            this.meterNumber = _data["meterNumber"];
            this.region = _data["region"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): GetSecMeterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecMeterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secMeter"] = this.secMeter ? this.secMeter.toJSON() : <any>undefined;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationName_Ar"] = this.organizationName_Ar;
        data["organizationName_En"] = this.organizationName_En;
        data["reviewStatusName_Ar"] = this.reviewStatusName_Ar;
        data["meterNumber"] = this.meterNumber;
        data["region"] = this.region;
        data["city"] = this.city;
        return data;
    }
}

export interface IGetSecMeterForViewDto {
    secMeter: SecMeterDto;
    organizationUnitId: number | undefined;
    organizationName_Ar: string | undefined;
    organizationName_En: string | undefined;
    reviewStatusName_Ar: string | undefined;
    meterNumber: string | undefined;
    region: string | undefined;
    city: string | undefined;
}

export class GetSectorForEditOutput implements IGetSectorForEditOutput {
    sector!: CreateOrEditSectorDto;

    constructor(data?: IGetSectorForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sector = _data["sector"] ? CreateOrEditSectorDto.fromJS(_data["sector"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSectorForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSectorForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sector"] = this.sector ? this.sector.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSectorForEditOutput {
    sector: CreateOrEditSectorDto;
}

export class GetSectorForViewDto implements IGetSectorForViewDto {
    sector!: SectorDto;

    constructor(data?: IGetSectorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sector = _data["sector"] ? SectorDto.fromJS(_data["sector"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSectorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSectorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sector"] = this.sector ? this.sector.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSectorForViewDto {
    sector: SectorDto;
}

export class GetSeecEmailForEditOutput implements IGetSeecEmailForEditOutput {
    seecEmail!: CreateOrEditSeecEmailDto;
    emailTemplateName!: string | undefined;

    constructor(data?: IGetSeecEmailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seecEmail = _data["seecEmail"] ? CreateOrEditSeecEmailDto.fromJS(_data["seecEmail"]) : <any>undefined;
            this.emailTemplateName = _data["emailTemplateName"];
        }
    }

    static fromJS(data: any): GetSeecEmailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeecEmailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seecEmail"] = this.seecEmail ? this.seecEmail.toJSON() : <any>undefined;
        data["emailTemplateName"] = this.emailTemplateName;
        return data;
    }
}

export interface IGetSeecEmailForEditOutput {
    seecEmail: CreateOrEditSeecEmailDto;
    emailTemplateName: string | undefined;
}

export class GetSeecEmailForViewDto implements IGetSeecEmailForViewDto {
    seecEmail!: SeecEmailDto;
    emailTemplateName!: string | undefined;

    constructor(data?: IGetSeecEmailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seecEmail = _data["seecEmail"] ? SeecEmailDto.fromJS(_data["seecEmail"]) : <any>undefined;
            this.emailTemplateName = _data["emailTemplateName"];
        }
    }

    static fromJS(data: any): GetSeecEmailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeecEmailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seecEmail"] = this.seecEmail ? this.seecEmail.toJSON() : <any>undefined;
        data["emailTemplateName"] = this.emailTemplateName;
        return data;
    }
}

export interface IGetSeecEmailForViewDto {
    seecEmail: SeecEmailDto;
    emailTemplateName: string | undefined;
}

export class GetSeecEmailTemplateForEditOutput implements IGetSeecEmailTemplateForEditOutput {
    seecEmailTemplate!: CreateOrEditSeecEmailTemplateDto;

    constructor(data?: IGetSeecEmailTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seecEmailTemplate = _data["seecEmailTemplate"] ? CreateOrEditSeecEmailTemplateDto.fromJS(_data["seecEmailTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSeecEmailTemplateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeecEmailTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seecEmailTemplate"] = this.seecEmailTemplate ? this.seecEmailTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSeecEmailTemplateForEditOutput {
    seecEmailTemplate: CreateOrEditSeecEmailTemplateDto;
}

export class GetSeecEmailTemplateForViewDto implements IGetSeecEmailTemplateForViewDto {
    seecEmailTemplate!: SeecEmailTemplateDto;

    constructor(data?: IGetSeecEmailTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seecEmailTemplate = _data["seecEmailTemplate"] ? SeecEmailTemplateDto.fromJS(_data["seecEmailTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSeecEmailTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeecEmailTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seecEmailTemplate"] = this.seecEmailTemplate ? this.seecEmailTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSeecEmailTemplateForViewDto {
    seecEmailTemplate: SeecEmailTemplateDto;
}

export class GetSeecSMSForEditOutput implements IGetSeecSMSForEditOutput {
    seecSMS!: CreateOrEditSeecSMSDto;
    smsTemplateName!: string | undefined;

    constructor(data?: IGetSeecSMSForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seecSMS = _data["seecSMS"] ? CreateOrEditSeecSMSDto.fromJS(_data["seecSMS"]) : <any>undefined;
            this.smsTemplateName = _data["smsTemplateName"];
        }
    }

    static fromJS(data: any): GetSeecSMSForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeecSMSForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seecSMS"] = this.seecSMS ? this.seecSMS.toJSON() : <any>undefined;
        data["smsTemplateName"] = this.smsTemplateName;
        return data;
    }
}

export interface IGetSeecSMSForEditOutput {
    seecSMS: CreateOrEditSeecSMSDto;
    smsTemplateName: string | undefined;
}

export class GetSeecSMSForViewDto implements IGetSeecSMSForViewDto {
    seecSMS!: SeecSMSDto;
    smsTemplateName!: string | undefined;

    constructor(data?: IGetSeecSMSForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seecSMS = _data["seecSMS"] ? SeecSMSDto.fromJS(_data["seecSMS"]) : <any>undefined;
            this.smsTemplateName = _data["smsTemplateName"];
        }
    }

    static fromJS(data: any): GetSeecSMSForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeecSMSForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seecSMS"] = this.seecSMS ? this.seecSMS.toJSON() : <any>undefined;
        data["smsTemplateName"] = this.smsTemplateName;
        return data;
    }
}

export interface IGetSeecSMSForViewDto {
    seecSMS: SeecSMSDto;
    smsTemplateName: string | undefined;
}

export class GetSeecSmsTemplateForEditOutput implements IGetSeecSmsTemplateForEditOutput {
    seecSmsTemplate!: CreateOrEditSeecSmsTemplateDto;

    constructor(data?: IGetSeecSmsTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seecSmsTemplate = _data["seecSmsTemplate"] ? CreateOrEditSeecSmsTemplateDto.fromJS(_data["seecSmsTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSeecSmsTemplateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeecSmsTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seecSmsTemplate"] = this.seecSmsTemplate ? this.seecSmsTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSeecSmsTemplateForEditOutput {
    seecSmsTemplate: CreateOrEditSeecSmsTemplateDto;
}

export class GetSeecSmsTemplateForViewDto implements IGetSeecSmsTemplateForViewDto {
    seecSmsTemplate!: SeecSmsTemplateDto;

    constructor(data?: IGetSeecSmsTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seecSmsTemplate = _data["seecSmsTemplate"] ? SeecSmsTemplateDto.fromJS(_data["seecSmsTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSeecSmsTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeecSmsTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seecSmsTemplate"] = this.seecSmsTemplate ? this.seecSmsTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSeecSmsTemplateForViewDto {
    seecSmsTemplate: SeecSmsTemplateDto;
}

export class GetSMSForEditOutput implements IGetSMSForEditOutput {
    sms!: CreateOrEditSMSDto;

    constructor(data?: IGetSMSForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sms = _data["sms"] ? CreateOrEditSMSDto.fromJS(_data["sms"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSMSForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSMSForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sms"] = this.sms ? this.sms.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSMSForEditOutput {
    sms: CreateOrEditSMSDto;
}

export class GetSMSForViewDto implements IGetSMSForViewDto {
    sms!: SMSDto;

    constructor(data?: IGetSMSForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sms = _data["sms"] ? SMSDto.fromJS(_data["sms"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSMSForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSMSForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sms"] = this.sms ? this.sms.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSMSForViewDto {
    sms: SMSDto;
}

export class GetSmsTemplateForEditOutput implements IGetSmsTemplateForEditOutput {
    smsTemplate!: CreateOrEditSmsTemplateDto;

    constructor(data?: IGetSmsTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsTemplate = _data["smsTemplate"] ? CreateOrEditSmsTemplateDto.fromJS(_data["smsTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSmsTemplateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSmsTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsTemplate"] = this.smsTemplate ? this.smsTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSmsTemplateForEditOutput {
    smsTemplate: CreateOrEditSmsTemplateDto;
}

export class GetSmsTemplateForViewDto implements IGetSmsTemplateForViewDto {
    smsTemplate!: SmsTemplateDto;

    constructor(data?: IGetSmsTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsTemplate = _data["smsTemplate"] ? SmsTemplateDto.fromJS(_data["smsTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSmsTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSmsTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsTemplate"] = this.smsTemplate ? this.smsTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSmsTemplateForViewDto {
    smsTemplate: SmsTemplateDto;
}

export class GetStreetlightAssetInfoForViewDto implements IGetStreetlightAssetInfoForViewDto {
    streetlightAssetInfo!: StreetlightAssetInfoDto;
    regionName_Ar!: string | undefined;
    lightingTypeName_Ar!: string | undefined;
    operationalStatusName_Ar!: string | undefined;
    maintenanceCycleName_Ar!: string | undefined;
    serviceProviderName!: string | undefined;

    constructor(data?: IGetStreetlightAssetInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetlightAssetInfo = _data["streetlightAssetInfo"] ? StreetlightAssetInfoDto.fromJS(_data["streetlightAssetInfo"]) : <any>undefined;
            this.regionName_Ar = _data["regionName_Ar"];
            this.lightingTypeName_Ar = _data["lightingTypeName_Ar"];
            this.operationalStatusName_Ar = _data["operationalStatusName_Ar"];
            this.maintenanceCycleName_Ar = _data["maintenanceCycleName_Ar"];
            this.serviceProviderName = _data["serviceProviderName"];
        }
    }

    static fromJS(data: any): GetStreetlightAssetInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStreetlightAssetInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetlightAssetInfo"] = this.streetlightAssetInfo ? this.streetlightAssetInfo.toJSON() : <any>undefined;
        data["regionName_Ar"] = this.regionName_Ar;
        data["lightingTypeName_Ar"] = this.lightingTypeName_Ar;
        data["operationalStatusName_Ar"] = this.operationalStatusName_Ar;
        data["maintenanceCycleName_Ar"] = this.maintenanceCycleName_Ar;
        data["serviceProviderName"] = this.serviceProviderName;
        return data;
    }
}

export interface IGetStreetlightAssetInfoForViewDto {
    streetlightAssetInfo: StreetlightAssetInfoDto;
    regionName_Ar: string | undefined;
    lightingTypeName_Ar: string | undefined;
    operationalStatusName_Ar: string | undefined;
    maintenanceCycleName_Ar: string | undefined;
    serviceProviderName: string | undefined;
}

export class GetSubActivityForEditOutput implements IGetSubActivityForEditOutput {
    subActivity!: CreateOrEditSubActivityDto;
    mainActivityName_Ar!: string | undefined;

    constructor(data?: IGetSubActivityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subActivity = _data["subActivity"] ? CreateOrEditSubActivityDto.fromJS(_data["subActivity"]) : <any>undefined;
            this.mainActivityName_Ar = _data["mainActivityName_Ar"];
        }
    }

    static fromJS(data: any): GetSubActivityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubActivityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subActivity"] = this.subActivity ? this.subActivity.toJSON() : <any>undefined;
        data["mainActivityName_Ar"] = this.mainActivityName_Ar;
        return data;
    }
}

export interface IGetSubActivityForEditOutput {
    subActivity: CreateOrEditSubActivityDto;
    mainActivityName_Ar: string | undefined;
}

export class GetSubActivityForViewDto implements IGetSubActivityForViewDto {
    subActivity!: SubActivityDto;
    mainActivityName_Ar!: string | undefined;

    constructor(data?: IGetSubActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subActivity = _data["subActivity"] ? SubActivityDto.fromJS(_data["subActivity"]) : <any>undefined;
            this.mainActivityName_Ar = _data["mainActivityName_Ar"];
        }
    }

    static fromJS(data: any): GetSubActivityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subActivity"] = this.subActivity ? this.subActivity.toJSON() : <any>undefined;
        data["mainActivityName_Ar"] = this.mainActivityName_Ar;
        return data;
    }
}

export interface IGetSubActivityForViewDto {
    subActivity: SubActivityDto;
    mainActivityName_Ar: string | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetTopicForEditOutput implements IGetTopicForEditOutput {
    topic!: CreateOrEditTopicDto;

    constructor(data?: IGetTopicForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"] ? CreateOrEditTopicDto.fromJS(_data["topic"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTopicForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopicForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTopicForEditOutput {
    topic: CreateOrEditTopicDto;
}

export class GetTopicForViewDto implements IGetTopicForViewDto {
    topic!: TopicDto;

    constructor(data?: IGetTopicForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"] ? TopicDto.fromJS(_data["topic"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTopicForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopicForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTopicForViewDto {
    topic: TopicDto;
}

export class GetTopStatsOutput implements IGetTopStatsOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;

    constructor(data?: IGetTopStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
        }
    }

    static fromJS(data: any): GetTopStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        return data;
    }
}

export interface IGetTopStatsOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
}

export class GetTrainingPackageForEditOutput implements IGetTrainingPackageForEditOutput {
    trainingPackage!: CreateOrEditTrainingPackageDto;

    constructor(data?: IGetTrainingPackageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingPackage = _data["trainingPackage"] ? CreateOrEditTrainingPackageDto.fromJS(_data["trainingPackage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTrainingPackageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrainingPackageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingPackage"] = this.trainingPackage ? this.trainingPackage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTrainingPackageForEditOutput {
    trainingPackage: CreateOrEditTrainingPackageDto;
}

export class GetTrainingPackageForViewDto implements IGetTrainingPackageForViewDto {
    trainingPackage!: TrainingPackageDto;

    constructor(data?: IGetTrainingPackageForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingPackage = _data["trainingPackage"] ? TrainingPackageDto.fromJS(_data["trainingPackage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTrainingPackageForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrainingPackageForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingPackage"] = this.trainingPackage ? this.trainingPackage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTrainingPackageForViewDto {
    trainingPackage: TrainingPackageDto;
}

export class GetTrainingPackageRequestForEditOutput implements IGetTrainingPackageRequestForEditOutput {
    trainingPackageRequest!: CreateOrEditTrainingPackageRequestDto;
    request!: RequestDto;

    constructor(data?: IGetTrainingPackageRequestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingPackageRequest = _data["trainingPackageRequest"] ? CreateOrEditTrainingPackageRequestDto.fromJS(_data["trainingPackageRequest"]) : <any>undefined;
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTrainingPackageRequestForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrainingPackageRequestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingPackageRequest"] = this.trainingPackageRequest ? this.trainingPackageRequest.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTrainingPackageRequestForEditOutput {
    trainingPackageRequest: CreateOrEditTrainingPackageRequestDto;
    request: RequestDto;
}

export class GetTrainingPackageRequestForViewDto implements IGetTrainingPackageRequestForViewDto {
    trainingPackageRequest!: TrainingPackageRequestDto;
    requestHistoryList!: RequestHistoryDto[] | undefined;
    myRequestsCount!: number;

    constructor(data?: IGetTrainingPackageRequestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingPackageRequest = _data["trainingPackageRequest"] ? TrainingPackageRequestDto.fromJS(_data["trainingPackageRequest"]) : <any>undefined;
            if (Array.isArray(_data["requestHistoryList"])) {
                this.requestHistoryList = [] as any;
                for (let item of _data["requestHistoryList"])
                    this.requestHistoryList!.push(RequestHistoryDto.fromJS(item));
            }
            this.myRequestsCount = _data["myRequestsCount"];
        }
    }

    static fromJS(data: any): GetTrainingPackageRequestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrainingPackageRequestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingPackageRequest"] = this.trainingPackageRequest ? this.trainingPackageRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.requestHistoryList)) {
            data["requestHistoryList"] = [];
            for (let item of this.requestHistoryList)
                data["requestHistoryList"].push(item.toJSON());
        }
        data["myRequestsCount"] = this.myRequestsCount;
        return data;
    }
}

export interface IGetTrainingPackageRequestForViewDto {
    trainingPackageRequest: TrainingPackageRequestDto;
    requestHistoryList: RequestHistoryDto[] | undefined;
    myRequestsCount: number;
}

export class GetTrainingRequestForEditOutput implements IGetTrainingRequestForEditOutput {
    organizationUnitHeader!: GetOrganizationUserDto;
    trainingRequest!: CreateOrEditTrainingRequestDto;
    availableSeats!: number;
    request!: RequestDto;
    courseViewDto!: GetCourseForViewDto;
    requestStatus!: RequestStatusEnum;
    organizationUnitDisplayName!: string | undefined;
    courseTermAndConditions!: string | undefined;
    requestRejectionReason!: string | undefined;
    attendeeListForView!: GetAttendeeInfoForViewDto[] | undefined;

    constructor(data?: IGetTrainingRequestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitHeader = _data["organizationUnitHeader"] ? GetOrganizationUserDto.fromJS(_data["organizationUnitHeader"]) : <any>undefined;
            this.trainingRequest = _data["trainingRequest"] ? CreateOrEditTrainingRequestDto.fromJS(_data["trainingRequest"]) : <any>undefined;
            this.availableSeats = _data["availableSeats"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.courseViewDto = _data["courseViewDto"] ? GetCourseForViewDto.fromJS(_data["courseViewDto"]) : <any>undefined;
            this.requestStatus = _data["requestStatus"];
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
            this.courseTermAndConditions = _data["courseTermAndConditions"];
            this.requestRejectionReason = _data["requestRejectionReason"];
            if (Array.isArray(_data["attendeeListForView"])) {
                this.attendeeListForView = [] as any;
                for (let item of _data["attendeeListForView"])
                    this.attendeeListForView!.push(GetAttendeeInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTrainingRequestForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrainingRequestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitHeader"] = this.organizationUnitHeader ? this.organizationUnitHeader.toJSON() : <any>undefined;
        data["trainingRequest"] = this.trainingRequest ? this.trainingRequest.toJSON() : <any>undefined;
        data["availableSeats"] = this.availableSeats;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["courseViewDto"] = this.courseViewDto ? this.courseViewDto.toJSON() : <any>undefined;
        data["requestStatus"] = this.requestStatus;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        data["courseTermAndConditions"] = this.courseTermAndConditions;
        data["requestRejectionReason"] = this.requestRejectionReason;
        if (Array.isArray(this.attendeeListForView)) {
            data["attendeeListForView"] = [];
            for (let item of this.attendeeListForView)
                data["attendeeListForView"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTrainingRequestForEditOutput {
    organizationUnitHeader: GetOrganizationUserDto;
    trainingRequest: CreateOrEditTrainingRequestDto;
    availableSeats: number;
    request: RequestDto;
    courseViewDto: GetCourseForViewDto;
    requestStatus: RequestStatusEnum;
    organizationUnitDisplayName: string | undefined;
    courseTermAndConditions: string | undefined;
    requestRejectionReason: string | undefined;
    attendeeListForView: GetAttendeeInfoForViewDto[] | undefined;
}

export class GetTrainingRequestForViewDto implements IGetTrainingRequestForViewDto {
    organizationUnitHeader!: GetOrganizationUserDto;
    trainingRequest!: TrainingRequestDto;
    requestHistoryList!: RequestHistoryDto[] | undefined;
    courseViewDto!: GetCourseForViewDto;
    attendeeListForView!: GetAttendeeInfoForViewDto[] | undefined;
    myRequestsCount!: number;
    topicName!: string | undefined;
    topicId!: number;
    topicTypeName!: string | undefined;

    constructor(data?: IGetTrainingRequestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitHeader = _data["organizationUnitHeader"] ? GetOrganizationUserDto.fromJS(_data["organizationUnitHeader"]) : <any>undefined;
            this.trainingRequest = _data["trainingRequest"] ? TrainingRequestDto.fromJS(_data["trainingRequest"]) : <any>undefined;
            if (Array.isArray(_data["requestHistoryList"])) {
                this.requestHistoryList = [] as any;
                for (let item of _data["requestHistoryList"])
                    this.requestHistoryList!.push(RequestHistoryDto.fromJS(item));
            }
            this.courseViewDto = _data["courseViewDto"] ? GetCourseForViewDto.fromJS(_data["courseViewDto"]) : <any>undefined;
            if (Array.isArray(_data["attendeeListForView"])) {
                this.attendeeListForView = [] as any;
                for (let item of _data["attendeeListForView"])
                    this.attendeeListForView!.push(GetAttendeeInfoForViewDto.fromJS(item));
            }
            this.myRequestsCount = _data["myRequestsCount"];
            this.topicName = _data["topicName"];
            this.topicId = _data["topicId"];
            this.topicTypeName = _data["topicTypeName"];
        }
    }

    static fromJS(data: any): GetTrainingRequestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrainingRequestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitHeader"] = this.organizationUnitHeader ? this.organizationUnitHeader.toJSON() : <any>undefined;
        data["trainingRequest"] = this.trainingRequest ? this.trainingRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.requestHistoryList)) {
            data["requestHistoryList"] = [];
            for (let item of this.requestHistoryList)
                data["requestHistoryList"].push(item.toJSON());
        }
        data["courseViewDto"] = this.courseViewDto ? this.courseViewDto.toJSON() : <any>undefined;
        if (Array.isArray(this.attendeeListForView)) {
            data["attendeeListForView"] = [];
            for (let item of this.attendeeListForView)
                data["attendeeListForView"].push(item.toJSON());
        }
        data["myRequestsCount"] = this.myRequestsCount;
        data["topicName"] = this.topicName;
        data["topicId"] = this.topicId;
        data["topicTypeName"] = this.topicTypeName;
        return data;
    }
}

export interface IGetTrainingRequestForViewDto {
    organizationUnitHeader: GetOrganizationUserDto;
    trainingRequest: TrainingRequestDto;
    requestHistoryList: RequestHistoryDto[] | undefined;
    courseViewDto: GetCourseForViewDto;
    attendeeListForView: GetAttendeeInfoForViewDto[] | undefined;
    myRequestsCount: number;
    topicName: string | undefined;
    topicId: number;
    topicTypeName: string | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    sectors!: UserSectorDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;
    assignedOrganizationTypeId!: number | undefined;
    assignedOrganizationUnitId!: number | undefined;
    assignedOrganizationTypeName!: string | undefined;
    assignedOrganizationUnitName!: string | undefined;
    addAsSeecAdmin!: boolean;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["sectors"])) {
                this.sectors = [] as any;
                for (let item of _data["sectors"])
                    this.sectors!.push(UserSectorDto.fromJS(item));
            }
            if (Array.isArray(_data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
            this.assignedOrganizationTypeId = _data["assignedOrganizationTypeId"];
            this.assignedOrganizationUnitId = _data["assignedOrganizationUnitId"];
            this.assignedOrganizationTypeName = _data["assignedOrganizationTypeName"];
            this.assignedOrganizationUnitName = _data["assignedOrganizationUnitName"];
            this.addAsSeecAdmin = _data["addAsSeecAdmin"];
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.sectors)) {
            data["sectors"] = [];
            for (let item of this.sectors)
                data["sectors"].push(item.toJSON());
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        data["assignedOrganizationTypeId"] = this.assignedOrganizationTypeId;
        data["assignedOrganizationUnitId"] = this.assignedOrganizationUnitId;
        data["assignedOrganizationTypeName"] = this.assignedOrganizationTypeName;
        data["assignedOrganizationUnitName"] = this.assignedOrganizationUnitName;
        data["addAsSeecAdmin"] = this.addAsSeecAdmin;
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    sectors: UserSectorDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
    assignedOrganizationTypeId: number | undefined;
    assignedOrganizationUnitId: number | undefined;
    assignedOrganizationTypeName: string | undefined;
    assignedOrganizationUnitName: string | undefined;
    addAsSeecAdmin: boolean;
}

export class GetUserForViewDto implements IGetUserForViewDto {
    user!: UserDto;
    roles!: UserRoleDto[] | undefined;
    sectors!: UserSectorDto[] | undefined;
    organizationUnitName!: string | undefined;
    organizationTypeName!: string | undefined;
    organizationTypeId!: string | undefined;
    organizationUnitGovCode!: string | undefined;
    organizationUnitCraetionDate!: string | undefined;
    sectorName_Ar!: string | undefined;
    organizationUnitId!: number;

    constructor(data?: IGetUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["sectors"])) {
                this.sectors = [] as any;
                for (let item of _data["sectors"])
                    this.sectors!.push(UserSectorDto.fromJS(item));
            }
            this.organizationUnitName = _data["organizationUnitName"];
            this.organizationTypeName = _data["organizationTypeName"];
            this.organizationTypeId = _data["organizationTypeId"];
            this.organizationUnitGovCode = _data["organizationUnitGovCode"];
            this.organizationUnitCraetionDate = _data["organizationUnitCraetionDate"];
            this.sectorName_Ar = _data["sectorName_Ar"];
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): GetUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.sectors)) {
            data["sectors"] = [];
            for (let item of this.sectors)
                data["sectors"].push(item.toJSON());
        }
        data["organizationUnitName"] = this.organizationUnitName;
        data["organizationTypeName"] = this.organizationTypeName;
        data["organizationTypeId"] = this.organizationTypeId;
        data["organizationUnitGovCode"] = this.organizationUnitGovCode;
        data["organizationUnitCraetionDate"] = this.organizationUnitCraetionDate;
        data["sectorName_Ar"] = this.sectorName_Ar;
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IGetUserForViewDto {
    user: UserDto;
    roles: UserRoleDto[] | undefined;
    sectors: UserSectorDto[] | undefined;
    organizationUnitName: string | undefined;
    organizationTypeName: string | undefined;
    organizationTypeId: string | undefined;
    organizationUnitGovCode: string | undefined;
    organizationUnitCraetionDate: string | undefined;
    sectorName_Ar: string | undefined;
    organizationUnitId: number;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetUserSectorForEditOutput implements IGetUserSectorForEditOutput {
    userSector!: CreateOrEditUserSectorDto;
    userName!: string | undefined;
    sectorName_En!: string | undefined;

    constructor(data?: IGetUserSectorForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSector = _data["userSector"] ? CreateOrEditUserSectorDto.fromJS(_data["userSector"]) : <any>undefined;
            this.userName = _data["userName"];
            this.sectorName_En = _data["sectorName_En"];
        }
    }

    static fromJS(data: any): GetUserSectorForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSectorForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSector"] = this.userSector ? this.userSector.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["sectorName_En"] = this.sectorName_En;
        return data;
    }
}

export interface IGetUserSectorForEditOutput {
    userSector: CreateOrEditUserSectorDto;
    userName: string | undefined;
    sectorName_En: string | undefined;
}

export class GetUserSectorForViewDto implements IGetUserSectorForViewDto {
    userSector!: UserSectorDto;
    userName!: string | undefined;
    sectorName_En!: string | undefined;

    constructor(data?: IGetUserSectorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSector = _data["userSector"] ? UserSectorDto.fromJS(_data["userSector"]) : <any>undefined;
            this.userName = _data["userName"];
            this.sectorName_En = _data["sectorName_En"];
        }
    }

    static fromJS(data: any): GetUserSectorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSectorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSector"] = this.userSector ? this.userSector.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["sectorName_En"] = this.sectorName_En;
        return data;
    }
}

export interface IGetUserSectorForViewDto {
    userSector: UserSectorDto;
    userName: string | undefined;
    sectorName_En: string | undefined;
}

export class GetUsersInput implements IGetUsersInput {
    organizationTypeId!: number | undefined;
    sectorId!: number | undefined;
    organizationUnitId!: number | undefined;
    isActive!: boolean | undefined;
    userName!: string | undefined;
    fullName!: string | undefined;
    phoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    filter!: string | undefined;
    permissions!: string[] | undefined;
    role!: number | undefined;
    onlyLockedUsers!: boolean;
    excludeRoleId!: number | undefined;
    sectorsIds!: string[] | undefined;
    isCurrentUserTechAdmin!: boolean;
    filterUnitIds!: string[] | undefined;
    filterSectorIds!: string[] | undefined;
    identificationNumber!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationTypeId = _data["organizationTypeId"];
            this.sectorId = _data["sectorId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.isActive = _data["isActive"];
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.role = _data["role"];
            this.onlyLockedUsers = _data["onlyLockedUsers"];
            this.excludeRoleId = _data["excludeRoleId"];
            if (Array.isArray(_data["sectorsIds"])) {
                this.sectorsIds = [] as any;
                for (let item of _data["sectorsIds"])
                    this.sectorsIds!.push(item);
            }
            this.isCurrentUserTechAdmin = _data["isCurrentUserTechAdmin"];
            if (Array.isArray(_data["filterUnitIds"])) {
                this.filterUnitIds = [] as any;
                for (let item of _data["filterUnitIds"])
                    this.filterUnitIds!.push(item);
            }
            if (Array.isArray(_data["filterSectorIds"])) {
                this.filterSectorIds = [] as any;
                for (let item of _data["filterSectorIds"])
                    this.filterSectorIds!.push(item);
            }
            this.identificationNumber = _data["identificationNumber"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationTypeId"] = this.organizationTypeId;
        data["sectorId"] = this.sectorId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["isActive"] = this.isActive;
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["filter"] = this.filter;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["role"] = this.role;
        data["onlyLockedUsers"] = this.onlyLockedUsers;
        data["excludeRoleId"] = this.excludeRoleId;
        if (Array.isArray(this.sectorsIds)) {
            data["sectorsIds"] = [];
            for (let item of this.sectorsIds)
                data["sectorsIds"].push(item);
        }
        data["isCurrentUserTechAdmin"] = this.isCurrentUserTechAdmin;
        if (Array.isArray(this.filterUnitIds)) {
            data["filterUnitIds"] = [];
            for (let item of this.filterUnitIds)
                data["filterUnitIds"].push(item);
        }
        if (Array.isArray(this.filterSectorIds)) {
            data["filterSectorIds"] = [];
            for (let item of this.filterSectorIds)
                data["filterSectorIds"].push(item);
        }
        data["identificationNumber"] = this.identificationNumber;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetUsersInput {
    organizationTypeId: number | undefined;
    sectorId: number | undefined;
    organizationUnitId: number | undefined;
    isActive: boolean | undefined;
    userName: string | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string | undefined;
    filter: string | undefined;
    permissions: string[] | undefined;
    role: number | undefined;
    onlyLockedUsers: boolean;
    excludeRoleId: number | undefined;
    sectorsIds: string[] | undefined;
    isCurrentUserTechAdmin: boolean;
    filterUnitIds: string[] | undefined;
    filterSectorIds: string[] | undefined;
    identificationNumber: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetUserSubmissionForViewDto implements IGetUserSubmissionForViewDto {
    userSubmission!: UserSubmissionDto;

    constructor(data?: IGetUserSubmissionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSubmission = _data["userSubmission"] ? UserSubmissionDto.fromJS(_data["userSubmission"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserSubmissionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSubmissionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSubmission"] = this.userSubmission ? this.userSubmission.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserSubmissionForViewDto {
    userSubmission: UserSubmissionDto;
}

export class GetVehicleInfoForEditOutput implements IGetVehicleInfoForEditOutput {
    vehicleInfo!: CreateOrEditVehicleInfoDto;
    organizationUnitDisplayName!: string | undefined;
    carModelName_Ar!: string | undefined;
    manufactureCompanyName_Ar!: string | undefined;
    fuelTypeName_Ar!: string | undefined;

    constructor(data?: IGetVehicleInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleInfo = _data["vehicleInfo"] ? CreateOrEditVehicleInfoDto.fromJS(_data["vehicleInfo"]) : <any>undefined;
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
            this.carModelName_Ar = _data["carModelName_Ar"];
            this.manufactureCompanyName_Ar = _data["manufactureCompanyName_Ar"];
            this.fuelTypeName_Ar = _data["fuelTypeName_Ar"];
        }
    }

    static fromJS(data: any): GetVehicleInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVehicleInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleInfo"] = this.vehicleInfo ? this.vehicleInfo.toJSON() : <any>undefined;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        data["carModelName_Ar"] = this.carModelName_Ar;
        data["manufactureCompanyName_Ar"] = this.manufactureCompanyName_Ar;
        data["fuelTypeName_Ar"] = this.fuelTypeName_Ar;
        return data;
    }
}

export interface IGetVehicleInfoForEditOutput {
    vehicleInfo: CreateOrEditVehicleInfoDto;
    organizationUnitDisplayName: string | undefined;
    carModelName_Ar: string | undefined;
    manufactureCompanyName_Ar: string | undefined;
    fuelTypeName_Ar: string | undefined;
}

export class GetVehicleInfoForViewDto implements IGetVehicleInfoForViewDto {
    vehicleInfo!: VehicleInfoDto;
    organizationUnitDisplayName!: string | undefined;
    carModelName_Ar!: string | undefined;
    manufactureCompanyName_Ar!: string | undefined;
    fuelTypeName_Ar!: string | undefined;

    constructor(data?: IGetVehicleInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleInfo = _data["vehicleInfo"] ? VehicleInfoDto.fromJS(_data["vehicleInfo"]) : <any>undefined;
            this.organizationUnitDisplayName = _data["organizationUnitDisplayName"];
            this.carModelName_Ar = _data["carModelName_Ar"];
            this.manufactureCompanyName_Ar = _data["manufactureCompanyName_Ar"];
            this.fuelTypeName_Ar = _data["fuelTypeName_Ar"];
        }
    }

    static fromJS(data: any): GetVehicleInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVehicleInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleInfo"] = this.vehicleInfo ? this.vehicleInfo.toJSON() : <any>undefined;
        data["organizationUnitDisplayName"] = this.organizationUnitDisplayName;
        data["carModelName_Ar"] = this.carModelName_Ar;
        data["manufactureCompanyName_Ar"] = this.manufactureCompanyName_Ar;
        data["fuelTypeName_Ar"] = this.fuelTypeName_Ar;
        return data;
    }
}

export interface IGetVehicleInfoForViewDto {
    vehicleInfo: VehicleInfoDto;
    organizationUnitDisplayName: string | undefined;
    carModelName_Ar: string | undefined;
    manufactureCompanyName_Ar: string | undefined;
    fuelTypeName_Ar: string | undefined;
}

export class GoogleExternalLoginProviderSettings implements IGoogleExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    userInfoEndpoint!: string | undefined;

    constructor(data?: IGoogleExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.userInfoEndpoint = _data["userInfoEndpoint"];
        }
    }

    static fromJS(data: any): GoogleExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["userInfoEndpoint"] = this.userInfoEndpoint;
        return data;
    }
}

export interface IGoogleExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    userInfoEndpoint: string | undefined;
}

export class GovAwarnessContentPublicationDto implements IGovAwarnessContentPublicationDto {
    id!: number;
    seecContentId!: number;
    publicationDate!: DateTime;
    publicationTypeId!: number;
    publicationDurationInDays!: number;
    seecContentNameAr!: string | undefined;
    publicationTypeNameAr!: string | undefined;
    organizationName!: string | undefined;
    contentUserName!: string | undefined;
    requestId!: number | undefined;
    request!: RequestDto;

    constructor(data?: IGovAwarnessContentPublicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seecContentId = _data["seecContentId"];
            this.publicationDate = _data["publicationDate"] ? DateTime.fromISO(_data["publicationDate"].toString()) : <any>undefined;
            this.publicationTypeId = _data["publicationTypeId"];
            this.publicationDurationInDays = _data["publicationDurationInDays"];
            this.seecContentNameAr = _data["seecContentNameAr"];
            this.publicationTypeNameAr = _data["publicationTypeNameAr"];
            this.organizationName = _data["organizationName"];
            this.contentUserName = _data["contentUserName"];
            this.requestId = _data["requestId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GovAwarnessContentPublicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GovAwarnessContentPublicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seecContentId"] = this.seecContentId;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toString() : <any>undefined;
        data["publicationTypeId"] = this.publicationTypeId;
        data["publicationDurationInDays"] = this.publicationDurationInDays;
        data["seecContentNameAr"] = this.seecContentNameAr;
        data["publicationTypeNameAr"] = this.publicationTypeNameAr;
        data["organizationName"] = this.organizationName;
        data["contentUserName"] = this.contentUserName;
        data["requestId"] = this.requestId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGovAwarnessContentPublicationDto {
    id: number;
    seecContentId: number;
    publicationDate: DateTime;
    publicationTypeId: number;
    publicationDurationInDays: number;
    seecContentNameAr: string | undefined;
    publicationTypeNameAr: string | undefined;
    organizationName: string | undefined;
    contentUserName: string | undefined;
    requestId: number | undefined;
    request: RequestDto;
}

export class GovElectricityConsumptionDto implements IGovElectricityConsumptionDto {
    key!: string | undefined;
    electricityProviderEntityId!: number;
    meterTypeId!: number;
    numberOfOwnedBuildings!: number | undefined;
    consumptionOfOwnedBuildings!: number | undefined;
    costOfOwnedBuildings!: number | undefined;
    numberOfRentedBuildings!: number | undefined;
    consumptionOfRentedBuildings!: number | undefined;
    costOfRentedBuildings!: number | undefined;
    numberOfOwnedFloors!: number | undefined;
    consumptionOfOwnedFloors!: number | undefined;
    costOfOwnedFloors!: number | undefined;
    numberOfRentedFloors!: number | undefined;
    consumptionOfRentedFloors!: number | undefined;
    costOfRentedFloors!: number | undefined;
    comment!: string | undefined;
    creatorUserId!: number | undefined;

    constructor(data?: IGovElectricityConsumptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.electricityProviderEntityId = _data["electricityProviderEntityId"];
            this.meterTypeId = _data["meterTypeId"];
            this.numberOfOwnedBuildings = _data["numberOfOwnedBuildings"];
            this.consumptionOfOwnedBuildings = _data["consumptionOfOwnedBuildings"];
            this.costOfOwnedBuildings = _data["costOfOwnedBuildings"];
            this.numberOfRentedBuildings = _data["numberOfRentedBuildings"];
            this.consumptionOfRentedBuildings = _data["consumptionOfRentedBuildings"];
            this.costOfRentedBuildings = _data["costOfRentedBuildings"];
            this.numberOfOwnedFloors = _data["numberOfOwnedFloors"];
            this.consumptionOfOwnedFloors = _data["consumptionOfOwnedFloors"];
            this.costOfOwnedFloors = _data["costOfOwnedFloors"];
            this.numberOfRentedFloors = _data["numberOfRentedFloors"];
            this.consumptionOfRentedFloors = _data["consumptionOfRentedFloors"];
            this.costOfRentedFloors = _data["costOfRentedFloors"];
            this.comment = _data["comment"];
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): GovElectricityConsumptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GovElectricityConsumptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["electricityProviderEntityId"] = this.electricityProviderEntityId;
        data["meterTypeId"] = this.meterTypeId;
        data["numberOfOwnedBuildings"] = this.numberOfOwnedBuildings;
        data["consumptionOfOwnedBuildings"] = this.consumptionOfOwnedBuildings;
        data["costOfOwnedBuildings"] = this.costOfOwnedBuildings;
        data["numberOfRentedBuildings"] = this.numberOfRentedBuildings;
        data["consumptionOfRentedBuildings"] = this.consumptionOfRentedBuildings;
        data["costOfRentedBuildings"] = this.costOfRentedBuildings;
        data["numberOfOwnedFloors"] = this.numberOfOwnedFloors;
        data["consumptionOfOwnedFloors"] = this.consumptionOfOwnedFloors;
        data["costOfOwnedFloors"] = this.costOfOwnedFloors;
        data["numberOfRentedFloors"] = this.numberOfRentedFloors;
        data["consumptionOfRentedFloors"] = this.consumptionOfRentedFloors;
        data["costOfRentedFloors"] = this.costOfRentedFloors;
        data["comment"] = this.comment;
        data["creatorUserId"] = this.creatorUserId;
        return data;
    }
}

export interface IGovElectricityConsumptionDto {
    key: string | undefined;
    electricityProviderEntityId: number;
    meterTypeId: number;
    numberOfOwnedBuildings: number | undefined;
    consumptionOfOwnedBuildings: number | undefined;
    costOfOwnedBuildings: number | undefined;
    numberOfRentedBuildings: number | undefined;
    consumptionOfRentedBuildings: number | undefined;
    costOfRentedBuildings: number | undefined;
    numberOfOwnedFloors: number | undefined;
    consumptionOfOwnedFloors: number | undefined;
    costOfOwnedFloors: number | undefined;
    numberOfRentedFloors: number | undefined;
    consumptionOfRentedFloors: number | undefined;
    costOfRentedFloors: number | undefined;
    comment: string | undefined;
    creatorUserId: number | undefined;
}

export class GovElectricityDto implements IGovElectricityDto {
    submissionCycle!: string | undefined;
    year!: string | undefined;
    requestId!: number;
    justificationId!: number | undefined;
    organizationId!: number;
    totalConsumption!: number;
    numberOfRentedBuildings!: number | undefined;
    numberOfOwnedBuildings!: number | undefined;
    numberOfOwnedFloors!: number | undefined;
    numberOfRentedFloors!: number | undefined;
    totalAmount!: number;
    requestNumber!: string | undefined;
    organizationName!: string | undefined;
    submitionDate!: DateTime | undefined;
    submittedByUserName!: string | undefined;
    submittedByPhoneNumber!: string | undefined;
    createdByUserName!: string | undefined;
    createdByPhoneNumber!: string | undefined;
    requestStatus!: number;
    requestStatusName!: string | undefined;
    hasRelatedAssets!: boolean;
    canEditConsumptionData!: boolean;
    canSelectNotApplicable!: boolean;
    isNotApplicable!: boolean;
    onTimeSubmitted!: boolean;
    claimAccountNumber!: string | undefined;
    percentageOfOwnedBuildingsToTheLastYear!: number;
    percentageOfRentedBuildingsToTheLastYear!: number;
    percentageOfOwnedFloorsToTheLastYear!: number;
    percentageOfRentedFloorsToTheLastYear!: number;
    percentageOfConsumptionToTheLastYear!: number;
    percentageOfAmountToTheLastYear!: number;
    assumptionPrice!: number;
    comment!: string | undefined;
    seecTech!: UserViewDto;
    comparisonDataDto!: ComparisonDataDto;
    govElectricityConsumptionDataList!: GovElectricityConsumptionDto[] | undefined;
    id!: number;

    constructor(data?: IGovElectricityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionCycle = _data["submissionCycle"];
            this.year = _data["year"];
            this.requestId = _data["requestId"];
            this.justificationId = _data["justificationId"];
            this.organizationId = _data["organizationId"];
            this.totalConsumption = _data["totalConsumption"];
            this.numberOfRentedBuildings = _data["numberOfRentedBuildings"];
            this.numberOfOwnedBuildings = _data["numberOfOwnedBuildings"];
            this.numberOfOwnedFloors = _data["numberOfOwnedFloors"];
            this.numberOfRentedFloors = _data["numberOfRentedFloors"];
            this.totalAmount = _data["totalAmount"];
            this.requestNumber = _data["requestNumber"];
            this.organizationName = _data["organizationName"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.submittedByUserName = _data["submittedByUserName"];
            this.submittedByPhoneNumber = _data["submittedByPhoneNumber"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdByPhoneNumber = _data["createdByPhoneNumber"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusName = _data["requestStatusName"];
            this.hasRelatedAssets = _data["hasRelatedAssets"];
            this.canEditConsumptionData = _data["canEditConsumptionData"];
            this.canSelectNotApplicable = _data["canSelectNotApplicable"];
            this.isNotApplicable = _data["isNotApplicable"];
            this.onTimeSubmitted = _data["onTimeSubmitted"];
            this.claimAccountNumber = _data["claimAccountNumber"];
            this.percentageOfOwnedBuildingsToTheLastYear = _data["percentageOfOwnedBuildingsToTheLastYear"];
            this.percentageOfRentedBuildingsToTheLastYear = _data["percentageOfRentedBuildingsToTheLastYear"];
            this.percentageOfOwnedFloorsToTheLastYear = _data["percentageOfOwnedFloorsToTheLastYear"];
            this.percentageOfRentedFloorsToTheLastYear = _data["percentageOfRentedFloorsToTheLastYear"];
            this.percentageOfConsumptionToTheLastYear = _data["percentageOfConsumptionToTheLastYear"];
            this.percentageOfAmountToTheLastYear = _data["percentageOfAmountToTheLastYear"];
            this.assumptionPrice = _data["assumptionPrice"];
            this.comment = _data["comment"];
            this.seecTech = _data["seecTech"] ? UserViewDto.fromJS(_data["seecTech"]) : <any>undefined;
            this.comparisonDataDto = _data["comparisonDataDto"] ? ComparisonDataDto.fromJS(_data["comparisonDataDto"]) : <any>undefined;
            if (Array.isArray(_data["govElectricityConsumptionDataList"])) {
                this.govElectricityConsumptionDataList = [] as any;
                for (let item of _data["govElectricityConsumptionDataList"])
                    this.govElectricityConsumptionDataList!.push(GovElectricityConsumptionDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GovElectricityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GovElectricityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionCycle"] = this.submissionCycle;
        data["year"] = this.year;
        data["requestId"] = this.requestId;
        data["justificationId"] = this.justificationId;
        data["organizationId"] = this.organizationId;
        data["totalConsumption"] = this.totalConsumption;
        data["numberOfRentedBuildings"] = this.numberOfRentedBuildings;
        data["numberOfOwnedBuildings"] = this.numberOfOwnedBuildings;
        data["numberOfOwnedFloors"] = this.numberOfOwnedFloors;
        data["numberOfRentedFloors"] = this.numberOfRentedFloors;
        data["totalAmount"] = this.totalAmount;
        data["requestNumber"] = this.requestNumber;
        data["organizationName"] = this.organizationName;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["submittedByUserName"] = this.submittedByUserName;
        data["submittedByPhoneNumber"] = this.submittedByPhoneNumber;
        data["createdByUserName"] = this.createdByUserName;
        data["createdByPhoneNumber"] = this.createdByPhoneNumber;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusName"] = this.requestStatusName;
        data["hasRelatedAssets"] = this.hasRelatedAssets;
        data["canEditConsumptionData"] = this.canEditConsumptionData;
        data["canSelectNotApplicable"] = this.canSelectNotApplicable;
        data["isNotApplicable"] = this.isNotApplicable;
        data["onTimeSubmitted"] = this.onTimeSubmitted;
        data["claimAccountNumber"] = this.claimAccountNumber;
        data["percentageOfOwnedBuildingsToTheLastYear"] = this.percentageOfOwnedBuildingsToTheLastYear;
        data["percentageOfRentedBuildingsToTheLastYear"] = this.percentageOfRentedBuildingsToTheLastYear;
        data["percentageOfOwnedFloorsToTheLastYear"] = this.percentageOfOwnedFloorsToTheLastYear;
        data["percentageOfRentedFloorsToTheLastYear"] = this.percentageOfRentedFloorsToTheLastYear;
        data["percentageOfConsumptionToTheLastYear"] = this.percentageOfConsumptionToTheLastYear;
        data["percentageOfAmountToTheLastYear"] = this.percentageOfAmountToTheLastYear;
        data["assumptionPrice"] = this.assumptionPrice;
        data["comment"] = this.comment;
        data["seecTech"] = this.seecTech ? this.seecTech.toJSON() : <any>undefined;
        data["comparisonDataDto"] = this.comparisonDataDto ? this.comparisonDataDto.toJSON() : <any>undefined;
        if (Array.isArray(this.govElectricityConsumptionDataList)) {
            data["govElectricityConsumptionDataList"] = [];
            for (let item of this.govElectricityConsumptionDataList)
                data["govElectricityConsumptionDataList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGovElectricityDto {
    submissionCycle: string | undefined;
    year: string | undefined;
    requestId: number;
    justificationId: number | undefined;
    organizationId: number;
    totalConsumption: number;
    numberOfRentedBuildings: number | undefined;
    numberOfOwnedBuildings: number | undefined;
    numberOfOwnedFloors: number | undefined;
    numberOfRentedFloors: number | undefined;
    totalAmount: number;
    requestNumber: string | undefined;
    organizationName: string | undefined;
    submitionDate: DateTime | undefined;
    submittedByUserName: string | undefined;
    submittedByPhoneNumber: string | undefined;
    createdByUserName: string | undefined;
    createdByPhoneNumber: string | undefined;
    requestStatus: number;
    requestStatusName: string | undefined;
    hasRelatedAssets: boolean;
    canEditConsumptionData: boolean;
    canSelectNotApplicable: boolean;
    isNotApplicable: boolean;
    onTimeSubmitted: boolean;
    claimAccountNumber: string | undefined;
    percentageOfOwnedBuildingsToTheLastYear: number;
    percentageOfRentedBuildingsToTheLastYear: number;
    percentageOfOwnedFloorsToTheLastYear: number;
    percentageOfRentedFloorsToTheLastYear: number;
    percentageOfConsumptionToTheLastYear: number;
    percentageOfAmountToTheLastYear: number;
    assumptionPrice: number;
    comment: string | undefined;
    seecTech: UserViewDto;
    comparisonDataDto: ComparisonDataDto;
    govElectricityConsumptionDataList: GovElectricityConsumptionDto[] | undefined;
    id: number;
}

export class GovElectricityLastYearVarianceDto implements IGovElectricityLastYearVarianceDto {
    isFirstSubmission!: boolean;
    isVariant!: boolean;
    percentageOfOwnedBuildingsToTheLastYear!: number;
    percentageOfRentedBuildingsToTheLastYear!: number;
    percentageOfOwnedFloorsToTheLastYear!: number;
    percentageOfRentedFloorsToTheLastYear!: number;
    percentageOfConsumptionToTheLastYear!: number;
    percentageOfAmountToTheLastYear!: number;

    constructor(data?: IGovElectricityLastYearVarianceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFirstSubmission = _data["isFirstSubmission"];
            this.isVariant = _data["isVariant"];
            this.percentageOfOwnedBuildingsToTheLastYear = _data["percentageOfOwnedBuildingsToTheLastYear"];
            this.percentageOfRentedBuildingsToTheLastYear = _data["percentageOfRentedBuildingsToTheLastYear"];
            this.percentageOfOwnedFloorsToTheLastYear = _data["percentageOfOwnedFloorsToTheLastYear"];
            this.percentageOfRentedFloorsToTheLastYear = _data["percentageOfRentedFloorsToTheLastYear"];
            this.percentageOfConsumptionToTheLastYear = _data["percentageOfConsumptionToTheLastYear"];
            this.percentageOfAmountToTheLastYear = _data["percentageOfAmountToTheLastYear"];
        }
    }

    static fromJS(data: any): GovElectricityLastYearVarianceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GovElectricityLastYearVarianceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFirstSubmission"] = this.isFirstSubmission;
        data["isVariant"] = this.isVariant;
        data["percentageOfOwnedBuildingsToTheLastYear"] = this.percentageOfOwnedBuildingsToTheLastYear;
        data["percentageOfRentedBuildingsToTheLastYear"] = this.percentageOfRentedBuildingsToTheLastYear;
        data["percentageOfOwnedFloorsToTheLastYear"] = this.percentageOfOwnedFloorsToTheLastYear;
        data["percentageOfRentedFloorsToTheLastYear"] = this.percentageOfRentedFloorsToTheLastYear;
        data["percentageOfConsumptionToTheLastYear"] = this.percentageOfConsumptionToTheLastYear;
        data["percentageOfAmountToTheLastYear"] = this.percentageOfAmountToTheLastYear;
        return data;
    }
}

export interface IGovElectricityLastYearVarianceDto {
    isFirstSubmission: boolean;
    isVariant: boolean;
    percentageOfOwnedBuildingsToTheLastYear: number;
    percentageOfRentedBuildingsToTheLastYear: number;
    percentageOfOwnedFloorsToTheLastYear: number;
    percentageOfRentedFloorsToTheLastYear: number;
    percentageOfConsumptionToTheLastYear: number;
    percentageOfAmountToTheLastYear: number;
}

export class GovernmentDataDto implements IGovernmentDataDto {
    submissionCycle!: string | undefined;
    year!: string | undefined;
    requestId!: number;
    organizationId!: number;
    totalConsumption!: number;
    totalBuildings!: number;
    totalAmount!: number;
    requestNumber!: string | undefined;
    organizationName!: string | undefined;
    submitionDate!: DateTime | undefined;
    submittedByUserName!: string | undefined;
    submittedByPhoneNumber!: string | undefined;
    createdByUserName!: string | undefined;
    createdByPhoneNumber!: string | undefined;
    requestStatus!: number;
    requestStatusName!: string | undefined;
    onTimeSubmitted!: boolean;
    claimAccount!: ClaimAccountDto;

    constructor(data?: IGovernmentDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionCycle = _data["submissionCycle"];
            this.year = _data["year"];
            this.requestId = _data["requestId"];
            this.organizationId = _data["organizationId"];
            this.totalConsumption = _data["totalConsumption"];
            this.totalBuildings = _data["totalBuildings"];
            this.totalAmount = _data["totalAmount"];
            this.requestNumber = _data["requestNumber"];
            this.organizationName = _data["organizationName"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.submittedByUserName = _data["submittedByUserName"];
            this.submittedByPhoneNumber = _data["submittedByPhoneNumber"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdByPhoneNumber = _data["createdByPhoneNumber"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusName = _data["requestStatusName"];
            this.onTimeSubmitted = _data["onTimeSubmitted"];
            this.claimAccount = _data["claimAccount"] ? ClaimAccountDto.fromJS(_data["claimAccount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GovernmentDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GovernmentDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionCycle"] = this.submissionCycle;
        data["year"] = this.year;
        data["requestId"] = this.requestId;
        data["organizationId"] = this.organizationId;
        data["totalConsumption"] = this.totalConsumption;
        data["totalBuildings"] = this.totalBuildings;
        data["totalAmount"] = this.totalAmount;
        data["requestNumber"] = this.requestNumber;
        data["organizationName"] = this.organizationName;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["submittedByUserName"] = this.submittedByUserName;
        data["submittedByPhoneNumber"] = this.submittedByPhoneNumber;
        data["createdByUserName"] = this.createdByUserName;
        data["createdByPhoneNumber"] = this.createdByPhoneNumber;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusName"] = this.requestStatusName;
        data["onTimeSubmitted"] = this.onTimeSubmitted;
        data["claimAccount"] = this.claimAccount ? this.claimAccount.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGovernmentDataDto {
    submissionCycle: string | undefined;
    year: string | undefined;
    requestId: number;
    organizationId: number;
    totalConsumption: number;
    totalBuildings: number;
    totalAmount: number;
    requestNumber: string | undefined;
    organizationName: string | undefined;
    submitionDate: DateTime | undefined;
    submittedByUserName: string | undefined;
    submittedByPhoneNumber: string | undefined;
    createdByUserName: string | undefined;
    createdByPhoneNumber: string | undefined;
    requestStatus: number;
    requestStatusName: string | undefined;
    onTimeSubmitted: boolean;
    claimAccount: ClaimAccountDto;
}

export class GovFuelDto implements IGovFuelDto {
    requestId!: number;
    submissionCycle!: string | undefined;
    submitionDate!: DateTime | undefined;
    submittedByUserName!: string | undefined;
    requestStatusName!: string | undefined;
    requestStatus!: number;
    requestNumber!: string | undefined;
    submittedByPhoneNumber!: string | undefined;
    createdByUserName!: string | undefined;
    createdByPhoneNumber!: string | undefined;
    onTimeSubmitted!: boolean;
    fuelSummary!: FuelConsumptionSummaryDto[] | undefined;
    fuelConsumptionData!: FuelConsumptionRecordDto[] | undefined;
    validSubmittionDate!: DateTime | undefined;
    comment!: string | undefined;
    fuelComparisonData!: FuelComparisonData;
    percentageOfConsumptionLitersToTheLastYear!: number | undefined;
    percentageOfVeiclesToTheLastYear!: number | undefined;
    noVeiclesInLastYear!: boolean;
    percentageOfEquibmentToTheLastYear!: number | undefined;
    noEquibmentInLastYear!: boolean;
    percentageOfCostToTheLastYear!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IGovFuelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.submissionCycle = _data["submissionCycle"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.submittedByUserName = _data["submittedByUserName"];
            this.requestStatusName = _data["requestStatusName"];
            this.requestStatus = _data["requestStatus"];
            this.requestNumber = _data["requestNumber"];
            this.submittedByPhoneNumber = _data["submittedByPhoneNumber"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdByPhoneNumber = _data["createdByPhoneNumber"];
            this.onTimeSubmitted = _data["onTimeSubmitted"];
            if (Array.isArray(_data["fuelSummary"])) {
                this.fuelSummary = [] as any;
                for (let item of _data["fuelSummary"])
                    this.fuelSummary!.push(FuelConsumptionSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["fuelConsumptionData"])) {
                this.fuelConsumptionData = [] as any;
                for (let item of _data["fuelConsumptionData"])
                    this.fuelConsumptionData!.push(FuelConsumptionRecordDto.fromJS(item));
            }
            this.validSubmittionDate = _data["validSubmittionDate"] ? DateTime.fromISO(_data["validSubmittionDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.fuelComparisonData = _data["fuelComparisonData"] ? FuelComparisonData.fromJS(_data["fuelComparisonData"]) : <any>undefined;
            this.percentageOfConsumptionLitersToTheLastYear = _data["percentageOfConsumptionLitersToTheLastYear"];
            this.percentageOfVeiclesToTheLastYear = _data["percentageOfVeiclesToTheLastYear"];
            this.noVeiclesInLastYear = _data["noVeiclesInLastYear"];
            this.percentageOfEquibmentToTheLastYear = _data["percentageOfEquibmentToTheLastYear"];
            this.noEquibmentInLastYear = _data["noEquibmentInLastYear"];
            this.percentageOfCostToTheLastYear = _data["percentageOfCostToTheLastYear"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GovFuelDto {
        data = typeof data === 'object' ? data : {};
        let result = new GovFuelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["submissionCycle"] = this.submissionCycle;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["submittedByUserName"] = this.submittedByUserName;
        data["requestStatusName"] = this.requestStatusName;
        data["requestStatus"] = this.requestStatus;
        data["requestNumber"] = this.requestNumber;
        data["submittedByPhoneNumber"] = this.submittedByPhoneNumber;
        data["createdByUserName"] = this.createdByUserName;
        data["createdByPhoneNumber"] = this.createdByPhoneNumber;
        data["onTimeSubmitted"] = this.onTimeSubmitted;
        if (Array.isArray(this.fuelSummary)) {
            data["fuelSummary"] = [];
            for (let item of this.fuelSummary)
                data["fuelSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.fuelConsumptionData)) {
            data["fuelConsumptionData"] = [];
            for (let item of this.fuelConsumptionData)
                data["fuelConsumptionData"].push(item.toJSON());
        }
        data["validSubmittionDate"] = this.validSubmittionDate ? this.validSubmittionDate.toString() : <any>undefined;
        data["comment"] = this.comment;
        data["fuelComparisonData"] = this.fuelComparisonData ? this.fuelComparisonData.toJSON() : <any>undefined;
        data["percentageOfConsumptionLitersToTheLastYear"] = this.percentageOfConsumptionLitersToTheLastYear;
        data["percentageOfVeiclesToTheLastYear"] = this.percentageOfVeiclesToTheLastYear;
        data["noVeiclesInLastYear"] = this.noVeiclesInLastYear;
        data["percentageOfEquibmentToTheLastYear"] = this.percentageOfEquibmentToTheLastYear;
        data["noEquibmentInLastYear"] = this.noEquibmentInLastYear;
        data["percentageOfCostToTheLastYear"] = this.percentageOfCostToTheLastYear;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGovFuelDto {
    requestId: number;
    submissionCycle: string | undefined;
    submitionDate: DateTime | undefined;
    submittedByUserName: string | undefined;
    requestStatusName: string | undefined;
    requestStatus: number;
    requestNumber: string | undefined;
    submittedByPhoneNumber: string | undefined;
    createdByUserName: string | undefined;
    createdByPhoneNumber: string | undefined;
    onTimeSubmitted: boolean;
    fuelSummary: FuelConsumptionSummaryDto[] | undefined;
    fuelConsumptionData: FuelConsumptionRecordDto[] | undefined;
    validSubmittionDate: DateTime | undefined;
    comment: string | undefined;
    fuelComparisonData: FuelComparisonData;
    percentageOfConsumptionLitersToTheLastYear: number | undefined;
    percentageOfVeiclesToTheLastYear: number | undefined;
    noVeiclesInLastYear: boolean;
    percentageOfEquibmentToTheLastYear: number | undefined;
    noEquibmentInLastYear: boolean;
    percentageOfCostToTheLastYear: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class GovFuelLastYearVarianceDto implements IGovFuelLastYearVarianceDto {
    isFirstSubmission!: boolean;
    isVariant!: boolean;
    percentageOfConsumptionLitersToTheLastYear!: number | undefined;
    percentageOfVeiclesToTheLastYear!: number | undefined;
    percentageOfEquibmentToTheLastYear!: number | undefined;
    percentageOfCostToTheLastYear!: number | undefined;

    constructor(data?: IGovFuelLastYearVarianceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFirstSubmission = _data["isFirstSubmission"];
            this.isVariant = _data["isVariant"];
            this.percentageOfConsumptionLitersToTheLastYear = _data["percentageOfConsumptionLitersToTheLastYear"];
            this.percentageOfVeiclesToTheLastYear = _data["percentageOfVeiclesToTheLastYear"];
            this.percentageOfEquibmentToTheLastYear = _data["percentageOfEquibmentToTheLastYear"];
            this.percentageOfCostToTheLastYear = _data["percentageOfCostToTheLastYear"];
        }
    }

    static fromJS(data: any): GovFuelLastYearVarianceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GovFuelLastYearVarianceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFirstSubmission"] = this.isFirstSubmission;
        data["isVariant"] = this.isVariant;
        data["percentageOfConsumptionLitersToTheLastYear"] = this.percentageOfConsumptionLitersToTheLastYear;
        data["percentageOfVeiclesToTheLastYear"] = this.percentageOfVeiclesToTheLastYear;
        data["percentageOfEquibmentToTheLastYear"] = this.percentageOfEquibmentToTheLastYear;
        data["percentageOfCostToTheLastYear"] = this.percentageOfCostToTheLastYear;
        return data;
    }
}

export interface IGovFuelLastYearVarianceDto {
    isFirstSubmission: boolean;
    isVariant: boolean;
    percentageOfConsumptionLitersToTheLastYear: number | undefined;
    percentageOfVeiclesToTheLastYear: number | undefined;
    percentageOfEquibmentToTheLastYear: number | undefined;
    percentageOfCostToTheLastYear: number | undefined;
}

export class GovFuelRequestLookupTableDto implements IGovFuelRequestLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGovFuelRequestLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): GovFuelRequestLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GovFuelRequestLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGovFuelRequestLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class HistoricalConsumptionInfoDto implements IHistoricalConsumptionInfoDto {
    organizationUnitId!: number | undefined;
    year!: number;
    fuelConsumptionJson!: FuelConsumptionJson[] | undefined;
    electricityCycle1Json!: ElectricityCycleConsumptionJson[] | undefined;
    electricityCycle2Json!: ElectricityCycleConsumptionJson[] | undefined;

    constructor(data?: IHistoricalConsumptionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.year = _data["year"];
            if (Array.isArray(_data["fuelConsumptionJson"])) {
                this.fuelConsumptionJson = [] as any;
                for (let item of _data["fuelConsumptionJson"])
                    this.fuelConsumptionJson!.push(FuelConsumptionJson.fromJS(item));
            }
            if (Array.isArray(_data["electricityCycle1Json"])) {
                this.electricityCycle1Json = [] as any;
                for (let item of _data["electricityCycle1Json"])
                    this.electricityCycle1Json!.push(ElectricityCycleConsumptionJson.fromJS(item));
            }
            if (Array.isArray(_data["electricityCycle2Json"])) {
                this.electricityCycle2Json = [] as any;
                for (let item of _data["electricityCycle2Json"])
                    this.electricityCycle2Json!.push(ElectricityCycleConsumptionJson.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HistoricalConsumptionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalConsumptionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["year"] = this.year;
        if (Array.isArray(this.fuelConsumptionJson)) {
            data["fuelConsumptionJson"] = [];
            for (let item of this.fuelConsumptionJson)
                data["fuelConsumptionJson"].push(item.toJSON());
        }
        if (Array.isArray(this.electricityCycle1Json)) {
            data["electricityCycle1Json"] = [];
            for (let item of this.electricityCycle1Json)
                data["electricityCycle1Json"].push(item.toJSON());
        }
        if (Array.isArray(this.electricityCycle2Json)) {
            data["electricityCycle2Json"] = [];
            for (let item of this.electricityCycle2Json)
                data["electricityCycle2Json"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHistoricalConsumptionInfoDto {
    organizationUnitId: number | undefined;
    year: number;
    fuelConsumptionJson: FuelConsumptionJson[] | undefined;
    electricityCycle1Json: ElectricityCycleConsumptionJson[] | undefined;
    electricityCycle2Json: ElectricityCycleConsumptionJson[] | undefined;
}

export class HomeAboutDto implements IHomeAboutDto {
    centerPrefDescription!: string | undefined;
    aboutProgramDescription!: string | undefined;
    technicalSideDescription!: string | undefined;
    awarenessSideDescription!: string | undefined;
    traningSideDescription!: string | undefined;
    isPublished!: boolean;
    publishDate!: DateTime | undefined;
    version!: number;
    isLatest!: boolean;

    constructor(data?: IHomeAboutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.centerPrefDescription = _data["centerPrefDescription"];
            this.aboutProgramDescription = _data["aboutProgramDescription"];
            this.technicalSideDescription = _data["technicalSideDescription"];
            this.awarenessSideDescription = _data["awarenessSideDescription"];
            this.traningSideDescription = _data["traningSideDescription"];
            this.isPublished = _data["isPublished"];
            this.publishDate = _data["publishDate"] ? DateTime.fromISO(_data["publishDate"].toString()) : <any>undefined;
            this.version = _data["version"];
            this.isLatest = _data["isLatest"];
        }
    }

    static fromJS(data: any): HomeAboutDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeAboutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["centerPrefDescription"] = this.centerPrefDescription;
        data["aboutProgramDescription"] = this.aboutProgramDescription;
        data["technicalSideDescription"] = this.technicalSideDescription;
        data["awarenessSideDescription"] = this.awarenessSideDescription;
        data["traningSideDescription"] = this.traningSideDescription;
        data["isPublished"] = this.isPublished;
        data["publishDate"] = this.publishDate ? this.publishDate.toString() : <any>undefined;
        data["version"] = this.version;
        data["isLatest"] = this.isLatest;
        return data;
    }
}

export interface IHomeAboutDto {
    centerPrefDescription: string | undefined;
    aboutProgramDescription: string | undefined;
    technicalSideDescription: string | undefined;
    awarenessSideDescription: string | undefined;
    traningSideDescription: string | undefined;
    isPublished: boolean;
    publishDate: DateTime | undefined;
    version: number;
    isLatest: boolean;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto;
    otherSettings!: OtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? OtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    otherSettings: OtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    useCaptchaOnLogin!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    useCaptchaOnLogin: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class HttpContent implements IHttpContent {
    readonly headers!: KeyValuePairOfStringIEnumerableOfString[] | undefined;

    constructor(data?: IHttpContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(KeyValuePairOfStringIEnumerableOfString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HttpContent {
        data = typeof data === 'object' ? data : {};
        let result = new HttpContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHttpContent {
    headers: KeyValuePairOfStringIEnumerableOfString[] | undefined;
}

export class HttpMethod implements IHttpMethod {
    method!: string | undefined;

    constructor(data?: IHttpMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
        }
    }

    static fromJS(data: any): HttpMethod {
        data = typeof data === 'object' ? data : {};
        let result = new HttpMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        return data;
    }
}

export interface IHttpMethod {
    method: string | undefined;
}

export class HttpRequestMessage implements IHttpRequestMessage {
    version!: string | undefined;
    versionPolicy!: HttpVersionPolicy;
    content!: HttpContent;
    method!: HttpMethod;
    requestUri!: string | undefined;
    readonly headers!: KeyValuePairOfStringIEnumerableOfString[] | undefined;
    readonly properties!: { [key: string]: any; } | undefined;
    readonly options!: { [key: string]: any; } | undefined;

    constructor(data?: IHttpRequestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.versionPolicy = _data["versionPolicy"];
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.method = _data["method"] ? HttpMethod.fromJS(_data["method"]) : <any>undefined;
            this.requestUri = _data["requestUri"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(KeyValuePairOfStringIEnumerableOfString.fromJS(item));
            }
            if (_data["properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)![key] = _data["properties"][key];
                }
            }
            if (_data["options"]) {
                (<any>this).options = {} as any;
                for (let key in _data["options"]) {
                    if (_data["options"].hasOwnProperty(key))
                        (<any>(<any>this).options)![key] = _data["options"][key];
                }
            }
        }
    }

    static fromJS(data: any): HttpRequestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["versionPolicy"] = this.versionPolicy;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["requestUri"] = this.requestUri;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        if (this.options) {
            data["options"] = {};
            for (let key in this.options) {
                if (this.options.hasOwnProperty(key))
                    (<any>data["options"])[key] = (<any>this.options)[key];
            }
        }
        return data;
    }
}

export interface IHttpRequestMessage {
    version: string | undefined;
    versionPolicy: HttpVersionPolicy;
    content: HttpContent;
    method: HttpMethod;
    requestUri: string | undefined;
    headers: KeyValuePairOfStringIEnumerableOfString[] | undefined;
    properties: { [key: string]: any; } | undefined;
    options: { [key: string]: any; } | undefined;
}

export class HttpResponseMessage implements IHttpResponseMessage {
    version!: string | undefined;
    content!: HttpContent;
    statusCode!: HttpStatusCode;
    reasonPhrase!: string | undefined;
    readonly headers!: KeyValuePairOfStringIEnumerableOfString[] | undefined;
    readonly trailingHeaders!: KeyValuePairOfStringIEnumerableOfString[] | undefined;
    requestMessage!: HttpRequestMessage;
    readonly isSuccessStatusCode!: boolean;

    constructor(data?: IHttpResponseMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            this.reasonPhrase = _data["reasonPhrase"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(KeyValuePairOfStringIEnumerableOfString.fromJS(item));
            }
            if (Array.isArray(_data["trailingHeaders"])) {
                (<any>this).trailingHeaders = [] as any;
                for (let item of _data["trailingHeaders"])
                    (<any>this).trailingHeaders!.push(KeyValuePairOfStringIEnumerableOfString.fromJS(item));
            }
            this.requestMessage = _data["requestMessage"] ? HttpRequestMessage.fromJS(_data["requestMessage"]) : <any>undefined;
            (<any>this).isSuccessStatusCode = _data["isSuccessStatusCode"];
        }
    }

    static fromJS(data: any): HttpResponseMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpResponseMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["reasonPhrase"] = this.reasonPhrase;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (Array.isArray(this.trailingHeaders)) {
            data["trailingHeaders"] = [];
            for (let item of this.trailingHeaders)
                data["trailingHeaders"].push(item.toJSON());
        }
        data["requestMessage"] = this.requestMessage ? this.requestMessage.toJSON() : <any>undefined;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        return data;
    }
}

export interface IHttpResponseMessage {
    version: string | undefined;
    content: HttpContent;
    statusCode: HttpStatusCode;
    reasonPhrase: string | undefined;
    headers: KeyValuePairOfStringIEnumerableOfString[] | undefined;
    trailingHeaders: KeyValuePairOfStringIEnumerableOfString[] | undefined;
    requestMessage: HttpRequestMessage;
    isSuccessStatusCode: boolean;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 301,
    MovedPermanently = 302,
    Moved = 303,
    Found = 304,
    Redirect = 305,
    SeeOther = 306,
    RedirectMethod = 307,
    NotModified = 308,
    UseProxy = 400,
    Unused = 401,
    TemporaryRedirect = 402,
    RedirectKeepVerb = 403,
    PermanentRedirect = 404,
    BadRequest = 405,
    Unauthorized = 406,
    PaymentRequired = 407,
    Forbidden = 408,
    NotFound = 409,
    MethodNotAllowed = 410,
    NotAcceptable = 411,
    ProxyAuthenticationRequired = 412,
    RequestTimeout = 413,
    Conflict = 414,
    Gone = 415,
    LengthRequired = 416,
    PreconditionFailed = 417,
    RequestEntityTooLarge = 421,
    RequestUriTooLong = 422,
    UnsupportedMediaType = 423,
    RequestedRangeNotSatisfiable = 424,
    ExpectationFailed = 426,
    MisdirectedRequest = 428,
    UnprocessableEntity = 429,
    Locked = 431,
    FailedDependency = 451,
    UpgradeRequired = 500,
    PreconditionRequired = 501,
    TooManyRequests = 502,
    RequestHeaderFieldsTooLarge = 503,
    UnavailableForLegalReasons = 504,
    InternalServerError = 505,
    NotImplemented = 506,
    BadGateway = 507,
    ServiceUnavailable = 508,
    GatewayTimeout = 510,
    HttpVersionNotSupported = 511,
}

export enum HttpVersionPolicy {
    RequestVersionOrLower = 0,
    RequestVersionOrHigher = 1,
    RequestVersionExact = 2,
}

export class IdentificationAuthModel implements IIdentificationAuthModel {
    identificationNumber!: string;
    providerName!: string | undefined;

    constructor(data?: IIdentificationAuthModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identificationNumber = _data["identificationNumber"];
            this.providerName = _data["providerName"];
        }
    }

    static fromJS(data: any): IdentificationAuthModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdentificationAuthModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identificationNumber"] = this.identificationNumber;
        data["providerName"] = this.providerName;
        return data;
    }
}

export interface IIdentificationAuthModel {
    identificationNumber: string;
    providerName: string | undefined;
}

export class IdentitifcationAuthResultModel implements IIdentitifcationAuthResultModel {
    userId!: number;
    requireOtpVerification!: boolean;
    message!: string | undefined;
    otp!: string | undefined;

    constructor(data?: IIdentitifcationAuthResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.requireOtpVerification = _data["requireOtpVerification"];
            this.message = _data["message"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): IdentitifcationAuthResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdentitifcationAuthResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["requireOtpVerification"] = this.requireOtpVerification;
        data["message"] = this.message;
        data["otp"] = this.otp;
        return data;
    }
}

export interface IIdentitifcationAuthResultModel {
    userId: number;
    requireOtpVerification: boolean;
    message: string | undefined;
    otp: string | undefined;
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class ImpersonateTenantInput implements IImpersonateTenantInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateTenantInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateUserInput implements IImpersonateUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: DateTime;
    amount!: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: DateTime;
    amount: number;
}

export class InstallDto implements IInstallDto {
    connectionString!: string;
    adminPassword!: string;
    webSiteUrl!: string;
    serverUrl!: string | undefined;
    defaultLanguage!: string;
    smtpSettings!: EmailSettingsEditDto;
    billInfo!: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["connectionString"];
            this.adminPassword = _data["adminPassword"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverUrl = _data["serverUrl"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.smtpSettings = _data["smtpSettings"] ? EmailSettingsEditDto.fromJS(_data["smtpSettings"]) : <any>undefined;
            this.billInfo = _data["billInfo"] ? HostBillingSettingsEditDto.fromJS(_data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class JsonClaimMapDto implements IJsonClaimMapDto {
    claim!: string | undefined;
    key!: string | undefined;

    constructor(data?: IJsonClaimMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claim = _data["claim"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): JsonClaimMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonClaimMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claim"] = this.claim;
        data["key"] = this.key;
        return data;
    }
}

export interface IJsonClaimMapDto {
    claim: string | undefined;
    key: string | undefined;
}

export class KeyValuePairOfStringIEnumerableOfString implements IKeyValuePairOfStringIEnumerableOfString {
    key!: string | undefined;
    value!: string[] | undefined;

    constructor(data?: IKeyValuePairOfStringIEnumerableOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): KeyValuePairOfStringIEnumerableOfString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringIEnumerableOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IKeyValuePairOfStringIEnumerableOfString {
    key: string | undefined;
    value: string[] | undefined;
}

export enum KnowledgeBankCategory {
    Regulations = 1,
    Laws = 2,
    Guidelines = 3,
}

export class KnowledgeBankDto implements IKnowledgeBankDto {
    title!: string | undefined;
    description!: string | undefined;
    attachmnets!: string | undefined;
    category!: KnowledgeBankCategory;
    publishState!: KnowledgeBankPublishStatus;
    publishStateDate!: DateTime | undefined;
    publishStateChangeBy!: UserInfoDto;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    isFeatured!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IKnowledgeBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.attachmnets = _data["attachmnets"];
            this.category = _data["category"];
            this.publishState = _data["publishState"];
            this.publishStateDate = _data["publishStateDate"] ? DateTime.fromISO(_data["publishStateDate"].toString()) : <any>undefined;
            this.publishStateChangeBy = _data["publishStateChangeBy"] ? UserInfoDto.fromJS(_data["publishStateChangeBy"]) : <any>undefined;
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.isFeatured = _data["isFeatured"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): KnowledgeBankDto {
        data = typeof data === 'object' ? data : {};
        let result = new KnowledgeBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["attachmnets"] = this.attachmnets;
        data["category"] = this.category;
        data["publishState"] = this.publishState;
        data["publishStateDate"] = this.publishStateDate ? this.publishStateDate.toString() : <any>undefined;
        data["publishStateChangeBy"] = this.publishStateChangeBy ? this.publishStateChangeBy.toJSON() : <any>undefined;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["isFeatured"] = this.isFeatured;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IKnowledgeBankDto {
    title: string | undefined;
    description: string | undefined;
    attachmnets: string | undefined;
    category: KnowledgeBankCategory;
    publishState: KnowledgeBankPublishStatus;
    publishStateDate: DateTime | undefined;
    publishStateChangeBy: UserInfoDto;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    isFeatured: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum KnowledgeBankPublishStatus {
    Draft = 1,
    Published = 2,
    UnPublished = 3,
    RePublish = 4,
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    id!: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.username = _data["username"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data;
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string;
    password!: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class LookupDto implements ILookupDto {
    id!: number;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: ILookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): LookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface ILookupDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
}

export class LookupMapperDto implements ILookupMapperDto {
    id!: number;
    name_En!: string | undefined;
    name_Ar!: string | undefined;
    description!: string | undefined;
    code!: string | undefined;

    constructor(data?: ILookupMapperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name_En = _data["name_En"];
            this.name_Ar = _data["name_Ar"];
            this.description = _data["description"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): LookupMapperDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupMapperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name_En"] = this.name_En;
        data["name_Ar"] = this.name_Ar;
        data["description"] = this.description;
        data["code"] = this.code;
        return data;
    }
}

export interface ILookupMapperDto {
    id: number;
    name_En: string | undefined;
    name_Ar: string | undefined;
    description: string | undefined;
    code: string | undefined;
}

export class MainActivityDto implements IMainActivityDto {
    name_Ar!: string | undefined;
    subActivities!: SubActivityDto[] | undefined;
    id!: number;

    constructor(data?: IMainActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name_Ar = _data["name_Ar"];
            if (Array.isArray(_data["subActivities"])) {
                this.subActivities = [] as any;
                for (let item of _data["subActivities"])
                    this.subActivities!.push(SubActivityDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MainActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new MainActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name_Ar"] = this.name_Ar;
        if (Array.isArray(this.subActivities)) {
            data["subActivities"] = [];
            for (let item of this.subActivities)
                data["subActivities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMainActivityDto {
    name_Ar: string | undefined;
    subActivities: SubActivityDto[] | undefined;
    id: number;
}

export enum MediaCenterCategory {
    News = 1,
    Events = 2,
    MediaLibrary = 3,
}

export class MediaCenterDto implements IMediaCenterDto {
    title!: string | undefined;
    date!: DateTime;
    summery!: string | undefined;
    content!: string | undefined;
    category!: MediaCenterCategory;
    vidioAttachments!: string | undefined;
    imageAttachments!: string | undefined;
    publishState!: MediaCenterPublishStatus;
    publishStateDate!: DateTime | undefined;
    publishStateChangeBy!: UserInfoDto;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    isFeatured!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IMediaCenterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.summery = _data["summery"];
            this.content = _data["content"];
            this.category = _data["category"];
            this.vidioAttachments = _data["vidioAttachments"];
            this.imageAttachments = _data["imageAttachments"];
            this.publishState = _data["publishState"];
            this.publishStateDate = _data["publishStateDate"] ? DateTime.fromISO(_data["publishStateDate"].toString()) : <any>undefined;
            this.publishStateChangeBy = _data["publishStateChangeBy"] ? UserInfoDto.fromJS(_data["publishStateChangeBy"]) : <any>undefined;
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.isFeatured = _data["isFeatured"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MediaCenterDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaCenterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["summery"] = this.summery;
        data["content"] = this.content;
        data["category"] = this.category;
        data["vidioAttachments"] = this.vidioAttachments;
        data["imageAttachments"] = this.imageAttachments;
        data["publishState"] = this.publishState;
        data["publishStateDate"] = this.publishStateDate ? this.publishStateDate.toString() : <any>undefined;
        data["publishStateChangeBy"] = this.publishStateChangeBy ? this.publishStateChangeBy.toJSON() : <any>undefined;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["isFeatured"] = this.isFeatured;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMediaCenterDto {
    title: string | undefined;
    date: DateTime;
    summery: string | undefined;
    content: string | undefined;
    category: MediaCenterCategory;
    vidioAttachments: string | undefined;
    imageAttachments: string | undefined;
    publishState: MediaCenterPublishStatus;
    publishStateDate: DateTime | undefined;
    publishStateChangeBy: UserInfoDto;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    isFeatured: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum MediaCenterPublishStatus {
    Draft = 1,
    Published = 2,
    UnPublished = 3,
    RePublish = 4,
}

export class MediaLibraryInputDto implements IMediaLibraryInputDto {
    fileName!: string | undefined;
    fileMimeType!: string | undefined;
    fileContent!: string | undefined;
    fileSize!: number;
    entityRefrenaceId!: string | undefined;

    constructor(data?: IMediaLibraryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileMimeType = _data["fileMimeType"];
            this.fileContent = _data["fileContent"];
            this.fileSize = _data["fileSize"];
            this.entityRefrenaceId = _data["entityRefrenaceId"];
        }
    }

    static fromJS(data: any): MediaLibraryInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLibraryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileMimeType"] = this.fileMimeType;
        data["fileContent"] = this.fileContent;
        data["fileSize"] = this.fileSize;
        data["entityRefrenaceId"] = this.entityRefrenaceId;
        return data;
    }
}

export interface IMediaLibraryInputDto {
    fileName: string | undefined;
    fileMimeType: string | undefined;
    fileContent: string | undefined;
    fileSize: number;
    entityRefrenaceId: string | undefined;
}

export class MediaLibraryModel implements IMediaLibraryModel {
    fileToken!: string;
    fileName!: string | undefined;
    fileMimeType!: string | undefined;
    fileSize!: number;
    fileContent!: string | undefined;

    constructor(data?: IMediaLibraryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.fileName = _data["fileName"];
            this.fileMimeType = _data["fileMimeType"];
            this.fileSize = _data["fileSize"];
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): MediaLibraryModel {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLibraryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["fileName"] = this.fileName;
        data["fileMimeType"] = this.fileMimeType;
        data["fileSize"] = this.fileSize;
        data["fileContent"] = this.fileContent;
        return data;
    }
}

export interface IMediaLibraryModel {
    fileToken: string;
    fileName: string | undefined;
    fileMimeType: string | undefined;
    fileSize: number;
    fileContent: string | undefined;
}

export class MediaLibraryOutputDto implements IMediaLibraryOutputDto {
    fileToken!: string;
    mimeType!: string | undefined;
    fileName!: string | undefined;

    constructor(data?: IMediaLibraryOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.mimeType = _data["mimeType"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): MediaLibraryOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLibraryOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["mimeType"] = this.mimeType;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IMediaLibraryOutputDto {
    fileToken: string;
    mimeType: string | undefined;
    fileName: string | undefined;
}

export class MemberActivity implements IMemberActivity {
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number;
    closed!: number;
    rate!: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.earnings = _data["earnings"];
            this.cases = _data["cases"];
            this.closed = _data["closed"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number;
    closed: number;
    rate: string | undefined;
}

export class MemberDto implements IMemberDto {
    userId!: number | undefined;
    surname!: string;
    emailAddress!: string | undefined;
    userName!: string | undefined;
    phoneNumber!: string | undefined;
    roleId!: number | undefined;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    organizationUnitId!: number | undefined;
    isActive!: boolean | undefined;
    identificationNumber!: string | undefined;

    constructor(data?: IMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.isActive = _data["isActive"];
            this.identificationNumber = _data["identificationNumber"];
        }
    }

    static fromJS(data: any): MemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["organizationUnitId"] = this.organizationUnitId;
        data["isActive"] = this.isActive;
        data["identificationNumber"] = this.identificationNumber;
        return data;
    }
}

export interface IMemberDto {
    userId: number | undefined;
    surname: string;
    emailAddress: string | undefined;
    userName: string | undefined;
    phoneNumber: string | undefined;
    roleId: number | undefined;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    organizationUnitId: number | undefined;
    isActive: boolean | undefined;
    identificationNumber: string | undefined;
}

export class MeterInfoDto implements IMeterInfoDto {
    meterNumber!: string | undefined;
    premiseId!: number | undefined;
    contractAccount!: number | undefined;
    subscriptionNumber!: string | undefined;
    organizationUnitId!: number | undefined;
    id!: number;

    constructor(data?: IMeterInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meterNumber = _data["meterNumber"];
            this.premiseId = _data["premiseId"];
            this.contractAccount = _data["contractAccount"];
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeterInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeterInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meterNumber"] = this.meterNumber;
        data["premiseId"] = this.premiseId;
        data["contractAccount"] = this.contractAccount;
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMeterInfoDto {
    meterNumber: string | undefined;
    premiseId: number | undefined;
    contractAccount: number | undefined;
    subscriptionNumber: string | undefined;
    organizationUnitId: number | undefined;
    id: number;
}

export class MeterInfoOrganizationUnitLookupTableDto implements IMeterInfoOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMeterInfoOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): MeterInfoOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeterInfoOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IMeterInfoOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class MicrosoftExternalLoginProviderSettings implements IMicrosoftExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IMicrosoftExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): MicrosoftExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IMicrosoftExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class MisMatchedItem implements IMisMatchedItem {
    property!: string | undefined;
    oldValue!: string | undefined;
    newValue!: string | undefined;
    recordIndex!: number;

    constructor(data?: IMisMatchedItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.recordIndex = _data["recordIndex"];
        }
    }

    static fromJS(data: any): MisMatchedItem {
        data = typeof data === 'object' ? data : {};
        let result = new MisMatchedItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["recordIndex"] = this.recordIndex;
        return data;
    }
}

export interface IMisMatchedItem {
    property: string | undefined;
    oldValue: string | undefined;
    newValue: string | undefined;
    recordIndex: number;
}

export class MonthTotal implements IMonthTotal {
    month!: number;
    totalConsumption!: number;
    totalAmount!: number;

    constructor(data?: IMonthTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.totalConsumption = _data["totalConsumption"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): MonthTotal {
        data = typeof data === 'object' ? data : {};
        let result = new MonthTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["totalConsumption"] = this.totalConsumption;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

export interface IMonthTotal {
    month: number;
    totalConsumption: number;
    totalAmount: number;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEditionId = _data["sourceEditionId"];
            this.targetEditionId = _data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export class NafathExchangeInput implements INafathExchangeInput {
    state!: string | undefined;

    constructor(data?: INafathExchangeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): NafathExchangeInput {
        data = typeof data === 'object' ? data : {};
        let result = new NafathExchangeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        return data;
    }
}

export interface INafathExchangeInput {
    state: string | undefined;
}

export class NafathLoginUrlResponse implements INafathLoginUrlResponse {
    id!: string | undefined;
    url!: string | undefined;
    hasedState!: string | undefined;
    requestId!: string | undefined;

    constructor(data?: INafathLoginUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.hasedState = _data["hasedState"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): NafathLoginUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NafathLoginUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["hasedState"] = this.hasedState;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface INafathLoginUrlResponse {
    id: string | undefined;
    url: string | undefined;
    hasedState: string | undefined;
    requestId: string | undefined;
}

export class NafathStatusResponse implements INafathStatusResponse {
    status!: string | undefined;
    claims!: NafathUserClaims;

    constructor(data?: INafathStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.claims = _data["claims"] ? NafathUserClaims.fromJS(_data["claims"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NafathStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NafathStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["claims"] = this.claims ? this.claims.toJSON() : <any>undefined;
        return data;
    }
}

export interface INafathStatusResponse {
    status: string | undefined;
    claims: NafathUserClaims;
}

export class NafathUserClaims implements INafathUserClaims {
    nationalId!: string | undefined;
    arabicName!: string | undefined;
    englishName!: string | undefined;
    arabicFirstName!: string | undefined;
    englishFirstName!: string | undefined;
    arabicFamilyName!: string | undefined;
    englishFamilyName!: string | undefined;
    gender!: string | undefined;
    dateOfBirth!: string | undefined;
    nationality!: string | undefined;
    nationalityCode!: string | undefined;
    lang!: string | undefined;

    constructor(data?: INafathUserClaims) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nationalId = _data["nationalId"];
            this.arabicName = _data["arabicName"];
            this.englishName = _data["englishName"];
            this.arabicFirstName = _data["arabicFirstName"];
            this.englishFirstName = _data["englishFirstName"];
            this.arabicFamilyName = _data["arabicFamilyName"];
            this.englishFamilyName = _data["englishFamilyName"];
            this.gender = _data["gender"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.nationality = _data["nationality"];
            this.nationalityCode = _data["nationalityCode"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): NafathUserClaims {
        data = typeof data === 'object' ? data : {};
        let result = new NafathUserClaims();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nationalId"] = this.nationalId;
        data["arabicName"] = this.arabicName;
        data["englishName"] = this.englishName;
        data["arabicFirstName"] = this.arabicFirstName;
        data["englishFirstName"] = this.englishFirstName;
        data["arabicFamilyName"] = this.arabicFamilyName;
        data["englishFamilyName"] = this.englishFamilyName;
        data["gender"] = this.gender;
        data["dateOfBirth"] = this.dateOfBirth;
        data["nationality"] = this.nationality;
        data["nationalityCode"] = this.nationalityCode;
        data["lang"] = this.lang;
        return data;
    }
}

export interface INafathUserClaims {
    nationalId: string | undefined;
    arabicName: string | undefined;
    englishName: string | undefined;
    arabicFirstName: string | undefined;
    englishFirstName: string | undefined;
    arabicFamilyName: string | undefined;
    englishFamilyName: string | undefined;
    gender: string | undefined;
    dateOfBirth: string | undefined;
    nationality: string | undefined;
    nationalityCode: string | undefined;
    lang: string | undefined;
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class NewsDto implements INewsDto {
    newsTitle!: string | undefined;
    importanceType!: NewsImportanceType;
    publishState!: NewsPublishState;
    newsBody!: string | undefined;
    newsImageId!: string | undefined;
    newsVideoId!: string | undefined;
    publishStateDate!: DateTime | undefined;
    publishStateChangeBy!: UserInfoDto;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    currentVersion!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: string;

    constructor(data?: INewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newsTitle = _data["newsTitle"];
            this.importanceType = _data["importanceType"];
            this.publishState = _data["publishState"];
            this.newsBody = _data["newsBody"];
            this.newsImageId = _data["newsImageId"];
            this.newsVideoId = _data["newsVideoId"];
            this.publishStateDate = _data["publishStateDate"] ? DateTime.fromISO(_data["publishStateDate"].toString()) : <any>undefined;
            this.publishStateChangeBy = _data["publishStateChangeBy"] ? UserInfoDto.fromJS(_data["publishStateChangeBy"]) : <any>undefined;
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.currentVersion = _data["currentVersion"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsTitle"] = this.newsTitle;
        data["importanceType"] = this.importanceType;
        data["publishState"] = this.publishState;
        data["newsBody"] = this.newsBody;
        data["newsImageId"] = this.newsImageId;
        data["newsVideoId"] = this.newsVideoId;
        data["publishStateDate"] = this.publishStateDate ? this.publishStateDate.toString() : <any>undefined;
        data["publishStateChangeBy"] = this.publishStateChangeBy ? this.publishStateChangeBy.toJSON() : <any>undefined;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["currentVersion"] = this.currentVersion;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface INewsDto {
    newsTitle: string | undefined;
    importanceType: NewsImportanceType;
    publishState: NewsPublishState;
    newsBody: string | undefined;
    newsImageId: string | undefined;
    newsVideoId: string | undefined;
    publishStateDate: DateTime | undefined;
    publishStateChangeBy: UserInfoDto;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    currentVersion: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: string;
}

export enum NewsImportanceType {
    Important = 1,
    NotImportant = 2,
}

export enum NewsPublishState {
    Draft = 1,
    Published = 2,
    UnPublished = 3,
    RePublish = 4,
}

export class NewsVersionDto implements INewsVersionDto {
    newsId!: string;
    newsTitle!: string | undefined;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    importanceType!: NewsImportanceType;
    newsBody!: string | undefined;
    newsVersionImageId!: string | undefined;
    newsVersionVideoId!: string | undefined;
    version!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: string;

    constructor(data?: INewsVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newsId = _data["newsId"];
            this.newsTitle = _data["newsTitle"];
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.importanceType = _data["importanceType"];
            this.newsBody = _data["newsBody"];
            this.newsVersionImageId = _data["newsVersionImageId"];
            this.newsVersionVideoId = _data["newsVersionVideoId"];
            this.version = _data["version"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NewsVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsId"] = this.newsId;
        data["newsTitle"] = this.newsTitle;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["importanceType"] = this.importanceType;
        data["newsBody"] = this.newsBody;
        data["newsVersionImageId"] = this.newsVersionImageId;
        data["newsVersionVideoId"] = this.newsVersionVideoId;
        data["version"] = this.version;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface INewsVersionDto {
    newsId: string;
    newsTitle: string | undefined;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    importanceType: NewsImportanceType;
    newsBody: string | undefined;
    newsVersionImageId: string | undefined;
    newsVersionVideoId: string | undefined;
    version: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: string;
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export class NotificationLogDto implements INotificationLogDto {
    message!: string | undefined;
    messageTemplate!: string | undefined;
    level!: string | undefined;
    timeStamp!: DateTime;
    exception!: string | undefined;
    properties!: string | undefined;
    logEvent!: string | undefined;
    id!: number;

    constructor(data?: INotificationLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.messageTemplate = _data["messageTemplate"];
            this.level = _data["level"];
            this.timeStamp = _data["timeStamp"] ? DateTime.fromISO(_data["timeStamp"].toString()) : <any>undefined;
            this.exception = _data["exception"];
            this.properties = _data["properties"];
            this.logEvent = _data["logEvent"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NotificationLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["messageTemplate"] = this.messageTemplate;
        data["level"] = this.level;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toString() : <any>undefined;
        data["exception"] = this.exception;
        data["properties"] = this.properties;
        data["logEvent"] = this.logEvent;
        data["id"] = this.id;
        return data;
    }
}

export interface INotificationLogDto {
    message: string | undefined;
    messageTemplate: string | undefined;
    level: string | undefined;
    timeStamp: DateTime;
    exception: string | undefined;
    properties: string | undefined;
    logEvent: string | undefined;
    id: number;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;
}

export class OpenIdConnectExternalLoginProviderSettings implements IOpenIdConnectExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    authority!: string | undefined;
    loginUrl!: string | undefined;
    validateIssuer!: boolean;

    constructor(data?: IOpenIdConnectExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.authority = _data["authority"];
            this.loginUrl = _data["loginUrl"];
            this.validateIssuer = _data["validateIssuer"];
        }
    }

    static fromJS(data: any): OpenIdConnectExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OpenIdConnectExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["authority"] = this.authority;
        data["loginUrl"] = this.loginUrl;
        data["validateIssuer"] = this.validateIssuer;
        return data;
    }
}

export interface IOpenIdConnectExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    authority: string | undefined;
    loginUrl: string | undefined;
    validateIssuer: boolean;
}

export class OrganizationActivityDetailDto implements IOrganizationActivityDetailDto {
    organizationActivityId!: number;
    isChecked!: boolean;
    correctiveSteps!: string | undefined;
    subActivityId!: number;
    id!: number;

    constructor(data?: IOrganizationActivityDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationActivityId = _data["organizationActivityId"];
            this.isChecked = _data["isChecked"];
            this.correctiveSteps = _data["correctiveSteps"];
            this.subActivityId = _data["subActivityId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationActivityDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationActivityDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationActivityId"] = this.organizationActivityId;
        data["isChecked"] = this.isChecked;
        data["correctiveSteps"] = this.correctiveSteps;
        data["subActivityId"] = this.subActivityId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationActivityDetailDto {
    organizationActivityId: number;
    isChecked: boolean;
    correctiveSteps: string | undefined;
    subActivityId: number;
    id: number;
}

export class OrganizationActivityDetailSubActivityLookupTableDto implements IOrganizationActivityDetailSubActivityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IOrganizationActivityDetailSubActivityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationActivityDetailSubActivityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationActivityDetailSubActivityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrganizationActivityDetailSubActivityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class OrganizationActivityDto implements IOrganizationActivityDto {
    creationTime!: DateTime;
    organizationUnitId!: number;
    planYear!: string | undefined;
    lastModifierUserName!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModificationDate!: string | undefined;
    id!: number;

    constructor(data?: IOrganizationActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.organizationUnitId = _data["organizationUnitId"];
            this.planYear = _data["planYear"];
            this.lastModifierUserName = _data["lastModifierUserName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModificationDate = _data["lastModificationDate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["organizationUnitId"] = this.organizationUnitId;
        data["planYear"] = this.planYear;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModificationDate"] = this.lastModificationDate;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationActivityDto {
    creationTime: DateTime;
    organizationUnitId: number;
    planYear: string | undefined;
    lastModifierUserName: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModificationDate: string | undefined;
    id: number;
}

export class OrganizationActivityOrganizationUnitLookupTableDto implements IOrganizationActivityOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IOrganizationActivityOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationActivityOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationActivityOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrganizationActivityOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class OrganizationEEPBaselinePeriodLookupTableDto implements IOrganizationEEPBaselinePeriodLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IOrganizationEEPBaselinePeriodLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationEEPBaselinePeriodLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEEPBaselinePeriodLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrganizationEEPBaselinePeriodLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class OrganizationEEPDetailAreaOfImprovementLookupTableDto implements IOrganizationEEPDetailAreaOfImprovementLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IOrganizationEEPDetailAreaOfImprovementLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationEEPDetailAreaOfImprovementLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEEPDetailAreaOfImprovementLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrganizationEEPDetailAreaOfImprovementLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class OrganizationEEPDetailDto implements IOrganizationEEPDetailDto {
    departmentName!: string | undefined;
    activityStartDate!: DateTime;
    activityEndDate!: DateTime;
    expectedEnergySaving!: number | undefined;
    expectedSavingUnitName!: string | undefined;
    achievedEnergySaving!: number | undefined;
    activityRelativeWeight!: number | undefined;
    organizationEEPId!: number;
    expectedEnergySavingUnitId!: number | undefined;
    fuelExpectedEnergySavingUnitId!: number | undefined;
    eepStatusId!: number;
    areaOfImprovementId!: number | undefined;
    areaOfImprovement!: AreaOfImprovementDto;
    customAreaOfImprovementId!: number | undefined;
    customAreaOfImprovement!: CustomAreaOfImprovementDto;
    notes!: string | undefined;
    isDraft!: boolean | undefined;
    planYear!: string | undefined;
    formatedActivityStartDate!: string | undefined;
    formatedActivityEndDate!: string | undefined;
    isCustomAreaOfImprovement!: boolean | undefined;
    randomGeneratedIndex!: number | undefined;
    areaOfImprovementName_Ar!: string | undefined;
    areaOfImprovementParent!: string | undefined;
    areaOfImprovementNature!: string | undefined;
    isFuel!: boolean;
    id!: number;

    constructor(data?: IOrganizationEEPDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentName = _data["departmentName"];
            this.activityStartDate = _data["activityStartDate"] ? DateTime.fromISO(_data["activityStartDate"].toString()) : <any>undefined;
            this.activityEndDate = _data["activityEndDate"] ? DateTime.fromISO(_data["activityEndDate"].toString()) : <any>undefined;
            this.expectedEnergySaving = _data["expectedEnergySaving"];
            this.expectedSavingUnitName = _data["expectedSavingUnitName"];
            this.achievedEnergySaving = _data["achievedEnergySaving"];
            this.activityRelativeWeight = _data["activityRelativeWeight"];
            this.organizationEEPId = _data["organizationEEPId"];
            this.expectedEnergySavingUnitId = _data["expectedEnergySavingUnitId"];
            this.fuelExpectedEnergySavingUnitId = _data["fuelExpectedEnergySavingUnitId"];
            this.eepStatusId = _data["eepStatusId"];
            this.areaOfImprovementId = _data["areaOfImprovementId"];
            this.areaOfImprovement = _data["areaOfImprovement"] ? AreaOfImprovementDto.fromJS(_data["areaOfImprovement"]) : <any>undefined;
            this.customAreaOfImprovementId = _data["customAreaOfImprovementId"];
            this.customAreaOfImprovement = _data["customAreaOfImprovement"] ? CustomAreaOfImprovementDto.fromJS(_data["customAreaOfImprovement"]) : <any>undefined;
            this.notes = _data["notes"];
            this.isDraft = _data["isDraft"];
            this.planYear = _data["planYear"];
            this.formatedActivityStartDate = _data["formatedActivityStartDate"];
            this.formatedActivityEndDate = _data["formatedActivityEndDate"];
            this.isCustomAreaOfImprovement = _data["isCustomAreaOfImprovement"];
            this.randomGeneratedIndex = _data["randomGeneratedIndex"];
            this.areaOfImprovementName_Ar = _data["areaOfImprovementName_Ar"];
            this.areaOfImprovementParent = _data["areaOfImprovementParent"];
            this.areaOfImprovementNature = _data["areaOfImprovementNature"];
            this.isFuel = _data["isFuel"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationEEPDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEEPDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentName"] = this.departmentName;
        data["activityStartDate"] = this.activityStartDate ? this.activityStartDate.toString() : <any>undefined;
        data["activityEndDate"] = this.activityEndDate ? this.activityEndDate.toString() : <any>undefined;
        data["expectedEnergySaving"] = this.expectedEnergySaving;
        data["expectedSavingUnitName"] = this.expectedSavingUnitName;
        data["achievedEnergySaving"] = this.achievedEnergySaving;
        data["activityRelativeWeight"] = this.activityRelativeWeight;
        data["organizationEEPId"] = this.organizationEEPId;
        data["expectedEnergySavingUnitId"] = this.expectedEnergySavingUnitId;
        data["fuelExpectedEnergySavingUnitId"] = this.fuelExpectedEnergySavingUnitId;
        data["eepStatusId"] = this.eepStatusId;
        data["areaOfImprovementId"] = this.areaOfImprovementId;
        data["areaOfImprovement"] = this.areaOfImprovement ? this.areaOfImprovement.toJSON() : <any>undefined;
        data["customAreaOfImprovementId"] = this.customAreaOfImprovementId;
        data["customAreaOfImprovement"] = this.customAreaOfImprovement ? this.customAreaOfImprovement.toJSON() : <any>undefined;
        data["notes"] = this.notes;
        data["isDraft"] = this.isDraft;
        data["planYear"] = this.planYear;
        data["formatedActivityStartDate"] = this.formatedActivityStartDate;
        data["formatedActivityEndDate"] = this.formatedActivityEndDate;
        data["isCustomAreaOfImprovement"] = this.isCustomAreaOfImprovement;
        data["randomGeneratedIndex"] = this.randomGeneratedIndex;
        data["areaOfImprovementName_Ar"] = this.areaOfImprovementName_Ar;
        data["areaOfImprovementParent"] = this.areaOfImprovementParent;
        data["areaOfImprovementNature"] = this.areaOfImprovementNature;
        data["isFuel"] = this.isFuel;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationEEPDetailDto {
    departmentName: string | undefined;
    activityStartDate: DateTime;
    activityEndDate: DateTime;
    expectedEnergySaving: number | undefined;
    expectedSavingUnitName: string | undefined;
    achievedEnergySaving: number | undefined;
    activityRelativeWeight: number | undefined;
    organizationEEPId: number;
    expectedEnergySavingUnitId: number | undefined;
    fuelExpectedEnergySavingUnitId: number | undefined;
    eepStatusId: number;
    areaOfImprovementId: number | undefined;
    areaOfImprovement: AreaOfImprovementDto;
    customAreaOfImprovementId: number | undefined;
    customAreaOfImprovement: CustomAreaOfImprovementDto;
    notes: string | undefined;
    isDraft: boolean | undefined;
    planYear: string | undefined;
    formatedActivityStartDate: string | undefined;
    formatedActivityEndDate: string | undefined;
    isCustomAreaOfImprovement: boolean | undefined;
    randomGeneratedIndex: number | undefined;
    areaOfImprovementName_Ar: string | undefined;
    areaOfImprovementParent: string | undefined;
    areaOfImprovementNature: string | undefined;
    isFuel: boolean;
    id: number;
}

export class OrganizationEEPDetailEEPStatusLookupTableDto implements IOrganizationEEPDetailEEPStatusLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IOrganizationEEPDetailEEPStatusLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationEEPDetailEEPStatusLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEEPDetailEEPStatusLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrganizationEEPDetailEEPStatusLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class OrganizationEEPDetailOrganizationEEPLookupTableDto implements IOrganizationEEPDetailOrganizationEEPLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IOrganizationEEPDetailOrganizationEEPLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationEEPDetailOrganizationEEPLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEEPDetailOrganizationEEPLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrganizationEEPDetailOrganizationEEPLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class OrganizationEEPDetailUnitLookupTableDto implements IOrganizationEEPDetailUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    isFuel!: boolean | undefined;

    constructor(data?: IOrganizationEEPDetailUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isFuel = _data["isFuel"];
        }
    }

    static fromJS(data: any): OrganizationEEPDetailUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEEPDetailUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isFuel"] = this.isFuel;
        return data;
    }
}

export interface IOrganizationEEPDetailUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
    isFuel: boolean | undefined;
}

export class OrganizationEEPDto implements IOrganizationEEPDto {
    subject!: string | undefined;
    baselineYear!: string | undefined;
    planYear!: string | undefined;
    baseline!: number;
    submitDate!: DateTime | undefined;
    formatedSubmitDate!: string | undefined;
    expectedSavingRate!: number | undefined;
    expectedConsumption!: number | undefined;
    implementStartDate!: DateTime | undefined;
    implementEndDate!: DateTime | undefined;
    organizationUnitId!: number;
    orgTeamLeadId!: number;
    baselineUnitId!: number | undefined;
    fuelBaselineUnitId!: number | undefined;
    isDraft!: boolean | undefined;
    tabIndex!: number | undefined;
    isFuel!: boolean | undefined;
    id!: number;

    constructor(data?: IOrganizationEEPDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.baselineYear = _data["baselineYear"];
            this.planYear = _data["planYear"];
            this.baseline = _data["baseline"];
            this.submitDate = _data["submitDate"] ? DateTime.fromISO(_data["submitDate"].toString()) : <any>undefined;
            this.formatedSubmitDate = _data["formatedSubmitDate"];
            this.expectedSavingRate = _data["expectedSavingRate"];
            this.expectedConsumption = _data["expectedConsumption"];
            this.implementStartDate = _data["implementStartDate"] ? DateTime.fromISO(_data["implementStartDate"].toString()) : <any>undefined;
            this.implementEndDate = _data["implementEndDate"] ? DateTime.fromISO(_data["implementEndDate"].toString()) : <any>undefined;
            this.organizationUnitId = _data["organizationUnitId"];
            this.orgTeamLeadId = _data["orgTeamLeadId"];
            this.baselineUnitId = _data["baselineUnitId"];
            this.fuelBaselineUnitId = _data["fuelBaselineUnitId"];
            this.isDraft = _data["isDraft"];
            this.tabIndex = _data["tabIndex"];
            this.isFuel = _data["isFuel"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationEEPDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEEPDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["baselineYear"] = this.baselineYear;
        data["planYear"] = this.planYear;
        data["baseline"] = this.baseline;
        data["submitDate"] = this.submitDate ? this.submitDate.toString() : <any>undefined;
        data["formatedSubmitDate"] = this.formatedSubmitDate;
        data["expectedSavingRate"] = this.expectedSavingRate;
        data["expectedConsumption"] = this.expectedConsumption;
        data["implementStartDate"] = this.implementStartDate ? this.implementStartDate.toString() : <any>undefined;
        data["implementEndDate"] = this.implementEndDate ? this.implementEndDate.toString() : <any>undefined;
        data["organizationUnitId"] = this.organizationUnitId;
        data["orgTeamLeadId"] = this.orgTeamLeadId;
        data["baselineUnitId"] = this.baselineUnitId;
        data["fuelBaselineUnitId"] = this.fuelBaselineUnitId;
        data["isDraft"] = this.isDraft;
        data["tabIndex"] = this.tabIndex;
        data["isFuel"] = this.isFuel;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationEEPDto {
    subject: string | undefined;
    baselineYear: string | undefined;
    planYear: string | undefined;
    baseline: number;
    submitDate: DateTime | undefined;
    formatedSubmitDate: string | undefined;
    expectedSavingRate: number | undefined;
    expectedConsumption: number | undefined;
    implementStartDate: DateTime | undefined;
    implementEndDate: DateTime | undefined;
    organizationUnitId: number;
    orgTeamLeadId: number;
    baselineUnitId: number | undefined;
    fuelBaselineUnitId: number | undefined;
    isDraft: boolean | undefined;
    tabIndex: number | undefined;
    isFuel: boolean | undefined;
    id: number;
}

export class OrganizationEEPOrganizationUnitLookupTableDto implements IOrganizationEEPOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IOrganizationEEPOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationEEPOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEEPOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrganizationEEPOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class OrganizationEEPUnitLookupTableDto implements IOrganizationEEPUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IOrganizationEEPUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationEEPUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEEPUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrganizationEEPUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class OrganizationEEPUserLookupTableDto implements IOrganizationEEPUserLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IOrganizationEEPUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationEEPUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationEEPUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrganizationEEPUserLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class OrganizationUnit implements IOrganizationUnit {
    tenantId!: number | undefined;
    parent!: OrganizationUnit;
    parentId!: number | undefined;
    code!: string;
    displayName!: string;
    children!: OrganizationUnit[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.parent = _data["parent"] ? OrganizationUnit.fromJS(_data["parent"]) : <any>undefined;
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(OrganizationUnit.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnit {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnit {
    tenantId: number | undefined;
    parent: OrganizationUnit;
    parentId: number | undefined;
    code: string;
    displayName: string;
    children: OrganizationUnit[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    sectorId!: number | undefined;
    parentId!: number | undefined;
    memberCount!: number;
    roleCount!: number;
    sectorName!: string | undefined;
    name_En!: string | undefined;
    name_Ar!: string;
    organizationTypeId!: number;
    govCode!: string;
    isSubEntity!: boolean;
    subEntities!: OrganizationUnitDto[] | undefined;
    claimAccounts!: ClaimAccountDto[] | undefined;
    isSelectedOrg!: boolean;
    mainOrgName!: string | undefined;
    isActive!: boolean | undefined;
    lastLogin!: DateTime | undefined;
    lastLoginDuration!: string | undefined;
    lastSubmitDuration!: string | undefined;
    organizationTierId!: number | undefined;
    organizationTierCode!: string | undefined;
    mustPassTierA!: boolean | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectorId = _data["sectorId"];
            this.parentId = _data["parentId"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.sectorName = _data["sectorName"];
            this.name_En = _data["name_En"];
            this.name_Ar = _data["name_Ar"];
            this.organizationTypeId = _data["organizationTypeId"];
            this.govCode = _data["govCode"];
            this.isSubEntity = _data["isSubEntity"];
            if (Array.isArray(_data["subEntities"])) {
                this.subEntities = [] as any;
                for (let item of _data["subEntities"])
                    this.subEntities!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["ClaimAccounts"])) {
                this.claimAccounts = [] as any;
                for (let item of _data["ClaimAccounts"])
                    this.claimAccounts!.push(ClaimAccountDto.fromJS(item));
            }
            this.isSelectedOrg = _data["isSelectedOrg"];
            this.mainOrgName = _data["mainOrgName"];
            this.isActive = _data["isActive"];
            this.lastLogin = _data["lastLogin"] ? DateTime.fromISO(_data["lastLogin"].toString()) : <any>undefined;
            this.lastLoginDuration = _data["lastLoginDuration"];
            this.lastSubmitDuration = _data["lastSubmitDuration"];
            this.organizationTierId = _data["organizationTierId"];
            this.organizationTierCode = _data["organizationTierCode"];
            this.mustPassTierA = _data["mustPassTierA"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectorId"] = this.sectorId;
        data["parentId"] = this.parentId;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["sectorName"] = this.sectorName;
        data["name_En"] = this.name_En;
        data["name_Ar"] = this.name_Ar;
        data["organizationTypeId"] = this.organizationTypeId;
        data["govCode"] = this.govCode;
        data["isSubEntity"] = this.isSubEntity;
        if (Array.isArray(this.subEntities)) {
            data["subEntities"] = [];
            for (let item of this.subEntities)
                data["subEntities"].push(item.toJSON());
        }
        if (Array.isArray(this.claimAccounts)) {
            data["ClaimAccounts"] = [];
            for (let item of this.claimAccounts)
                data["ClaimAccounts"].push(item.toJSON());
        }
        data["isSelectedOrg"] = this.isSelectedOrg;
        data["mainOrgName"] = this.mainOrgName;
        data["isActive"] = this.isActive;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toString() : <any>undefined;
        data["lastLoginDuration"] = this.lastLoginDuration;
        data["lastSubmitDuration"] = this.lastSubmitDuration;
        data["organizationTierId"] = this.organizationTierId;
        data["organizationTierCode"] = this.organizationTierCode;
        data["mustPassTierA"] = this.mustPassTierA;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitDto {
    sectorId: number | undefined;
    parentId: number | undefined;
    memberCount: number;
    roleCount: number;
    sectorName: string | undefined;
    name_En: string | undefined;
    name_Ar: string;
    organizationTypeId: number;
    govCode: string;
    isSubEntity: boolean;
    subEntities: OrganizationUnitDto[] | undefined;
    claimAccounts: ClaimAccountDto[] | undefined;
    isSelectedOrg: boolean;
    mainOrgName: string | undefined;
    isActive: boolean | undefined;
    lastLogin: DateTime | undefined;
    lastLoginDuration: string | undefined;
    lastSubmitDuration: string | undefined;
    organizationTierId: number | undefined;
    organizationTierCode: string | undefined;
    mustPassTierA: boolean | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class OrganizationUnitForHeaderDto implements IOrganizationUnitForHeaderDto {
    id!: number;
    sectorName!: string | undefined;
    organizationName!: string | undefined;
    parentOrganizationName!: string | undefined;
    isSubEntity!: boolean;
    govCode!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IOrganizationUnitForHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectorName = _data["sectorName"];
            this.organizationName = _data["organizationName"];
            this.parentOrganizationName = _data["parentOrganizationName"];
            this.isSubEntity = _data["isSubEntity"];
            this.govCode = _data["govCode"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationUnitForHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitForHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectorName"] = this.sectorName;
        data["organizationName"] = this.organizationName;
        data["parentOrganizationName"] = this.parentOrganizationName;
        data["isSubEntity"] = this.isSubEntity;
        data["govCode"] = this.govCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IOrganizationUnitForHeaderDto {
    id: number;
    sectorName: string | undefined;
    organizationName: string | undefined;
    parentOrganizationName: string | undefined;
    isSubEntity: boolean;
    govCode: string | undefined;
    creationTime: DateTime;
}

export class OrganizationUnitForViewDto implements IOrganizationUnitForViewDto {
    teamMemberUser!: UserDto;
    id!: number;
    sectorName!: string | undefined;
    organizationName!: string | undefined;
    govCode!: string | undefined;
    organizationTypeId!: number;
    claimAccounts!: ClaimAccountDto[] | undefined;

    constructor(data?: IOrganizationUnitForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberUser = _data["teamMemberUser"] ? UserDto.fromJS(_data["teamMemberUser"]) : <any>undefined;
            this.id = _data["id"];
            this.sectorName = _data["sectorName"];
            this.organizationName = _data["organizationName"];
            this.govCode = _data["govCode"];
            this.organizationTypeId = _data["organizationTypeId"];
            if (Array.isArray(_data["claimAccounts"])) {
                this.claimAccounts = [] as any;
                for (let item of _data["claimAccounts"])
                    this.claimAccounts!.push(ClaimAccountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationUnitForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberUser"] = this.teamMemberUser ? this.teamMemberUser.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["sectorName"] = this.sectorName;
        data["organizationName"] = this.organizationName;
        data["govCode"] = this.govCode;
        data["organizationTypeId"] = this.organizationTypeId;
        if (Array.isArray(this.claimAccounts)) {
            data["claimAccounts"] = [];
            for (let item of this.claimAccounts)
                data["claimAccounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationUnitForViewDto {
    teamMemberUser: UserDto;
    id: number;
    sectorName: string | undefined;
    organizationName: string | undefined;
    govCode: string | undefined;
    organizationTypeId: number;
    claimAccounts: ClaimAccountDto[] | undefined;
}

export class OrganizationUnitHeaderDto implements IOrganizationUnitHeaderDto {
    organization!: OrganizationUnitForViewDto;
    requetStatusName!: string | undefined;

    constructor(data?: IOrganizationUnitHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organization = _data["organization"] ? OrganizationUnitForViewDto.fromJS(_data["organization"]) : <any>undefined;
            this.requetStatusName = _data["requetStatusName"];
        }
    }

    static fromJS(data: any): OrganizationUnitHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["requetStatusName"] = this.requetStatusName;
        return data;
    }
}

export interface IOrganizationUnitHeaderDto {
    organization: OrganizationUnitForViewDto;
    requetStatusName: string | undefined;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OrganizationUnitTreeModelDto implements IOrganizationUnitTreeModelDto {
    organizationUnitTreeNodes!: TreeNodesDto[] | undefined;
    count!: number;

    constructor(data?: IOrganizationUnitTreeModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizationUnitTreeNodes"])) {
                this.organizationUnitTreeNodes = [] as any;
                for (let item of _data["organizationUnitTreeNodes"])
                    this.organizationUnitTreeNodes!.push(TreeNodesDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): OrganizationUnitTreeModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitTreeModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizationUnitTreeNodes)) {
            data["organizationUnitTreeNodes"] = [];
            for (let item of this.organizationUnitTreeNodes)
                data["organizationUnitTreeNodes"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IOrganizationUnitTreeModelDto {
    organizationUnitTreeNodes: TreeNodesDto[] | undefined;
    count: number;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class Page implements IPage {
    id!: string | undefined;
    name!: string | undefined;
    widgets!: Widget[] | undefined;

    constructor(data?: IPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(Widget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPage {
    id: string | undefined;
    name: string | undefined;
    widgets: Widget[] | undefined;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export class PagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto implements IPagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto {
    totalCount!: number;
    items!: AwarnessContentAwarenessContentClassificationLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AwarnessContentAwarenessContentClassificationLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAwarnessContentAwarenessContentClassificationLookupTableDto {
    totalCount: number;
    items: AwarnessContentAwarenessContentClassificationLookupTableDto[] | undefined;
}

export class PagedResultDtoOfAwarnessContentContentTypeLookupTableDto implements IPagedResultDtoOfAwarnessContentContentTypeLookupTableDto {
    totalCount!: number;
    items!: AwarnessContentContentTypeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAwarnessContentContentTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AwarnessContentContentTypeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAwarnessContentContentTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAwarnessContentContentTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAwarnessContentContentTypeLookupTableDto {
    totalCount: number;
    items: AwarnessContentContentTypeLookupTableDto[] | undefined;
}

export class PagedResultDtoOfClaimAccountListDto implements IPagedResultDtoOfClaimAccountListDto {
    totalCount!: number;
    items!: ClaimAccountListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfClaimAccountListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClaimAccountListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfClaimAccountListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfClaimAccountListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfClaimAccountListDto {
    totalCount: number;
    items: ClaimAccountListDto[] | undefined;
}

export class PagedResultDtoOfElectricityConsumptionReportEntityRowDto implements IPagedResultDtoOfElectricityConsumptionReportEntityRowDto {
    totalCount!: number;
    items!: ElectricityConsumptionReportEntityRowDto[] | undefined;

    constructor(data?: IPagedResultDtoOfElectricityConsumptionReportEntityRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ElectricityConsumptionReportEntityRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfElectricityConsumptionReportEntityRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfElectricityConsumptionReportEntityRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfElectricityConsumptionReportEntityRowDto {
    totalCount: number;
    items: ElectricityConsumptionReportEntityRowDto[] | undefined;
}

export class PagedResultDtoOfElectricityHistoricalConsumptionRowDto implements IPagedResultDtoOfElectricityHistoricalConsumptionRowDto {
    totalCount!: number;
    items!: ElectricityHistoricalConsumptionRowDto[] | undefined;

    constructor(data?: IPagedResultDtoOfElectricityHistoricalConsumptionRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ElectricityHistoricalConsumptionRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfElectricityHistoricalConsumptionRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfElectricityHistoricalConsumptionRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfElectricityHistoricalConsumptionRowDto {
    totalCount: number;
    items: ElectricityHistoricalConsumptionRowDto[] | undefined;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class PagedResultDtoOfFuelConsumptionReportEntityRowDto implements IPagedResultDtoOfFuelConsumptionReportEntityRowDto {
    totalCount!: number;
    items!: FuelConsumptionReportEntityRowDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFuelConsumptionReportEntityRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FuelConsumptionReportEntityRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFuelConsumptionReportEntityRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFuelConsumptionReportEntityRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfFuelConsumptionReportEntityRowDto {
    totalCount: number;
    items: FuelConsumptionReportEntityRowDto[] | undefined;
}

export class PagedResultDtoOfFuelHistoricalConsumptionRowDto implements IPagedResultDtoOfFuelHistoricalConsumptionRowDto {
    totalCount!: number;
    items!: FuelHistoricalConsumptionRowDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFuelHistoricalConsumptionRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FuelHistoricalConsumptionRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFuelHistoricalConsumptionRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFuelHistoricalConsumptionRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfFuelHistoricalConsumptionRowDto {
    totalCount: number;
    items: FuelHistoricalConsumptionRowDto[] | undefined;
}

export class PagedResultDtoOfGetAboutSeecForViewDto implements IPagedResultDtoOfGetAboutSeecForViewDto {
    totalCount!: number;
    items!: GetAboutSeecForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAboutSeecForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAboutSeecForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAboutSeecForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAboutSeecForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAboutSeecForViewDto {
    totalCount: number;
    items: GetAboutSeecForViewDto[] | undefined;
}

export class PagedResultDtoOfGetAttendeeInfoForViewDto implements IPagedResultDtoOfGetAttendeeInfoForViewDto {
    totalCount!: number;
    items!: GetAttendeeInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAttendeeInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAttendeeInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAttendeeInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAttendeeInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAttendeeInfoForViewDto {
    totalCount: number;
    items: GetAttendeeInfoForViewDto[] | undefined;
}

export class PagedResultDtoOfGetAwarnessContentForViewDto implements IPagedResultDtoOfGetAwarnessContentForViewDto {
    totalCount!: number;
    items!: GetAwarnessContentForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAwarnessContentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAwarnessContentForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAwarnessContentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAwarnessContentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAwarnessContentForViewDto {
    totalCount: number;
    items: GetAwarnessContentForViewDto[] | undefined;
}

export class PagedResultDtoOfGetBuildingAssetInfoForViewDto implements IPagedResultDtoOfGetBuildingAssetInfoForViewDto {
    totalCount!: number;
    items!: GetBuildingAssetInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBuildingAssetInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBuildingAssetInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBuildingAssetInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBuildingAssetInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBuildingAssetInfoForViewDto {
    totalCount: number;
    items: GetBuildingAssetInfoForViewDto[] | undefined;
}

export class PagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto implements IPagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto {
    totalCount!: number;
    items!: GetBuildingEnergyEfficiencySubmissionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBuildingEnergyEfficiencySubmissionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBuildingEnergyEfficiencySubmissionForViewDto {
    totalCount: number;
    items: GetBuildingEnergyEfficiencySubmissionForViewDto[] | undefined;
}

export class PagedResultDtoOfGetBuildingInfoForViewDto implements IPagedResultDtoOfGetBuildingInfoForViewDto {
    totalCount!: number;
    items!: GetBuildingInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBuildingInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetBuildingInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBuildingInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBuildingInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBuildingInfoForViewDto {
    totalCount: number;
    items: GetBuildingInfoForViewDto[] | undefined;
}

export class PagedResultDtoOfGetContactUsForViewDto implements IPagedResultDtoOfGetContactUsForViewDto {
    totalCount!: number;
    items!: GetContactUsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetContactUsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetContactUsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetContactUsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetContactUsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetContactUsForViewDto {
    totalCount: number;
    items: GetContactUsForViewDto[] | undefined;
}

export class PagedResultDtoOfGetCoolingStationAssetInfoForViewDto implements IPagedResultDtoOfGetCoolingStationAssetInfoForViewDto {
    totalCount!: number;
    items!: GetCoolingStationAssetInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCoolingStationAssetInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCoolingStationAssetInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCoolingStationAssetInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCoolingStationAssetInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCoolingStationAssetInfoForViewDto {
    totalCount: number;
    items: GetCoolingStationAssetInfoForViewDto[] | undefined;
}

export class PagedResultDtoOfGetCourseForViewDto implements IPagedResultDtoOfGetCourseForViewDto {
    totalCount!: number;
    items!: GetCourseForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCourseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCourseForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCourseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCourseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCourseForViewDto {
    totalCount: number;
    items: GetCourseForViewDto[] | undefined;
}

export class PagedResultDtoOfGetCustomAreaOfImprovementForViewDto implements IPagedResultDtoOfGetCustomAreaOfImprovementForViewDto {
    totalCount!: number;
    items!: GetCustomAreaOfImprovementForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCustomAreaOfImprovementForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCustomAreaOfImprovementForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCustomAreaOfImprovementForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCustomAreaOfImprovementForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCustomAreaOfImprovementForViewDto {
    totalCount: number;
    items: GetCustomAreaOfImprovementForViewDto[] | undefined;
}

export class PagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto implements IPagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto {
    totalCount!: number;
    items!: GetEEPRequestDeadlineSettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEEPRequestDeadlineSettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEEPRequestDeadlineSettingForViewDto {
    totalCount: number;
    items: GetEEPRequestDeadlineSettingForViewDto[] | undefined;
}

export class PagedResultDtoOfGetEfficiencyPlanForViewDto implements IPagedResultDtoOfGetEfficiencyPlanForViewDto {
    totalCount!: number;
    items!: GetEfficiencyPlanForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEfficiencyPlanForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEfficiencyPlanForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEfficiencyPlanForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEfficiencyPlanForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEfficiencyPlanForViewDto {
    totalCount: number;
    items: GetEfficiencyPlanForViewDto[] | undefined;
}

export class PagedResultDtoOfGetEmailForViewDto implements IPagedResultDtoOfGetEmailForViewDto {
    totalCount!: number;
    items!: GetEmailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmailForViewDto {
    totalCount: number;
    items: GetEmailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetEmailTemplateForViewDto implements IPagedResultDtoOfGetEmailTemplateForViewDto {
    totalCount!: number;
    items!: GetEmailTemplateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmailTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmailTemplateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmailTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmailTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmailTemplateForViewDto {
    totalCount: number;
    items: GetEmailTemplateForViewDto[] | undefined;
}

export class PagedResultDtoOfGetFAQCategoryForViewDto implements IPagedResultDtoOfGetFAQCategoryForViewDto {
    totalCount!: number;
    items!: GetFAQCategoryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFAQCategoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetFAQCategoryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFAQCategoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFAQCategoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFAQCategoryForViewDto {
    totalCount: number;
    items: GetFAQCategoryForViewDto[] | undefined;
}

export class PagedResultDtoOfGetFAQForViewDto implements IPagedResultDtoOfGetFAQForViewDto {
    totalCount!: number;
    items!: GetFAQForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFAQForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetFAQForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFAQForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFAQForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFAQForViewDto {
    totalCount: number;
    items: GetFAQForViewDto[] | undefined;
}

export class PagedResultDtoOfGetFuelAssetInfoForViewDto implements IPagedResultDtoOfGetFuelAssetInfoForViewDto {
    totalCount!: number;
    items!: GetFuelAssetInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFuelAssetInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetFuelAssetInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFuelAssetInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFuelAssetInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFuelAssetInfoForViewDto {
    totalCount: number;
    items: GetFuelAssetInfoForViewDto[] | undefined;
}

export class PagedResultDtoOfGetFuelProviderDataForViewDto implements IPagedResultDtoOfGetFuelProviderDataForViewDto {
    totalCount!: number;
    items!: GetFuelProviderDataForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFuelProviderDataForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetFuelProviderDataForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFuelProviderDataForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFuelProviderDataForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFuelProviderDataForViewDto {
    totalCount: number;
    items: GetFuelProviderDataForViewDto[] | undefined;
}

export class PagedResultDtoOfGetFuelProviderDetailForViewDto implements IPagedResultDtoOfGetFuelProviderDetailForViewDto {
    totalCount!: number;
    items!: GetFuelProviderDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFuelProviderDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetFuelProviderDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFuelProviderDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFuelProviderDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFuelProviderDetailForViewDto {
    totalCount: number;
    items: GetFuelProviderDetailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetGeneratorInfoForViewDto implements IPagedResultDtoOfGetGeneratorInfoForViewDto {
    totalCount!: number;
    items!: GetGeneratorInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGeneratorInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGeneratorInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGeneratorInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGeneratorInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGeneratorInfoForViewDto {
    totalCount: number;
    items: GetGeneratorInfoForViewDto[] | undefined;
}

export class PagedResultDtoOfGetGovElectricityForViewDto implements IPagedResultDtoOfGetGovElectricityForViewDto {
    totalCount!: number;
    items!: GetGovElectricityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGovElectricityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGovElectricityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGovElectricityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGovElectricityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGovElectricityForViewDto {
    totalCount: number;
    items: GetGovElectricityForViewDto[] | undefined;
}

export class PagedResultDtoOfGetGovFuelForViewDto implements IPagedResultDtoOfGetGovFuelForViewDto {
    totalCount!: number;
    items!: GetGovFuelForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGovFuelForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetGovFuelForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGovFuelForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGovFuelForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGovFuelForViewDto {
    totalCount: number;
    items: GetGovFuelForViewDto[] | undefined;
}

export class PagedResultDtoOfGetKnowledgeBankForViewDto implements IPagedResultDtoOfGetKnowledgeBankForViewDto {
    totalCount!: number;
    items!: GetKnowledgeBankForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetKnowledgeBankForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetKnowledgeBankForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetKnowledgeBankForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetKnowledgeBankForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetKnowledgeBankForViewDto {
    totalCount: number;
    items: GetKnowledgeBankForViewDto[] | undefined;
}

export class PagedResultDtoOfGetLogInboxOutput implements IPagedResultDtoOfGetLogInboxOutput {
    totalCount!: number;
    items!: GetLogInboxOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLogInboxOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetLogInboxOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLogInboxOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLogInboxOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLogInboxOutput {
    totalCount: number;
    items: GetLogInboxOutput[] | undefined;
}

export class PagedResultDtoOfGetMainActivityForViewDto implements IPagedResultDtoOfGetMainActivityForViewDto {
    totalCount!: number;
    items!: GetMainActivityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMainActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMainActivityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMainActivityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMainActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMainActivityForViewDto {
    totalCount: number;
    items: GetMainActivityForViewDto[] | undefined;
}

export class PagedResultDtoOfGetMediaCenterForViewDto implements IPagedResultDtoOfGetMediaCenterForViewDto {
    totalCount!: number;
    items!: GetMediaCenterForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMediaCenterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMediaCenterForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMediaCenterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMediaCenterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMediaCenterForViewDto {
    totalCount: number;
    items: GetMediaCenterForViewDto[] | undefined;
}

export class PagedResultDtoOfGetNewsForViewDto implements IPagedResultDtoOfGetNewsForViewDto {
    totalCount!: number;
    items!: GetNewsForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNewsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetNewsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNewsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNewsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetNewsForViewDto {
    totalCount: number;
    items: GetNewsForViewDto[] | undefined;
}

export class PagedResultDtoOfGetNewsVersionForViewDto implements IPagedResultDtoOfGetNewsVersionForViewDto {
    totalCount!: number;
    items!: GetNewsVersionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNewsVersionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetNewsVersionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNewsVersionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNewsVersionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetNewsVersionForViewDto {
    totalCount: number;
    items: GetNewsVersionForViewDto[] | undefined;
}

export class PagedResultDtoOfGetNotificationLogForViewDto implements IPagedResultDtoOfGetNotificationLogForViewDto {
    totalCount!: number;
    items!: GetNotificationLogForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNotificationLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetNotificationLogForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNotificationLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNotificationLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetNotificationLogForViewDto {
    totalCount: number;
    items: GetNotificationLogForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOldRequestsResponseDTO implements IPagedResultDtoOfGetOldRequestsResponseDTO {
    totalCount!: number;
    items!: GetOldRequestsResponseDTO[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOldRequestsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOldRequestsResponseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOldRequestsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOldRequestsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOldRequestsResponseDTO {
    totalCount: number;
    items: GetOldRequestsResponseDTO[] | undefined;
}

export class PagedResultDtoOfGetOrganizationActivityDetailForViewDto implements IPagedResultDtoOfGetOrganizationActivityDetailForViewDto {
    totalCount!: number;
    items!: GetOrganizationActivityDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOrganizationActivityDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOrganizationActivityDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOrganizationActivityDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOrganizationActivityDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOrganizationActivityDetailForViewDto {
    totalCount: number;
    items: GetOrganizationActivityDetailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrganizationActivityForViewDto implements IPagedResultDtoOfGetOrganizationActivityForViewDto {
    totalCount!: number;
    items!: GetOrganizationActivityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOrganizationActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOrganizationActivityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOrganizationActivityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOrganizationActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOrganizationActivityForViewDto {
    totalCount: number;
    items: GetOrganizationActivityForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto implements IPagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto {
    totalCount!: number;
    items!: GetOrganizationEEPDetailByOrgEppIdDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOrganizationEEPDetailByOrgEppIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOrganizationEEPDetailByOrgEppIdDto {
    totalCount: number;
    items: GetOrganizationEEPDetailByOrgEppIdDto[] | undefined;
}

export class PagedResultDtoOfGetOrganizationEEPDetailForViewDto implements IPagedResultDtoOfGetOrganizationEEPDetailForViewDto {
    totalCount!: number;
    items!: GetOrganizationEEPDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOrganizationEEPDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOrganizationEEPDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOrganizationEEPDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOrganizationEEPDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOrganizationEEPDetailForViewDto {
    totalCount: number;
    items: GetOrganizationEEPDetailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetOrganizationEEPForViewDto implements IPagedResultDtoOfGetOrganizationEEPForViewDto {
    totalCount!: number;
    items!: GetOrganizationEEPForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOrganizationEEPForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetOrganizationEEPForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOrganizationEEPForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOrganizationEEPForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOrganizationEEPForViewDto {
    totalCount: number;
    items: GetOrganizationEEPForViewDto[] | undefined;
}

export class PagedResultDtoOfGetProviderElectricityForViewDto implements IPagedResultDtoOfGetProviderElectricityForViewDto {
    totalCount!: number;
    items!: GetProviderElectricityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProviderElectricityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProviderElectricityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProviderElectricityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProviderElectricityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProviderElectricityForViewDto {
    totalCount: number;
    items: GetProviderElectricityForViewDto[] | undefined;
}

export class PagedResultDtoOfGetReferenceForViewDto implements IPagedResultDtoOfGetReferenceForViewDto {
    totalCount!: number;
    items!: GetReferenceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReferenceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetReferenceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReferenceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetReferenceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetReferenceForViewDto {
    totalCount: number;
    items: GetReferenceForViewDto[] | undefined;
}

export class PagedResultDtoOfGetRequestPeriodSettingForViewDto implements IPagedResultDtoOfGetRequestPeriodSettingForViewDto {
    totalCount!: number;
    items!: GetRequestPeriodSettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRequestPeriodSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetRequestPeriodSettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRequestPeriodSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRequestPeriodSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRequestPeriodSettingForViewDto {
    totalCount: number;
    items: GetRequestPeriodSettingForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSecMeterForViewDto implements IPagedResultDtoOfGetSecMeterForViewDto {
    totalCount!: number;
    items!: GetSecMeterForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSecMeterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSecMeterForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSecMeterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSecMeterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSecMeterForViewDto {
    totalCount: number;
    items: GetSecMeterForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSectorForViewDto implements IPagedResultDtoOfGetSectorForViewDto {
    totalCount!: number;
    items!: GetSectorForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSectorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSectorForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSectorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSectorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSectorForViewDto {
    totalCount: number;
    items: GetSectorForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSeecEmailForViewDto implements IPagedResultDtoOfGetSeecEmailForViewDto {
    totalCount!: number;
    items!: GetSeecEmailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeecEmailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeecEmailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeecEmailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeecEmailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeecEmailForViewDto {
    totalCount: number;
    items: GetSeecEmailForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSeecEmailTemplateForViewDto implements IPagedResultDtoOfGetSeecEmailTemplateForViewDto {
    totalCount!: number;
    items!: GetSeecEmailTemplateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeecEmailTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeecEmailTemplateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeecEmailTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeecEmailTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeecEmailTemplateForViewDto {
    totalCount: number;
    items: GetSeecEmailTemplateForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSeecSMSForViewDto implements IPagedResultDtoOfGetSeecSMSForViewDto {
    totalCount!: number;
    items!: GetSeecSMSForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeecSMSForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeecSMSForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeecSMSForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeecSMSForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeecSMSForViewDto {
    totalCount: number;
    items: GetSeecSMSForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSeecSmsTemplateForViewDto implements IPagedResultDtoOfGetSeecSmsTemplateForViewDto {
    totalCount!: number;
    items!: GetSeecSmsTemplateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeecSmsTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSeecSmsTemplateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeecSmsTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeecSmsTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeecSmsTemplateForViewDto {
    totalCount: number;
    items: GetSeecSmsTemplateForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSMSForViewDto implements IPagedResultDtoOfGetSMSForViewDto {
    totalCount!: number;
    items!: GetSMSForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSMSForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSMSForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSMSForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSMSForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSMSForViewDto {
    totalCount: number;
    items: GetSMSForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSmsTemplateForViewDto implements IPagedResultDtoOfGetSmsTemplateForViewDto {
    totalCount!: number;
    items!: GetSmsTemplateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSmsTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSmsTemplateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSmsTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSmsTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSmsTemplateForViewDto {
    totalCount: number;
    items: GetSmsTemplateForViewDto[] | undefined;
}

export class PagedResultDtoOfGetStreetlightAssetInfoForViewDto implements IPagedResultDtoOfGetStreetlightAssetInfoForViewDto {
    totalCount!: number;
    items!: GetStreetlightAssetInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetStreetlightAssetInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetStreetlightAssetInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetStreetlightAssetInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetStreetlightAssetInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetStreetlightAssetInfoForViewDto {
    totalCount: number;
    items: GetStreetlightAssetInfoForViewDto[] | undefined;
}

export class PagedResultDtoOfGetSubActivityForViewDto implements IPagedResultDtoOfGetSubActivityForViewDto {
    totalCount!: number;
    items!: GetSubActivityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSubActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSubActivityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSubActivityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSubActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSubActivityForViewDto {
    totalCount: number;
    items: GetSubActivityForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTopicForViewDto implements IPagedResultDtoOfGetTopicForViewDto {
    totalCount!: number;
    items!: GetTopicForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTopicForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTopicForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTopicForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTopicForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTopicForViewDto {
    totalCount: number;
    items: GetTopicForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTrainingPackageForViewDto implements IPagedResultDtoOfGetTrainingPackageForViewDto {
    totalCount!: number;
    items!: GetTrainingPackageForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTrainingPackageForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTrainingPackageForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTrainingPackageForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTrainingPackageForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTrainingPackageForViewDto {
    totalCount: number;
    items: GetTrainingPackageForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTrainingPackageRequestForViewDto implements IPagedResultDtoOfGetTrainingPackageRequestForViewDto {
    totalCount!: number;
    items!: GetTrainingPackageRequestForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTrainingPackageRequestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTrainingPackageRequestForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTrainingPackageRequestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTrainingPackageRequestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTrainingPackageRequestForViewDto {
    totalCount: number;
    items: GetTrainingPackageRequestForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTrainingRequestForViewDto implements IPagedResultDtoOfGetTrainingRequestForViewDto {
    totalCount!: number;
    items!: GetTrainingRequestForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTrainingRequestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTrainingRequestForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTrainingRequestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTrainingRequestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTrainingRequestForViewDto {
    totalCount: number;
    items: GetTrainingRequestForViewDto[] | undefined;
}

export class PagedResultDtoOfGetUserSectorForViewDto implements IPagedResultDtoOfGetUserSectorForViewDto {
    totalCount!: number;
    items!: GetUserSectorForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUserSectorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetUserSectorForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUserSectorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUserSectorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetUserSectorForViewDto {
    totalCount: number;
    items: GetUserSectorForViewDto[] | undefined;
}

export class PagedResultDtoOfGetUserSubmissionForViewDto implements IPagedResultDtoOfGetUserSubmissionForViewDto {
    totalCount!: number;
    items!: GetUserSubmissionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUserSubmissionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetUserSubmissionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUserSubmissionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUserSubmissionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetUserSubmissionForViewDto {
    totalCount: number;
    items: GetUserSubmissionForViewDto[] | undefined;
}

export class PagedResultDtoOfGovAwarnessContentPublicationDto implements IPagedResultDtoOfGovAwarnessContentPublicationDto {
    totalCount!: number;
    items!: GovAwarnessContentPublicationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGovAwarnessContentPublicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GovAwarnessContentPublicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGovAwarnessContentPublicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGovAwarnessContentPublicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGovAwarnessContentPublicationDto {
    totalCount: number;
    items: GovAwarnessContentPublicationDto[] | undefined;
}

export class PagedResultDtoOfGovFuelRequestLookupTableDto implements IPagedResultDtoOfGovFuelRequestLookupTableDto {
    totalCount!: number;
    items!: GovFuelRequestLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGovFuelRequestLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GovFuelRequestLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGovFuelRequestLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGovFuelRequestLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGovFuelRequestLookupTableDto {
    totalCount: number;
    items: GovFuelRequestLookupTableDto[] | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class PagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto implements IPagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto {
    totalCount!: number;
    items!: OrganizationEEPDetailAreaOfImprovementLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationEEPDetailAreaOfImprovementLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationEEPDetailAreaOfImprovementLookupTableDto {
    totalCount: number;
    items: OrganizationEEPDetailAreaOfImprovementLookupTableDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitDto implements IPagedResultDtoOfOrganizationUnitDto {
    totalCount!: number;
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitDto {
    totalCount: number;
    items: OrganizationUnitDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount!: number;
    items!: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class PagedResultDtoOfTrainingPackageDetailsDto implements IPagedResultDtoOfTrainingPackageDetailsDto {
    totalCount!: number;
    items!: TrainingPackageDetailsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTrainingPackageDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TrainingPackageDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTrainingPackageDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTrainingPackageDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTrainingPackageDetailsDto {
    totalCount: number;
    items: TrainingPackageDetailsDto[] | undefined;
}

export class PagedResultDtoOfUserDelegationDto implements IPagedResultDtoOfUserDelegationDto {
    totalCount!: number;
    items!: UserDelegationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDelegationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserDelegationDto {
    totalCount: number;
    items: UserDelegationDto[] | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class PagedResultDtoOfUserLoginAttemptDto implements IPagedResultDtoOfUserLoginAttemptDto {
    totalCount!: number;
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserLoginAttemptDto {
    totalCount: number;
    items: UserLoginAttemptDto[] | undefined;
}

export class PagedResultDtoOfUserSectorUserLookupTableDto implements IPagedResultDtoOfUserSectorUserLookupTableDto {
    totalCount!: number;
    items!: UserSectorUserLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserSectorUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserSectorUserLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserSectorUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserSectorUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserSectorUserLookupTableDto {
    totalCount: number;
    items: UserSectorUserLookupTableDto[] | undefined;
}

export class PagedResultExtendedDtoOfGetMeterInfoForViewDto implements IPagedResultExtendedDtoOfGetMeterInfoForViewDto {
    number!: number | undefined;
    totalCount!: number;
    items!: GetMeterInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultExtendedDtoOfGetMeterInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMeterInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultExtendedDtoOfGetMeterInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultExtendedDtoOfGetMeterInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultExtendedDtoOfGetMeterInfoForViewDto {
    number: number | undefined;
    totalCount: number;
    items: GetMeterInfoForViewDto[] | undefined;
}

export class PagedResultExtendedDtoOfGetVehicleInfoForViewDto implements IPagedResultExtendedDtoOfGetVehicleInfoForViewDto {
    number!: number | undefined;
    totalCount!: number;
    items!: GetVehicleInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultExtendedDtoOfGetVehicleInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetVehicleInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultExtendedDtoOfGetVehicleInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultExtendedDtoOfGetVehicleInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultExtendedDtoOfGetVehicleInfoForViewDto {
    number: number | undefined;
    totalCount: number;
    items: GetVehicleInfoForViewDto[] | undefined;
}

export class PagedResultForTabsDtoOfGetRequestsForViewDto implements IPagedResultForTabsDtoOfGetRequestsForViewDto {
    myRequestCount!: number;
    totalCount!: number;
    items!: GetRequestsForViewDto[] | undefined;

    constructor(data?: IPagedResultForTabsDtoOfGetRequestsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myRequestCount = _data["myRequestCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetRequestsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultForTabsDtoOfGetRequestsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultForTabsDtoOfGetRequestsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myRequestCount"] = this.myRequestCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultForTabsDtoOfGetRequestsForViewDto {
    myRequestCount: number;
    totalCount: number;
    items: GetRequestsForViewDto[] | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export class PickedByEntitiesViewDto implements IPickedByEntitiesViewDto {
    year!: number;
    organizationCode!: string | undefined;
    organizationName!: string | undefined;

    constructor(data?: IPickedByEntitiesViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.organizationCode = _data["organizationCode"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): PickedByEntitiesViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PickedByEntitiesViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["organizationCode"] = this.organizationCode;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface IPickedByEntitiesViewDto {
    year: number;
    organizationCode: string | undefined;
    organizationName: string | undefined;
}

export class PortfolioTotalCountDto implements IPortfolioTotalCountDto {
    meters!: number | undefined;
    buildings!: number | undefined;
    generators!: number | undefined;
    vehicles!: number | undefined;
    secMeters!: number | undefined;
    streetLights!: number | undefined;

    constructor(data?: IPortfolioTotalCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meters = _data["meters"];
            this.buildings = _data["buildings"];
            this.generators = _data["generators"];
            this.vehicles = _data["vehicles"];
            this.secMeters = _data["secMeters"];
            this.streetLights = _data["streetLights"];
        }
    }

    static fromJS(data: any): PortfolioTotalCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortfolioTotalCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meters"] = this.meters;
        data["buildings"] = this.buildings;
        data["generators"] = this.generators;
        data["vehicles"] = this.vehicles;
        data["secMeters"] = this.secMeters;
        data["streetLights"] = this.streetLights;
        return data;
    }
}

export interface IPortfolioTotalCountDto {
    meters: number | undefined;
    buildings: number | undefined;
    generators: number | undefined;
    vehicles: number | undefined;
    secMeters: number | undefined;
    streetLights: number | undefined;
}

export class ProRequestDto implements IProRequestDto {
    requestNumber!: string | undefined;
    requestTypeId!: number;
    requestStatusId!: number;
    actionerId!: number | undefined;
    entityId!: number;
    rejectionReason!: string | undefined;
    submitionDate!: DateTime | undefined;
    submittedByUserId!: number | undefined;
    organizationUnit!: OrganizationUnitDto;
    requestHistoryDto!: ProRequestHistoryDto[] | undefined;
    requestTypes!: LookupMapperDto;
    requestStatusFk!: LookupMapperDto;
    actioner!: UserViewDto;
    submittedByUser!: UserViewDto;
    createdByUser!: UserViewDto;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IProRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestStatusId = _data["requestStatusId"];
            this.actionerId = _data["actionerId"];
            this.entityId = _data["entityId"];
            this.rejectionReason = _data["rejectionReason"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.submittedByUserId = _data["submittedByUserId"];
            this.organizationUnit = _data["organizationUnit"] ? OrganizationUnitDto.fromJS(_data["organizationUnit"]) : <any>undefined;
            if (Array.isArray(_data["requestHistoryDto"])) {
                this.requestHistoryDto = [] as any;
                for (let item of _data["requestHistoryDto"])
                    this.requestHistoryDto!.push(ProRequestHistoryDto.fromJS(item));
            }
            this.requestTypes = _data["requestTypes"] ? LookupMapperDto.fromJS(_data["requestTypes"]) : <any>undefined;
            this.requestStatusFk = _data["requestStatusFk"] ? LookupMapperDto.fromJS(_data["requestStatusFk"]) : <any>undefined;
            this.actioner = _data["actioner"] ? UserViewDto.fromJS(_data["actioner"]) : <any>undefined;
            this.submittedByUser = _data["submittedByUser"] ? UserViewDto.fromJS(_data["submittedByUser"]) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? UserViewDto.fromJS(_data["createdByUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["requestTypeId"] = this.requestTypeId;
        data["requestStatusId"] = this.requestStatusId;
        data["actionerId"] = this.actionerId;
        data["entityId"] = this.entityId;
        data["rejectionReason"] = this.rejectionReason;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["submittedByUserId"] = this.submittedByUserId;
        data["organizationUnit"] = this.organizationUnit ? this.organizationUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.requestHistoryDto)) {
            data["requestHistoryDto"] = [];
            for (let item of this.requestHistoryDto)
                data["requestHistoryDto"].push(item.toJSON());
        }
        data["requestTypes"] = this.requestTypes ? this.requestTypes.toJSON() : <any>undefined;
        data["requestStatusFk"] = this.requestStatusFk ? this.requestStatusFk.toJSON() : <any>undefined;
        data["actioner"] = this.actioner ? this.actioner.toJSON() : <any>undefined;
        data["submittedByUser"] = this.submittedByUser ? this.submittedByUser.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProRequestDto {
    requestNumber: string | undefined;
    requestTypeId: number;
    requestStatusId: number;
    actionerId: number | undefined;
    entityId: number;
    rejectionReason: string | undefined;
    submitionDate: DateTime | undefined;
    submittedByUserId: number | undefined;
    organizationUnit: OrganizationUnitDto;
    requestHistoryDto: ProRequestHistoryDto[] | undefined;
    requestTypes: LookupMapperDto;
    requestStatusFk: LookupMapperDto;
    actioner: UserViewDto;
    submittedByUser: UserViewDto;
    createdByUser: UserViewDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ProRequestHistoryDto implements IProRequestHistoryDto {
    changeType!: ActionType;
    requestId!: number;
    affectedUserId!: number | undefined;
    requestNumber!: string | undefined;
    requestTypeId!: number;
    requestStatusId!: number;
    actionerId!: number | undefined;
    entityId!: number;
    rejectionReason!: string | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    requestLastModifierUserId!: number | undefined;
    requestLastModificationTime!: DateTime | undefined;
    requestJson!: string | undefined;

    constructor(data?: IProRequestHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeType = _data["changeType"];
            this.requestId = _data["requestId"];
            this.affectedUserId = _data["affectedUserId"];
            this.requestNumber = _data["requestNumber"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestStatusId = _data["requestStatusId"];
            this.actionerId = _data["actionerId"];
            this.entityId = _data["entityId"];
            this.rejectionReason = _data["rejectionReason"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.requestLastModifierUserId = _data["requestLastModifierUserId"];
            this.requestLastModificationTime = _data["requestLastModificationTime"] ? DateTime.fromISO(_data["requestLastModificationTime"].toString()) : <any>undefined;
            this.requestJson = _data["requestJson"];
        }
    }

    static fromJS(data: any): ProRequestHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProRequestHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeType"] = this.changeType;
        data["requestId"] = this.requestId;
        data["affectedUserId"] = this.affectedUserId;
        data["requestNumber"] = this.requestNumber;
        data["requestTypeId"] = this.requestTypeId;
        data["requestStatusId"] = this.requestStatusId;
        data["actionerId"] = this.actionerId;
        data["entityId"] = this.entityId;
        data["rejectionReason"] = this.rejectionReason;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["requestLastModifierUserId"] = this.requestLastModifierUserId;
        data["requestLastModificationTime"] = this.requestLastModificationTime ? this.requestLastModificationTime.toString() : <any>undefined;
        data["requestJson"] = this.requestJson;
        return data;
    }
}

export interface IProRequestHistoryDto {
    changeType: ActionType;
    requestId: number;
    affectedUserId: number | undefined;
    requestNumber: string | undefined;
    requestTypeId: number;
    requestStatusId: number;
    actionerId: number | undefined;
    entityId: number;
    rejectionReason: string | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    requestLastModifierUserId: number | undefined;
    requestLastModificationTime: DateTime | undefined;
    requestJson: string | undefined;
}

export class ProviderDataCharItem implements IProviderDataCharItem {
    consumption!: number;
    amount!: number;
    isExist!: boolean;
    months!: number;
    requestStatusId!: number;

    constructor(data?: IProviderDataCharItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumption = _data["consumption"];
            this.amount = _data["amount"];
            this.isExist = _data["isExist"];
            this.months = _data["months"];
            this.requestStatusId = _data["requestStatusId"];
        }
    }

    static fromJS(data: any): ProviderDataCharItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderDataCharItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumption"] = this.consumption;
        data["amount"] = this.amount;
        data["isExist"] = this.isExist;
        data["months"] = this.months;
        data["requestStatusId"] = this.requestStatusId;
        return data;
    }
}

export interface IProviderDataCharItem {
    consumption: number;
    amount: number;
    isExist: boolean;
    months: number;
    requestStatusId: number;
}

export class ProviderDataChart implements IProviderDataChart {
    claimAccount!: number;
    providerDataCharItems!: ProviderDataCharItem[] | undefined;
    totalConsumption!: number;
    totalAmount!: number;
    monthTotals!: MonthTotal[] | undefined;

    constructor(data?: IProviderDataChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claimAccount = _data["claimAccount"];
            if (Array.isArray(_data["providerDataCharItems"])) {
                this.providerDataCharItems = [] as any;
                for (let item of _data["providerDataCharItems"])
                    this.providerDataCharItems!.push(ProviderDataCharItem.fromJS(item));
            }
            this.totalConsumption = _data["totalConsumption"];
            this.totalAmount = _data["totalAmount"];
            if (Array.isArray(_data["monthTotals"])) {
                this.monthTotals = [] as any;
                for (let item of _data["monthTotals"])
                    this.monthTotals!.push(MonthTotal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderDataChart {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderDataChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claimAccount"] = this.claimAccount;
        if (Array.isArray(this.providerDataCharItems)) {
            data["providerDataCharItems"] = [];
            for (let item of this.providerDataCharItems)
                data["providerDataCharItems"].push(item.toJSON());
        }
        data["totalConsumption"] = this.totalConsumption;
        data["totalAmount"] = this.totalAmount;
        if (Array.isArray(this.monthTotals)) {
            data["monthTotals"] = [];
            for (let item of this.monthTotals)
                data["monthTotals"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProviderDataChart {
    claimAccount: number;
    providerDataCharItems: ProviderDataCharItem[] | undefined;
    totalConsumption: number;
    totalAmount: number;
    monthTotals: MonthTotal[] | undefined;
}

export class ProviderDataDto implements IProviderDataDto {
    year!: string | undefined;
    month!: number;
    claimAccountId!: number;
    meterNumber!: string | undefined;
    consumption!: number;
    amount!: number;
    organizationId!: number;
    requestId!: number;
    requestNumber!: string | undefined;
    requestStatusId!: number;
    requestStatus!: string | undefined;
    organizationUnit!: string | undefined;
    request!: RequestDto;
    claimAccount!: ClaimAccountDto;

    constructor(data?: IProviderDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.claimAccountId = _data["claimAccountId"];
            this.meterNumber = _data["meterNumber"];
            this.consumption = _data["consumption"];
            this.amount = _data["amount"];
            this.organizationId = _data["organizationId"];
            this.requestId = _data["requestId"];
            this.requestNumber = _data["requestNumber"];
            this.requestStatusId = _data["requestStatusId"];
            this.requestStatus = _data["requestStatus"];
            this.organizationUnit = _data["organizationUnit"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.claimAccount = _data["claimAccount"] ? ClaimAccountDto.fromJS(_data["claimAccount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["claimAccountId"] = this.claimAccountId;
        data["meterNumber"] = this.meterNumber;
        data["consumption"] = this.consumption;
        data["amount"] = this.amount;
        data["organizationId"] = this.organizationId;
        data["requestId"] = this.requestId;
        data["requestNumber"] = this.requestNumber;
        data["requestStatusId"] = this.requestStatusId;
        data["requestStatus"] = this.requestStatus;
        data["organizationUnit"] = this.organizationUnit;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["claimAccount"] = this.claimAccount ? this.claimAccount.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProviderDataDto {
    year: string | undefined;
    month: number;
    claimAccountId: number;
    meterNumber: string | undefined;
    consumption: number;
    amount: number;
    organizationId: number;
    requestId: number;
    requestNumber: string | undefined;
    requestStatusId: number;
    requestStatus: string | undefined;
    organizationUnit: string | undefined;
    request: RequestDto;
    claimAccount: ClaimAccountDto;
}

export class ProviderElectricityDto implements IProviderElectricityDto {
    year!: string | undefined;
    month!: number;
    claimAccountId!: number;
    meterNumber!: string | undefined;
    consumption!: number;
    amount!: number;
    organizationId!: number;
    requestId!: number | undefined;
    requestNumber!: string | undefined;
    requestStatusId!: number;
    requestStatus!: string | undefined;
    organizationUnit!: string | undefined;
    claimAccountDto!: ClaimAccountDto;
    isManuall!: boolean;
    isPartial!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IProviderElectricityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.claimAccountId = _data["claimAccountId"];
            this.meterNumber = _data["meterNumber"];
            this.consumption = _data["consumption"];
            this.amount = _data["amount"];
            this.organizationId = _data["organizationId"];
            this.requestId = _data["requestId"];
            this.requestNumber = _data["requestNumber"];
            this.requestStatusId = _data["requestStatusId"];
            this.requestStatus = _data["requestStatus"];
            this.organizationUnit = _data["organizationUnit"];
            this.claimAccountDto = _data["claimAccountDto"] ? ClaimAccountDto.fromJS(_data["claimAccountDto"]) : <any>undefined;
            this.isManuall = _data["isManuall"];
            this.isPartial = _data["isPartial"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProviderElectricityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderElectricityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["claimAccountId"] = this.claimAccountId;
        data["meterNumber"] = this.meterNumber;
        data["consumption"] = this.consumption;
        data["amount"] = this.amount;
        data["organizationId"] = this.organizationId;
        data["requestId"] = this.requestId;
        data["requestNumber"] = this.requestNumber;
        data["requestStatusId"] = this.requestStatusId;
        data["requestStatus"] = this.requestStatus;
        data["organizationUnit"] = this.organizationUnit;
        data["claimAccountDto"] = this.claimAccountDto ? this.claimAccountDto.toJSON() : <any>undefined;
        data["isManuall"] = this.isManuall;
        data["isPartial"] = this.isPartial;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProviderElectricityDto {
    year: string | undefined;
    month: number;
    claimAccountId: number;
    meterNumber: string | undefined;
    consumption: number;
    amount: number;
    organizationId: number;
    requestId: number | undefined;
    requestNumber: string | undefined;
    requestStatusId: number;
    requestStatus: string | undefined;
    organizationUnit: string | undefined;
    claimAccountDto: ClaimAccountDto;
    isManuall: boolean;
    isPartial: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class ReassignTechAdminDto implements IReassignTechAdminDto {
    requestId!: number;
    reassignTo!: number;

    constructor(data?: IReassignTechAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.reassignTo = _data["reassignTo"];
        }
    }

    static fromJS(data: any): ReassignTechAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReassignTechAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["reassignTo"] = this.reassignTo;
        return data;
    }
}

export interface IReassignTechAdminDto {
    requestId: number;
    reassignTo: number;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: DateTime;
}

export class ReferenceDto implements IReferenceDto {
    referenceTitle!: string | undefined;
    attachmentId!: string | undefined;
    referenceDescription!: string | undefined;
    targetedUsers!: string | undefined;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: string;

    constructor(data?: IReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceTitle = _data["referenceTitle"];
            this.attachmentId = _data["attachmentId"];
            this.referenceDescription = _data["referenceDescription"];
            this.targetedUsers = _data["targetedUsers"];
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceTitle"] = this.referenceTitle;
        data["attachmentId"] = this.attachmentId;
        data["referenceDescription"] = this.referenceDescription;
        data["targetedUsers"] = this.targetedUsers;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IReferenceDto {
    referenceTitle: string | undefined;
    attachmentId: string | undefined;
    referenceDescription: string | undefined;
    targetedUsers: string | undefined;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: string;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class RegionalStatCountry implements IRegionalStatCountry {
    countryName!: string | undefined;
    sales!: number;
    change!: number[] | undefined;
    averagePrice!: number;
    totalPrice!: number;

    constructor(data?: IRegionalStatCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            this.sales = _data["sales"];
            if (Array.isArray(_data["change"])) {
                this.change = [] as any;
                for (let item of _data["change"])
                    this.change!.push(item);
            }
            this.averagePrice = _data["averagePrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): RegionalStatCountry {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalStatCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IRegionalStatCountry {
    countryName: string | undefined;
    sales: number;
    change: number[] | undefined;
    averagePrice: number;
    totalPrice: number;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    editionId!: number | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.captchaResponse = _data["captchaResponse"];
            this.subscriptionStartType = _data["subscriptionStartType"];
            this.editionId = _data["editionId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    editionId: number | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isTenantActive = _data["isTenantActive"];
            this.isActive = _data["isActive"];
            this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class RenamePageInput implements IRenamePageInput {
    dashboardName!: string | undefined;
    id!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IRenamePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): RenamePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenamePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    }
}

export interface IRenamePageInput {
    dashboardName: string | undefined;
    id: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export enum ReportHalf {
    FirstHalf = 1,
    SecondHalf = 2,
}

export class RequestCompareResult implements IRequestCompareResult {
    equal!: boolean;
    mismatchedProperities!: MisMatchedItem[] | undefined;

    constructor(data?: IRequestCompareResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equal = _data["equal"];
            if (Array.isArray(_data["mismatchedProperities"])) {
                this.mismatchedProperities = [] as any;
                for (let item of _data["mismatchedProperities"])
                    this.mismatchedProperities!.push(MisMatchedItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestCompareResult {
        data = typeof data === 'object' ? data : {};
        let result = new RequestCompareResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equal"] = this.equal;
        if (Array.isArray(this.mismatchedProperities)) {
            data["mismatchedProperities"] = [];
            for (let item of this.mismatchedProperities)
                data["mismatchedProperities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequestCompareResult {
    equal: boolean;
    mismatchedProperities: MisMatchedItem[] | undefined;
}

export class RequestDto implements IRequestDto {
    requestJsonObject!: string | undefined;
    requestNumber!: string | undefined;
    requestTypeId!: RequestTypesEnum;
    requestStatusId!: RequestStatusEnum;
    isNotApplicable!: boolean;
    actionerId!: number | undefined;
    entityId!: number;
    rejectionReason!: string | undefined;
    submitionDate!: DateTime | undefined;
    submittedByUserId!: number | undefined;
    organizationUnit!: OrganizationUnitDto;
    requestHistoryDto!: RequestHistoryDto[] | undefined;
    requestTypesFk!: LookupMapperDto;
    requestStatusFk!: LookupMapperDto;
    actioner!: UserViewDto;
    submittedByUser!: UserViewDto;
    createdByUser!: UserViewDto;
    sectorName!: string | undefined;
    govElectricity!: GovElectricityDto;
    govFuel!: GovFuelDto;
    efficiencyPlan!: EfficiencyPlanDto;
    buildingEnergyEfficiencySubmission!: BuildingEnergyEfficiencySubmissionDto;
    providerElectricity!: ProviderElectricityDto;
    getFuelProviderDataForViewDto!: GetFuelProviderDataForViewDto;
    lastModificationTime!: DateTime | undefined;
    onTimeSubmitted!: boolean | undefined;
    trainingPackageRequest!: TrainingPackageRequestDto;
    trainingAttendanceRequest!: TrainingRequestDto;
    validSubmittionDate!: DateTime | undefined;
    attachments!: string | undefined;
    requestReasons!: string | undefined;
    baseRequestId!: number | undefined;
    baseRequest!: RequestDto;
    justificationId!: number | undefined;
    justification!: LookupMapperDto;
    seecTech!: UserViewDto;
    currentReviewerEntityId!: number | undefined;
    secSummeryConsumption!: SecSummeryConsumptionDto;
    id!: number;

    constructor(data?: IRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestJsonObject = _data["requestJsonObject"];
            this.requestNumber = _data["requestNumber"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestStatusId = _data["requestStatusId"];
            this.isNotApplicable = _data["isNotApplicable"];
            this.actionerId = _data["actionerId"];
            this.entityId = _data["entityId"];
            this.rejectionReason = _data["rejectionReason"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.submittedByUserId = _data["submittedByUserId"];
            this.organizationUnit = _data["organizationUnit"] ? OrganizationUnitDto.fromJS(_data["organizationUnit"]) : <any>undefined;
            if (Array.isArray(_data["requestHistoryDto"])) {
                this.requestHistoryDto = [] as any;
                for (let item of _data["requestHistoryDto"])
                    this.requestHistoryDto!.push(RequestHistoryDto.fromJS(item));
            }
            this.requestTypesFk = _data["requestTypesFk"] ? LookupMapperDto.fromJS(_data["requestTypesFk"]) : <any>undefined;
            this.requestStatusFk = _data["requestStatusFk"] ? LookupMapperDto.fromJS(_data["requestStatusFk"]) : <any>undefined;
            this.actioner = _data["actioner"] ? UserViewDto.fromJS(_data["actioner"]) : <any>undefined;
            this.submittedByUser = _data["submittedByUser"] ? UserViewDto.fromJS(_data["submittedByUser"]) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? UserViewDto.fromJS(_data["createdByUser"]) : <any>undefined;
            this.sectorName = _data["sectorName"];
            this.govElectricity = _data["govElectricity"] ? GovElectricityDto.fromJS(_data["govElectricity"]) : <any>undefined;
            this.govFuel = _data["govFuel"] ? GovFuelDto.fromJS(_data["govFuel"]) : <any>undefined;
            this.efficiencyPlan = _data["efficiencyPlan"] ? EfficiencyPlanDto.fromJS(_data["efficiencyPlan"]) : <any>undefined;
            this.buildingEnergyEfficiencySubmission = _data["buildingEnergyEfficiencySubmission"] ? BuildingEnergyEfficiencySubmissionDto.fromJS(_data["buildingEnergyEfficiencySubmission"]) : <any>undefined;
            this.providerElectricity = _data["providerElectricity"] ? ProviderElectricityDto.fromJS(_data["providerElectricity"]) : <any>undefined;
            this.getFuelProviderDataForViewDto = _data["getFuelProviderDataForViewDto"] ? GetFuelProviderDataForViewDto.fromJS(_data["getFuelProviderDataForViewDto"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.onTimeSubmitted = _data["onTimeSubmitted"];
            this.trainingPackageRequest = _data["trainingPackageRequest"] ? TrainingPackageRequestDto.fromJS(_data["trainingPackageRequest"]) : <any>undefined;
            this.trainingAttendanceRequest = _data["trainingAttendanceRequest"] ? TrainingRequestDto.fromJS(_data["trainingAttendanceRequest"]) : <any>undefined;
            this.validSubmittionDate = _data["validSubmittionDate"] ? DateTime.fromISO(_data["validSubmittionDate"].toString()) : <any>undefined;
            this.attachments = _data["attachments"];
            this.requestReasons = _data["requestReasons"];
            this.baseRequestId = _data["baseRequestId"];
            this.baseRequest = _data["baseRequest"] ? RequestDto.fromJS(_data["baseRequest"]) : <any>undefined;
            this.justificationId = _data["justificationId"];
            this.justification = _data["justification"] ? LookupMapperDto.fromJS(_data["justification"]) : <any>undefined;
            this.seecTech = _data["seecTech"] ? UserViewDto.fromJS(_data["seecTech"]) : <any>undefined;
            this.currentReviewerEntityId = _data["currentReviewerEntityId"];
            this.secSummeryConsumption = _data["secSummeryConsumption"] ? SecSummeryConsumptionDto.fromJS(_data["secSummeryConsumption"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestJsonObject"] = this.requestJsonObject;
        data["requestNumber"] = this.requestNumber;
        data["requestTypeId"] = this.requestTypeId;
        data["requestStatusId"] = this.requestStatusId;
        data["isNotApplicable"] = this.isNotApplicable;
        data["actionerId"] = this.actionerId;
        data["entityId"] = this.entityId;
        data["rejectionReason"] = this.rejectionReason;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["submittedByUserId"] = this.submittedByUserId;
        data["organizationUnit"] = this.organizationUnit ? this.organizationUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.requestHistoryDto)) {
            data["requestHistoryDto"] = [];
            for (let item of this.requestHistoryDto)
                data["requestHistoryDto"].push(item.toJSON());
        }
        data["requestTypesFk"] = this.requestTypesFk ? this.requestTypesFk.toJSON() : <any>undefined;
        data["requestStatusFk"] = this.requestStatusFk ? this.requestStatusFk.toJSON() : <any>undefined;
        data["actioner"] = this.actioner ? this.actioner.toJSON() : <any>undefined;
        data["submittedByUser"] = this.submittedByUser ? this.submittedByUser.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["sectorName"] = this.sectorName;
        data["govElectricity"] = this.govElectricity ? this.govElectricity.toJSON() : <any>undefined;
        data["govFuel"] = this.govFuel ? this.govFuel.toJSON() : <any>undefined;
        data["efficiencyPlan"] = this.efficiencyPlan ? this.efficiencyPlan.toJSON() : <any>undefined;
        data["buildingEnergyEfficiencySubmission"] = this.buildingEnergyEfficiencySubmission ? this.buildingEnergyEfficiencySubmission.toJSON() : <any>undefined;
        data["providerElectricity"] = this.providerElectricity ? this.providerElectricity.toJSON() : <any>undefined;
        data["getFuelProviderDataForViewDto"] = this.getFuelProviderDataForViewDto ? this.getFuelProviderDataForViewDto.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["onTimeSubmitted"] = this.onTimeSubmitted;
        data["trainingPackageRequest"] = this.trainingPackageRequest ? this.trainingPackageRequest.toJSON() : <any>undefined;
        data["trainingAttendanceRequest"] = this.trainingAttendanceRequest ? this.trainingAttendanceRequest.toJSON() : <any>undefined;
        data["validSubmittionDate"] = this.validSubmittionDate ? this.validSubmittionDate.toString() : <any>undefined;
        data["attachments"] = this.attachments;
        data["requestReasons"] = this.requestReasons;
        data["baseRequestId"] = this.baseRequestId;
        data["baseRequest"] = this.baseRequest ? this.baseRequest.toJSON() : <any>undefined;
        data["justificationId"] = this.justificationId;
        data["justification"] = this.justification ? this.justification.toJSON() : <any>undefined;
        data["seecTech"] = this.seecTech ? this.seecTech.toJSON() : <any>undefined;
        data["currentReviewerEntityId"] = this.currentReviewerEntityId;
        data["secSummeryConsumption"] = this.secSummeryConsumption ? this.secSummeryConsumption.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestDto {
    requestJsonObject: string | undefined;
    requestNumber: string | undefined;
    requestTypeId: RequestTypesEnum;
    requestStatusId: RequestStatusEnum;
    isNotApplicable: boolean;
    actionerId: number | undefined;
    entityId: number;
    rejectionReason: string | undefined;
    submitionDate: DateTime | undefined;
    submittedByUserId: number | undefined;
    organizationUnit: OrganizationUnitDto;
    requestHistoryDto: RequestHistoryDto[] | undefined;
    requestTypesFk: LookupMapperDto;
    requestStatusFk: LookupMapperDto;
    actioner: UserViewDto;
    submittedByUser: UserViewDto;
    createdByUser: UserViewDto;
    sectorName: string | undefined;
    govElectricity: GovElectricityDto;
    govFuel: GovFuelDto;
    efficiencyPlan: EfficiencyPlanDto;
    buildingEnergyEfficiencySubmission: BuildingEnergyEfficiencySubmissionDto;
    providerElectricity: ProviderElectricityDto;
    getFuelProviderDataForViewDto: GetFuelProviderDataForViewDto;
    lastModificationTime: DateTime | undefined;
    onTimeSubmitted: boolean | undefined;
    trainingPackageRequest: TrainingPackageRequestDto;
    trainingAttendanceRequest: TrainingRequestDto;
    validSubmittionDate: DateTime | undefined;
    attachments: string | undefined;
    requestReasons: string | undefined;
    baseRequestId: number | undefined;
    baseRequest: RequestDto;
    justificationId: number | undefined;
    justification: LookupMapperDto;
    seecTech: UserViewDto;
    currentReviewerEntityId: number | undefined;
    secSummeryConsumption: SecSummeryConsumptionDto;
    id: number;
}

export class RequestEditDto implements IRequestEditDto {
    requestNumber!: string | undefined;
    requestStatusId!: number;
    requestTypeId!: number;
    entityId!: number;
    actionerId!: number;
    rejectionReason!: string | undefined;
    requestJsonObject!: string | undefined;
    submitionDate!: DateTime | undefined;
    actioner!: UserViewDto;
    submittedByUser!: UserViewDto;
    createdByUser!: UserViewDto;
    requestTypesFk!: LookupMapperDto;
    requestStatusFk!: LookupMapperDto;
    attachmentTokens!: string[] | undefined;
    requestReasons!: string | undefined;
    organizationUnit!: OrganizationUnitDto;
    currentReviewerEntityId!: number;
    lastModificationTime!: DateTime | undefined;
    id!: number | undefined;

    constructor(data?: IRequestEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.requestStatusId = _data["requestStatusId"];
            this.requestTypeId = _data["requestTypeId"];
            this.entityId = _data["entityId"];
            this.actionerId = _data["actionerId"];
            this.rejectionReason = _data["rejectionReason"];
            this.requestJsonObject = _data["requestJsonObject"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.actioner = _data["actioner"] ? UserViewDto.fromJS(_data["actioner"]) : <any>undefined;
            this.submittedByUser = _data["submittedByUser"] ? UserViewDto.fromJS(_data["submittedByUser"]) : <any>undefined;
            this.createdByUser = _data["createdByUser"] ? UserViewDto.fromJS(_data["createdByUser"]) : <any>undefined;
            this.requestTypesFk = _data["requestTypesFk"] ? LookupMapperDto.fromJS(_data["requestTypesFk"]) : <any>undefined;
            this.requestStatusFk = _data["requestStatusFk"] ? LookupMapperDto.fromJS(_data["requestStatusFk"]) : <any>undefined;
            if (Array.isArray(_data["attachmentTokens"])) {
                this.attachmentTokens = [] as any;
                for (let item of _data["attachmentTokens"])
                    this.attachmentTokens!.push(item);
            }
            this.requestReasons = _data["requestReasons"];
            this.organizationUnit = _data["organizationUnit"] ? OrganizationUnitDto.fromJS(_data["organizationUnit"]) : <any>undefined;
            this.currentReviewerEntityId = _data["currentReviewerEntityId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["requestStatusId"] = this.requestStatusId;
        data["requestTypeId"] = this.requestTypeId;
        data["entityId"] = this.entityId;
        data["actionerId"] = this.actionerId;
        data["rejectionReason"] = this.rejectionReason;
        data["requestJsonObject"] = this.requestJsonObject;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["actioner"] = this.actioner ? this.actioner.toJSON() : <any>undefined;
        data["submittedByUser"] = this.submittedByUser ? this.submittedByUser.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["requestTypesFk"] = this.requestTypesFk ? this.requestTypesFk.toJSON() : <any>undefined;
        data["requestStatusFk"] = this.requestStatusFk ? this.requestStatusFk.toJSON() : <any>undefined;
        if (Array.isArray(this.attachmentTokens)) {
            data["attachmentTokens"] = [];
            for (let item of this.attachmentTokens)
                data["attachmentTokens"].push(item);
        }
        data["requestReasons"] = this.requestReasons;
        data["organizationUnit"] = this.organizationUnit ? this.organizationUnit.toJSON() : <any>undefined;
        data["currentReviewerEntityId"] = this.currentReviewerEntityId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestEditDto {
    requestNumber: string | undefined;
    requestStatusId: number;
    requestTypeId: number;
    entityId: number;
    actionerId: number;
    rejectionReason: string | undefined;
    requestJsonObject: string | undefined;
    submitionDate: DateTime | undefined;
    actioner: UserViewDto;
    submittedByUser: UserViewDto;
    createdByUser: UserViewDto;
    requestTypesFk: LookupMapperDto;
    requestStatusFk: LookupMapperDto;
    attachmentTokens: string[] | undefined;
    requestReasons: string | undefined;
    organizationUnit: OrganizationUnitDto;
    currentReviewerEntityId: number;
    lastModificationTime: DateTime | undefined;
    id: number | undefined;
}

export class RequestHistoryDto implements IRequestHistoryDto {
    actionDate!: DateTime;
    modifiedBy!: string | undefined;
    requestStatus_ar!: string | undefined;
    requestStatus!: string | undefined;
    requestTypeId!: number;
    requestType!: string | undefined;
    requestType_ar!: string | undefined;
    comment!: string | undefined;
    requestJson!: string | undefined;
    seecRequestStatus_ar!: string | undefined;
    isVisible!: boolean;

    constructor(data?: IRequestHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionDate = _data["actionDate"] ? DateTime.fromISO(_data["actionDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.requestStatus_ar = _data["requestStatus_ar"];
            this.requestStatus = _data["requestStatus"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestType = _data["requestType"];
            this.requestType_ar = _data["requestType_ar"];
            this.comment = _data["comment"];
            this.requestJson = _data["requestJson"];
            this.seecRequestStatus_ar = _data["seecRequestStatus_ar"];
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): RequestHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionDate"] = this.actionDate ? this.actionDate.toString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["requestStatus_ar"] = this.requestStatus_ar;
        data["requestStatus"] = this.requestStatus;
        data["requestTypeId"] = this.requestTypeId;
        data["requestType"] = this.requestType;
        data["requestType_ar"] = this.requestType_ar;
        data["comment"] = this.comment;
        data["requestJson"] = this.requestJson;
        data["seecRequestStatus_ar"] = this.seecRequestStatus_ar;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IRequestHistoryDto {
    actionDate: DateTime;
    modifiedBy: string | undefined;
    requestStatus_ar: string | undefined;
    requestStatus: string | undefined;
    requestTypeId: number;
    requestType: string | undefined;
    requestType_ar: string | undefined;
    comment: string | undefined;
    requestJson: string | undefined;
    seecRequestStatus_ar: string | undefined;
    isVisible: boolean;
}

export class RequestInputDto implements IRequestInputDto {
    rejectionReason!: string | undefined;
    requestNumber!: string | undefined;
    requestStatusId!: number;
    requestTypeId!: number;
    entityId!: number;
    actionerId!: number | undefined;
    requestJsonObject!: string | undefined;
    currentTeamLeadAction!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    isAutoApproval!: boolean | undefined;
    baseRequestId!: number | undefined;
    attachments!: string | undefined;
    requestReasons!: string | undefined;
    justificationId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IRequestInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rejectionReason = _data["rejectionReason"];
            this.requestNumber = _data["requestNumber"];
            this.requestStatusId = _data["requestStatusId"];
            this.requestTypeId = _data["requestTypeId"];
            this.entityId = _data["entityId"];
            this.actionerId = _data["actionerId"];
            this.requestJsonObject = _data["requestJsonObject"];
            this.currentTeamLeadAction = _data["currentTeamLeadAction"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isAutoApproval = _data["isAutoApproval"];
            this.baseRequestId = _data["baseRequestId"];
            this.attachments = _data["attachments"];
            this.requestReasons = _data["requestReasons"];
            this.justificationId = _data["justificationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rejectionReason"] = this.rejectionReason;
        data["requestNumber"] = this.requestNumber;
        data["requestStatusId"] = this.requestStatusId;
        data["requestTypeId"] = this.requestTypeId;
        data["entityId"] = this.entityId;
        data["actionerId"] = this.actionerId;
        data["requestJsonObject"] = this.requestJsonObject;
        data["currentTeamLeadAction"] = this.currentTeamLeadAction;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["isAutoApproval"] = this.isAutoApproval;
        data["baseRequestId"] = this.baseRequestId;
        data["attachments"] = this.attachments;
        data["requestReasons"] = this.requestReasons;
        data["justificationId"] = this.justificationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestInputDto {
    rejectionReason: string | undefined;
    requestNumber: string | undefined;
    requestStatusId: number;
    requestTypeId: number;
    entityId: number;
    actionerId: number | undefined;
    requestJsonObject: string | undefined;
    currentTeamLeadAction: number | undefined;
    lastModificationTime: DateTime | undefined;
    isAutoApproval: boolean | undefined;
    baseRequestId: number | undefined;
    attachments: string | undefined;
    requestReasons: string | undefined;
    justificationId: number | undefined;
    id: number | undefined;
}

export enum RequestListViewFilterEnum {
    NoFilter = 0,
    MyRequests = 1,
    AllSubmittedRequests = 2,
    AllOtherRequests = 3,
}

export class RequestMainInfoDto implements IRequestMainInfoDto {
    requestNumber!: string | undefined;
    requestStatus!: RequestStatusEnum;
    requestStatusId!: number | undefined;
    requestStatusName!: string | undefined;
    returnUrl!: string | undefined;
    year!: string | undefined;
    cycle!: string | undefined;
    totalConsumption!: number;

    constructor(data?: IRequestMainInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusId = _data["requestStatusId"];
            this.requestStatusName = _data["requestStatusName"];
            this.returnUrl = _data["returnUrl"];
            this.year = _data["year"];
            this.cycle = _data["cycle"];
            this.totalConsumption = _data["totalConsumption"];
        }
    }

    static fromJS(data: any): RequestMainInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestMainInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusId"] = this.requestStatusId;
        data["requestStatusName"] = this.requestStatusName;
        data["returnUrl"] = this.returnUrl;
        data["year"] = this.year;
        data["cycle"] = this.cycle;
        data["totalConsumption"] = this.totalConsumption;
        return data;
    }
}

export interface IRequestMainInfoDto {
    requestNumber: string | undefined;
    requestStatus: RequestStatusEnum;
    requestStatusId: number | undefined;
    requestStatusName: string | undefined;
    returnUrl: string | undefined;
    year: string | undefined;
    cycle: string | undefined;
    totalConsumption: number;
}

export class RequestPeriodSettingDto implements IRequestPeriodSettingDto {
    year!: string | undefined;
    fromDate!: DateTime | undefined;
    toDate!: DateTime | undefined;
    settingPeriodTypeId!: number;
    settingPeriodsRequestTypeId!: number;
    submissionCycleId!: number | undefined;
    isDefault!: boolean | undefined;
    isActive!: boolean | undefined;
    fromPeriod!: string | undefined;
    toPeriod!: string | undefined;
    id!: number;

    constructor(data?: IRequestPeriodSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.fromDate = _data["fromDate"] ? DateTime.fromISO(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? DateTime.fromISO(_data["toDate"].toString()) : <any>undefined;
            this.settingPeriodTypeId = _data["settingPeriodTypeId"];
            this.settingPeriodsRequestTypeId = _data["settingPeriodsRequestTypeId"];
            this.submissionCycleId = _data["submissionCycleId"];
            this.isDefault = _data["isDefault"];
            this.isActive = _data["isActive"];
            this.fromPeriod = _data["fromPeriod"];
            this.toPeriod = _data["toPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestPeriodSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPeriodSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["fromDate"] = this.fromDate ? this.fromDate.toString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toString() : <any>undefined;
        data["settingPeriodTypeId"] = this.settingPeriodTypeId;
        data["settingPeriodsRequestTypeId"] = this.settingPeriodsRequestTypeId;
        data["submissionCycleId"] = this.submissionCycleId;
        data["isDefault"] = this.isDefault;
        data["isActive"] = this.isActive;
        data["fromPeriod"] = this.fromPeriod;
        data["toPeriod"] = this.toPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestPeriodSettingDto {
    year: string | undefined;
    fromDate: DateTime | undefined;
    toDate: DateTime | undefined;
    settingPeriodTypeId: number;
    settingPeriodsRequestTypeId: number;
    submissionCycleId: number | undefined;
    isDefault: boolean | undefined;
    isActive: boolean | undefined;
    fromPeriod: string | undefined;
    toPeriod: string | undefined;
    id: number;
}

export class RequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto implements IRequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    name_En!: string | undefined;

    constructor(data?: IRequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.name_En = _data["name_En"];
        }
    }

    static fromJS(data: any): RequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["name_En"] = this.name_En;
        return data;
    }
}

export interface IRequestPeriodSettingSettingPeriodsRequestTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
    name_En: string | undefined;
}

export class RequestPeriodSettingSettingPeriodTypeLookupTableDto implements IRequestPeriodSettingSettingPeriodTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    nameEn!: string | undefined;

    constructor(data?: IRequestPeriodSettingSettingPeriodTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.nameEn = _data["nameEn"];
        }
    }

    static fromJS(data: any): RequestPeriodSettingSettingPeriodTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPeriodSettingSettingPeriodTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["nameEn"] = this.nameEn;
        return data;
    }
}

export interface IRequestPeriodSettingSettingPeriodTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
    nameEn: string | undefined;
}

export class RequestPeriodSettingSubmissionCycleLookupTableDto implements IRequestPeriodSettingSubmissionCycleLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    name_En!: string | undefined;

    constructor(data?: IRequestPeriodSettingSubmissionCycleLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.name_En = _data["name_En"];
        }
    }

    static fromJS(data: any): RequestPeriodSettingSubmissionCycleLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPeriodSettingSubmissionCycleLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["name_En"] = this.name_En;
        return data;
    }
}

export interface IRequestPeriodSettingSubmissionCycleLookupTableDto {
    id: number;
    displayName: string | undefined;
    name_En: string | undefined;
}

export enum RequestStatusEnum {
    Draft = 1,
    New = 2,
    Approved = 3,
    NeedMoreInformation = 4,
    Rejected = 5,
    NewEdited = 6,
    NewCorrected = 7,
    ApprovedInitially = 8,
    Archived = 9,
    RejectedBySeecAdmin = 10,
    UnderTierAReview = 11,
    RejectedByTierA = 12,
}

export enum RequestTypesEnum {
    CreateUser = 1,
    GovElectricityConsumption = 2,
    GovFuelConsumption = 3,
    FuelProvider = 4,
    ElectricityProvider = 5,
    EditUser = 6,
    DeleteUser = 7,
    EnergyEfficiencyPlan = 8,
    GovAwarnessContentPublication = 9,
    GovNewDesignerAwarnessContentPublication = 10,
    TrainingCourseAttendance = 11,
    TrainingPackageRequest = 12,
    DeactiveUser = 13,
    ActivateUser = 14,
    ReopenedRequest = 15,
    BuildingEnergyEfficiencySubmission = 16,
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName_ar!: string;
    displayName!: string | undefined;
    isDefault!: boolean;
    organizationTypeId!: number;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName_ar = _data["displayName_ar"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
            this.organizationTypeId = _data["organizationTypeId"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName_ar"] = this.displayName_ar;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        data["organizationTypeId"] = this.organizationTypeId;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName_ar: string;
    displayName: string | undefined;
    isDefault: boolean;
    organizationTypeId: number;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: DateTime;
    id: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number;
    profit!: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.sales = _data["sales"];
            this.profit = _data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number;
    profit: number;
}

export enum SalesSummaryDatePeriod {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class SavePageInput implements ISavePageInput {
    dashboardName!: string | undefined;
    application!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: ISavePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.application = _data["application"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SavePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["application"] = this.application;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISavePageInput {
    dashboardName: string | undefined;
    application: string | undefined;
    pages: Page[] | undefined;
}

export class SecMeterDto implements ISecMeterDto {
    id!: number;
    installationNumber!: string | undefined;
    seecCode!: string | undefined;
    createdAt!: DateTime;
    seecReviewMeterStatus!: SeecReviewMetersStatuses;
    seecReviewMeterStatusReason!: string | undefined;

    constructor(data?: ISecMeterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.installationNumber = _data["installationNumber"];
            this.seecCode = _data["seecCode"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : <any>undefined;
            this.seecReviewMeterStatus = _data["seecReviewMeterStatus"];
            this.seecReviewMeterStatusReason = _data["seecReviewMeterStatusReason"];
        }
    }

    static fromJS(data: any): SecMeterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecMeterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["installationNumber"] = this.installationNumber;
        data["seecCode"] = this.seecCode;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : <any>undefined;
        data["seecReviewMeterStatus"] = this.seecReviewMeterStatus;
        data["seecReviewMeterStatusReason"] = this.seecReviewMeterStatusReason;
        return data;
    }
}

export interface ISecMeterDto {
    id: number;
    installationNumber: string | undefined;
    seecCode: string | undefined;
    createdAt: DateTime;
    seecReviewMeterStatus: SeecReviewMetersStatuses;
    seecReviewMeterStatusReason: string | undefined;
}

export enum SecMeterReviewStatusFilter {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
}

export class SecMeterSnapshotDto implements ISecMeterSnapshotDto {
    id!: number;
    effectiveFrom!: DateTime;
    collectiveContract!: string | undefined;
    contractAccountName!: string | undefined;
    collectiveReferenceNumber!: string | undefined;
    typeOfCollective!: string | undefined;
    typeOfCollectiveDescription!: string | undefined;
    highMinistry!: string | undefined;
    ministry!: string | undefined;
    ministryDescription!: string | undefined;
    sectorCode!: string | undefined;
    sectorDescription!: string | undefined;
    departmentGovernmentCode!: string | undefined;
    departmentDescription!: string | undefined;
    region!: string | undefined;
    regionCode!: string | undefined;
    department!: string | undefined;
    departmentCode!: string | undefined;
    office!: string | undefined;
    officeCode!: string | undefined;
    xCoordinates!: number | undefined;
    yCoordinates!: number | undefined;
    blockingReason!: string | undefined;
    blockingReasonCode!: string | undefined;
    installationType!: string | undefined;
    installationTypeCode!: string | undefined;
    activeInstallation!: string | undefined;
    errorCode!: string | undefined;
    meterNumber!: string | undefined;
    breakerCapacity!: number | undefined;
    voltageLevel!: string | undefined;
    voltageLevelCode!: string | undefined;
    premiseNumber!: string | undefined;
    city!: string | undefined;
    serviceClass!: string | undefined;
    serviceClassCode!: string | undefined;
    unitCount!: number | undefined;
    rateCategory!: string | undefined;
    rateCategoryCode!: string | undefined;
    businessPartnerNumber!: string | undefined;
    businessPartnerName!: string | undefined;
    contractAccount!: string | undefined;
    billingClass!: string | undefined;
    creationDate!: DateTime | undefined;
    multiplicationFactor!: number | undefined;
    contractedLoad!: number | undefined;
    functionalId!: string | undefined;
    deviceCategory!: string | undefined;
    deviceInstallationDate!: DateTime | undefined;
    manufacturerSerialNumber!: string | undefined;
    amiGroupCode!: string | undefined;
    amiGroup!: string | undefined;

    constructor(data?: ISecMeterSnapshotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effectiveFrom = _data["effectiveFrom"] ? DateTime.fromISO(_data["effectiveFrom"].toString()) : <any>undefined;
            this.collectiveContract = _data["collectiveContract"];
            this.contractAccountName = _data["contractAccountName"];
            this.collectiveReferenceNumber = _data["collectiveReferenceNumber"];
            this.typeOfCollective = _data["typeOfCollective"];
            this.typeOfCollectiveDescription = _data["typeOfCollectiveDescription"];
            this.highMinistry = _data["highMinistry"];
            this.ministry = _data["ministry"];
            this.ministryDescription = _data["ministryDescription"];
            this.sectorCode = _data["sectorCode"];
            this.sectorDescription = _data["sectorDescription"];
            this.departmentGovernmentCode = _data["departmentGovernmentCode"];
            this.departmentDescription = _data["departmentDescription"];
            this.region = _data["region"];
            this.regionCode = _data["regionCode"];
            this.department = _data["department"];
            this.departmentCode = _data["departmentCode"];
            this.office = _data["office"];
            this.officeCode = _data["officeCode"];
            this.xCoordinates = _data["xCoordinates"];
            this.yCoordinates = _data["yCoordinates"];
            this.blockingReason = _data["blockingReason"];
            this.blockingReasonCode = _data["blockingReasonCode"];
            this.installationType = _data["installationType"];
            this.installationTypeCode = _data["installationTypeCode"];
            this.activeInstallation = _data["activeInstallation"];
            this.errorCode = _data["errorCode"];
            this.meterNumber = _data["meterNumber"];
            this.breakerCapacity = _data["breakerCapacity"];
            this.voltageLevel = _data["voltageLevel"];
            this.voltageLevelCode = _data["voltageLevelCode"];
            this.premiseNumber = _data["premiseNumber"];
            this.city = _data["city"];
            this.serviceClass = _data["serviceClass"];
            this.serviceClassCode = _data["serviceClassCode"];
            this.unitCount = _data["unitCount"];
            this.rateCategory = _data["rateCategory"];
            this.rateCategoryCode = _data["rateCategoryCode"];
            this.businessPartnerNumber = _data["businessPartnerNumber"];
            this.businessPartnerName = _data["businessPartnerName"];
            this.contractAccount = _data["contractAccount"];
            this.billingClass = _data["billingClass"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.multiplicationFactor = _data["multiplicationFactor"];
            this.contractedLoad = _data["contractedLoad"];
            this.functionalId = _data["functionalId"];
            this.deviceCategory = _data["deviceCategory"];
            this.deviceInstallationDate = _data["deviceInstallationDate"] ? DateTime.fromISO(_data["deviceInstallationDate"].toString()) : <any>undefined;
            this.manufacturerSerialNumber = _data["manufacturerSerialNumber"];
            this.amiGroupCode = _data["amiGroupCode"];
            this.amiGroup = _data["amiGroup"];
        }
    }

    static fromJS(data: any): SecMeterSnapshotDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecMeterSnapshotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toString() : <any>undefined;
        data["collectiveContract"] = this.collectiveContract;
        data["contractAccountName"] = this.contractAccountName;
        data["collectiveReferenceNumber"] = this.collectiveReferenceNumber;
        data["typeOfCollective"] = this.typeOfCollective;
        data["typeOfCollectiveDescription"] = this.typeOfCollectiveDescription;
        data["highMinistry"] = this.highMinistry;
        data["ministry"] = this.ministry;
        data["ministryDescription"] = this.ministryDescription;
        data["sectorCode"] = this.sectorCode;
        data["sectorDescription"] = this.sectorDescription;
        data["departmentGovernmentCode"] = this.departmentGovernmentCode;
        data["departmentDescription"] = this.departmentDescription;
        data["region"] = this.region;
        data["regionCode"] = this.regionCode;
        data["department"] = this.department;
        data["departmentCode"] = this.departmentCode;
        data["office"] = this.office;
        data["officeCode"] = this.officeCode;
        data["xCoordinates"] = this.xCoordinates;
        data["yCoordinates"] = this.yCoordinates;
        data["blockingReason"] = this.blockingReason;
        data["blockingReasonCode"] = this.blockingReasonCode;
        data["installationType"] = this.installationType;
        data["installationTypeCode"] = this.installationTypeCode;
        data["activeInstallation"] = this.activeInstallation;
        data["errorCode"] = this.errorCode;
        data["meterNumber"] = this.meterNumber;
        data["breakerCapacity"] = this.breakerCapacity;
        data["voltageLevel"] = this.voltageLevel;
        data["voltageLevelCode"] = this.voltageLevelCode;
        data["premiseNumber"] = this.premiseNumber;
        data["city"] = this.city;
        data["serviceClass"] = this.serviceClass;
        data["serviceClassCode"] = this.serviceClassCode;
        data["unitCount"] = this.unitCount;
        data["rateCategory"] = this.rateCategory;
        data["rateCategoryCode"] = this.rateCategoryCode;
        data["businessPartnerNumber"] = this.businessPartnerNumber;
        data["businessPartnerName"] = this.businessPartnerName;
        data["contractAccount"] = this.contractAccount;
        data["billingClass"] = this.billingClass;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["multiplicationFactor"] = this.multiplicationFactor;
        data["contractedLoad"] = this.contractedLoad;
        data["functionalId"] = this.functionalId;
        data["deviceCategory"] = this.deviceCategory;
        data["deviceInstallationDate"] = this.deviceInstallationDate ? this.deviceInstallationDate.toString() : <any>undefined;
        data["manufacturerSerialNumber"] = this.manufacturerSerialNumber;
        data["amiGroupCode"] = this.amiGroupCode;
        data["amiGroup"] = this.amiGroup;
        return data;
    }
}

export interface ISecMeterSnapshotDto {
    id: number;
    effectiveFrom: DateTime;
    collectiveContract: string | undefined;
    contractAccountName: string | undefined;
    collectiveReferenceNumber: string | undefined;
    typeOfCollective: string | undefined;
    typeOfCollectiveDescription: string | undefined;
    highMinistry: string | undefined;
    ministry: string | undefined;
    ministryDescription: string | undefined;
    sectorCode: string | undefined;
    sectorDescription: string | undefined;
    departmentGovernmentCode: string | undefined;
    departmentDescription: string | undefined;
    region: string | undefined;
    regionCode: string | undefined;
    department: string | undefined;
    departmentCode: string | undefined;
    office: string | undefined;
    officeCode: string | undefined;
    xCoordinates: number | undefined;
    yCoordinates: number | undefined;
    blockingReason: string | undefined;
    blockingReasonCode: string | undefined;
    installationType: string | undefined;
    installationTypeCode: string | undefined;
    activeInstallation: string | undefined;
    errorCode: string | undefined;
    meterNumber: string | undefined;
    breakerCapacity: number | undefined;
    voltageLevel: string | undefined;
    voltageLevelCode: string | undefined;
    premiseNumber: string | undefined;
    city: string | undefined;
    serviceClass: string | undefined;
    serviceClassCode: string | undefined;
    unitCount: number | undefined;
    rateCategory: string | undefined;
    rateCategoryCode: string | undefined;
    businessPartnerNumber: string | undefined;
    businessPartnerName: string | undefined;
    contractAccount: string | undefined;
    billingClass: string | undefined;
    creationDate: DateTime | undefined;
    multiplicationFactor: number | undefined;
    contractedLoad: number | undefined;
    functionalId: string | undefined;
    deviceCategory: string | undefined;
    deviceInstallationDate: DateTime | undefined;
    manufacturerSerialNumber: string | undefined;
    amiGroupCode: string | undefined;
    amiGroup: string | undefined;
}

export class SecSummeryConsumptionDto implements ISecSummeryConsumptionDto {
    totalBillAmount!: number;
    totalConsumptionKwh!: number;
    totalConsumptionKva!: number;

    constructor(data?: ISecSummeryConsumptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalBillAmount = _data["totalBillAmount"];
            this.totalConsumptionKwh = _data["totalConsumptionKwh"];
            this.totalConsumptionKva = _data["totalConsumptionKva"];
        }
    }

    static fromJS(data: any): SecSummeryConsumptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecSummeryConsumptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalBillAmount"] = this.totalBillAmount;
        data["totalConsumptionKwh"] = this.totalConsumptionKwh;
        data["totalConsumptionKva"] = this.totalConsumptionKva;
        return data;
    }
}

export interface ISecSummeryConsumptionDto {
    totalBillAmount: number;
    totalConsumptionKwh: number;
    totalConsumptionKva: number;
}

export class SectorDto implements ISectorDto {
    name_En!: string | undefined;
    name_Ar!: string | undefined;
    code!: string | undefined;
    id!: number;

    constructor(data?: ISectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name_En = _data["name_En"];
            this.name_Ar = _data["name_Ar"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name_En"] = this.name_En;
        data["name_Ar"] = this.name_Ar;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface ISectorDto {
    name_En: string | undefined;
    name_Ar: string | undefined;
    code: string | undefined;
    id: number;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser!: boolean;
    isNafathLoginEnabled!: boolean;
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting;
    defaultPasswordComplexity!: PasswordComplexitySetting;
    userLockOut!: UserLockOutSettingsEditDto;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowOneConcurrentLoginPerUser = _data["allowOneConcurrentLoginPerUser"];
            this.isNafathLoginEnabled = _data["isNafathLoginEnabled"];
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["isNafathLoginEnabled"] = this.isNafathLoginEnabled;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser: boolean;
    isNafathLoginEnabled: boolean;
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class SeecEmailDto implements ISeecEmailDto {
    receiverEmailAddress!: string | undefined;
    emailSubject!: string | undefined;
    emailBody!: string | undefined;
    isSent!: boolean;
    errorType!: string | undefined;
    errorCode!: string | undefined;
    errorMessage!: string | undefined;
    reTryCounter!: number;
    machineName!: string | undefined;
    dateCreated!: DateTime;
    dateUpdated!: DateTime;
    attachmentFile!: string | undefined;
    addtionalData!: string | undefined;
    templateId!: number;
    id!: number;

    constructor(data?: ISeecEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiverEmailAddress = _data["receiverEmailAddress"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.isSent = _data["isSent"];
            this.errorType = _data["errorType"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.reTryCounter = _data["reTryCounter"];
            this.machineName = _data["machineName"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.attachmentFile = _data["attachmentFile"];
            this.addtionalData = _data["addtionalData"];
            this.templateId = _data["templateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeecEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeecEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiverEmailAddress"] = this.receiverEmailAddress;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["isSent"] = this.isSent;
        data["errorType"] = this.errorType;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["reTryCounter"] = this.reTryCounter;
        data["machineName"] = this.machineName;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["attachmentFile"] = this.attachmentFile;
        data["addtionalData"] = this.addtionalData;
        data["templateId"] = this.templateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeecEmailDto {
    receiverEmailAddress: string | undefined;
    emailSubject: string | undefined;
    emailBody: string | undefined;
    isSent: boolean;
    errorType: string | undefined;
    errorCode: string | undefined;
    errorMessage: string | undefined;
    reTryCounter: number;
    machineName: string | undefined;
    dateCreated: DateTime;
    dateUpdated: DateTime;
    attachmentFile: string | undefined;
    addtionalData: string | undefined;
    templateId: number;
    id: number;
}

export class SeecEmailEmailTemplateLookupTableDto implements ISeecEmailEmailTemplateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeecEmailEmailTemplateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeecEmailEmailTemplateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeecEmailEmailTemplateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeecEmailEmailTemplateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeecEmailTemplateDto implements ISeecEmailTemplateDto {
    name!: string | undefined;
    emailSubject!: string | undefined;
    emailBody!: string | undefined;
    isTemplateActive!: boolean;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    id!: number;

    constructor(data?: ISeecEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.isTemplateActive = _data["isTemplateActive"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeecEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeecEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["isTemplateActive"] = this.isTemplateActive;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeecEmailTemplateDto {
    name: string | undefined;
    emailSubject: string | undefined;
    emailBody: string | undefined;
    isTemplateActive: boolean;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    id: number;
}

export enum SeecReviewMetersStatuses {
    Approved = 1,
    Rejected = 2,
}

export class SeecSettingsEditDto implements ISeecSettingsEditDto {
    loginPeriodValue!: number;
    electricityRequestPeriodValue!: number;
    fuelRequestPeriodValue!: number;
    eepRequestPeriodValue!: number;
    gracePeriodValue!: number;
    kwhPriceValue!: string | undefined;
    noOfDaysForGovRequestAutoApprovalValue!: number;

    constructor(data?: ISeecSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginPeriodValue = _data["loginPeriodValue"];
            this.electricityRequestPeriodValue = _data["electricityRequestPeriodValue"];
            this.fuelRequestPeriodValue = _data["fuelRequestPeriodValue"];
            this.eepRequestPeriodValue = _data["eepRequestPeriodValue"];
            this.gracePeriodValue = _data["gracePeriodValue"];
            this.kwhPriceValue = _data["kwhPriceValue"];
            this.noOfDaysForGovRequestAutoApprovalValue = _data["noOfDaysForGovRequestAutoApprovalValue"];
        }
    }

    static fromJS(data: any): SeecSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeecSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginPeriodValue"] = this.loginPeriodValue;
        data["electricityRequestPeriodValue"] = this.electricityRequestPeriodValue;
        data["fuelRequestPeriodValue"] = this.fuelRequestPeriodValue;
        data["eepRequestPeriodValue"] = this.eepRequestPeriodValue;
        data["gracePeriodValue"] = this.gracePeriodValue;
        data["kwhPriceValue"] = this.kwhPriceValue;
        data["noOfDaysForGovRequestAutoApprovalValue"] = this.noOfDaysForGovRequestAutoApprovalValue;
        return data;
    }
}

export interface ISeecSettingsEditDto {
    loginPeriodValue: number;
    electricityRequestPeriodValue: number;
    fuelRequestPeriodValue: number;
    eepRequestPeriodValue: number;
    gracePeriodValue: number;
    kwhPriceValue: string | undefined;
    noOfDaysForGovRequestAutoApprovalValue: number;
}

export class SeecSMSDto implements ISeecSMSDto {
    mobileNumber!: string | undefined;
    messageBody!: string | undefined;
    isDeliveryRequired!: boolean;
    transactionID!: string | undefined;
    type!: string | undefined;
    isSent!: boolean;
    errorType!: string | undefined;
    errorCode!: string | undefined;
    errorMessage!: string | undefined;
    reTryCounter!: number;
    machineName!: string | undefined;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    sentDatetime!: DateTime | undefined;
    addtionalData!: string | undefined;
    smsTemplateId!: number;
    id!: number;

    constructor(data?: ISeecSMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileNumber = _data["mobileNumber"];
            this.messageBody = _data["messageBody"];
            this.isDeliveryRequired = _data["isDeliveryRequired"];
            this.transactionID = _data["transactionID"];
            this.type = _data["type"];
            this.isSent = _data["isSent"];
            this.errorType = _data["errorType"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.reTryCounter = _data["reTryCounter"];
            this.machineName = _data["machineName"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.sentDatetime = _data["sentDatetime"] ? DateTime.fromISO(_data["sentDatetime"].toString()) : <any>undefined;
            this.addtionalData = _data["addtionalData"];
            this.smsTemplateId = _data["smsTemplateId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeecSMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeecSMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileNumber"] = this.mobileNumber;
        data["messageBody"] = this.messageBody;
        data["isDeliveryRequired"] = this.isDeliveryRequired;
        data["transactionID"] = this.transactionID;
        data["type"] = this.type;
        data["isSent"] = this.isSent;
        data["errorType"] = this.errorType;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["reTryCounter"] = this.reTryCounter;
        data["machineName"] = this.machineName;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["sentDatetime"] = this.sentDatetime ? this.sentDatetime.toString() : <any>undefined;
        data["addtionalData"] = this.addtionalData;
        data["smsTemplateId"] = this.smsTemplateId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeecSMSDto {
    mobileNumber: string | undefined;
    messageBody: string | undefined;
    isDeliveryRequired: boolean;
    transactionID: string | undefined;
    type: string | undefined;
    isSent: boolean;
    errorType: string | undefined;
    errorCode: string | undefined;
    errorMessage: string | undefined;
    reTryCounter: number;
    machineName: string | undefined;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    sentDatetime: DateTime | undefined;
    addtionalData: string | undefined;
    smsTemplateId: number;
    id: number;
}

export class SeecSMSSmsTemplateLookupTableDto implements ISeecSMSSmsTemplateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISeecSMSSmsTemplateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SeecSMSSmsTemplateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeecSMSSmsTemplateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISeecSMSSmsTemplateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SeecSmsTemplateDto implements ISeecSmsTemplateDto {
    name!: string | undefined;
    smsTemplateBody!: string | undefined;
    isTemplateActive!: boolean;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    gracePeriod!: string | undefined;
    description!: string | undefined;
    actor!: string | undefined;
    parameter!: string | undefined;
    addtionalData!: string | undefined;
    id!: number;

    constructor(data?: ISeecSmsTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.smsTemplateBody = _data["smsTemplateBody"];
            this.isTemplateActive = _data["isTemplateActive"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.gracePeriod = _data["gracePeriod"];
            this.description = _data["description"];
            this.actor = _data["actor"];
            this.parameter = _data["parameter"];
            this.addtionalData = _data["addtionalData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SeecSmsTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeecSmsTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["smsTemplateBody"] = this.smsTemplateBody;
        data["isTemplateActive"] = this.isTemplateActive;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["gracePeriod"] = this.gracePeriod;
        data["description"] = this.description;
        data["actor"] = this.actor;
        data["parameter"] = this.parameter;
        data["addtionalData"] = this.addtionalData;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeecSmsTemplateDto {
    name: string | undefined;
    smsTemplateBody: string | undefined;
    isTemplateActive: boolean;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    gracePeriod: string | undefined;
    description: string | undefined;
    actor: string | undefined;
    parameter: string | undefined;
    addtionalData: string | undefined;
    id: number;
}

export class SeecTechInfo implements ISeecTechInfo {
    name!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: ISeecTechInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SeecTechInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SeecTechInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISeecTechInfo {
    name: string | undefined;
    phoneNumber: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string | undefined;
    userName!: string;
    captchaResponse!: string | undefined;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.userName = _data["userName"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["userName"] = this.userName;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string | undefined;
    userName: string;
    captchaResponse: string | undefined;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string;
    captchaResponse!: string | undefined;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
    captchaResponse: string | undefined;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled!: boolean;
    timeOutSecond!: number;
    showTimeOutNotificationSecond!: number;
    showLockScreenWhenTimedOut!: boolean;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.timeOutSecond = _data["timeOutSecond"];
            this.showTimeOutNotificationSecond = _data["showTimeOutNotificationSecond"];
            this.showLockScreenWhenTimedOut = _data["showLockScreenWhenTimedOut"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
        return data;
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled: boolean;
    timeOutSecond: number;
    showTimeOutNotificationSecond: number;
    showLockScreenWhenTimedOut: boolean;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export enum SettingScopes {
    Application = 1,
    Tenant = 2,
    User = 4,
    All = 7,
}

export class SMSDto implements ISMSDto {
    mobileNumber!: string | undefined;
    messageBody!: string | undefined;
    isDeliveryRequired!: boolean;
    isSent!: boolean;
    errorType!: string | undefined;
    errorCode!: string | undefined;
    errorMessage!: string | undefined;
    reTryCounter!: number;
    machineName!: string | undefined;
    dateCreated!: DateTime;
    dateUpdated!: DateTime | undefined;
    sentDatetime!: DateTime | undefined;
    id!: number;

    constructor(data?: ISMSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileNumber = _data["mobileNumber"];
            this.messageBody = _data["messageBody"];
            this.isDeliveryRequired = _data["isDeliveryRequired"];
            this.isSent = _data["isSent"];
            this.errorType = _data["errorType"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.reTryCounter = _data["reTryCounter"];
            this.machineName = _data["machineName"];
            this.dateCreated = _data["dateCreated"] ? DateTime.fromISO(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? DateTime.fromISO(_data["dateUpdated"].toString()) : <any>undefined;
            this.sentDatetime = _data["sentDatetime"] ? DateTime.fromISO(_data["sentDatetime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SMSDto {
        data = typeof data === 'object' ? data : {};
        let result = new SMSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileNumber"] = this.mobileNumber;
        data["messageBody"] = this.messageBody;
        data["isDeliveryRequired"] = this.isDeliveryRequired;
        data["isSent"] = this.isSent;
        data["errorType"] = this.errorType;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["reTryCounter"] = this.reTryCounter;
        data["machineName"] = this.machineName;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toString() : <any>undefined;
        data["sentDatetime"] = this.sentDatetime ? this.sentDatetime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISMSDto {
    mobileNumber: string | undefined;
    messageBody: string | undefined;
    isDeliveryRequired: boolean;
    isSent: boolean;
    errorType: string | undefined;
    errorCode: string | undefined;
    errorMessage: string | undefined;
    reTryCounter: number;
    machineName: string | undefined;
    dateCreated: DateTime;
    dateUpdated: DateTime | undefined;
    sentDatetime: DateTime | undefined;
    id: number;
}

export class SmsTemplateDto implements ISmsTemplateDto {
    id!: number;

    constructor(data?: ISmsTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SmsTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmsTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISmsTemplateDto {
    id: number;
}

export class StreetlightAssetInfoDto implements IStreetlightAssetInfoDto {
    refrenceNumber!: string | undefined;
    organizationUnitId!: number;
    description!: string | undefined;
    regionId!: number;
    cityName!: string | undefined;
    lightingTypeId!: number;
    numberOfStreetlights!: number;
    yearBuilt!: string | undefined;
    lastRetrofitYear!: string | undefined;
    operationalStatus!: number;
    maintenanceCycle!: number;
    tarshidRetrofit!: boolean;
    serviceProviderId!: number;
    seAccountNumber!: string | undefined;
    operatingHoursPerWeek!: number;
    operationStartTime!: string | undefined;
    notes!: string | undefined;
    attachments!: string | undefined;
    addedStatusId!: number | undefined;
    createdAt!: DateTime | undefined;
    id!: number;

    constructor(data?: IStreetlightAssetInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refrenceNumber = _data["refrenceNumber"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.description = _data["description"];
            this.regionId = _data["regionId"];
            this.cityName = _data["cityName"];
            this.lightingTypeId = _data["lightingTypeId"];
            this.numberOfStreetlights = _data["numberOfStreetlights"];
            this.yearBuilt = _data["yearBuilt"];
            this.lastRetrofitYear = _data["lastRetrofitYear"];
            this.operationalStatus = _data["operationalStatus"];
            this.maintenanceCycle = _data["maintenanceCycle"];
            this.tarshidRetrofit = _data["tarshidRetrofit"];
            this.serviceProviderId = _data["serviceProviderId"];
            this.seAccountNumber = _data["seAccountNumber"];
            this.operatingHoursPerWeek = _data["operatingHoursPerWeek"];
            this.operationStartTime = _data["operationStartTime"];
            this.notes = _data["notes"];
            this.attachments = _data["attachments"];
            this.addedStatusId = _data["addedStatusId"];
            this.createdAt = _data["createdAt"] ? DateTime.fromISO(_data["createdAt"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StreetlightAssetInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new StreetlightAssetInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refrenceNumber"] = this.refrenceNumber;
        data["organizationUnitId"] = this.organizationUnitId;
        data["description"] = this.description;
        data["regionId"] = this.regionId;
        data["cityName"] = this.cityName;
        data["lightingTypeId"] = this.lightingTypeId;
        data["numberOfStreetlights"] = this.numberOfStreetlights;
        data["yearBuilt"] = this.yearBuilt;
        data["lastRetrofitYear"] = this.lastRetrofitYear;
        data["operationalStatus"] = this.operationalStatus;
        data["maintenanceCycle"] = this.maintenanceCycle;
        data["tarshidRetrofit"] = this.tarshidRetrofit;
        data["serviceProviderId"] = this.serviceProviderId;
        data["seAccountNumber"] = this.seAccountNumber;
        data["operatingHoursPerWeek"] = this.operatingHoursPerWeek;
        data["operationStartTime"] = this.operationStartTime;
        data["notes"] = this.notes;
        data["attachments"] = this.attachments;
        data["addedStatusId"] = this.addedStatusId;
        data["createdAt"] = this.createdAt ? this.createdAt.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IStreetlightAssetInfoDto {
    refrenceNumber: string | undefined;
    organizationUnitId: number;
    description: string | undefined;
    regionId: number;
    cityName: string | undefined;
    lightingTypeId: number;
    numberOfStreetlights: number;
    yearBuilt: string | undefined;
    lastRetrofitYear: string | undefined;
    operationalStatus: number;
    maintenanceCycle: number;
    tarshidRetrofit: boolean;
    serviceProviderId: number;
    seAccountNumber: string | undefined;
    operatingHoursPerWeek: number;
    operationStartTime: string | undefined;
    notes: string | undefined;
    attachments: string | undefined;
    addedStatusId: number | undefined;
    createdAt: DateTime | undefined;
    id: number;
}

export class StringOutput implements IStringOutput {
    output!: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class SubActivityDto implements ISubActivityDto {
    name_Ar!: string | undefined;
    explanationText!: string | undefined;
    isCheckedByDefault!: boolean;
    mainActivityId!: number;
    correctiveSteps!: string | undefined;
    isChecked!: boolean;
    isFollowExecusion!: boolean | undefined;
    organizationActivityDetailsId!: number;
    isVisible!: boolean;
    id!: number;

    constructor(data?: ISubActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name_Ar = _data["name_Ar"];
            this.explanationText = _data["explanationText"];
            this.isCheckedByDefault = _data["isCheckedByDefault"];
            this.mainActivityId = _data["mainActivityId"];
            this.correctiveSteps = _data["correctiveSteps"];
            this.isChecked = _data["isChecked"];
            this.isFollowExecusion = _data["isFollowExecusion"];
            this.organizationActivityDetailsId = _data["organizationActivityDetailsId"];
            this.isVisible = _data["isVisible"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name_Ar"] = this.name_Ar;
        data["explanationText"] = this.explanationText;
        data["isCheckedByDefault"] = this.isCheckedByDefault;
        data["mainActivityId"] = this.mainActivityId;
        data["correctiveSteps"] = this.correctiveSteps;
        data["isChecked"] = this.isChecked;
        data["isFollowExecusion"] = this.isFollowExecusion;
        data["organizationActivityDetailsId"] = this.organizationActivityDetailsId;
        data["isVisible"] = this.isVisible;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubActivityDto {
    name_Ar: string | undefined;
    explanationText: string | undefined;
    isCheckedByDefault: boolean;
    mainActivityId: number;
    correctiveSteps: string | undefined;
    isChecked: boolean;
    isFollowExecusion: boolean | undefined;
    organizationActivityDetailsId: number;
    isVisible: boolean;
    id: number;
}

export class SubActivityMainActivityLookupTableDto implements ISubActivityMainActivityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISubActivityMainActivityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SubActivityMainActivityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivityMainActivityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISubActivityMainActivityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFree = _data["isFree"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export enum SubscriptionStartType {
    Free = 1,
    Trial = 2,
    Paid = 3,
}

export class SumbitRequestInput implements ISumbitRequestInput {
    requestJson!: string | undefined;
    requestId!: number;
    requestTypeId!: number;

    constructor(data?: ISumbitRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestJson = _data["requestJson"];
            this.requestId = _data["requestId"];
            this.requestTypeId = _data["requestTypeId"];
        }
    }

    static fromJS(data: any): SumbitRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new SumbitRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestJson"] = this.requestJson;
        data["requestId"] = this.requestId;
        data["requestTypeId"] = this.requestTypeId;
        return data;
    }
}

export interface ISumbitRequestInput {
    requestJson: string | undefined;
    requestId: number;
    requestTypeId: number;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class TechAdminUserListFilter implements ITechAdminUserListFilter {
    execludeRoleId!: number;
    isCurrentUserTechAdmin!: boolean;
    filterUnitIds!: string[] | undefined;
    filterSectorIds!: string[] | undefined;

    constructor(data?: ITechAdminUserListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.execludeRoleId = _data["execludeRoleId"];
            this.isCurrentUserTechAdmin = _data["isCurrentUserTechAdmin"];
            if (Array.isArray(_data["filterUnitIds"])) {
                this.filterUnitIds = [] as any;
                for (let item of _data["filterUnitIds"])
                    this.filterUnitIds!.push(item);
            }
            if (Array.isArray(_data["filterSectorIds"])) {
                this.filterSectorIds = [] as any;
                for (let item of _data["filterSectorIds"])
                    this.filterSectorIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TechAdminUserListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TechAdminUserListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["execludeRoleId"] = this.execludeRoleId;
        data["isCurrentUserTechAdmin"] = this.isCurrentUserTechAdmin;
        if (Array.isArray(this.filterUnitIds)) {
            data["filterUnitIds"] = [];
            for (let item of this.filterUnitIds)
                data["filterUnitIds"].push(item);
        }
        if (Array.isArray(this.filterSectorIds)) {
            data["filterSectorIds"] = [];
            for (let item of this.filterSectorIds)
                data["filterSectorIds"].push(item);
        }
        return data;
    }
}

export interface ITechAdminUserListFilter {
    execludeRoleId: number;
    isCurrentUserTechAdmin: boolean;
    filterUnitIds: string[] | undefined;
    filterSectorIds: string[] | undefined;
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings!: boolean;
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings: boolean;
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    subscriptionEndDateUtc!: DateTime | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: DateTime;
    subscriptionEndDateUtc: DateTime | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    featureValues!: NameValueDto[] | undefined;
    creationTime!: DateTime;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    featureValues: NameValueDto[] | undefined;
    creationTime: DateTime;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.defaultEditionId = _data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityType!: string | undefined;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: DateTime;
    id!: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"];
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: DateTime;
    id: string;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto;
    ldap!: LdapSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto;
    otherSettings!: TenantOtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : <any>undefined;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : <any>undefined;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : <any>undefined;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    otherSettings: TenantOtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    useCaptchaOnRegistration!: boolean;
    useCaptchaOnLogin!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
    useCaptchaOnLogin: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader!: boolean;
    mobileFixedHeader!: boolean;
    headerSkin!: string | undefined;
    minimizeDesktopHeaderType!: string | undefined;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedHeader = _data["desktopFixedHeader"];
            this.mobileFixedHeader = _data["mobileFixedHeader"];
            this.headerSkin = _data["headerSkin"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        return data;
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    headerSkin: string | undefined;
    minimizeDesktopHeaderType: string | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        return data;
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;
    enableSecondary!: boolean;
    hoverableAside!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.searchActive = _data["searchActive"];
            this.enableSecondary = _data["enableSecondary"];
            this.hoverableAside = _data["hoverableAside"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        data["enableSecondary"] = this.enableSecondary;
        data["hoverableAside"] = this.hoverableAside;
        return data;
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
    enableSecondary: boolean;
    hoverableAside: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : <any>undefined;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : <any>undefined;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : <any>undefined;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : <any>undefined;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;
    subheaderSize!: number;
    titleStlye!: string | undefined;
    containerStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
            this.subheaderSize = _data["subheaderSize"];
            this.titleStlye = _data["titleStlye"];
            this.containerStyle = _data["containerStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        data["subheaderSize"] = this.subheaderSize;
        data["titleStlye"] = this.titleStlye;
        data["containerStyle"] = this.containerStyle;
        return data;
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
    subheaderSize: number;
    titleStlye: string | undefined;
    containerStyle: string | undefined;
}

export class TopicDto implements ITopicDto {
    topicName!: string | undefined;
    createdOn!: DateTime;
    createdBy!: string | undefined;
    lastModifiedOn!: DateTime | undefined;
    lastModifiedBy!: string | undefined;
    id!: number;

    constructor(data?: ITopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicName = _data["topicName"];
            this.createdOn = _data["createdOn"] ? DateTime.fromISO(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? DateTime.fromISO(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicName"] = this.topicName;
        data["createdOn"] = this.createdOn ? this.createdOn.toString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["id"] = this.id;
        return data;
    }
}

export interface ITopicDto {
    topicName: string | undefined;
    createdOn: DateTime;
    createdBy: string | undefined;
    lastModifiedOn: DateTime | undefined;
    lastModifiedBy: string | undefined;
    id: number;
}

export class TopStatsData implements ITopStatsData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;

    constructor(data?: ITopStatsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newTenantsCount = _data["newTenantsCount"];
            this.newSubscriptionAmount = _data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
        }
    }

    static fromJS(data: any): TopStatsData {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data;
    }
}

export interface ITopStatsData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
}

export class TrainingPackageDetailsDto implements ITrainingPackageDetailsDto {
    recordIndex!: number | undefined;
    expectedTrainingDateFrom!: DateTime | undefined;
    expectedTrainingDateTo!: DateTime | undefined;
    courseTypeId!: number | undefined;
    trainingPackageRequestId!: number | undefined;
    courseTypeName!: string | undefined;
    id!: number;

    constructor(data?: ITrainingPackageDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordIndex = _data["recordIndex"];
            this.expectedTrainingDateFrom = _data["expectedTrainingDateFrom"] ? DateTime.fromISO(_data["expectedTrainingDateFrom"].toString()) : <any>undefined;
            this.expectedTrainingDateTo = _data["expectedTrainingDateTo"] ? DateTime.fromISO(_data["expectedTrainingDateTo"].toString()) : <any>undefined;
            this.courseTypeId = _data["courseTypeId"];
            this.trainingPackageRequestId = _data["trainingPackageRequestId"];
            this.courseTypeName = _data["courseTypeName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrainingPackageDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPackageDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordIndex"] = this.recordIndex;
        data["expectedTrainingDateFrom"] = this.expectedTrainingDateFrom ? this.expectedTrainingDateFrom.toString() : <any>undefined;
        data["expectedTrainingDateTo"] = this.expectedTrainingDateTo ? this.expectedTrainingDateTo.toString() : <any>undefined;
        data["courseTypeId"] = this.courseTypeId;
        data["trainingPackageRequestId"] = this.trainingPackageRequestId;
        data["courseTypeName"] = this.courseTypeName;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrainingPackageDetailsDto {
    recordIndex: number | undefined;
    expectedTrainingDateFrom: DateTime | undefined;
    expectedTrainingDateTo: DateTime | undefined;
    courseTypeId: number | undefined;
    trainingPackageRequestId: number | undefined;
    courseTypeName: string | undefined;
    id: number;
}

export class TrainingPackageDto implements ITrainingPackageDto {
    packageName!: string | undefined;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    requestsCount!: number | undefined;
    attachmentId!: string;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITrainingPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageName = _data["packageName"];
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.requestsCount = _data["requestsCount"];
            this.attachmentId = _data["attachmentId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrainingPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageName"] = this.packageName;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["requestsCount"] = this.requestsCount;
        data["attachmentId"] = this.attachmentId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrainingPackageDto {
    packageName: string | undefined;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    requestsCount: number | undefined;
    attachmentId: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class TrainingPackageRequestDto implements ITrainingPackageRequestDto {
    requestId!: number;
    trainingSessions!: number;
    organizationId!: number;
    trainingPackageId!: number;
    packageName!: string | undefined;
    trainingPackageAttachmentId!: string;
    trainingPackageDetails!: TrainingPackageDetailsDto[] | undefined;
    requestNumber!: string | undefined;
    organizationName!: string | undefined;
    submitionDate!: DateTime | undefined;
    submittedByUserName!: string | undefined;
    submittedByPhoneNumber!: string | undefined;
    createdByUserName!: string | undefined;
    createdByPhoneNumber!: string | undefined;
    requestStatus!: number;
    requestStatusName!: string | undefined;
    onTimeSubmitted!: boolean;
    id!: number | undefined;

    constructor(data?: ITrainingPackageRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.trainingSessions = _data["trainingSessions"];
            this.organizationId = _data["organizationId"];
            this.trainingPackageId = _data["trainingPackageId"];
            this.packageName = _data["packageName"];
            this.trainingPackageAttachmentId = _data["trainingPackageAttachmentId"];
            if (Array.isArray(_data["trainingPackageDetails"])) {
                this.trainingPackageDetails = [] as any;
                for (let item of _data["trainingPackageDetails"])
                    this.trainingPackageDetails!.push(TrainingPackageDetailsDto.fromJS(item));
            }
            this.requestNumber = _data["requestNumber"];
            this.organizationName = _data["organizationName"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.submittedByUserName = _data["submittedByUserName"];
            this.submittedByPhoneNumber = _data["submittedByPhoneNumber"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdByPhoneNumber = _data["createdByPhoneNumber"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusName = _data["requestStatusName"];
            this.onTimeSubmitted = _data["onTimeSubmitted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrainingPackageRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPackageRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["trainingSessions"] = this.trainingSessions;
        data["organizationId"] = this.organizationId;
        data["trainingPackageId"] = this.trainingPackageId;
        data["packageName"] = this.packageName;
        data["trainingPackageAttachmentId"] = this.trainingPackageAttachmentId;
        if (Array.isArray(this.trainingPackageDetails)) {
            data["trainingPackageDetails"] = [];
            for (let item of this.trainingPackageDetails)
                data["trainingPackageDetails"].push(item.toJSON());
        }
        data["requestNumber"] = this.requestNumber;
        data["organizationName"] = this.organizationName;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["submittedByUserName"] = this.submittedByUserName;
        data["submittedByPhoneNumber"] = this.submittedByPhoneNumber;
        data["createdByUserName"] = this.createdByUserName;
        data["createdByPhoneNumber"] = this.createdByPhoneNumber;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusName"] = this.requestStatusName;
        data["onTimeSubmitted"] = this.onTimeSubmitted;
        data["id"] = this.id;
        return data;
    }
}

export interface ITrainingPackageRequestDto {
    requestId: number;
    trainingSessions: number;
    organizationId: number;
    trainingPackageId: number;
    packageName: string | undefined;
    trainingPackageAttachmentId: string;
    trainingPackageDetails: TrainingPackageDetailsDto[] | undefined;
    requestNumber: string | undefined;
    organizationName: string | undefined;
    submitionDate: DateTime | undefined;
    submittedByUserName: string | undefined;
    submittedByPhoneNumber: string | undefined;
    createdByUserName: string | undefined;
    createdByPhoneNumber: string | undefined;
    requestStatus: number;
    requestStatusName: string | undefined;
    onTimeSubmitted: boolean;
    id: number | undefined;
}

export class TrainingRequestCourseLookupTableDto implements ITrainingRequestCourseLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITrainingRequestCourseLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TrainingRequestCourseLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingRequestCourseLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITrainingRequestCourseLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class TrainingRequestDto implements ITrainingRequestDto {
    reservedSeats!: number;
    organizationUnitId!: number;
    courseId!: number;
    requestId!: number | undefined;
    attachmentId!: string | undefined;
    requestNumber!: string | undefined;
    organizationName!: string | undefined;
    submitionDate!: DateTime | undefined;
    submittedByUserName!: string | undefined;
    submittedByUserId!: number | undefined;
    submittedByPhoneNumber!: string | undefined;
    createdByUserName!: string | undefined;
    createdByPhoneNumber!: string | undefined;
    requestStatus!: number;
    requestStatusName!: string | undefined;
    requestCreationTime!: DateTime | undefined;
    attendeeListForView!: GetAttendeeInfoForViewDto[] | undefined;
    id!: number;

    constructor(data?: ITrainingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservedSeats = _data["reservedSeats"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.courseId = _data["courseId"];
            this.requestId = _data["requestId"];
            this.attachmentId = _data["attachmentId"];
            this.requestNumber = _data["requestNumber"];
            this.organizationName = _data["organizationName"];
            this.submitionDate = _data["submitionDate"] ? DateTime.fromISO(_data["submitionDate"].toString()) : <any>undefined;
            this.submittedByUserName = _data["submittedByUserName"];
            this.submittedByUserId = _data["submittedByUserId"];
            this.submittedByPhoneNumber = _data["submittedByPhoneNumber"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdByPhoneNumber = _data["createdByPhoneNumber"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusName = _data["requestStatusName"];
            this.requestCreationTime = _data["requestCreationTime"] ? DateTime.fromISO(_data["requestCreationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["attendeeListForView"])) {
                this.attendeeListForView = [] as any;
                for (let item of _data["attendeeListForView"])
                    this.attendeeListForView!.push(GetAttendeeInfoForViewDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TrainingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservedSeats"] = this.reservedSeats;
        data["organizationUnitId"] = this.organizationUnitId;
        data["courseId"] = this.courseId;
        data["requestId"] = this.requestId;
        data["attachmentId"] = this.attachmentId;
        data["requestNumber"] = this.requestNumber;
        data["organizationName"] = this.organizationName;
        data["submitionDate"] = this.submitionDate ? this.submitionDate.toString() : <any>undefined;
        data["submittedByUserName"] = this.submittedByUserName;
        data["submittedByUserId"] = this.submittedByUserId;
        data["submittedByPhoneNumber"] = this.submittedByPhoneNumber;
        data["createdByUserName"] = this.createdByUserName;
        data["createdByPhoneNumber"] = this.createdByPhoneNumber;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusName"] = this.requestStatusName;
        data["requestCreationTime"] = this.requestCreationTime ? this.requestCreationTime.toString() : <any>undefined;
        if (Array.isArray(this.attendeeListForView)) {
            data["attendeeListForView"] = [];
            for (let item of this.attendeeListForView)
                data["attendeeListForView"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ITrainingRequestDto {
    reservedSeats: number;
    organizationUnitId: number;
    courseId: number;
    requestId: number | undefined;
    attachmentId: string | undefined;
    requestNumber: string | undefined;
    organizationName: string | undefined;
    submitionDate: DateTime | undefined;
    submittedByUserName: string | undefined;
    submittedByUserId: number | undefined;
    submittedByPhoneNumber: string | undefined;
    createdByUserName: string | undefined;
    createdByPhoneNumber: string | undefined;
    requestStatus: number;
    requestStatusName: string | undefined;
    requestCreationTime: DateTime | undefined;
    attendeeListForView: GetAttendeeInfoForViewDto[] | undefined;
    id: number;
}

export class TrainingRequestOrganizationUnitLookupTableDto implements ITrainingRequestOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITrainingRequestOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TrainingRequestOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingRequestOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITrainingRequestOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class TrainingRequestRequestLookupTableDto implements ITrainingRequestRequestLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITrainingRequestRequestLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): TrainingRequestRequestLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingRequestRequestLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITrainingRequestRequestLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class TreeNodesDto implements ITreeNodesDto {
    data!: string | undefined;
    leaf!: boolean | undefined;
    expanded!: boolean | undefined;
    label!: string | undefined;
    expandedIcon!: string | undefined;
    collapsedIcon!: string | undefined;
    children!: TreeNodesDto[] | undefined;
    govCode!: string | undefined;
    partialSelected!: boolean | undefined;
    claimAccounts!: ClaimAccountDto[] | undefined;
    sectorId!: number | undefined;
    nameEn!: string | undefined;
    description!: string | undefined;

    constructor(data?: ITreeNodesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.leaf = _data["leaf"];
            this.expanded = _data["expanded"];
            this.label = _data["label"];
            this.expandedIcon = _data["expandedIcon"];
            this.collapsedIcon = _data["collapsedIcon"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(TreeNodesDto.fromJS(item));
            }
            this.govCode = _data["govCode"];
            this.partialSelected = _data["partialSelected"];
            if (Array.isArray(_data["claimAccounts"])) {
                this.claimAccounts = [] as any;
                for (let item of _data["claimAccounts"])
                    this.claimAccounts!.push(ClaimAccountDto.fromJS(item));
            }
            this.sectorId = _data["sectorId"];
            this.nameEn = _data["nameEn"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TreeNodesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["leaf"] = this.leaf;
        data["expanded"] = this.expanded;
        data["label"] = this.label;
        data["expandedIcon"] = this.expandedIcon;
        data["collapsedIcon"] = this.collapsedIcon;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["govCode"] = this.govCode;
        data["partialSelected"] = this.partialSelected;
        if (Array.isArray(this.claimAccounts)) {
            data["claimAccounts"] = [];
            for (let item of this.claimAccounts)
                data["claimAccounts"].push(item.toJSON());
        }
        data["sectorId"] = this.sectorId;
        data["nameEn"] = this.nameEn;
        data["description"] = this.description;
        return data;
    }
}

export interface ITreeNodesDto {
    data: string | undefined;
    leaf: boolean | undefined;
    expanded: boolean | undefined;
    label: string | undefined;
    expandedIcon: string | undefined;
    collapsedIcon: string | undefined;
    children: TreeNodesDto[] | undefined;
    govCode: string | undefined;
    partialSelected: boolean | undefined;
    claimAccounts: ClaimAccountDto[] | undefined;
    sectorId: number | undefined;
    nameEn: string | undefined;
    description: string | undefined;
}

export class TwitterExternalLoginProviderSettings implements ITwitterExternalLoginProviderSettings {
    consumerKey!: string | undefined;
    consumerSecret!: string | undefined;

    constructor(data?: ITwitterExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerKey = _data["consumerKey"];
            this.consumerSecret = _data["consumerSecret"];
        }
    }

    static fromJS(data: any): TwitterExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        return data;
    }
}

export interface ITwitterExternalLoginProviderSettings {
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
}

export class TwitterGetAccessTokenResponse implements ITwitterGetAccessTokenResponse {
    accessToken!: string | undefined;
    accessTokenSecret!: string | undefined;
    userId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ITwitterGetAccessTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.accessTokenSecret = _data["accessTokenSecret"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): TwitterGetAccessTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetAccessTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["accessTokenSecret"] = this.accessTokenSecret;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ITwitterGetAccessTokenResponse {
    accessToken: string | undefined;
    accessTokenSecret: string | undefined;
    userId: string | undefined;
    userName: string | undefined;
}

export class TwitterGetRequestTokenResponse implements ITwitterGetRequestTokenResponse {
    token!: string | undefined;
    secret!: string | undefined;
    confirmed!: boolean;
    redirectUrl!: string | undefined;

    constructor(data?: ITwitterGetRequestTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.secret = _data["secret"];
            this.confirmed = _data["confirmed"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): TwitterGetRequestTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetRequestTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["secret"] = this.secret;
        data["confirmed"] = this.confirmed;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ITwitterGetRequestTokenResponse {
    token: string | undefined;
    secret: string | undefined;
    confirmed: boolean;
    redirectUrl: string | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;
    useGravatarProfilePicture!: boolean;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.useGravatarProfilePicture = _data["useGravatarProfilePicture"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["useGravatarProfilePicture"] = this.useGravatarProfilePicture;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
    useGravatarProfilePicture: boolean;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class UserDelegationDto implements IUserDelegationDto {
    username!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime;
    id!: number;

    constructor(data?: IUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDelegationDto {
    username: string | undefined;
    startTime: DateTime;
    endTime: DateTime;
    id: number;
}

export class UserDto implements IUserDto {
    id!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;
    organizationUnitId!: number | undefined;
    apiKey!: string | undefined;
    identificationNumber!: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.apiKey = _data["apiKey"];
            this.identificationNumber = _data["identificationNumber"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["organizationUnitId"] = this.organizationUnitId;
        data["apiKey"] = this.apiKey;
        data["identificationNumber"] = this.identificationNumber;
        return data;
    }
}

export interface IUserDto {
    id: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    organizationUnitId: number | undefined;
    apiKey: string | undefined;
    identificationNumber: string | undefined;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string;
    userName!: string | undefined;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;
    organizationUnitId!: number | undefined;
    identificationNumber!: string;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.identificationNumber = _data["identificationNumber"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["organizationUnitId"] = this.organizationUnitId;
        data["identificationNumber"] = this.identificationNumber;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    userName: string | undefined;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    organizationUnitId: number | undefined;
    identificationNumber: string;
}

export class UserInfoDto implements IUserInfoDto {
    id!: number | undefined;
    name!: string | undefined;
    isActive!: boolean;
    organizationUnitId!: number | undefined;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUserInfoDto {
    id: number | undefined;
    name: string | undefined;
    isActive: boolean;
    organizationUnitId: number | undefined;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    roles!: UserListRoleDto[] | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    organizationUnitId!: number | undefined;
    organizationUnitName_Ar!: string | undefined;
    showView!: boolean;
    showEdit!: boolean;
    showDelete!: boolean;
    lastLoginTime!: DateTime | undefined;
    latestActionTime!: DateTime | undefined;
    latestActionType!: string | undefined;
    identificationNumber!: string | undefined;
    id!: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName_Ar = _data["organizationUnitName_Ar"];
            this.showView = _data["showView"];
            this.showEdit = _data["showEdit"];
            this.showDelete = _data["showDelete"];
            this.lastLoginTime = _data["lastLoginTime"] ? DateTime.fromISO(_data["lastLoginTime"].toString()) : <any>undefined;
            this.latestActionTime = _data["latestActionTime"] ? DateTime.fromISO(_data["latestActionTime"].toString()) : <any>undefined;
            this.latestActionType = _data["latestActionType"];
            this.identificationNumber = _data["identificationNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName_Ar"] = this.organizationUnitName_Ar;
        data["showView"] = this.showView;
        data["showEdit"] = this.showEdit;
        data["showDelete"] = this.showDelete;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toString() : <any>undefined;
        data["latestActionTime"] = this.latestActionTime ? this.latestActionTime.toString() : <any>undefined;
        data["latestActionType"] = this.latestActionType;
        data["identificationNumber"] = this.identificationNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    isActive: boolean;
    creationTime: DateTime;
    organizationUnitId: number | undefined;
    organizationUnitName_Ar: string | undefined;
    showView: boolean;
    showEdit: boolean;
    showDelete: boolean;
    lastLoginTime: DateTime | undefined;
    latestActionTime: DateTime | undefined;
    latestActionType: string | undefined;
    identificationNumber: string | undefined;
    id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number;
    defaultAccountLockoutSeconds!: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmail = _data["userNameOrEmail"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: DateTime;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    organizationUnitId!: number | undefined;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    organizationUnitId: number | undefined;
    id: number;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;
    targetNotifiers!: string | undefined;
    readonly targetNotifiersList!: string[] | undefined;
    id!: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.targetNotifiers = _data["targetNotifiers"];
            if (Array.isArray(_data["targetNotifiersList"])) {
                (<any>this).targetNotifiersList = [] as any;
                for (let item of _data["targetNotifiersList"])
                    (<any>this).targetNotifiersList!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["targetNotifiers"] = this.targetNotifiers;
        if (Array.isArray(this.targetNotifiersList)) {
            data["targetNotifiersList"] = [];
            for (let item of this.targetNotifiersList)
                data["targetNotifiersList"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    targetNotifiers: string | undefined;
    targetNotifiersList: string[] | undefined;
    id: string;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;
    organizationTypeId!: number | undefined;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
            this.organizationTypeId = _data["organizationTypeId"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["organizationTypeId"] = this.organizationTypeId;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    organizationTypeId: number | undefined;
}

export class UserSectorDto implements IUserSectorDto {
    userId!: number;
    sectorId!: number;
    sectorName_EN!: string | undefined;
    sectorName_Ar!: string | undefined;
    isAssigned!: boolean;
    id!: number;

    constructor(data?: IUserSectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.sectorId = _data["sectorId"];
            this.sectorName_EN = _data["sectorName_EN"];
            this.sectorName_Ar = _data["sectorName_Ar"];
            this.isAssigned = _data["isAssigned"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserSectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["sectorId"] = this.sectorId;
        data["sectorName_EN"] = this.sectorName_EN;
        data["sectorName_Ar"] = this.sectorName_Ar;
        data["isAssigned"] = this.isAssigned;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserSectorDto {
    userId: number;
    sectorId: number;
    sectorName_EN: string | undefined;
    sectorName_Ar: string | undefined;
    isAssigned: boolean;
    id: number;
}

export class UserSectorSectorLookupTableDto implements IUserSectorSectorLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IUserSectorSectorLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserSectorSectorLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSectorSectorLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserSectorSectorLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class UserSectorUserLookupTableDto implements IUserSectorUserLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IUserSectorUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserSectorUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSectorUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserSectorUserLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export enum UserSubmissionCategory {
    Inquiry = 1,
    Feedback = 2,
    Complaint = 3,
    Others = 4,
}

export class UserSubmissionDto implements IUserSubmissionDto {
    fullName!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    subject!: string | undefined;
    message!: string | undefined;
    category!: UserSubmissionCategory;
    status!: UserSubmissionStatus;
    createBy!: string | undefined;
    modifiedBy!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.category = _data["category"];
            this.status = _data["status"];
            this.createBy = _data["createBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["category"] = this.category;
        data["status"] = this.status;
        data["createBy"] = this.createBy;
        data["modifiedBy"] = this.modifiedBy;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserSubmissionDto {
    fullName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    subject: string | undefined;
    message: string | undefined;
    category: UserSubmissionCategory;
    status: UserSubmissionStatus;
    createBy: string | undefined;
    modifiedBy: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum UserSubmissionStatus {
    New = 1,
    InReview = 2,
    Resolved = 3,
    Achieved = 4,
}

export class UserViewDto implements IUserViewDto {
    id!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    isActive!: boolean;
    organizationUnitId!: number | undefined;

    constructor(data?: IUserViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UserViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUserViewDto {
    id: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    organizationUnitId: number | undefined;
}

export class ValidSubmitDateOuput implements IValidSubmitDateOuput {
    validSubmitDate!: DateTime | undefined;
    isSubmittedOnTime!: boolean;

    constructor(data?: IValidSubmitDateOuput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validSubmitDate = _data["validSubmitDate"] ? DateTime.fromISO(_data["validSubmitDate"].toString()) : <any>undefined;
            this.isSubmittedOnTime = _data["isSubmittedOnTime"];
        }
    }

    static fromJS(data: any): ValidSubmitDateOuput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidSubmitDateOuput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validSubmitDate"] = this.validSubmitDate ? this.validSubmitDate.toString() : <any>undefined;
        data["isSubmittedOnTime"] = this.isSubmittedOnTime;
        return data;
    }
}

export interface IValidSubmitDateOuput {
    validSubmitDate: DateTime | undefined;
    isSubmittedOnTime: boolean;
}

export class VehicleInfoCarModelLookupTableDto implements IVehicleInfoCarModelLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    manufactureCompanyId!: number | undefined;

    constructor(data?: IVehicleInfoCarModelLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.manufactureCompanyId = _data["manufactureCompanyId"];
        }
    }

    static fromJS(data: any): VehicleInfoCarModelLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleInfoCarModelLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["manufactureCompanyId"] = this.manufactureCompanyId;
        return data;
    }
}

export interface IVehicleInfoCarModelLookupTableDto {
    id: number;
    displayName: string | undefined;
    manufactureCompanyId: number | undefined;
}

export class VehicleInfoDto implements IVehicleInfoDto {
    structureNumber!: string | undefined;
    manufacturingYear!: number | undefined;
    fuelEconomy!: number | undefined;
    organizationUnitId!: number;
    carModelId!: number | undefined;
    manufactureCompanyId!: number | undefined;
    fuelTypeId!: number | undefined;
    id!: number;

    constructor(data?: IVehicleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureNumber = _data["structureNumber"];
            this.manufacturingYear = _data["manufacturingYear"];
            this.fuelEconomy = _data["fuelEconomy"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.carModelId = _data["carModelId"];
            this.manufactureCompanyId = _data["manufactureCompanyId"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VehicleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureNumber"] = this.structureNumber;
        data["manufacturingYear"] = this.manufacturingYear;
        data["fuelEconomy"] = this.fuelEconomy;
        data["organizationUnitId"] = this.organizationUnitId;
        data["carModelId"] = this.carModelId;
        data["manufactureCompanyId"] = this.manufactureCompanyId;
        data["fuelTypeId"] = this.fuelTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IVehicleInfoDto {
    structureNumber: string | undefined;
    manufacturingYear: number | undefined;
    fuelEconomy: number | undefined;
    organizationUnitId: number;
    carModelId: number | undefined;
    manufactureCompanyId: number | undefined;
    fuelTypeId: number | undefined;
    id: number;
}

export class VehicleInfoFuelTypeLookupTableDto implements IVehicleInfoFuelTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IVehicleInfoFuelTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): VehicleInfoFuelTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleInfoFuelTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IVehicleInfoFuelTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class VehicleInfoManufactureCompanyLookupTableDto implements IVehicleInfoManufactureCompanyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IVehicleInfoManufactureCompanyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): VehicleInfoManufactureCompanyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleInfoManufactureCompanyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IVehicleInfoManufactureCompanyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class VehicleInfoOrganizationUnitLookupTableDto implements IVehicleInfoOrganizationUnitLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IVehicleInfoOrganizationUnitLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): VehicleInfoOrganizationUnitLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleInfoOrganizationUnitLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IVehicleInfoOrganizationUnitLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class VerifyIdentificationOtpModel implements IVerifyIdentificationOtpModel {
    userId!: number;
    otpCode!: string | undefined;

    constructor(data?: IVerifyIdentificationOtpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.otpCode = _data["otpCode"];
        }
    }

    static fromJS(data: any): VerifyIdentificationOtpModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyIdentificationOtpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["otpCode"] = this.otpCode;
        return data;
    }
}

export interface IVerifyIdentificationOtpModel {
    userId: number;
    otpCode: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class Widget implements IWidget {
    widgetId!: string | undefined;
    height!: number;
    width!: number;
    positionX!: number;
    positionY!: number;

    constructor(data?: IWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.positionX = _data["positionX"];
            this.positionY = _data["positionY"];
        }
    }

    static fromJS(data: any): Widget {
        data = typeof data === 'object' ? data : {};
        let result = new Widget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["height"] = this.height;
        data["width"] = this.width;
        data["positionX"] = this.positionX;
        data["positionY"] = this.positionY;
        return data;
    }
}

export interface IWidget {
    widgetId: string | undefined;
    height: number;
    width: number;
    positionX: number;
    positionY: number;
}

export class WidgetFilterOutput implements IWidgetFilterOutput {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: IWidgetFilterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WidgetFilterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetFilterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWidgetFilterOutput {
    id: string | undefined;
    name: string | undefined;
}

export class WidgetOutput implements IWidgetOutput {
    id!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    filters!: WidgetFilterOutput[] | undefined;

    constructor(data?: IWidgetOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(WidgetFilterOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WidgetOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWidgetOutput {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    filters: WidgetFilterOutput[] | undefined;
}

export class WsFederationExternalLoginProviderSettings implements IWsFederationExternalLoginProviderSettings {
    clientId!: string | undefined;
    tenant!: string | undefined;
    metaDataAddress!: string | undefined;
    wtrealm!: string | undefined;
    authority!: string | undefined;

    constructor(data?: IWsFederationExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.tenant = _data["tenant"];
            this.metaDataAddress = _data["metaDataAddress"];
            this.wtrealm = _data["wtrealm"];
            this.authority = _data["authority"];
        }
    }

    static fromJS(data: any): WsFederationExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WsFederationExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["tenant"] = this.tenant;
        data["metaDataAddress"] = this.metaDataAddress;
        data["wtrealm"] = this.wtrealm;
        data["authority"] = this.authority;
        return data;
    }
}

export interface IWsFederationExternalLoginProviderSettings {
    clientId: string | undefined;
    tenant: string | undefined;
    metaDataAddress: string | undefined;
    wtrealm: string | undefined;
    authority: string | undefined;
}

export class AdditionalData implements IAdditionalData {
    paypal!: { [key: string]: string; };
    stripe!: { [key: string]: string; };

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["Paypal"]) {
                this.paypal = {} as any;
                for (let key in _data["Paypal"]) {
                    if (_data["Paypal"].hasOwnProperty(key))
                        (<any>this.paypal)![key] = _data["Paypal"][key];
                }
            }
            if (_data["Stripe"]) {
                this.stripe = {} as any;
                for (let key in _data["Stripe"]) {
                    if (_data["Stripe"].hasOwnProperty(key))
                        (<any>this.stripe)![key] = _data["Stripe"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    (<any>data["Paypal"])[key] = (<any>this.paypal)[key];
            }
        }
        if (this.stripe) {
            data["Stripe"] = {};
            for (let key in this.stripe) {
                if (this.stripe.hasOwnProperty(key))
                    (<any>data["Stripe"])[key] = (<any>this.stripe)[key];
            }
        }
        return data;
    }
}

export interface IAdditionalData {
    paypal: { [key: string]: string; };
    stripe: { [key: string]: string; };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}